// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/fonts/nucleo-icons.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("assets/fonts/nucleo-icons.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("assets/fonts/nucleo-icons.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("assets/fonts/nucleo-icons.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("assets/fonts/nucleo-icons.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/gif;base64,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", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAQAAADYWf5HAAAAkElEQVQoz7X QMQ5AQBCF4dWQSJxC5wwax1Cq1e7BAdxD5SL+Tq/QCM1oNiJidwox0355mXnG/DrEtIQ6azioNZQxI0ykPhTQIwhCR+BmBYtlK7kLJYwWCcJA9M4qdrZrd8pPjZWPtOqdRQy320YSV17OatFC4euts6z39GYMKRPCTKY9UnPQ6P+GtMRfGtPnBCiqhAeJPmkqAAAAAElFTkSuQmCC", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIGNIUk0AAG2YAABzjgAA+swAAIT6AAB5gQAA/RMAADBtAAASKQ0eJk4AAACASURBVHja7NKhDcJQFIbRV1MSEqaoYwYMYyARR6HZowzAHqguUolHYEgxD9MmTYPpA1JEb/KZK476Q4wxfKvwc6x/WKJE3v+nYkc8cfgIwxpXRNQokjBkOLdQ1wlZCrbFbYDdsRmFYYVqAHVdsBiD7dHg8aYGu2l2NmMz9s/YawDpU8qkYQTHqgAAAABJRU5ErkJggg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIGNIUk0AAG2YAABzjgAA+swAAIT6AAB5gQAA/RMAADBtAAASKQ0eJk4AAACFSURBVHja7NKhDcJQFIbRWwMJCVPgmKGGMZCIo9DsAQOwRxWLIPEIDCnmYR4JaSp4DYKQis/8NznqRkopvlWM2Ij9BYY1Wtx7arEpwaZokHo6Yf4xFhGBGrcOdMUqIqIUq3DoYEdUxVgGFzhn6ILl61aMZXCLB3bv+1Bsgj1mg7CfeNrnAMXSyqQtsCNeAAAAAElFTkSuQmCC", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*!

 =========================================================
 * Light Bootstrap Dashboard - v2.0.1
 =========================================================

 * Product Page: http://www.creative-tim.com/product/light-bootstrap-dashboard
 * Copyright 2020 Creative Tim (http://www.creative-tim.com)
 * License (http://www.creative-tim.com/license)

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
/*      light colors         */
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.modal.show .modal-dialog {
  transform: translate(0, 30%);
}
.modal.modal-mini .modal-dialog {
  max-width: 255px;
  margin: 0 auto;
}
.modal .modal-content .modal-header {
  border-bottom: none;
  padding-top: 24px;
  padding-right: 24px;
  padding-bottom: 0;
  padding-left: 24px;
}
.modal .modal-content .modal-header .modal-profile {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  text-align: center;
  line-height: 5.7;
  box-shadow: 0px 1px 20px 0px rgba(0, 0, 0, 0.3);
}
.modal .modal-content .modal-header .modal-profile i {
  font-size: 32px;
  padding-top: 24px;
}
.modal .modal-content .modal-body {
  padding-top: 24px;
  padding-right: 24px;
  padding-bottom: 16px;
  padding-left: 24px;
  line-height: 1.9;
}
.modal .modal-content .modal-body + .modal-footer {
  padding-top: 0;
}
.modal .modal-content .modal-footer {
  border-top: none;
  padding-right: 24px;
  padding-bottom: 16px;
  padding-left: 24px;
  justify-content: space-between;
}
.modal .modal-content .modal-footer .btn {
  margin: 0;
  padding-left: 16px;
  padding-right: 16px;
  width: auto;
}
.modal .modal-content .modal-footer .btn:hover, .modal .modal-content .modal-footer .btnfocus {
  text-decoration: none;
}

/*           Font Smoothing      */
body,
h1, .h1,
h2, .h2,
h3, .h3,
h4, .h4,
h5, .h5,
h6, .h6,
p,
.navbar,
.brand,
.btn-simple,
.alert,
a,
.td-name,
td,
button.close {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  font-family: "Roboto", "Helvetica Neue", Arial, sans-serif;
  font-weight: 400;
}

h1, .h1, h2, .h2, h3, .h3, h4, .h4 {
  font-weight: 300;
  margin: 30px 0 15px;
}

h1, .h1 {
  font-size: 3.25rem;
}

h2, .h2 {
  font-size: 2.25rem;
}

h3, .h3 {
  font-size: 1.75rem;
  margin: 20px 0 10px;
}

h4, .h4 {
  font-size: 1.375rem;
  line-height: 30px;
}

h5, .h5 {
  font-size: 1.125rem;
  margin-bottom: 15px;
}

h6, .h6 {
  font-size: 0.875rem;
  font-weight: 600;
  text-transform: uppercase;
}

p {
  font-size: 1rem;
  line-height: 1.5;
}

h1 small, h2 small, h3 small, h4 small, h5 small, h6 small, .h1 small, .h2 small, .h3 small, .h4 small, .h5 small, .h6 small, h1 .small, h2 .small, h3 .small, h4 .small, h5 .small, h6 .small, .h1 .small, .h2 .small, .h3 .small, .h4 .small, .h5 .small, .h6 .small {
  color: #9A9A9A;
  font-weight: 300;
  line-height: 1.5;
}

h1 small, h2 small, h3 small, h1 .small, h2 .small, h3 .small {
  font-size: 60%;
}

h1 .subtitle {
  display: block;
  margin: 0 0 30px;
}

.text-muted {
  color: #9A9A9A;
}

.text-primary, .text-primary:hover {
  color: #1D62F0 !important;
}

.text-info, .text-info:hover {
  color: #23CCEF !important;
}

.text-success, .text-success:hover {
  color: #275D38 !important;
}

.text-warning, .text-warning:hover {
  color: #FFA534 !important;
}

.text-danger, .text-danger:hover {
  color: #FB404B !important;
}

.typo-line {
  padding-left: 140px;
  margin-bottom: 40px;
  position: relative;
}
.typo-line .category {
  transform: translateY(-50%);
  top: 50%;
  left: 0px;
  position: absolute;
  font-size: 14px;
  font-weight: 400;
  color: #888888;
  margin-bottom: 0px;
}

blockquote {
  padding: 10px 20px;
  margin: 0 0 20px;
  font-size: 17.5px;
  border-left: 5px solid #eee;
}

/*     General overwrite     */
body,
.wrapper {
  min-height: 100vh;
  position: relative;
}

a {
  color: #23CCEF;
}
a:hover, a:focus {
  color: #11bfe3;
  text-decoration: none;
}

a:focus, a:active,
button::-moz-focus-inner,
input::-moz-focus-inner,
input[type=reset]::-moz-focus-inner,
input[type=button]::-moz-focus-inner,
input[type=submit]::-moz-focus-inner,
select::-moz-focus-inner,
input[type=file] > input[type=button]::-moz-focus-inner {
  outline: 0;
}

.ui-slider-handle:focus,
.navbar-toggle,
input:focus {
  outline: 0 !important;
}

/*           Animations              */
.form-control,
.input-group-addon,
.tagsinput,
.navbar,
.navbar .alert {
  transition: all 300ms linear;
}

.animation-transition-fast,
.sidebar .nav .collapse a > span,
.sidebar .sidebar-wrapper > .nav p,
.sidebar .user .info > a > span,
.sidebar .logo a.logo-normal,
.sidebar .user .info .collapse .nav a > span {
  transition: all 150ms linear;
}

.sidebar .nav a,
.table > tbody > tr .td-actions .btn {
  transition: all 150ms ease-in;
}

.btn {
  transition: all 60ms ease-in;
}

.fa, .fas, .far, .fal, .fad, .fab {
  width: 18px;
  text-align: center;
}

.margin-top {
  margin-top: 50px;
}

.wrapper {
  position: relative;
  top: 0;
  height: 100vh;
}

.card .map {
  height: 400px;
}
.card .map .map-big {
  height: 350px;
}

.page-header .page-header-image {
  background-position: center center;
  background-size: cover;
  height: 450px;
  overflow: hidden;
  width: 100%;
  z-index: 1;
}
.page-header .title-container {
  color: #fff;
  position: relative;
  top: 200px;
  z-index: 3;
}
.page-header .filter:after {
  background: rgba(0, 0, 0, 0) linear-gradient(to bottom, #9368e9 0%, #943bea 100%) repeat scroll 0 0/150% 150%;
  content: "";
  display: block;
  height: 450px;
  left: 0;
  opacity: 0.77;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 2;
}

.form-control,
.input-group-addon,
.tagsinput,
.navbar .alert,
.card-collapse.collapse {
  transition: all 300ms linear;
}

.card .card-body.content-full-width {
  padding: 15px 0px 10px 0px;
}
.card .card-body.content-full-width .accordions .card-title a {
  padding: 0px 0px 5px 15px;
}

.sidebar,
.main-panel,
.sidebar-wrapper,
.navbar-fixed,
.navbar-minimize {
  transition-property: top, bottom, width;
  transition-duration: 0.2s, 0.2s, 0.35s;
  transition-timing-function: linear, linear, ease;
  -webkit-overflow-scrolling: touch;
}

.animation-transition-general,
.sidebar .nav p,
.sidebar .user .photo,
.bootstrap-navbar .user .photo,
.sidebar .user a,
.bootstrap-navbar .user a,
.login-page .card {
  transition: all 300ms linear;
}

.sidebar {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  width: 260px;
  display: block;
  z-index: 1;
  color: #fff;
  font-weight: 200;
  background-size: cover;
  background-position: center center;
}
.sidebar .logo-img {
  width: 30px;
  display: inline-block;
  max-height: 30px;
}
.sidebar .logo-img img {
  width: 35px;
  top: 1px;
  position: absolute;
  left: 0px;
}
.sidebar .logo {
  padding: 12px 0px 9px;
  margin: 0;
  position: relative;
  z-index: 4;
  display: block;
}
.sidebar .logo a.logo-mini {
  float: left;
  width: 30px;
  text-align: center;
  margin-left: 23px;
  margin-right: 15px;
  position: relative;
}
.sidebar .logo a.logo-normal {
  display: block;
  opacity: 1;
  transform: translate3d(0px, 0, 0);
}
.sidebar .logo .simple-text {
  text-transform: uppercase;
  padding: 5px 0px;
  display: inline-block;
  font-size: 1.125rem;
  font-weight: 400;
  line-height: 30px;
  white-space: nowrap;
  color: #FFFFFF;
  overflow: hidden;
}
.sidebar .logo p {
  float: left;
  font-size: 20px;
  margin: 10px 10px;
  line-height: 20px;
}
.sidebar .logo:before {
  content: "";
  position: absolute;
  bottom: 0px;
  right: 15px;
  width: calc(100% - 30px);
  height: 1px;
}
.sidebar .sidebar-wrapper {
  position: relative;
  max-height: calc(100vh - 75px);
  min-height: 100%;
  overflow: auto;
  width: 260px;
  z-index: 4;
  padding-bottom: 100px;
}
.sidebar .sidebar-wrapper .nav .nav-item [data-toggle=collapse] ~ div .nav .nav-item .nav-link {
  background: transparent;
  padding-left: 55px;
  text-transform: capitalize;
  padding: 5px 15px 5px 15px;
  font-weight: 400;
  font-size: 14px;
}
.sidebar .sidebar-wrapper .nav .nav-item [data-toggle=collapse] ~ div .nav .nav-item:hover .nav-link, .sidebar .sidebar-wrapper .nav .nav-item [data-toggle=collapse] ~ div .nav .nav-item:focus .nav-link, .sidebar .sidebar-wrapper .nav .nav-item [data-toggle=collapse] ~ div .nav .nav-item.active .nav-link {
  background: rgba(255, 255, 255, 0.13);
}
.sidebar .sidebar-wrapper .nav .nav-item [data-toggle=collapse] ~ div .nav .sidebar-normal {
  left: 15px;
}
.sidebar .sidebar-wrapper .nav .nav-link p {
  margin: 0;
  line-height: 30px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  white-space: nowrap;
  position: relative;
  color: #FFFFFF;
  transform: translate3d(0px, 0, 0);
  display: block;
  height: auto;
  opacity: 1;
}
.sidebar .sidebar-wrapper .navbar-form.navbar-search-form {
  margin-top: 15px;
  padding-left: 25px;
}
.sidebar .sidebar-wrapper .navbar-form.navbar-search-form input {
  padding-left: 10px;
  padding-top: 5px;
}
.sidebar .sidebar-background {
  position: absolute;
  z-index: 1;
  height: 100%;
  width: 100%;
  display: block;
  top: 0;
  left: 0;
  background-size: cover;
  background-position: center center;
}
.sidebar .user {
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  padding-bottom: 20px;
  margin-top: 20px;
}
.sidebar .user .photo {
  width: 34px;
  height: 34px;
  overflow: hidden;
  border-radius: 50%;
  float: left;
  margin-right: 11px;
  margin-left: 23px;
  z-index: 5;
  border: 2px solid rgba(255, 255, 255, 0.3);
}
.sidebar .user .photo img {
  width: 100%;
}
.sidebar .user .info .caret {
  right: 15px;
  top: -5px;
}
.sidebar .user .info a {
  color: #FFFFFF;
  padding: 8px 14px;
  display: block;
  white-space: nowrap;
  line-height: 18px;
}
.sidebar .user .info span {
  position: relative;
  display: block;
}
.sidebar .user .info .collapse .sidebar-normal {
  padding-left: 0;
}
.sidebar .user .profile-dropdown {
  text-align: left !important;
  padding-left: 25px !important;
}
.sidebar .user .profile-dropdown .sidebar-mini,
.sidebar .user .profile-dropdown .sidebar-normal {
  margin-right: 0;
  font-size: 14px;
}
.sidebar .user .profile-dropdown .sidebar-normal {
  left: 15px;
}
.sidebar .caret {
  display: inline-block;
  width: 0;
  height: 0;
  vertical-align: middle;
  border-top: 4px dashed;
  border-top: 4px solid\\9 ;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
  margin-top: 13px;
  position: absolute;
  right: 0;
  transition: all 150ms ease-in;
}
.sidebar a[data-toggle=collapse][aria-expanded=true] .caret,
.sidebar .btn[data-toggle=collapse][aria-expanded=true] .caret,
.sidebar a.dropdown-toggle[aria-expanded=true] .caret {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
  transform: rotate(180deg);
}
.sidebar .nav {
  float: none;
  display: block;
}
.sidebar .nav .nav-item .nav-link {
  color: #FFFFFF;
  margin: 5px 15px 0px 10px;
  opacity: 0.86;
  border-radius: 4px;
  text-transform: uppercase;
  line-height: 30px;
  font-size: 12px;
  font-weight: 600;
  padding: 10px 15px;
  white-space: nowrap;
}
.sidebar .nav .nav-item .nav-link:hover {
  background: rgba(255, 255, 255, 0.13);
  opacity: 1;
}
.sidebar .nav .nav-item .nav-link i {
  font-size: 28px;
  margin-right: 15px;
  width: 30px;
  text-align: center;
  vertical-align: middle;
  float: left;
}
.sidebar .nav .nav-item:not(.collapse .nav-link):hover .nav-link {
  background: rgba(255, 255, 255, 0.13);
  opacity: 1;
}
.sidebar .nav .nav-item.active .nav-link {
  color: #FFFFFF;
  opacity: 1;
  background: rgba(255, 255, 255, 0.23);
}
.sidebar .nav .nav-item.separator {
  margin: 15px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}
.sidebar .nav .nav-item.separator + .nav-item {
  margin-top: 31px;
}
.sidebar:after, .sidebar:before {
  display: block;
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 2;
}
.sidebar:before {
  opacity: 0.33;
  background: #000000;
}
.sidebar[data-image]:after, .sidebar.has-image:after {
  opacity: 0.95;
}

.sidebar .logo p,
.bootstrap-navbar .logo p {
  float: left;
  font-size: 20px;
  margin: 10px 10px;
  color: #FFFFFF;
  line-height: 20px;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.sidebar .logo .logo-text,
.bootstrap-navbar .logo .logo-text {
  text-transform: uppercase;
  padding: 5px 0px 5px 15px;
  display: block;
  font-size: 1.125rem;
  color: #FFFFFF;
  font-weight: 400;
  line-height: 30px;
  white-space: nowrap;
  overflow: hidden;
}
.sidebar .logo .logo-image,
.bootstrap-navbar .logo .logo-image {
  float: left;
  height: 40px;
  width: 40px;
  margin: 0 10px;
}
.sidebar .logo .logo-round,
.bootstrap-navbar .logo .logo-round {
  border-radius: 50%;
  display: block;
  overflow: hidden;
}
.sidebar .logo .logo-round img,
.bootstrap-navbar .logo .logo-round img {
  width: 100%;
}
.sidebar .logo:before,
.bootstrap-navbar .logo:before {
  content: "";
  position: absolute;
  bottom: 0px;
  right: 15px;
  width: calc(100% - 30px);
  height: 1px;
  background-color: rgba(255, 255, 255, 0.3);
}
.sidebar .logo-mini .logo-text,
.bootstrap-navbar .logo-mini .logo-text {
  text-transform: uppercase;
  padding: 7px 0px;
  display: block;
  font-size: 1.125rem;
  color: #FFFFFF;
  font-weight: 400;
  line-height: 30px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
}
.sidebar[data-color=black]:after,
.bootstrap-navbar[data-color=black]:after {
  background: #797979;
  background: linear-gradient(to bottom, #797979 0%, rgba(121, 121, 121, 0.7) 100%);
  background-size: 150% 150%;
}
.sidebar[data-color=blue]:after,
.bootstrap-navbar[data-color=blue]:after {
  background: #447DF7;
  background: linear-gradient(to bottom, #447DF7 0%, rgba(83, 60, 225, 0.7) 100%);
  background-size: 150% 150%;
}
.sidebar[data-color=azure]:after,
.bootstrap-navbar[data-color=azure]:after {
  background: #23CCEF;
  background: linear-gradient(to bottom, #23CCEF 0%, rgba(64, 145, 255, 0.7) 100%);
  background-size: 150% 150%;
}
.sidebar[data-color=green]:after,
.bootstrap-navbar[data-color=green]:after {
  background: #275D38;
  background: linear-gradient(to bottom, #275D38 0%, rgba(109, 192, 48, 0.7) 100%);
  background-size: 150% 150%;
}
.sidebar[data-color=orange]:after,
.bootstrap-navbar[data-color=orange]:after {
  background: #FFA534;
  background: linear-gradient(to bottom, #FFA534 0%, rgba(255, 82, 33, 0.7) 100%);
  background-size: 150% 150%;
}
.sidebar[data-color=red]:after,
.bootstrap-navbar[data-color=red]:after {
  background: #FB404B;
  background: linear-gradient(to bottom, #FB404B 0%, rgba(187, 5, 2, 0.7) 100%);
  background-size: 150% 150%;
}
.sidebar[data-color=purple]:after,
.bootstrap-navbar[data-color=purple]:after {
  background: #9368E9;
  background: linear-gradient(to bottom, #9368E9 0%, rgba(148, 59, 234, 0.7) 100%);
  background-size: 150% 150%;
}

.main-panel {
  background: rgba(203, 203, 210, 0.15);
  position: relative;
  float: right;
  width: calc(100% - 260px);
}
.main-panel .content {
  padding: 30px 15px;
  min-height: calc(100vh - 123px);
}
.main-panel .footer {
  border-top: 1px solid #e7e7e7;
}
.main-panel .navbar {
  margin-bottom: 0;
}

.sidebar-mini .sidebar .sidebar-wrapper .nav .nav-item:hover .collapse .nav-item .nav-link {
  padding: 5px 15px;
}

.sidebar .sidebar-wrapper .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-mini,
.sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-mini {
  text-transform: uppercase;
  float: left;
  width: 30px;
  text-align: center;
  letter-spacing: 1px;
}

.sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
.sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
.off-canvas-sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
.off-canvas-sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal {
  margin: 0;
  position: relative;
  transform: translateX(0px);
  opacity: 1;
  white-space: nowrap;
  display: inline-block;
  line-height: 23px;
}

.sidebar .nav .nav-item .nav-link .sidebar-mini {
  padding-left: 5px !important;
  opacity: 0.86 !important;
}

@media (min-width: 992px) {
  .sidebar-mini .visible-on-sidebar-regular {
    display: none !important;
  }
  .sidebar-mini .visible-on-sidebar-mini {
    display: inline-block !important;
  }
  .sidebar-mini .sidebar {
    width: 80px;
    display: block;
    font-weight: 200;
    z-index: 3;
    position: fixed;
  }
  .sidebar-mini .sidebar .logo a.logo-mini {
    opacity: 1;
  }
  .sidebar-mini .sidebar .logo a.logo-normal {
    opacity: 0;
    transform: translate3d(-25px, 0, 0);
  }
  .sidebar-mini .sidebar .sidebar-wrapper {
    overflow: inherit;
    width: 80px;
    box-shadow: none;
  }
  .sidebar-mini .sidebar .sidebar-wrapper .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
.sidebar-mini .sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
.sidebar-mini .sidebar .sidebar-wrapper .user .info > a > span,
.sidebar-mini .sidebar .sidebar-wrapper > .nav li > a p {
    transform: translate3d(-25px, 0, 0);
    opacity: 0;
  }
  .sidebar-mini .sidebar .info .collapse .nav li > a {
    margin: 0;
    border-radius: 0;
  }
  .sidebar-mini .sidebar .info .caret {
    opacity: 0;
  }
  .sidebar-mini .sidebar .info [data-toggle=collapse] ~ div > ul > li:last-child > a {
    margin-bottom: 5px;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }
  .sidebar-mini .sidebar .info [data-toggle=collapse] ~ div > ul > li:first-child > a {
    margin-top: 5px;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
  }
  .sidebar-mini .sidebar .nav .nav-item .nav-link .sidebar-mini {
    padding-left: 30px !important;
  }
  .sidebar-mini .sidebar:hover {
    width: 260px;
  }
  .sidebar-mini .sidebar:hover .logo a.logo-normal {
    opacity: 1;
    transform: translate3d(0px, 0, 0);
  }
  .sidebar-mini .sidebar:hover .nav-item [data-toggle=collapse] ~ div .nav .sidebar-normal {
    left: 0;
  }
  .sidebar-mini .sidebar:hover .caret {
    opacity: 1;
  }
  .sidebar-mini .sidebar:hover .sidebar-wrapper {
    width: 260px;
  }
  .sidebar-mini .sidebar:hover .sidebar-wrapper > .nav li > a p,
.sidebar-mini .sidebar:hover .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
.sidebar-mini .sidebar:hover .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
.sidebar-mini .sidebar:hover .sidebar-wrapper .user .info > a > p,
.sidebar-mini .sidebar:hover .sidebar-wrapper > .nav li > a .caret,
.sidebar-mini .sidebar:hover .sidebar-wrapper .user .info a span {
    transform: translate3d(0px, 0, 0);
    opacity: 1;
  }
  .sidebar-mini .sidebar:hover .sidebar-wrapper > .nav li.active > a:not([data-toggle=collapse]):before, .sidebar-mini .sidebar:hover .sidebar-wrapper > .nav li.active > a:not([data-toggle=collapse]):after {
    opacity: 0;
  }
  .sidebar-mini .sidebar:hover .nav .nav-item .nav-link .sidebar-mini {
    margin-right: 5px !important;
  }
  .sidebar-mini .sidebar:hover .sidebar-normal {
    padding-left: 10px;
    padding-right: 10px;
    margin: 5px 15px 0px;
    border-radius: 4px;
    color: #FFFFFF;
    opacity: 0.86;
  }
  .sidebar-mini .main-panel {
    width: calc(100% - 80px);
    margin-left: 80px;
  }
  .sidebar-mini .wrapper {
    height: auto;
  }
  .sidebar-mini .sidebar,
.sidebar-mini .main-panel {
    overflow: visible;
    max-height: none;
    height: auto;
  }
  .sidebar-mini .navbar-fixed {
    width: calc(100% - 80px) !important;
  }
}
.visible-on-sidebar-regular {
  display: inline-block !important;
}

.visible-on-sidebar-mini {
  display: none !important;
}

.navbar-minimize {
  margin-right: 15px;
}

.wrapper-full-page {
  min-height: 100vh;
  height: 100%;
}
.wrapper-full-page .navbar {
  z-index: 1030;
}
.wrapper-full-page .navbar .nav-link i {
  font-size: 18px;
  position: relative;
  right: 10px;
  text-align: center;
}
.wrapper-full-page .navbar .nav-item.active .nav-link {
  background-color: rgba(255, 255, 255, 0.2) !important;
}
.wrapper-full-page .navbar .nav-link:not(.btn):hover {
  background-color: rgba(255, 255, 255, 0.2) !important;
  border-radius: 0.1875rem;
  transition: all 300ms linear;
}
.wrapper-full-page .navbar .navbar-nav .nav-item .nav-link {
  padding: 3px 15px;
}
.wrapper-full-page .footer {
  position: relative;
  z-index: 2;
  background: transparent;
}
.wrapper-full-page .footer .copyright {
  color: rgba(255, 255, 255, 0.7);
}
.wrapper-full-page .footer .copyright a {
  opacity: 1;
}

.full-page .full-page-background {
  position: absolute;
  z-index: 1;
  height: 100%;
  width: 100%;
  display: block;
  top: 0;
  left: 0;
  background-size: cover;
  background-position: center center;
}
.full-page:before, .full-page:after {
  display: block;
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 2;
}
.full-page:before {
  opacity: 0.33;
}
.full-page.register-page .content:first-of-type {
  padding-top: 10vh;
}
.full-page > .content {
  min-height: calc(100vh - 70px);
  z-index: 4;
  position: relative;
}
.full-page > .content .card-register .card-title {
  color: #FFFFFF;
}
.full-page > .content .card-register .card-subtitle {
  margin-top: 10px;
  margin-bottom: 0;
  font-size: 21px;
  color: #FFFFFF;
}
.full-page > .content .card-register .footer {
  background-color: transparent;
}
.full-page > .content .card-register .content {
  padding-top: 5%;
}
.full-page > .content .card-register .media {
  color: #FFFFFF;
  margin-bottom: 15px;
}
.full-page > .content .card-register .media .icon {
  float: left;
  margin-right: 5px;
}
.full-page > .content .card-register .media .icon i {
  font-size: 36px;
}
.full-page > .content .card-register .media .media-left,
.full-page > .content .card-register .media .media-body {
  display: table-cell;
  vertical-align: top;
}
.full-page > .content .card-register .media .media-body {
  overflow: hidden;
}
.full-page > .content .card-register .media h4 {
  margin: 0 0 5px 15px;
  text-align: left;
}
.full-page > .content .card-register .media p {
  text-align: justify;
  margin-left: 15px;
}
.full-page > .content:first-of-type {
  padding-top: 20vh;
}
.full-page.register-page .content {
  padding-top: 10vh;
}
.full-page[data-color=black]:after {
  background: #797979;
  background: linear-gradient(to bottom, #797979 0%, #797979 100%);
  background-size: 150% 150%;
}
.full-page[data-color=blue]:after {
  background: #1F77D0;
  background: linear-gradient(to bottom, #1F77D0 0%, #533ce1 100%);
  background-size: 150% 150%;
}
.full-page[data-color=azure]:after {
  background: #1DC7EA;
  background: linear-gradient(to bottom, #1DC7EA 0%, #4091ff 100%);
  background-size: 150% 150%;
}
.full-page[data-color=green]:after {
  background: #87CB16;
  background: linear-gradient(to bottom, #87CB16 0%, #6dc030 100%);
  background-size: 150% 150%;
}
.full-page[data-color=orange]:after {
  background: #FFA534;
  background: linear-gradient(to bottom, #FFA534 0%, #ff5221 100%);
  background-size: 150% 150%;
}
.full-page[data-color=red]:after {
  background: #FB404B;
  background: linear-gradient(to bottom, #FB404B 0%, #bb0502 100%);
  background-size: 150% 150%;
}
.full-page[data-color=purple]:after {
  background: #9368E9;
  background: linear-gradient(to bottom, #9368E9 0%, #943bea 100%);
  background-size: 150% 150%;
}

.full-page[data-image]:after,
.full-page.has-image:after {
  opacity: 0.77;
}

.fixed-plugin .dropdown .dropdown-menu {
  border-radius: 10px;
}
.fixed-plugin .dropdown .dropdown-menu li.adjustments-line {
  border-bottom: 1px solid #ddd;
}
.fixed-plugin .dropdown .dropdown-menu li {
  padding: 5px 2px !important;
}
.fixed-plugin .dropdown .dropdown-menu .button-container a {
  font-size: 14px;
}
.fixed-plugin .dropdown .dropdown-menu .adjustments-line .bootstrap-switch {
  position: absolute;
  right: 10px !important;
}
.fixed-plugin .dropdown .dropdown-menu .adjustments-line label {
  margin-bottom: 0.6rem !important;
}

.fixed-plugin li > a,
.fixed-plugin .badge {
  transition: all 0.34s;
  -webkit-transition: all 0.34s;
  -moz-transition: all 0.34s;
}

.fixed-plugin {
  position: fixed;
  top: 200px;
  right: 0;
  width: 64px;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1031;
  border-radius: 8px 0 0 8px;
  text-align: center;
}

.fixed-plugin .fa-cogs {
  color: #FFFFFF;
  padding: 10px;
  border-radius: 0 0 6px 6px;
  width: auto;
}

.fixed-plugin .dropdown-menu {
  right: 80px;
  left: auto;
  width: 290px;
  border-radius: 0.1875rem;
  padding: 0 10px;
}

.fixed-plugin .dropdown-menu:after, .fixed-plugin .dropdown-menu:before {
  right: 10px;
  margin-left: auto;
  left: auto;
}

.fixed-plugin .fa-circle-thin {
  color: #FFFFFF;
}

.fixed-plugin .active .fa-circle-thin {
  color: #00bbff;
}

.fixed-plugin .dropdown-menu > .active > a,
.fixed-plugin .dropdown-menu > .active > a:hover,
.fixed-plugin .dropdown-menu > .active > a:focus {
  color: #777777;
  text-align: center;
}

.fixed-plugin img {
  border-radius: 0;
  width: 100%;
  height: 100px;
  margin: 0 auto;
}

.fixed-plugin .dropdown-menu li > a:hover,
.fixed-plugin .dropdown-menu li > a:focus {
  box-shadow: none;
}

.fixed-plugin .badge {
  border: 3px solid #FFFFFF;
  border-radius: 50%;
  cursor: pointer;
  display: inline-block;
  height: 23px;
  margin-right: 5px;
  position: relative;
  width: 23px;
}

.fixed-plugin .badge.active,
.fixed-plugin .badge:hover {
  border-color: #00bbff;
}

.fixed-plugin .badge-black {
  background-color: #777;
}

.fixed-plugin .badge-azure {
  background-color: #2CA8FF;
}

.fixed-plugin .badge-green {
  background-color: #18ce0f;
}

.fixed-plugin .badge-orange {
  background-color: #f96332;
}

.fixed-plugin .badge-yellow {
  background-color: #FFB236;
}

.fixed-plugin .badge-red {
  background-color: #FF3636;
}

.fixed-plugin .badge-purple {
  background-color: #9368E9;
}

.fixed-plugin h5 {
  font-size: 14px;
  margin: 10px;
}

.fixed-plugin .dropdown-menu li {
  display: block;
  padding: 18px 2px;
  width: 25%;
  float: left;
}

.fixed-plugin li.adjustments-line,
.fixed-plugin li.header-title,
.fixed-plugin li.button-container {
  width: 100%;
  height: 50px;
  min-height: inherit;
}

.fixed-plugin li.button-container {
  height: auto;
}

.fixed-plugin li.button-container div {
  margin-bottom: 5px;
}

.fixed-plugin #sharrreTitle {
  text-align: center;
  padding: 10px 0;
  height: 50px;
}

.fixed-plugin li.header-title {
  height: 30px;
  line-height: 25px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}

.fixed-plugin .adjustments-line p {
  float: left;
  display: inline-block;
  margin-bottom: 0;
  font-size: 1em;
  color: #3C4858;
  padding-top: 7px;
}

.fixed-plugin .adjustments-line a .badge-colors {
  position: relative;
  top: -2px;
}

.fixed-plugin .adjustments-line .togglebutton {
  float: right;
}

.fixed-plugin .adjustments-line .togglebutton .toggle {
  margin-right: 0;
}

.fixed-plugin .dropdown-menu > li.adjustments-line > a {
  padding-right: 0;
  padding-left: 0;
  /*border-bottom: 1px solid #ddd;*/
  border-radius: 0;
  margin: 0;
}

.fixed-plugin .dropdown-menu > li > a.img-holder {
  font-size: 16px;
  text-align: center;
  border-radius: 10px;
  background-color: #FFF;
  border: 3px solid #FFF;
  padding-left: 0;
  padding-right: 0;
  opacity: 1;
  cursor: pointer;
  display: block;
  max-height: 100px;
  overflow: hidden;
  padding: 0;
}

.fixed-plugin .dropdown-menu > li > a.switch-trigger:hover,
.fixed-plugin .dropdown-menu > li > a.switch-trigger:focus {
  background-color: transparent;
}

.fixed-plugin .dropdown-menu > li:hover > a.img-holder,
.fixed-plugin .dropdown-menu > li:focus > a.img-holder {
  border-color: rgba(0, 187, 255, 0.53);
}

.fixed-plugin .dropdown-menu > .active > a.img-holder,
.fixed-plugin .dropdown-menu > .active > a.img-holder {
  border-color: #00bbff;
  background-color: #FFFFFF;
}

.fixed-plugin .dropdown-menu > li > a img {
  margin-top: auto;
}

.fixed-plugin .btn-social {
  width: 50%;
  display: block;
  width: 48%;
  float: left;
  font-weight: 600;
}

.fixed-plugin .btn-social i {
  margin-right: 5px;
}

.fixed-plugin .btn-social:first-child {
  margin-right: 2%;
}

.fixed-plugin .adjustments-line a:hover,
.fixed-plugin .adjustments-line a:focus,
.fixed-plugin .adjustments-line a {
  color: transparent;
}

.fixed-plugin .dropdown .dropdown-menu {
  transform: translate3d(0, -5%, 0) !important;
  top: -40px !important;
  opacity: 0;
  left: -303px !important;
  transform-origin: 0 0;
}

.fixed-plugin .dropdown.show .dropdown-menu {
  opacity: 1;
  transform: translate3d(0, 0%, 0) !important;
  transform-origin: 0 0;
  left: -303px !important;
}

.fixed-plugin .dropdown-menu:before,
.fixed-plugin .dropdown-menu:after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 65px;
  width: 16px;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
}

.fixed-plugin .dropdown-menu:before {
  border-bottom: 16px solid rgba(0, 0, 0, 0);
  border-left: 16px solid rgba(0, 0, 0, 0.2);
  border-top: 16px solid rgba(0, 0, 0, 0);
  right: -16px;
}

.fixed-plugin .dropdown-menu:after {
  border-bottom: 16px solid rgba(0, 0, 0, 0);
  border-left: 16px solid #fff;
  border-top: 16px solid rgba(0, 0, 0, 0);
  right: -15px;
}

.wrapper-full-page ~ .fixed-plugin .dropdown.open .dropdown-menu {
  transform: translateY(-17%);
}

.wrapper-full-page ~ .fixed-plugin .dropdown .dropdown-menu {
  transform: translateY(-19%);
}

.modal-header {
  border: 0 none;
}

.modal-content {
  border: 0 none;
  border-radius: 10px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.15), 0 0 1px 1px rgba(0, 0, 0, 0.1);
}

.modal-dialog {
  padding-top: 60px;
}

.modal-footer {
  border-top: 0 none;
  padding: 10px 10px;
}

.modal-footer .modal-footer .btn-default.btn-simple {
  font-weight: 400;
}

.modal.fade .modal-dialog {
  transform: none;
  -webkit-transform: none;
  -moz-transform: none;
}

.modal.in .modal-dialog {
  transform: none;
  -webkit-transform: none;
  -moz-transform: none;
}

.modal-small .modal-dialog {
  max-width: 350px;
}

.modal-small .divider {
  margin: 0 auto;
  display: block;
  width: 14px;
  position: relative;
  margin-top: 40px;
  margin-bottom: 30px;
  font-size: 1rem;
}
.modal-small .divider:after {
  position: absolute;
  content: "";
  right: -140px;
  top: 12px;
  height: 1px;
  width: 115px;
  background-color: #E3E3E3;
}
.modal-small .divider:before {
  position: absolute;
  content: "";
  left: -140px;
  top: 12px;
  height: 1px;
  width: 115px;
  background-color: #E3E3E3;
}
.modal-small .modal-footer {
  text-align: center;
}

.social-area {
  text-align: center;
}
.social-area .btn-social {
  margin: 0 10px;
}

.modal-backdrop.in {
  opacity: 0.25;
}

.btn {
  border-width: 2px;
  background-color: transparent;
  font-weight: 400;
  padding: 8px 16px;
  border: 1px solid #888888;
  color: #FFFFFF;
  background-color: #888888;
  cursor: pointer;
  margin-bottom: 5px;
  font-size: 0.875rem;
  line-height: 1.42857143;
}
.btn:hover, .btn:focus, .btn:active, .btn.active, .open > .btn.dropdown-toggle {
  background-color: #797979;
  color: #FFFFFF;
  border-color: #797979;
}
.btn.disabled, .btn.disabled:hover, .btn.disabled:focus, .btn.disabled.focus, .btn.disabled:active, .btn.disabled.active, .btn:disabled, .btn:disabled:hover, .btn:disabled:focus, .btn:disabled.focus, .btn:disabled:active, .btn:disabled.active, .btn[disabled], .btn[disabled]:hover, .btn[disabled]:focus, .btn[disabled].focus, .btn[disabled]:active, .btn[disabled].active, fieldset[disabled] .btn, fieldset[disabled] .btn:hover, fieldset[disabled] .btn:focus, fieldset[disabled] .btn.focus, fieldset[disabled] .btn:active, fieldset[disabled] .btn.active {
  background-color: transparent;
  border-color: #888888;
}
.btn.btn-outline {
  color: #888888;
  background-color: transparent;
  border: 1px solid #888888;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn.btn-outline:hover, .btn.btn-outline:focus, .btn.btn-outline:active, .btn.btn-outline.active, .open > .btn.btn-outline.dropdown-toggle {
  background-color: #797979;
  color: #FFFFFF;
  border: 1px solid #797979;
}
.btn.btn-outline .caret {
  border-top-color: #FFFFFF;
}
.btn.btn-link {
  border-color: transparent !important;
  background-color: transparent !important;
  color: #888888;
}
.btn.btn-link:hover, .btn.btn-link:focus, .btn.btn-link:active {
  text-decoration: none;
  border-color: transparent;
  color: #797979;
}
.btn .caret {
  border-top-color: #888888;
}
.btn:hover, .btn:focus {
  outline: 0 !important;
  box-shadow: none;
}
.btn:active, .btn.active, .open > .btn.dropdown-toggle {
  box-shadow: none;
  outline: 0 !important;
}
.btn.btn-icon {
  padding: 8px;
}

.btn-primary {
  border: 1px solid #447DF7;
  color: #FFFFFF;
  background-color: #447DF7;
  cursor: pointer;
}
.btn-primary:hover, .btn-primary:focus, .btn-primary:active, .btn-primary.active, .open > .btn-primary.dropdown-toggle {
  background-color: #2c6cf6;
  color: #FFFFFF;
  border-color: #2c6cf6;
}
.btn-primary.disabled, .btn-primary.disabled:hover, .btn-primary.disabled:focus, .btn-primary.disabled.focus, .btn-primary.disabled:active, .btn-primary.disabled.active, .btn-primary:disabled, .btn-primary:disabled:hover, .btn-primary:disabled:focus, .btn-primary:disabled.focus, .btn-primary:disabled:active, .btn-primary:disabled.active, .btn-primary[disabled], .btn-primary[disabled]:hover, .btn-primary[disabled]:focus, .btn-primary[disabled].focus, .btn-primary[disabled]:active, .btn-primary[disabled].active, fieldset[disabled] .btn-primary, fieldset[disabled] .btn-primary:hover, fieldset[disabled] .btn-primary:focus, fieldset[disabled] .btn-primary.focus, fieldset[disabled] .btn-primary:active, fieldset[disabled] .btn-primary.active {
  background-color: transparent;
  border-color: #447DF7;
}
.btn-primary.btn-outline {
  color: #447DF7;
  background-color: transparent;
  border: 1px solid #447DF7;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-primary.btn-outline:hover, .btn-primary.btn-outline:focus, .btn-primary.btn-outline:active, .btn-primary.btn-outline.active, .open > .btn-primary.btn-outline.dropdown-toggle {
  background-color: #2c6cf6;
  color: #FFFFFF;
  border: 1px solid #2c6cf6;
}
.btn-primary.btn-outline .caret {
  border-top-color: #FFFFFF;
}
.btn-primary.btn-link {
  border-color: transparent !important;
  background-color: transparent !important;
  color: #888888;
}
.btn-primary.btn-link:hover, .btn-primary.btn-link:focus, .btn-primary.btn-link:active {
  text-decoration: none;
  border-color: transparent;
  color: #797979;
}
.btn-primary .caret {
  border-top-color: #447DF7;
}

.btn-success {
  border: 1px solid #275D38;
  color: #FFFFFF;
  background-color: #275D38;
  cursor: pointer;
}
.btn-success:hover, .btn-success:focus, .btn-success:active, .btn-success.active, .open > .btn-success.dropdown-toggle {
  background-color: #1f4b2d;
  color: #FFFFFF;
  border-color: #1f4b2d;
}
.btn-success.disabled, .btn-success.disabled:hover, .btn-success.disabled:focus, .btn-success.disabled.focus, .btn-success.disabled:active, .btn-success.disabled.active, .btn-success:disabled, .btn-success:disabled:hover, .btn-success:disabled:focus, .btn-success:disabled.focus, .btn-success:disabled:active, .btn-success:disabled.active, .btn-success[disabled], .btn-success[disabled]:hover, .btn-success[disabled]:focus, .btn-success[disabled].focus, .btn-success[disabled]:active, .btn-success[disabled].active, fieldset[disabled] .btn-success, fieldset[disabled] .btn-success:hover, fieldset[disabled] .btn-success:focus, fieldset[disabled] .btn-success.focus, fieldset[disabled] .btn-success:active, fieldset[disabled] .btn-success.active {
  background-color: transparent;
  border-color: #275D38;
}
.btn-success.btn-outline {
  color: #275D38;
  background-color: transparent;
  border: 1px solid #275D38;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-success.btn-outline:hover, .btn-success.btn-outline:focus, .btn-success.btn-outline:active, .btn-success.btn-outline.active, .open > .btn-success.btn-outline.dropdown-toggle {
  background-color: #1f4b2d;
  color: #FFFFFF;
  border: 1px solid #1f4b2d;
}
.btn-success.btn-outline .caret {
  border-top-color: #FFFFFF;
}
.btn-success.btn-link {
  border-color: transparent !important;
  background-color: transparent !important;
  color: #888888;
}
.btn-success.btn-link:hover, .btn-success.btn-link:focus, .btn-success.btn-link:active {
  text-decoration: none;
  border-color: transparent;
  color: #797979;
}
.btn-success .caret {
  border-top-color: #275D38;
}

.btn-info {
  border: 1px solid #23CCEF;
  color: #FFFFFF;
  background-color: #23CCEF;
  cursor: pointer;
}
.btn-info:hover, .btn-info:focus, .btn-info:active, .btn-info.active, .open > .btn-info.dropdown-toggle {
  background-color: #11bfe3;
  color: #FFFFFF;
  border-color: #11bfe3;
}
.btn-info.disabled, .btn-info.disabled:hover, .btn-info.disabled:focus, .btn-info.disabled.focus, .btn-info.disabled:active, .btn-info.disabled.active, .btn-info:disabled, .btn-info:disabled:hover, .btn-info:disabled:focus, .btn-info:disabled.focus, .btn-info:disabled:active, .btn-info:disabled.active, .btn-info[disabled], .btn-info[disabled]:hover, .btn-info[disabled]:focus, .btn-info[disabled].focus, .btn-info[disabled]:active, .btn-info[disabled].active, fieldset[disabled] .btn-info, fieldset[disabled] .btn-info:hover, fieldset[disabled] .btn-info:focus, fieldset[disabled] .btn-info.focus, fieldset[disabled] .btn-info:active, fieldset[disabled] .btn-info.active {
  background-color: transparent;
  border-color: #23CCEF;
}
.btn-info.btn-outline {
  color: #23CCEF;
  background-color: transparent;
  border: 1px solid #23CCEF;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-info.btn-outline:hover, .btn-info.btn-outline:focus, .btn-info.btn-outline:active, .btn-info.btn-outline.active, .open > .btn-info.btn-outline.dropdown-toggle {
  background-color: #11bfe3;
  color: #FFFFFF;
  border: 1px solid #11bfe3;
}
.btn-info.btn-outline .caret {
  border-top-color: #FFFFFF;
}
.btn-info.btn-link {
  border-color: transparent !important;
  background-color: transparent !important;
  color: #888888;
}
.btn-info.btn-link:hover, .btn-info.btn-link:focus, .btn-info.btn-link:active {
  text-decoration: none;
  border-color: transparent;
  color: #797979;
}
.btn-info .caret {
  border-top-color: #23CCEF;
}

.btn-warning {
  border: 1px solid #FFA534;
  color: #FFFFFF;
  background-color: #FFA534;
  cursor: pointer;
}
.btn-warning:hover, .btn-warning:focus, .btn-warning:active, .btn-warning.active, .open > .btn-warning.dropdown-toggle {
  background-color: #ff9510;
  color: #FFFFFF;
  border-color: #ff9510;
}
.btn-warning.disabled, .btn-warning.disabled:hover, .btn-warning.disabled:focus, .btn-warning.disabled.focus, .btn-warning.disabled:active, .btn-warning.disabled.active, .btn-warning:disabled, .btn-warning:disabled:hover, .btn-warning:disabled:focus, .btn-warning:disabled.focus, .btn-warning:disabled:active, .btn-warning:disabled.active, .btn-warning[disabled], .btn-warning[disabled]:hover, .btn-warning[disabled]:focus, .btn-warning[disabled].focus, .btn-warning[disabled]:active, .btn-warning[disabled].active, fieldset[disabled] .btn-warning, fieldset[disabled] .btn-warning:hover, fieldset[disabled] .btn-warning:focus, fieldset[disabled] .btn-warning.focus, fieldset[disabled] .btn-warning:active, fieldset[disabled] .btn-warning.active {
  background-color: transparent;
  border-color: #FFA534;
}
.btn-warning.btn-outline {
  color: #FFA534;
  background-color: transparent;
  border: 1px solid #FFA534;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-warning.btn-outline:hover, .btn-warning.btn-outline:focus, .btn-warning.btn-outline:active, .btn-warning.btn-outline.active, .open > .btn-warning.btn-outline.dropdown-toggle {
  background-color: #ff9510;
  color: #FFFFFF;
  border: 1px solid #ff9510;
}
.btn-warning.btn-outline .caret {
  border-top-color: #FFFFFF;
}
.btn-warning.btn-link {
  border-color: transparent !important;
  background-color: transparent !important;
  color: #888888;
}
.btn-warning.btn-link:hover, .btn-warning.btn-link:focus, .btn-warning.btn-link:active {
  text-decoration: none;
  border-color: transparent;
  color: #797979;
}
.btn-warning .caret {
  border-top-color: #FFA534;
}

.btn-danger {
  border: 1px solid #FB404B;
  color: #FFFFFF;
  background-color: #FB404B;
  cursor: pointer;
}
.btn-danger:hover, .btn-danger:focus, .btn-danger:active, .btn-danger.active, .open > .btn-danger.dropdown-toggle {
  background-color: #fa1825;
  color: #FFFFFF;
  border-color: #fa1825;
}
.btn-danger.disabled, .btn-danger.disabled:hover, .btn-danger.disabled:focus, .btn-danger.disabled.focus, .btn-danger.disabled:active, .btn-danger.disabled.active, .btn-danger:disabled, .btn-danger:disabled:hover, .btn-danger:disabled:focus, .btn-danger:disabled.focus, .btn-danger:disabled:active, .btn-danger:disabled.active, .btn-danger[disabled], .btn-danger[disabled]:hover, .btn-danger[disabled]:focus, .btn-danger[disabled].focus, .btn-danger[disabled]:active, .btn-danger[disabled].active, fieldset[disabled] .btn-danger, fieldset[disabled] .btn-danger:hover, fieldset[disabled] .btn-danger:focus, fieldset[disabled] .btn-danger.focus, fieldset[disabled] .btn-danger:active, fieldset[disabled] .btn-danger.active {
  background-color: transparent;
  border-color: #FB404B;
}
.btn-danger.btn-outline {
  color: #FB404B;
  background-color: transparent;
  border: 1px solid #FB404B;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-danger.btn-outline:hover, .btn-danger.btn-outline:focus, .btn-danger.btn-outline:active, .btn-danger.btn-outline.active, .open > .btn-danger.btn-outline.dropdown-toggle {
  background-color: #fa1825;
  color: #FFFFFF;
  border: 1px solid #fa1825;
}
.btn-danger.btn-outline .caret {
  border-top-color: #FFFFFF;
}
.btn-danger.btn-link {
  border-color: transparent !important;
  background-color: transparent !important;
  color: #888888;
}
.btn-danger.btn-link:hover, .btn-danger.btn-link:focus, .btn-danger.btn-link:active {
  text-decoration: none;
  border-color: transparent;
  color: #797979;
}
.btn-danger .caret {
  border-top-color: #FB404B;
}

.btn-neutral {
  border: 1px solid #FFFFFF;
  color: #FFFFFF;
  background-color: #FFFFFF;
  cursor: pointer;
}
.btn-neutral:hover, .btn-neutral:focus, .btn-neutral:active, .btn-neutral.active, .open > .btn-neutral.dropdown-toggle {
  background-color: #FFFFFF;
  color: #FFFFFF;
  border-color: #FFFFFF;
}
.btn-neutral.disabled, .btn-neutral.disabled:hover, .btn-neutral.disabled:focus, .btn-neutral.disabled.focus, .btn-neutral.disabled:active, .btn-neutral.disabled.active, .btn-neutral:disabled, .btn-neutral:disabled:hover, .btn-neutral:disabled:focus, .btn-neutral:disabled.focus, .btn-neutral:disabled:active, .btn-neutral:disabled.active, .btn-neutral[disabled], .btn-neutral[disabled]:hover, .btn-neutral[disabled]:focus, .btn-neutral[disabled].focus, .btn-neutral[disabled]:active, .btn-neutral[disabled].active, fieldset[disabled] .btn-neutral, fieldset[disabled] .btn-neutral:hover, fieldset[disabled] .btn-neutral:focus, fieldset[disabled] .btn-neutral.focus, fieldset[disabled] .btn-neutral:active, fieldset[disabled] .btn-neutral.active {
  background-color: transparent;
  border-color: #FFFFFF;
}
.btn-neutral.btn-outline {
  color: #FFFFFF;
  background-color: transparent;
  border: 1px solid #FFFFFF;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-neutral.btn-outline:hover, .btn-neutral.btn-outline:focus, .btn-neutral.btn-outline:active, .btn-neutral.btn-outline.active, .open > .btn-neutral.btn-outline.dropdown-toggle {
  background-color: #FFFFFF;
  color: #FFFFFF;
  border: 1px solid #FFFFFF;
}
.btn-neutral.btn-outline .caret {
  border-top-color: #FFFFFF;
}
.btn-neutral.btn-link {
  border-color: transparent !important;
  background-color: transparent !important;
  color: #888888;
}
.btn-neutral.btn-link:hover, .btn-neutral.btn-link:focus, .btn-neutral.btn-link:active {
  text-decoration: none;
  border-color: transparent;
  color: #797979;
}
.btn-neutral .caret {
  border-top-color: #FFFFFF;
}
.btn-neutral:active, .btn-neutral.active, .open > .btn-neutral.dropdown-toggle {
  background-color: #FFFFFF;
  color: #888888;
}
.btn-neutral.btn-fill, .btn-neutral.btn-fill:hover, .btn-neutral.btn-fill:focus {
  color: #888888;
}
.btn-neutral.btn-simple:active, .btn-neutral.btn-simple.active {
  background-color: transparent;
}

.btn:disabled, .btn[disabled], .btn.disabled {
  opacity: 0.5;
  filter: alpha(opacity=50);
}

.btn-round {
  border-width: 1px;
  border-radius: 30px !important;
  padding: 8px 16px;
}
.btn-round.btn-icon {
  padding: 8px;
}

.btn-lg {
  font-size: 1.125rem;
  border-radius: 6px;
  padding: 14px 30px;
  font-weight: 400;
}
.btn-lg.btn-round {
  padding: 15px 30px;
}
.btn-lg.btn-simple {
  padding: 16px 30px;
}

.btn-sm {
  font-size: 0.75rem;
  border-radius: 3px;
  padding: 5px 10px;
}
.btn-sm.btn-round {
  padding: 6px 10px;
}
.btn-sm.btn-simple {
  padding: 7px 10px;
}

.btn-wd {
  min-width: 140px;
}

.btn-group.select {
  width: 100%;
}

.btn-group.select .btn {
  text-align: left;
}

.btn-group.select .caret {
  position: absolute;
  top: 50%;
  margin-top: -1px;
  right: 8px;
}

.btn-social {
  opacity: 0.85;
}

button[type=button] {
  -webkit-appearance: none;
          appearance: none;
  border: 0;
}

.btn-social {
  padding: 8px 9px;
}
.btn-social .fa, .btn-social .fas, .btn-social .far, .btn-social .fal, .btn-social .fad, .btn-social .fab {
  font-size: 18px;
  width: 20px;
  vertical-align: middle;
  display: inline-block;
}
.btn-social.btn-round {
  padding: 8px;
}
.btn-social.btn-link {
  padding: 8px 5px;
  font-size: 16px;
}
.btn-social.btn-link .fa, .btn-social.btn-link .fas, .btn-social.btn-link .far, .btn-social.btn-link .fal, .btn-social.btn-link .fad, .btn-social.btn-link .fab {
  font-size: 20px;
  position: relative;
  top: -2px;
  width: 24px;
}

.btn-facebook {
  border-color: #3b5998;
  background-color: #3b5998;
  color: #FFFFFF;
}
.btn-facebook:hover, .btn-facebook:focus, .btn-facebook:active, .btn-facebook.active, .open > .btn-facebook.dropdown-toggle {
  background-color: #2d4373;
  color: #FFFFFF;
  border-color: #3b5998;
}
.btn-facebook:disabled, .btn-facebook[disabled], .btn-facebook.disabled {
  background-color: transparent;
  border-color: #3b5998;
}
.btn-facebook.btn-outline {
  color: #3b5998;
  background-color: transparent;
  border: 1px solid #3b5998;
}
.btn-facebook.btn-outline:hover, .btn-facebook.btn-outline:focus, .btn-facebook.btn-outline:active, .btn-facebook.btn-outline.active, .open > .btn-facebook.btn-outline.dropdown-toggle {
  background-color: #2d4373;
  color: #FFFFFF;
  border: 1px solid #2d4373;
}
.btn-facebook.btn-link {
  color: #3b5998;
  background-color: transparent;
  border: 1px solid #3b5998;
}
.btn-facebook.btn-link:hover, .btn-facebook.btn-link:focus, .btn-facebook.btn-link:active, .btn-facebook.btn-link.active, .open > .btn-facebook.btn-link.dropdown-toggle {
  background-color: transparent;
  color: #2d4373;
  border: 1px solid #2d4373;
}

.btn-twitter {
  border-color: #55acee;
  background-color: #55acee;
  color: #FFFFFF;
}
.btn-twitter:hover, .btn-twitter:focus, .btn-twitter:active, .btn-twitter.active, .open > .btn-twitter.dropdown-toggle {
  background-color: #2795e9;
  color: #FFFFFF;
  border-color: #55acee;
}
.btn-twitter:disabled, .btn-twitter[disabled], .btn-twitter.disabled {
  background-color: transparent;
  border-color: #55acee;
}
.btn-twitter.btn-outline {
  color: #55acee;
  background-color: transparent;
  border: 1px solid #55acee;
}
.btn-twitter.btn-outline:hover, .btn-twitter.btn-outline:focus, .btn-twitter.btn-outline:active, .btn-twitter.btn-outline.active, .open > .btn-twitter.btn-outline.dropdown-toggle {
  background-color: #2795e9;
  color: #FFFFFF;
  border: 1px solid #2795e9;
}
.btn-twitter.btn-link {
  color: #55acee;
  background-color: transparent;
  border: 1px solid #55acee;
}
.btn-twitter.btn-link:hover, .btn-twitter.btn-link:focus, .btn-twitter.btn-link:active, .btn-twitter.btn-link.active, .open > .btn-twitter.btn-link.dropdown-toggle {
  background-color: transparent;
  color: #2795e9;
  border: 1px solid #2795e9;
}

.btn-pinterest {
  border-color: #cc2127;
  background-color: #cc2127;
  color: #FFFFFF;
}
.btn-pinterest:hover, .btn-pinterest:focus, .btn-pinterest:active, .btn-pinterest.active, .open > .btn-pinterest.dropdown-toggle {
  background-color: #a01a1f;
  color: #FFFFFF;
  border-color: #cc2127;
}
.btn-pinterest:disabled, .btn-pinterest[disabled], .btn-pinterest.disabled {
  background-color: transparent;
  border-color: #cc2127;
}
.btn-pinterest.btn-outline {
  color: #cc2127;
  background-color: transparent;
  border: 1px solid #cc2127;
}
.btn-pinterest.btn-outline:hover, .btn-pinterest.btn-outline:focus, .btn-pinterest.btn-outline:active, .btn-pinterest.btn-outline.active, .open > .btn-pinterest.btn-outline.dropdown-toggle {
  background-color: #a01a1f;
  color: #FFFFFF;
  border: 1px solid #a01a1f;
}
.btn-pinterest.btn-link {
  color: #cc2127;
  background-color: transparent;
  border: 1px solid #cc2127;
}
.btn-pinterest.btn-link:hover, .btn-pinterest.btn-link:focus, .btn-pinterest.btn-link:active, .btn-pinterest.btn-link.active, .open > .btn-pinterest.btn-link.dropdown-toggle {
  background-color: transparent;
  color: #a01a1f;
  border: 1px solid #a01a1f;
}

.btn-google {
  border-color: #dd4b39;
  background-color: #dd4b39;
  color: #FFFFFF;
}
.btn-google:hover, .btn-google:focus, .btn-google:active, .btn-google.active, .open > .btn-google.dropdown-toggle {
  background-color: #c23321;
  color: #FFFFFF;
  border-color: #dd4b39;
}
.btn-google:disabled, .btn-google[disabled], .btn-google.disabled {
  background-color: transparent;
  border-color: #dd4b39;
}
.btn-google.btn-outline {
  color: #dd4b39;
  background-color: transparent;
  border: 1px solid #dd4b39;
}
.btn-google.btn-outline:hover, .btn-google.btn-outline:focus, .btn-google.btn-outline:active, .btn-google.btn-outline.active, .open > .btn-google.btn-outline.dropdown-toggle {
  background-color: #c23321;
  color: #FFFFFF;
  border: 1px solid #c23321;
}
.btn-google.btn-link {
  color: #dd4b39;
  background-color: transparent;
  border: 1px solid #dd4b39;
}
.btn-google.btn-link:hover, .btn-google.btn-link:focus, .btn-google.btn-link:active, .btn-google.btn-link.active, .open > .btn-google.btn-link.dropdown-toggle {
  background-color: transparent;
  color: #c23321;
  border: 1px solid #c23321;
}

.btn-linkedin {
  border-color: #0976b4;
  background-color: #0976b4;
  color: #FFFFFF;
}
.btn-linkedin:hover, .btn-linkedin:focus, .btn-linkedin:active, .btn-linkedin.active, .open > .btn-linkedin.dropdown-toggle {
  background-color: #075683;
  color: #FFFFFF;
  border-color: #0976b4;
}
.btn-linkedin:disabled, .btn-linkedin[disabled], .btn-linkedin.disabled {
  background-color: transparent;
  border-color: #0976b4;
}
.btn-linkedin.btn-outline {
  color: #0976b4;
  background-color: transparent;
  border: 1px solid #0976b4;
}
.btn-linkedin.btn-outline:hover, .btn-linkedin.btn-outline:focus, .btn-linkedin.btn-outline:active, .btn-linkedin.btn-outline.active, .open > .btn-linkedin.btn-outline.dropdown-toggle {
  background-color: #075683;
  color: #FFFFFF;
  border: 1px solid #075683;
}
.btn-linkedin.btn-link {
  color: #0976b4;
  background-color: transparent;
  border: 1px solid #0976b4;
}
.btn-linkedin.btn-link:hover, .btn-linkedin.btn-link:focus, .btn-linkedin.btn-link:active, .btn-linkedin.btn-link.active, .open > .btn-linkedin.btn-link.dropdown-toggle {
  background-color: transparent;
  color: #075683;
  border: 1px solid #075683;
}

.btn-dribbble {
  border-color: #ea4c89;
  background-color: #ea4c89;
  color: #FFFFFF;
}
.btn-dribbble:hover, .btn-dribbble:focus, .btn-dribbble:active, .btn-dribbble.active, .open > .btn-dribbble.dropdown-toggle {
  background-color: #e51e6b;
  color: #FFFFFF;
  border-color: #ea4c89;
}
.btn-dribbble:disabled, .btn-dribbble[disabled], .btn-dribbble.disabled {
  background-color: transparent;
  border-color: #ea4c89;
}
.btn-dribbble.btn-outline {
  color: #ea4c89;
  background-color: transparent;
  border: 1px solid #ea4c89;
}
.btn-dribbble.btn-outline:hover, .btn-dribbble.btn-outline:focus, .btn-dribbble.btn-outline:active, .btn-dribbble.btn-outline.active, .open > .btn-dribbble.btn-outline.dropdown-toggle {
  background-color: #e51e6b;
  color: #FFFFFF;
  border: 1px solid #e51e6b;
}
.btn-dribbble.btn-link {
  color: #ea4c89;
  background-color: transparent;
  border: 1px solid #ea4c89;
}
.btn-dribbble.btn-link:hover, .btn-dribbble.btn-link:focus, .btn-dribbble.btn-link:active, .btn-dribbble.btn-link.active, .open > .btn-dribbble.btn-link.dropdown-toggle {
  background-color: transparent;
  color: #e51e6b;
  border: 1px solid #e51e6b;
}

.btn-github {
  border-color: #333333;
  background-color: #333333;
  color: #FFFFFF;
}
.btn-github:hover, .btn-github:focus, .btn-github:active, .btn-github.active, .open > .btn-github.dropdown-toggle {
  background-color: #1a1a1a;
  color: #FFFFFF;
  border-color: #333333;
}
.btn-github:disabled, .btn-github[disabled], .btn-github.disabled {
  background-color: transparent;
  border-color: #333333;
}
.btn-github.btn-outline {
  color: #333333;
  background-color: transparent;
  border: 1px solid #333333;
}
.btn-github.btn-outline:hover, .btn-github.btn-outline:focus, .btn-github.btn-outline:active, .btn-github.btn-outline.active, .open > .btn-github.btn-outline.dropdown-toggle {
  background-color: #1a1a1a;
  color: #FFFFFF;
  border: 1px solid #1a1a1a;
}
.btn-github.btn-link {
  color: #333333;
  background-color: transparent;
  border: 1px solid #333333;
}
.btn-github.btn-link:hover, .btn-github.btn-link:focus, .btn-github.btn-link:active, .btn-github.btn-link.active, .open > .btn-github.btn-link.dropdown-toggle {
  background-color: transparent;
  color: #1a1a1a;
  border: 1px solid #1a1a1a;
}

.btn-youtube {
  border-color: #e52d27;
  background-color: #e52d27;
  color: #FFFFFF;
}
.btn-youtube:hover, .btn-youtube:focus, .btn-youtube:active, .btn-youtube.active, .open > .btn-youtube.dropdown-toggle {
  background-color: #c21d17;
  color: #FFFFFF;
  border-color: #e52d27;
}
.btn-youtube:disabled, .btn-youtube[disabled], .btn-youtube.disabled {
  background-color: transparent;
  border-color: #e52d27;
}
.btn-youtube.btn-outline {
  color: #e52d27;
  background-color: transparent;
  border: 1px solid #e52d27;
}
.btn-youtube.btn-outline:hover, .btn-youtube.btn-outline:focus, .btn-youtube.btn-outline:active, .btn-youtube.btn-outline.active, .open > .btn-youtube.btn-outline.dropdown-toggle {
  background-color: #c21d17;
  color: #FFFFFF;
  border: 1px solid #c21d17;
}
.btn-youtube.btn-link {
  color: #e52d27;
  background-color: transparent;
  border: 1px solid #e52d27;
}
.btn-youtube.btn-link:hover, .btn-youtube.btn-link:focus, .btn-youtube.btn-link:active, .btn-youtube.btn-link.active, .open > .btn-youtube.btn-link.dropdown-toggle {
  background-color: transparent;
  color: #c21d17;
  border: 1px solid #c21d17;
}

.btn-stumbleupon {
  border-color: #eb4924;
  background-color: #eb4924;
  color: #FFFFFF;
}
.btn-stumbleupon:hover, .btn-stumbleupon:focus, .btn-stumbleupon:active, .btn-stumbleupon.active, .open > .btn-stumbleupon.dropdown-toggle {
  background-color: #ca3412;
  color: #FFFFFF;
  border-color: #eb4924;
}
.btn-stumbleupon:disabled, .btn-stumbleupon[disabled], .btn-stumbleupon.disabled {
  background-color: transparent;
  border-color: #eb4924;
}
.btn-stumbleupon.btn-outline {
  color: #eb4924;
  background-color: transparent;
  border: 1px solid #eb4924;
}
.btn-stumbleupon.btn-outline:hover, .btn-stumbleupon.btn-outline:focus, .btn-stumbleupon.btn-outline:active, .btn-stumbleupon.btn-outline.active, .open > .btn-stumbleupon.btn-outline.dropdown-toggle {
  background-color: #ca3412;
  color: #FFFFFF;
  border: 1px solid #ca3412;
}
.btn-stumbleupon.btn-link {
  color: #eb4924;
  background-color: transparent;
  border: 1px solid #eb4924;
}
.btn-stumbleupon.btn-link:hover, .btn-stumbleupon.btn-link:focus, .btn-stumbleupon.btn-link:active, .btn-stumbleupon.btn-link.active, .open > .btn-stumbleupon.btn-link.dropdown-toggle {
  background-color: transparent;
  color: #ca3412;
  border: 1px solid #ca3412;
}

.btn-reddit {
  border-color: #ff4500;
  background-color: #ff4500;
  color: #FFFFFF;
}
.btn-reddit:hover, .btn-reddit:focus, .btn-reddit:active, .btn-reddit.active, .open > .btn-reddit.dropdown-toggle {
  background-color: #cc3700;
  color: #FFFFFF;
  border-color: #ff4500;
}
.btn-reddit:disabled, .btn-reddit[disabled], .btn-reddit.disabled {
  background-color: transparent;
  border-color: #ff4500;
}
.btn-reddit.btn-outline {
  color: #ff4500;
  background-color: transparent;
  border: 1px solid #ff4500;
}
.btn-reddit.btn-outline:hover, .btn-reddit.btn-outline:focus, .btn-reddit.btn-outline:active, .btn-reddit.btn-outline.active, .open > .btn-reddit.btn-outline.dropdown-toggle {
  background-color: #cc3700;
  color: #FFFFFF;
  border: 1px solid #cc3700;
}
.btn-reddit.btn-link {
  color: #ff4500;
  background-color: transparent;
  border: 1px solid #ff4500;
}
.btn-reddit.btn-link:hover, .btn-reddit.btn-link:focus, .btn-reddit.btn-link:active, .btn-reddit.btn-link.active, .open > .btn-reddit.btn-link.dropdown-toggle {
  background-color: transparent;
  color: #cc3700;
  border: 1px solid #cc3700;
}

.btn-tumblr {
  border-color: #35465c;
  background-color: #35465c;
  color: #FFFFFF;
}
.btn-tumblr:hover, .btn-tumblr:focus, .btn-tumblr:active, .btn-tumblr.active, .open > .btn-tumblr.dropdown-toggle {
  background-color: #222d3c;
  color: #FFFFFF;
  border-color: #35465c;
}
.btn-tumblr:disabled, .btn-tumblr[disabled], .btn-tumblr.disabled {
  background-color: transparent;
  border-color: #35465c;
}
.btn-tumblr.btn-outline {
  color: #35465c;
  background-color: transparent;
  border: 1px solid #35465c;
}
.btn-tumblr.btn-outline:hover, .btn-tumblr.btn-outline:focus, .btn-tumblr.btn-outline:active, .btn-tumblr.btn-outline.active, .open > .btn-tumblr.btn-outline.dropdown-toggle {
  background-color: #222d3c;
  color: #FFFFFF;
  border: 1px solid #222d3c;
}
.btn-tumblr.btn-link {
  color: #35465c;
  background-color: transparent;
  border: 1px solid #35465c;
}
.btn-tumblr.btn-link:hover, .btn-tumblr.btn-link:focus, .btn-tumblr.btn-link:active, .btn-tumblr.btn-link.active, .open > .btn-tumblr.btn-link.dropdown-toggle {
  background-color: transparent;
  color: #222d3c;
  border: 1px solid #222d3c;
}

.btn-behance {
  border-color: #1769ff;
  background-color: #1769ff;
  color: #FFFFFF;
}
.btn-behance:hover, .btn-behance:focus, .btn-behance:active, .btn-behance.active, .open > .btn-behance.dropdown-toggle {
  background-color: #0050e3;
  color: #FFFFFF;
  border-color: #1769ff;
}
.btn-behance:disabled, .btn-behance[disabled], .btn-behance.disabled {
  background-color: transparent;
  border-color: #1769ff;
}
.btn-behance.btn-outline {
  color: #1769ff;
  background-color: transparent;
  border: 1px solid #1769ff;
}
.btn-behance.btn-outline:hover, .btn-behance.btn-outline:focus, .btn-behance.btn-outline:active, .btn-behance.btn-outline.active, .open > .btn-behance.btn-outline.dropdown-toggle {
  background-color: #0050e3;
  color: #FFFFFF;
  border: 1px solid #0050e3;
}
.btn-behance.btn-link {
  color: #1769ff;
  background-color: transparent;
  border: 1px solid #1769ff;
}
.btn-behance.btn-link:hover, .btn-behance.btn-link:focus, .btn-behance.btn-link:active, .btn-behance.btn-link.active, .open > .btn-behance.btn-link.dropdown-toggle {
  background-color: transparent;
  color: #0050e3;
  border: 1px solid #0050e3;
}

.form-control::-moz-placeholder {
  color: #DDDDDD;
  opacity: 1;
  filter: alpha(opacity=100);
}

.form-control:-moz-placeholder {
  color: #DDDDDD;
  opacity: 1;
  filter: alpha(opacity=100);
}

.form-control::-webkit-input-placeholder {
  color: #DDDDDD;
  opacity: 1;
  filter: alpha(opacity=100);
}

.form-control:-ms-input-placeholder {
  color: #DDDDDD;
  opacity: 1;
  filter: alpha(opacity=100);
}

.form-control {
  background-color: #FFFFFF;
  border: 1px solid #E3E3E3;
  border-radius: 4px;
  font-size: 0.875rem;
  color: #565656;
  padding: 8px 12px;
  height: 40px;
  box-shadow: none;
}
.form-control:focus {
  background-color: #FFFFFF;
  border: 1px solid #AAAAAA;
  box-shadow: none;
  outline: 0 !important;
  color: #333333;
}
.has-success .form-control, .has-error .form-control, .has-success .form-control:focus, .has-error .form-control:focus {
  border-color: #E3E3E3;
  box-shadow: none;
}
.has-success .form-control:focus {
  border-color: #275D38;
  color: #275D38;
}
.has-error .form-control {
  color: #FB404B;
}
.has-error .form-control:focus {
  border-color: #FB404B;
}
.form-control + .form-control-feedback {
  border-radius: 6px;
  font-size: 0.875rem;
  margin-top: -7px;
  position: absolute;
  right: 10px;
  top: 50%;
  vertical-align: middle;
}
.open .form-control {
  border-radius: 4px 4px 0 0;
  border-bottom-color: transparent;
}

.input-lg {
  height: 55px;
  padding: 14px 30px;
}

.has-error .form-control-feedback {
  color: #FB404B;
}

.has-success .form-control-feedback {
  color: #275D38;
}

.input-group-addon {
  background-color: #FFFFFF;
  border: 1px solid #E3E3E3;
  border-radius: 4px;
}
.has-success .input-group-addon, .has-error .input-group-addon {
  background-color: #FFFFFF;
  border: 1px solid #E3E3E3;
}
.has-error .form-control:focus + .input-group-addon {
  border-color: #FB404B;
  color: #FB404B;
}
.has-success .form-control:focus + .input-group-addon {
  border-color: #275D38;
  color: #275D38;
}
.form-control:focus + .input-group-addon, .form-control:focus ~ .input-group-addon {
  background-color: #FFFFFF;
  border-color: #9A9A9A;
}

.input-group .form-control:first-child,
.input-group-addon:first-child,
.input-group-btn:first-child > .dropdown-toggle,
.input-group-btn:last-child > .btn:not(:last-child):not(.dropdown-toggle) {
  border-right: 0 none;
}

.input-group .form-control:last-child,
.input-group-addon:last-child,
.input-group-btn:last-child > .dropdown-toggle,
.input-group-btn:first-child > .btn:not(:first-child) {
  border-left: 0 none;
}

.form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control {
  background-color: #F5F5F5;
  color: #888888;
  cursor: not-allowed;
}

.input-group-btn .btn {
  border-width: 1px;
  padding: 8px 16px;
}

.input-group-btn .btn-default:not(.btn-fill) {
  border-color: #DDDDDD;
}

.input-group-btn:last-child > .btn {
  margin-left: 0;
}

.input-group-focus .input-group-addon {
  border-color: #9A9A9A;
}

.star {
  color: #FB404B;
  padding-left: 3px;
}

.card .card-body .control-label {
  text-align: right;
  padding-top: 18px;
}
.card .card-body .form-control-static,
.card .card-body .col-sm-10 .form-check:first-of-type,
.card .card-body .col-sm-4 .form-check:first-of-type {
  padding-top: 8px;
}

.form-group.has-error .error {
  color: #FB404B;
  text-transform: none;
  margin-bottom: 0;
}

.form-group.has-success .error {
  display: none !important;
}

.alert {
  border: 0;
  border-radius: 0;
  color: #FFFFFF;
  padding: 10px 15px;
  font-size: 14px;
}
.container .alert {
  border-radius: 4px;
}
.navbar .alert {
  border-radius: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 85px;
  width: 100%;
  z-index: 3;
}
.navbar:not(.navbar-transparent) .alert {
  top: 70px;
}
.alert span[data-notify=icon] {
  font-size: 30px;
  display: block;
  left: 15px;
  position: absolute;
  top: 50%;
  margin-top: -15px;
}
.alert i.nc-simple-remove {
  font-size: 12px !important;
  font: bold normal normal 14px/1 "nucleo-icons";
}
.alert button.close {
  position: absolute;
  right: 10px;
  top: 50%;
  margin-top: -13px;
  z-index: 1033;
  background-color: #FFFFFF;
  display: block;
  border-radius: 50%;
  opacity: 0.4;
  line-height: 9px;
  width: 25px;
  height: 25px;
  outline: 0 !important;
  text-align: center;
  padding: 3px;
  font-weight: 300;
}
.alert button.close:hover {
  opacity: 0.55;
}
.alert .close ~ span {
  display: block;
  max-width: 89%;
}
.alert[data-notify=container] {
  padding: 10px 10px 10px 20px;
  border-radius: 4px;
}
.alert.alert-with-icon {
  padding-left: 65px;
}

.alert-primary {
  background-color: #4091e2;
}

.alert-info {
  background-color: #63d8f1;
}

.alert-success {
  background-color: #a1e82c;
}

.alert-warning {
  background-color: #ffbc67;
}

.alert-danger {
  background-color: #fc727a;
}

.table .radio,
.table .checkbox {
  position: relative;
  height: 20px;
  display: block;
  width: 20px;
  padding: 0px 0px;
  margin: 0px 5px;
}
.table > thead > tr > th,
.table > tbody > tr > th,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > tbody > tr > td,
.table > tfoot > tr > td {
  padding: 12px 8px;
  vertical-align: middle;
  border-color: #E3E3E3;
}
.table > thead > tr > th {
  border-bottom-width: 1px;
  font-size: 0.75rem;
  text-transform: uppercase;
  color: #9A9A9A;
  font-weight: 400;
  padding-bottom: 5px;
}
.table table > tr > td.td-actions {
  display: inline-flex !important;
}
.table .td-actions .btn {
  opacity: 0.36;
  filter: alpha(opacity=36);
}
.table .td-actions .btn.btn-xs {
  padding-left: 3px;
  padding-right: 3px;
}
.table .td-actions {
  min-width: 90px;
}
.table > tbody > tr {
  position: relative;
  font-size: 14px !important;
}
.table > tbody > tr:hover .td-actions .btn {
  opacity: 1;
  filter: alpha(opacity=100);
}
.table thead th {
  border-bottom: none !important;
  border-top: none !important;
}
.table .btn-info.btn-link {
  color: #23CCEF;
}
.table .btn-danger.btn-link {
  color: #FB404B;
}
.table .btn-success.btn-link {
  color: #275D38;
}
.table .btn-warning.btn-link {
  color: #FFA534;
}
.table .form-check .form-check-sign,
.table .form-check .form-check-sign:before,
.table .form-check .form-check-sign:after {
  margin-top: -14px;
}

.card .table tbody td:first-child,
.card .table thead th:first-child {
  padding-left: 15px;
}
.card .table tbody td:last-child,
.card .table thead th:last-child {
  padding-right: 15px;
  display: block;
}

.table-bigboy > thead > tr > th {
  font-size: 0.875rem;
  text-transform: uppercase;
  color: #9A9A9A;
  font-weight: 400;
}
.table-bigboy > tbody > tr > td {
  font-size: 0.875rem;
}
.table-bigboy > tbody > tr > td b {
  display: block;
  margin-bottom: 5px;
}
.table-bigboy .td-name {
  font-weight: 300;
  font-size: 1.125rem;
}
.table-bigboy .td-name {
  min-width: 240px;
}
.table-bigboy .td-number {
  text-align: right;
  min-width: 110px;
}
.table-bigboy .td-number small {
  margin-right: 3px;
}
.table-bigboy .td-actions {
  width: 60px;
  min-width: auto;
}
.table-bigboy .td-actions .btn {
  float: right;
}
.table-bigboy .img-container {
  width: 180px;
  height: 120px;
  overflow: hidden;
  display: block;
  border-radius: 6px;
}
.table-bigboy .img-container img {
  width: 100%;
}

.table-with-links .card-body {
  padding-bottom: 0 !important;
}
.table-with-links .card-body .table .btn {
  margin-bottom: 0 !important;
}
.table-with-links .card-body .table tr td {
  padding: 7px 3px !important;
}

.table-with-switches .card-body,
.regular-table-with-color .card-body {
  padding-bottom: 0 !important;
}
.table-with-switches .card-body .table tbody td:last-child,
.regular-table-with-color .card-body .table tbody td:last-child {
  padding-right: 10px !important;
}

.table-big-boy .card-body {
  padding-bottom: 0 !important;
}
.table-big-boy .card-body .table tbody td:last-child {
  padding-right: 10px !important;
}

.bootstrap-table .table thead th:first-child {
  padding-left: 0 !important;
}
.bootstrap-table .dropdown-menu li a {
  display: block;
  padding: 8px 16px;
  clear: both;
  font-weight: 400;
  line-height: 1.42857143;
  white-space: nowrap;
  color: #333;
}
.bootstrap-table .dropdown-menu li a:hover {
  background-color: #F5F5F5;
}
.bootstrap-table .dropdown-menu li.active a {
  background-color: rgba(68, 125, 247, 0.2);
}

.data-tables table tbody .btn {
  padding: 3px !important;
  font-size: 16px !important;
}
.data-tables .pagination {
  float: right;
}
.data-tables tfoot {
  font-size: 14px;
}

.card-tasks .table tbody td:last-child {
  padding-right: 0;
  display: inline-flex;
}
.card-tasks .table tbody td:last-child .btn {
  padding: 3px;
}
.card-tasks .table tbody td:first-child {
  padding-left: 0;
}
.card-tasks .table-full-width {
  padding-bottom: 0 !important;
}
.card-tasks .card-footer {
  padding-top: 0;
}
.card-tasks .table {
  margin-bottom: 0 !important;
}

.table-full-width {
  margin-left: -15px;
  margin-right: -15px;
  padding: 15px !important;
}

.table > thead > tr > td.success,
.table > thead > tr > th.success, .table > thead > tr.success > td, .table > thead > tr.success > th,
.table > tbody > tr > td.success,
.table > tbody > tr > th.success,
.table > tbody > tr.success > td,
.table > tbody > tr.success > th,
.table > tfoot > tr > td.success,
.table > tfoot > tr > th.success,
.table > tfoot > tr.success > td,
.table > tfoot > tr.success > th {
  background-color: rgba(39, 93, 56, 0.2);
}

.table-hover > tbody > tr > td.success:hover,
.table-hover > tbody > tr > th.success:hover, .table-hover > tbody > tr.success:hover > td, .table-hover > tbody > tr:hover > .success, .table-hover > tbody > tr.success:hover > th {
  background-color: rgba(44, 104, 62, 0.2);
}

.table > thead > tr > td.info,
.table > thead > tr > th.info, .table > thead > tr.info > td, .table > thead > tr.info > th,
.table > tbody > tr > td.info,
.table > tbody > tr > th.info,
.table > tbody > tr.info > td,
.table > tbody > tr.info > th,
.table > tfoot > tr > td.info,
.table > tfoot > tr > th.info,
.table > tfoot > tr.info > td,
.table > tfoot > tr.info > th {
  background-color: rgba(35, 204, 239, 0.2);
}

.table-hover > tbody > tr > td.info:hover,
.table-hover > tbody > tr > th.info:hover, .table-hover > tbody > tr.info:hover > td, .table-hover > tbody > tr:hover > .info, .table-hover > tbody > tr.info:hover > th {
  background-color: rgba(49, 207, 240, 0.2);
}

.table > thead > tr > td.warning,
.table > thead > tr > th.warning, .table > thead > tr.warning > td, .table > thead > tr.warning > th,
.table > tbody > tr > td.warning,
.table > tbody > tr > th.warning,
.table > tbody > tr.warning > td,
.table > tbody > tr.warning > th,
.table > tfoot > tr > td.warning,
.table > tfoot > tr > th.warning,
.table > tfoot > tr.warning > td,
.table > tfoot > tr.warning > th {
  background-color: rgba(255, 165, 52, 0.2);
}

.table-hover > tbody > tr > td.warning:hover,
.table-hover > tbody > tr > th.warning:hover, .table-hover > tbody > tr.warning:hover > td, .table-hover > tbody > tr:hover > .warning, .table-hover > tbody > tr.warning:hover > th {
  background-color: rgba(255, 172, 67, 0.2);
}

.table > thead > tr > td.danger,
.table > thead > tr > th.danger, .table > thead > tr.danger > td, .table > thead > tr.danger > th,
.table > tbody > tr > td.danger,
.table > tbody > tr > th.danger,
.table > tbody > tr.danger > td,
.table > tbody > tr.danger > th,
.table > tfoot > tr > td.danger,
.table > tfoot > tr > th.danger,
.table > tfoot > tr.danger > td,
.table > tfoot > tr.danger > th {
  background-color: rgba(251, 64, 75, 0.2);
}

.table-hover > tbody > tr > td.danger:hover,
.table-hover > tbody > tr > th.danger:hover, .table-hover > tbody > tr.danger:hover > td, .table-hover > tbody > tr:hover > .danger, .table-hover > tbody > tr.danger:hover > th {
  background-color: rgba(251, 79, 89, 0.2);
}

.from-check,
.form-check-radio {
  margin-bottom: 12px;
  position: relative;
}

.form-check .form-check-label {
  display: inline-block;
  position: relative;
  cursor: pointer;
  padding-left: 35px;
  line-height: 26px;
  margin-bottom: 0;
  text-transform: capitalize;
}
.form-check .form-check-sign::before,
.form-check .form-check-sign::after {
  font-family: "Font Awesome 5 Free";
  content: "\\f0c8";
  color: #888888;
  display: inline-block;
  position: absolute;
  width: 19px;
  height: 19px;
  margin-left: -23px;
  font-size: 18px;
  cursor: pointer;
  transition: opacity 0.3s linear;
}
.form-check .form-check-sign::after {
  font-family: "Font Awesome 5 Free";
  content: "\\f14a";
  text-align: center;
  opacity: 0;
  color: #23CCEF;
  border: 0;
  background-color: inherit;
  margin-left: -23px;
  font-weight: bold;
}
.form-check .form-check-sign::before {
  margin-left: -22px;
}
.form-check.disabled .form-check-label {
  color: #9A9A9A;
  opacity: 0.5;
  cursor: not-allowed;
}

#RegisterValidation .card .form-check .form-check-sign:before {
  margin-left: -27px;
}

.form-check .form-check-input:disabled + .form-check-sign:before,
.form-check .form-check-input:disabled + .form-check-sign:after,
.radio input[type=radio]:disabled + label,
.form-check .form-check-input:disabled:checked + .form-check-sign::after {
  color: #ddd;
  pointer-events: none;
}

.form-check.disabled .form-check-label {
  cursor: not-allowed;
}

.form-check input[type=checkbox],
.form-check-radio input[type=radio] {
  opacity: 0;
  position: absolute;
  visibility: hidden;
}

.form-check input[type=checkbox]:checked + .form-check-sign::after {
  opacity: 1;
}

.form-check input[type=checkbox]:checked + .form-check-sign::before {
  opacity: 0;
}

.form-control input[type=checkbox]:disabled + .form-check-sign::before,
.checkbox input[type=checkbox]:disabled + .form-check-sign::after {
  cursor: not-allowed;
}

.form-check .form-check-label input[type=checkbox]:disabled + .form-check-sign,
.form-check-radio input[type=radio]:disabled + .form-check-sign {
  pointer-events: none !important;
}

.form-check.checkbox-inline {
  display: inline-block;
}

.form-check-radio .form-check-label {
  padding-left: 2.2rem;
}
.form-check-radio.disabled .form-check-label {
  color: #9A9A9A;
  opacity: 0.5;
  cursor: not-allowed;
}

.form-check-radio .form-check-sign::before {
  font-family: "FontAwesome";
  content: "\\f10c";
  font-size: 18px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: inline-block;
  position: absolute;
  opacity: 0.5;
  left: 34px;
}

.form-check-radio input[type=radio] + .form-check-sign:after,
.form-check-radio input[type=radio] {
  opacity: 0;
  transition: opacity 0.3s linear;
  content: " ";
  display: block;
  margin-left: 5px;
  font-size: 18px;
}

.form-check-radio input[type=radio]:checked + .form-check-sign::after {
  font-family: "FontAwesome";
  content: "\\f192";
  position: absolute;
  left: 5.3px;
  opacity: 1;
}

.form-check-radio input[type=radio]:checked + .form-check-sign::after {
  opacity: 1;
  transition: opacity 0.3s linear;
}

.form-check input[type=radio]:checked + .form-check-sign::before {
  opacity: 0;
  transition: opacity 0.3s linear;
}

.form-check-radio input[type=radio]:disabled + .form-check-sign::before,
.form-check-radio input[type=radio]:disabled + .form-check-sign::after {
  color: #9A9A9A;
}

.card.stacked-form .form-check .form-check-label, .card.horizontal-form .form-check .form-check-label {
  padding-left: 22px !important;
}

.nav .nav-item .nav-link:hover,
.nav .nav-item .nav-link:focus {
  background-color: transparent;
}

.navbar {
  border: 0;
  font-size: 1rem;
  border-radius: 0;
  min-height: 50px;
  max-height: 61px;
  background-color: rgba(255, 255, 255, 0.96);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.navbar .navbar-brand {
  font-weight: 400;
  margin: 5px 0px;
  font-size: 18px;
  color: #888888;
}
.navbar .navbar-brand:hover {
  color: #5e5e5e;
}
.navbar .navbar-wrapper {
  display: inline-flex;
  align-items: center;
}
.navbar .navbar-toggler {
  width: 37px;
  height: 27px;
  vertical-align: middle;
  outline: 0;
  cursor: pointer;
}
.navbar .navbar-toggler.navbar-toggler-left {
  position: relative;
  left: 0;
  padding-left: 0;
}
.navbar .navbar-toggler.navbar-toggler-right {
  padding-right: 0;
}
.navbar .navbar-toggler .navbar-toggler-bar {
  width: 3px;
  height: 3px;
  border-radius: 50%;
  margin: 0 auto;
}
.navbar .navbar-toggler .burger-lines {
  display: block;
  position: relative;
  background-color: #888;
  width: 24px;
  height: 2px;
  border-radius: 1px;
  margin: 4px auto;
}
.navbar .btn-round.btn-icon {
  padding: 8px 9px;
}
.navbar .navbar-nav .nav-item .nav-link {
  color: #888888;
  padding: 10px 15px;
  margin: 10px 3px;
  position: relative;
  display: inline-flex;
  line-height: 40px;
}
.navbar .navbar-nav .nav-item .nav-link.btn {
  margin: 15px 3px;
  padding: 8px 16px;
}
.navbar .navbar-nav .nav-item .nav-link.btn-round {
  margin: 16px 3px;
}
.navbar .navbar-nav .nav-item .nav-link [class^=fa],
.navbar .navbar-nav .nav-item .nav-link [class^=fas],
.navbar .navbar-nav .nav-item .nav-link [class^=far],
.navbar .navbar-nav .nav-item .nav-link [class^=fal],
.navbar .navbar-nav .nav-item .nav-link [class^=fad],
.navbar .navbar-nav .nav-item .nav-link [class^=fab] {
  font-size: 2.125rem;
  position: relative;
  line-height: 40px;
  top: 1px;
}
.navbar .navbar-nav .nav-item .nav-link:hover {
  color: #23CCEF;
}
.navbar .navbar-nav .nav-item .nav-link .stats {
  margin-left: 10px;
}
.navbar .navbar-nav .nav-item .dropdown-menu {
  border-radius: 10px;
  margin-top: -5px;
}
.navbar .navbar-nav .nav-item .dropdown-menu .dropdown-item:first-child {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.navbar .navbar-nav .nav-item .dropdown-menu .dropdown-item:last-child {
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
.navbar .navbar-nav .nav-item .dropdown-menu .divider {
  height: 1px;
  margin: 5px 0;
  overflow: hidden;
  background-color: #e5e5e5;
}
.navbar .navbar-nav .notification {
  position: absolute;
  background-color: #FB404B;
  text-align: center;
  border-radius: 10px;
  min-width: 18px;
  padding: 0 5px;
  height: 18px;
  font-size: 12px;
  color: #FFFFFF;
  font-weight: bold;
  line-height: 18px;
  top: 10px;
  left: 7px;
}
.navbar .navbar-nav .dropdown-toggle:after {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 5px;
  margin-top: 18px;
  vertical-align: middle;
  border-top: 4px dashed;
  border-top: 4px solid\\9 ;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
}
.navbar .btn {
  margin: 15px 3px;
  font-size: 0.875rem;
}
.navbar .btn-simple {
  font-size: 1rem;
}
.navbar.fixed {
  width: calc(100% - calc(100% - 260px));
  right: 0;
  left: auto;
  border-radius: 0;
}

.navbar-transparent .navbar-brand, [class*=navbar-ct] .navbar-brand {
  color: #FFFFFF;
  margin-left: 10px;
  opacity: 0.9;
  filter: alpha(opacity=90);
}
.navbar-transparent .navbar-brand:focus, .navbar-transparent .navbar-brand:hover, [class*=navbar-ct] .navbar-brand:focus, [class*=navbar-ct] .navbar-brand:hover {
  background-color: transparent;
  opacity: 1;
  filter: alpha(opacity=100);
  color: #FFFFFF;
}
.navbar-transparent .navbar-nav .nav-item .nav-link:not(.btn), [class*=navbar-ct] .navbar-nav .nav-item .nav-link:not(.btn) {
  color: #FFFFFF;
  border-color: #FFFFFF;
  opacity: 0.8;
  filter: alpha(opacity=80);
}
.navbar-transparent .navbar-nav .active .nav-link:not(.btn),
.navbar-transparent .navbar-nav .active .nav-link:hover:not(.btn),
.navbar-transparent .navbar-nav .active .nav-link:focus:not(.btn),
.navbar-transparent .navbar-nav .nav-item .nav-link:not(.btn),
.navbar-transparent .navbar-nav .nav-item .nav-link:hover:not(.btn),
.navbar-transparent .navbar-nav .nav-item .nav-link:focus:not(.btn), [class*=navbar-ct] .navbar-nav .active .nav-link:not(.btn),
[class*=navbar-ct] .navbar-nav .active .nav-link:hover:not(.btn),
[class*=navbar-ct] .navbar-nav .active .nav-link:focus:not(.btn),
[class*=navbar-ct] .navbar-nav .nav-item .nav-link:not(.btn),
[class*=navbar-ct] .navbar-nav .nav-item .nav-link:hover:not(.btn),
[class*=navbar-ct] .navbar-nav .nav-item .nav-link:focus:not(.btn) {
  background-color: transparent;
  border-radius: 3px;
  color: #FFFFFF;
  opacity: 0.8;
  filter: alpha(opacity=80);
}
.navbar-transparent .navbar-nav .active .nav-link:not(.btn):focus, .navbar-transparent .navbar-nav .active .nav-link:not(.btn):hover,
.navbar-transparent .navbar-nav .active .nav-link:hover:not(.btn):focus,
.navbar-transparent .navbar-nav .active .nav-link:hover:not(.btn):hover,
.navbar-transparent .navbar-nav .active .nav-link:focus:not(.btn):focus,
.navbar-transparent .navbar-nav .active .nav-link:focus:not(.btn):hover,
.navbar-transparent .navbar-nav .nav-item .nav-link:not(.btn):focus,
.navbar-transparent .navbar-nav .nav-item .nav-link:not(.btn):hover,
.navbar-transparent .navbar-nav .nav-item .nav-link:hover:not(.btn):focus,
.navbar-transparent .navbar-nav .nav-item .nav-link:hover:not(.btn):hover,
.navbar-transparent .navbar-nav .nav-item .nav-link:focus:not(.btn):focus,
.navbar-transparent .navbar-nav .nav-item .nav-link:focus:not(.btn):hover, [class*=navbar-ct] .navbar-nav .active .nav-link:not(.btn):focus, [class*=navbar-ct] .navbar-nav .active .nav-link:not(.btn):hover,
[class*=navbar-ct] .navbar-nav .active .nav-link:hover:not(.btn):focus,
[class*=navbar-ct] .navbar-nav .active .nav-link:hover:not(.btn):hover,
[class*=navbar-ct] .navbar-nav .active .nav-link:focus:not(.btn):focus,
[class*=navbar-ct] .navbar-nav .active .nav-link:focus:not(.btn):hover,
[class*=navbar-ct] .navbar-nav .nav-item .nav-link:not(.btn):focus,
[class*=navbar-ct] .navbar-nav .nav-item .nav-link:not(.btn):hover,
[class*=navbar-ct] .navbar-nav .nav-item .nav-link:hover:not(.btn):focus,
[class*=navbar-ct] .navbar-nav .nav-item .nav-link:hover:not(.btn):hover,
[class*=navbar-ct] .navbar-nav .nav-item .nav-link:focus:not(.btn):focus,
[class*=navbar-ct] .navbar-nav .nav-item .nav-link:focus:not(.btn):hover {
  opacity: 1;
  filter: alpha(opacity=100);
}
.navbar-transparent .navbar-nav .nav .nav-item .nav-link.btn:hover, [class*=navbar-ct] .navbar-nav .nav .nav-item .nav-link.btn:hover {
  background-color: transparent;
}
.navbar-transparent .navbar-nav .show .nav-link,
.navbar-transparent .navbar-nav .show .nav-link:hover,
.navbar-transparent .navbar-nav .show .nav-link:focus, [class*=navbar-ct] .navbar-nav .show .nav-link,
[class*=navbar-ct] .navbar-nav .show .nav-link:hover,
[class*=navbar-ct] .navbar-nav .show .nav-link:focus {
  background-color: transparent;
  color: #FFFFFF;
  opacity: 1;
  filter: alpha(opacity=100);
}
.navbar-transparent .btn-default, [class*=navbar-ct] .btn-default {
  color: #FFFFFF;
  border-color: #FFFFFF;
}
.navbar-transparent .btn-default.btn-fill, [class*=navbar-ct] .btn-default.btn-fill {
  color: #9A9A9A;
  background-color: #FFFFFF;
  opacity: 0.9;
  filter: alpha(opacity=90);
}
.navbar-transparent .btn-default.btn-fill:hover,
.navbar-transparent .btn-default.btn-fill:focus,
.navbar-transparent .btn-default.btn-fill:active,
.navbar-transparent .btn-default.btn-fill.active,
.navbar-transparent .show .dropdown-toggle.btn-fill.btn-default, [class*=navbar-ct] .btn-default.btn-fill:hover,
[class*=navbar-ct] .btn-default.btn-fill:focus,
[class*=navbar-ct] .btn-default.btn-fill:active,
[class*=navbar-ct] .btn-default.btn-fill.active,
[class*=navbar-ct] .show .dropdown-toggle.btn-fill.btn-default {
  border-color: #FFFFFF;
  opacity: 1;
  filter: alpha(opacity=100);
}

.navbar-transparent .dropdown-menu .divider {
  background-color: rgba(255, 255, 255, 0.2);
}

.navbar-default {
  background-color: rgba(255, 255, 255, 0.96);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.navbar-default .navbar-nav .nav-item .nav-link:not(.btn) {
  color: #9A9A9A;
}
.navbar-default .navbar-nav .active .nav-link,
.navbar-default .navbar-nav .active .nav-link:not(.btn):hover,
.navbar-default .navbar-nav .active .nav-link:not(.btn):focus,
.navbar-default .navbar-nav .nav-item .nav-link:not(.btn):hover,
.navbar-default .navbar-nav .nav-item .nav-link:not(.btn):focus {
  background-color: transparent;
  border-radius: 3px;
  color: #23CCEF;
  opacity: 1;
  filter: alpha(opacity=100);
}
.navbar-default .navbar-nav .show .nav-link,
.navbar-default .navbar-nav .show .nav-link:hover,
.navbar-default .navbar-nav .show .nav-link:focus {
  background-color: transparent;
  color: #23CCEF;
}
.navbar-default .navbar-nav .navbar-toggle:hover, .navbar-default .navbar-nav .navbar-toggle:focus {
  background-color: transparent;
}
.navbar-default:not(.navbar-transparent) .btn-default:hover {
  color: #23CCEF;
  border-color: #23CCEF;
}
.navbar-default:not(.navbar-transparent) .btn-neutral, .navbar-default:not(.navbar-transparent) .btn-neutral:hover, .navbar-default:not(.navbar-transparent) .btn-neutral:active {
  color: #9A9A9A;
}

/*      Navbar with icons            */
.navbar-icons.navbar .navbar-brand {
  margin-top: 12px;
  margin-bottom: 12px;
}
.navbar-icons .navbar-nav .nav-item .nav-link {
  text-align: center;
  padding: 6px 15px;
  margin: 6px 3px;
}
.navbar-icons .navbar-nav [class^=pe] {
  font-size: 30px;
  position: relative;
}
.navbar-icons .navbar-nav p {
  margin: 3px 0 0;
}

.navbar-form {
  box-shadow: none;
}
.navbar-form .form-control {
  border-radius: 0;
  border: 0;
  padding: 0;
  background-color: transparent;
  height: 22px;
  font-size: 1rem;
  line-height: 1.5;
  color: #E3E3E3;
}
.navbar-transparent .navbar-form .form-control, [class*=navbar-ct] .navbar-form .form-control {
  color: #FFFFFF;
  border: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.6);
}

.navbar-ct-blue {
  background-color: #4091e2;
}

.navbar-ct-azure {
  background-color: #63d8f1;
}

.navbar-ct-green {
  background-color: #a1e82c;
}

.navbar-ct-orange {
  background-color: #ffbc67;
}

.navbar-ct-red {
  background-color: #fc727a;
}

.navbar-transparent {
  padding-top: 15px;
  background-color: transparent;
  border-bottom: 1px solid transparent;
  z-index: 999;
}
.navbar-transparent .navbar-toggler .burger-lines {
  background: #FFFFFF;
}

.navbar-toggle {
  margin-top: 19px;
  margin-bottom: 19px;
  border: 0;
}
.navbar-toggle .icon-bar {
  background-color: #FFFFFF;
}
.navbar-toggle .navbar-collapse,
.navbar-toggle .navbar-form {
  border-color: transparent;
}
.navbar-toggle.navbar-default .navbar-toggle:hover, .navbar-toggle.navbar-default .navbar-toggle:focus {
  background-color: transparent;
}

.main-panel .navbar-fixed {
  position: fixed;
  right: 0;
  width: calc(100% - 260px);
  z-index: 1030;
}
.main-panel .navbar-fixed + .content {
  padding-top: 90px;
}

.nav-mobile-menu.nav .navbar-search-form .nc-icon {
  font-size: 28px;
  width: 30px;
  text-align: center;
  vertical-align: middle;
  float: left;
  color: #FFFFFF;
}
.nav-mobile-menu.nav .navbar-search-form .form-control::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  color: #FFFFFF;
}
.nav-mobile-menu.nav .navbar-search-form .form-control::-moz-placeholder { /* Firefox 19+ */
  color: #FFFFFF;
}
.nav-mobile-menu.nav .navbar-search-form .form-control:-ms-input-placeholder { /* IE 10+ */
  color: #FFFFFF;
}
.nav-mobile-menu.nav .navbar-search-form .form-control:-moz-placeholder { /* Firefox 18- */
  color: #FFFFFF;
}

.nav .navbar-search-form .nc-icon {
  color: #888888;
}

.footer {
  background-color: #FFFFFF;
  width: 100%;
}
.footer .footer-menu {
  height: 41px;
}
.footer nav > ul {
  list-style: none;
  margin: 0;
  padding: 0;
  font-weight: normal;
}
.footer nav > ul a:not(.btn) {
  color: #9A9A9A;
  display: block;
  margin-bottom: 3px;
}
.footer nav > ul a:not(.btn):hover, .footer nav > ul a:not(.btn):focus {
  color: #797979;
}
.footer .social-area {
  padding: 15px 0;
}
.footer .social-area h5 {
  padding-bottom: 15px;
}
.footer .social-area > a:not(.btn) {
  color: #9A9A9A;
  display: inline-block;
  vertical-align: top;
  padding: 10px 5px;
  font-size: 1.25rem;
  font-weight: normal;
  line-height: 20px;
  text-align: center;
}
.footer .social-area > a:not(.btn):hover, .footer .social-area > a:not(.btn):focus {
  color: #797979;
}
.footer .copyright {
  color: #797979;
  padding: 10px 15px;
  margin: 10px 3px;
  line-height: 20px;
  font-size: 0.875rem;
}
.footer hr {
  border-color: #DDDDDD;
}
.footer .title {
  color: #797979;
}

.footer-default {
  background-color: #F5F5F5;
}

.footer:not(.footer-big) nav > ul {
  font-size: 0.875rem;
}
.footer:not(.footer-big) nav > ul li {
  margin-left: 20px;
  float: left;
}
.footer:not(.footer-big) nav > ul a {
  padding: 10px 0px;
  margin: 10px 10px 10px 0px;
}

.full-page + .footer li a,
.full-page + .footer .copyright a {
  color: #fff !important;
}

.bootstrap-tagsinput {
  overflow-y: auto;
  text-align: left;
}
.bootstrap-tagsinput .badge {
  cursor: pointer;
  overflow: hidden;
  position: relative;
  margin: 5px 3px 5px 0;
  padding: 4px 18px !important;
  padding: 2px 12px;
  border: 1px solid #888888;
  border-radius: 3px;
  color: #888888;
  font-weight: 500;
  font-size: 0.75rem;
  text-transform: uppercase;
  display: inline-block;
  vertical-align: middle;
  background-color: transparent;
  border: 1px solid #888888;
  font-size: 12px !important;
}
.bootstrap-tagsinput .badge.badge-blue, .bootstrap-tagsinput .badge.badge-blue .tagsinput-remove-link {
  border-color: #447DF7;
  color: #447DF7;
}
.bootstrap-tagsinput .badge.badge-azure, .bootstrap-tagsinput .badge.badge-azure .tagsinput-remove-link {
  border-color: #23CCEF;
  color: #23CCEF;
}
.bootstrap-tagsinput .badge.badge-green .tag, .bootstrap-tagsinput .badge.badge-green .tagsinput-remove-link {
  border-color: #275D38;
  color: #275D38;
}
.bootstrap-tagsinput .badge.badge-orange .tag, .bootstrap-tagsinput .badge.badge-orange .tagsinput-remove-link {
  border-color: #FFA534;
  color: #FFA534;
}
.bootstrap-tagsinput .badge.badgebadge-red .tag, .bootstrap-tagsinput .badge.badgebadge-red .tagsinput-remove-link {
  border-color: #FB404B;
  color: #FB404B;
}
.bootstrap-tagsinput .badge .badge-remove-link {
  transition: all 60ms ease-in;
}
.bootstrap-tagsinput .badge:hover {
  padding-left: 10px;
  padding-right: 18px;
  opacity: 1 !important;
  visibility: visible !important;
}
.bootstrap-tagsinput .badge:hover .badge-remove-link {
  opacity: 1 !important;
  color: black;
  padding-right: 6px;
}
.bootstrap-tagsinput .tagsinput-add {
  color: #333333;
  cursor: pointer;
  display: inline-block;
  font-size: 14px;
  padding: 5px 6px;
  vertical-align: top;
  opacity: 0.8;
  filter: alpha(opacity=80);
}
.bootstrap-tagsinput .tagsinput-add:hover, .bootstrap-tagsinput .tagsinput-add:focus {
  opacity: 1;
  filter: alpha(opacity=100);
}
.bootstrap-tagsinput .tagsinput-add:before {
  content: "\\f067";
  font-family: "FontAwesome";
}
.bootstrap-tagsinput .badge-remove-link {
  cursor: pointer;
  font-size: 12px;
  padding: 3px 0;
  position: absolute;
  right: -3px;
  opacity: 0;
  text-align: right;
  text-decoration: none;
  top: 0;
  width: 100%;
  z-index: 2;
}
.bootstrap-tagsinput .tag:hover .tagsinput-remove-link {
  opacity: 1;
  padding-right: 6px;
}
.bootstrap-tagsinput .badge-remove-link:before {
  content: "\\f00d";
  font-family: "FontAwesome";
  color: #23CCEF;
}
.bootstrap-tagsinput .tagsinput-add-container {
  display: inline-block;
  vertical-align: middle;
}
.bootstrap-tagsinput input {
  background: transparent;
  border: none;
  color: #333333;
  margin: 0;
  outline: medium none !important;
  padding: 0 0 0 5px;
  vertical-align: top;
  width: 40px;
  height: 30px;
}
.bootstrap-tagsinput.badge-fill .badge-blue {
  border-color: #447DF7;
  color: #FFFFFF;
  background-color: #447DF7;
}
.bootstrap-tagsinput.badge-fill .badge-azure {
  border-color: #23CCEF;
  color: #FFFFFF;
  background-color: #23CCEF;
}
.bootstrap-tagsinput.badge-fill.badge-green {
  border-color: #275D38;
  color: #FFFFFF;
  background-color: #275D38;
}
.bootstrap-tagsinput.badge-fill.badge-orange {
  border-color: #FFA534;
  color: #FFFFFF;
  background-color: #FFA534;
}
.bootstrap-tagsinput.badge-fill.badge-red {
  border-color: #FB404B;
  color: #FFFFFF;
  background-color: #FB404B;
}
.bootstrap-tagsinput.badge-fill .tagsinput-remove-link {
  color: #FFFFFF;
}

/*            Navigation menu                */
.nav-pills > li + li {
  margin-left: 0;
}
.nav-pills > li > a {
  border: 1px solid #23CCEF;
  border-radius: 0;
  color: #23CCEF;
  margin-left: -1px;
}
.nav-pills > li > a:hover, .nav-pills > li > a:focus {
  background-color: #F5F5F5;
}
.nav-pills > li.active > a,
.nav-pills > li.active > a:hover,
.nav-pills > li.active > a:focus {
  background-color: #23CCEF;
  color: #FFFFFF;
}
.nav-pills > li:first-child > a {
  border-radius: 4px 0 0 4px;
  margin: 0;
}
.nav-pills > li:last-child > a {
  border-radius: 0 4px 4px 0;
}

.pagination .page-item .page-link {
  border-radius: 50%;
  margin: 0 2px;
  color: #797979;
  padding: 6px 12px;
}
.pagination .page-item .page-link:hover {
  background-color: #eee;
  border-color: #ddd;
}
.pagination .page-item.active .page-link {
  background-color: #23CCEF;
  border: 0;
  color: #FFFFFF !important;
  padding: 7px 13px;
}
.pagination .page-item:first-child .page-link, .pagination .page-item:last-child .page-link {
  border-radius: 50%;
}

.pagination > li.disabled {
  opacity: 0.4;
}

.pagination.pagination-no-border > li > a,
.pagination.pagination-no-border > li > span {
  border: 0;
}

.pagination > li > a,
.pagination > li > span,
.pagination > li:first-child > a,
.pagination > li:first-child > span,
.pagination > li:last-child > a,
.pagination > li:last-child > span {
  border-radius: 50%;
  margin: 0 2px;
  color: #797979;
}

.pagination > li.active > a,
.pagination > li.active > span,
.pagination > li.active > a:hover,
.pagination > li.active > span:hover,
.pagination > li.active > a:focus,
.pagination > li.active > span:focus {
  background-color: #23CCEF;
  border: 0;
  color: #FFFFFF;
  padding: 7px 13px;
}

.nav-pills-blue > li.active > a,
.nav-pills-blue > li.active > a:hover,
.nav-pills-blue > li.active > a:focus {
  background-color: #447DF7;
}

.pagination-blue > li.active a,
.pagination-blue > li.active a:hover,
.pagination-blue > li.active a:focus,
.pagination-blue > li.active span,
.pagination-blue > li.active span:hover,
.pagination-blue > li.active span:focus {
  background-color: #447DF7 !important;
}

.nav-pills-azure > li.active > a,
.nav-pills-azure > li.active > a:hover,
.nav-pills-azure > li.active > a:focus {
  background-color: #23CCEF;
}

.pagination-azure li.active a,
.pagination-azure li.active a:hover,
.pagination-azure li.active a:focus,
.pagination-azure li.active span,
.pagination-azure li.active span:hover,
.pagination-azure li.active span:focus {
  background-color: #23CCEF !important;
}

.nav-pills-green > li.active > a,
.nav-pills-green > li.active > a:hover,
.nav-pills-green > li.active > a:focus {
  background-color: #275D38;
}

.pagination-green > li.active a,
.pagination-green > li.active a:hover,
.pagination-green > li.active a:focus,
.pagination-green > li.active span,
.pagination-green > li.active span:hover,
.pagination-green > li.active span:focus {
  background-color: #275D38 !important;
}

.nav-pills-orange > li.active > a,
.nav-pills-orange > li.active > a:hover,
.nav-pills-orange > li.active > a:focus {
  background-color: #FFA534;
}

.pagination-orange > li.active a,
.pagination-orange > li.active a:hover,
.pagination-orange > li.active a:focus,
.pagination-orange > li.active span,
.pagination-orange > li.active span:hover,
.pagination-orange > li.active span:focus {
  background-color: #FFA534 !important;
}

.nav-pills-red > li.active > a,
.nav-pills-red > li.active > a:hover,
.nav-pills-red > li.active > a:focus {
  background-color: #FB404B;
}

.pagination-red > li.active a,
.pagination-red > li.active a:hover,
.pagination-red > li.active a:focus,
.pagination-red > li.active span,
.pagination-red > li.active span:hover,
.pagination-red > li.active span:focus {
  background-color: #FB404B !important;
}

.bootstrap-table .pagination .page-number a {
  padding: 7px 12px;
}

.nav-pills-blue > li > a {
  border: 1px solid #447DF7;
  color: #447DF7;
}

.nav-pills-azure > li > a {
  border: 1px solid #23CCEF;
  color: #23CCEF;
}

.nav-pills-green > li > a {
  border: 1px solid #275D38;
  color: #275D38;
}

.nav-pills-orange > li > a {
  border: 1px solid #FFA534;
  color: #FFA534;
}

.nav-pills-red > li > a {
  border: 1px solid #FB404B;
  color: #FB404B;
}

.nav-text,
.nav-icons {
  padding: 10px 0 0;
}
.nav-text .nav-item .nav-link,
.nav-icons .nav-item .nav-link {
  display: block;
  padding: 0px 16px;
  color: #9A9A9A;
  text-align: center;
  opacity: 0.8;
  filter: alpha(opacity=80);
}
.nav-text .nav-item .nav-link:hover, .nav-text .nav-item .nav-link:focus,
.nav-icons .nav-item .nav-link:hover,
.nav-icons .nav-item .nav-link:focus {
  background-color: transparent;
  opacity: 1;
  filter: alpha(opacity=100);
}
.nav-text .nav-item:first-child .nav-link,
.nav-icons .nav-item:first-child .nav-link {
  padding-left: 0;
}
.nav-text .nav-item .nav-link.active,
.nav-text .nav-item.active .nav-link,
.nav-icons .nav-item .nav-link.active,
.nav-icons .nav-item.active .nav-link {
  color: #23CCEF;
}

.nav-icons > li {
  display: inline-block;
}
.nav-icons > li > a {
  padding: 0 10px;
  margin-bottom: 10px;
}
.nav-icons > li > a i {
  font-size: 1.375rem;
  margin-bottom: 10px;
  width: 1.375rem;
}

.nav-icons.nav-stacked > li {
  display: block;
}
.nav-icons.nav-stacked > li > a {
  margin-bottom: 20px;
}

.nav-blue > li.active a {
  color: #447DF7;
}

.nav-azure > li.active a {
  color: #23CCEF;
}

.nav-green > li.active a {
  color: #275D38;
}

.nav-orange > li.active a {
  color: #FFA534;
}

.nav-red > li.active a {
  color: #FB404B;
}

.nav-text {
  margin: 0 0 10px 0;
}
.nav-text > li > a {
  font-size: 0.875rem;
  text-transform: uppercase;
  padding: 3px 0;
  text-align: left;
  font-weight: 500;
}
.nav-text > li:first-child > a {
  padding-top: 0;
}
.nav-text h4 {
  margin-top: 0;
}

.nav-text:not(.nav-stacked) > li {
  display: inline-block;
}
.nav-text:not(.nav-stacked) > li > a {
  margin-right: 15px;
}

.tab-pane {
  padding: 15px 0;
}

.nav-container {
  display: block;
  width: 100%;
  text-align: center;
}

.content-full-width .nav-tabs li:first-child {
  padding-left: 15px;
}
.content-full-width .tab-pane {
  padding: 15px;
}

.accordions .card {
  border: 0;
  box-shadow: none;
  margin-bottom: 15px;
}
.accordions .card .card-header {
  padding: 0;
  border-bottom: 1px solid #DDDDDD !important;
}
.accordions .card .card-header .card-title {
  margin-top: 0;
  margin-bottom: 0;
  font-size: 18px;
  color: inherit;
}
.accordions .card .card-header .card-title a {
  color: #333;
  padding: 0px 0 5px;
  display: block;
  width: 100%;
  font-size: 16px;
}
.accordions .card .card-header .card-title a:hover {
  color: #797979;
}
.accordions .card .card-header .caret {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 2px;
  vertical-align: middle;
  border-top: 4px dashed;
  border-top: 4px solid\\9 ;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
  float: right;
  margin-top: 12px;
  margin-right: 15px;
  transition: all 150ms ease-in;
}
.accordions .card .card-header a[data-toggle=collapse][aria-expanded=true] .caret,
.accordions .card .card-header a[data-toggle=collapse-hover][aria-expanded=true] .caret {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
  transform: rotate(180deg);
}
.accordions .card .card-header + .card-collapse .card-body {
  box-shadow: inset 0 7px 10px -7px rgba(0, 0, 0, 0.14);
}
.accordions .card .card-collapse.collapse-hover {
  transition: all 300ms linear !important;
}

.card-body-full-width {
  padding: 15px 0 !important;
}
.card-body-full-width .accordions .card-header .card-title a {
  padding: 10px 15px;
}

.content-full-width .nav-tabs .nav-item:first-child {
  padding-left: 15px;
}

.nav-container .nav-icons .nc-icon {
  font-weight: 700;
}

.card-wizard .nav-tabs {
  margin-left: -15px;
  margin-right: -15px;
  margin-top: 10px;
  margin-bottom: 10px;
}
.card-wizard .nav-tabs .nav-item {
  width: 33.33%;
}
.card-wizard .nav-tabs .nav-item .nav-link {
  text-align: center;
  border: none;
  background-color: #9A9A9A;
  color: #FFFFFF;
  text-transform: uppercase;
  border-radius: 0;
  border-radius: initial;
}
.card-wizard .nav-tabs .nav-item .nav-link.active {
  background-color: #23CCEF;
}

.progress {
  background-color: #E5E5E5;
  border-radius: 3px;
  box-shadow: none;
  height: 4px;
  margin-bottom: 20px;
}

.progress-thin {
  height: 2px;
}

.progress-bar,
.progress-bar-primary {
  background-color: #447DF7;
}

.progress-bar-info {
  background-color: #23CCEF;
}

.progress-bar-success {
  background-color: #275D38;
}

.progress-bar-warning {
  background-color: #FFA534;
}

.progress-bar-danger {
  background-color: #FB404B;
}

/*!
 * jQuery UI Slider 1.10.4
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/slider/#theming
 */
.ui-slider {
  position: relative;
  text-align: left;
}

.ui-slider .ui-slider-handle {
  position: absolute;
  z-index: 2;
  width: 1.2em;
  height: 1.2em;
  cursor: default;
}

.ui-slider .ui-slider-range {
  position: absolute;
  z-index: 1;
  font-size: 0.7em;
  display: block;
  border: 0;
  background-position: 0 0;
}

/* For IE8 - See #6727 */
.ui-slider.ui-state-disabled .ui-slider-handle,
.ui-slider.ui-state-disabled .ui-slider-range {
  filter: inherit;
}

.ui-slider-horizontal {
  height: 4px;
}

.ui-slider-horizontal .ui-slider-handle {
  margin-left: -10px;
  top: -7px;
}

.ui-slider-horizontal .ui-slider-range {
  top: 0;
  height: 100%;
}

.ui-slider-horizontal .ui-slider-range-min {
  left: 0;
}

.ui-slider-horizontal .ui-slider-range-max {
  right: 0;
}

.ui-slider-vertical {
  width: 0.8em;
  height: 100px;
}

.ui-slider-vertical .ui-slider-handle {
  left: -0.3em;
  margin-left: 0;
  margin-bottom: -0.6em;
}

.ui-slider-vertical .ui-slider-range {
  left: 0;
  width: 100%;
}

.ui-slider-vertical .ui-slider-range-min {
  bottom: 0;
}

.ui-slider-vertical .ui-slider-range-max {
  top: 0;
}

/* Component containers
----------------------------------*/
.ui-widget {
  font-size: 1.1em;
}

.ui-widget .ui-widget {
  font-size: 1em;
}

.ui-widget input,
.ui-widget select,
.ui-widget textarea,
.ui-widget button {
  font-size: 1em;
}

.ui-widget-content {
  background-color: #E5E5E5;
}

.ui-widget-content a {
  color: #222222;
}

.ui-widget-header {
  background: #999999;
  color: #222222;
  font-weight: bold;
}

.ui-widget-header a {
  color: #222222;
}

.slider-primary .ui-widget-header {
  background-color: #447DF7;
}

.slider-info .ui-widget-header {
  background-color: #23CCEF;
}

.slider-success .ui-widget-header {
  background-color: #275D38;
}

.slider-warning .ui-widget-header {
  background-color: #FFA534;
}

.slider-danger .ui-widget-header {
  background-color: #FB404B;
}

/* Interaction states
----------------------------------*/
.ui-state-default,
.ui-widget-content .ui-state-default,
.ui-widget-header .ui-state-default {
  background: rgb(255, 255, 255); /* Old browsers */ /* FF3.6+ */ /* Chrome,Safari4+ */ /* Chrome10+,Safari5.1+ */ /* Opera 11.10+ */ /* IE10+ */
  background: linear-gradient(to bottom, rgb(255, 255, 255) 0%, rgb(241, 241, 242) 100%); /* W3C */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="#ffffff", endColorstr="#f1f1f2",GradientType=0 ); /* IE6-9 */
  border-radius: 50%;
  box-shadow: 0 1px 1px #FFFFFF inset, 0 1px 2px rgba(0, 0, 0, 0.4);
  height: 15px;
  width: 15px;
  cursor: pointer;
}

.ui-state-default a,
.ui-state-default a:link,
.ui-state-default a:visited {
  color: #555555;
  text-decoration: none;
}

.ui-state-hover a,
.ui-state-hover a:hover,
.ui-state-hover a:link,
.ui-state-hover a:visited,
.ui-state-focus a,
.ui-state-focus a:hover,
.ui-state-focus a:link,
.ui-state-focus a:visited {
  color: #212121;
  text-decoration: none;
}

.ui-state-active a,
.ui-state-active a:link,
.ui-state-active a:visited {
  color: #212121;
  text-decoration: none;
}

/* Interaction Cues
----------------------------------*/
.ui-state-highlight,
.ui-widget-content .ui-state-highlight,
.ui-widget-header .ui-state-highlight {
  border: 1px solid #fcefa1;
  background: #fbf9ee;
  color: #363636;
}

.ui-state-highlight a,
.ui-widget-content .ui-state-highlight a,
.ui-widget-header .ui-state-highlight a {
  color: #363636;
}

.ui-state-error,
.ui-widget-content .ui-state-error,
.ui-widget-header .ui-state-error {
  border: 1px solid #FB404B;
  background-color: #FB404B;
  color: #FB404B;
}

.ui-state-error a,
.ui-widget-content .ui-state-error a,
.ui-widget-header .ui-state-error a {
  color: #FB404B;
}

.ui-state-error-text,
.ui-widget-content .ui-state-error-text,
.ui-widget-header .ui-state-error-text {
  color: #FB404B;
}

.ui-priority-primary,
.ui-widget-content .ui-priority-primary,
.ui-widget-header .ui-priority-primary {
  font-weight: bold;
}

.ui-priority-secondary,
.ui-widget-content .ui-priority-secondary,
.ui-widget-header .ui-priority-secondary {
  opacity: 0.7;
  filter: Alpha(Opacity=70);
  font-weight: normal;
}

.ui-state-disabled,
.ui-widget-content .ui-state-disabled,
.ui-widget-header .ui-state-disabled {
  opacity: 0.35;
  filter: Alpha(Opacity=35);
  background-image: none;
}

.ui-state-disabled .ui-icon {
  filter: Alpha(Opacity=35); /* For IE8 - See #6059 */
}

.dropdown-menu {
  visibility: hidden;
  margin: 0;
  padding: 0;
  border-radius: 10px;
  display: block;
  z-index: 9000;
  position: absolute;
  opacity: 0;
  filter: alpha(opacity=0);
  box-shadow: 1px 2px 3px rgba(0, 0, 0, 0.125);
}
.show .dropdown-menu {
  opacity: 1;
  filter: alpha(opacity=100);
  visibility: visible;
}
.select .dropdown-menu {
  border-radius: 0 0 10px 10px;
  box-shadow: none;
  transform-origin: 50% -40px;
  transform: scale(1);
  transition: all 150ms linear;
  margin-top: -20px;
}
.select.show .dropdown-menu {
  margin-top: -1px;
}
.dropdown-menu .dropdown-item {
  padding: 8px 16px;
  color: #333333;
}
.dropdown-menu .dropdown-item img {
  margin-top: -3px;
}
.dropdown-menu .dropdown-item:focus {
  outline: 0 !important;
}
.btn-group.select .dropdown-menu {
  min-width: 100%;
}
.dropdown-menu > li:first-child > a {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.dropdown-menu > li:last-child > a {
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
.select .dropdown-menu > li:first-child > a {
  border-radius: 0;
  border-bottom: 0 none;
}
.dropdown-menu .dropdown-item:hover,
.dropdown-menu .dropdown-item:focus {
  background-color: #F5F5F5;
  color: #333333;
  opacity: 1;
  text-decoration: none;
}
.dropdown-menu.dropdown-blue > li > a:hover, .dropdown-menu.dropdown-blue > li > a:focus {
  background-color: rgba(68, 125, 247, 0.2);
}
.dropdown-menu.dropdown-azure > li > a:hover, .dropdown-menu.dropdown-azure > li > a:focus {
  background-color: rgba(35, 204, 239, 0.2);
}
.dropdown-menu.ct-green > li > a:hover, .dropdown-menu.ct-green > li > a:focus {
  background-color: rgba(39, 93, 56, 0.2);
}
.dropdown-menu.dropdown-orange > li > a:hover, .dropdown-menu.dropdown-orange > li > a:focus {
  background-color: rgba(255, 165, 52, 0.2);
}
.dropdown-menu.dropdown-red > li > a:hover, .dropdown-menu.dropdown-red > li > a:focus {
  background-color: rgba(251, 64, 75, 0.2);
}
.dropdown-menu .dropdown-item i[class*=nc-icon] {
  font-size: 18px;
  text-align: center;
  line-height: 25px;
  float: left;
  padding-right: 10px;
}
.dropdown-menu.dropdown-menu-right:before, .dropdown-menu.dropdown-menu-right:after {
  right: 12px !important;
  left: auto !important;
}

.dropdown-with-icons > li > a {
  padding-left: 0px;
  line-height: 28px;
}
.dropdown-with-icons i {
  text-align: center;
  line-height: 28px;
  float: left;
}
.dropdown-with-icons i[class^=pe-] {
  font-size: 24px;
  width: 46px;
}
.dropdown-with-icons i[class^=fa], .dropdown-with-icons i[class^=fas], .dropdown-with-icons i[class^=far], .dropdown-with-icons i[class^=fal], .dropdown-with-icons i[class^=fad], .dropdown-with-icons i[class^=fab] {
  font-size: 14px;
  width: 38px;
}

.btn-group.select {
  overflow: hidden;
}

.btn-group.select.show {
  overflow: visible;
}

.card {
  border-radius: 4px;
  background-color: #FFFFFF;
}
.card .card-image {
  width: 100%;
  overflow: hidden;
  height: 260px;
  border-radius: 4px 4px 0 0;
  position: relative;
  transform-style: preserve-3d;
}
.card .card-image img {
  width: 100%;
}
.card .filter {
  position: absolute;
  z-index: 2;
  background-color: rgba(0, 0, 0, 0.68);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  opacity: 0;
  filter: alpha(opacity=0);
}
.card .filter .btn {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}
.card:hover .filter {
  opacity: 1;
  filter: alpha(opacity=100);
}
.card .btn-hover {
  opacity: 0;
  filter: alpha(opacity=0);
}
.card:hover .btn-hover {
  opacity: 1;
  filter: alpha(opacity=100);
}
.card .card-body {
  padding: 15px 15px 10px 15px;
}
.card .card-header {
  padding: 15px 15px 0;
  background-color: #FFFFFF;
  border-bottom: none !important;
}
.card .card-category,
.card label {
  font-size: 0.875rem;
  font-weight: 400;
  color: #9A9A9A;
  margin-bottom: 0px;
}
.card .card-category i,
.card label i {
  font-size: 1rem;
}
.card label {
  font-size: 0.75rem;
  margin-bottom: 5px;
  text-transform: uppercase;
}
.card .card-title {
  margin: 0;
  color: #333333;
  font-weight: 300;
}
.card .avatar {
  height: 100%;
  overflow: hidden;
  border-radius: 50%;
  margin-right: 5px;
}
.card .description {
  font-size: 0.875rem;
  color: #333;
}
.card .card-footer {
  padding: 15px 15px 10px 15px;
  background-color: transparent;
  line-height: 30px;
  border-top: none !important;
  font-size: 14px;
}
.card .card-footer .legend {
  padding: 5px 0;
}
.card .card-footer hr {
  margin-top: 5px;
  margin-bottom: 5px;
}
.card .stats {
  color: #a9a9a9;
}
.card .author {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  border-radius: 50%;
  border: 4px solid rgba(255, 255, 255, 0.3);
  overflow: hidden;
  margin: 0 auto;
  transition: all 300ms linear;
}
.card .author i {
  font-size: 0.875rem;
}
.card h6 {
  font-size: 0.75rem;
  margin: 0;
}
.card.card-separator:after {
  height: 100%;
  right: -15px;
  top: 0;
  width: 1px;
  background-color: #DDDDDD;
  card-body: "";
  position: absolute;
}
.card .ct-chart {
  margin: 30px 0 30px;
}
.card .ct-label {
  font-size: 1rem !important;
}
.card .alert {
  border-radius: 4px;
  position: relative;
}
.card .alert.alert-with-icon {
  padding-left: 65px;
}
.card.card-lock .card-body .card-title {
  margin-bottom: 20px;
  color: #FFFFFF;
}
.card.card-lock .card-header .author {
  width: 100px;
  height: 100px;
}

.card-stats .card-body {
  padding: 15px 15px 0px;
}
.card-stats .card-body .numbers {
  text-align: right;
}
.card-stats .card-body .numbers p {
  margin-bottom: 0;
}
.card-stats .card-footer {
  padding: 0px 15px 10px 15px;
}
.card-stats .icon-big {
  font-size: 3em;
  min-height: 64px;
}
.card-stats .icon-big i {
  line-height: 59px;
}

.card-user .card-image {
  height: 110px;
}
.card-user .card-image-plain {
  height: 0;
  margin-top: 110px;
}
.card-user .author {
  text-align: center;
  text-transform: none;
  margin-top: -70px;
}
.card-user .avatar {
  width: 124px;
  height: 124px;
  border: 5px solid #EEEEEE;
  position: relative;
  margin-bottom: 15px;
}
.card-user .avatar.border-gray {
  border-color: #EEEEEE;
}
.card-user .title {
  line-height: 24px;
}
.card-user .card-body {
  min-height: 240px;
}
.card-user .card-header.no-padding {
  padding: 0;
}
.card-user .card-footer .button-container .btn {
  font-size: 16px;
}

.card-user .card-footer,
.card-price .card-footer {
  padding: 5px 15px 10px;
}
.card-user hr,
.card-price hr {
  margin: 5px 15px;
}

.card-plain {
  background-color: transparent;
  box-shadow: none;
  border-radius: 0;
}
.card-plain .card-image {
  border-radius: 4px;
}

.card.card-plain {
  border: none !important;
}
.card.card-plain .card-header {
  background-color: transparent !important;
}

.card.card-login {
  box-shadow: 0 25px 30px -13px rgba(40, 40, 40, 0.4);
  border-radius: 10px;
  padding-top: 10px;
  padding-bottom: 30px;
  transform: translate3d(0, 0px, 0);
  transition: all 300ms linear;
}
.card.card-login .form-check {
  margin-left: -12px;
}
.card.card-login.card-hidden {
  opacity: 0;
  transform: translate3d(0, -60px, 0);
}
.card.card-register .header-text hr {
  border-top: 1px solid rgba(255, 255, 255, 0.3);
}

.ct-label {
  fill: rgba(0, 0, 0, 0.4);
  color: rgba(0, 0, 0, 0.4);
  font-size: 1.3rem;
  line-height: 1;
}

.ct-chart-line .ct-label,
.ct-chart-bar .ct-label {
  display: block;
  display: flex;
}

.ct-label.ct-horizontal.ct-start {
  align-items: flex-end;
  justify-content: flex-start;
  text-align: left;
  text-anchor: start;
}

.ct-label.ct-horizontal.ct-end {
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
  text-anchor: start;
}

.ct-label.ct-vertical.ct-start {
  align-items: flex-end;
  justify-content: flex-end;
  text-align: right;
  text-anchor: end;
}

.ct-label.ct-vertical.ct-end {
  align-items: flex-end;
  justify-content: flex-start;
  text-align: left;
  text-anchor: start;
}

.ct-chart-bar .ct-label.ct-horizontal.ct-start {
  align-items: flex-end;
  justify-content: center;
  text-align: center;
  text-anchor: start;
}

.ct-chart-bar .ct-label.ct-horizontal.ct-end {
  align-items: flex-start;
  justify-content: center;
  text-align: center;
  text-anchor: start;
}

.ct-chart-bar.ct-horizontal-bars .ct-label.ct-horizontal.ct-start {
  align-items: flex-end;
  justify-content: flex-start;
  text-align: left;
  text-anchor: start;
}

.ct-chart-bar.ct-horizontal-bars .ct-label.ct-horizontal.ct-end {
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
  text-anchor: start;
}

.ct-chart-bar.ct-horizontal-bars .ct-label.ct-vertical.ct-start {
  align-items: center;
  justify-content: flex-end;
  text-align: right;
  text-anchor: end;
}

.ct-chart-bar.ct-horizontal-bars .ct-label.ct-vertical.ct-end {
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  text-anchor: end;
}

.ct-grid {
  stroke: rgba(0, 0, 0, 0.2);
  stroke-width: 1px;
  stroke-dasharray: 2px;
}

.ct-point {
  stroke-width: 8px;
  stroke-linecap: round;
}

.ct-line {
  fill: none;
  stroke-width: 3px;
}

.ct-area {
  stroke: none;
  fill-opacity: 0.8;
}

.ct-bar {
  fill: none;
  stroke-width: 10px;
}

.ct-slice-donut {
  fill: none;
  stroke-width: 60px;
}

.ct-series-a .ct-point, .ct-series-a .ct-line, .ct-series-a .ct-bar, .ct-series-a .ct-slice-donut {
  stroke: #1DC7EA;
}
.ct-series-a .ct-slice-pie, .ct-series-a .ct-area {
  fill: #1DC7EA;
}

.ct-series-b .ct-point, .ct-series-b .ct-line, .ct-series-b .ct-bar, .ct-series-b .ct-slice-donut {
  stroke: #FB404B;
}
.ct-series-b .ct-slice-pie, .ct-series-b .ct-area {
  fill: #FB404B;
}

.ct-series-c .ct-point, .ct-series-c .ct-line, .ct-series-c .ct-bar, .ct-series-c .ct-slice-donut {
  stroke: #FFA534;
}
.ct-series-c .ct-slice-pie, .ct-series-c .ct-area {
  fill: #FFA534;
}

.ct-series-d .ct-point, .ct-series-d .ct-line, .ct-series-d .ct-bar, .ct-series-d .ct-slice-donut {
  stroke: #9368E9;
}
.ct-series-d .ct-slice-pie, .ct-series-d .ct-area {
  fill: #9368E9;
}

.ct-series-e .ct-point, .ct-series-e .ct-line, .ct-series-e .ct-bar, .ct-series-e .ct-slice-donut {
  stroke: #87CB16;
}
.ct-series-e .ct-slice-pie, .ct-series-e .ct-area {
  fill: #87CB16;
}

.ct-series-f .ct-point, .ct-series-f .ct-line, .ct-series-f .ct-bar, .ct-series-f .ct-slice-donut {
  stroke: #1F77D0;
}
.ct-series-f .ct-slice-pie, .ct-series-f .ct-area {
  fill: #1F77D0;
}

.ct-series-g .ct-point, .ct-series-g .ct-line, .ct-series-g .ct-bar, .ct-series-g .ct-slice-donut {
  stroke: #5e5e5e;
}
.ct-series-g .ct-slice-pie, .ct-series-g .ct-area {
  fill: #5e5e5e;
}

.ct-series-h .ct-point, .ct-series-h .ct-line, .ct-series-h .ct-bar, .ct-series-h .ct-slice-donut {
  stroke: #dd4b39;
}
.ct-series-h .ct-slice-pie, .ct-series-h .ct-area {
  fill: #dd4b39;
}

.ct-series-i .ct-point, .ct-series-i .ct-line, .ct-series-i .ct-bar, .ct-series-i .ct-slice-donut {
  stroke: #35465c;
}
.ct-series-i .ct-slice-pie, .ct-series-i .ct-area {
  fill: #35465c;
}

.ct-series-j .ct-point, .ct-series-j .ct-line, .ct-series-j .ct-bar, .ct-series-j .ct-slice-donut {
  stroke: #e52d27;
}
.ct-series-j .ct-slice-pie, .ct-series-j .ct-area {
  fill: #e52d27;
}

.ct-series-k .ct-point, .ct-series-k .ct-line, .ct-series-k .ct-bar, .ct-series-k .ct-slice-donut {
  stroke: #55acee;
}
.ct-series-k .ct-slice-pie, .ct-series-k .ct-area {
  fill: #55acee;
}

.ct-series-l .ct-point, .ct-series-l .ct-line, .ct-series-l .ct-bar, .ct-series-l .ct-slice-donut {
  stroke: #cc2127;
}
.ct-series-l .ct-slice-pie, .ct-series-l .ct-area {
  fill: #cc2127;
}

.ct-series-m .ct-point, .ct-series-m .ct-line, .ct-series-m .ct-bar, .ct-series-m .ct-slice-donut {
  stroke: #1769ff;
}
.ct-series-m .ct-slice-pie, .ct-series-m .ct-area {
  fill: #1769ff;
}

.ct-series-n .ct-point, .ct-series-n .ct-line, .ct-series-n .ct-bar, .ct-series-n .ct-slice-donut {
  stroke: #6188e2;
}
.ct-series-n .ct-slice-pie, .ct-series-n .ct-area {
  fill: #6188e2;
}

.ct-series-o .ct-point, .ct-series-o .ct-line, .ct-series-o .ct-bar, .ct-series-o .ct-slice-donut {
  stroke: #a748ca;
}
.ct-series-o .ct-slice-pie, .ct-series-o .ct-area {
  fill: #a748ca;
}

.ct-square {
  display: block;
  position: relative;
  width: 100%;
}
.ct-square:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 100%;
}
.ct-square:after {
  content: "";
  display: table;
  clear: both;
}
.ct-square > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-minor-second {
  display: block;
  position: relative;
  width: 100%;
}
.ct-minor-second:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 93.75%;
}
.ct-minor-second:after {
  content: "";
  display: table;
  clear: both;
}
.ct-minor-second > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-second {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-second:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 88.8888888889%;
}
.ct-major-second:after {
  content: "";
  display: table;
  clear: both;
}
.ct-major-second > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-minor-third {
  display: block;
  position: relative;
  width: 100%;
}
.ct-minor-third:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 83.3333333333%;
}
.ct-minor-third:after {
  content: "";
  display: table;
  clear: both;
}
.ct-minor-third > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-third {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-third:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 80%;
}
.ct-major-third:after {
  content: "";
  display: table;
  clear: both;
}
.ct-major-third > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-perfect-fourth {
  display: block;
  position: relative;
  width: 100%;
}
.ct-perfect-fourth:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 75%;
}
.ct-perfect-fourth:after {
  content: "";
  display: table;
  clear: both;
}
.ct-perfect-fourth > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-perfect-fifth {
  display: block;
  position: relative;
  width: 100%;
}
.ct-perfect-fifth:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 66.6666666667%;
}
.ct-perfect-fifth:after {
  content: "";
  display: table;
  clear: both;
}
.ct-perfect-fifth > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-minor-sixth {
  display: block;
  position: relative;
  width: 100%;
}
.ct-minor-sixth:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 62.5%;
}
.ct-minor-sixth:after {
  content: "";
  display: table;
  clear: both;
}
.ct-minor-sixth > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-golden-section {
  display: block;
  position: relative;
  width: 100%;
}
.ct-golden-section:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 61.804697157%;
}
.ct-golden-section:after {
  content: "";
  display: table;
  clear: both;
}
.ct-golden-section > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-sixth {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-sixth:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 60%;
}
.ct-major-sixth:after {
  content: "";
  display: table;
  clear: both;
}
.ct-major-sixth > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-minor-seventh {
  display: block;
  position: relative;
  width: 100%;
}
.ct-minor-seventh:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 56.25%;
}
.ct-minor-seventh:after {
  content: "";
  display: table;
  clear: both;
}
.ct-minor-seventh > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-seventh {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-seventh:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 53.3333333333%;
}
.ct-major-seventh:after {
  content: "";
  display: table;
  clear: both;
}
.ct-major-seventh > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-octave {
  display: block;
  position: relative;
  width: 100%;
}
.ct-octave:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 50%;
}
.ct-octave:after {
  content: "";
  display: table;
  clear: both;
}
.ct-octave > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-tenth {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-tenth:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 40%;
}
.ct-major-tenth:after {
  content: "";
  display: table;
  clear: both;
}
.ct-major-tenth > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-eleventh {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-eleventh:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 37.5%;
}
.ct-major-eleventh:after {
  content: "";
  display: table;
  clear: both;
}
.ct-major-eleventh > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-twelfth {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-twelfth:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 33.3333333333%;
}
.ct-major-twelfth:after {
  content: "";
  display: table;
  clear: both;
}
.ct-major-twelfth > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-double-octave {
  display: block;
  position: relative;
  width: 100%;
}
.ct-double-octave:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 25%;
}
.ct-double-octave:after {
  content: "";
  display: table;
  clear: both;
}
.ct-double-octave > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

@media (min-width: 992px) {
  .navbar-fixed {
    width: calc(100% + 260px);
  }
  .navbar-form {
    padding-left: 15px;
    padding-right: 5px;
  }
  .navbar-form .input-group .form-control {
    margin-left: 10px;
  }
  .nav.nav-mobile-menu {
    display: none;
  }
  .navbar .navbar-nav .nc-icon {
    font-weight: 700;
    margin-top: 10px;
  }
  .navbar .navbar-nav .input-group .nc-icon {
    margin-top: 0;
  }
  .navbar .navbar-nav .dropdown-menu .dropdown-item .nc-icon {
    margin-top: 0;
  }
  .close-layer {
    display: none;
  }
  .navbar-nav .nav-item .dropdown-menu, .dropdown .dropdown-menu {
    transform: scale(0);
    transition: all 370ms cubic-bezier(0.34, 1.61, 0.7, 1);
  }
  .navbar-nav .nav-item.show .dropdown-menu, .dropdown.show .dropdown-menu {
    transform: scale(1);
    transform-origin: 29px -50px;
  }
  .sidebar-mini .sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal, .sidebar-mini .sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal, .sidebar-mini .sidebar .sidebar-wrapper .user .info > a > span,
.sidebar-mini .sidebar .sidebar-wrapper > .nav li > a span,
.sidebar-mini .sidebar .sidebar-wrapper > .nav li > a .caret {
    transform: translate3d(-25px, 0, 0);
    opacity: 0;
  }
  .sidebar-mini .sidebar .logo a.logo-mini {
    opacity: 1;
  }
  .sidebar-mini .sidebar .logo a.logo-normal {
    opacity: 0;
  }
  .footer {
    height: 60px;
  }
  .footer .footer-menu {
    float: left;
  }
  .footer .copyright {
    float: right;
  }
  .navbar-nav .nav-item .dropdown-menu:before {
    border-bottom: 11px solid rgba(0, 0, 0, 0.2);
    border-left: 11px solid rgba(0, 0, 0, 0);
    border-right: 11px solid rgba(0, 0, 0, 0);
    content: "";
    display: inline-block;
    position: absolute;
    left: 12px;
    top: -11px;
  }
  .navbar-nav .nav-item .dropdown-menu:after {
    border-bottom: 11px solid #FFFFFF;
    border-left: 11px solid rgba(0, 0, 0, 0);
    border-right: 11px solid rgba(0, 0, 0, 0);
    content: "";
    display: inline-block;
    position: absolute;
    left: 12px;
    top: -10px;
  }
  .navbar-nav.navbar-right .nav-item .dropdown-menu:before {
    left: auto;
    right: 12px;
  }
  .navbar-nav.navbar-right .nav-item .dropdown-menu:after {
    left: auto;
    right: 12px;
  }
  .footer:not(.footer-big) nav > ul li:first-child {
    margin-left: 0;
  }
  .card form [class*=col-] {
    padding: 6px;
  }
  .card form [class*=col-]:first-child {
    padding-left: 15px;
  }
  .card form [class*=col-]:last-child {
    padding-right: 15px;
  }
}
/*          Changes for small display      */
@media (max-width: 991px) {
  .sidebar {
    right: 0 !important;
    left: auto;
    transform: translate3d(260px, 0, 0);
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .nav-open .main-panel {
    position: absolute;
    left: 0;
    transform: translate3d(-260px, 0, 0);
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .nav-open .sidebar {
    transform: translate3d(0px, 0, 0);
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .main-panel {
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .menu-on-left .sidebar {
    left: 0 !important;
    right: auto;
    transform: translate3d(-260px, 0, 0);
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .menu-on-left .main-panel {
    transform: translate3d(0px, 0, 0);
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .nav-open .menu-on-left .main-panel {
    position: absolute;
    left: 0;
    transform: translate3d(260px, 0, 0);
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .nav-open .menu-on-left .sidebar {
    transform: translate3d(0px, 0, 0);
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .nav-item.active-pro {
    position: relative !important;
  }
  .nav-mobile-menu {
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    margin-bottom: 15px;
    padding-bottom: 15px;
    padding-top: 5px;
  }
  .nav-mobile-menu .dropdown .dropdown-menu {
    position: static !important;
    float: none;
    width: auto;
    color: #FFFFFF;
    margin-top: 0;
    background-color: transparent;
    border: 0;
    box-shadow: none;
    transform: translate3d(0px, 0px, 0px) !important;
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .nav-mobile-menu .dropdown .dropdown-menu .dropdown-item {
    margin: 5px 15px 0px 20px;
    border-radius: 4px;
    color: #FFFFFF;
    opacity: 0.86;
    padding: 8px 50px;
  }
  .nav-mobile-menu .dropdown .dropdown-menu .dropdown-item:hover {
    background-color: rgba(255, 255, 255, 0.23);
  }
  .nav-mobile-menu .dropdown .dropdown-menu .dropdown-item .nc-icon {
    margin-left: -40px;
  }
  .nav-mobile-menu .nav-item .nav-link span {
    display: inline-block !important;
  }
  .nav-mobile-menu .nav-item .nav-link .no-icon {
    padding-left: 50px;
  }
  .main-panel {
    width: 100%;
  }
  .navbar-brand {
    padding: 15px 0px;
  }
  .navbar-transparent {
    padding-top: 15px;
  }
  body {
    position: relative;
  }
  .wrapper {
    left: 0;
    background-color: white;
  }
  .navbar .container {
    left: 15px;
    width: 100%;
    position: relative;
    top: -10px;
  }
  .navbar-nav .nav-item {
    float: none;
    position: relative;
    display: block;
  }
  body > .navbar-collapse {
    position: fixed;
    display: block;
    top: 0;
    height: 100%;
    right: 0;
    left: auto;
    z-index: 1032;
    visibility: visible;
    background-color: #999;
    overflow-y: visible;
    border-top: none;
    text-align: left;
    padding: 0;
    transform: translate3d(260px, 0, 0);
    transition: all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  body > .navbar-collapse > ul {
    position: relative;
    z-index: 4;
    overflow-y: scroll;
    height: calc(100vh - 61px);
    width: 100%;
  }
  body > .navbar-collapse::before {
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    position: absolute;
    background-color: #282828;
    display: block;
    content: "";
    z-index: 1;
  }
  body > .navbar-collapse .logo {
    position: relative;
    z-index: 4;
  }
  body > .navbar-collapse .nav li > a {
    padding: 10px 15px;
  }
  .nav-show .navbar-collapse {
    transform: translate3d(0px, 0, 0);
  }
  .nav-show .navbar .container {
    left: -250px;
  }
  .nav-show .wrapper {
    left: 0;
    transform: translate3d(-260px, 0, 0);
  }
  .navbar-toggle .icon-bar {
    display: block;
    position: relative;
    background: #fff;
    width: 24px;
    height: 2px;
    border-radius: 1px;
    margin: 0 auto;
  }
  .navbar-header .navbar-toggle {
    margin: 10px 15px 10px 0;
    width: 40px;
    height: 40px;
  }
  .bar1,
.bar2,
.bar3 {
    outline: 1px solid transparent;
  }
  .bar1 {
    top: 0px;
    animation: topbar-back 500ms 0s;
    animation-fill-mode: forwards;
  }
  .bar2 {
    opacity: 1;
  }
  .bar3 {
    bottom: 0px;
    animation: bottombar-back 500ms 0s;
    animation-fill-mode: forwards;
  }
  .toggled .bar1 {
    top: 6px;
    animation: topbar-x 500ms 0s;
    animation-fill-mode: forwards;
  }
  .toggled .bar2 {
    opacity: 0;
  }
  .toggled .bar3 {
    bottom: 6px;
    animation: bottombar-x 500ms 0s;
    animation-fill-mode: forwards;
  }
  @keyframes topbar-x {
    0% {
      top: 0px;
      transform: rotate(0deg);
    }
    45% {
      top: 6px;
      transform: rotate(145deg);
    }
    75% {
      transform: rotate(130deg);
    }
    100% {
      transform: rotate(135deg);
    }
  }
  @keyframes topbar-back {
    0% {
      top: 6px;
      transform: rotate(135deg);
    }
    45% {
      transform: rotate(-10deg);
    }
    75% {
      transform: rotate(5deg);
    }
    100% {
      top: 0px;
      transform: rotate(0);
    }
  }
  @keyframes bottombar-x {
    0% {
      bottom: 0px;
      transform: rotate(0deg);
    }
    45% {
      bottom: 6px;
      transform: rotate(-145deg);
    }
    75% {
      transform: rotate(-130deg);
    }
    100% {
      transform: rotate(-135deg);
    }
  }
  @keyframes bottombar-back {
    0% {
      bottom: 6px;
      transform: rotate(-135deg);
    }
    45% {
      transform: rotate(10deg);
    }
    75% {
      transform: rotate(-5deg);
    }
    100% {
      bottom: 0px;
      transform: rotate(0);
    }
  }
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  .dropdown-menu .divider {
    background-color: rgba(229, 229, 229, 0.15);
  }
  .navbar-nav {
    margin: 1px 0;
  }
  .navbar-nav .show .dropdown-menu .nav-item .nav-link {
    padding: 10px 15px 10px 60px;
  }
  [class*=navbar-] .navbar-nav > li > a,
[class*=navbar-] .navbar-nav > li > a:hover,
[class*=navbar-] .navbar-nav > li > a:focus,
[class*=navbar-] .navbar-nav .active > a,
[class*=navbar-] .navbar-nav .active > a:hover,
[class*=navbar-] .navbar-nav .active > a:focus,
[class*=navbar-] .navbar-nav .show .dropdown-menu > li > a,
[class*=navbar-] .navbar-nav .show .dropdown-menu > li > a:hover,
[class*=navbar-] .navbar-nav .show .dropdown-menu > li > a:focus,
[class*=navbar-] .navbar-nav .show .dropdown-menu > li > a:active {
    color: white;
  }
  [class*=navbar-] .navbar-nav > li > a,
[class*=navbar-] .navbar-nav > li > a:hover,
[class*=navbar-] .navbar-nav > li > a:focus {
    opacity: 0.7;
    background-color: transparent;
    outline: none;
  }
  [class*=navbar-] .navbar-nav .show .dropdown-menu > li > a:hover,
[class*=navbar-] .navbar-nav .show .dropdown-menu > li > a:focus {
    background-color: rgba(255, 255, 255, 0.1);
  }
  [class*=navbar-] .navbar-nav.navbar-nav .show .dropdown-menu > li > a:active {
    opacity: 1;
  }
  [class*=navbar-] .navbar-nav .dropdown > a:hover .caret {
    border-bottom-color: #fff;
    border-top-color: #fff;
  }
  [class*=navbar-] .navbar-nav .dropdown > a:active .caret {
    border-bottom-color: white;
    border-top-color: white;
  }
  .dropdown-menu {
    display: none;
  }
  .navbar-fixed-top {
    -webkit-backface-visibility: hidden;
  }
  #bodyClick {
    height: 100%;
    width: 100%;
    position: fixed;
    opacity: 0;
    top: 0;
    left: auto;
    right: 250px;
    content: "";
    z-index: 9999;
    overflow-x: hidden;
  }
  .social-line .btn {
    margin: 0 0 10px 0;
  }
  .subscribe-line .form-control {
    margin: 0 0 10px 0;
  }
  .social-line.pull-right {
    float: none;
  }
  .social-area.pull-right {
    float: none !important;
  }
  .form-control + .form-control-feedback {
    margin-top: -8px;
  }
  .navbar-toggle:hover, .navbar-toggle:focus {
    background-color: transparent !important;
  }
  .btn.dropdown-toggle {
    margin-bottom: 0;
  }
  .media-post .author {
    width: 20%;
    float: none !important;
    display: block;
    margin: 0 auto 10px;
  }
  .media-post .media-body {
    width: 100%;
  }
  .navbar-collapse.collapse.in {
    display: block;
  }
  .navbar-header .collapse, .navbar-toggle {
    display: block !important;
  }
  .navbar-header {
    float: none;
  }
  .navbar-nav .show .dropdown-menu {
    position: static;
    float: none;
    width: auto;
    margin-top: 0;
    background-color: transparent;
    border: 0;
    box-shadow: none;
  }
  .navbar-collapse .navbar-nav p {
    line-height: 40px !important;
    margin: 0;
  }
  .navbar-collapse [class^=pe-7s-] {
    float: left;
    font-size: 20px;
    margin-right: 10px;
  }
}
@media (min-width: 992px) {
  .table-full-width {
    margin-left: -15px;
    margin-right: -15px;
  }
  .table-responsive {
    overflow: visible;
  }
}
@media (max-width: 991px) {
  .table-responsive {
    width: 100%;
    margin-bottom: 15px;
    overflow-x: scroll;
    overflow-y: hidden;
    -ms-overflow-style: -ms-autohiding-scrollbar;
    -webkit-overflow-scrolling: touch;
  }
  .close-layer {
    height: 100%;
    width: 100%;
    position: absolute;
    opacity: 0;
    top: 0;
    left: auto;
    content: "";
    z-index: 9999;
    overflow-x: hidden;
    background-color: rgba(0, 0, 0, 0.35);
    transition: all 370ms ease-in;
  }
  .close-layer.visible {
    opacity: 1;
  }
}
@media (max-width: 768px) {
  .main-panel .navbar.navbar-fixed {
    width: 100% !important;
  }
  .main-panel .typo-line {
    padding-left: 80px;
  }
  .main-panel .slider-success.noUi-target {
    margin-bottom: 15px;
  }
  .card .card-body .control-label {
    text-align: left;
  }
}
.bootstrap-switch {
  display: inline-block;
  direction: ltr;
  cursor: pointer;
  border-radius: 30px;
  border: 0;
  position: relative;
  text-align: left;
  overflow: hidden;
  margin-bottom: 5px;
  line-height: 8px;
  width: 61px !important;
  height: 26px;
  outline: none;
  z-index: 0;
  margin-right: 1px;
  -webkit-user-select: none;
  user-select: none;
  vertical-align: middle;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}

.bootstrap-switch .bootstrap-switch-container {
  display: inline-flex;
  top: 0;
  height: 26px;
  border-radius: 4px;
  transform: translate3d(0, 0, 0);
  width: 100px !important;
}

.bootstrap-switch .bootstrap-switch-handle-on,
.bootstrap-switch .bootstrap-switch-handle-off,
.bootstrap-switch .bootstrap-switch-label {
  box-sizing: border-box;
  cursor: pointer;
  display: inline-block !important;
  height: 100%;
  color: #fff;
  padding: 6px 10px;
  font-size: 11px;
  text-indent: -5px;
  line-height: 15px;
  transition: 0.25s ease-out;
}
.bootstrap-switch .bootstrap-switch-handle-on i,
.bootstrap-switch .bootstrap-switch-handle-off i,
.bootstrap-switch .bootstrap-switch-label i {
  font-size: 12px;
  line-height: 14px;
}

.bootstrap-switch .bootstrap-switch-handle-on,
.bootstrap-switch .bootstrap-switch-handle-off {
  text-align: center;
  z-index: 1;
  float: left;
  width: 50% !important;
  background-color: #23CCEF;
}

.bootstrap-switch .bootstrap-switch-label {
  text-align: center;
  z-index: 100;
  color: #333333;
  background: #ffffff;
  width: 22px !important;
  height: 22px;
  margin: 2px -11px;
  border-radius: 12px;
  position: relative;
  float: left;
  padding: 0;
  background-color: #FFFFFF;
  box-shadow: 0 1px 1px #FFFFFF inset, 0 1px 1px rgba(0, 0, 0, 0.25);
}

.bootstrap-switch .bootstrap-switch-handle-on {
  border-bottom-left-radius: 3px;
  border-top-left-radius: 3px;
}

.bootstrap-switch .bootstrap-switch-handle-off {
  text-indent: 6px;
}

.bootstrap-switch input[type=radio],
.bootstrap-switch input[type=checkbox] {
  position: absolute !important;
  top: 0;
  left: 0;
  opacity: 0;
  filter: alpha(opacity=0);
  z-index: -1;
}

.bootstrap-switch.bootstrap-switch-animate .bootstrap-switch-container {
  transition: margin-left 0.5s;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-container {
  margin-left: -2px !important;
}

.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-container {
  margin-left: -37px !important;
}

.bootstrap-switch.bootstrap-switch-on:hover .bootstrap-switch-label {
  width: 26px !important;
  margin: 2px -15px;
}

.bootstrap-switch.bootstrap-switch-off:hover .bootstrap-switch-label {
  width: 26px !important;
  margin: 2px -15px -13px -11px;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-danger {
  background-color: #FB404B;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-warning {
  background-color: #FFA534;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-success {
  background-color: #275D38;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-primary {
  background-color: #447DF7;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-info {
  background-color: #23CCEF;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-default {
  background-color: #5e5e5e;
}

.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-danger,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-primary,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-info,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-warning,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-success {
  background-color: #cfcfca;
}

/*--------------------------------

nucleo-icons Web Font - built using nucleoapp.com
License - nucleoapp.com/license/

-------------------------------- */
@font-face {
  font-family: "nucleo-icons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
/*------------------------
	base class definition
-------------------------*/
.nc-icon {
  display: inline-block;
  font: normal normal normal 14px/1 "nucleo-icons";
  font-size: inherit;
  speak: none;
  text-transform: none;
  /* Better Font Rendering */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.nc-icon.icon-bold {
  font-weight: 700;
}

/*------------------------
  change icon size
-------------------------*/
.nc-icon.lg {
  font-size: 1.33333333em;
  vertical-align: -16%;
}

.nc-icon.x2 {
  font-size: 2em;
}

.nc-icon.x3 {
  font-size: 3em;
}

/*----------------------------------
  add a square/circle background
-----------------------------------*/
.nc-icon.square,
.nc-icon.circle {
  padding: 0.33333333em;
  vertical-align: -16%;
  background-color: #eee;
}

.nc-icon.circle {
  border-radius: 50%;
}

/*------------------------
  list icons
-------------------------*/
.nc-icon-ul {
  padding-left: 0;
  margin-left: 2.14285714em;
  list-style-type: none;
}

.nc-icon-ul > li {
  position: relative;
}

.nc-icon-ul > li > .nc-icon {
  position: absolute;
  left: -1.57142857em;
  top: 0.14285714em;
  text-align: center;
}

.nc-icon-ul > li > .nc-icon.lg {
  top: 0;
  left: -1.35714286em;
}

.nc-icon-ul > li > .nc-icon.circle,
.nc-icon-ul > li > .nc-icon.square {
  top: -0.19047619em;
  left: -1.9047619em;
}

.all-icons .font-icon-list .font-icon-detail i {
  font-size: 32px;
}

/*------------------------
  spinning icons
-------------------------*/
.nc-icon.spin {
  animation: nc-icon-spin 2s infinite linear;
}
@keyframes nc-icon-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/*------------------------
  rotated/flipped icons
-------------------------*/
.nc-icon.rotate-90 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);
  transform: rotate(90deg);
}

.nc-icon.rotate-180 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
  transform: rotate(180deg);
}

.nc-icon.rotate-270 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
  transform: rotate(270deg);
}

.nc-icon.flip-y {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=0);
  transform: scale(-1, 1);
}

.nc-icon.flip-x {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
  transform: scale(1, -1);
}

/*------------------------
	font icons
-------------------------*/
.nc-air-baloon::before {
  content: "\\ea01";
}

.nc-album-2::before {
  content: "\\ea02";
}

.nc-alien-33::before {
  content: "\\ea03";
}

.nc-align-center::before {
  content: "\\ea04";
}

.nc-align-left-2::before {
  content: "\\ea05";
}

.nc-ambulance::before {
  content: "\\ea06";
}

.nc-android::before {
  content: "\\ea07";
}

.nc-app::before {
  content: "\\ea08";
}

.nc-apple::before {
  content: "\\ea09";
}

.nc-atom::before {
  content: "\\ea0a";
}

.nc-attach-87::before {
  content: "\\ea0b";
}

.nc-audio-92::before {
  content: "\\ea0c";
}

.nc-backpack::before {
  content: "\\ea0d";
}

.nc-badge::before {
  content: "\\ea0e";
}

.nc-bag::before {
  content: "\\ea0f";
}

.nc-bank::before {
  content: "\\ea10";
}

.nc-battery-81::before {
  content: "\\ea11";
}

.nc-bell-55::before {
  content: "\\ea12";
}

.nc-bold::before {
  content: "\\ea13";
}

.nc-bulb-63::before {
  content: "\\ea14";
}

.nc-bullet-list-67::before {
  content: "\\ea15";
}

.nc-bus-front-12::before {
  content: "\\ea16";
}

.nc-button-pause::before {
  content: "\\ea17";
}

.nc-button-play::before {
  content: "\\ea18";
}

.nc-button-power::before {
  content: "\\ea19";
}

.nc-camera-20::before {
  content: "\\ea1a";
}

.nc-caps-small::before {
  content: "\\ea1b";
}

.nc-cart-simple::before {
  content: "\\ea1c";
}

.nc-cctv::before {
  content: "\\ea1d";
}

.nc-chart-bar-32::before {
  content: "\\ea1e";
}

.nc-chart-pie-35::before {
  content: "\\ea1f";
}

.nc-chart-pie-36::before {
  content: "\\ea20";
}

.nc-chart::before {
  content: "\\ea21";
}

.nc-chat-round::before {
  content: "\\ea22";
}

.nc-check-2::before {
  content: "\\ea23";
}

.nc-circle-09::before {
  content: "\\ea24";
}

.nc-circle::before {
  content: "\\ea25";
}

.nc-cloud-download-93::before {
  content: "\\ea26";
}

.nc-cloud-upload-94::before {
  content: "\\ea27";
}

.nc-compass-05::before {
  content: "\\ea28";
}

.nc-controller-modern::before {
  content: "\\ea29";
}

.nc-credit-card::before {
  content: "\\ea2a";
}

.nc-delivery-fast::before {
  content: "\\ea2b";
}

.nc-email-83::before {
  content: "\\ea2c";
}

.nc-email-85::before {
  content: "\\ea2d";
}

.nc-explore-2::before {
  content: "\\ea2e";
}

.nc-fav-remove::before {
  content: "\\ea2f";
}

.nc-favourite-28::before {
  content: "\\ea30";
}

.nc-globe-2::before {
  content: "\\ea31";
}

.nc-grid-45::before {
  content: "\\ea32";
}

.nc-headphones-2::before {
  content: "\\ea33";
}

.nc-html5::before {
  content: "\\ea34";
}

.nc-istanbul::before {
  content: "\\ea35";
}

.nc-key-25::before {
  content: "\\ea36";
}

.nc-layers-3::before {
  content: "\\ea37";
}

.nc-light-3::before {
  content: "\\ea38";
}

.nc-lock-circle-open::before {
  content: "\\ea39";
}

.nc-map-big::before {
  content: "\\ea3a";
}

.nc-mobile::before {
  content: "\\ea3c";
}

.nc-money-coins::before {
  content: "\\ea3b";
}

.nc-note-03::before {
  content: "\\ea3d";
}

.nc-notes::before {
  content: "\\ea3e";
}

.nc-notification-70::before {
  content: "\\ea3f";
}

.nc-palette::before {
  content: "\\ea40";
}

.nc-paper-2::before {
  content: "\\ea41";
}

.nc-pin-3::before {
  content: "\\ea42";
}

.nc-planet::before {
  content: "\\ea43";
}

.nc-preferences-circle-rotate::before {
  content: "\\ea44";
}

.nc-puzzle-10::before {
  content: "\\ea45";
}

.nc-quote::before {
  content: "\\ea46";
}

.nc-refresh-02::before {
  content: "\\ea47";
}

.nc-ruler-pencil::before {
  content: "\\ea48";
}

.nc-satisfied::before {
  content: "\\ea49";
}

.nc-scissors::before {
  content: "\\ea4a";
}

.nc-send::before {
  content: "\\ea4b";
}

.nc-settings-90::before {
  content: "\\ea4c";
}

.nc-settings-gear-64::before {
  content: "\\ea4d";
}

.nc-settings-tool-66::before {
  content: "\\ea4e";
}

.nc-simple-add::before {
  content: "\\ea4f";
}

.nc-simple-delete::before {
  content: "\\ea50";
}

.nc-simple-remove::before {
  content: "\\ea51";
}

.nc-single-02::before {
  content: "\\ea52";
}

.nc-single-copy-04::before {
  content: "\\ea53";
}

.nc-spaceship::before {
  content: "\\ea54";
}

.nc-square-pin::before {
  content: "\\ea55";
}

.nc-stre-down::before {
  content: "\\ea56";
}

.nc-stre-left::before {
  content: "\\ea57";
}

.nc-stre-right::before {
  content: "\\ea58";
}

.nc-stre-up::before {
  content: "\\ea59";
}

.nc-sun-fog-29::before {
  content: "\\ea5a";
}

.nc-support-17::before {
  content: "\\ea5b";
}

.nc-tablet-2::before {
  content: "\\ea5c";
}

.nc-tag-content::before {
  content: "\\ea5d";
}

.nc-tap-01::before {
  content: "\\ea5e";
}

.nc-time-alarm::before {
  content: "\\ea5f";
}

.nc-tv-2::before {
  content: "\\ea60";
}

.nc-umbrella-13::before {
  content: "\\ea61";
}

.nc-vector::before {
  content: "\\ea62";
}

.nc-watch-time::before {
  content: "\\ea63";
}

.nc-zoom-split::before {
  content: "\\ea64";
}

/* all icon font classes list here */
/*!
Animate.css - http://daneden.me/animate
Licensed under the MIT license - http://opensource.org/licenses/MIT

Copyright (c) 2015 Daniel Eden
*/
.animated {
  animation-duration: 1s;
  animation-fill-mode: both;
}

.animated.infinite {
  animation-iteration-count: infinite;
}

.animated.hinge {
  animation-duration: 2s;
}

.animated.bounceIn,
.animated.bounceOut {
  animation-duration: 0.75s;
}

.animated.flipOutX,
.animated.flipOutY {
  animation-duration: 0.75s;
}
@keyframes shake {
  from, to {
    transform: translate3d(0, 0, 0);
  }
  10%, 30%, 50%, 70%, 90% {
    transform: translate3d(-10px, 0, 0);
  }
  20%, 40%, 60%, 80% {
    transform: translate3d(10px, 0, 0);
  }
}
.shake {
  animation-name: shake;
}
@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.fadeInDown {
  animation-name: fadeInDown;
}
@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
.fadeOut {
  animation-name: fadeOut;
}
@keyframes fadeOutDown {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }
}
.fadeOutDown {
  animation-name: fadeOutDown;
}
@keyframes fadeOutUp {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
}
.fadeOutUp {
  animation-name: fadeOutUp;
}

.sweet-overlay {
  background-color: rgba(0, 0, 0, 0.4);
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: none;
  z-index: 1000;
}

.sweet-alert {
  background-color: #fff;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  border-radius: 5px;
  box-sizing: border-box;
  text-align: center;
  position: fixed;
  left: 50%;
  top: 50%;
  margin-top: -200px;
  max-height: 90%;
  overflow-x: hidden;
  overflow-y: auto;
  display: none;
  z-index: 2000;
}
.sweet-alert:focus {
  outline: 0;
}
.sweet-alert button {
  margin: 0 5px;
}
.sweet-alert .form-control {
  max-width: 300px;
  margin: 0 auto;
}

.sweet-alert h2 {
  color: #575757;
  text-align: center;
  text-transform: none;
  position: relative;
  padding: 0;
  display: block;
}

.sweet-alert p {
  text-align: center;
  position: relative;
  float: none;
  margin: 0;
  padding: 0;
}

.sweet-alert hr {
  height: 5px;
  color: transparent;
  border: 0;
}

.sweet-alert button.styled {
  color: #fff;
  border: 0;
  box-shadow: none;
  font-size: 17px;
  font-weight: 500;
  border-radius: 5px;
  padding: 10px 32px;
  margin: 0 5px;
  cursor: pointer;
}

.sweet-alert button.styled:focus {
  outline: none;
}

.sweet-alert button.styled.sweet-cancel[disabled] {
  opacity: 0.4;
}

.sweet-alert button.styled.sweet-confirm[disabled] {
  border: 4px solid transparent;
  border-color: transparent;
  width: 40px;
  height: 40px;
  padding: 0;
  margin: 0 30px;
  vertical-align: middle;
  background-color: transparent !important;
  color: transparent;
  cursor: default;
  border-radius: 100%;
  animation: rotate-loading 1.5s linear 0s infinite normal;
}

.sweet-alert button.styled::-moz-focus-inner {
  border: 0;
}

.sweet-alert[data-has-cancel-button=false] button {
  box-shadow: none !important;
}

.sweet-alert .icon {
  width: 80px;
  height: 80px;
  border: 4px solid #808080;
  border-radius: 50%;
  margin: 20px auto;
  padding: 0;
  position: relative;
  box-sizing: content-box;
}

.sweet-alert .icon.error {
  border-color: #f27474;
}

.sweet-alert .icon.error .x-mark {
  position: relative;
  display: block;
}

.sweet-alert .icon.error .line {
  position: absolute;
  height: 5px;
  width: 47px;
  display: block;
  top: 37px;
  border-radius: 2px;
}

.sweet-alert .icon.error .line.left {
  transform: rotate(45deg);
  left: 17px;
}

.sweet-alert .icon.error .line.right {
  transform: rotate(-45deg);
  right: 16px;
}

.sweet-alert .icon.warning {
  border-color: #f8bb86;
}

.sweet-alert .icon.warning .body {
  position: absolute;
  width: 5px;
  height: 47px;
  left: 50%;
  top: 10px;
  border-radius: 2px;
  margin-left: -2px;
  background-color: #f8bb86;
}

.sweet-alert .icon.warning .dot {
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  margin-left: -3px;
  left: 50%;
  bottom: 10px;
  background-color: #f8bb86;
}

.sweet-alert .icon.info {
  border-color: #c9dae1;
}

.sweet-alert .icon.info::before {
  content: "";
  position: absolute;
  width: 5px;
  height: 29px;
  left: 50%;
  bottom: 17px;
  border-radius: 2px;
  margin-left: -2px;
  background-color: #c9dae1;
}

.sweet-alert .icon.info::after {
  content: "";
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  margin-left: -3px;
  top: 19px;
  background-color: #c9dae1;
}

.sweet-alert .icon.success {
  border-color: #a5dc86;
}

.sweet-alert .icon.success::before, .sweet-alert .icon.success::after {
  content: "";
  border-radius: 50%;
  position: absolute;
  width: 60px;
  height: 120px;
  background: #fff;
  transform: rotate(45deg);
}

.sweet-alert .icon.success::before {
  border-radius: 120px 0 0 120px;
  top: -7px;
  left: -33px;
  transform: rotate(-45deg);
  transform-origin: 60px 60px;
}

.sweet-alert .icon.success::after {
  border-radius: 0 120px 120px 0;
  top: -11px;
  left: 30px;
  transform: rotate(-45deg);
  transform-origin: 0 60px;
}

.sweet-alert .icon.success .placeholder {
  width: 80px;
  height: 80px;
  border: 4px solid rgba(165, 220, 134, 0.2);
  border-radius: 50%;
  box-sizing: content-box;
  position: absolute;
  left: -4px;
  top: -4px;
  z-index: 2;
}

.sweet-alert .icon.success .fix {
  width: 5px;
  height: 90px;
  background-color: #fff;
  position: absolute;
  left: 28px;
  top: 8px;
  z-index: 1;
  transform: rotate(-45deg);
}

.sweet-alert .icon.success .line {
  height: 5px;
  background-color: #275D38;
  display: block;
  border-radius: 2px;
  position: absolute;
  z-index: 2;
}

.sweet-alert .icon.success .line.tip {
  width: 25px;
  left: 14px;
  top: 46px;
  transform: rotate(45deg);
}

.sweet-alert .icon.success .line.long {
  width: 47px;
  right: 8px;
  top: 38px;
  transform: rotate(-45deg);
}

.sweet-alert .sweet-image {
  margin: 20px auto;
}
@keyframes showSweetAlert {
  0% {
    transform: scale(0.7);
  }
  45% {
    transform: scale(1.05);
  }
  80% {
    transform: scale(0.95);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes hideSweetAlert {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.5);
  }
}
.show-sweet-alert {
  animation: showSweetAlert 0.3s;
}

.show-sweet-alert.no-animation {
  animation: none;
}

.hide-sweet-alert {
  animation: hideSweetAlert 0.2s;
}

.hide-sweet-alert.no-animation {
  animation: none;
}
@keyframes animate-success-tip {
  0% {
    width: 0;
    left: 1px;
    top: 19px;
  }
  54% {
    width: 0;
    left: 1px;
    top: 19px;
  }
  70% {
    width: 50px;
    left: -8px;
    top: 37px;
  }
  84% {
    width: 17px;
    left: 21px;
    top: 48px;
  }
  100% {
    width: 25px;
    left: 14px;
    top: 45px;
  }
}
@keyframes animate-success-long {
  0% {
    width: 0;
    right: 46px;
    top: 54px;
  }
  65% {
    width: 0;
    right: 46px;
    top: 54px;
  }
  84% {
    width: 55px;
    right: 0;
    top: 35px;
  }
  100% {
    width: 47px;
    right: 8px;
    top: 38px;
  }
}
@keyframes rotatePlaceholder {
  0% {
    transform: rotate(-45deg);
  }
  5% {
    transform: rotate(-45deg);
  }
  12% {
    transform: rotate(-405deg);
  }
  100% {
    transform: rotate(-405deg);
  }
}
.animate-success-tip {
  animation: animate-success-tip 0.75s;
}

.animate-success-long {
  animation: animate-success-long 0.75s;
}

.icon.success.animate::after {
  animation: rotatePlaceholder 4.25s ease-in;
}
@keyframes animate-error-icon {
  0% {
    transform: rotateX(100deg);
    opacity: 0;
  }
  100% {
    transform: rotateX(0deg);
    opacity: 1;
  }
}
.animate-error-icon {
  animation: animate-error-icon 0.5s;
}
@keyframes animate-x-mark {
  0% {
    transform: scale(0.4);
    margin-top: 26px;
    opacity: 0;
  }
  50% {
    transform: scale(0.4);
    margin-top: 26px;
    opacity: 0;
  }
  80% {
    transform: scale(1.15);
    margin-top: -6px;
  }
  100% {
    transform: scale(1);
    margin-top: 0;
    opacity: 1;
  }
}
.animate-x-mark {
  animation: animate-x-mark 0.5s;
}
@keyframes pulse-warning {
  0% {
    border-color: #f8d486;
  }
  100% {
    border-color: #f8bb86;
  }
}
.pulse-warning {
  animation: pulse-warning 0.75s infinite alternate;
}
@keyframes pulse-warning-ins {
  0% {
    background-color: #f8d486;
  }
  100% {
    background-color: #f8bb86;
  }
}
.pulse-warning-ins {
  animation: pulse-warning-ins 0.75s infinite alternate;
}
@keyframes rotate-loading {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
svg {
  touch-action: none;
}

.jvectormap-container {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  touch-action: none;
}

.jvectormap-tip {
  position: absolute;
  display: none;
  border: solid 1px #CDCDCD;
  border-radius: 3px;
  background: #292929;
  color: white;
  font-family: sans-serif, Verdana;
  font-size: smaller;
  padding: 3px;
}

.jvectormap-zoomin, .jvectormap-zoomout, .jvectormap-goback {
  position: absolute;
  left: 10px;
  border-radius: 3px;
  background: #292929;
  padding: 3px;
  color: white;
  cursor: pointer;
  line-height: 10px;
  text-align: center;
  box-sizing: content-box;
}

.jvectormap-zoomin, .jvectormap-zoomout {
  width: 10px;
  height: 10px;
}

.jvectormap-zoomin {
  top: 10px;
}

.jvectormap-zoomout {
  top: 30px;
}

.jvectormap-goback {
  bottom: 10px;
  z-index: 1000;
  padding: 6px;
}

.jvectormap-spinner {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: center no-repeat url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.jvectormap-legend-title {
  font-weight: bold;
  font-size: 14px;
  text-align: center;
}

.jvectormap-legend-cnt {
  position: absolute;
}

.jvectormap-legend-cnt-h {
  bottom: 0;
  right: 0;
}

.jvectormap-legend-cnt-v {
  top: 0;
  right: 0;
}

.jvectormap-legend {
  background: black;
  color: white;
  border-radius: 3px;
}

.jvectormap-legend-cnt-h .jvectormap-legend {
  float: left;
  margin: 0 10px 10px 0;
  padding: 3px 3px 1px 3px;
}

.jvectormap-legend-cnt-h .jvectormap-legend .jvectormap-legend-tick {
  float: left;
}

.jvectormap-legend-cnt-v .jvectormap-legend {
  margin: 10px 10px 0 0;
  padding: 3px;
}

.jvectormap-legend-cnt-h .jvectormap-legend-tick {
  width: 40px;
}

.jvectormap-legend-cnt-h .jvectormap-legend-tick-sample {
  height: 15px;
}

.jvectormap-legend-cnt-v .jvectormap-legend-tick-sample {
  height: 20px;
  width: 20px;
  display: inline-block;
  vertical-align: middle;
}

.jvectormap-legend-tick-text {
  font-size: 12px;
}

.jvectormap-legend-cnt-h .jvectormap-legend-tick-text {
  text-align: center;
}

.jvectormap-legend-cnt-v .jvectormap-legend-tick-text {
  display: inline-block;
  vertical-align: middle;
  line-height: 20px;
  padding-left: 3px;
}

/**
 * @author zhixin wen <wenzhixin2010@gmail.com>
 * version: 1.8.1
 * https://github.com/wenzhixin/bootstrap-table/
 */
.bootstrap-table .table {
  margin-bottom: 0 !important;
  border-bottom: 1px solid #dddddd;
  border-collapse: collapse !important;
  border-radius: 1px;
}

.bootstrap-table .table,
.bootstrap-table .table > tbody > tr > th,
.bootstrap-table .table > tfoot > tr > th,
.bootstrap-table .table > thead > tr > td,
.bootstrap-table .table > tbody > tr > td,
.bootstrap-table .table > tfoot > tr > td {
  padding: 8px !important;
}

.bootstrap-table .table > tbody > .selected {
  background-color: rgba(68, 125, 247, 0.2);
}

.bootstrap-table .table.table-no-bordered > thead > tr > th,
.bootstrap-table .table.table-no-bordered > tbody > tr > td {
  border-right: 2px solid transparent;
}

.fixed-table-container {
  position: relative;
  clear: both;
}

.fixed-table-container.table-no-bordered {
  border: 1px solid transparent;
}

.fixed-table-footer,
.fixed-table-header {
  overflow: hidden;
}

.fixed-table-footer {
  border-top: 1px solid #dddddd;
}

.fixed-table-body {
  height: 100%;
  overflow: auto;
}

.fixed-table-container table {
  width: 100%;
}

.fixed-table-container thead th {
  height: 0;
  padding: 0;
  margin: 0;
}

.fixed-table-container thead th:first-child {
  border-left: none;
}

.fixed-table-container thead th .th-inner {
  padding: 0 8px;
  line-height: 24px;
  vertical-align: top;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.fixed-table-container thead th .sortable {
  cursor: pointer;
  background-repeat: no-repeat;
  padding-right: 30px;
}

.fixed-table-container thead th .both {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-position: right 2px;
}

.fixed-table-container thead th .asc {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-position: right 5px;
}

.fixed-table-container thead th .desc {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-position: right 0px;
}

.fixed-table-container th.detail {
  width: 30px;
}

.fixed-table-container tbody tr:first-child td {
  border-top: none;
}

.fixed-table-container tbody td:first-child {
  border-left: none;
}

/* the same color with .active */
.fixed-table-container tbody .selected td {
  background-color: rgba(245, 245, 245, 0.34);
}

.fixed-table-container .bs-checkbox {
  text-align: center;
}

.fixed-table-container .bs-checkbox .th-inner {
  padding: 8px 0;
}

.fixed-table-container input[type=radio],
.fixed-table-container input[type=checkbox] {
  margin: 0 auto !important;
  cursor: pointer;
}

.fixed-table-container .no-records-found {
  text-align: center;
  background-color: #FFFFFF !important;
  height: 340px;
  border-radius: 10px;
  width: 100%;
  vertical-align: middle;
}

.fixed-table-container .no-records-found td {
  font-weight: 300;
  font-size: 1.375rem;
}

.fixed-table-pagination div.pagination,
.fixed-table-pagination .pagination-detail {
  margin-top: 10px;
  margin-bottom: 10px;
}

.fixed-table-pagination div.pagination .pagination {
  margin: 0;
}

.fixed-table-pagination .pagination a {
  padding: 6px 12px;
  line-height: 1.428571429;
}

.fixed-table-pagination .pagination-info {
  line-height: 34px;
  margin-right: 5px;
}

.fixed-table-pagination .btn-group {
  position: relative;
  display: inline-block;
  vertical-align: middle;
}

.fixed-table-pagination .page-list {
  display: inline-block;
}

.fixed-table-toolbar {
  padding: 5px 15px;
}

.fixed-table-toolbar .columns-left {
  margin-right: 5px;
}

.fixed-table-toolbar .columns-right {
  margin-left: 5px;
}

.fixed-table-toolbar .columns .btn {
  margin: 0 2px;
  border-radius: 30px;
}

.fixed-table-toolbar .columns label {
  display: block;
  padding: 10px 20px;
  border-bottom: 1px solid #eee;
  clear: both;
  margin-bottom: 0;
  font-weight: normal;
  line-height: 1.428571429;
}

.fixed-table-toolbar .columns li:last-child label {
  border-bottom: none;
}

.fixed-table-toolbar .bars,
.fixed-table-toolbar .search,
.fixed-table-toolbar .columns {
  position: relative;
  margin-top: 10px;
  margin-bottom: 10px;
  line-height: 34px;
}

.fixed-table-pagination li.disabled a {
  pointer-events: none;
  cursor: default;
}

.fixed-table-loading {
  display: none;
  position: absolute;
  top: 42px;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99;
  background-color: #fff;
  text-align: center;
}

.fixed-table-body .card-view .title {
  font-weight: bold;
  display: inline-block;
  min-width: 30%;
  text-align: left !important;
}

/* support bootstrap 2 */
.fixed-table-body thead th .th-inner {
  box-sizing: border-box;
}

.table th, .table td {
  vertical-align: middle;
  box-sizing: border-box;
}

.fixed-table-toolbar .btn-group > .btn-group {
  display: inline-block;
  margin-left: -1px !important;
}

.fixed-table-toolbar .dropdown-menu label {
  cursor: pointer;
}

.fixed-table-toolbar .btn-group > .btn-group > .btn {
  border-radius: 0;
}

.fixed-table-toolbar .btn-group > .btn-group:first-child > .btn {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.fixed-table-toolbar .btn-group > .btn-group:last-child > .btn {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

/* support bootstrap 3 */
.bootstrap-table .table thead > tr > th {
  padding: 0;
  margin: 0;
}

.pull-right .dropdown-menu {
  right: 0;
  left: auto;
}

/* calculate scrollbar width */
p.fixed-table-scroll-inner {
  width: 100%;
  height: 200px;
}

div.fixed-table-scroll-outer {
  top: 0;
  left: 0;
  visibility: hidden;
  width: 200px;
  height: 150px;
  overflow: hidden;
}

.bootstrap-table .fixed-table-pagination {
  margin: 0 10px;
}
.bootstrap-table .fixed-table-pagination:after {
  display: table;
  content: "";
  clear: both;
}
.bootstrap-table .fixed-table-pagination .page-list .btn {
  border-radius: 30px;
}
.bootstrap-table .fixed-table-pagination .page-list .btn-group {
  margin-right: 5px;
}
.bootstrap-table .fixed-table-pagination div.pagination,
.bootstrap-table .fixed-table-pagination .pagination-detail {
  margin-top: 15px;
  margin-bottom: 15px;
}
.bootstrap-table .table.table-striped > thead > tr > td, .bootstrap-table .table.table-striped > tbody > tr > td, .bootstrap-table .table.table-striped > tfoot > tr > td {
  border: none;
}

table.dataTable {
  clear: both;
  margin-top: 6px !important;
  margin-bottom: 6px !important;
  max-width: none !important;
  border-collapse: separate !important;
}

table.dataTable td,
table.dataTable th {
  box-sizing: content-box;
}

table.dataTable td.dataTables_empty,
table.dataTable th.dataTables_empty {
  text-align: center;
}

table.dataTable.nowrap th,
table.dataTable.nowrap td {
  white-space: nowrap;
}

div.dataTables_wrapper div.dataTables_length label {
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
}

div.dataTables_wrapper div.dataTables_length select {
  width: 75px;
  display: inline-block;
}

div.dataTables_wrapper div.dataTables_filter {
  text-align: right;
}

div.dataTables_wrapper div.dataTables_filter label {
  font-weight: normal;
  white-space: nowrap;
  text-align: left;
}

div.dataTables_wrapper div.dataTables_filter input {
  margin-left: 0.5em;
  display: inline-block;
  width: auto;
}

div.dataTables_wrapper div.dataTables_info {
  padding-top: 8px;
  white-space: nowrap;
}

div.dataTables_wrapper div.dataTables_paginate {
  margin: 0;
  white-space: nowrap;
  text-align: right;
}

div.dataTables_wrapper div.dataTables_paginate ul.pagination {
  margin: 2px 0;
  white-space: nowrap;
}

div.dataTables_wrapper div.dataTables_processing {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 200px;
  margin-left: -100px;
  margin-top: -26px;
  text-align: center;
  padding: 1em 0;
}

table.dataTable thead > tr > th.sorting_asc, table.dataTable thead > tr > th.sorting_desc, table.dataTable thead > tr > th.sorting,
table.dataTable thead > tr > td.sorting_asc,
table.dataTable thead > tr > td.sorting_desc,
table.dataTable thead > tr > td.sorting {
  padding-right: 30px;
}

table.dataTable thead > tr > th:active,
table.dataTable thead > tr > td:active {
  outline: none;
}

table.dataTable thead .sorting,
table.dataTable thead .sorting_asc,
table.dataTable thead .sorting_desc,
table.dataTable thead .sorting_asc_disabled,
table.dataTable thead .sorting_desc_disabled {
  cursor: pointer;
  position: relative;
}

table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after,
table.dataTable thead .sorting_asc_disabled:after,
table.dataTable thead .sorting_desc_disabled:after {
  position: absolute;
  bottom: 8px;
  right: 8px;
  display: block;
  font-family: "Glyphicons Halflings";
  opacity: 0.5;
}

table.dataTable thead .sorting:after {
  opacity: 0.2;
  content: "\\e150";
  /* sort */
}

table.dataTable thead .sorting_asc:after {
  content: "\\e155";
  /* sort-by-attributes */
}

table.dataTable thead .sorting_desc:after {
  content: "\\e156";
  /* sort-by-attributes-alt */
}

table.dataTable thead .sorting_asc_disabled:after,
table.dataTable thead .sorting_desc_disabled:after {
  color: #eee;
}

div.dataTables_scrollHead table.dataTable {
  margin-bottom: 0 !important;
}

div.dataTables_scrollBody table {
  border-top: none;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

div.dataTables_scrollBody table thead .sorting:after,
div.dataTables_scrollBody table thead .sorting_asc:after,
div.dataTables_scrollBody table thead .sorting_desc:after {
  display: none;
}

div.dataTables_scrollBody table tbody tr:first-child th,
div.dataTables_scrollBody table tbody tr:first-child td {
  border-top: none;
}

div.dataTables_scrollFoot table {
  margin-top: 0 !important;
  border-top: none;
}

@media screen and (max-width: 767px) {
  div.dataTables_wrapper div.dataTables_length,
div.dataTables_wrapper div.dataTables_filter,
div.dataTables_wrapper div.dataTables_info,
div.dataTables_wrapper div.dataTables_paginate {
    text-align: center;
  }
}
table.dataTable.table-condensed > thead > tr > th {
  padding-right: 20px;
}

table.dataTable.table-condensed .sorting:after,
table.dataTable.table-condensed .sorting_asc:after,
table.dataTable.table-condensed .sorting_desc:after {
  top: 6px;
  right: 6px;
}

table.table-bordered.dataTable th,
table.table-bordered.dataTable td {
  border-left-width: 0;
}

table.table-bordered.dataTable th:last-child, table.table-bordered.dataTable th:last-child,
table.table-bordered.dataTable td:last-child,
table.table-bordered.dataTable td:last-child {
  border-right-width: 0;
}

table.table-bordered.dataTable tbody th,
table.table-bordered.dataTable tbody td {
  border-bottom-width: 0;
}

div.dataTables_scrollHead table.table-bordered {
  border-bottom-width: 0;
}

div.table-responsive > div.dataTables_wrapper > div.row {
  margin: 0;
}

div.table-responsive > div.dataTables_wrapper > div.row > div[class^=col-]:first-child {
  padding-left: 0;
}

div.table-responsive > div.dataTables_wrapper > div.row > div[class^=col-]:last-child {
  padding-right: 0;
}

table.dataTable .btn-simple.btn-icon {
  padding: 3px;
}
table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after,
table.dataTable thead .sorting_asc_disabled:after,
table.dataTable thead .sorting_desc_disabled:after {
  position: relative;
  display: inline-block;
  bottom: 0px;
  right: -7px;
  font-family: "FontAwesome";
  opacity: 0.8;
}
table.dataTable thead .disabled-sorting.sorting:after,
table.dataTable thead .disabled-sorting.sorting_asc:after,
table.dataTable thead .disabled-sorting.sorting_desc:after,
table.dataTable thead .disabled-sorting.sorting_asc_disabled:after,
table.dataTable thead .disabled-sorting.sorting_desc_disabled:after {
  display: none;
}
table.dataTable thead .sorting:after {
  opacity: 0.4;
  content: "\\f0dc";
}
table.dataTable thead .sorting_asc:after {
  content: "\\f0de";
  top: 3px;
}
table.dataTable thead .sorting_desc:after {
  content: "\\f0dd";
  top: -3px;
}
table.dataTable > thead > tr > th,
table.dataTable > tbody > tr > th,
table.dataTable > tfoot > tr > th,
table.dataTable > thead > tr > td,
table.dataTable > tbody > tr > td,
table.dataTable > tfoot > tr > td {
  padding: 8px !important;
  outline: 0;
}
table.dataTable > thead > tr > th {
  border: none;
}

.fresh-datatables .pagination > li > a,
.fresh-datatables .pagination > li:first-child > a,
.fresh-datatables .pagination > li:first-child > span,
.fresh-datatables .pagination > li:last-child > a,
.fresh-datatables .pagination > li:last-child > span {
  border-radius: 25px;
}

.dataTables_paginate a {
  outline: 0;
}

table.dataTable.dtr-inline.collapsed > tbody > tr > td.child,
table.dataTable.dtr-inline.collapsed > tbody > tr > th.child,
table.dataTable.dtr-inline.collapsed > tbody > tr > td.dataTables_empty {
  cursor: default !important;
}
table.dataTable.dtr-inline.collapsed > tbody > tr > td.child:before,
table.dataTable.dtr-inline.collapsed > tbody > tr > th.child:before,
table.dataTable.dtr-inline.collapsed > tbody > tr > td.dataTables_empty:before {
  display: none !important;
}
table.dataTable.dtr-inline.collapsed > tbody > tr > td:first-child,
table.dataTable.dtr-inline.collapsed > tbody > tr > th:first-child {
  position: relative;
  padding-left: 30px !important;
  cursor: pointer;
}
table.dataTable.dtr-inline.collapsed > tbody > tr > td:first-child:before,
table.dataTable.dtr-inline.collapsed > tbody > tr > th:first-child:before {
  top: 50%;
  margin-top: -9px;
  left: 4px;
  height: 18px;
  width: 18px;
  display: block;
  position: absolute;
  color: #518607;
  border: 0px solid white;
  border-radius: 14px;
  box-shadow: 0 0 3px #444;
  box-sizing: content-box;
  text-align: center;
  font-family: "Courier New", Courier, monospace;
  line-height: 18px;
  content: "+";
  background-color: #FFF;
}
table.dataTable.dtr-inline.collapsed > tbody > tr.parent > td:first-child:before,
table.dataTable.dtr-inline.collapsed > tbody > tr.parent > th:first-child:before {
  content: "-";
  color: #ED362C;
}
table.dataTable.dtr-inline.collapsed > tbody > tr.child td:before {
  display: none;
}

table.dataTable.dtr-inline.collapsed.compact > tbody > tr > td:first-child,
table.dataTable.dtr-inline.collapsed.compact > tbody > tr > th:first-child {
  padding-left: 27px;
}
table.dataTable.dtr-inline.collapsed.compact > tbody > tr > td:first-child:before,
table.dataTable.dtr-inline.collapsed.compact > tbody > tr > th:first-child:before {
  top: 5px;
  left: 4px;
  height: 14px;
  width: 14px;
  border-radius: 14px;
  line-height: 14px;
  text-indent: 3px;
}

table.dataTable.dtr-column > tbody > tr > td.control,
table.dataTable.dtr-column > tbody > tr > th.control {
  position: relative;
  cursor: pointer;
}
table.dataTable.dtr-column > tbody > tr > td.control:before,
table.dataTable.dtr-column > tbody > tr > th.control:before {
  top: 50%;
  left: 50%;
  height: 16px;
  width: 16px;
  margin-top: -10px;
  margin-left: -10px;
  display: block;
  position: absolute;
  color: white;
  border: 2px solid white;
  border-radius: 14px;
  box-shadow: 0 0 3px #444;
  box-sizing: content-box;
  text-align: center;
  font-family: "Courier New", Courier, monospace;
  line-height: 14px;
  content: "+";
  background-color: #31b131;
}
table.dataTable.dtr-column > tbody > tr.parent td.control:before,
table.dataTable.dtr-column > tbody > tr.parent th.control:before {
  content: "-";
  background-color: #d33333;
}

table.dataTable > tbody > tr.child {
  padding: 0.5em 1em;
}
table.dataTable > tbody > tr.child:hover {
  background: transparent !important;
}
table.dataTable > tbody > tr.child ul {
  display: inline-block;
  list-style-type: none;
  margin: 0;
  padding: 0;
}
table.dataTable > tbody > tr.child ul li {
  border-bottom: 1px solid #efefef;
  padding: 0.5em 0;
}
table.dataTable > tbody > tr.child ul li:first-child {
  padding-top: 0;
}
table.dataTable > tbody > tr.child ul li:last-child {
  border-bottom: none;
}
table.dataTable > tbody > tr.child span.dtr-title {
  display: inline-block;
  min-width: 75px;
  font-weight: bold;
}

div.dtr-modal {
  position: fixed;
  box-sizing: border-box;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 100;
  padding: 10em 1em;
}
div.dtr-modal div.dtr-modal-display {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 50%;
  height: 50%;
  overflow: auto;
  margin: auto;
  z-index: 102;
  overflow: auto;
  background-color: #f5f5f7;
  border: 1px solid black;
  border-radius: 0.5em;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.6);
}
div.dtr-modal div.dtr-modal-content {
  position: relative;
  padding: 1em;
}
div.dtr-modal div.dtr-modal-close {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 22px;
  height: 22px;
  border: 1px solid #eaeaea;
  background-color: #f9f9f9;
  text-align: center;
  border-radius: 3px;
  cursor: pointer;
  z-index: 12;
}
div.dtr-modal div.dtr-modal-close:hover {
  background-color: #eaeaea;
}
div.dtr-modal div.dtr-modal-background {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 101;
  background: rgba(0, 0, 0, 0.6);
}

.data-tables .pagination .paginate_button.page-item.first .page-link, .data-tables .pagination .paginate_button.page-item.previous .page-link, .data-tables .pagination .paginate_button.page-item.next .page-link, .data-tables .pagination .paginate_button.page-item.last .page-link {
  border-radius: 25px;
}

@media screen and (max-width: 767px) {
  div.dtr-modal div.dtr-modal-display {
    width: 95%;
  }
  .data-tables .pagination .paginate_button.page-item.first, .data-tables .pagination .paginate_button.page-item.last {
    display: none;
  }
}
/*!
 * FullCalendar v3.6.2 Stylesheet
 * Docs & License: https://fullcalendar.io/
 * (c) 2017 Adam Shaw
 */
.fc {
  direction: ltr;
  text-align: left;
}

.fc-rtl {
  text-align: right;
}

body .fc { /* extra precedence to overcome jqui */
  font-size: 1em;
}

/* Colors
--------------------------------------------------------------------------------------------------*/
.fc-unthemed th,
.fc-unthemed td,
.fc-unthemed thead,
.fc-unthemed tbody,
.fc-unthemed .fc-divider,
.fc-unthemed .fc-row,
.fc-unthemed .fc-popover {
  border-color: #ddd;
}

.fc-unthemed .fc-popover {
  background-color: #fff;
}

.fc-unthemed .fc-divider,
.fc-unthemed .fc-popover .fc-header {
  background: #eee;
}

.fc-unthemed .fc-popover .fc-header .fc-close {
  color: #666;
}

.fc-unthemed .fc-today {
  background: #F5F5F5;
}

.fc-highlight { /* when user is selecting cells */
  background: #bce8f1;
  opacity: 0.3;
  filter: alpha(opacity=30); /* for IE */
}

.fc-bgevent { /* default look for background events */
  background: rgb(143, 223, 130);
  opacity: 0.3;
  filter: alpha(opacity=30); /* for IE */
}

.fc-nonbusiness { /* default look for non-business-hours areas */
  /* will inherit .fc-bgevent's styles */
  background: #d7d7d7;
}

/* Icons (inline elements with styled text that mock arrow icons)
--------------------------------------------------------------------------------------------------*/
.fc-icon {
  display: inline-block;
  width: 1em;
  height: 1em;
  line-height: 1em;
  font-size: 1em;
  text-align: center;
  overflow: hidden;
  font-family: "Courier New", Courier, monospace;
  /* don't allow browser text-selection */
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}

/*
Acceptable font-family overrides for individual icons:
	"Arial", sans-serif
	"Times New Roman", serif

NOTE: use percentage font sizes or else old IE chokes
*/
.fc-icon:after {
  position: relative;
  margin: 0 -1em; /* ensures character will be centered, regardless of width */
}

.fc-icon-left-single-arrow:after {
  content: "‹";
  font-weight: bold;
  font-size: 200%;
  top: -7%;
  left: 3%;
}

.fc-icon-right-single-arrow:after {
  content: "›";
  font-weight: bold;
  font-size: 200%;
  top: -7%;
  left: -3%;
}

.fc-icon-left-double-arrow:after {
  content: "«";
  font-size: 160%;
  top: -7%;
}

.fc-icon-right-double-arrow:after {
  content: "»";
  font-size: 160%;
  top: -7%;
}

.fc-icon-left-triangle:after {
  content: "◄";
  font-size: 125%;
  top: 3%;
  left: -2%;
}

.fc-icon-right-triangle:after {
  content: "►";
  font-size: 125%;
  top: 3%;
  left: 2%;
}

.fc-icon-down-triangle:after {
  content: "▼";
  font-size: 125%;
  top: 2%;
}

.fc-icon-x:after {
  content: "×";
  font-size: 200%;
  top: 6%;
}

/* Buttons (styled <button> tags, normalized to work cross-browser)
--------------------------------------------------------------------------------------------------*/
.fc button {
  border-width: 1px;
  background-color: transparent;
  font-weight: 400;
  opacity: 0.8;
  filter: alpha(opacity=80);
  padding: 8px 16px;
  border-color: #888888;
  color: #888888;
}
.fc button:hover, .fc button:focus {
  opacity: 1;
  filter: alpha(opacity=100);
  outline: 0 !important;
}
.fc button:active, .fc button.active, .open > .fc button.dropdown-toggle {
  box-shadow: none;
  outline: 0 !important;
}

/* Firefox has an annoying inner border */
.fc button::-moz-focus-inner {
  margin: 0;
  padding: 0;
}

.fc-state-default { /* non-theme */
  border: 1px solid;
}

.fc-state-default.fc-corner-left { /* non-theme */
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.fc-state-default.fc-corner-right { /* non-theme */
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

/* icons in buttons */
.fc button .fc-icon { /* non-theme */
  position: relative;
  top: -0.05em; /* seems to be a good adjustment across browsers */
  margin: 0 0.2em;
  vertical-align: middle;
}

/*
  button states
  borrowed from twitter bootstrap (http://twitter.github.com/bootstrap/)
*/
.fc-state-hover,
.fc-state-active,
.fc-state-disabled {
  color: #333333;
  background-color: #e6e6e6;
}

.fc button[disabled],
.fc button[disabled]:focus,
.fc button[disabled]:hover {
  background-color: #E3E3E3;
  border-color: #E3E3E3;
  cursor: default;
  opacity: 0.65;
  filter: alpha(opacity=65);
  margin-left: 0.75em;
}

.fc-state-hover {
  background-color: #F5F5F5;
}

.fc .fc-state-active,
.fc .fc-state-active:focus,
.fc .fc-state-active:hover,
.fc .fc-state-active:active:focus,
.fc .fc-state-active:active:hover,
.fc .fc-state-active:active {
  background-color: #888888;
  color: #FFFFFF;
}

/* Buttons Groups
--------------------------------------------------------------------------------------------------*/
.fc-button-group {
  display: inline-block;
}

/*
every button that is not first in a button group should scootch over one pixel and cover the
previous button's border...
*/
.fc .fc-button-group > * { /* extra precedence b/c buttons have margin set to zero */
  float: left;
  margin: 0 0 0 5px;
}

.fc .fc-button-group > :first-child { /* same */
  margin-left: 0;
}

/* Popover
--------------------------------------------------------------------------------------------------*/
.fc-popover {
  position: absolute;
  box-shadow: 1px 2px 3px rgba(0, 0, 0, 0.125);
}

.fc-popover .fc-header { /* TODO: be more consistent with fc-head/fc-body */
  padding: 2px 4px;
}

.fc-popover .fc-header .fc-title {
  margin: 0 2px;
}

.fc-popover .fc-header .fc-close {
  cursor: pointer;
}

.fc-ltr .fc-popover .fc-header .fc-title,
.fc-rtl .fc-popover .fc-header .fc-close {
  float: left;
}

.fc-rtl .fc-popover .fc-header .fc-title,
.fc-ltr .fc-popover .fc-header .fc-close {
  float: right;
}

/* unthemed */
.fc-unthemed .fc-popover {
  border-width: 1px;
  border-style: solid;
}

.fc-unthemed .fc-popover .fc-header .fc-close {
  font-size: 0.9em;
  margin-top: 2px;
}

/* jqui themed */
.fc-popover > .ui-widget-header + .ui-widget-content {
  border-top: 0; /* where they meet, let the header have the border */
}

/* Misc Reusable Components
--------------------------------------------------------------------------------------------------*/
.fc-divider {
  border-style: solid;
  border-width: 1px;
}

hr.fc-divider {
  height: 0;
  margin: 0;
  padding: 0 0 2px; /* height is unreliable across browsers, so use padding */
  border-width: 1px 0;
}

.fc-clear {
  clear: both;
}

.fc-bg,
.fc-bgevent-skeleton,
.fc-highlight-skeleton,
.fc-helper-skeleton {
  /* these element should always cling to top-left/right corners */
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}

.fc-bg {
  bottom: 0; /* strech bg to bottom edge */
}

.fc-bg table {
  height: 100%; /* strech bg to bottom edge */
}

/* Tables
--------------------------------------------------------------------------------------------------*/
.fc table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  border-spacing: 0;
  font-size: 1em; /* normalize cross-browser */
}

.fc th {
  text-align: right;
  border-bottom-width: 1px;
  font-size: 0.875rem;
  text-transform: uppercase;
  color: #9A9A9A;
  font-weight: 400;
  padding-bottom: 3px;
}

.fc td {
  border-style: solid;
  border-width: 1px;
  padding: 0;
  vertical-align: top;
}

.fc td.fc-today {
  border-style: double; /* overcome neighboring borders */
}

.fc .fc-widget-header {
  border: 0;
}

.fc .fc-head .fc-widget-header {
  margin-top: 15px;
}

/* Fake Table Rows
--------------------------------------------------------------------------------------------------*/
.fc .fc-row { /* extra precedence to overcome themes w/ .ui-widget-content forcing a 1px border */
  /* no visible border by default. but make available if need be (scrollbar width compensation) */
  border-style: solid;
  border-width: 0;
}

.fc-row table {
  /* don't put left/right border on anything within a fake row.
     the outer tbody will worry about this */
  border-left: 0 hidden transparent;
  border-right: 0 hidden transparent;
  /* no bottom borders on rows */
  border-bottom: 0 hidden transparent;
}

.fc-row:first-child table {
  border-top: 0 hidden transparent; /* no top border on first row */
}

/* Day Row (used within the header and the DayGrid)
--------------------------------------------------------------------------------------------------*/
.fc-row {
  position: relative;
}

.fc-row .fc-bg {
  z-index: 1;
}

/* highlighting cells & background event skeleton */
.fc-row .fc-bgevent-skeleton,
.fc-row .fc-highlight-skeleton {
  bottom: 0; /* stretch skeleton to bottom of row */
}

.fc-row .fc-bgevent-skeleton table,
.fc-row .fc-highlight-skeleton table {
  height: 100%; /* stretch skeleton to bottom of row */
}

.fc-row .fc-highlight-skeleton td,
.fc-row .fc-bgevent-skeleton td {
  border-color: transparent;
}

.fc-row .fc-bgevent-skeleton {
  z-index: 2;
}

.fc-row .fc-highlight-skeleton {
  z-index: 3;
}

/*
row content (which contains day/week numbers and events) as well as "helper" (which contains
temporary rendered events).
*/
.fc-row .fc-content-skeleton {
  position: relative;
  z-index: 4;
  padding-bottom: 2px; /* matches the space above the events */
}

.fc-row .fc-helper-skeleton {
  z-index: 5;
}

.fc-row .fc-content-skeleton td,
.fc-row .fc-helper-skeleton td {
  /* see-through to the background below */
  background: none; /* in case <td>s are globally styled */
  border-color: transparent;
  /* don't put a border between events and/or the day number */
  border-bottom: 0;
}

.fc-row .fc-content-skeleton tbody td,
.fc-row .fc-helper-skeleton tbody td {
  /* don't put a border between event cells */
  border-top: 0;
}

/* Scrolling Container
--------------------------------------------------------------------------------------------------*/
.fc-scroller { /* this class goes on elements for guaranteed vertical scrollbars */
  overflow-y: scroll;
  overflow-x: hidden;
}

.fc-scroller > * { /* we expect an immediate inner element */
  position: relative; /* re-scope all positions */
  width: 100%; /* hack to force re-sizing this inner element when scrollbars appear/disappear */
  overflow: hidden; /* don't let negative margins or absolute positioning create further scroll */
}

/* Global Event Styles
--------------------------------------------------------------------------------------------------*/
.fc-event {
  position: relative; /* for resize handle and other inner positioning */
  display: block; /* make the <a> tag block */
  font-size: 0.85em;
  line-height: 1.3;
  border-radius: 2px;
  background-color: rgba(68, 125, 247, 0.2); /* default BACKGROUND color */
  font-weight: normal; /* undo jqui's ui-widget-header bold */
}
.fc-event.event-azure {
  background-color: rgba(35, 204, 239, 0.2);
}
.fc-event.event-green {
  background-color: rgba(39, 93, 56, 0.2);
}
.fc-event.event-orange {
  background-color: rgba(255, 165, 52, 0.2);
}
.fc-event.event-red {
  background-color: rgba(251, 64, 75, 0.2);
}

/* overpower some of bootstrap's and jqui's styles on <a> tags */
.fc-event,
.fc-event:hover,
.ui-widget .fc-event {
  color: #333333; /* default TEXT color */
  text-decoration: none; /* if <a> has an href */
}

.fc-event[href],
.fc-event.fc-draggable {
  cursor: pointer; /* give events with links and draggable events a hand mouse pointer */
}

.fc-not-allowed,
.fc-not-allowed .fc-event { /* to override an event's custom cursor */
  cursor: not-allowed;
}

.fc-event .fc-bg { /* the generic .fc-bg already does position */
  z-index: 1;
  background: #fff;
  opacity: 0.25;
  filter: alpha(opacity=25); /* for IE */
}

.fc-event .fc-content {
  position: relative;
  z-index: 2;
}

.fc-event .fc-resizer {
  position: absolute;
  z-index: 3;
}

/* Horizontal Events
--------------------------------------------------------------------------------------------------*/
/* events that are continuing to/from another week. kill rounded corners and butt up against edge */
.fc-ltr .fc-h-event.fc-not-start,
.fc-rtl .fc-h-event.fc-not-end {
  margin-left: 0;
  border-left-width: 0;
  padding-left: 1px; /* replace the border with padding */
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.fc-ltr .fc-h-event.fc-not-end,
.fc-rtl .fc-h-event.fc-not-start {
  margin-right: 0;
  border-right-width: 0;
  padding-right: 1px; /* replace the border with padding */
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

/* resizer */
.fc-h-event .fc-resizer { /* positioned it to overcome the event's borders */
  top: -1px;
  bottom: -1px;
  left: -1px;
  right: -1px;
  width: 5px;
}

/* left resizer  */
.fc-ltr .fc-h-event .fc-start-resizer,
.fc-ltr .fc-h-event .fc-start-resizer:before,
.fc-ltr .fc-h-event .fc-start-resizer:after,
.fc-rtl .fc-h-event .fc-end-resizer,
.fc-rtl .fc-h-event .fc-end-resizer:before,
.fc-rtl .fc-h-event .fc-end-resizer:after {
  right: auto; /* ignore the right and only use the left */
  cursor: w-resize;
}

/* right resizer */
.fc-ltr .fc-h-event .fc-end-resizer,
.fc-ltr .fc-h-event .fc-end-resizer:before,
.fc-ltr .fc-h-event .fc-end-resizer:after,
.fc-rtl .fc-h-event .fc-start-resizer,
.fc-rtl .fc-h-event .fc-start-resizer:before,
.fc-rtl .fc-h-event .fc-start-resizer:after {
  left: auto; /* ignore the left and only use the right */
  cursor: e-resize;
}

/* DayGrid events
----------------------------------------------------------------------------------------------------
We use the full "fc-day-grid-event" class instead of using descendants because the event won't
be a descendant of the grid when it is being dragged.
*/
.fc-day-grid-event {
  margin: 2px 5px 0; /* spacing between events and edges */
  padding: 1px 2px;
}

.fc-day-grid-event .fc-content { /* force events to be one-line tall */
  white-space: nowrap;
  overflow: hidden;
}

.fc-day-grid-event .fc-time {
  font-weight: bold;
}

.fc-day-grid-event .fc-resizer { /* enlarge the default hit area */
  left: -3px;
  right: -3px;
  width: 7px;
}

/* Event Limiting
--------------------------------------------------------------------------------------------------*/
/* "more" link that represents hidden events */
a.fc-more {
  margin: 1px 3px;
  font-size: 0.85em;
  cursor: pointer;
  text-decoration: none;
}

a.fc-more:hover {
  text-decoration: underline;
}

.fc-limited { /* rows and cells that are hidden because of a "more" link */
  display: none;
}

/* popover that appears when "more" link is clicked */
.fc-day-grid .fc-row {
  z-index: 1; /* make the "more" popover one higher than this */
}

.fc-more-popover {
  z-index: 2;
  width: 220px;
}

.fc-more-popover .fc-event-container {
  padding: 10px;
}

/* Toolbar
--------------------------------------------------------------------------------------------------*/
.fc-toolbar {
  text-align: center;
  margin-bottom: 1em;
}

.fc-toolbar .fc-left {
  float: left;
  min-width: 260px;
}

.fc-toolbar .fc-right {
  float: right;
}

.fc-toolbar .fc-center {
  display: inline-block;
}

/* the things within each left/right/center section */
.fc .fc-toolbar > * > * { /* extra precedence to override button border margins */
  float: left;
  margin-left: 0.75em;
}

/* the first thing within each left/center/right section */
.fc .fc-toolbar > * > :first-child { /* extra precedence to override button border margins */
  margin-left: 0;
}

/* title text */
.fc-toolbar h2 {
  margin: 0;
}

/* button layering (for border precedence) */
.fc-toolbar button {
  position: relative;
}

.fc-toolbar .fc-state-hover,
.fc-toolbar .ui-state-hover {
  z-index: 2;
}

.fc-toolbar .fc-state-down {
  z-index: 3;
}

.fc-toolbar .fc-state-active,
.fc-toolbar .ui-state-active {
  z-index: 4;
}

.fc-toolbar button:focus {
  z-index: 5;
}

/* View Structure
--------------------------------------------------------------------------------------------------*/
/* undo twitter bootstrap's box-sizing rules. normalizes positioning techniques */
/* don't do this for the toolbar because we'll want bootstrap to style those buttons as some pt */
.fc-view-container *,
.fc-view-container *:before,
.fc-view-container *:after {
  box-sizing: content-box;
}

.fc-view,
.fc-view > table { /* so dragged elements can be above the view's main element */
  position: relative;
  z-index: 1;
}

/* BasicView
--------------------------------------------------------------------------------------------------*/
/* day row structure */
.fc-basicWeek-view .fc-content-skeleton,
.fc-basicDay-view .fc-content-skeleton {
  /* we are sure there are no day numbers in these views, so... */
  padding-top: 1px; /* add a pixel to make sure there are 2px padding above events */
  padding-bottom: 1em; /* ensure a space at bottom of cell for user selecting/clicking */
}

.fc-basic-view .fc-body .fc-row {
  min-height: 4em; /* ensure that all rows are at least this tall */
}

/* a "rigid" row will take up a constant amount of height because content-skeleton is absolute */
.fc-row.fc-rigid {
  overflow: hidden;
}

.fc-row.fc-rigid .fc-content-skeleton {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}

/* week and day number styling */
.fc-basic-view .fc-week-number,
.fc-basic-view .fc-day-number {
  padding: 8px;
}

.fc-basic-view .fc-week-number {
  text-align: center;
}

.fc-basic-view .fc-week-number span {
  /* work around the way we do column resizing and ensure a minimum width */
  display: inline-block;
  min-width: 1.25em;
}

.fc-ltr .fc-basic-view .fc-day-number {
  float: right;
}

.fc-rtl .fc-basic-view .fc-day-number {
  text-align: left;
}

.fc-other-month .fc-day-number {
  opacity: 0.3;
  filter: alpha(opacity=30); /* for IE */
  /* opacity with small font can sometimes look too faded
     might want to set the 'color' property instead
     making day-numbers bold also fixes the problem */
}

/* AgendaView all-day area
--------------------------------------------------------------------------------------------------*/
.fc-agenda-view .fc-day-grid {
  position: relative;
  z-index: 2; /* so the "more.." popover will be over the time grid */
}

.fc-agenda-view .fc-day-grid .fc-row {
  min-height: 3em; /* all-day section will never get shorter than this */
}

.fc-agenda-view .fc-day-grid .fc-row .fc-content-skeleton {
  padding-top: 1px; /* add a pixel to make sure there are 2px padding above events */
  padding-bottom: 1em; /* give space underneath events for clicking/selecting days */
}

/* TimeGrid axis running down the side (for both the all-day area and the slot area)
--------------------------------------------------------------------------------------------------*/
.fc .fc-axis { /* .fc to overcome default cell styles */
  vertical-align: middle;
  padding: 0 4px;
  white-space: nowrap;
}

.fc-ltr .fc-axis {
  text-align: right;
}

.fc-rtl .fc-axis {
  text-align: left;
}

.ui-widget td.fc-axis {
  font-weight: normal; /* overcome jqui theme making it bold */
}

/* TimeGrid Structure
--------------------------------------------------------------------------------------------------*/
.fc-time-grid-container,
.fc-time-grid { /* so slats/bg/content/etc positions get scoped within here */
  position: relative;
  z-index: 1;
}

.fc-time-grid {
  min-height: 100%; /* so if height setting is 'auto', .fc-bg stretches to fill height */
}

.fc-time-grid table { /* don't put outer borders on slats/bg/content/etc */
  border: 0 hidden transparent;
}

.fc-time-grid > .fc-bg {
  z-index: 1;
}

.fc-time-grid .fc-slats,
.fc-time-grid > hr { /* the <hr> AgendaView injects when grid is shorter than scroller */
  position: relative;
  z-index: 2;
}

.fc-time-grid .fc-bgevent-skeleton,
.fc-time-grid .fc-content-skeleton {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}

.fc-time-grid .fc-bgevent-skeleton {
  z-index: 3;
}

.fc-time-grid .fc-highlight-skeleton {
  z-index: 4;
}

.fc-time-grid .fc-content-skeleton {
  z-index: 5;
}

.fc-time-grid .fc-helper-skeleton {
  z-index: 6;
}

/* TimeGrid Slats (lines that run horizontally)
--------------------------------------------------------------------------------------------------*/
.fc-time-grid .fc-slats td {
  height: 1.5em;
  border-bottom: 0; /* each cell is responsible for its top border */
}

.fc-time-grid .fc-slats .fc-minor td {
  border-top-style: dotted;
}

.fc-time-grid .fc-slats .ui-widget-content { /* for jqui theme */
  background: none; /* see through to fc-bg */
}

/* TimeGrid Highlighting Slots
--------------------------------------------------------------------------------------------------*/
.fc-time-grid .fc-highlight-container { /* a div within a cell within the fc-highlight-skeleton */
  position: relative; /* scopes the left/right of the fc-highlight to be in the column */
}

.fc-time-grid .fc-highlight {
  position: absolute;
  left: 0;
  right: 0;
  /* top and bottom will be in by JS */
}

/* TimeGrid Event Containment
--------------------------------------------------------------------------------------------------*/
.fc-time-grid .fc-event-container,
.fc-time-grid .fc-bgevent-container { /* a div within a cell within the fc-bgevent-skeleton */
  position: relative;
}

.fc-ltr .fc-time-grid .fc-event-container { /* space on the sides of events for LTR (default) */
  margin: 0 2.5% 0 2px;
}

.fc-rtl .fc-time-grid .fc-event-container { /* space on the sides of events for RTL */
  margin: 0 2px 0 2.5%;
}

.fc-time-grid .fc-event,
.fc-time-grid .fc-bgevent {
  position: absolute;
  z-index: 1; /* scope inner z-index's */
}

.fc-time-grid .fc-bgevent {
  /* background events always span full width */
  left: 0;
  right: 0;
}

/* Generic Vertical Event
--------------------------------------------------------------------------------------------------*/
.fc-v-event.fc-not-start { /* events that are continuing from another day */
  /* replace space made by the top border with padding */
  border-top-width: 0;
  padding-top: 1px;
  /* remove top rounded corners */
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.fc-v-event.fc-not-end {
  /* replace space made by the top border with padding */
  border-bottom-width: 0;
  padding-bottom: 1px;
  /* remove bottom rounded corners */
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

/* TimeGrid Event Styling
----------------------------------------------------------------------------------------------------
We use the full "fc-time-grid-event" class instead of using descendants because the event won't
be a descendant of the grid when it is being dragged.
*/
.fc-time-grid-event {
  overflow: hidden; /* don't let the bg flow over rounded corners */
}

.fc-time-grid-event .fc-time,
.fc-time-grid-event .fc-title {
  padding: 0 1px;
}

.fc-time-grid-event .fc-time {
  font-size: 0.85em;
  white-space: nowrap;
}

/* short mode, where time and title are on the same line */
.fc-time-grid-event.fc-short .fc-content {
  /* don't wrap to second line (now that contents will be inline) */
  white-space: nowrap;
}

.fc-time-grid-event.fc-short .fc-time,
.fc-time-grid-event.fc-short .fc-title {
  /* put the time and title on the same line */
  display: inline-block;
  vertical-align: top;
}

.fc-time-grid-event.fc-short .fc-time span {
  display: none; /* don't display the full time text... */
}

.fc-time-grid-event.fc-short .fc-time:before {
  content: attr(data-start); /* ...instead, display only the start time */
}

.fc-time-grid-event.fc-short .fc-time:after {
  content: " - "; /* seperate with a dash, wrapped in nbsp's */
}

.fc-time-grid-event.fc-short .fc-title {
  font-size: 0.85em; /* make the title text the same size as the time */
  padding: 0; /* undo padding from above */
}

/* resizer */
.fc-time-grid-event .fc-resizer {
  left: 0;
  right: 0;
  bottom: 0;
  height: 8px;
  overflow: hidden;
  line-height: 8px;
  font-size: 11px;
  font-family: monospace;
  text-align: center;
  cursor: s-resize;
}

.fc-time-grid-event .fc-resizer:after {
  content: "=";
}

.card-calendar .content {
  padding: 0 !important;
}
.card-calendar .fc-toolbar {
  padding-top: 15px;
  padding-left: 15px;
  padding-right: 15px;
}
.card-calendar .fc td:first-child {
  border-left: 0;
}
.card-calendar .fc td:last-child {
  border-right: 0;
}
.card-calendar .fc-basic-view td:last-child.fc-week-number span,
.card-calendar .fc-basic-view td:last-child.fc-day-number {
  padding-right: 15px;
}
.card-calendar .fc .fc-day-header:last-child {
  padding-right: 15px;
}
.card-calendar .fc .fc-row:last-child td {
  border-bottom: 0;
}
.card-calendar .fc .fc-body .fc-widget-content {
  border-bottom: 0;
}

.ct-label {
  fill: rgba(0, 0, 0, 0.4);
  color: rgba(0, 0, 0, 0.4);
  font-size: 1.3rem;
  line-height: 1;
}

.ct-chart-line .ct-label,
.ct-chart-bar .ct-label {
  display: block;
  display: flex;
}

.ct-label.ct-horizontal.ct-start {
  align-items: flex-end;
  justify-content: flex-start;
  text-align: left;
  text-anchor: start;
}

.ct-label.ct-horizontal.ct-end {
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
  text-anchor: start;
}

.ct-label.ct-vertical.ct-start {
  align-items: flex-end;
  justify-content: flex-end;
  text-align: right;
  text-anchor: end;
}

.ct-label.ct-vertical.ct-end {
  align-items: flex-end;
  justify-content: flex-start;
  text-align: left;
  text-anchor: start;
}

.ct-chart-bar .ct-label.ct-horizontal.ct-start {
  align-items: flex-end;
  justify-content: center;
  text-align: center;
  text-anchor: start;
}

.ct-chart-bar .ct-label.ct-horizontal.ct-end {
  align-items: flex-start;
  justify-content: center;
  text-align: center;
  text-anchor: start;
}

.ct-chart-bar.ct-horizontal-bars .ct-label.ct-horizontal.ct-start {
  align-items: flex-end;
  justify-content: flex-start;
  text-align: left;
  text-anchor: start;
}

.ct-chart-bar.ct-horizontal-bars .ct-label.ct-horizontal.ct-end {
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
  text-anchor: start;
}

.ct-chart-bar.ct-horizontal-bars .ct-label.ct-vertical.ct-start {
  align-items: center;
  justify-content: flex-end;
  text-align: right;
  text-anchor: end;
}

.ct-chart-bar.ct-horizontal-bars .ct-label.ct-vertical.ct-end {
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  text-anchor: end;
}

.ct-grid {
  stroke: rgba(0, 0, 0, 0.2);
  stroke-width: 1px;
  stroke-dasharray: 2px;
}

.ct-point {
  stroke-width: 8px;
  stroke-linecap: round;
}

.ct-line {
  fill: none;
  stroke-width: 3px;
}

.ct-area {
  stroke: none;
  fill-opacity: 0.8;
}

.ct-bar {
  fill: none;
  stroke-width: 10px;
}

.ct-slice-donut {
  fill: none;
  stroke-width: 60px;
}

.ct-series-a .ct-point, .ct-series-a .ct-line, .ct-series-a .ct-bar, .ct-series-a .ct-slice-donut {
  stroke: #1DC7EA;
}
.ct-series-a .ct-slice-pie, .ct-series-a .ct-area {
  fill: #1DC7EA;
}

.ct-series-b .ct-point, .ct-series-b .ct-line, .ct-series-b .ct-bar, .ct-series-b .ct-slice-donut {
  stroke: #FB404B;
}
.ct-series-b .ct-slice-pie, .ct-series-b .ct-area {
  fill: #FB404B;
}

.ct-series-c .ct-point, .ct-series-c .ct-line, .ct-series-c .ct-bar, .ct-series-c .ct-slice-donut {
  stroke: #FFA534;
}
.ct-series-c .ct-slice-pie, .ct-series-c .ct-area {
  fill: #FFA534;
}

.ct-series-d .ct-point, .ct-series-d .ct-line, .ct-series-d .ct-bar, .ct-series-d .ct-slice-donut {
  stroke: #9368E9;
}
.ct-series-d .ct-slice-pie, .ct-series-d .ct-area {
  fill: #9368E9;
}

.ct-series-e .ct-point, .ct-series-e .ct-line, .ct-series-e .ct-bar, .ct-series-e .ct-slice-donut {
  stroke: #87CB16;
}
.ct-series-e .ct-slice-pie, .ct-series-e .ct-area {
  fill: #87CB16;
}

.ct-series-f .ct-point, .ct-series-f .ct-line, .ct-series-f .ct-bar, .ct-series-f .ct-slice-donut {
  stroke: #1F77D0;
}
.ct-series-f .ct-slice-pie, .ct-series-f .ct-area {
  fill: #1F77D0;
}

.ct-series-g .ct-point, .ct-series-g .ct-line, .ct-series-g .ct-bar, .ct-series-g .ct-slice-donut {
  stroke: #5e5e5e;
}
.ct-series-g .ct-slice-pie, .ct-series-g .ct-area {
  fill: #5e5e5e;
}

.ct-series-h .ct-point, .ct-series-h .ct-line, .ct-series-h .ct-bar, .ct-series-h .ct-slice-donut {
  stroke: #dd4b39;
}
.ct-series-h .ct-slice-pie, .ct-series-h .ct-area {
  fill: #dd4b39;
}

.ct-series-i .ct-point, .ct-series-i .ct-line, .ct-series-i .ct-bar, .ct-series-i .ct-slice-donut {
  stroke: #35465c;
}
.ct-series-i .ct-slice-pie, .ct-series-i .ct-area {
  fill: #35465c;
}

.ct-series-j .ct-point, .ct-series-j .ct-line, .ct-series-j .ct-bar, .ct-series-j .ct-slice-donut {
  stroke: #e52d27;
}
.ct-series-j .ct-slice-pie, .ct-series-j .ct-area {
  fill: #e52d27;
}

.ct-series-k .ct-point, .ct-series-k .ct-line, .ct-series-k .ct-bar, .ct-series-k .ct-slice-donut {
  stroke: #55acee;
}
.ct-series-k .ct-slice-pie, .ct-series-k .ct-area {
  fill: #55acee;
}

.ct-series-l .ct-point, .ct-series-l .ct-line, .ct-series-l .ct-bar, .ct-series-l .ct-slice-donut {
  stroke: #cc2127;
}
.ct-series-l .ct-slice-pie, .ct-series-l .ct-area {
  fill: #cc2127;
}

.ct-series-m .ct-point, .ct-series-m .ct-line, .ct-series-m .ct-bar, .ct-series-m .ct-slice-donut {
  stroke: #1769ff;
}
.ct-series-m .ct-slice-pie, .ct-series-m .ct-area {
  fill: #1769ff;
}

.ct-series-n .ct-point, .ct-series-n .ct-line, .ct-series-n .ct-bar, .ct-series-n .ct-slice-donut {
  stroke: #6188e2;
}
.ct-series-n .ct-slice-pie, .ct-series-n .ct-area {
  fill: #6188e2;
}

.ct-series-o .ct-point, .ct-series-o .ct-line, .ct-series-o .ct-bar, .ct-series-o .ct-slice-donut {
  stroke: #a748ca;
}
.ct-series-o .ct-slice-pie, .ct-series-o .ct-area {
  fill: #a748ca;
}

.ct-square {
  display: block;
  position: relative;
  width: 100%;
}
.ct-square:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 100%;
}
.ct-square:after {
  content: "";
  display: table;
  clear: both;
}
.ct-square > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-minor-second {
  display: block;
  position: relative;
  width: 100%;
}
.ct-minor-second:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 93.75%;
}
.ct-minor-second:after {
  content: "";
  display: table;
  clear: both;
}
.ct-minor-second > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-second {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-second:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 88.8888888889%;
}
.ct-major-second:after {
  content: "";
  display: table;
  clear: both;
}
.ct-major-second > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-minor-third {
  display: block;
  position: relative;
  width: 100%;
}
.ct-minor-third:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 83.3333333333%;
}
.ct-minor-third:after {
  content: "";
  display: table;
  clear: both;
}
.ct-minor-third > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-third {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-third:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 80%;
}
.ct-major-third:after {
  content: "";
  display: table;
  clear: both;
}
.ct-major-third > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-perfect-fourth {
  display: block;
  position: relative;
  width: 100%;
}
.ct-perfect-fourth:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 75%;
}
.ct-perfect-fourth:after {
  content: "";
  display: table;
  clear: both;
}
.ct-perfect-fourth > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-perfect-fifth {
  display: block;
  position: relative;
  width: 100%;
}
.ct-perfect-fifth:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 66.6666666667%;
}
.ct-perfect-fifth:after {
  content: "";
  display: table;
  clear: both;
}
.ct-perfect-fifth > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-minor-sixth {
  display: block;
  position: relative;
  width: 100%;
}
.ct-minor-sixth:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 62.5%;
}
.ct-minor-sixth:after {
  content: "";
  display: table;
  clear: both;
}
.ct-minor-sixth > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-golden-section {
  display: block;
  position: relative;
  width: 100%;
}
.ct-golden-section:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 61.804697157%;
}
.ct-golden-section:after {
  content: "";
  display: table;
  clear: both;
}
.ct-golden-section > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-sixth {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-sixth:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 60%;
}
.ct-major-sixth:after {
  content: "";
  display: table;
  clear: both;
}
.ct-major-sixth > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-minor-seventh {
  display: block;
  position: relative;
  width: 100%;
}
.ct-minor-seventh:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 56.25%;
}
.ct-minor-seventh:after {
  content: "";
  display: table;
  clear: both;
}
.ct-minor-seventh > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-seventh {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-seventh:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 53.3333333333%;
}
.ct-major-seventh:after {
  content: "";
  display: table;
  clear: both;
}
.ct-major-seventh > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-octave {
  display: block;
  position: relative;
  width: 100%;
}
.ct-octave:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 50%;
}
.ct-octave:after {
  content: "";
  display: table;
  clear: both;
}
.ct-octave > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-tenth {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-tenth:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 40%;
}
.ct-major-tenth:after {
  content: "";
  display: table;
  clear: both;
}
.ct-major-tenth > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-eleventh {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-eleventh:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 37.5%;
}
.ct-major-eleventh:after {
  content: "";
  display: table;
  clear: both;
}
.ct-major-eleventh > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-twelfth {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-twelfth:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 33.3333333333%;
}
.ct-major-twelfth:after {
  content: "";
  display: table;
  clear: both;
}
.ct-major-twelfth > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-double-octave {
  display: block;
  position: relative;
  width: 100%;
}
.ct-double-octave:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 25%;
}
.ct-double-octave:after {
  content: "";
  display: table;
  clear: both;
}
.ct-double-octave > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-blue {
  stroke: #447DF7 !important;
}

.ct-azure {
  stroke: #23CCEF !important;
}

.ct-green {
  stroke: #275D38 !important;
}

.ct-orange {
  stroke: #FFA534 !important;
}

.ct-red {
  stroke: #FB404B !important;
}

/* perfect-scrollbar v0.6.10 */
.ps-container {
  touch-action: none;
  overflow: hidden !important;
  -ms-overflow-style: none;
}

@supports (-ms-overflow-style: none) {
  .ps-container {
    overflow: auto !important;
  }
}
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .ps-container {
    overflow: auto !important;
  }
}
.ps-container.ps-active-x > .ps-scrollbar-x-rail,
.ps-container.ps-active-y > .ps-scrollbar-y-rail {
  display: block;
  background-color: transparent;
}

.ps-container.ps-in-scrolling {
  pointer-events: none;
}

.ps-container.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail {
  background-color: #eee;
  opacity: 0.9;
}

.ps-container.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail > .ps-scrollbar-x {
  background-color: #999;
}

.ps-container.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail {
  background-color: #eee;
  opacity: 0.9;
}

.ps-container.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail > .ps-scrollbar-y {
  background-color: #999;
}

.ps-container > .ps-scrollbar-x-rail {
  display: none;
  position: absolute;
  /* please don't change 'position' */
  border-radius: 4px;
  opacity: 0;
  transition: background-color 0.2s linear, opacity 0.2s linear;
  bottom: 3px;
  /* there must be 'bottom' for ps-scrollbar-x-rail */
  height: 8px;
}

.ps-container > .ps-scrollbar-x-rail > .ps-scrollbar-x {
  position: absolute;
  /* please don't change 'position' */
  background-color: #aaa;
  border-radius: 4px;
  transition: background-color 0.2s linear;
  bottom: 0;
  /* there must be 'bottom' for ps-scrollbar-x */
  height: 8px;
}

.ps-container > .ps-scrollbar-y-rail {
  display: none;
  position: absolute;
  /* please don't change 'position' */
  border-radius: 4px;
  opacity: 0;
  transition: background-color 0.2s linear, opacity 0.2s linear;
  right: 3px;
  /* there must be 'right' for ps-scrollbar-y-rail */
  width: 8px;
}

.ps-container > .ps-scrollbar-y-rail > .ps-scrollbar-y {
  position: absolute;
  /* please don't change 'position' */
  background-color: #aaa;
  border-radius: 4px;
  transition: background-color 0.2s linear;
  right: 0;
  /* there must be 'right' for ps-scrollbar-y */
  width: 8px;
}

.ps-container:hover.ps-in-scrolling {
  pointer-events: none;
}

.ps-container:hover.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail {
  background-color: #eee;
  opacity: 0.9;
}

.ps-container:hover.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail > .ps-scrollbar-x {
  background-color: #999;
}

.ps-container:hover.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail {
  background-color: #eee;
  opacity: 0.9;
}

.ps-container:hover.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail > .ps-scrollbar-y {
  background-color: #999;
}

.ps-container:hover > .ps-scrollbar-x-rail,
.ps-container:hover > .ps-scrollbar-y-rail {
  opacity: 0.6;
}

.ps-container:hover > .ps-scrollbar-x-rail:hover {
  background-color: #eee;
  opacity: 0.9;
}

.ps-container:hover > .ps-scrollbar-x-rail:hover > .ps-scrollbar-x {
  background-color: #999;
}

.ps-container:hover > .ps-scrollbar-y-rail:hover {
  background-color: #eee;
  opacity: 0.9;
}

.ps-container:hover > .ps-scrollbar-y-rail:hover > .ps-scrollbar-y {
  background-color: #999;
}

/*!
 * Bootstrap-select v1.12.2 (http://silviomoreto.github.io/bootstrap-select)
 *
 * Copyright 2013-2017 bootstrap-select
 * Licensed under MIT (https://github.com/silviomoreto/bootstrap-select/blob/master/LICENSE)
 */
select.bs-select-hidden,
select.selectpicker {
  display: none !important;
}

.bootstrap-select {
  min-width: 100%;
}

.bootstrap-select > .dropdown-toggle {
  width: 100%;
  padding-right: 25px;
  z-index: 1;
  margin: 0;
}
.bootstrap-select > .dropdown-toggle:after {
  margin-left: -10px;
}

.bootstrap-select > select {
  position: absolute !important;
  bottom: 0;
  left: 50%;
  display: block !important;
  width: 0.5px !important;
  height: 100% !important;
  padding: 0 !important;
  opacity: 0 !important;
  border: none;
  border-top-left-radius: 3px !important;
  border-top-right-radius: 3px !important;
}

.bootstrap-select > select.mobile-device {
  top: 0;
  left: 0;
  display: block !important;
  width: 100% !important;
  z-index: 2;
}

.has-error .bootstrap-select .dropdown-toggle,
.error .bootstrap-select .dropdown-toggle {
  border-color: #b94a48;
}

.bootstrap-select.fit-width {
  width: auto !important;
}

.bootstrap-select:not([class*=col-]):not([class*=form-control]):not(.input-group-btn) {
  width: 100%;
}

.bootstrap-select.form-control {
  margin-bottom: 0;
  padding: 0;
  border: none;
}

.bootstrap-select.form-control:not([class*=col-]) {
  width: 100%;
}

.bootstrap-select.btn-block {
  width: 100%;
}

.bootstrap-select.form-control.input-group-btn {
  z-index: auto;
}

.bootstrap-select.form-control.input-group-btn:not(:first-child):not(:last-child) > .btn {
  border-radius: 0;
}

.bootstrap-select.btn-group:not(.input-group-btn),
.bootstrap-select.btn-group[class*=col-] {
  float: none;
  display: inline-block;
  margin-left: 0;
}

.bootstrap-select.btn-group.dropdown-menu-right,
.bootstrap-select.btn-group[class*=col-].dropdown-menu-right,
.row .bootstrap-select.btn-group[class*=col-].dropdown-menu-right {
  float: right;
}

.form-inline .bootstrap-select.btn-group,
.form-horizontal .bootstrap-select.btn-group,
.form-group .bootstrap-select.btn-group {
  margin-bottom: 0;
}

.form-group-lg .bootstrap-select.btn-group.form-control,
.form-group-sm .bootstrap-select.btn-group.form-control {
  padding: 0;
}

.form-group-lg .bootstrap-select.btn-group.form-control .dropdown-toggle,
.form-group-sm .bootstrap-select.btn-group.form-control .dropdown-toggle {
  height: 100%;
  font-size: inherit;
  line-height: inherit;
  border-radius: inherit;
}

.form-inline .bootstrap-select.btn-group .form-control {
  width: 100%;
}

.bootstrap-select.btn-group.disabled,
.bootstrap-select.btn-group > .disabled {
  cursor: not-allowed;
}

.bootstrap-select.btn-group.disabled:focus,
.bootstrap-select.btn-group > .disabled:focus {
  outline: none !important;
}

.bootstrap-select.btn-group.bs-container {
  position: absolute;
  height: 0 !important;
  padding: 0 !important;
}

.bootstrap-select.btn-group.bs-container .dropdown-menu {
  z-index: 1060;
}

.bootstrap-select.btn-group .dropdown-toggle .filter-option {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  text-align: left;
}

.bootstrap-select.btn-group .dropdown-toggle .caret {
  display: none;
}

.bootstrap-select.btn-group[class*=col-] .dropdown-toggle {
  width: 100%;
}

.bootstrap-select.btn-group .dropdown-menu {
  min-width: 100%;
  box-sizing: border-box;
  max-height: 400px !important;
}

.bootstrap-select.btn-group .dropdown-menu.inner {
  position: static;
  float: none;
  border: 0;
  padding: 0;
  margin: 0;
  display: block;
  max-height: 400px !important;
  overflow-y: scroll;
  -ms-overflow-style: auto;
  box-shadow: none;
}

.bootstrap-select.btn-group .dropdown-menu li {
  position: relative;
}

.bootstrap-select.btn-group .dropdown-menu li.active small {
  color: #fff;
}

.bootstrap-select.btn-group .dropdown-menu li.disabled a {
  cursor: not-allowed;
}

.bootstrap-select.btn-group .dropdown-menu li a {
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
}

.bootstrap-select.btn-group .dropdown-menu li a.opt {
  position: relative;
  padding-left: 2.25em;
}

.bootstrap-select.btn-group .dropdown-menu li a span.check-mark {
  display: none;
}

.bootstrap-select.btn-group .dropdown-menu li a span.text {
  display: inline-block;
}

.bootstrap-select.btn-group .dropdown-menu li small {
  padding-left: 0.5em;
}

.bootstrap-select.btn-group .dropdown-menu .notify {
  position: absolute;
  bottom: 5px;
  width: 96%;
  margin: 0 2%;
  min-height: 26px;
  padding: 3px 5px;
  background: #f5f5f5;
  border: 1px solid #e3e3e3;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
  pointer-events: none;
  opacity: 0.9;
  box-sizing: border-box;
}

.bootstrap-select.btn-group .no-results {
  padding: 3px;
  background: #f5f5f5;
  margin: 0 5px;
  white-space: nowrap;
}

.bootstrap-select.btn-group.fit-width .dropdown-toggle .filter-option {
  position: static;
}

.bootstrap-select.btn-group.fit-width .dropdown-toggle .caret {
  position: static;
  top: auto;
  margin-top: -1px;
}

.bootstrap-select.btn-group.show-tick .dropdown-menu li.selected a span.check-mark {
  position: absolute;
  display: inline-block;
  right: 20px;
  margin-top: 3px;
  color: black;
}

.bootstrap-select.btn-group.show-tick .dropdown-menu li a span.text {
  margin-right: 34px;
}

.bootstrap-select.show-menu-arrow.open > .dropdown-toggle {
  z-index: 1061;
}

.bootstrap-select.show-menu-arrow .dropdown-toggle:before {
  content: "";
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid rgba(204, 204, 204, 0.2);
  position: absolute;
  bottom: -4px;
  left: 9px;
  display: none;
}

.bootstrap-select.show-menu-arrow .dropdown-toggle:after {
  content: "";
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid white;
  position: absolute;
  bottom: -4px;
  left: 10px;
  display: none;
}

.bootstrap-select.show-menu-arrow.dropup .dropdown-toggle:before {
  bottom: auto;
  top: -3px;
  border-top: 7px solid rgba(204, 204, 204, 0.2);
  border-bottom: 0;
}

.bootstrap-select.show-menu-arrow.dropup .dropdown-toggle:after {
  bottom: auto;
  top: -3px;
  border-top: 6px solid white;
  border-bottom: 0;
}

.bootstrap-select.show-menu-arrow.pull-right .dropdown-toggle:before {
  right: 12px;
  left: auto;
}

.bootstrap-select.show-menu-arrow.pull-right .dropdown-toggle:after {
  right: 13px;
  left: auto;
}

.bootstrap-select.show-menu-arrow.open > .dropdown-toggle:before,
.bootstrap-select.show-menu-arrow.open > .dropdown-toggle:after {
  display: block;
}

.bs-searchbox,
.bs-actionsbox,
.bs-donebutton {
  padding: 4px 8px;
}

.bs-actionsbox {
  width: 100%;
  box-sizing: border-box;
}

.bs-actionsbox .btn-group button {
  width: 50%;
}

.bs-donebutton {
  float: left;
  width: 100%;
  box-sizing: border-box;
}

.bs-donebutton .btn-group button {
  width: 100%;
}

.bs-searchbox + .bs-actionsbox {
  padding: 0 8px 4px;
}

.bs-searchbox .form-control {
  margin-bottom: 0;
  width: 100%;
  float: none;
}

.bootstrap-select {
  margin-top: 5px;
}
.bootstrap-select .dropdown-menu.inner li a {
  display: block;
  padding: 8px 16px;
  clear: both;
  font-weight: 400;
  line-height: 1.42857143;
  color: #333;
  white-space: nowrap;
  outline: none;
  font-size: 14px;
}
.bootstrap-select .dropdown-menu.inner li.disabled a:hover, .bootstrap-select .dropdown-menu.inner li.disabled a:focus {
  background-color: transparent;
}
.bootstrap-select .dropdown-menu.inner li a:hover {
  background-color: #F5F5F5 !important;
  color: #333333 !important;
  opacity: 1;
  text-decoration: none;
}
.bootstrap-select .dropdown-menu.open {
  overflow: visible !important;
  display: none;
  visibility: hidden;
}
.bootstrap-select .dropdown-menu.open.show {
  display: block;
  visibility: visible;
}
.bootstrap-select .dropdown-menu.open[x-placement=top-start] {
  top: 0px !important;
}

.show .btn-info.dropdown-toggle {
  background-color: #23CCEF;
  border-color: #23CCEF;
}

/*!
 * Datetimepicker for Bootstrap 3
 * ! version : 4.7.14
 * https://github.com/Eonasdan/bootstrap-datetimepicker/
 */
.sr-only, .bootstrap-datetimepicker-widget table th.next::after, .bootstrap-datetimepicker-widget table th.prev::after, .bootstrap-datetimepicker-widget .picker-switch::after, .bootstrap-datetimepicker-widget .btn[data-action=today]::after, .bootstrap-datetimepicker-widget .btn[data-action=clear]::after, .bootstrap-datetimepicker-widget .btn[data-action=togglePeriod]::after, .bootstrap-datetimepicker-widget .btn[data-action=showMinutes]::after, .bootstrap-datetimepicker-widget .btn[data-action=showHours]::after, .bootstrap-datetimepicker-widget .btn[data-action=decrementMinutes]::after, .bootstrap-datetimepicker-widget .btn[data-action=decrementHours]::after, .bootstrap-datetimepicker-widget .btn[data-action=incrementMinutes]::after, .bootstrap-datetimepicker-widget .btn[data-action=incrementHours]::after {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.bootstrap-datetimepicker-widget {
  list-style: none;
}
.bootstrap-datetimepicker-widget.dropdown-menu {
  padding: 4px;
  width: 19em;
}
@media (min-width: 768px) {
  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {
    width: 38em;
  }
}
@media (min-width: 992px) {
  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {
    width: 38em;
  }
}
@media (min-width: 1200px) {
  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {
    width: 38em;
  }
}
.bootstrap-datetimepicker-widget.dropdown-menu.bottom:before {
  border-bottom: 11px solid rgba(0, 0, 0, 0.2);
  border-left: 11px solid rgba(0, 0, 0, 0);
  border-right: 11px solid rgba(0, 0, 0, 0);
  content: "";
  display: inline-block;
  position: absolute;
  left: 12px;
  top: -11px;
}
.bootstrap-datetimepicker-widget.dropdown-menu.bottom:after {
  border-bottom: 11px solid #FFFFFF;
  border-left: 11px solid rgba(0, 0, 0, 0);
  border-right: 11px solid rgba(0, 0, 0, 0);
  content: "";
  display: inline-block;
  position: absolute;
  left: 12px;
  top: -10px;
}
.bootstrap-datetimepicker-widget.dropdown-menu.top {
  margin-top: auto;
  margin-bottom: -20px;
}
.bootstrap-datetimepicker-widget.dropdown-menu.top.open {
  margin-top: auto;
  margin-bottom: 5px;
}
.bootstrap-datetimepicker-widget.dropdown-menu.top:before {
  border-top: 11px solid rgba(0, 0, 0, 0.2);
  border-left: 11px solid rgba(0, 0, 0, 0);
  border-right: 11px solid rgba(0, 0, 0, 0);
  border-bottom: none;
  content: "";
  display: inline-block;
  position: absolute;
  left: 12px;
  bottom: -11px;
  top: auto;
}
.bootstrap-datetimepicker-widget.dropdown-menu.top:after {
  border-top: 11px solid #FFFFFF;
  border-left: 11px solid rgba(0, 0, 0, 0);
  border-right: 11px solid rgba(0, 0, 0, 0);
  border-bottom: none;
  content: "";
  display: inline-block;
  position: absolute;
  left: 12px;
  bottom: -10px;
  top: auto;
}
.bootstrap-datetimepicker-widget.dropdown-menu.pull-right:before {
  left: auto;
  right: 6px;
}
.bootstrap-datetimepicker-widget.dropdown-menu.pull-right:after {
  left: auto;
  right: 7px;
}
.bootstrap-datetimepicker-widget.dropdown-menu.open {
  visibility: visible !important;
  opacity: 1 !important;
  top: 120px !important;
  font-size: 14px !important;
}
.bootstrap-datetimepicker-widget .list-unstyled {
  margin: 0;
}
.bootstrap-datetimepicker-widget a[data-action] {
  padding: 6px 0;
  border-width: 0;
}
.bootstrap-datetimepicker-widget a[data-action]:active {
  box-shadow: none;
}
.bootstrap-datetimepicker-widget .timepicker-hour, .bootstrap-datetimepicker-widget .timepicker-minute, .bootstrap-datetimepicker-widget .timepicker-second {
  width: 56px;
  height: 56px;
  font-weight: 300;
  font-size: 1.375rem;
  margin: 3px;
  border-radius: 50%;
}
.bootstrap-datetimepicker-widget button[data-action] {
  padding: 6px;
}
.bootstrap-datetimepicker-widget .btn[data-action=incrementHours]::after {
  content: "Increment Hours";
}
.bootstrap-datetimepicker-widget .btn[data-action=incrementMinutes]::after {
  content: "Increment Minutes";
}
.bootstrap-datetimepicker-widget .btn[data-action=decrementHours]::after {
  content: "Decrement Hours";
}
.bootstrap-datetimepicker-widget .btn[data-action=decrementMinutes]::after {
  content: "Decrement Minutes";
}
.bootstrap-datetimepicker-widget .btn[data-action=showHours]::after {
  content: "Show Hours";
}
.bootstrap-datetimepicker-widget .btn[data-action=showMinutes]::after {
  content: "Show Minutes";
}
.bootstrap-datetimepicker-widget .btn[data-action=togglePeriod]::after {
  content: "Toggle AM/PM";
}
.bootstrap-datetimepicker-widget .btn[data-action=clear]::after {
  content: "Clear the picker";
}
.bootstrap-datetimepicker-widget .btn[data-action=today]::after {
  content: "Set the date to today";
}
.bootstrap-datetimepicker-widget .picker-switch {
  text-align: center;
  border-radius: 4px;
  font-size: 14px;
}
.bootstrap-datetimepicker-widget .picker-switch::after {
  content: "Toggle Date and Time Screens";
}
.bootstrap-datetimepicker-widget .picker-switch td {
  padding: 0;
  margin: 0;
  height: auto;
  width: auto;
  line-height: inherit;
}
.bootstrap-datetimepicker-widget .picker-switch td span {
  line-height: 2.5;
  height: 2.5em;
  width: 100%;
  border-radius: 4px;
  margin: 2px 0px !important;
}
.bootstrap-datetimepicker-widget .picker-switch td a,
.bootstrap-datetimepicker-widget .picker-switch td a:hover {
  color: #23CCEF;
}
.bootstrap-datetimepicker-widget table {
  width: 100%;
  margin: 0;
}
.bootstrap-datetimepicker-widget table td > div, .bootstrap-datetimepicker-widget table th > div {
  text-align: center;
}
.bootstrap-datetimepicker-widget table th {
  height: 20px;
  line-height: 20px;
  width: 20px;
}
.bootstrap-datetimepicker-widget table th.picker-switch {
  width: 145px;
}
.bootstrap-datetimepicker-widget table th.disabled, .bootstrap-datetimepicker-widget table th.disabled:hover {
  background: none;
  color: #DDDDDD;
  cursor: not-allowed;
}
.bootstrap-datetimepicker-widget table th.prev span, .bootstrap-datetimepicker-widget table th.next span {
  border-radius: 4px;
  height: 27px;
  width: 27px;
  line-height: 28px;
  font-size: 12px;
  border-radius: 50%;
  text-align: center;
}
.bootstrap-datetimepicker-widget table th.prev::after {
  content: "Previous Month";
}
.bootstrap-datetimepicker-widget table th.next::after {
  content: "Next Month";
}
.bootstrap-datetimepicker-widget table th.dow {
  text-align: center;
  border-bottom: 1px solid #E3E3E3;
  font-size: 0.75rem;
  text-transform: uppercase;
  color: #9A9A9A;
  font-weight: 400;
  padding-bottom: 5px;
  padding-top: 10px;
}
.bootstrap-datetimepicker-widget table thead tr:first-child th {
  cursor: pointer;
}
.bootstrap-datetimepicker-widget table thead tr:first-child th:hover span, .bootstrap-datetimepicker-widget table thead tr:first-child th.picker-switch:hover {
  background: #E3E3E3;
}
.bootstrap-datetimepicker-widget table td > div {
  border-radius: 4px;
  height: 54px;
  line-height: 54px;
  width: 54px;
  text-align: center;
}
.bootstrap-datetimepicker-widget table td.cw > div {
  font-size: 0.8em;
  height: 20px;
  line-height: 20px;
  color: #DDDDDD;
}
.bootstrap-datetimepicker-widget table td.day > div {
  height: 30px;
  line-height: 30px;
  width: 30px;
  text-align: center;
  padding: 0px;
  border-radius: 50%;
  margin: 0 auto;
  z-index: -1;
  position: relative;
}
.bootstrap-datetimepicker-widget table td.minute > div, .bootstrap-datetimepicker-widget table td.hour > div {
  border-radius: 50%;
}
.bootstrap-datetimepicker-widget table td.day:hover > div, .bootstrap-datetimepicker-widget table td.hour:hover > div, .bootstrap-datetimepicker-widget table td.minute:hover > div, .bootstrap-datetimepicker-widget table td.second:hover > div {
  background: #E3E3E3;
  cursor: pointer;
}
.bootstrap-datetimepicker-widget table td.old > div, .bootstrap-datetimepicker-widget table td.new > div {
  color: #DDDDDD;
}
.bootstrap-datetimepicker-widget table td.today > div {
  position: relative;
}
.bootstrap-datetimepicker-widget table td.today > div:before {
  content: "";
  display: inline-block;
  border: 0 0 7px 7px solid transparent;
  border-bottom-color: #23CCEF;
  border-top-color: rgba(0, 0, 0, 0.2);
  position: absolute;
  bottom: 4px;
  right: 4px;
}
.bootstrap-datetimepicker-widget table td.active > div, .bootstrap-datetimepicker-widget table td.active:hover > div {
  background-color: #23CCEF;
  color: #FFFFFF;
}
.bootstrap-datetimepicker-widget table td.active.today:before > div {
  border-bottom-color: #fff;
}
.bootstrap-datetimepicker-widget table td.disabled > div, .bootstrap-datetimepicker-widget table td.disabled:hover > div {
  background: none;
  color: #DDDDDD;
  cursor: not-allowed;
}
.bootstrap-datetimepicker-widget table td span {
  display: inline-block;
  width: 56px;
  height: 56px;
  line-height: 56px;
  margin: 3px 3px;
  cursor: pointer;
  border-radius: 50%;
  text-align: center;
}
.bootstrap-datetimepicker-widget table td span:hover {
  background: #E3E3E3;
}
.bootstrap-datetimepicker-widget table td span.active {
  background-color: #23CCEF;
  color: #FFFFFF;
}
.bootstrap-datetimepicker-widget table td span.old {
  color: #DDDDDD;
}
.bootstrap-datetimepicker-widget table td span.disabled, .bootstrap-datetimepicker-widget table td span.disabled:hover {
  background: none;
  color: #DDDDDD;
  cursor: not-allowed;
}
.bootstrap-datetimepicker-widget .timepicker-picker span,
.bootstrap-datetimepicker-widget .timepicker-hours span,
.bootstrap-datetimepicker-widget .timepicker-minutes span {
  border-radius: 50% !important;
}
.bootstrap-datetimepicker-widget .timepicker-picker .table-condensed td a,
.bootstrap-datetimepicker-widget .timepicker-hours .table-condensed td a,
.bootstrap-datetimepicker-widget .timepicker-minutes .table-condensed td a {
  color: #888888;
  background-color: transparent;
}
.bootstrap-datetimepicker-widget.usetwentyfour td.hour {
  height: 27px;
  line-height: 27px;
}

.input-group.date .input-group-addon {
  cursor: pointer;
}

.table-condensed > tbody > tr > td,
.table-condensed > tbody > tr > th,
.table-condensed > tfoot > tr > td,
.table-condensed > tfoot > tr > th,
.table-condensed > thead > tr > td,
.table-condensed > thead > tr > th {
  padding: 1px;
}

.bootstrap-datetimepicker-widget {
  opacity: 0;
  transform: translate3d(0px, -10px, 0px);
}
.bootstrap-datetimepicker-widget.top {
  transform: translate3d(0px, 0px, 0px);
}
.bootstrap-datetimepicker-widget.open {
  opacity: 1;
  transform: translate3d(0, 5px, 0);
  transition: transform 0.5s cubic-bezier(0.215, 0.61, 0.355, 1) 0s;
}

.bootstrap-datetimepicker-widget.dropdown-menu.top {
  top: auto !important;
}

.bootstrap-datetimepicker-widget.open.top {
  transform: translate3d(0, -10px, 0);
}
.bootstrap-datetimepicker-widget.open.top:before {
  border-top: 11px solid #DCD9D1;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  left: 12px;
  bottom: -12px;
}
.bootstrap-datetimepicker-widget.open.top:after {
  border-top: 11px solid #FFFFFF;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  left: 12px;
  bottom: -11px;
}

/*! nouislider - 9.1.0 - 2016-12-10 16:00:32 */
/* Functional styling;
 * These styles are required for noUiSlider to function.
 * You don't need to change these rules to apply your design.
 */
.noUi-target,
.noUi-target * {
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-user-select: none;
  touch-action: none;
  user-select: none;
  box-sizing: border-box;
}

.noUi-target {
  position: relative;
  direction: ltr;
}

.noUi-base {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1; /* Fix 401 */
}

.noUi-connect {
  position: absolute;
  right: 0;
  top: 0;
  left: 0;
  bottom: 0;
}

.noUi-origin {
  position: absolute;
  height: 0;
  width: 0;
}

.noUi-handle {
  position: relative;
  z-index: 1;
}

.noUi-state-tap .noUi-connect,
.noUi-state-tap .noUi-origin {
  transition: top 0.3s, right 0.3s, bottom 0.3s, left 0.3s;
}

.noUi-state-drag * {
  cursor: inherit !important;
}

/* Painting and performance;
 * Browsers can paint handles in their own layer.
 */
.noUi-base,
.noUi-handle {
  transform: translate3d(0, 0, 0);
}

/* Slider size and handle placement;
 */
.noUi-horizontal {
  height: 4px;
}

.noUi-horizontal .noUi-handle {
  border-radius: 50%;
  background-color: #FFFFFF;
  box-shadow: 0 1px 13px 0 rgba(0, 0, 0, 0.2);
  height: 15px;
  width: 15px;
  cursor: pointer;
  margin-left: -10px;
  margin-top: -6px;
  outline: none;
}

.noUi-vertical {
  width: 18px;
}

.noUi-vertical .noUi-handle {
  width: 28px;
  height: 34px;
  left: -6px;
  top: -17px;
}

/* Styling;
 */
.noUi-target {
  background-color: rgba(182, 182, 182, 0.3);
  border-radius: 3px;
}

.noUi-connect {
  background: #888888;
  border-radius: 3px;
  transition: background 450ms;
}

/* Handles and cursors;
 */
.noUi-draggable {
  cursor: ew-resize;
}

.noUi-vertical .noUi-draggable {
  cursor: ns-resize;
}

.noUi-handle {
  border-radius: 3px;
  background: #FFF;
  cursor: default;
  box-shadow: inset 0 0 1px #FFF, inset 0 1px 7px #EBEBEB, 0 3px 6px -3px #BBB;
  -webkit-transition: 300ms ease 0s;
  -moz-transition: 300ms ease 0s;
  -ms-transition: 300ms ease 0s;
  -o-transform: 300ms ease 0s;
  transition: 300ms ease 0s;
}

.noUi-active {
  transform: scale3d(1.5, 1.5, 1);
}

/* Disabled state;
 */
[disabled] .noUi-connect {
  background: #B8B8B8;
}

[disabled].noUi-target,
[disabled].noUi-handle,
[disabled] .noUi-handle {
  cursor: not-allowed;
}

/* Base;
 *
 */
.noUi-pips,
.noUi-pips * {
  box-sizing: border-box;
}

.noUi-pips {
  position: absolute;
  color: #999;
}

/* Values;
 *
 */
.noUi-value {
  position: absolute;
  text-align: center;
}

.noUi-value-sub {
  color: #ccc;
  font-size: 10px;
}

/* Markings;
 *
 */
.noUi-marker {
  position: absolute;
  background: #CCC;
}

.noUi-marker-sub {
  background: #AAA;
}

.noUi-marker-large {
  background: #AAA;
}

/* Horizontal layout;
 *
 */
.noUi-pips-horizontal {
  padding: 10px 0;
  height: 80px;
  top: 100%;
  left: 0;
  width: 100%;
}

.noUi-value-horizontal {
  transform: translate3d(-50%, 50%, 0);
}

.noUi-marker-horizontal.noUi-marker {
  margin-left: -1px;
  width: 2px;
  height: 5px;
}

.noUi-marker-horizontal.noUi-marker-sub {
  height: 10px;
}

.noUi-marker-horizontal.noUi-marker-large {
  height: 15px;
}

/* Vertical layout;
 *
 */
.noUi-pips-vertical {
  padding: 0 10px;
  height: 100%;
  top: 0;
  left: 100%;
}

.noUi-value-vertical {
  transform: translate3d(0, 50%, 0);
  padding-left: 25px;
}

.noUi-marker-vertical.noUi-marker {
  width: 5px;
  height: 2px;
  margin-top: -1px;
}

.noUi-marker-vertical.noUi-marker-sub {
  width: 10px;
}

.noUi-marker-vertical.noUi-marker-large {
  width: 15px;
}

.noUi-tooltip {
  display: block;
  position: absolute;
  border: 1px solid #D9D9D9;
  border-radius: 3px;
  background: #fff;
  color: #000;
  padding: 5px;
  text-align: center;
}

.noUi-horizontal .noUi-tooltip {
  transform: translate(-50%, 0);
  left: 50%;
  bottom: 120%;
}

.noUi-vertical .noUi-tooltip {
  transform: translate(0, -50%);
  top: 50%;
  right: 120%;
}

.slider-neutral .noUi-connect, .slider-neutral.noUi-connect {
  background-color: #FFFFFF;
}

.slider-primary .noUi-connect, .slider-primary.noUi-connect {
  background-color: #447DF7;
}

.slider-info .noUi-connect, .slider-info.noUi-connect {
  background-color: #23CCEF;
}

.slider-success .noUi-connect, .slider-success.noUi-connect {
  background-color: #275D38;
}

.slider-warning .noUi-connect, .slider-warning.noUi-connect {
  background-color: #FFA534;
}

.slider-danger .noUi-connect, .slider-danger.noUi-connect {
  background-color: #FB404B;
}

/*! nouislider - 14.6.3 - 11/19/2020 */
/* Functional styling;
 * These styles are required for noUiSlider to function.
 * You don't need to change these rules to apply your design.
 */
.noUi-target,
.noUi-target * {
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-user-select: none;
  touch-action: none;
  user-select: none;
  box-sizing: border-box;
}

.noUi-target {
  position: relative;
}

.noUi-base,
.noUi-connects {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
}

/* Wrapper for all connect elements.
 */
.noUi-connects {
  overflow: hidden;
  z-index: 0;
}

.noUi-connect,
.noUi-origin {
  will-change: transform;
  position: absolute;
  z-index: 1;
  top: 0;
  right: 0;
  -ms-transform-origin: 0 0;
  -webkit-transform-origin: 0 0;
  -webkit-transform-style: preserve-3d;
  transform-origin: 0 0;
  transform-style: flat;
}

.noUi-connect {
  height: 100%;
  width: 100%;
}

.noUi-origin {
  height: 10%;
  width: 10%;
}

/* Offset direction
 */
.noUi-txt-dir-rtl.noUi-horizontal .noUi-origin {
  left: 0;
  right: auto;
}

/* Give origins 0 height/width so they don't interfere with clicking the
 * connect elements.
 */
.noUi-vertical .noUi-origin {
  width: 0;
}

.noUi-horizontal .noUi-origin {
  height: 0;
}

.noUi-handle {
  backface-visibility: hidden;
  position: absolute;
}

.noUi-touch-area {
  height: 100%;
  width: 100%;
}

.noUi-state-tap .noUi-connect,
.noUi-state-tap .noUi-origin {
  transition: transform 0.3s;
}

.noUi-state-drag * {
  cursor: inherit !important;
}

/* Slider size and handle placement;
 */
.noUi-horizontal {
  height: 4px;
}

.noUi-horizontal .noUi-handle {
  width: 15px;
  height: 15px;
  right: -10px;
  top: 0px;
}

.noUi-vertical {
  width: 18px;
}

.noUi-vertical .noUi-handle {
  width: 15px;
  height: 15px;
  right: -6px;
  top: -17px;
}

.noUi-txt-dir-rtl.noUi-horizontal .noUi-handle {
  left: -17px;
  right: auto;
}

/* Styling;
 * Giving the connect element a border radius causes issues with using transform: scale
 */
.noUi-target {
  background: #FAFAFA;
  border-radius: 4px;
}

.noUi-connects {
  border-radius: 3px;
}

.noUi-connect {
  background: #3FB8AF;
}

/* Handles and cursors;
 */
.noUi-draggable {
  cursor: ew-resize;
}

.noUi-vertical .noUi-draggable {
  cursor: ns-resize;
}

.noUi-handle {
  box-shadow: 0 1px 13px 0 rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  background: #FFF;
  cursor: default;
  transition: 300ms ease 0s;
}

/* Handle stripes;
 */
/* Disabled state;
 */
[disabled] .noUi-connect {
  background: #B8B8B8;
}

[disabled].noUi-target,
[disabled].noUi-handle,
[disabled] .noUi-handle {
  cursor: not-allowed;
}

/* Base;
 *
 */
.noUi-pips,
.noUi-pips * {
  box-sizing: border-box;
}

.noUi-pips {
  position: absolute;
  color: #999;
}

/* Values;
 *
 */
.noUi-value {
  position: absolute;
  white-space: nowrap;
  text-align: center;
}

.noUi-value-sub {
  color: #ccc;
  font-size: 10px;
}

/* Markings;
 *
 */
.noUi-marker {
  position: absolute;
  background: #CCC;
}

.noUi-marker-sub {
  background: #AAA;
}

.noUi-marker-large {
  background: #AAA;
}

/* Horizontal layout;
 *
 */
.noUi-pips-horizontal {
  padding: 10px 0;
  height: 80px;
  top: 100%;
  left: 0;
  width: 100%;
}

.noUi-value-horizontal {
  transform: translate(-50%, 50%);
}

.noUi-rtl .noUi-value-horizontal {
  transform: translate(50%, 50%);
}

.noUi-marker-horizontal.noUi-marker {
  margin-left: -1px;
  width: 2px;
  height: 5px;
}

.noUi-marker-horizontal.noUi-marker-sub {
  height: 10px;
}

.noUi-marker-horizontal.noUi-marker-large {
  height: 15px;
}

/* Vertical layout;
 *
 */
.noUi-pips-vertical {
  padding: 0 10px;
  height: 100%;
  top: 0;
  left: 100%;
}

.noUi-value-vertical {
  transform: translate(0, -50%);
  padding-left: 25px;
}

.noUi-rtl .noUi-value-vertical {
  transform: translate(0, 50%);
}

.noUi-marker-vertical.noUi-marker {
  width: 5px;
  height: 2px;
  margin-top: -1px;
}

.noUi-marker-vertical.noUi-marker-sub {
  width: 10px;
}

.noUi-marker-vertical.noUi-marker-large {
  width: 15px;
}

.noUi-tooltip {
  display: block;
  position: absolute;
  border: 1px solid #D9D9D9;
  border-radius: 3px;
  background: #fff;
  color: #000;
  padding: 5px;
  text-align: center;
  white-space: nowrap;
}

.noUi-horizontal .noUi-tooltip {
  transform: translate(-50%, 0);
  left: 50%;
  bottom: 120%;
}

.noUi-vertical .noUi-tooltip {
  transform: translate(0, -50%);
  top: 50%;
  right: 120%;
}

.noUi-horizontal .noUi-origin > .noUi-tooltip {
  transform: translate(50%, 0);
  left: auto;
  bottom: 10px;
}

.noUi-vertical .noUi-origin > .noUi-tooltip {
  transform: translate(0, -18px);
  top: auto;
  right: 28px;
}

.noUi-active {
  transform: scale3d(1.5, 1.5, 1);
}

.slider-primary .noUi-connect {
  background: #447DF7;
}

.slider-info .noUi-connect {
  background: #23CCEF;
}

.slider-success .noUi-connect {
  background: #275D38;
}

.slider-warning .noUi-connect {
  background: #FFA534;
}

.slider-danger .noUi-connect {
  background: #FB404B;
}

.rbc-btn {
  color: inherit;
  font: inherit;
  margin: 0;
}

button.rbc-btn {
  overflow: visible;
  text-transform: none;
  -webkit-appearance: button;
  cursor: pointer;
}

button[disabled].rbc-btn {
  cursor: not-allowed;
}

button.rbc-input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

.rbc-calendar {
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.rbc-calendar *,
.rbc-calendar *:before,
.rbc-calendar *:after {
  box-sizing: inherit;
}

.rbc-abs-full,
.rbc-row-bg {
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.rbc-ellipsis,
.rbc-event-label,
.rbc-row-segment .rbc-event-content,
.rbc-show-more {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rbc-rtl {
  direction: rtl;
}

.rbc-off-range {
  color: #333333;
  opacity: 0.3;
}

.rbc-header {
  overflow: hidden;
  flex: 1 0;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 3px;
  text-align: right;
  vertical-align: middle;
  font-size: 0.875em;
  min-height: 0;
  border-bottom: 1px solid #DDD;
  color: #999999;
  font-weight: 400;
}
.rbc-header:last-child span {
  padding-right: 15px;
}

.rbc-header > a,
.rbc-header > a:active,
.rbc-header > a:visited {
  color: inherit;
  text-decoration: none;
}

.rbc-row-content {
  position: relative;
  user-select: none;
  -webkit-user-select: none;
  z-index: 4;
  min-height: 153px;
}

.rbc-toolbar {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-size: 16px;
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
}

.rbc-toolbar .rbc-toolbar-label {
  flex-grow: 1;
  padding: 0 10px;
  text-align: center;
  font-family: inherit;
  line-height: 1.5em;
  color: inherit;
  font-weight: 300;
  margin: 0;
  font-size: 2.25em;
}

.rbc-toolbar button {
  display: inline-block;
  margin: 0;
  text-align: center;
  vertical-align: middle;
  background: none;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 4px;
  line-height: normal;
  white-space: nowrap;
  border-width: 1px;
  background-color: transparent;
  font-weight: 400;
  padding: 8px 16px;
  border-color: #888;
  color: #888;
  font-family: inherit;
  font-size: inherit;
  font: inherit;
}

.rbc-toolbar button:focus {
  outline: none;
}

.rbc-toolbar button.rbc-active, .rbc-toolbar button.rbc-active:hover {
  border-color: #888;
  background-color: #888;
  color: #fff;
}

.rbc-toolbar button:hover {
  color: #373a3c;
  background-color: #e6e6e6;
  border-color: #adadad;
}

.rbc-btn-group {
  display: inline-block;
  white-space: nowrap;
}

.rbc-btn-group > button:first-child:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.rbc-btn-group > button:last-child:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.rbc-rtl .rbc-btn-group > button:first-child:not(:last-child) {
  border-radius: 4px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.rbc-rtl .rbc-btn-group > button:last-child:not(:first-child) {
  border-radius: 4px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.rbc-btn-group > button:not(:first-child):not(:last-child) {
  border-radius: 0;
}

.rbc-btn-group button + button {
  margin-left: -1px;
}

.rbc-rtl .rbc-btn-group button + button {
  margin-left: 0;
  margin-right: -1px;
}

.rbc-btn-group + .rbc-btn-group,
.rbc-btn-group + button {
  margin-left: 10px;
}

.rbc-slot-selecting .rbc-event {
  cursor: inherit;
  pointer-events: none;
}

.rbc-event.rbc-selected {
  background-color: #265985;
}

.rbc-event-label {
  font-size: 80%;
}

.rbc-event-overlaps {
  box-shadow: -1px 1px 5px 0px rgba(51, 51, 51, 0.5);
}

.rbc-event-continues-prior {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.rbc-event-continues-after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.rbc-event-continues-earlier {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.rbc-event-continues-later {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.rbc-event-continues-day-after {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.rbc-event-continues-day-prior {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.rbc-row {
  display: flex;
  flex-direction: row;
}

.rbc-row-segment {
  padding: 2px 6px 1px;
}

.rbc-selected-cell {
  background-color: rgba(0, 0, 0, 0.1);
}

.rbc-show-more {
  background-color: rgba(255, 255, 255, 0.3);
  z-index: 4;
  font-weight: bold;
  font-size: 85%;
  height: auto;
  line-height: normal;
  white-space: nowrap;
}

.rbc-month-view {
  position: relative;
  border: 1px solid #DDD;
  border-bottom: 0px;
  display: flex;
  flex-direction: column;
  flex: 1 0;
  width: 100%;
  user-select: none;
  -webkit-user-select: none;
  height: 100%;
  border-left: none;
  border-right: none;
}

.rbc-month-view {
  border-top: none;
}

.rbc-month-header {
  display: flex;
  flex-direction: row;
}

.rbc-month-row {
  display: flex;
  position: relative;
  flex-direction: column;
  flex: 1 0;
  -ms-flex-preferred-size: 0px;
  overflow: hidden;
  height: 100%;
}

.rbc-month-row + .rbc-month-row {
  border-top: 1px solid #DDD;
}

.rbc-date-cell {
  flex: 1 1;
  min-width: 0;
  padding-left: 5px;
  text-align: left;
}

.rbc-date-cell.rbc-now {
  font-weight: bold;
}

.rbc-date-cell > a,
.rbc-date-cell > a:active,
.rbc-date-cell > a:visited {
  color: inherit;
  text-decoration: none;
}

.rbc-row-bg {
  display: flex;
  flex-direction: row;
  flex: 1 0;
  overflow: hidden;
}

.rbc-day-bg {
  flex: 1 0;
}

.rbc-day-bg + .rbc-day-bg {
  border-left: 1px solid #DDD;
}

.rbc-rtl .rbc-day-bg + .rbc-day-bg {
  border-left-width: 0;
  border-right: 1px solid #DDD;
}

.rbc-overlay {
  position: absolute;
  z-index: 5;
  border: 1px solid #e5e5e5;
  background-color: #fff;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);
  padding: 10px;
}

.rbc-overlay > * + * {
  margin-top: 1px;
}

.rbc-overlay-header {
  border-bottom: 1px solid #e5e5e5;
  margin: -10px -10px 5px -10px;
  padding: 2px 10px;
}

.rbc-agenda-view {
  display: flex;
  flex-direction: column;
  flex: 1 0;
  overflow: auto;
}

.rbc-agenda-view table.rbc-agenda-table {
  width: 100%;
  border: 1px solid #DDD;
  border-spacing: 0;
  border-collapse: collapse;
}

.rbc-agenda-view table.rbc-agenda-table tbody > tr > td {
  padding: 5px 10px;
  vertical-align: top;
}

.rbc-agenda-view table.rbc-agenda-table .rbc-agenda-time-cell {
  padding-left: 15px;
  padding-right: 15px;
  text-transform: lowercase;
}

.rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {
  border-left: 1px solid #DDD;
}

.rbc-rtl .rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {
  border-left-width: 0;
  border-right: 1px solid #DDD;
}

.rbc-agenda-view table.rbc-agenda-table tbody > tr + tr {
  border-top: 1px solid #DDD;
}

.rbc-agenda-view table.rbc-agenda-table thead > tr > th {
  padding: 3px 5px;
  text-align: left;
  border-bottom: 1px solid #DDD;
}

.rbc-rtl .rbc-agenda-view table.rbc-agenda-table thead > tr > th {
  text-align: right;
}

.rbc-agenda-time-cell {
  text-transform: lowercase;
}

.rbc-agenda-time-cell .rbc-continues-after:after {
  content: " »";
}

.rbc-agenda-time-cell .rbc-continues-prior:before {
  content: "« ";
}

.rbc-agenda-date-cell,
.rbc-agenda-time-cell {
  white-space: nowrap;
}

.rbc-agenda-event-cell {
  width: 100%;
}

.rbc-time-column {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

.rbc-time-column .rbc-timeslot-group {
  flex: 1 1;
}

.rbc-timeslot-group {
  border-bottom: 1px solid #DDD;
  min-height: 40px;
  display: flex;
  flex-flow: column nowrap;
}

.rbc-time-gutter,
.rbc-header-gutter {
  flex: none;
}

.rbc-label {
  padding: 0 5px;
}

.rbc-day-slot {
  position: relative;
}

.rbc-day-slot .rbc-events-container {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 10px;
  top: 0;
}

.rbc-day-slot .rbc-events-container.rbc-is-rtl {
  left: 10px;
  right: 0;
}

.rbc-day-slot .rbc-event {
  display: flex;
  max-height: 100%;
  min-height: 20px;
  flex-flow: column wrap;
  align-items: flex-start;
  overflow: hidden;
  position: absolute;
}

.rbc-day-slot .rbc-event-label {
  flex: none;
  padding-right: 5px;
  width: auto;
  font-weight: bold;
  box-sizing: content-box;
  color: #fff;
  white-space: nowrap;
}

.rbc-day-slot .rbc-event-content {
  width: 100%;
  flex: 1 1;
  word-wrap: break-word;
  line-height: 1;
  height: 100%;
  min-height: 1em;
}

.rbc-day-slot .rbc-time-slot + .rbc-time-slot {
  border-top: 1px dotted #ddd;
}

.rbc-time-slot {
  flex: 1 0;
}

.rbc-time-slot.rbc-now {
  font-weight: bold;
}

.rbc-day-header {
  text-align: center;
}

.rbc-slot-selection {
  z-index: 10;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  font-size: 75%;
  width: 100%;
  padding: 3px;
}

.rbc-slot-selecting {
  cursor: move;
}

.rbc-time-view {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  width: 100%;
  border: 1px solid #DDD;
  min-height: 0;
  border-left: none;
  border-right: none;
  border-top: none;
}

.rbc-time-view .rbc-time-gutter {
  white-space: nowrap;
}

.rbc-time-view .rbc-allday-cell {
  box-sizing: content-box;
  width: 100%;
  position: relative;
}

.rbc-time-view .rbc-allday-events {
  position: relative;
  z-index: 4;
}

.rbc-time-view .rbc-row {
  box-sizing: border-box;
  min-height: 20px;
}

.rbc-time-header {
  display: flex;
  flex: 0 0 auto;
  flex-direction: row;
}

.rbc-time-header.rbc-overflowing {
  border-right: 1px solid #DDD;
}

.rbc-rtl .rbc-time-header.rbc-overflowing {
  border-right-width: 0;
  border-left: 1px solid #DDD;
}

.rbc-time-header > .rbc-row:first-child {
  border-bottom: 1px solid #DDD;
}

.rbc-time-header > .rbc-row.rbc-row-resource {
  border-bottom: 1px solid #DDD;
}

.rbc-time-header-content {
  flex: 1 1;
  min-width: 0;
  flex-direction: column;
  border-left: 1px solid #DDD;
}

.rbc-rtl .rbc-time-header-content {
  border-left-width: 0;
  border-right: 1px solid #DDD;
}

.rbc-time-content {
  display: flex;
  flex: 1 0;
  align-items: flex-start;
  width: 100%;
  border-top: 2px solid #DDD;
  overflow-y: auto;
  position: relative;
}

.rbc-time-content > .rbc-time-gutter {
  flex: none;
}

.rbc-time-content > * + * > * {
  border-left: 1px solid #DDD;
}

.rbc-rtl .rbc-time-content > * + * > * {
  border-left-width: 0;
  border-right: 1px solid #DDD;
}

.rbc-time-content > .rbc-day-slot {
  width: 100%;
  user-select: none;
  -webkit-user-select: none;
}

.rbc-current-time-indicator {
  position: absolute;
  z-index: 3;
  height: 1px;
  background-color: #74ad31;
  pointer-events: none;
}

.rbc-event {
  width: 100%;
  position: relative; /* for resize handle and other inner positioning */
  display: block; /* make the <a> tag block */
  font-size: 0.85em;
  border-radius: 2px;
  padding: 0;
  background-color: rgba(68, 125, 247, 0.2); /* default BACKGROUND color */
  font-weight: normal; /* undo jqui's ui-widget-header bold */
  text-align: left;
  border: none;
  padding-bottom: 1px;
  line-height: 1.2;
}
.rbc-event.rbc-event-azure {
  background-color: rgba(35, 204, 239, 0.2);
}
.rbc-event.rbc-event-green {
  background-color: rgba(39, 93, 56, 0.2);
}
.rbc-event.rbc-event-orange {
  background-color: rgba(255, 165, 52, 0.2);
}
.rbc-event.rbc-event-red {
  background-color: rgba(251, 64, 75, 0.2);
}
.rbc-event .rbc-event-content {
  position: relative;
  z-index: 2;
  white-space: nowrap;
  overflow: hidden;
  color: inherit;
  padding: 0 5px;
}

.rbc-day-slot .rbc-event {
  display: block !important;
  height: auto !important;
  height: initial !important;
  max-height: none !important;
  max-height: initial !important;
}

.rbc-today {
  background-color: #F5F5F5;
}

@media screen and (max-width: 1373px) {
  .rbc-toolbar {
    display: block;
  }
  .rbc-toolbar .rbc-btn-group {
    display: block;
    text-align: center;
  }
  .rbc-toolbar .rbc-toolbar-label {
    display: block;
    flex-grow: initial;
    padding: 0;
  }
}
.sweet-alert {
  margin: auto !important;
  top: auto !important;
  top: initial !important;
  left: auto !important;
  left: initial !important;
}

.card-wizard {
  min-height: 410px;
  transition: all 300ms linear;
}
.card-wizard[data-color=primary] .moving-tab {
  background-color: #447DF7;
}
.card-wizard[data-color=primary] .picture:hover {
  border-color: #447DF7;
}
.card-wizard[data-color=primary] .choice:hover .icon, .card-wizard[data-color=primary] .choice.active .icon {
  border-color: #447DF7;
  color: #447DF7;
}
.card-wizard[data-color=primary] .checkbox input[type=checkbox]:checked + .checkbox-material .check {
  background-color: #447DF7;
}
.card-wizard[data-color=primary] .radio input[type=radio]:checked ~ .check {
  background-color: #447DF7;
}
.card-wizard[data-color=primary] .radio input[type=radio]:checked ~ .circle {
  border-color: #447DF7;
}
.card-wizard[data-color=green] .moving-tab {
  background-color: #275D38;
}
.card-wizard[data-color=green] .picture:hover {
  border-color: #275D38;
}
.card-wizard[data-color=green] .choice:hover .icon, .card-wizard[data-color=green] .choice.active .icon {
  border-color: #275D38;
  color: #275D38;
}
.card-wizard[data-color=green] .checkbox input[type=checkbox]:checked + .checkbox-material .check {
  background-color: #275D38;
}
.card-wizard[data-color=green] .radio input[type=radio]:checked ~ .check {
  background-color: #275D38;
}
.card-wizard[data-color=green] .radio input[type=radio]:checked ~ .circle {
  border-color: #275D38;
}
.card-wizard[data-color=orange] .moving-tab {
  background-color: #FFA534;
}
.card-wizard[data-color=orange] .picture:hover {
  border-color: #FFA534;
}
.card-wizard[data-color=orange] .choice:hover .icon, .card-wizard[data-color=orange] .choice.active .icon {
  border-color: #FFA534;
  color: #FFA534;
}
.card-wizard[data-color=orange] .checkbox input[type=checkbox]:checked + .checkbox-material .check {
  background-color: #FFA534;
}
.card-wizard[data-color=orange] .radio input[type=radio]:checked ~ .check {
  background-color: #FFA534;
}
.card-wizard[data-color=orange] .radio input[type=radio]:checked ~ .circle {
  border-color: #FFA534;
}
.card-wizard[data-color=red] .moving-tab {
  background-color: #FB404B;
}
.card-wizard[data-color=red] .picture:hover {
  border-color: #FB404B;
}
.card-wizard[data-color=red] .choice:hover .icon, .card-wizard[data-color=red] .choice.active .icon {
  border-color: #FB404B;
  color: #FB404B;
}
.card-wizard[data-color=red] .checkbox input[type=checkbox]:checked + .checkbox-material .check {
  background-color: #FB404B;
}
.card-wizard[data-color=red] .radio input[type=radio]:checked ~ .check {
  background-color: #FB404B;
}
.card-wizard[data-color=red] .radio input[type=radio]:checked ~ .circle {
  border-color: #FB404B;
}
.card-wizard[data-color=blue] .moving-tab {
  background-color: #23CCEF;
}
.card-wizard[data-color=blue] .picture:hover {
  border-color: #23CCEF;
}
.card-wizard[data-color=blue] .choice:hover .icon, .card-wizard[data-color=blue] .choice.active .icon {
  border-color: #23CCEF;
  color: #23CCEF;
}
.card-wizard[data-color=blue] .checkbox input[type=checkbox]:checked + .checkbox-material .check {
  background-color: #23CCEF;
}
.card-wizard[data-color=blue] .radio input[type=radio]:checked ~ .check {
  background-color: #23CCEF;
}
.card-wizard[data-color=blue] .radio input[type=radio]:checked ~ .circle {
  border-color: #23CCEF;
}
.card-wizard .card-header {
  padding: 15px 0 !important;
  padding-bottom: 40px;
  background-color: transparent;
}
.card-wizard .card-header .card-title {
  margin-bottom: 0px;
}
.card-wizard .card-header .card-title + .description {
  color: #9A9A9A;
  font-size: 0.875rem;
  font-weight: 400;
  margin: 0px;
  margin-bottom: 40px;
}
.card-wizard .nav-pills .nav-item .nav-link {
  padding: 0.75rem;
}
.card-wizard .nav-pills .nav-item .nav-link,
.card-wizard .nav-pills .nav-item .nav-link.active,
.card-wizard .nav-pills .nav-item .nav-link:hover,
.card-wizard .nav-pills .nav-item .nav-link:focus,
.card-wizard .nav-pills .nav-item .nav-link.active:focus,
.card-wizard .nav-pills .nav-item .nav-link.active:hover {
  background-color: transparent;
  box-shadow: none;
}
.card-wizard .picture-container {
  position: relative;
  cursor: pointer;
  text-align: center;
}
.card-wizard .wizard-navigation {
  position: relative;
}
.card-wizard .wizard-navigation .nav-link {
  display: flex;
  align-items: center;
  justify-content: center;
}
.card-wizard .wizard-navigation .nav-link i,
.card-wizard .moving-tab i {
  display: inline-block;
  font-size: 19px;
  line-height: 18px;
  margin-right: 6px;
  padding: 0;
  vertical-align: bottom;
}
.card-wizard .moving-tab i {
  margin-right: 9px;
}
.card-wizard .picture {
  width: 106px;
  height: 106px;
  background-color: #999999;
  border: 1px solid #E3E3E3;
  color: #FFFFFF;
  border-radius: 50%;
  margin: 5px auto;
  overflow: hidden;
  transition: all 0.2s;
  -webkit-transition: all 0.2s;
}
.card-wizard .picture:hover {
  border-color: #2ca8ff;
}
.card-wizard .moving-tab {
  position: absolute;
  text-align: center;
  padding: 0.75rem;
  font-size: 1rem;
  text-transform: uppercase;
  -webkit-font-smoothing: subpixel-antialiased;
  top: 0px;
  left: 0px;
  background-color: #888888;
  color: #FFFFFF !important;
  cursor: pointer;
  font-weight: 400;
  line-height: 18px;
}
.card-wizard .picture input[type=file] {
  cursor: pointer;
  display: block;
  height: 100%;
  left: 0;
  opacity: 0 !important;
  position: absolute;
  top: 0;
  width: 100%;
}
.card-wizard .picture-src {
  width: 100%;
}
.card-wizard .tab-content {
  min-height: 355px;
  padding: 20px 0;
}
.card-wizard .wizard-footer {
  padding: 0 15px;
}
.card-wizard .wizard-footer .checkbox {
  margin-top: 16px;
}
.card-wizard .disabled {
  display: none;
}
.card-wizard .wizard-header {
  text-align: center;
  padding: 25px 0 35px;
}
.card-wizard .wizard-header h5 {
  margin: 5px 0 0;
}
.card-wizard .nav-pills > li {
  text-align: center;
}
.card-wizard .btn {
  text-transform: uppercase;
}
.card-wizard .info-text {
  text-align: center;
  font-weight: 300;
  margin: 10px 0 30px;
}
.card-wizard .choice {
  text-align: center;
  cursor: pointer;
  margin-top: 20px;
}
.card-wizard .choice[disabled] {
  pointer-events: none;
  cursor: not-allowed;
  opacity: 0.5;
}
.card-wizard .choice .icon {
  text-align: center;
  vertical-align: middle;
  height: 116px;
  width: 116px;
  border-radius: 50%;
  color: #888888;
  margin: 0 auto 20px;
  border: 1px solid #E3E3E3;
  transition: all 0.2s;
  -webkit-transition: all 0.2s;
}
.card-wizard .choice i {
  font-size: 30px;
  line-height: 116px;
  position: absolute;
  left: 0;
  right: 0;
}
.card-wizard .choice:hover .icon, .card-wizard .choice.active .icon {
  border-color: #2ca8ff;
}
.card-wizard .choice input[type=radio],
.card-wizard .choice input[type=checkbox] {
  position: absolute;
  left: -10000px;
  z-index: -1;
}
.card-wizard .btn-finish {
  display: none;
}
.card-wizard .card-title + .description {
  font-size: 3.875rem;
  margin-bottom: 32px;
}
.card-wizard .wizard-title {
  margin: 0;
}
.card-wizard .nav-pills {
  background-color: #9A9A9A;
}
.card-wizard .nav-pills > li + li {
  margin-left: 0;
}
.card-wizard .nav-pills > li > a {
  border: 0 !important;
  border-radius: 0;
  line-height: 18px;
  text-transform: uppercase;
  font-size: 1rem;
  font-weight: 400;
  min-width: 100px;
  text-align: center;
  color: #FFFFFF !important;
}
.card-wizard .nav-pills > li.active > a,
.card-wizard .nav-pills > li.active > a:hover,
.card-wizard .nav-pills > li.active > a:focus,
.card-wizard .nav-pills > li > a:hover,
.card-wizard .nav-pills > li > a:focus {
  background-color: inherit;
  box-shadow: none;
}
.card-wizard .nav-pills > li i {
  display: block;
  font-size: 30px;
  padding: 15px 0;
}
.card-wizard .form-group.select-wizard {
  margin-top: 15px;
}
.card-wizard .dropdown.show .dropdown-menu,
.card-wizard .dropup.show .dropdown-menu {
  transform: translate3d(0, 0px, 0);
}

/*!
* https://github.com/YouCanBookMe/react-datetime
*/
.rdt {
  position: relative;
}
.rdt .rdtPicker {
  transition: all 150ms linear;
  margin-top: -20px;
  visibility: hidden;
  display: block;
  opacity: 0;
}
.rdt.rdtOpen .rdtPicker {
  opacity: 1;
  visibility: visible;
  margin-top: 0;
}

.rdtPicker {
  display: none;
  position: absolute;
  width: 260px;
  padding: 4px;
  margin-top: 1px;
  z-index: 99999 !important;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  box-shadow: 1px 2px 3px rgba(0, 0, 0, 0.125);
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  min-width: 160px;
}
.rdtPicker:before {
  border-bottom: 11px solid rgba(0, 0, 0, 0.2);
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  left: 12px;
  top: -11px;
}
.rdtPicker:after {
  border-bottom: 11px solid #ffffff;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  left: 12px;
  top: -10px;
}

.rdtOpen .rdtPicker {
  display: block;
  top: 49px;
}

.rdtStatic .rdtPicker {
  box-shadow: none;
  position: static;
}

.rdtPicker .rdtTimeToggle {
  text-align: center;
  padding: 5px;
  border-radius: 4px;
}

.rdtPicker table {
  width: 100%;
  margin: 0;
  border-color: #FFFFFF !important;
}

.rdtPicker td,
.rdtPicker th {
  text-align: center;
  padding: 1px;
}

.rdtPicker td {
  cursor: pointer;
}

.rdtDay {
  height: 30px;
  line-height: 33px;
  width: 30px;
  text-align: center;
  padding: 0px;
  border-radius: 50%;
}
.rdtDay.rdtToday.rdtActive, .rdtDay.rdtActive, .rdtDay.rdtActive:hover {
  background-color: #23CCEF !important;
  color: #FFFFFF;
}

.rdtDays tr .dow {
  text-align: center;
  border-bottom: 1px solid #e3e3e3;
  font-size: 12px;
  text-transform: uppercase;
  color: #9a9a9a;
  font-weight: 400;
  padding-bottom: 5px;
  padding-top: 10px;
}
.rdtDays tr .rdtOld,
.rdtDays tr .rdtNew {
  color: #DDDDDD;
}

.rdtPicker td.rdtDay:hover,
.rdtPicker td.rdtHour:hover,
.rdtPicker td.rdtMinute:hover,
.rdtPicker td.rdtSecond:hover,
.rdtPicker .rdtTimeToggle:hover {
  background: #eeeeee;
  cursor: pointer;
}

.rdtPicker td.rdtToday {
  position: relative;
}

.rdtPicker td.rdtActive.rdtToday:before {
  border-bottom-color: #fff;
}

.rdtPicker td.rdtDisabled,
.rdtPicker td.rdtDisabled:hover {
  background: none;
  color: #999999;
  cursor: not-allowed;
}

.rdtPicker td span.rdtOld {
  color: #999999;
}

.rdtPicker td span.rdtDisabled,
.rdtPicker td span.rdtDisabled:hover {
  background: none;
  color: #999999;
  cursor: not-allowed;
}

.rdtPicker .dow {
  width: 14.2857%;
  border-bottom: none;
}

.rdtPicker th.rdtSwitch {
  width: 50px;
  padding: 5px;
  border-radius: 4px;
}

.rdtPicker th.rdtNext,
.rdtPicker th.rdtPrev {
  font-size: 21px;
  vertical-align: top;
  border-radius: 50%;
  line-height: 33px;
}

.rdtPrev span,
.rdtNext span {
  display: block;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Chrome/Safari/Opera */ /* Konqueror */ /* Firefox */ /* Internet Explorer/Edge */
  user-select: none;
}

.rdtPicker th.rdtDisabled,
.rdtPicker th.rdtDisabled:hover {
  background: none;
  color: #999999;
  cursor: not-allowed;
}

.rdtPicker thead tr:first-child th {
  cursor: pointer;
}

.rdtPicker thead tr:first-child th:hover {
  background: #eeeeee;
}

.rdtPicker button {
  border: none;
  background: none;
  cursor: pointer;
}

.rdtPicker button:hover {
  background-color: #eee;
}

.rdtPicker thead button {
  width: 100%;
  height: 100%;
}

td.rdtMonth,
td.rdtYear {
  height: 50px;
  width: 25%;
  cursor: pointer;
}

td.rdtMonth:hover,
td.rdtYear:hover {
  background: #eee;
}

.rdtCounters {
  display: inline-block;
}

.rdtCounters > div {
  float: left;
  width: 40px;
  font-weight: 300;
  margin: 3px;
  border-radius: 50%;
}
.rdtCounters .rdtCounterSeparator {
  width: 0;
  border: 1px solid transparent;
}

.rdtCounter {
  height: 100px;
}

.rdtCounter {
  width: 40px;
}
.rdtCounter .rdtCount {
  padding: 7px;
  height: 40px;
  border: 1px solid transparent;
}

.rdtCounters .rdtCounter:last-child .rdtCount {
  color: #23CCEF;
  border-radius: 50%;
  border: 1px solid #23CCEF;
}

.rdtCounterSeparator {
  padding: 7px;
  line-height: 100px;
}

.rdtCounter .rdtBtn {
  line-height: 40px;
  cursor: pointer;
  display: block;
  border-radius: 50%;
  color: #AAAAAA;
  transition: all 60ms ease-in;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Chrome/Safari/Opera */ /* Konqueror */ /* Firefox */ /* Internet Explorer/Edge */
  user-select: none;
}

.rdtCounter .rdtBtn:hover {
  background: #eee;
  color: #797979;
}

.rdtCounter .rdtCount {
  font-size: 1.2em;
}

.rdtMilli {
  vertical-align: middle;
  padding-left: 8px;
  width: 48px;
}

.rdtMilli input {
  width: 100%;
  font-size: 1.2em;
  margin-top: 37px;
}

.rdtMonths,
.rdtYears {
  padding-bottom: 10px;
}
.rdtMonths .rdtMonth,
.rdtMonths .rdtYear,
.rdtYears .rdtMonth,
.rdtYears .rdtYear {
  display: inline-block;
  width: 56px;
  height: 56px;
  line-height: 56px;
  margin: 3px 3px;
  cursor: pointer;
  border-radius: 50%;
  text-align: center;
}
.rdtMonths .rdtMonth.rdtActive,
.rdtMonths .rdtYear.rdtActive,
.rdtYears .rdtMonth.rdtActive,
.rdtYears .rdtYear.rdtActive {
  background-color: #23CCEF !important;
  color: #FFFFFF;
}

.rdtTime .rdtCounters .rdtCounterSeparator + .rdtCounter + .rdtCounter .rdtCount {
  font-size: 1rem;
}

.rna-container .alert button.close {
  color: #000;
  display: flex;
  justify-content: center;
  align-items: center;
}
.rna-container .alert button.close span {
  margin-top: -4px;
}

/**
* React Select v1.0.0-rc.10
* ============
* Created by Jed Watson and Joss Mackison for KeystoneJS, https://www.keystonejs.com/
* https://twitter.com/jedwatson https://twitter.com/jossmackison https://twitter.com/keystonejs
* MIT License: https://github.com/JedWatson/react-select
*/
/*
This file was modified entirely by Creative Tim for React-Select v2.0.0
*/
.react-select .react-select__menu {
  border-radius: 0;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
  background-color: #fff;
  border: 1px solid #ccc;
  border-top-color: #e6e6e6;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);
  box-sizing: border-box;
  margin-top: -1px;
  position: absolute;
  left: 0;
  top: 100%;
  width: 100%;
  z-index: 5;
  -webkit-overflow-scrolling: touch;
}
.react-select .react-select__menu-list {
  overflow-y: auto;
  padding-bottom: 0;
  padding-bottom: initial;
  padding-top: 0;
  padding-top: initial;
  position: relative;
  max-height: 200px;
}
.react-select .react-select__option {
  cursor: pointer;
  display: block;
  padding: 8px 10px;
}
.react-select .react-select__menu .react-select__option, .react-select .react-select__menu .react-select__option:active {
  background-color: transparent;
}
.react-select .react-select__menu .react-select__option.react-select__option--is-selected, .react-select .react-select__menu .react-select__option.react-select__option--is-selected:active, .react-select .react-select__menu .react-select__option.react-select__option--is-selected:not(:first-child), .react-select .react-select__menu .react-select__option.react-select__option--is-selected:not(:first-child):active, .react-select .react-select__menu .react-select__option.react-select__option--is-selected.react-select__option--is-focused:not(:first-child), .react-select .react-select__menu .react-select__option.react-select__option--is-selected.react-select__option--is-focused:not(:first-child):active {
  background-color: rgba(0, 126, 255, 0.04);
  color: #333;
}
.react-select .react-select__menu .react-select__option:not(:first-child).react-select__option--is-focused:not(:first-child), .react-select .react-select__menu .react-select__option:not(:first-child).react-select__option--is-focused:not(:first-child):active {
  background-color: rgba(0, 126, 255, 0.08);
  color: #333;
}
.react-select .react-select__menu .react-select__option.react-select__option--is-disabled, .react-select .react-select__menu .react-select__option.react-select__option--is-disabled:active {
  color: #cccccc;
  cursor: default;
}
.react-select .react-select__control {
  background-color: #FFFFFF;
  border-color: #d9d9d9 #ccc #b3b3b3;
  border-radius: 4px;
  border: 1px solid #ccc;
  min-height: 36px;
  height: 36px;
  box-sizing: border-box;
  border-collapse: separate;
  display: table;
  width: 100%;
}
.react-select .react-select__control.react-select__control--menu-is-open {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.react-select .react-select__control.react-select__control--is-focused .react-select__dropdown-indicator:after {
  transform: rotate(180deg);
  top: -4px;
}
.react-select .react-select__control.react-select__control--is-focused, .react-select .react-select__control.react-select__control--is-focused:hover {
  border: 1px solid #447DF7;
  box-shadow: none;
}
.react-select .react-select__control .react-select__value-container--has-value .react-select__multi-value {
  display: inline-flex;
  border-radius: 4px;
  background-color: transparent;
}
.react-select .react-select__control .react-select__value-container--has-value .react-select__multi-value + div:not(.react-select__multi-value) {
  display: inline-flex;
}
.react-select .react-select__control .react-select__value-container--has-value .react-select__multi-value .react-select__multi-value__label {
  font-size: 0.9em;
}
.react-select .react-select__control .react-select__value-container--has-value .react-select__single-value {
  top: 48%;
  color: #333333;
}
.react-select .react-select__control .react-select__placeholder {
  color: #AAAAAA;
  line-height: 34px;
  padding-left: 10px;
  padding-right: 10px;
  font-size: 14px;
  left: 0;
  margin-left: 0;
  margin-right: 0;
}
.react-select .react-select__control .react-select__value-container,
.react-select .react-select__control .react-select__indicators {
  display: table-cell;
}
.react-select .react-select__control .react-select__indicators {
  width: 60px;
  padding-right: 10px;
  align-items: flex-end;
  vertical-align: middle;
  text-align: right;
}
.react-select .react-select__control .react-select__indicators .react-select__indicator-separator {
  display: none;
}
.react-select .react-select__control .react-select__indicators .react-select__indicator {
  padding: 0;
  display: inline-block;
}
.react-select .react-select__control .react-select__indicators .react-select__dropdown-indicator:after {
  transition: all 150ms ease 0s;
  border-color: #999 transparent transparent;
  border-style: solid;
  border-width: 5px 5px 2.5px;
  display: inline-block;
  height: 0;
  width: 0;
  position: relative;
  content: "";
}
.react-select .react-select__control .react-select__indicators .react-select__dropdown-indicator:hover:after {
  border-top-color: #666666;
}
.react-select .react-select__control .react-select__indicators .react-select__dropdown-indicator > * {
  display: none;
}
.react-select .react-select__control .react-select__indicators .react-select__clear-indicator:before {
  content: "×";
  display: inline-block;
  font-size: 18px;
  line-height: 1;
  top: 2px;
  position: relative;
  margin-right: 3px;
}
.react-select .react-select__control .react-select__indicators .react-select__clear-indicator > * {
  display: none;
}
.react-select.primary .react-select__control.react-select__control--is-focused, .react-select.primary .react-select__control.react-select__control--is-focused:hover {
  border-color: #447DF7;
}
.react-select.primary .react-select__control .react-select__value-container--has-value .react-select__single-value,
.react-select.primary .react-select__control .react-select__value-container--has-value .react-select__multi-value__label {
  color: #447DF7;
}
.react-select.primary .react-select__multi-value {
  border: 1px solid #447DF7;
}
.react-select.primary .react-select__multi-value .react-select__multi-value__remove {
  color: #2c6cf6;
  border-left: 1px solid #2c6cf6;
}
.react-select.primary .react-select__multi-value .react-select__multi-value__remove:hover {
  color: #447DF7;
  background-color: transparent;
}
.react-select.success .react-select__control.react-select__control--is-focused, .react-select.success .react-select__control.react-select__control--is-focused:hover {
  border-color: #275D38;
}
.react-select.success .react-select__control .react-select__value-container--has-value .react-select__single-value,
.react-select.success .react-select__control .react-select__value-container--has-value .react-select__multi-value__label {
  color: #275D38;
}
.react-select.success .react-select__multi-value {
  border: 1px solid #275D38;
}
.react-select.success .react-select__multi-value .react-select__multi-value__remove {
  color: #1f4b2d;
  border-left: 1px solid #1f4b2d;
}
.react-select.success .react-select__multi-value .react-select__multi-value__remove:hover {
  color: #275D38;
  background-color: transparent;
}
.react-select.info .react-select__control.react-select__control--is-focused, .react-select.info .react-select__control.react-select__control--is-focused:hover {
  border-color: #23CCEF;
}
.react-select.info .react-select__control .react-select__value-container--has-value .react-select__single-value,
.react-select.info .react-select__control .react-select__value-container--has-value .react-select__multi-value__label {
  color: #23CCEF;
}
.react-select.info .react-select__multi-value {
  border: 1px solid #23CCEF;
}
.react-select.info .react-select__multi-value .react-select__multi-value__remove {
  color: #11bfe3;
  border-left: 1px solid #11bfe3;
}
.react-select.info .react-select__multi-value .react-select__multi-value__remove:hover {
  color: #23CCEF;
  background-color: transparent;
}
.react-select.warning .react-select__control.react-select__control--is-focused, .react-select.warning .react-select__control.react-select__control--is-focused:hover {
  border-color: #FFA534;
}
.react-select.warning .react-select__control .react-select__value-container--has-value .react-select__single-value,
.react-select.warning .react-select__control .react-select__value-container--has-value .react-select__multi-value__label {
  color: #FFA534;
}
.react-select.warning .react-select__multi-value {
  border: 1px solid #FFA534;
}
.react-select.warning .react-select__multi-value .react-select__multi-value__remove {
  color: #ff9510;
  border-left: 1px solid #ff9510;
}
.react-select.warning .react-select__multi-value .react-select__multi-value__remove:hover {
  color: #FFA534;
  background-color: transparent;
}
.react-select.danger .react-select__control.react-select__control--is-focused, .react-select.danger .react-select__control.react-select__control--is-focused:hover {
  border-color: #FB404B;
}
.react-select.danger .react-select__control .react-select__value-container--has-value .react-select__single-value,
.react-select.danger .react-select__control .react-select__value-container--has-value .react-select__multi-value__label {
  color: #FB404B;
}
.react-select.danger .react-select__multi-value {
  border: 1px solid #FB404B;
}
.react-select.danger .react-select__multi-value .react-select__multi-value__remove {
  color: #fa1825;
  border-left: 1px solid #fa1825;
}
.react-select.danger .react-select__multi-value .react-select__multi-value__remove:hover {
  color: #FB404B;
  background-color: transparent;
}
.react-select .react-select__multi-value {
  border: 1px solid #9A9A9A;
}
.react-select .react-select__multi-value .react-select__multi-value__remove {
  position: relative;
  color: #AAAAAA;
  border-left: 1px solid #AAAAAA;
}
.react-select .react-select__multi-value .react-select__multi-value__remove:hover {
  color: #9A9A9A;
  background-color: transparent;
}
.react-select.react-select--is-disabled .react-select__multi-value--is-disabled .react-select__multi-value__remove {
  display: none;
}
.react-select.react-select--is-disabled .react-select__multi-value--is-disabled.react-select__multi-value {
  background-color: #fcfcfc;
  border: 1px solid #e3e3e3;
}
.react-select.react-select--is-disabled .react-select__control--is-disabled {
  background-color: #f9f9f9;
}

.ReactTable {
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: transparent;
}

.ReactTable .actions-right {
  text-align: right;
}
.ReactTable .actions-left {
  text-align: left;
}
.ReactTable .actions-center {
  text-align: center;
}

.ReactTable * {
  box-sizing: border-box;
}

.ReactTable .rt-table {
  flex: auto 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  border-collapse: collapse;
  overflow: auto;
}

.ReactTable .rt-thead {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  -webkit-user-select: none;
  user-select: none;
}

.ReactTable .rt-thead.-headerGroups {
  background: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.ReactTable .rt-thead.-filters {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.ReactTable .rt-thead.-filters input,
.ReactTable .rt-thead.-filters select {
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  color: #565656;
  font-weight: 400;
  height: 36px;
  background-color: inherit;
  padding-left: 0.8em;
}
.ReactTable .rt-thead.-filters input:focus,
.ReactTable .rt-thead.-filters select:focus {
  outline: none;
  border: 1px solid #aaa;
  color: #333;
}

.ReactTable .rt-thead .rt-tr {
  text-align: center;
}

.ReactTable .rt-thead .rt-th:last-child {
  text-align: right;
  margin: 0;
  margin: initial;
}

.ReactTable .rt-thead .rt-th.-cursor-pointer > div:first-of-type:after {
  opacity: 0.4;
  content: "\\f0dc";
  position: relative;
  display: inline-block;
  bottom: 0;
  right: -7px;
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
}

.ReactTable .rt-thead .rt-th.-cursor-pointer.-sort-desc > div:first-of-type:after {
  content: "\\f0dd";
  top: -3px;
  position: relative;
  display: inline-block;
  bottom: 0;
  right: -7px;
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  opacity: 0.8;
}

.ReactTable .rt-thead .rt-th.-cursor-pointer.-sort-asc > div:first-of-type:after {
  content: "\\f0de";
  top: 3px;
  position: relative;
  display: inline-block;
  bottom: 0;
  right: -7px;
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  opacity: 0.8;
}

.ReactTable .rt-thead .rt-th,
.ReactTable .rt-thead .rt-td {
  font-size: 1.063rem;
  text-align: left;
  font-weight: 300;
  line-height: 2.5em !important;
  padding: 5px 5px;
  line-height: normal;
  position: relative;
  transition: box-shadow 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  box-shadow: inset 0 0 0 0 transparent;
}
.ReactTable .rt-thead .rt-th .form-check .form-check-sign,
.ReactTable .rt-thead .rt-th .form-check .form-check-sign:before,
.ReactTable .rt-thead .rt-th .form-check .form-check-sign:after,
.ReactTable .rt-thead .rt-td .form-check .form-check-sign,
.ReactTable .rt-thead .rt-td .form-check .form-check-sign:before,
.ReactTable .rt-thead .rt-td .form-check .form-check-sign:after {
  margin-top: -14px;
  position: inherit;
}

.ReactTable .rt-tr .rt-th .form-check .form-check-sign,
.ReactTable .rt-tr .rt-th .form-check .form-check-sign:before,
.ReactTable .rt-tr .rt-th .form-check .form-check-sign:after,
.ReactTable .rt-tr .rt-td .form-check .form-check-sign,
.ReactTable .rt-tr .rt-td .form-check .form-check-sign:before,
.ReactTable .rt-tr .rt-td .form-check .form-check-sign:after {
  margin-top: -14px;
  position: inherit;
}

.ReactTable .rt-thead .rt-th.-cursor-pointer,
.ReactTable .rt-thead .rt-td.-cursor-pointer {
  cursor: pointer;
}

.ReactTable .rt-thead .rt-th:last-child,
.ReactTable .rt-thead .rt-td:last-child {
  border-right: 0;
}

.ReactTable .rt-thead .rt-resizable-header {
  overflow: visible;
}

.ReactTable .rt-thead .rt-resizable-header:last-child {
  overflow: hidden;
}

.ReactTable .rt-thead .rt-resizable-header-content {
  overflow: hidden;
  text-overflow: ellipsis;
}
.ReactTable .rt-thead .rt-resizable-header-content:focus {
  outline: none;
}

.ReactTable .rt-thead .rt-header-pivot {
  border-right-color: #f7f7f7;
}

.ReactTable .rt-thead .rt-header-pivot:after,
.ReactTable .rt-thead .rt-header-pivot:before {
  left: 100%;
  top: 50%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.ReactTable .rt-thead .rt-header-pivot:after {
  border-color: rgba(255, 255, 255, 0);
  border-left-color: #fff;
  border-width: 8px;
  margin-top: -8px;
}

.ReactTable .rt-thead .rt-header-pivot:before {
  border-color: rgba(102, 102, 102, 0);
  border-left-color: #f7f7f7;
  border-width: 10px;
  margin-top: -10px;
}

.ReactTable .rt-tbody {
  flex: 99999 1 auto;
  display: flex;
  flex-direction: column;
  overflow: auto;
}

.ReactTable .rt-tbody .rt-tr-group {
  border-bottom: solid 1px rgba(0, 0, 0, 0.05);
}

.ReactTable .rt-tbody .rt-tr-group:last-child {
  border-bottom: 0;
}

.ReactTable .rt-tbody .rt-td:last-child {
  border-right: 0;
}

.ReactTable .rt-tbody .rt-expandable {
  cursor: pointer;
}

.ReactTable .rt-tr-group {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.ReactTable .rt-tr {
  flex: 1 0 auto;
  display: inline-flex;
}

.ReactTable .rt-th,
.ReactTable .rt-td {
  flex: 1 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 7px 5px;
  overflow: hidden;
  transition: 0.3s ease;
  transition-property: width, min-width, padding, opacity;
  margin: auto;
}

.ReactTable .rt-th.-hidden,
.ReactTable .rt-td.-hidden {
  width: 0 !important;
  min-width: 0 !important;
  padding: 0 !important;
  border: 0 !important;
  opacity: 0 !important;
}

.ReactTable .rt-expander {
  display: inline-block;
  position: relative;
  margin: 0;
  color: transparent;
  margin: 0 10px;
}

.ReactTable .rt-expander:after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-90deg);
  border-left: 5.04px solid transparent;
  border-right: 5.04px solid transparent;
  border-top: 7px solid rgba(0, 0, 0, 0.8);
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  cursor: pointer;
}

.ReactTable .rt-expander.-open:after {
  transform: translate(-50%, -50%) rotate(0);
}

.ReactTable .rt-resizer {
  display: inline-block;
  position: absolute;
  width: 36px;
  top: 0;
  bottom: 0;
  right: -18px;
  cursor: col-resize;
  z-index: 10;
}

.ReactTable .rt-tfoot {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);
}

.ReactTable .rt-tfoot .rt-td {
  border-right: 1px solid rgba(0, 0, 0, 0.05);
}

.ReactTable .rt-tfoot .rt-td:last-child {
  border-right: 0;
}

.ReactTable.-striped .rt-tr.-odd {
  background: rgba(0, 0, 0, 0.03);
}

.ReactTable.-highlight .rt-tbody .rt-tr:not(.-padRow):hover {
  background: rgba(0, 0, 0, 0.05);
}

.ReactTable .-pagination {
  z-index: 1;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  flex-wrap: wrap;
  padding: 3px;
}

.ReactTable .-pagination input,
.ReactTable .-pagination select {
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  color: #565656;
  font-weight: 400;
  height: 36px;
  background-color: inherit;
  text-align: center;
}
.ReactTable .-pagination input:focus,
.ReactTable .-pagination select:focus {
  outline: none;
  border: 1px solid #aaa;
  color: #333;
}

.ReactTable .-pagination .-btn {
  -webkit-appearance: none;
  appearance: none;
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
  border-radius: 3px;
  padding: 6px;
  font-size: 1em;
  color: rgba(0, 0, 0, 0.6);
  background: rgba(0, 0, 0, 0.1);
  transition: all 0.1s ease;
  cursor: pointer;
  outline: none;
}

.ReactTable .-pagination .-btn[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
}

.ReactTable .-pagination .-btn:not([disabled]):hover {
  background: rgba(0, 0, 0, 0.3);
  color: #fff;
}

.ReactTable .-pagination .-previous,
.ReactTable .-pagination .-next {
  flex: 1 1;
  text-align: center;
}

.ReactTable .-pagination .-center {
  flex: 1.5 1;
  text-align: center;
  margin-bottom: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-around;
}

.ReactTable .-pagination .-pageInfo {
  display: inline-block;
  margin: 3px 10px;
  white-space: nowrap;
}

.ReactTable .-pagination .-pageJump {
  display: inline-block;
}

.ReactTable .-pagination .-pageSizeOptions {
  margin: 3px 10px;
}

.ReactTable .rt-noData {
  display: block;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 255, 255, 0.8);
  transition: all 0.3s ease;
  z-index: 1;
  pointer-events: none;
  padding: 20px;
  color: rgba(0, 0, 0, 0.5);
}

.ReactTable .-loading {
  display: block;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  transition: all 0.3s ease;
  z-index: -1;
  opacity: 0;
  pointer-events: none;
}

.ReactTable .-loading > div {
  position: absolute;
  display: block;
  text-align: center;
  width: 100%;
  top: 50%;
  left: 0;
  font-size: 15px;
  color: rgba(0, 0, 0, 0.6);
  transform: translateY(-52%);
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.ReactTable .-loading.-active {
  opacity: 1;
  z-index: 2;
  pointer-events: all;
}

.ReactTable .-loading.-active > div {
  transform: translateY(50%);
}

.ReactTable .rt-resizing .rt-th,
.ReactTable .rt-resizing .rt-td {
  transition: none !important;
  cursor: col-resize;
  -webkit-user-select: none;
  user-select: none;
}

.ReactTable .rt-thead .rt-th:focus {
  outline: none;
}

.ReactTable .rt-thead .rt-th {
  font-size: 12px;
  text-transform: uppercase;
  color: #9a9a9a;
  font-weight: 400;
}

.alert {
  border-radius: 0.25rem;
}

.fixed-plugin {
  background-color: transparent;
  background-color: initial;
}
.fixed-plugin .dropdown-toggle,
.fixed-plugin .dropdown-toggle:focus,
.fixed-plugin .dropdown-toggle:active {
  background-color: rgba(0, 0, 0, 0.3) !important;
  border: none !important;
  padding: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.fixed-plugin .dropdown-toggle .fa-cogs,
.fixed-plugin .dropdown-toggle:focus .fa-cogs,
.fixed-plugin .dropdown-toggle:active .fa-cogs {
  padding-left: 15px;
  padding-right: 15px;
}
.fixed-plugin .dropdown-toggle::after,
.fixed-plugin .dropdown-toggle:focus::after,
.fixed-plugin .dropdown-toggle:active::after {
  display: none;
}

.navbar {
  min-height: 0;
  min-height: initial;
  max-height: none;
  max-height: initial;
}
.navbar .btn,
.navbar .navbar-brand,
.navbar .navbar-nav .nav-item .nav-link {
  margin: 0;
  margin: initial;
  align-items: center;
}
.navbar .navbar-nav .dropdown-toggle:after {
  margin-top: 0px;
}

@media (min-width: 992px) {
  .navbar .navbar-nav .nc-icon {
    margin-top: 0;
    margin-top: initial;
  }
  .navbar .navbar-nav .notification {
    top: 0px;
  }
}
@media (max-width: 991.98px) {
  .navbar-expand-lg > .container,
.navbar-expand-lg > .container-fluid,
.navbar-expand-lg > .container-lg,
.navbar-expand-lg > .container-md,
.navbar-expand-lg > .container-sm,
.navbar-expand-lg > .container-xl {
    padding-right: 15px;
    padding-left: 15px;
  }
}
.card-header-tabs {
  border-bottom: 1px solid #dee2e6;
}

.sidebar[data-color=black]:after {
  background: #282828;
  background: linear-gradient(to bottom, #282828 0%, rgba(17, 17, 17, 0.7) 100%);
  background-size: 150% 150%;
}
.sidebar .logo a.logo-mini, .sidebar .logo-img {
  width: 40px;
}
.sidebar .logo a.logo-mini {
  margin-right: 5px;
}
.sidebar .logo-img img {
  width: 40px;
  top: 6px;
}

.sidebar-mini .sidebar .nav .nav-item .nav-link {
  padding: 10px 12px;
}
.sidebar-mini .sidebar:hover .nav .nav-item .nav-link {
  padding: 10px 15px;
}
.sidebar-mini .main-panel .navbar.fixed-top {
  margin-left: auto;
  width: calc(100% - 80px);
}

.close-layer {
  display: none;
  pointer-events: none;
  width: 0;
  height: 0;
}

@media (max-width: 991px) {
  .nav-open .close-layer {
    width: 100%;
    height: 100%;
    pointer-events: auto;
    display: block;
    opacity: 1;
  }
}
.main-panel .navbar.fixed-top {
  margin-left: auto;
  width: calc(100% - 260px);
}

.full-page[data-color=black]:after {
  background: #282828;
  background: linear-gradient(180deg, #282828 0, rgba(17, 17, 17, 0.4));
  opacity: 0.9;
}

.custom-switch {
  min-height: 26px;
  min-width: 62px;
  padding: 0;
}
.custom-switch .custom-control-label::after {
  width: 22px !important;
  height: 22px !important;
  border-radius: 22px;
  transition: all 0.15s ease-in-out;
  top: 2px;
  left: 2px;
  background-color: white;
}
.custom-switch .custom-control-label::before {
  width: 62px !important;
  height: 26px !important;
  border-radius: 26px;
  left: 0;
  top: 0;
  border: #ddd;
  background: #ddd;
}
.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  transform: translateX(36px);
}
.custom-switch:hover .custom-control-input:checked ~ .custom-control-label::after {
  margin-left: -6px;
}
.custom-switch:hover .custom-control-label::after {
  width: 28px !important;
}

.react-tagsinput {
  background-color: #fff;
  border-bottom: 2px solid #efefef;
  overflow: hidden;
  padding-top: 5px;
  transition: all 60ms ease-in;
}

.react-tagsinput--focused {
  border-bottom: 2px solid #2196f3;
}

.react-tagsinput-tag {
  cursor: pointer;
  overflow: hidden;
  position: relative;
  margin: 5px 3px 5px 0;
  padding: 2px 12px;
  border: 1px solid #888888;
  border-radius: 3px;
  color: #888888;
  font-weight: 500;
  font-size: 12px;
  text-transform: uppercase;
  display: inline-block;
  vertical-align: middle;
  transition: all 60ms ease-in;
}
.react-tagsinput-tag:hover {
  padding-left: 8px;
  padding-right: 16px;
}
.react-tagsinput-tag:hover a {
  opacity: 1;
  padding-right: 4px;
}
.react-tagsinput-tag a {
  transition: all 60ms ease-in;
  color: #888888;
  cursor: pointer;
  font-size: 12px;
  padding: 2px 0;
  position: absolute;
  right: 0;
  opacity: 0;
  text-align: right;
  text-decoration: none;
  top: 0;
  width: 100%;
  z-index: 2;
}
.react-tagsinput-tag a::before {
  content: "\\f00d";
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
}
.react-tagsinput-tag.tag-blue, .react-tagsinput-tag.tag-blue a {
  border-color: #447DF7;
  color: #447DF7;
}
.react-tagsinput-tag.tag-azure, .react-tagsinput-tag.tag-azure a {
  border-color: #23CCEF;
  color: #23CCEF;
}
.react-tagsinput-tag.tag-green, .react-tagsinput-tag.tag-green a {
  border-color: #275D38;
  color: #275D38;
}
.react-tagsinput-tag.tag-orange, .react-tagsinput-tag.tag-orange a {
  border-color: #FFA534;
  color: #FFA534;
}
.react-tagsinput-tag.tag-red, .react-tagsinput-tag.tag-red a {
  border-color: #FB404B;
  color: #FB404B;
}
.react-tagsinput-tag.tag-fill.tag-blue {
  border-color: #447DF7;
  color: #FFFFFF;
  background-color: #447DF7;
}
.react-tagsinput-tag.tag-fill.tag-azure {
  border-color: #23CCEF;
  color: #FFFFFF;
  background-color: #23CCEF;
}
.react-tagsinput-tag.tag-fill.tag-green {
  border-color: #275D38;
  color: #FFFFFF;
  background-color: #275D38;
}
.react-tagsinput-tag.tag-fill.tag-orange {
  border-color: #FFA534;
  color: #FFFFFF;
  background-color: #FFA534;
}
.react-tagsinput-tag.tag-fill.tag-red {
  border-color: #FB404B;
  color: #FFFFFF;
  background-color: #FB404B;
}
.react-tagsinput-tag.tag-fill, .react-tagsinput-tag.tag-fill a {
  color: #FFFFFF;
}

.react-tagsinput-remove {
  cursor: pointer;
  font-weight: bold;
}

.react-tagsinput-input {
  background: transparent;
  border: 0;
  color: #777;
  font-family: sans-serif;
  font-size: 13px;
  font-weight: 400;
  margin-bottom: 6px;
  margin-top: 1px;
  outline: none;
  padding: 5px;
  width: 80px;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/light-bootstrap-dashboard-pro-react.scss","webpack://./src/assets/scss/lbd/_variables.scss","webpack://./src/assets/scss/lbd/mixins/_morphing-buttons.scss","webpack://./src/assets/scss/lbd/_modals.scss","webpack://./src/assets/scss/lbd/_typography.scss","webpack://./src/assets/scss/lbd/_misc.scss","webpack://./src/assets/scss/lbd/mixins/_vendor-prefixes.scss","webpack://./src/assets/scss/lbd/_sidebar-and-main-panel.scss","webpack://./src/assets/scss/lbd/_fixed-plugin.scss","webpack://./src/assets/scss/lbd/_modal.scss","webpack://./src/assets/scss/lbd/_buttons.scss","webpack://./src/assets/scss/lbd/mixins/_buttons.scss","webpack://./src/assets/scss/lbd/mixins/_transparency.scss","webpack://./src/assets/scss/lbd/_social-buttons.scss","webpack://./src/assets/scss/lbd/mixins/_social-buttons.scss","webpack://./src/assets/scss/lbd/_inputs.scss","webpack://./src/assets/scss/lbd/mixins/_inputs.scss","webpack://./src/assets/scss/lbd/_alerts.scss","webpack://./src/assets/scss/lbd/_tables.scss","webpack://./src/assets/scss/lbd/mixins/_table-row.scss","webpack://./src/assets/scss/lbd/_checkbox-radio-switch.scss","webpack://./src/assets/scss/lbd/_navbars.scss","webpack://./src/assets/scss/lbd/mixins/_navbars.scss","webpack://./src/assets/scss/lbd/_footers.scss","webpack://./src/assets/scss/lbd/_tags.scss","webpack://./src/assets/scss/lbd/mixins/_labels.scss","webpack://./src/assets/scss/lbd/_tabs-navs-pagination.scss","webpack://./src/assets/scss/lbd/mixins/_tabs.scss","webpack://./src/assets/scss/lbd/_progress-bars.scss","webpack://./src/assets/scss/lbd/_sliders.scss","webpack://./src/assets/scss/lbd/_dropdown.scss","webpack://./src/assets/scss/lbd/_cards.scss","webpack://./src/assets/scss/lbd/_chartist.scss","webpack://./src/assets/scss/lbd/mixins/_chartist.scss","webpack://./src/assets/scss/lbd/_responsive.scss","webpack://./src/assets/scss/lbd/_bootstrap-switch.scss","webpack://./src/assets/scss/lbd/_partial-nucleo-icons.scss","webpack://./src/assets/scss/lbd/plugins/_animate.scss","webpack://./src/assets/scss/lbd/plugins/_sweetalert2.scss","webpack://./src/assets/scss/lbd/plugins/_jquery.jvectormap.scss","webpack://./src/assets/scss/lbd/plugins/_bootstrap-table.scss","webpack://./src/assets/scss/lbd/plugins/_datatables.net.scss","webpack://./src/assets/scss/lbd/plugins/_fullcalendar.scss","webpack://./src/assets/scss/lbd/plugins/_chartist.scss","webpack://./src/assets/scss/lbd/plugins/_perfect-scrollbar.scss","webpack://./src/assets/scss/lbd/plugins/_bootstrap-select.scss","webpack://./src/assets/scss/lbd/plugins/_datetime-picker.scss","webpack://./src/assets/scss/lbd/plugins/_nouislider.scss","webpack://./src/assets/scss/lbdpr/plugins/_nouislider.scss","webpack://./src/assets/scss/lbdpr/plugins/_react-big-calendar.scss","webpack://./src/assets/scss/lbdpr/plugins/_react-bootstrap-sweetalert.scss","webpack://./src/assets/scss/lbdpr/plugins/_react-bootstrap-wizard.scss","webpack://./src/assets/scss/lbdpr/_mixins.scss","webpack://./src/assets/scss/lbdpr/plugins/_react-datetime.scss","webpack://./src/assets/scss/lbdpr/plugins/_react-notification-alert.scss","webpack://./src/assets/scss/lbdpr/plugins/_react-select.scss","webpack://./src/assets/scss/lbdpr/plugins/_react-table.scss","webpack://./src/assets/scss/lbdpr/_alerts.scss","webpack://./src/assets/scss/lbdpr/_fixed-plugin.scss","webpack://./src/assets/scss/lbdpr/_navbars.scss","webpack://./src/assets/scss/lbdpr/_navs.scss","webpack://./src/assets/scss/lbdpr/_sidebar-and-main-panel.scss","webpack://./src/assets/scss/lbdpr/_switch.scss","webpack://./src/assets/scss/lbdpr/_tags-input.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;;;;;;;;;;;;;EAAA;ACYA,8BAAA;ACGA;EACI;IAAO,uBAAA;EFIT;EEHE;IAAK,yBAAA;EFMP;AACF;AGtBQ;EAGI,4BAAA;AHgDZ;AG5CQ;EACI,gBAAA;EACA,cAAA;AH8CZ;AG1CQ;EACI,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AH4CZ;AG1CY;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;AH4ChB;AG1CgB;EACI,eAAA;EACA,iBAAA;AH4CpB;AGvCQ;EACI,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;AHyCZ;AGtCQ;EACI,cAAA;AHwCZ;AGrCQ;EACI,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EAEA,8BAAA;AHuCZ;AGrCY;EACI,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;AHuChB;AGrCgB;EAEI,qBAAA;AHsCpB;;AIvGA,kCAAA;AACA;;;;;;;;;;;;;;;;EAgBI,kCAAA;EACA,mCAAA;EACA,0DAAA;EACA,gBHmMyB;ADzF7B;;AIvGA;EACI,gBH8LyB;EG7LzB,mBAAA;AJ0GJ;;AIvGA;EACI,kBH+K2B;ADrE/B;;AIxGA;EACI,kBH6K2B;ADlE/B;;AIzGA;EACI,kBH2K2B;EG1K3B,mBAAA;AJ4GJ;;AI1GA;EACI,mBHwK2B;EGvK3B,iBAAA;AJ6GJ;;AI3GA;EACI,mBHqK2B;EGpK3B,mBAAA;AJ8GJ;;AI5GA;EACI,mBHkK2B;EGjK3B,gBHyKyB;EGxKzB,yBAAA;AJ+GJ;;AI7GA;EACI,eH8J2B;EG7J3B,gBHsK2B;ADtD/B;;AI7GA;EACI,cH3ByB;EG4BzB,gBH4JyB;EG3JzB,gBHgK2B;ADhD/B;;AI7GA;EACI,cAAA;AJgHJ;;AI7GA;EACI,cAAA;EACA,gBAAA;AJgHJ;;AI7GA;EACI,cAAA;AJgHJ;;AI9GA;EACI,yBAAA;AJiHJ;;AI/GA;EACI,yBAAA;AJkHJ;;AIhHA;EACI,yBAAA;AJmHJ;;AIjHA;EACI,yBAAA;AJoHJ;;AIlHA;EACI,yBAAA;AJqHJ;;AIlHA;EACI,mBAAA;EACA,mBAAA;EACA,kBAAA;AJqHJ;AInHI;EACI,2BAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AJqHR;;AIjHA;EACI,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,2BAAA;AJoHJ;;AKnOA,8BAAA;AACA;;EAEI,iBAAA;EACA,kBAAA;ALsOJ;;AKpOA;EACE,cJJsB;AD2OxB;AKrOE;EACG,cJ0HwB;EIzHxB,qBAAA;ALuOL;;AKnOA;;;;;;;;EAQI,UAAA;ALsOJ;;AKpOA;;;EAGI,qBAAA;ALuOJ;;AKpOA,sCAAA;AACA;;;;;ECKI,4BAAA;AN2OJ;;AKvOA;;;;;;ECJI,4BAAA;ANwPJ;;AK3OA;;ECbI,6BAAA;ANiQJ;;AK/OA;EClBI,4BAAA;ANyQJ;;AKpPA;EACI,WAAA;EACA,kBAAA;ALuPJ;;AKrPA;EACI,gBAAA;ALwPJ;;AKrPA;EACI,kBAAA;EACA,MAAA;EACA,aAAA;ALwPJ;;AKrPA;EACI,aAAA;ALwPJ;AKtPI;EACI,aAAA;ALwPR;;AKhPI;EACI,kCAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;ALmPR;AKjPI;EACI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;ALmPR;AKjPI;EACI,6GAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;EACA,OAAA;EACA,aAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,UAAA;ALmPR;;AK7OA;;;;;EASI,4BAAA;ALgPJ;;AK5OI;EACI,0BAAA;AL+OR;AK3OgB;EACI,yBAAA;AL6OpB;;AOlXA;;;;;EAMI,uCAAA;EAEA,sCAAA;EAEA,gDAAA;EACA,iCAAA;APqXJ;;AOnXA;;;;;;;EDwBI,4BAAA;ANyWJ;;AOpXA;EACI,eAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,kCAAA;APuXJ;AOrXI;EACI,WAAA;EACA,qBAAA;EACA,gBAAA;APuXR;AOrXQ;EACI,WAAA;EACA,QAAA;EACA,kBAAA;EACA,SAAA;APuXZ;AOnXI;EACI,qBAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;APqXR;AOnXQ;EACI,WAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;APqXZ;AOlXQ;EACI,cAAA;EACA,UAAA;EDjBJ,iCAAA;AN0YR;AOrXQ;EACI,yBAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBN2HmB;EM1HnB,gBNwIiB;EMvIjB,iBAAA;EACA,mBAAA;EACA,cN+BiB;EM9BjB,gBAAA;APuXZ;AOpXQ;EACI,WAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;APsXZ;AOnXQ;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;EACA,WAAA;APqXZ;AOjXI;EACI,kBAAA;EACA,8BAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,UAAA;EACA,qBAAA;APmXR;AO7WwB;EACI,uBAAA;EACA,kBAAA;EACA,0BAAA;EACA,0BAAA;EACA,gBAAA;EACA,eAAA;AP+W5B;AOzW4B;EACI,qCAAA;AP2WhC;AOvWoB;EACI,UAAA;APyWxB;AOlWY;EACI,SAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EDhGR,iCAAA;ECkGQ,cAAA;EACA,YAAA;EACA,UAAA;APwWhB;AOpWQ;EACI,gBAAA;EACA,kBAAA;APsWZ;AOpWY;EACI,kBAAA;EACA,gBAAA;APsWhB;AOjWI;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,MAAA;EACA,OAAA;EACA,sBAAA;EACA,kCAAA;APmWR;AOhWI;EACI,iDAAA;EACA,oBAAA;EACA,gBAAA;APkWR;AOhWQ;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,0CAAA;APkWZ;AOhWY;EACI,WAAA;APkWhB;AO9VY;EACI,WAAA;EACA,SAAA;APgWhB;AO9VY;EACI,cN7Fa;EM8Fb,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;APgWhB;AO9VY;EACI,kBAAA;EACA,cAAA;APgWhB;AO7VgB;EACI,eAAA;AP+VpB;AO1VQ;EACI,2BAAA;EACA,6BAAA;AP4VZ;AO1VY;;EAEI,eAAA;EACA,eAAA;AP4VhB;AO1VY;EACI,UAAA;AP4VhB;AOvVI;EACI,qBAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,sBAAA;EACA,wBAAA;EACA,mCAAA;EACA,kCAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EDpNJ,6BAAA;ANkjBJ;AO1VI;;;EAGI,gEAAA;EAGA,yBAAA;AP4VR;AOzVI;EACI,WAAA;EACA,cAAA;AP2VR;AOxVY;EACI,cN3Ja;EM4Jb,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AP0VhB;AOxVgB;EACI,qCAAA;EACA,UAAA;AP0VpB;AOvVgB;EACI,eAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;APyVpB;AOrVY;EACI,qCAAA;EACA,UAAA;APuVhB;AOpVY;EACI,cN3La;EM4Lb,UAAA;EACA,qCAAA;APsVhB;AOlVY;EACI,cAAA;EACA,iDAAA;APoVhB;AOlVgB;EACI,gBAAA;APoVpB;AO5UI;EAEI,cAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;AP6UR;AO1UI;EACI,aAAA;EACA,mBAAA;AP4UR;AOxUI;EAEI,aAAA;APyUR;;AOhUQ;;EACI,WAAA;EACA,eAAA;EACA,iBAAA;EACA,cN/OiB;EMgPjB,iBAAA;EACA,2DAAA;APoUZ;AOjUQ;;EACI,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,mBNhKmB;EMiKnB,cNzPiB;EM0PjB,gBNpJiB;EMqJjB,iBAAA;EACA,mBAAA;EACA,gBAAA;APoUZ;AOjUQ;;EACI,WAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;APoUZ;AOjUQ;;EACI,kBAAA;EACA,cAAA;EACA,gBAAA;APoUZ;AOlUY;;EACI,WAAA;APqUhB;AOjUQ;;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;EACA,WAAA;EACA,0CAAA;APoUZ;AO/TQ;;EACI,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBNzMmB;EM0MnB,cNlSiB;EMmSjB,gBN7LiB;EM8LjB,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;APkUZ;AO5TI;;EDrUA,mBLmCyB;EK7BzB,iFAAA;EACA,0BAAA;ANqoBJ;AOpUI;;EDxUA,mBLjFoB;EKuFpB,+EAAA;EACA,0BAAA;ANgpBJ;AO5UI;;ED3UA,mBLtFoB;EK4FpB,gFAAA;EACA,0BAAA;AN2pBJ;AOpVI;;ED9UA,mBLnFoB;EKyFpB,gFAAA;EACA,0BAAA;ANsqBJ;AO5VI;;EDjVA,mBLlFoB;EKwFpB,+EAAA;EACA,0BAAA;ANirBJ;AOpWI;;EDpVA,mBLpFoB;EK0FpB,6EAAA;EACA,0BAAA;AN4rBJ;AO5WI;;EDvVA,mBLrFoB;EK2FpB,gFAAA;EACA,0BAAA;ANusBJ;;AO/WA;EACI,qCAAA;EACA,kBAAA;EACA,YAAA;EACA,yBN7N0B;AD+kB9B;AOhXI;EACI,kBAAA;EACA,+BAAA;APkXR;AO/WI;EACI,6BAAA;APiXR;AO9WI;EACI,gBAAA;APgXR;;AOpWoB;EACI,iBAAA;APuWxB;;AO9VA;;EAEI,yBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EAEA,mBAAA;APgWJ;;AO7VA;;;;EAII,SAAA;EACA,kBAAA;EACA,0BAAA;EACA,UAAA;EACA,mBAAA;EACA,qBAAA;EACA,iBAAA;APgWJ;;AO9VA;EACI,4BAAA;EACA,wBAAA;APiWJ;;AO5VA;EAEQ;IACI,wBAAA;EP8VV;EO5VM;IACI,gCAAA;EP8VV;EO5VM;IACI,WAAA;IACA,cAAA;IACA,gBAAA;IACA,UAAA;IACA,eAAA;EP8VV;EO3Vc;IACI,UAAA;EP6VlB;EO1Vc;IACI,UAAA;ID3dZ,mCAAA;EN4zBN;EO5VU;IACI,iBAAA;IACA,WAAA;IACA,gBAAA;EP8Vd;EO5Vc;;;;IDreR,mCAAA;IC0eY,UAAA;EPkWlB;EO3VsB;IACI,SAAA;IACA,gBAAA;EP6V1B;EOzVc;IACI,UAAA;EP2VlB;EOxVc;IACI,kBAAA;IACA,8BAAA;IACA,+BAAA;EP0VlB;EOvVc;IACI,eAAA;IACA,2BAAA;IACA,4BAAA;EPyVlB;EOnVkB;IACI,6BAAA;EPqVtB;EOhVU;IACI,YAAA;EPkVd;EO/UkB;IACI,UAAA;IDrhBhB,iCAAA;EN22BN;EOjVc;IACI,OAAA;EPmVlB;EOhVc;IACI,UAAA;EPkVlB;EO/Uc;IACI,YAAA;EPiVlB;EO/UkB;;;;;;IDriBZ,iCAAA;IC4iBgB,UAAA;EPqVtB;EO/U8B;IAEG,UAAA;EPgVjC;EOvUsB;IACI,4BAAA;EPyU1B;EOpUc;IACI,kBAAA;IACA,mBAAA;IACA,oBAAA;IACA,kBAAA;IACA,cAAA;IACA,aAAA;EPsUlB;EOjUM;IACI,wBAAA;IACA,iBAAA;EPmUV;EOhUM;IACI,YAAA;EPkUV;EO/TM;;IAEI,iBAAA;IACA,gBAAA;IACA,YAAA;EPiUV;EO9TM;IACI,mCAAA;EPgUV;AACF;AO1TA;EACI,gCAAA;AP4TJ;;AO1TA;EACI,wBAAA;AP6TJ;;AO3TA;EACI,kBAAA;AP8TJ;;AOrTA;EACI,iBAAA;EACA,YAAA;APwTJ;AOtTI;EACI,aAAA;APwTR;AOtTY;EACI,eAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;APwThB;AOnTY;EACI,qDAAA;APqThB;AOlTQ;EACI,qDAAA;EACA,wBAAA;ED5pBR,4BAAA;ANq9BJ;AOrTY;EACI,iBAAA;APuThB;AOlTI;EACI,kBAAA;EACA,UAAA;EACA,uBAAA;APoTR;AOnTQ;EACI,+BAAA;APqTZ;AOpTY;EACI,UAAA;APsThB;;AO/SI;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,MAAA;EACA,OAAA;EACA,sBAAA;EACA,kCAAA;APkTR;AO/SI;EAEI,cAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;APgTR;AO7SI;EACI,aAAA;AP+SR;AO1SQ;EACI,iBAAA;AP4SZ;AOxSI;EACI,8BAAA;EACA,UAAA;EACA,kBAAA;AP0SR;AOvSY;EACI,cNlpBa;AD27B7B;AOvSY;EACI,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,cNxpBa;ADi8B7B;AOvSY;EACI,6BAAA;APyShB;AOvSY;EACI,eAAA;APyShB;AOtSY;EACI,cAAA;EACA,mBAAA;APwShB;AOtSgB;EACI,WAAA;EACA,iBAAA;APwSpB;AOvSoB;EACI,eAAA;APySxB;AOrSgB;;EAEI,mBAAA;EACA,mBAAA;APuSpB;AOrSgB;EACI,gBAAA;APuSpB;AOrSgB;EACI,oBAAA;EACA,gBAAA;APuSpB;AOrSgB;EACI,mBAAA;EACA,iBAAA;APuSpB;AOjSI;EACI,iBAAA;APmSR;AO/RQ;EACI,iBAAA;APiSZ;AO9RI;EDluBA,mBLmCyB;EK7BzB,gEAAA;EACA,0BAAA;ANmgCJ;AOrSI;EDruBA,mBL+UkB;EKzUlB,gEAAA;EACA,0BAAA;AN6gCJ;AO5SI;EDxuBA,mBL0UkB;EKpUlB,gEAAA;EACA,0BAAA;ANuhCJ;AOnTI;ED3uBA,mBL6UkB;EKvUlB,gEAAA;EACA,0BAAA;ANiiCJ;AO1TI;ED9uBA,mBL8UkB;EKxUlB,gEAAA;EACA,0BAAA;AN2iCJ;AOjUI;EDjvBA,mBL4UkB;EKtUlB,gEAAA;EACA,0BAAA;ANqjCJ;AOxUI;EDpvBA,mBL2UkB;EKrUlB,gEAAA;EACA,0BAAA;AN+jCJ;;AO9UA;;EAEI,aAAA;APiVJ;;AQlqCQ;EACI,mBAAA;ARqqCZ;AQpqCY;EACI,6BAAA;ARsqChB;AQpqCY;EACI,2BAAA;ARsqChB;AQnqCgB;EACI,eAAA;ARqqCpB;AQjqCgB;EACI,kBAAA;EACA,sBAAA;ARmqCpB;AQjqCgB;EACI,gCAAA;ARmqCpB;;AQ5pCA;;EAEI,qBAAA;EACA,6BAAA;EACA,0BAAA;AR+pCJ;;AQ5pCA;EACI,eAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,8BAAA;EACA,aAAA;EACA,0BAAA;EACA,kBAAA;AR+pCJ;;AQ7pCA;EACI,cAAA;EACA,aAAA;EACA,0BAAA;EACA,WAAA;ARgqCJ;;AQ9pCA;EACI,WAAA;EACA,UAAA;EACA,YAAA;EACA,wBAAA;EACA,eAAA;ARiqCJ;;AQ/pCA;EACI,WAAA;EACA,iBAAA;EACA,UAAA;ARkqCJ;;AQhqCA;EACI,cAAA;ARmqCJ;;AQjqCA;EACI,cAAA;ARoqCJ;;AQjqCA;;;EAGI,cAAA;EACA,kBAAA;ARoqCJ;;AQjqCA;EACI,gBAAA;EACA,WAAA;EACA,aAAA;EACA,cAAA;ARoqCJ;;AQjqCA;;EAEI,gBAAA;ARoqCJ;;AQjqCA;EACI,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;ARoqCJ;;AQlqCA;;EAEI,qBAAA;ARqqCJ;;AQlqCA;EACI,sBAAA;ARqqCJ;;AQnqCA;EACI,yBAAA;ARsqCJ;;AQpqCA;EACI,yBAAA;ARuqCJ;;AQrqCA;EACI,yBAAA;ARwqCJ;;AQtqCA;EACI,yBAAA;ARyqCJ;;AQvqCA;EACI,yBAAA;AR0qCJ;;AQxqCA;EACI,yBAAA;AR2qCJ;;AQxqCA;EACI,eAAA;EACA,YAAA;AR2qCJ;;AQzqCA;EACI,cAAA;EACA,iBAAA;EACA,UAAA;EACA,WAAA;AR4qCJ;;AQzqCA;;;EAGI,WAAA;EACA,YAAA;EACA,mBAAA;AR4qCJ;;AQzqCA;EACI,YAAA;AR4qCJ;;AQ1qCA;EACI,kBAAA;AR6qCJ;;AQ1qCA;EACI,kBAAA;EACA,eAAA;EACA,YAAA;AR6qCJ;;AQ1qCA;EACI,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AR6qCJ;;AQ1qCA;EACI,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;AR6qCJ;;AQ1qCA;EACI,kBAAA;EACA,SAAA;AR6qCJ;;AQ1qCA;EACI,YAAA;AR6qCJ;;AQ1qCA;EACI,eAAA;AR6qCJ;;AQ1qCA;EACM,gBAAA;EACA,eAAA;EACA,iCAAA;EACA,gBAAA;EACA,SAAA;AR6qCN;;AQ3qCA;EACM,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;AR8qCN;;AQ3qCA;;EAEI,6BAAA;AR8qCJ;;AQ5qCA;;EAEI,qCAAA;AR+qCJ;;AQ7qCA;;EAEI,qBAAA;EACA,yBAAA;ARgrCJ;;AQ7qCA;EACI,gBAAA;ARgrCJ;;AQ7qCA;EACI,UAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;ARgrCJ;;AQ9qCA;EACI,iBAAA;ARirCJ;;AQ/qCA;EACI,gBAAA;ARkrCJ;;AQ/qCA;;;EAGI,kBAAA;ARkrCJ;;AQ/qCA;EF5KQ,4CAAA;EE8KJ,qBAAA;EACA,UAAA;EACA,uBAAA;EACA,qBAAA;ARsrCJ;;AQprCA;EACI,UAAA;EFpLI,2CAAA;EEsLJ,qBAAA;EACA,uBAAA;AR2rCJ;;AQxrCA;;EAEI,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,2BAAA;EACA,mCAAA;EACA,gCAAA;AR2rCJ;;AQxrCA;EACI,0CAAA;EACA,0CAAA;EACA,uCAAA;EACA,YAAA;AR2rCJ;;AQxrCA;EACI,0CAAA;EACA,4BAAA;EACA,uCAAA;EACA,YAAA;AR2rCJ;;AQxrCA;EAKI,2BAAA;AR2rCJ;;AQxrCA;EAKI,2BAAA;AR2rCJ;;ASz+CA;EACI,cAAA;AT4+CJ;;AS1+CA;EACI,cAAA;EACA,mBAAA;EACA,wEAAA;AT6+CJ;;AS3+CA;EACI,iBAAA;AT8+CJ;;AS5+CA;EACI,kBAAA;EACA,kBAAA;AT++CJ;;AS7+CA;EACI,gBAAA;ATg/CJ;;AS7+CA;EACI,eAAA;EACA,uBAAA;EACA,oBAAA;ATg/CJ;;AS9+CA;EACI,eAAA;EACA,uBAAA;EACA,oBAAA;ATi/CJ;;AS9+CI;EACI,gBAAA;ATi/CR;;AS7+CI;EACI,cAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eRwKuB;ADw0C/B;AS9+CI;EACI,kBAAA;EACA,WAAA;EACA,aAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,yBRzBqB;ADygD7B;AS9+CI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,yBRlCqB;ADkhD7B;AS9+CI;EACI,kBAAA;ATg/CR;;AS7+CA;EACI,kBAAA;ATg/CJ;AS9+CI;EACI,cAAA;ATg/CR;;AS7+CA;EACI,aAAA;ATg/CJ;;AU1jDA;EACE,iBT8G2B;ES7G3B,6BTsH2B;ESrH3B,gBToN2B;ESnN3B,iBAAA;ECFA,yBAAA;EACA,cV8G2B;EU7G3B,yBViB2B;EUhB3B,eAAA;EDCA,kBAAA;EACA,mBT+L6B;ES9L7B,uBAAA;AVgkDF;AWjkDE;EAKE,yBVgHyB;EU/GzB,cVoGyB;EUnGzB,qBV8GyB;ADi9C7B;AWxjDI;EAME,6BV6FuB;EU5FvB,qBVPuB;AD4jD7B;AWhjDE;EACE,cVbyB;EUczB,6BVqFyB;EUpFzB,yBAAA;ECjCF,UDkCmB;EC/BnB,0BAAA;AZklDF;AWjjDI;EAKI,yBVgFqB;EU/ErB,cVoEqB;EUnErB,yBAAA;AX+iDR;AW5iDI;EACI,yBV+DqB;AD++C7B;AW1iDE;EACI,oCAAA;EACA,wCAAA;EACA,cVpCuB;ADglD7B;AW1iDM;EAGI,qBAAA;EACA,yBVyDmB;EUxDnB,cV4DmB;AD8+C7B;AWriDE;EACI,yBVjDuB;ADwlD7B;AUnmDE;EAEE,qBAAA;EACA,gBAAA;AVomDJ;AUlmDE;EJHQ,gBIMN;EACA,qBAAA;AVmmDJ;AUhmDE;EACE,YTsI4B;AD49ChC;;AU5lDA;EC3BE,yBAAA;EACA,cV8G2B;EU7G3B,yBVIsB;EUHtB,eAAA;AX2nDF;AWznDE;EAKE,yBVoHyB;EUnHzB,cVoGyB;EUnGzB,qBVkHyB;ADqgD7B;AWhnDI;EAME,6BV6FuB;EU5FvB,qBVpBkB;ADioDxB;AWxmDE;EACE,cV1BoB;EU2BpB,6BVqFyB;EUpFzB,yBAAA;ECjCF,UDkCmB;EC/BnB,0BAAA;AZ0oDF;AWzmDI;EAKI,yBVoFqB;EUnFrB,cVoEqB;EUnErB,yBAAA;AXumDR;AWpmDI;EACI,yBV+DqB;ADuiD7B;AWlmDE;EACI,oCAAA;EACA,wCAAA;EACA,cVpCuB;ADwoD7B;AWlmDM;EAGI,qBAAA;EACA,yBVyDmB;EUxDnB,cV4DmB;ADsiD7B;AW7lDE;EACI,yBV9DkB;AD6pDxB;;AUroDA;EC9BE,yBAAA;EACA,cV8G2B;EU7G3B,yBVEsB;EUDtB,eAAA;AXuqDF;AWrqDE;EAKE,yBV4HyB;EU3HzB,cVoGyB;EUnGzB,qBV0HyB;ADyiD7B;AW5pDI;EAME,6BV6FuB;EU5FvB,qBVtBkB;AD+qDxB;AWppDE;EACE,cV5BoB;EU6BpB,6BVqFyB;EUpFzB,yBAAA;ECjCF,UDkCmB;EC/BnB,0BAAA;AZsrDF;AWrpDI;EAKI,yBV4FqB;EU3FrB,cVoEqB;EUnErB,yBAAA;AXmpDR;AWhpDI;EACI,yBV+DqB;ADmlD7B;AW9oDE;EACI,oCAAA;EACA,wCAAA;EACA,cVpCuB;ADorD7B;AW9oDM;EAGI,qBAAA;EACA,yBVyDmB;EUxDnB,cV4DmB;ADklD7B;AWzoDE;EACI,yBVhEkB;AD2sDxB;;AU9qDA;ECjCE,yBAAA;EACA,cV8G2B;EU7G3B,yBVDsB;EUEtB,eAAA;AXmtDF;AWjtDE;EAKE,yBVwHyB;EUvHzB,cVoGyB;EUnGzB,qBVsHyB;ADylD7B;AWxsDI;EAME,6BV6FuB;EU5FvB,qBVzBkB;AD8tDxB;AWhsDE;EACE,cV/BoB;EUgCpB,6BVqFyB;EUpFzB,yBAAA;ECjCF,UDkCmB;EC/BnB,0BAAA;AZkuDF;AWjsDI;EAKI,yBVwFqB;EUvFrB,cVoEqB;EUnErB,yBAAA;AX+rDR;AW5rDI;EACI,yBV+DqB;AD+nD7B;AW1rDE;EACI,oCAAA;EACA,wCAAA;EACA,cVpCuB;ADguD7B;AW1rDM;EAGI,qBAAA;EACA,yBVyDmB;EUxDnB,cV4DmB;AD8nD7B;AWrrDE;EACI,yBVnEkB;AD0vDxB;;AUvtDA;ECpCE,yBAAA;EACA,cV8G2B;EU7G3B,yBVGsB;EUFtB,eAAA;AX+vDF;AW7vDE;EAKE,yBVgIyB;EU/HzB,cVoGyB;EUnGzB,qBV8HyB;AD6nD7B;AWpvDI;EAME,6BV6FuB;EU5FvB,qBVrBkB;ADswDxB;AW5uDE;EACE,cV3BoB;EU4BpB,6BVqFyB;EUpFzB,yBAAA;ECjCF,UDkCmB;EC/BnB,0BAAA;AZ8wDF;AW7uDI;EAKI,yBVgGqB;EU/FrB,cVoEqB;EUnErB,yBAAA;AX2uDR;AWxuDI;EACI,yBV+DqB;AD2qD7B;AWtuDE;EACI,oCAAA;EACA,wCAAA;EACA,cVpCuB;AD4wD7B;AWtuDM;EAGI,qBAAA;EACA,yBVyDmB;EUxDnB,cV4DmB;AD0qD7B;AWjuDE;EACI,yBV/DkB;ADkyDxB;;AUhwDA;ECvCE,yBAAA;EACA,cV8G2B;EU7G3B,yBVCsB;EUAtB,eAAA;AX2yDF;AWzyDE;EAKE,yBVqIyB;EUpIzB,cVoGyB;EUnGzB,qBVmIyB;ADoqD7B;AWhyDI;EAME,6BV6FuB;EU5FvB,qBVvBkB;ADozDxB;AWxxDE;EACE,cV7BoB;EU8BpB,6BVqFyB;EUpFzB,yBAAA;ECjCF,UDkCmB;EC/BnB,0BAAA;AZ0zDF;AWzxDI;EAKI,yBVqGqB;EUpGrB,cVoEqB;EUnErB,yBAAA;AXuxDR;AWpxDI;EACI,yBV+DqB;ADutD7B;AWlxDE;EACI,oCAAA;EACA,wCAAA;EACA,cVpCuB;ADwzD7B;AWlxDM;EAGI,qBAAA;EACA,yBVyDmB;EUxDnB,cV4DmB;ADstD7B;AW7wDE;EACI,yBVjEkB;ADg1DxB;;AUzyDA;EC1CE,yBAAA;EACA,cV8G2B;EU7G3B,yBV6G2B;EU5G3B,eAAA;AXu1DF;AWr1DE;EAKE,yBVqGyB;EUpGzB,cVoGyB;EUnGzB,qBVmGyB;ADgvD7B;AW50DI;EAME,6BV6FuB;EU5FvB,qBVqFuB;ADovD7B;AWp0DE;EACE,cV+EyB;EU9EzB,6BVqFyB;EUpFzB,yBAAA;ECjCF,UDkCmB;EC/BnB,0BAAA;AZs2DF;AWr0DI;EAKI,yBVqEqB;EUpErB,cVoEqB;EUnErB,yBAAA;AXm0DR;AWh0DI;EACI,yBV+DqB;ADmwD7B;AW9zDE;EACI,oCAAA;EACA,wCAAA;EACA,cVpCuB;ADo2D7B;AW9zDM;EAGI,qBAAA;EACA,yBVyDmB;EUxDnB,cV4DmB;ADkwD7B;AWzzDE;EACI,yBV2CuB;ADgxD7B;AUl1DE;EAGE,yBT+DyB;ES9DzB,cT9ByB;ADg3D7B;AU/0DE;EAGE,cTpCyB;ADm3D7B;AU50DE;EAEE,6BAAA;AV60DJ;;AUx0DE;EEhEA,YFmEmB;EEhEnB,yBAAA;AZ04DF;;AUv0DA;EACE,iBToC2B;ESnC3B,8BAAA;EACA,iBAAA;AV00DF;AUx0DE;EACE,YTiF4B;ADyvDhC;;AUt0DA;ECPG,mBV6H4B;EU5H5B,kBV+G6B;EU9G7B,kBAAA;EDYD,gBT6H2B;ADysD7B;AWh1DG;EACI,kBAAA;AXk1DP;AW/0DG;EACI,kBAAA;AXi1DP;;AU10DA;EChBG,kBV2H4B;EU1H5B,kBV6G6B;EU5G7B,iBAAA;AX81DH;AW51DG;EACI,iBAAA;AX81DP;AW31DG;EACI,iBAAA;AX61DP;;AU70DA;EACE,gBAAA;AVg1DF;;AU70DA;EACE,WAAA;AVg1DF;;AU90DA;EACE,gBAAA;AVi1DF;;AU/0DA;EACE,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,UAAA;AVk1DF;;AUh1DA;EACE,aAAA;AVm1DF;;AUh1DA;EACE,wBAAA;UAAA,gBAAA;EAEA,SAAA;AVk1DF;;Aa98DA;EACC,gBAAA;Abi9DD;Aa/8DC;EACC,eAAA;EACA,WAAA;EACA,sBAAA;EACA,qBAAA;Abi9DF;Aa98DC;EACC,YAAA;Abg9DF;Aa78DC;EACC,gBAAA;EACA,eAAA;Ab+8DF;Aa78DE;EACC,eAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;Ab+8DH;;Aax8DA;EC5BE,qBb6YmB;Ea5YnB,yBb4YmB;Ea3YnB,cb8G2B;AD03D7B;Act+DE;EAKE,yBbqDwB;EapDxB,cbsGyB;EarGzB,qBbkYiB;ADkmDrB;Acj+DE;EAGE,6BbsGyB;EarGzB,qBb2XiB;ADsmDrB;Ac99DE;EACE,cbuXiB;EatXjB,6BbgGyB;Ea/FzB,yBAAA;Adg+DJ;Ac99DI;EAKI,yBb+BoB;Ea9BpB,cbgFqB;Ea/ErB,yBAAA;Ad49DR;Acx9DE;EACE,cbuWiB;EatWjB,6BbgFyB;Ea/EzB,yBAAA;Ad09DJ;Acx9DI;EAKI,6BbwEqB;EavErB,cbcoB;EabpB,yBAAA;Ads9DR;;Aav+DA;EChCE,qBb8YkB;Ea7YlB,yBb6YkB;Ea5YlB,cb8G2B;AD65D7B;AczgEE;EAKE,yBbuDuB;EatDvB,cbsGyB;EarGzB,qBbmYgB;ADooDpB;AcpgEE;EAGE,6BbsGyB;EarGzB,qBb4XgB;ADwoDpB;AcjgEE;EACE,cbwXgB;EavXhB,6BbgGyB;Ea/FzB,yBAAA;AdmgEJ;AcjgEI;EAKI,yBbiCmB;EahCnB,cbgFqB;Ea/ErB,yBAAA;Ad+/DR;Ac3/DE;EACE,cbwWgB;EavWhB,6BbgFyB;Ea/EzB,yBAAA;Ad6/DJ;Ac3/DI;EAKI,6BbwEqB;EavErB,cbgBmB;EafnB,yBAAA;Ady/DR;;AatgEA;ECpCE,qBb+YoB;Ea9YpB,yBb8YoB;Ea7YpB,cb8G2B;ADg8D7B;Ac5iEE;EAKE,yBbyDyB;EaxDzB,cbsGyB;EarGzB,qBboYkB;ADsqDtB;AcviEE;EAGE,6BbsGyB;EarGzB,qBb6XkB;AD0qDtB;AcpiEE;EACE,cbyXkB;EaxXlB,6BbgGyB;Ea/FzB,yBAAA;AdsiEJ;AcpiEI;EAKI,yBbmCqB;EalCrB,cbgFqB;Ea/ErB,yBAAA;AdkiER;Ac9hEE;EACE,cbyWkB;EaxWlB,6BbgFyB;Ea/EzB,yBAAA;AdgiEJ;Ac9hEI;EAKI,6BbwEqB;EavErB,cbkBqB;EajBrB,yBAAA;Ad4hER;;AariEA;ECxCE,qBbgZiB;Ea/YjB,yBb+YiB;Ea9YjB,cb8G2B;ADm+D7B;Ac/kEE;EAKE,yBb2D0B;Ea1D1B,cbsGyB;EarGzB,qBbqYe;ADwsDnB;Ac1kEE;EAGE,6BbsGyB;EarGzB,qBb8Xe;AD4sDnB;AcvkEE;EACE,cb0Xe;EazXf,6BbgGyB;Ea/FzB,yBAAA;AdykEJ;AcvkEI;EAKI,yBbqCsB;EapCtB,cbgFqB;Ea/ErB,yBAAA;AdqkER;AcjkEE;EACE,cb0We;EazWf,6BbgFyB;Ea/EzB,yBAAA;AdmkEJ;AcjkEI;EAKI,6BbwEqB;EavErB,cboBsB;EanBtB,yBAAA;Ad+jER;;AapkEA;EC5CE,qBbiZmB;EahZnB,yBbgZmB;Ea/YnB,cb8G2B;ADsgE7B;AclnEE;EAKE,yBb6DwB;Ea5DxB,cbsGyB;EarGzB,qBbsYiB;AD0uDrB;Ac7mEE;EAGE,6BbsGyB;EarGzB,qBb+XiB;AD8uDrB;Ac1mEE;EACE,cb2XiB;Ea1XjB,6BbgGyB;Ea/FzB,yBAAA;Ad4mEJ;Ac1mEI;EAKI,yBbuCoB;EatCpB,cbgFqB;Ea/ErB,yBAAA;AdwmER;AcpmEE;EACE,cb2WiB;Ea1WjB,6BbgFyB;Ea/EzB,yBAAA;AdsmEJ;AcpmEI;EAKI,6BbwEqB;EavErB,cbsBoB;EarBpB,yBAAA;AdkmER;;AanmEA;EChDE,qBbkZmB;EajZnB,yBbiZmB;EahZnB,cb8G2B;ADyiE7B;AcrpEE;EAKE,yBb+D6B;Ea9D7B,cbsGyB;EarGzB,qBbuYiB;AD4wDrB;AchpEE;EAGE,6BbsGyB;EarGzB,qBbgYiB;ADgxDrB;Ac7oEE;EACE,cb4XiB;Ea3XjB,6BbgGyB;Ea/FzB,yBAAA;Ad+oEJ;Ac7oEI;EAKI,yBbyCyB;EaxCzB,cbgFqB;Ea/ErB,yBAAA;Ad2oER;AcvoEE;EACE,cb4WiB;Ea3WjB,6BbgFyB;Ea/EzB,yBAAA;AdyoEJ;AcvoEI;EAKI,6BbwEqB;EavErB,cbwByB;EavBzB,yBAAA;AdqoER;;AaloEA;ECpDE,qBbmZiB;EalZjB,yBbkZiB;EajZjB,cb8G2B;AD4kE7B;AcxrEE;EAKE,yBbiE6B;EahE7B,cbsGyB;EarGzB,qBbwYe;AD8yDnB;AcnrEE;EAGE,6BbsGyB;EarGzB,qBbiYe;ADkzDnB;AchrEE;EACE,cb6Xe;Ea5Xf,6BbgGyB;Ea/FzB,yBAAA;AdkrEJ;AchrEI;EAKI,yBb2CyB;Ea1CzB,cbgFqB;Ea/ErB,yBAAA;Ad8qER;Ac1qEE;EACE,cb6We;Ea5Wf,6BbgFyB;Ea/EzB,yBAAA;Ad4qEJ;Ac1qEI;EAKI,6BbwEqB;EavErB,cb0ByB;EazBzB,yBAAA;AdwqER;;AajqEA;ECxDE,qBboZkB;EanZlB,yBbmZkB;EalZlB,cb8G2B;AD+mE7B;Ac3tEE;EAKE,yBbmE6B;EalE7B,cbsGyB;EarGzB,qBbyYgB;ADg1DpB;ActtEE;EAGE,6BbsGyB;EarGzB,qBbkYgB;ADo1DpB;AcntEE;EACE,cb8XgB;Ea7XhB,6BbgGyB;Ea/FzB,yBAAA;AdqtEJ;AcntEI;EAKI,yBb6CyB;Ea5CzB,cbgFqB;Ea/ErB,yBAAA;AditER;Ac7sEE;EACE,cb8WgB;Ea7WhB,6BbgFyB;Ea/EzB,yBAAA;Ad+sEJ;Ac7sEI;EAKI,6BbwEqB;EavErB,cb4ByB;Ea3BzB,yBAAA;Ad2sER;;AahsEA;EC5DE,qBbqZqB;EapZrB,yBboZqB;EanZrB,cb8G2B;ADkpE7B;Ac9vEE;EAKE,yBbqEgC;EapEhC,cbsGyB;EarGzB,qBb0YmB;ADk3DvB;AczvEE;EAGE,6BbsGyB;EarGzB,qBbmYmB;ADs3DvB;ActvEE;EACE,cb+XmB;Ea9XnB,6BbgGyB;Ea/FzB,yBAAA;AdwvEJ;ActvEI;EAKI,yBb+C4B;Ea9C5B,cbgFqB;Ea/ErB,yBAAA;AdovER;AchvEE;EACE,cb+WmB;Ea9WnB,6BbgFyB;Ea/EzB,yBAAA;AdkvEJ;AchvEI;EAKI,6BbwEqB;EavErB,cb8B4B;Ea7B5B,yBAAA;Ad8uER;;Aa/tEA;EChEE,qBbsZiB;EarZjB,yBbqZiB;EapZjB,cb8G2B;ADqrE7B;AcjyEE;EAKE,yBbuE6B;EatE7B,cbsGyB;EarGzB,qBb2Ye;ADo5DnB;Ac5xEE;EAGE,6BbsGyB;EarGzB,qBboYe;ADw5DnB;AczxEE;EACE,cbgYe;Ea/Xf,6BbgGyB;Ea/FzB,yBAAA;Ad2xEJ;AczxEI;EAKI,yBbiDyB;EahDzB,cbgFqB;Ea/ErB,yBAAA;AduxER;AcnxEE;EACE,cbgXe;Ea/Wf,6BbgFyB;Ea/EzB,yBAAA;AdqxEJ;AcnxEI;EAKI,6BbwEqB;EavErB,cbgCyB;Ea/BzB,yBAAA;AdixER;;Aa9vEA;ECpEE,qBbuZiB;EatZjB,yBbsZiB;EarZjB,cb8G2B;ADwtE7B;Acp0EE;EAKE,yBbyE0B;EaxE1B,cbsGyB;EarGzB,qBb4Ye;ADs7DnB;Ac/zEE;EAGE,6BbsGyB;EarGzB,qBbqYe;AD07DnB;Ac5zEE;EACE,cbiYe;EahYf,6BbgGyB;Ea/FzB,yBAAA;Ad8zEJ;Ac5zEI;EAKI,yBbmDsB;EalDtB,cbgFqB;Ea/ErB,yBAAA;Ad0zER;ActzEE;EACE,cbiXe;EahXf,6BbgFyB;Ea/EzB,yBAAA;AdwzEJ;ActzEI;EAKI,6BbwEqB;EavErB,cbkCsB;EajCtB,yBAAA;AdozER;;Aa7xEA;ECxEE,qBbwZkB;EavZlB,yBbuZkB;EatZlB,cb8G2B;AD2vE7B;Acv2EE;EAKE,yBb2E6B;Ea1E7B,cbsGyB;EarGzB,qBb6YgB;ADw9DpB;Acl2EE;EAGE,6BbsGyB;EarGzB,qBbsYgB;AD49DpB;Ac/1EE;EACE,cbkYgB;EajYhB,6BbgGyB;Ea/FzB,yBAAA;Adi2EJ;Ac/1EI;EAKI,yBbqDyB;EapDzB,cbgFqB;Ea/ErB,yBAAA;Ad61ER;Acz1EE;EACE,cbkXgB;EajXhB,6BbgFyB;Ea/EzB,yBAAA;Ad21EJ;Acz1EI;EAKI,6BbwEqB;EavErB,cboCyB;EanCzB,yBAAA;Adu1ER;;Aez4EA;ECMG,cfqB0B;EWxB3B,UIIkB;EJDlB,0BAAA;AZy4EF;;Ae54EA;ECGG,cfqB0B;EWxB3B,UIIkB;EJDlB,0BAAA;AZ+4EF;;Ae/4EA;ECAG,cfqB0B;EWxB3B,UIIkB;EJDlB,0BAAA;AZq5EF;;Ael5EA;ECHG,cfqB0B;EWxB3B,UIIkB;EJDlB,0BAAA;AZ25EF;;Aep5EA;EACI,yBdoGyB;EcnGzB,yBAAA;EACA,kBd2K4B;Ec1K5B,mBAAA;EACA,cAAA;ECjBA,iBAAA;EACA,YfkM2B;EKxLrB,gBSQN;Afy5EJ;Aev5EI;EACO,yBd2FkB;Ec1FlB,yBAAA;ETZD,gBSaC;EACA,qBAAA;EACA,cAAA;Af05EX;Aev5EI;EAII,qBdRqB;EKdnB,gBSuBF;Afu5ER;Aep5EI;EACI,qBdjCgB;EckChB,cdlCgB;ADw7ExB;Aep5EI;EACI,cdtCgB;AD47ExB;Aep5EI;EACI,qBdzCgB;AD+7ExB;Aen5EI;EACI,kBd0IwB;EczIxB,mBdmJuB;EclJvB,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,sBAAA;Afq5ER;Ael5EI;EACI,0BAAA;EACA,gCAAA;Afo5ER;;Aeh5EA;EACI,YAAA;EACA,kBAAA;Afm5EJ;;Ae/4EI;EACI,cdnEgB;ADq9ExB;;Ae94EI;EACI,cdvEgB;ADw9ExB;;Ae54EA;EACI,yBd8ByB;Ec7BzB,yBAAA;EACA,kBdsG4B;ADyyEhC;Ae74EI;EAEI,yBdwBqB;EcvBrB,yBAAA;Af84ER;Ae54EI;EACI,qBdxFgB;EcyFhB,cdzFgB;ADu+ExB;Ae54EI;EACI,qBd3FgB;Ec4FhB,cd5FgB;AD0+ExB;Ae54EI;EAEI,yBdWqB;EcVrB,qBdzEqB;ADs9E7B;;Aez4EA;;;;EAII,oBAAA;Af44EJ;;Ae14EA;;;;EAII,mBAAA;Af64EJ;;Ae34EA;EACI,yBdJyB;EcKzB,cdpGyB;EcqGzB,mBAAA;Af84EJ;;Ae34EA;EACI,iBdhByB;EciBzB,iBAAA;Af84EJ;;Ae54EA;EACI,qBdvGyB;ADs/E7B;;Ae54EA;EACI,cAAA;Af+4EJ;;Ae54EA;EACI,qBd5GyB;AD2/E7B;;Ae54EA;EACI,cAAA;EACA,iBAAA;Af+4EJ;;Ae34EI;EACI,iBAAA;EACA,iBAAA;Af84ER;Ae54EI;;;EAGI,gBAAA;Af84ER;;Aez4EI;EACI,cd3JgB;Ec4JhB,oBAAA;EACA,gBAAA;Af44ER;;Aev4EI;EACI,wBAAA;Af04ER;;AiBljFA;EACI,SAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AjBqjFJ;AiBnjFI;EACI,kBAAA;AjBqjFR;AiBljFI;EACI,gBAAA;EACA,OAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AjBojFR;AiBljFI;EACI,SAAA;AjBojFR;AiBjjFI;EACI,eAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;AjBmjFR;AiBhjFI;EACI,0BAAA;EACA,8CAAA;AjBkjFR;AiB/iFI;EACI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,iBAAA;EACA,aAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;AjBijFR;AiB/iFQ;EACI,aAAA;AjBijFZ;AiB7iFI;EACI,cAAA;EACA,cAAA;AjB+iFR;AiB5iFI;EACI,4BAAA;EACA,kBhBuHwB;ADu7EhC;AiB3iFI;EACI,kBAAA;AjB6iFR;;AiB1iFA;EACI,yBhBuWwB;ADssE5B;;AiB3iFA;EACK,yBhBqWuB;ADysE5B;;AiB5iFA;EACI,yBhBmWwB;AD4sE5B;;AiB7iFA;EACK,yBhBiWuB;AD+sE5B;;AiB9iFA;EACK,yBhB+VuB;ADktE5B;;AkBvoFG;;EAEK,kBAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;AlB0oFR;AkBxoFG;;;;;;EAMI,iBAAA;EACA,sBAAA;EACA,qBjBOsB;ADmoF7B;AkBvoFI;EACI,wBAAA;EACA,kBjB+KuB;EiB9KvB,yBAAA;EACA,cjBIqB;EiBHrB,gBjB4LqB;EiB3LrB,mBAAA;AlByoFR;AkBtoFI;EACI,+BAAA;AlBwoFR;AkBroFG;ENhCD,aMiCuB;EN9BvB,yBAAA;AZsqFF;AkBtoFQ;EACI,iBAAA;EACA,kBAAA;AlBwoFZ;AkBroFI;EACI,eAAA;AlBuoFR;AkBpoFI;EACI,kBAAA;EACA,0BAAA;AlBsoFR;AkBloFY;ENlDV,UMmD+B;ENhD/B,0BAAA;AZqrFF;AkBjoFI;EACI,8BAAA;EACA,2BAAA;AlBmoFR;AkBhoFI;EACI,cjB7DgB;AD+rFxB;AkBhoFI;EACI,cjB9DgB;ADgsFxB;AkBhoFI;EACI,cjBhEgB;ADksFxB;AkBhoFI;EACI,cjBlEgB;ADosFxB;AkB9nFQ;;;EAGI,iBAAA;AlBgoFZ;;AkBznFQ;;EAEI,kBAAA;AlB4nFZ;AkBznFQ;;EAEI,mBAAA;EACA,cAAA;AlB2nFZ;;AkBrnFI;EACI,mBjB2GuB;EiB1GvB,yBAAA;EACA,cjB1EqB;EiB2ErB,gBjB8GqB;AD0gF7B;AkBtnFI;EACI,mBjB0FuB;AD8hF/B;AkBtnFQ;EACI,cAAA;EACA,kBAAA;AlBwnFZ;AkBrnFI;EAEG,gBjBiGsB;EiBhGtB,mBjB0FwB;AD4hF/B;AkBpnFI;EACI,gBAAA;AlBsnFR;AkBpnFI;EACI,iBAAA;EACA,gBAAA;AlBsnFR;AkBpnFQ;EACI,iBAAA;AlBsnFZ;AkBlnFI;EACI,WAAA;EACA,eAAA;AlBonFR;AkBlnFQ;EACI,YAAA;AlBonFZ;AkBjnFI;EACI,YAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;EAEA,kBjB0CwB;ADwkFhC;AkBhnFQ;EACI,WAAA;AlBknFZ;;AkB1mFI;EACI,4BAAA;AlB6mFR;AkB1mFY;EACI,2BAAA;AlB4mFhB;AkB1mFY;EACI,2BAAA;AlB4mFhB;;AkBnmFI;;EACI,4BAAA;AlBumFR;AkBrmFQ;;EACI,8BAAA;AlBwmFZ;;AkBlmFI;EACI,4BAAA;AlBqmFR;AkBnmFQ;EACI,8BAAA;AlBqmFZ;;AkB/lFI;EACI,0BAAA;AlBkmFR;AkB9lFY;EACI,cAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AlBgmFhB;AkB9lFgB;EACI,yBAAA;AlBgmFpB;AkB5lFgB;EACI,yCAAA;AlB8lFpB;;AkBnlFY;EACI,uBAAA;EACA,0BAAA;AlBslFhB;AkBllFI;EACI,YAAA;AlBolFR;AkBllFI;EACI,eAAA;AlBolFR;;AkB9kFQ;EACI,gBAAA;EACA,oBAAA;AlBilFZ;AkBhlFY;EACI,YAAA;AlBklFhB;AkB/kFQ;EACI,eAAA;AlBilFZ;AkB9kFI;EACI,4BAAA;AlBglFR;AkB9kFI;EACI,cAAA;AlBglFR;AkB9kFI;EACI,2BAAA;AlBglFR;;AkB5kFA;EACI,kBAAA;EACA,mBAAA;EACA,wBAAA;AlB+kFJ;;AmBr1FI;;;;;;;;;;EAIE,uClBQuB;ADs1F7B;;AmBz1FI;;EAKE,wCAAA;AnBy1FN;;AmBv2FI;;;;;;;;;;EAIE,yClBOuB;ADy2F7B;;AmB32FI;;EAKE,yCAAA;AnB22FN;;AmBz3FI;;;;;;;;;;EAIE,yClBSuB;ADy3F7B;;AmB73FI;;EAKE,yCAAA;AnB63FN;;AmB34FI;;;;;;;;;;EAIE,wClBUuB;AD04F7B;;AmB/4FI;;EAKE,wCAAA;AnB+4FN;;AoBj6FA;;EAEI,mBAAA;EACA,kBAAA;ApBo6FJ;;AoBh6FI;EACI,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,0BAAA;ApBm6FR;AoBh6FI;;EAEI,kCAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EdNJ,+BAAA;AN66FJ;AoBp6FI;EACI,kCAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,cnBjCgB;EmBkChB,SAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;ApBs6FR;AoBp6FI;EACI,kBAAA;ApBs6FR;AoBn6FQ;EACI,cnBjBiB;EmBkBjB,YAAA;EACA,mBAAA;ApBq6FZ;;AoB75FQ;EACI,kBAAA;ApBg6FZ;;AoB35FA;;;;EAII,WAAA;EACA,oBAAA;ApB85FJ;;AoB35FA;EACI,mBAAA;ApB85FJ;;AoB35FA;;EAEI,UAAA;EACA,kBAAA;EACA,kBAAA;ApB85FJ;;AoB55FA;EACI,UAAA;ApB+5FJ;;AoB55FA;EACI,UAAA;ApB+5FJ;;AoB55FA;;EAEI,mBAAA;ApB+5FJ;;AoB55FA;;EAEI,+BAAA;ApB+5FJ;;AoB55FA;EACI,qBAAA;ApB+5FJ;;AoB15FI;EACI,oBAAA;ApB65FR;AoB15FQ;EACI,cnBhFiB;EmBiFjB,YAAA;EACA,mBAAA;ApB45FZ;;AoBv5FA;EACI,0BAAA;EACA,gBAAA;EACA,eAAA;EACA,mCAAA;EACA,kCAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;ApB05FJ;;AoBv5FA;;EAEI,UAAA;Ed7GA,+BAAA;Ec+GA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;ApB85FJ;;AoB35FA;EACI,0BAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;ApB85FJ;;AoB35FA;EACI,UAAA;Ed9HA,+BAAA;ANiiGJ;;AoB/5FA;EACI,UAAA;EdnIA,+BAAA;AN0iGJ;;AoBn6FA;;EAEI,cnBjIyB;ADuiG7B;;AoB/5FY;EACI,6BAAA;ApBk6FhB;;AqBvkGQ;;EAEI,6BAAA;ArB0kGZ;;AqBrkGA;EACI,SpBmGyB;EoBlGzB,epBwM2B;EoBvM3B,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,2CpBmawB;EoBlaxB,2CAAA;ArBwkGJ;AqBtkGI;EACI,gBAAA;EACA,eAAA;EACA,eAAA;EACA,cpBDqB;ADykG7B;AqBtkGQ;EACI,cAAA;ArBwkGZ;AqBpkGI;EACI,oBAAA;EACA,mBAAA;ArBskGR;AqBnkGI;EACI,WAAA;EACA,YAAA;EACA,sBAAA;EACA,UAAA;EACA,eAAA;ArBqkGR;AqBnkGQ;EACI,kBAAA;EACA,OAAA;EACA,eAAA;ArBqkGZ;AqBlkGQ;EACI,gBAAA;ArBokGZ;AqBjkGQ;EACI,UAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;ArBmkGZ;AqBjkGQ;EACI,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;ArBmkGZ;AqB/jGI;EACI,gBAAA;ArBikGR;AqB3jGY;EACI,cpBvDa;EoBwDb,kBpBgQiB;EoB/PjB,gBpBgQiB;EoB/PjB,kBAAA;EACA,oBAAA;EACA,iBAAA;ArB6jGhB;AqB3jGgB;EACI,gBpB8Pa;EoB7Pb,iBAAA;ArB6jGpB;AqB1jGgB;EACI,gBpB0Pa;ADk0FjC;AqBzjGgB;;;;;;EAMI,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,QAAA;ArB2jGpB;AqBxjGgB;EACI,cpBtGI;ADgqGxB;AqBvjGgB;EACI,iBAAA;ArByjGpB;AqBrjGY;EACI,mBpB2Ee;EoB1Ef,gBAAA;ArBujGhB;AqBpjGoB;EACI,4BAAA;EACA,6BAAA;ArBsjGxB;AqBpjGoB;EACI,+BAAA;EACA,gCAAA;ArBsjGxB;AqBljGgB;EACI,WAAA;EACA,aAAA;EACA,gBAAA;EACA,yBAAA;ArBojGpB;AqB/iGQ;EACI,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,cpBjCiB;EoBkCjB,iBAAA;EACA,iBAAA;EACA,SAAA;EACA,SAAA;ArBijGZ;AqB9iGQ;EACI,qBAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;EACA,wBAAA;EACA,mCAAA;EACA,kCAAA;ArBgjGZ;AqB7iGI;EACG,gBpBsL0B;EoBrL1B,mBpB8BwB;ADihG/B;AqB7iGI;EACI,epB6BuB;ADkhG/B;AqB5iGI;EACI,sCAAA;EACA,QAAA;EACA,UAAA;EACA,gBAAA;ArB8iGR;;AqBxiGI;EACI,cpBxEqB;EoByErB,iBAAA;ETvLN,YSwLuB;ETrLvB,yBAAA;AZiuGF;AqB1iGQ;EAEI,6BAAA;ET5LV,US6L2B;ET1L3B,0BAAA;ES2LU,cpBhFiB;AD4nG7B;AqBtiGY;EACI,cpBvFa;EoBwFb,qBpBxFa;EW9G3B,YSuM+B;ETpM/B,yBAAA;AZ6uGF;AqBniGY;;;;;;;;;;;EAGI,6BAAA;EACA,kBAAA;EACA,cpBpGa;EW9G3B,YSmN+B;EThN/B,yBAAA;AZ8vGF;AqB5iGgB;;;;;;;;;;;;;;;;;;;;;ETrNd,USuNmC;ETpNnC,0BAAA;AZsxGF;AqB7jGQ;EACI,6BAAA;ArB+jGZ;AqB3jGY;;;;;EAGI,6BAAA;EACA,cpBvHa;EW9G3B,USsO+B;ETnO/B,0BAAA;AZmyGF;AqB3jGI;EACI,cpB9HqB;EoB+HrB,qBpB/HqB;AD4rG7B;AqB3jGI;EACI,cpBrNqB;EoBsNrB,yBpBnIqB;EW9G3B,YSkPuB;ET/OvB,yBAAA;AZ6yGF;AqB5jGI;;;;;;;;;EAKI,qBpB3IqB;EW9G3B,US0PuB;ETvPvB,0BAAA;AZ0zGF;;AqB9jGI;EACI,0CAAA;ArBikGR;;AqB5jGA;EACI,2CpByKwB;EoBxKxB,2CAAA;ArB+jGJ;AqB3jGY;EACI,cpBjPa;AD8yG7B;AqBzjGQ;;;;;EAKI,6BAAA;EACA,kBAAA;EACA,cpBvRY;EWAtB,USwR2B;ETrR3B,0BAAA;AZi1GF;AqBxjGY;;;EAGI,6BAAA;EACA,cpBhSQ;AD01GxB;AqBrjGQ;EACI,6BAAA;ArBujGZ;AqBljGI;EACI,cpB5SgB;EoB6ShB,qBpB7SgB;ADi2GxB;AqBljGI;EAGQ,cpBvRiB;ADy0G7B;;AqB9iGA,sCAAA;AAGI;EACI,gBAAA;EACA,mBAAA;ArB+iGR;AqB3iGY;EACI,kBAAA;EACA,iBpBiBiB;EoBhBjB,epBiBiB;AD4hGjC;AqBziGQ;EACI,eAAA;EACA,kBAAA;ArB2iGZ;AqBziGQ;EACI,eAAA;ArB2iGZ;;AqBtiGA;EfvUU,gBewUP;ArB0iGH;AqBziGG;EL1UC,gBAAA;EACA,SAAA;EACA,UAAA;EACA,6BAAA;EKyUI,YAAA;EACA,epBrIuB;EoBsIvB,gBpB9HuB;EoB+HvB,cpBhUqB;AD82G7B;AqB5iGI;EAEI,cpB7OqB;EoB8OrB,SpBlPqB;EoBmPrB,iDAAA;ArB6iGR;;AqBxiGA;ECpWI,yBrBkbwB;AD89F5B;;AqBziGA;ECvWI,yBrBmbwB;ADi+F5B;;AqB1iGA;EC1WI,yBrBobwB;ADo+F5B;;AqB3iGA;EC7WI,yBrBqbwB;ADu+F5B;;AqB5iGA;EChXI,yBrBsbwB;AD0+F5B;;AqB5iGA;EACI,iBAAA;EACA,6BAAA;EACA,oCAAA;EACA,YAAA;ArB+iGJ;AqB7iGQ;EACI,mBpB3QiB;AD0zG7B;;AqB1iGA;EACI,gBAAA;EACA,mBAAA;EACA,SpBvRyB;ADo0G7B;AqB3iGI;EACI,yBpBtRqB;ADm0G7B;AqB3iGK;;EAEG,yBAAA;ArB6iGR;AqB1iGI;EAEI,6BAAA;ArB2iGR;;AqBtiGI;EACI,eAAA;EACA,QAAA;EACA,yBAAA;EACA,aAAA;ArByiGR;AqBviGI;EACI,iBAAA;ArByiGR;;AqBpiGI;EACI,eAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,cpBtTqB;AD61G7B;AqBniGQ,oFAAA,wBAAA;EACI,cpB3TiB;ADg2G7B;AqBniGQ,2EAAA,gBAAA;EACI,cpB9TiB;ADm2G7B;AqBniGQ,+EAAA,WAAA;EACI,cpBjUiB;ADs2G7B;AqBniGQ,0EAAA,gBAAA;EACI,cpBpUiB;ADy2G7B;;AqB/hGI;EACI,cAAA;ArBkiGR;;AuB99GA;EACI,yBtBgHyB;EsB/GzB,WAAA;AvBi+GJ;AuB/9GI;EACI,YAAA;AvBi+GR;AuB99GI;EACI,gBAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;AvBg+GR;AuB99GQ;EACI,ctBeiB;EsBdjB,cAAA;EACA,kBAAA;AvBg+GZ;AuB/9GY;EAEI,ctBwGa;ADw3G7B;AuB59GI;EACI,eAAA;AvB89GR;AuB79GQ;EACI,oBAAA;AvB+9GZ;AuB59GI;EACG,ctBDsB;EsBEtB,qBAAA;EACA,mBAAA;EACA,iBtB8S0B;EsB7S1B,kBtBuKwB;EsBtKxB,mBAAA;EACA,iBtBuLuB;EsBtLvB,kBAAA;AvB89GP;AuB79GO;EAEI,ctBmFkB;AD24G7B;AuB39GI;EACI,ctB+EqB;EsB9ErB,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBtBqJuB;ADw0G/B;AuB39GI;EACI,qBtBzBqB;ADs/G7B;AuB39GI;EACI,ctBqEqB;ADw5G7B;;AuBz9GA;EACI,yBtBwDyB;ADo6G7B;;AuBx9GI;EACG,mBtBqIwB;ADs1G/B;AuB19GO;EACK,iBAAA;EACA,WAAA;AvB49GZ;AuB19GQ;EACI,iBAAA;EACA,0BAAA;AvB49GZ;;AuBv9GA;;EAEI,sBAAA;AvB09GJ;;AwBxiHA;EAEI,gBAAA;EACA,gBAAA;AxB0iHJ;AwBziHI;EAEI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,4BAAA;ECVH,iBAAA;EACA,yBAAA;EACA,kBxBuL2B;EwBtL3B,cxBiBwB;EwBhBxB,gBxBmNwB;EwBlNxB,kBxBiM0B;EwBhM1B,yBAAA;EACA,qBAAA;EACA,sBAAA;EDIG,6BAAA;EACA,yBAAA;EACA,0BAAA;AxBkjHR;AwBhjHQ;ECJH,qBxBLmB;EwBMnB,cxBNmB;AD6jHxB;AwBhjHQ;ECRH,qBxBVmB;EwBWnB,cxBXmB;ADskHxB;AwBhjHQ;ECZH,qBxBPmB;EwBQnB,cxBRmB;ADukHxB;AwBhjHQ;EChBH,qBxBNmB;EwBOnB,cxBPmB;AD0kHxB;AwBhjHQ;ECpBH,qBxBRmB;EwBSnB,cxBTmB;ADglHxB;AwB/iHQ;ElBDJ,4BAAA;ANujHJ;AwBjjHI;EACI,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,8BAAA;AxBmjHR;AwBljHQ;EACI,qBAAA;EACA,YAAA;EACA,kBAAA;AxBojHZ;AwB/iHI;EACI,cvBlCqB;EuBmCrB,eAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EZ3DN,YY4DuB;EZzDvB,yBAAA;AZ2mHF;AwBhjHQ;EZ9DN,UYgE2B;EZ7D3B,0BAAA;AZ+mHF;AwB/iHI;EACI,gBAAA;EACA,0BAAA;AxBijHR;AwB9iHI;EAEI,eAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,iBAAA;EACA,qBAAA;EACA,MAAA;EACA,WAAA;EACA,UAAA;AxB+iHR;AwB7iHI;EACI,UAAA;EACA,kBAAA;AxB+iHR;AwB7iHI;EACI,gBAAA;EACA,0BAAA;EACA,cvB7FgB;AD4oHxB;AwB7iHI;EACI,qBAAA;EACA,sBAAA;AxB+iHR;AwB7iHI;EACI,uBAAA;EACA,YAAA;EACA,cvBlFqB;EuBmFrB,SAAA;EACA,+BAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AxB+iHR;AwB1iHQ;ECnGH,qBxBTmB;EwBUnB,cxB+FwB;EwB9FxB,yBxBXmB;AD2pHxB;AwB5iHQ;ECtGH,qBxBdmB;EwBenB,cxB+FwB;EwB9FxB,yBxBhBmB;ADqqHxB;AwB9iHQ;ECzGH,qBxBXmB;EwBYnB,cxB+FwB;EwB9FxB,yBxBbmB;ADuqHxB;AwBhjHQ;EC5GH,qBxBVmB;EwBWnB,cxB+FwB;EwB9FxB,yBxBZmB;AD2qHxB;AwBljHQ;EC/GH,qBxBZmB;EwBanB,cxB+FwB;EwB9FxB,yBxBdmB;ADkrHxB;AwBnjHI;EACI,cvBpBqB;ADykH7B;;A0B1rHA,8CAAA;AAGI;EACI,cAAA;A1B2rHR;A0BzrHI;EACI,yBAAA;EACA,gBAAA;EACA,czBNgB;EyBOhB,iBAAA;A1B2rHR;A0BzrHQ;EAEI,yBAAA;A1B0rHZ;A0BvrHI;;;EAGI,yBzBjBgB;EyBkBhB,cAAA;A1ByrHR;A0BvrHI;EACI,0BAAA;EACA,SAAA;A1ByrHR;A0BvrHI;EACI,0BAAA;A1ByrHR;;A0BlrHQ;EACI,kBAAA;EACA,aAAA;EACA,cAAA;EACA,iBAAA;A1BqrHZ;A0BnrHY;EACI,sBAAA;EACA,kBAAA;A1BqrHhB;A0BhrHY;EACI,yBAAA;EACA,SAAA;EACA,yBAAA;EACA,iBAAA;A1BkrHhB;A0BzqHY;EACI,kBAAA;A1B2qHhB;;A0BrqHA;EACI,YAAA;A1BwqHJ;;A0BrqHA;;EAEI,SAAA;A1BwqHJ;;A0BtqHA;;;;;;EAMI,kBAAA;EACA,aAAA;EACA,czBwCyB;ADioH7B;;A0BvqHA;;;;;;EAMI,yBzBzFoB;EyB0FpB,SAAA;EACA,cAAA;EACA,iBAAA;A1B0qHJ;;A0BrqHQ;;;EAGG,yBzB/Fa;ADuwHxB;;A0BjqHQ;;;;;;EAMI,oCAAA;A1BoqHZ;;A0B7pHQ;;;EAGG,yBzB3Ha;AD2xHxB;;A0BzpHQ;;;;;;EAMI,oCAAA;A1B4pHZ;;A0BrpHQ;;;EAGG,yBzB/Ia;ADuyHxB;;A0BjpHQ;;;;;;EAMI,oCAAA;A1BopHZ;;A0B7oHQ;;;EAGG,yBzBrKa;ADqzHxB;;A0BzoHQ;;;;;;EAMI,oCAAA;A1B4oHZ;;A0BroHQ;;;EAGG,yBzB9La;ADs0HxB;;A0BjoHQ;;;;;;EAMI,oCAAA;A1BooHZ;;A0B1nHY;EACI,iBAAA;A1B6nHhB;;A0BvnHA;EChOI,yBAAA;EACA,c1BMoB;ADq1HxB;;A0BznHA;ECnOI,yBAAA;EACA,c1BCoB;AD+1HxB;;A0B3nHA;ECtOI,yBAAA;EACA,c1BIoB;ADi2HxB;;A0B7nHA;ECzOI,yBAAA;EACA,c1BKoB;ADq2HxB;;A0B/nHA;EC5OI,yBAAA;EACA,c1BGoB;AD42HxB;;A0BhoHA;;EAEI,iBAAA;A1BmoHJ;A0BjoHI;;EACI,cAAA;EACA,iBAAA;EACA,czB1NqB;EyB2NrB,kBAAA;EdtPN,YcuPuB;EdpPvB,yBAAA;AZy3HF;A0BnoHQ;;;EAEI,6BzBtIiB;EWrH3B,Uc4P2B;EdzP3B,0BAAA;AZg4HF;A0BpoHI;;EACI,eAAA;A1BuoHR;A0BroHI;;;;EAEG,czBpQiB;AD64HxB;;A0BloHA;EACI,qBAAA;A1BqoHJ;A0BpoHK;EACG,eAAA;EACA,mBAAA;A1BsoHR;A0BpoHI;EACI,mBzBtEuB;EyBuEvB,mBAAA;EACA,ezBxEuB;AD8sH/B;;A0BloHA;EACI,cAAA;A1BqoHJ;A0BpoHI;EACI,mBAAA;A1BsoHR;;A0BloHA;EACI,czB3RoB;ADg6HxB;;A0BnoHA;EACI,czBnSoB;ADy6HxB;;A0BpoHA;EACI,czBnSoB;AD06HxB;;A0BroHA;EACI,czBrSoB;AD66HxB;;A0BtoHA;EACI,czB1SoB;ADm7HxB;;A0BtoHA;EACI,kBzB1H2B;ADmwH/B;A0BvoHI;EACI,mBzBrGuB;EyBsGvB,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBzBlGqB;AD2uH7B;A0BtoHI;EACI,cAAA;A1BwoHR;A0BtoHI;EACI,aAAA;A1BwoHR;;A0BnoHI;EACI,qBAAA;A1BsoHR;A0BpoHI;EACI,kBAAA;A1BsoHR;;A0BloHA;EACI,eAAA;A1BqoHJ;;A0BloHA;EACI,cAAA;EACA,WAAA;EACA,kBAAA;A1BqoHJ;;A0BjoHQ;EACI,kBzBhMmB;ADo0H/B;A0BjoHI;EACI,azBpMuB;ADu0H/B;;A0B3nHI;EACI,SAAA;EACA,gBAAA;EACA,mBAAA;A1B8nHR;A0B5nHQ;EACI,UAAA;EACA,2CAAA;A1B8nHZ;A0B5nHY;EACI,aAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;A1B8nHhB;A0B5nHgB;EACI,WAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;A1B8nHpB;A0B5nHoB;EACI,cAAA;A1B8nHxB;A0BznHY;EACI,qBAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;EACA,wBAAA;EACA,mCAAA;EACA,kCAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EpBzWZ,6BAAA;ANy+HJ;A0B5nHY;;EAEI,gEAAA;EAGA,yBAAA;A1B8nHhB;A0BznHY;EACI,qDAAA;A1B2nHhB;A0BvnHQ;EAKI,uCAAA;A1BynHZ;;A0BlnHA;EACI,0BAAA;A1BqnHJ;A0BhnHgB;EACI,kBAAA;A1BknHpB;;A0BrmHQ;EACI,kBAAA;A1BwmHZ;;A0BlmHI;EACI,gBAAA;A1BqmHR;;A0B7lHI;EACI,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;A1BgmHR;A0B9lHQ;EACI,aAAA;A1BgmHZ;A0B/lHY;EACI,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,czB5Wa;EyB6Wb,yBAAA;EACA,gBAAA;EAAA,sBAAA;A1BimHhB;A0B/lHgB;EACI,yBzB/dI;ADgkIxB;;A4BnkIA;EACI,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;A5BskIJ;;A4BpkIA;EACI,WAAA;A5BukIJ;;A4BpkIA;;EAEG,yB3BLqB;AD4kIxB;;A4BrkIA;EACI,yB3BboB;ADqlIxB;;A4BtkIA;EACG,yB3BbqB;ADslIxB;;A4BvkIA;EACG,yB3BfqB;ADylIxB;;A4BxkIA;EACG,yB3BpBqB;AD+lIxB;;A6BnmIA;;;;;;;;;EAAA;AAWA;EACC,kBAAA;EACA,gBAAA;A7BqmID;;A6BnmIA;EACC,kBAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;A7BsmID;;A6BpmIA;EACC,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,wBAAA;A7BumID;;A6BpmIA,wBAAA;AACA;;EAEC,eAAA;A7BumID;;A6BpmIA;EACC,WAAA;A7BumID;;A6BrmIA;EACI,kBAAA;EACA,SAAA;A7BwmIJ;;A6BtmIA;EACC,MAAA;EACA,YAAA;A7BymID;;A6BvmIA;EACC,OAAA;A7B0mID;;A6BxmIA;EACC,QAAA;A7B2mID;;A6BxmIA;EACC,YAAA;EACA,aAAA;A7B2mID;;A6BzmIA;EACC,YAAA;EACA,cAAA;EACA,qBAAA;A7B4mID;;A6B1mIA;EACC,OAAA;EACA,WAAA;A7B6mID;;A6B3mIA;EACC,SAAA;A7B8mID;;A6B5mIA;EACC,MAAA;A7B+mID;;A6B5mIA;mCAAA;AAEA;EACC,gBAAA;A7B+mID;;A6B7mIA;EACC,cAAA;A7BgnID;;A6B9mIA;;;;EAIC,cAAA;A7BinID;;A6B/mIA;EACC,yBAAA;A7BknID;;A6BhnIA;EACC,cAAA;A7BmnID;;A6BjnIA;EACC,mBAAA;EACA,cAAA;EACA,iBAAA;A7BonID;;A6BlnIA;EACC,cAAA;A7BqnID;;A6BlnIA;EACG,yB5BlGqB;ADutIxB;;A6BnnIA;EACI,yB5B1GoB;ADguIxB;;A6BpnIA;EACG,yB5B1GqB;ADiuIxB;;A6BrnIA;EACG,yB5B5GqB;ADouIxB;;A6BtnIA;EACG,yB5BjHqB;AD0uIxB;;A6BtnIA;mCAAA;AAEA;;;EAGC,8BAAA,EAAA,iBAAA,EACG,WAAA,EACA,oBAAA,EACA,yBAAA,EACA,iBAAA,EACA,UAAA;EACA,sFAAA,EAAA,QAAA;EACA,mHAAA,EAAA,UAAA;EAEA,kBAAA;EACA,iEAAA;EACH,YAAA;EACA,WAAA;EACA,eAAA;A7BwnID;;A6BtnIA;;;EAGC,cAAA;EACA,qBAAA;A7BynID;;A6BtnIA;;;;;;;;EAQC,cAAA;EACA,qBAAA;A7BynID;;A6BvnIA;;;EAGC,cAAA;EACA,qBAAA;A7B0nID;;A6BvnIA;mCAAA;AAEA;;;EAGC,yBAAA;EACA,mBAAA;EACA,cAAA;A7B0nID;;A6BxnIA;;;EAGC,cAAA;A7B2nID;;A6BznIA;;;EAGC,yBAAA;EACA,yB5BnLuB;E4BoLvB,c5BpLuB;ADgzIxB;;A6B1nIA;;;EAGC,c5BzLuB;ADszIxB;;A6B3nIA;;;EAGC,c5B9LuB;AD4zIxB;;A6B5nIA;;;EAGC,iBAAA;A7B+nID;;A6B7nIA;;;EAGC,YAAA;EACA,yBAAA;EACA,mBAAA;A7BgoID;;A6B9nIA;;;EAGC,aAAA;EACA,yBAAA;EACA,sBAAA;A7BioID;;A6B/nIA;EACC,yBAAA,EAAA,wBAAA;A7BkoID;;A8B31IA;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,mB7ByL2B;E6BxL3B,cAAA;EACA,aAAA;EACA,kBAAA;ElBJF,UkBMmB;ElBHnB,wBAAA;ENMQ,4CwBFN;A9B+1IJ;A8B71II;ElBTF,UkBUuB;ElBPvB,0BAAA;EkBQM,mBAAA;A9Bg2IR;A8B91II;EACG,4B7BkNoB;EKvNjB,gBwBMH;ExBmEC,2BL0JqB;EKlMrB,mBAAA;EARJ,4BAAA;EwBfG,iBAAA;A9B62IP;A8B32II;EACI,gBAAA;A9B62IR;A8B12II;EACG,iBAAA;EACA,cAAA;A9B42IP;A8B12IO;EACI,gBAAA;A9B42IX;A8Bz2II;EACI,qBAAA;A9B22IR;A8Bx2II;EACI,eAAA;A9B02IR;A8Bv2II;EACG,4B7BgJwB;E6B/IxB,6B7B+IwB;AD0tI/B;A8Bt2II;EACI,+B7B2IuB;E6B1IvB,gC7B0IuB;AD8tI/B;A8Br2II;EACI,gBAAA;EACA,qBAAA;A9Bu2IR;A8Bp2II;;EAEI,yB7BuDqB;E6BtDrB,cAAA;EACA,UAAA;EACA,qBAAA;A9Bs2IR;A8Bn2II;EAEI,yC7BvDqB;AD25I7B;A8Bl2II;EAEI,yC7B1DqB;AD65I7B;A8Bj2II;EAEI,uC7B7DqB;AD+5I7B;A8Bh2II;EAEI,yC7BhEqB;ADi6I7B;A8B/1II;EAEI,wC7BnEqB;ADm6I7B;A8B51IQ;EACI,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;A9B81IZ;A8Bz1IQ;EAEI,sBAAA;EACA,qBAAA;A9B01IZ;;A8Bn1II;EACI,iBAAA;EACA,iBAAA;A9Bs1IR;A8Bp1II;EACI,kBAAA;EACA,iBAAA;EACA,WAAA;A9Bs1IR;A8Bp1IQ;EACK,eAAA;EACA,WAAA;A9Bs1Ib;A8Bp1IQ;EAMI,eAAA;EACA,WAAA;A9Bi1IZ;;A8B30IA;EACI,gBAAA;A9B80IJ;;A8B50IA;EACI,iBAAA;A9B+0IJ;;A+B19IA;EACI,kB9B0L4B;E8BzL5B,yB9B+GyB;AD82I7B;A+B19II;EACI,WAAA;EACA,gBAAA;EACA,aAAA;EACA,0BAAA;EACA,kBAAA;EAGA,4BAAA;A/B49IR;A+B19IQ;EACI,WAAA;A/B49IZ;A+Bz9II;EACI,kBAAA;EACA,UAAA;EACA,qCAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EnBxBN,UmB0BuB;EnBvBvB,wBAAA;AZk/IF;A+Bz9IQ;EzBgFN,kBAAA;EACA,QAAA;EAGA,2BAAA;AN44IF;A+B59II;EnBhCF,UmBiCuB;EnB9BvB,0BAAA;AZ6/IF;A+B79II;EnBnCF,UmBoCuB;EnBjCvB,wBAAA;AZigJF;A+B99II;EnBtCF,UmBuCuB;EnBpCvB,0BAAA;AZqgJF;A+B/9II;EACI,4BAAA;A/Bi+IR;A+B/9II;EACI,oBAAA;EACA,yB9BgEqB;E8B/DrB,8BAAA;A/Bi+IR;A+B99II;;EAEI,mB9B+IuB;E8B9IvB,gB9B+JqB;E8B9JrB,c9B3BqB;E8B4BrB,kBAAA;A/Bg+IR;A+B99IQ;;EACI,e9BqJmB;AD40I/B;A+B79II;EACI,kB9BqIuB;E8BpIvB,kBAAA;EACA,yBAAA;A/B+9IR;A+B59II;EACI,S9BqCqB;E8BpCrB,c9BlDqB;E8BmDrB,gB9B4IqB;ADk1I7B;A+B59II;EACI,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;A/B89IR;A+B59II;EACI,mB9BmHuB;E8BlHvB,WAAA;A/B89IR;A+B59II;EACI,4BAAA;EACA,6B9BgCqB;E8B/BrB,iBAAA;EACA,2BAAA;EACA,eAAA;A/B89IR;A+B59IQ;EACI,cAAA;A/B89IZ;A+B39IQ;EACI,eAAA;EACA,kBAAA;A/B69IZ;A+B19II;EACI,cAAA;A/B49IR;A+Bz9II;EACI,kB9B4FuB;E8B3FvB,gB9B6GqB;E8B5GrB,yBAAA;EACA,kBAAA;EAGA,0CAAA;EACA,gBAAA;EACA,cAAA;EAKA,4BAAA;A/By9IR;A+Bv9II;EACI,mB9B2EuB;AD84I/B;A+Bv9II;EACI,kB9ByEuB;E8BxEvB,SAAA;A/By9IR;A+Bv9II;EACI,YAAA;EACA,YAAA;EACA,MAAA;EACA,UAAA;EACA,yB9B3GqB;E8B4GrB,aAAA;EACA,kBAAA;A/By9IR;A+Bt9II;EACI,mBAAA;A/Bw9IR;A+Bp9II;EACI,0BAAA;A/Bs9IR;A+Bn9II;EACI,kB9BsCwB;E8BrCxB,kBAAA;A/Bq9IR;A+Bn9IQ;EACI,kBAAA;A/Bq9IZ;A+Bh9IQ;EACI,mBAAA;EACA,c9B/CiB;ADigJ7B;A+B/8IY;EACI,YAAA;EACA,aAAA;A/Bi9IhB;;A+Bv8II;EACI,sBAAA;A/B08IR;A+Bx8IQ;EACI,iBAAA;A/B08IZ;A+Bx8IY;EACI,gBAAA;A/B08IhB;A+Bt8II;EACI,2BAAA;A/Bw8IR;A+Bt8II;EACI,cAAA;EACA,gBAAA;A/Bw8IR;A+Bt8IQ;EACI,iBAAA;A/Bw8IZ;;A+Bh8II;EACI,aAAA;A/Bm8IR;A+Bj8II;EACI,SAAA;EACA,iBAAA;A/Bm8IR;A+Bj8II;EACI,kBAAA;EACA,oBAAA;EACA,iBAAA;A/Bm8IR;A+Bj8II;EACI,YAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;A/Bm8IR;A+Bj8IQ;EACI,qBAAA;A/Bm8IZ;A+Bh8II;EACI,iBAAA;A/Bk8IR;A+Bh8II;EACI,iBAAA;A/Bk8IR;A+Bh8II;EACI,UAAA;A/Bk8IR;A+B97IQ;EACI,eAAA;A/Bg8IZ;;A+Bz7II;;EACI,sBAAA;A/B67IR;A+B37II;;EACI,gBAAA;A/B87IR;;A+B37IA;EACI,6BAAA;EACA,gBAAA;EACA,gBAAA;A/B87IJ;A+B57II;EACI,kBAAA;A/B87IR;;A+B17IA;EACI,uBAAA;A/B67IJ;A+B37II;EACI,wCAAA;A/B67IR;;A+Bx7II;EACI,mDAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EzB7MA,iCAAA;EAhCJ,4BAAA;ANkrJJ;A+Bj8IQ;EACI,kBAAA;A/Bm8IZ;A+Bj8IQ;EACI,UAAA;EzBrNJ,mCAAA;AN6pJR;A+Bj8IY;EACI,8CAAA;A/Bm8IhB;;AgCnnJE;EAxDA,wBC7Bc;ED8Bd,yBC9Bc;ED+Bd,iBC9Ba;ED+Bb,cC5BoB;AjC2sJtB;;AgCtnJE;;EArEA,cAAA;EAKA,aAAA;AhCgsJF;;AgC3nJE;EA3FA,qBA4F4B;EAxF5B,2BAwFsC;EArFpC,gBAAA;EAuFA,kBAAA;AhCqoJJ;;AgCloJE;EAjGA,uBAkG4B;EA9F5B,2BA8FwC;EA3FtC,gBAAA;EA6FA,kBAAA;AhC4oJJ;;AgCzoJE;EAvGA,qBAwG4B;EApG5B,yBAoGsC;EA/FpC,iBAAA;EAiGA,gBAAA;AhCmpJJ;;AgChpJE;EA7GA,qBA8G4B;EA1G5B,2BA0GsC;EAvGpC,gBAAA;EAyGA,kBAAA;AhC0pJJ;;AgCvpJE;EAnHA,qBAoH4B;EAhH5B,uBAgHsC;EAzGpC,kBAAA;EA2GA,kBAAA;AhCiqJJ;;AgC9pJE;EAzHA,uBA0H4B;EAtH5B,uBAsHwC;EA/GtC,kBAAA;EAiHA,kBAAA;AhCwqJJ;;AgCrqJE;EA/HA,qBAgI4B;EA5H5B,2BA4HsC;EAzHpC,gBAAA;EA2HA,kBAAA;AhC+qJJ;;AgC5qJE;EArIA,uBAsI4B;EAlI5B,2BAkIwC;EA/HtC,gBAAA;EAiIA,kBAAA;AhCsrJJ;;AgCnrJE;EA3IA,mBA6I4B;EAzI5B,yBAyIoC;EApIlC,iBAAA;EAsIA,gBAAA;AhC4rJJ;;AgCzrJE;EAlJA,mBAmJ4B;EA/I5B,2BA+IoC;EA5IlC,gBAAA;EA8IA,gBAAA;AhCmsJJ;;AgChsJE;EAvHA,0BC7Bc;ED8Bd,iBC5Bc;ED+BZ,qBChCgB;AjCy1JpB;;AgClsJE;EAlHA,iBC/Bc;EDgCd,qBC9Be;AjCs1JjB;;AgCnsJE;EAjHA,UAAA;EACA,iBCvCc;AjC+1JhB;;AgCpsJE;EA5GA,YAAA;EACA,iBC1CgB;AjC81JlB;;AgCrsJE;EA3GA,UAAA;EACA,kBC5Ca;AjCg2Jf;;AgCtsJE;EA1GA,UAAA;EACA,kBC9Ce;AjCk2JjB;;AgChzJE;EACE,eA2GY;AhCwsJhB;AgChzJE;EACE,aAuGY;AhC2sJhB;;AgCvzJE;EACE,eA2GY;AhC+sJhB;AgCvzJE;EACE,aAuGY;AhCktJhB;;AgC9zJE;EACE,eA2GY;AhCstJhB;AgC9zJE;EACE,aAuGY;AhCytJhB;;AgCr0JE;EACE,eA2GY;AhC6tJhB;AgCr0JE;EACE,aAuGY;AhCguJhB;;AgC50JE;EACE,eA2GY;AhCouJhB;AgC50JE;EACE,aAuGY;AhCuuJhB;;AgCn1JE;EACE,eA2GY;AhC2uJhB;AgCn1JE;EACE,aAuGY;AhC8uJhB;;AgC11JE;EACE,eA2GY;AhCkvJhB;AgC11JE;EACE,aAuGY;AhCqvJhB;;AgCj2JE;EACE,eA2GY;AhCyvJhB;AgCj2JE;EACE,aAuGY;AhC4vJhB;;AgCx2JE;EACE,eA2GY;AhCgwJhB;AgCx2JE;EACE,aAuGY;AhCmwJhB;;AgC/2JE;EACE,eA2GY;AhCuwJhB;AgC/2JE;EACE,aAuGY;AhC0wJhB;;AgCt3JE;EACE,eA2GY;AhC8wJhB;AgCt3JE;EACE,aAuGY;AhCixJhB;;AgC73JE;EACE,eA2GY;AhCqxJhB;AgC73JE;EACE,aAuGY;AhCwxJhB;;AgCp4JE;EACE,eA2GY;AhC4xJhB;AgCp4JE;EACE,aAuGY;AhC+xJhB;;AgC34JE;EACE,eA2GY;AhCmyJhB;AgC34JE;EACE,aAuGY;AhCsyJhB;;AgCl5JE;EACE,eA2GY;AhC0yJhB;AgCl5JE;EACE,aAuGY;AhC6yJhB;;AgChyJM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;AhCsgK3C;AgCjgKE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;AhCmgKJ;AgChgKE;EACE,WAAA;EACA,cAAA;EACA,WAAA;AhCkgKJ;AgC//JE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AhCigKJ;;AgCzzJM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;AhC+hK3C;AgC1hKE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;AhC4hKJ;AgCzhKE;EACE,WAAA;EACA,cAAA;EACA,WAAA;AhC2hKJ;AgCxhKE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AhC0hKJ;;AgCl1JM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;AhCwjK3C;AgCnjKE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;AhCqjKJ;AgCljKE;EACE,WAAA;EACA,cAAA;EACA,WAAA;AhCojKJ;AgCjjKE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AhCmjKJ;;AgC32JM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;AhCilK3C;AgC5kKE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;AhC8kKJ;AgC3kKE;EACE,WAAA;EACA,cAAA;EACA,WAAA;AhC6kKJ;AgC1kKE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AhC4kKJ;;AgCp4JM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;AhC0mK3C;AgCrmKE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;AhCumKJ;AgCpmKE;EACE,WAAA;EACA,cAAA;EACA,WAAA;AhCsmKJ;AgCnmKE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AhCqmKJ;;AgC75JM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;AhCmoK3C;AgC9nKE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;AhCgoKJ;AgC7nKE;EACE,WAAA;EACA,cAAA;EACA,WAAA;AhC+nKJ;AgC5nKE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AhC8nKJ;;AgCt7JM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;AhC4pK3C;AgCvpKE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;AhCypKJ;AgCtpKE;EACE,WAAA;EACA,cAAA;EACA,WAAA;AhCwpKJ;AgCrpKE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AhCupKJ;;AgC/8JM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;AhCqrK3C;AgChrKE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,qBAAA;AhCkrKJ;AgC/qKE;EACE,WAAA;EACA,cAAA;EACA,WAAA;AhCirKJ;AgC9qKE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AhCgrKJ;;AgCx+JM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;AhC8sK3C;AgCzsKE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,6BAAA;AhC2sKJ;AgCxsKE;EACE,WAAA;EACA,cAAA;EACA,WAAA;AhC0sKJ;AgCvsKE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AhCysKJ;;AgCjgKM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;AhCuuK3C;AgCluKE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;AhCouKJ;AgCjuKE;EACE,WAAA;EACA,cAAA;EACA,WAAA;AhCmuKJ;AgChuKE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AhCkuKJ;;AgC1hKM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;AhCgwK3C;AgC3vKE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;AhC6vKJ;AgC1vKE;EACE,WAAA;EACA,cAAA;EACA,WAAA;AhC4vKJ;AgCzvKE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AhC2vKJ;;AgCnjKM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;AhCyxK3C;AgCpxKE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;AhCsxKJ;AgCnxKE;EACE,WAAA;EACA,cAAA;EACA,WAAA;AhCqxKJ;AgClxKE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AhCoxKJ;;AgC5kKM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;AhCkzK3C;AgC7yKE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;AhC+yKJ;AgC5yKE;EACE,WAAA;EACA,cAAA;EACA,WAAA;AhC8yKJ;AgC3yKE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AhC6yKJ;;AgCrmKM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;AhC20K3C;AgCt0KE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;AhCw0KJ;AgCr0KE;EACE,WAAA;EACA,cAAA;EACA,WAAA;AhCu0KJ;AgCp0KE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AhCs0KJ;;AgC9nKM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;AhCo2K3C;AgC/1KE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,qBAAA;AhCi2KJ;AgC91KE;EACE,WAAA;EACA,cAAA;EACA,WAAA;AhCg2KJ;AgC71KE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AhC+1KJ;;AgCvpKM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;AhC63K3C;AgCx3KE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;AhC03KJ;AgCv3KE;EACE,WAAA;EACA,cAAA;EACA,WAAA;AhCy3KJ;AgCt3KE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AhCw3KJ;;AgChrKM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;AhCs5K3C;AgCj5KE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;AhCm5KJ;AgCh5KE;EACE,WAAA;EACA,cAAA;EACA,WAAA;AhCk5KJ;AgC/4KE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AhCi5KJ;;AkCz6KA;EAEI;IACI,yBAAA;ElC26KN;EkCx6KE;IACI,kBAAA;IACA,kBAAA;ElC06KN;EkCv6KU;IACI,iBAAA;ElCy6Kd;EkCp6KE;IACI,aAAA;ElCs6KN;EkCj6KU;IACI,gBAAA;IACA,gBAAA;ElCm6Kd;EkCh6Kc;IACI,aAAA;ElCk6KlB;EkC95Kc;IACI,aAAA;ElCg6KlB;EkC35KE;IACI,aAAA;ElC65KN;EkC15KE;I5BEI,mBAAA;IARJ,sDAAA;EN46KF;EkCl6KE;I5BFI,mBAAA;IAwCA,4BLqJoB;EDmvK1B;EkCx6KE;;;I5BQA,mCAAA;I4BJI,UAAA;ElC86KN;EkCx6Kc;IACI,UAAA;ElC06KlB;EkCx6Kc;IACI,UAAA;ElC06KlB;EkCp6KE;IACI,YAAA;ElCs6KN;EkCr6KM;IACI,WAAA;ElCu6KV;EkCr6KM;IACI,YAAA;ElCu6KV;EkCp6KE;IACI,4CAAA;IACA,wCAAA;IACA,yCAAA;IACA,WAAA;IACA,qBAAA;IACA,kBAAA;IACA,UAAA;IACA,UAAA;ElCs6KN;EkCp6KE;IACI,iCAAA;IACA,wCAAA;IACA,yCAAA;IACA,WAAA;IACA,qBAAA;IACA,kBAAA;IACA,UAAA;IACA,UAAA;ElCs6KN;EkCn6KE;IACI,UAAA;IACA,WAAA;ElCq6KN;EkCl6KE;IACI,UAAA;IACA,WAAA;ElCo6KN;EkC/5KS;IACE,cAAA;ElCi6KX;EkC15KU;IACI,YAAA;ElC45Kd;EkC15KU;IACI,kBAAA;ElC45Kd;EkC15KU;IACI,mBAAA;ElC45Kd;AACF;AkCv5KA,4CAAA;AAEA;EAEI;IACI,mBAAA;IACA,UAAA;I5BjFJ,mCAAA;IAxBA,0DAAA;EN0gLF;EkC35KM;IACI,kBAAA;IACA,OAAA;I5BzFR,oCAAA;IAxBA,0DAAA;ENwhLF;EkCl6KM;I5B9FJ,iCAAA;IAxBA,0DAAA;ENoiLF;EkCx6KE;I5B5HA,0DAAA;EN2iLF;EkCz6KM;IACI,kBAAA;IACA,WAAA;I5B5GR,oCAAA;IAxBA,0DAAA;ENyjLF;EkCj7KM;I5BhHJ,iCAAA;IAxBA,0DAAA;ENqkLF;EkCr7Kc;IACI,kBAAA;IACA,OAAA;I5B1HhB,mCAAA;IAxBA,0DAAA;ENmlLF;EkC57Kc;I5B/HZ,iCAAA;IAxBA,0DAAA;EN+lLF;EkC/7KE;IACI,6BAAA;ElCi8KN;EkC97KE;IACI,iDAAA;IACA,mBAAA;IACA,oBAAA;IACA,gBAAA;ElCg8KN;EkC77KU;IACI,2BAAA;IACA,WAAA;IACA,WAAA;IACA,cjCnGa;IiCoGb,aAAA;IACA,6BAAA;IACA,SAAA;IAEA,gBAAA;IACA,gDAAA;I5BrLZ,0DAAA;ENynLF;EkCj8Kc;IACI,yBAAA;IACA,kBAAA;IACA,cjC/GS;IiCgHT,aAAA;IACA,iBAAA;ElCm8KlB;EkCl8KkB;IACI,2CAAA;ElCo8KtB;EkCl8KkB;IACI,kBAAA;ElCo8KtB;EkC57Kc;IACI,gCAAA;ElC87KlB;EkC57Kc;IACI,kBAAA;ElC87KlB;EkCz7KE;IACI,WAAA;ElC27KN;EkCx7KE;IACI,iBAAA;ElC07KN;EkCx7KE;IACI,iBAAA;ElC07KN;EkCv7KE;IACK,kBAAA;ElCy7KP;EkCv7KE;IACG,OAAA;IACA,uBAAA;ElCy7KL;EkCv7KE;IACI,UAAA;IACA,WAAA;IACA,kBAAA;IACA,UAAA;ElCy7KN;EkCr7KM;IACI,WAAA;IACA,kBAAA;IACA,cAAA;ElCu7KV;EkCn7KE;IACI,eAAA;IACA,cAAA;IACA,MAAA;IACA,YAAA;IACA,QAAA;IACA,UAAA;IACA,aAAA;IACA,mBAAA;IACA,sBAAA;IACA,mBAAA;IACA,gBAAA;IACA,gBAAA;IACA,UAAA;I5BjPA,mCAAA;IAhBJ,2DAAA;ENgsLF;EkC37KM;IACI,kBAAA;IACA,UAAA;IACA,kBAAA;IACA,0BAAA;IACA,WAAA;ElC67KV;EkC17KM;IACI,MAAA;IACA,OAAA;IACA,YAAA;IACA,WAAA;IACA,kBAAA;IACA,yBAAA;IACA,cAAA;IACA,WAAA;IACA,UAAA;ElC47KV;EkCz7KM;IACI,kBAAA;IACA,UAAA;ElC27KV;EkCx7KM;IACI,kBAAA;ElC07KV;EkCv7KE;I5BlRI,iCAAA;ENgtLN;EkC37KE;IACI,YAAA;ElC67KN;EkC37KE;IACI,OAAA;I5BzRA,oCAAA;EN2tLN;EkC/7KE;IACM,cAAA;IACA,kBAAA;IACA,gBAAA;IACA,WAAA;IACA,WAAA;IACA,kBAAA;IACA,cAAA;ElCi8KR;EkC97KE;IACI,wBAAA;IACA,WAAA;IACA,YAAA;ElCg8KN;EkC97KE;;;IAGE,8BAAA;ElCg8KJ;EkC97KE;IACE,QAAA;I5BtOD,+BAAA;IAGA,6BAAA;ENyqLH;EkCn8KE;IACE,UAAA;ElCq8KJ;EkCn8KE;IACE,WAAA;I5B7OD,kCAAA;IAGA,6BAAA;ENqrLH;EkCx8KE;IACE,QAAA;I5BjPD,4BAAA;IAGA,6BAAA;EN8rLH;EkC78KE;IACE,UAAA;ElC+8KJ;EkC78KE;IACE,WAAA;I5BxPD,+BAAA;IAGA,6BAAA;EN0sLH;EMtsLE;IACE;MAAI,QAAA;MAAU,uBAAA;IN0sLhB;IMzsLE;MAAK,QAAA;MAAU,yBAAA;IN6sLjB;IM5sLE;MAAK,yBAAA;IN+sLP;IM9sLE;MAAM,yBAAA;INitLR;EACF;EMjsLE;IACE;MAAK,QAAA;MAAU,yBAAA;INquLjB;IMpuLE;MAAM,yBAAA;INuuLR;IMtuLE;MAAM,uBAAA;INyuLR;IMxuLE;MAAO,QAAA;MAAU,oBAAA;IN4uLnB;EACF;EM1tLE;IACE;MAAI,WAAA;MAAa,uBAAA;IN8vLnB;IM7vLE;MAAK,WAAA;MAAa,0BAAA;INiwLpB;IMhwLE;MAAK,0BAAA;INmwLP;IMlwLE;MAAM,0BAAA;INqwLR;EACF;EMrvLE;IACE;MAAK,WAAA;MAAY,0BAAA;INyxLnB;IMxxLE;MAAM,wBAAA;IN2xLR;IM1xLE;MAAM,wBAAA;IN6xLR;IM5xLE;MAAO,WAAA;MAAY,oBAAA;INgyLrB;EACF;EkCpmLE;IACE;MAAI,UAAA;IlCupLN;IkCtpLE;MAAM,UAAA;IlCypLR;EACF;EkCvpLE;IACI,2CAAA;ElCypLN;EkCtpLE;IACI,aAAA;ElCwpLN;EkCrpLU;IACI,4BAAA;ElCupLd;EkCjpLM;;;;;;;;;;IAUI,YAAA;ElCmpLV;EkChpLM;;;IAGI,YAAA;IACA,6BAAA;IACA,aAAA;ElCkpLV;EkC/oLM;;IAEI,0CAAA;ElCipLV;EkC5oLM;IACI,UAAA;ElC8oLV;EkC1oLU;IACI,yBAAA;IACA,sBAAA;ElC4oLd;EkC1oLU;IACI,0BAAA;IACA,uBAAA;ElC4oLd;EkCtoLE;IACI,aAAA;ElCwoLN;EkCtoLE;IACI,mCAAA;ElCwoLN;EkCtoLE;IACI,YAAA;IACA,WAAA;IACA,eAAA;IACA,UAAA;IACA,MAAA;IACA,UAAA;IACA,YAAA;IACA,WAAA;IACA,aAAA;IACA,kBAAA;ElCwoLN;EkCroLE;IACI,kBjCrSuB;ED46L7B;EkCroLE;IACI,kBjCxSuB;ED+6L7B;EkCroLE;IACI,WAAA;ElCuoLN;EkCroLE;IACI,sBAAA;ElCuoLN;EkCroLE;IACI,gBAAA;ElCuoLN;EkCroLE;IACI,wCAAA;ElCuoLN;EkCroLE;IACI,gBAAA;ElCuoLN;EkCroLE;IACI,UAAA;IACA,sBAAA;IACA,cAAA;IACA,mBAAA;ElCuoLN;EkCroLE;IACI,WAAA;ElCuoLN;EkCpoLE;IACI,cAAA;ElCsoLN;EkCpoLE;IACI,yBAAA;ElCsoLN;EkCpoLE;IACI,WAAA;ElCsoLN;EkCpoLE;IACI,gBAAA;IACA,WAAA;IACA,WAAA;IACA,aAAA;IACA,6BAAA;IACA,SAAA;IAEA,gBAAA;ElCsoLN;EkCnoLM;IACI,4BAAA;IACA,SAAA;ElCqoLV;EkCloLM;IACI,WAAA;IACA,eAAA;IACA,kBAAA;ElCooLV;AACF;AkC9nLA;EACI;IACI,kBAAA;IACA,mBAAA;ElCgoLN;EkC9nLE;IACI,iBAAA;ElCgoLN;AACF;AkC5nLA;EACI;IACI,WAAA;IACA,mBAAA;IACA,kBAAA;IACA,kBAAA;IACA,4CAAA;IACA,iCAAA;ElC8nLN;EkC3nLE;IACI,YAAA;IACA,WAAA;IACA,kBAAA;IACA,UAAA;IACA,MAAA;IACA,UAAA;IAEA,WAAA;IACA,aAAA;IACA,kBAAA;IACA,qCAAA;I5B1hBJ,6BAAA;EN2pMF;EkC7nLM;IACI,UAAA;ElC+nLV;AACF;AkC3nLA;EAEQ;IACI,sBAAA;ElC4nLV;EkCznLM;IACI,kBAAA;ElC2nLV;EkCznLM;IACI,mBAAA;ElC2nLV;EkCrnLU;IACI,gBAAA;ElCunLd;AACF;AmCltMA;EACE,qBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,iBAAA;EACA,yBAAA;EAGA,iBAAA;EACA,sBAAA;EAEA,wEAAA;AnCotMF;;AmCjtMA;EACE,oBAAA;EACA,MAAA;EACA,YAAA;EACA,kBAAA;EAEA,+BAAA;EACA,uBAAA;AnCotMF;;AmCjtMA;;;EAKI,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EAEA,0BAAA;AnCotMJ;AmCltMI;;;EACI,eAAA;EACA,iBAAA;AnCstMR;;AmCltMA;;EAEE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,qBAAA;EACA,yBlC7DsB;ADkxMxB;;AmCjtMA;EACE,kBAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EACA,kEAAA;AnCotMF;;AmCjtMA;EACE,8BAAA;EACA,2BAAA;AnCotMF;;AmCjtMA;EACE,gBAAA;AnCotMF;;AmCjtMA;;EAEE,6BAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,wBAAA;EACA,WAAA;AnCotMF;;AmChtMA;EAEE,4BAAA;AnCmtMF;;AmC/sMA;EACE,4BAAA;AnCktMF;;AmC/sMA;EACE,6BAAA;AnCktMF;;AmC/sMA;EACE,sBAAA;EACA,iBAAA;AnCktMF;;AmC/sMA;EACE,sBAAA;EACA,6BAAA;AnCktMF;;AmC9sMA;EACE,yBlC7HsB;AD80MxB;;AmC9sMA;EACE,yBlC/HsB;ADg1MxB;;AmC9sMA;EACE,yBlCpIsB;ADq1MxB;;AmC9sMA;EACE,yBlCtIsB;ADu1MxB;;AmC9sMA;EACE,yBlC/IsB;ADg2MxB;;AmC/sMA;EACE,yBlC5IsB;AD81MxB;;AmC/sMA;;;;;EAKE,yBAAA;AnCktMF;;AoC/2MA;;;;;kCAAA;AAMA;EACE,2BAAA;EACA,4CAAA;EACA,4SAAA;EACA,mBAAA;EACA,kBAAA;ApCk3MF;AoCh3MA;;0BAAA;AAGA;EACE,qBAAA;EACA,gDAAA;EACA,kBAAA;EACA,WAAA;EACA,oBAAA;EACA,0BAAA;EACA,mCAAA;EACA,kCAAA;ApCk3MF;AoCh3ME;EACE,gBAAA;ApCk3MJ;;AoC/2MA;;0BAAA;AAGA;EACE,uBAAA;EACA,oBAAA;ApCk3MF;;AoCh3MA;EACE,cAAA;ApCm3MF;;AoCj3MA;EACE,cAAA;ApCo3MF;;AoCl3MA;;oCAAA;AAGA;;EAEE,qBAAA;EACA,oBAAA;EACA,sBAAA;ApCq3MF;;AoCn3MA;EACE,kBAAA;ApCs3MF;;AoCp3MA;;0BAAA;AAGA;EACE,eAAA;EACA,yBAAA;EACA,qBAAA;ApCu3MF;;AoCr3MA;EACE,kBAAA;ApCw3MF;;AoCt3MA;EACE,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;ApCy3MF;;AoCv3MA;EACE,MAAA;EACA,mBAAA;ApC03MF;;AoCx3MA;;EAEE,kBAAA;EACA,kBAAA;ApC23MF;;AoCt3MQ;EACI,eAAA;ApCy3MZ;;AoCr3MA;;0BAAA;AAGA;EAGE,0CAAA;ApCw3MF;AoCt2MA;EACE;IAKE,uBAAA;EpCy3MF;EoCv3MA;IAKE,yBAAA;EpCy3MF;AACF;AoCv3MA;;0BAAA;AAGA;EACE,gEAAA;EAKA,wBAAA;ApCy3MF;;AoCv3MA;EACE,gEAAA;EAKA,yBAAA;ApC03MF;;AoCx3MA;EACE,gEAAA;EAKA,yBAAA;ApC23MF;;AoCz3MA;EACE,gEAAA;EAKA,uBAAA;ApC43MF;;AoC13MA;EACE,gEAAA;EAKA,uBAAA;ApC63MF;;AoC33MA;;0BAAA;AAIA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoC13MA;EACI,gBAAA;ApC63MJ;;AoCz3MA,oCAAA;AC/hBA;;;;;CAAA;AAOA;EAEE,sBAAA;EAEA,yBAAA;ArC25NF;;AqCx5NA;EAEE,mCAAA;ArC25NF;;AqCx5NA;EAEE,sBAAA;ArC25NF;;AqCx5NA;;EAGE,yBAAA;ArC25NF;;AqCx5NA;;EAGE,yBAAA;ArC25NF;AqCv4NA;EACE;IAEE,+BAAA;ErCw5NF;EqCr5NA;IAEE,mCAAA;ErCu5NF;EqCp5NA;IAEE,kCAAA;ErCs5NF;AACF;AqCn5NA;EAEE,qBAAA;ArCq5NF;AqCl4NA;EACE;IACE,UAAA;IAEA,mCAAA;ErCi5NF;EqC94NA;IACE,UAAA;IAEA,eAAA;ErCg5NF;AACF;AqC74NA;EAEE,0BAAA;ArC+4NF;AqCj4NA;EACE;IACE,UAAA;ErC44NF;EqCz4NA;IACE,UAAA;ErC24NF;AACF;AqCx4NA;EAEE,uBAAA;ArC04NF;AqC33NA;EACE;IACE,UAAA;ErCw4NF;EqCr4NA;IACE,UAAA;IAEA,kCAAA;ErCu4NF;AACF;AqCp4NA;EAEE,2BAAA;ArCs4NF;AqCv3NA;EACE;IACE,UAAA;ErCo4NF;EqCj4NA;IACE,UAAA;IAEA,mCAAA;ErCm4NF;AACF;AqCh4NA;EAEE,yBAAA;ArCk4NF;;AsChmOA;EACE,oCAAA;EACA,eAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,aAAA;EACA,aAAA;AtCmmOF;;AsCjmOA;EACE,sBAAA;EACA,2DAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;AtComOF;AsClmOE;EACI,UAAA;AtComON;AsCjmOE;EACI,aAAA;AtCmmON;AsChmOE;EACI,gBAAA;EACA,cAAA;AtCkmON;;AsC/lOE;EACE,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;AtCkmOJ;;AsChmOE;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;AtCmmOJ;;AsCjmOE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;AtComOJ;;AsClmOE;EACE,WAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;AtCqmOJ;;AsCpmOI;EACE,aAAA;AtCumON;;AsCtmOI;EACE,YAAA;AtCymON;;AsCxmOI;EACE,6BAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,cAAA;EACA,sBAAA;EACA,wCAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EAEQ,wDAAA;AtC2mOd;;AsC1mOI;EACE,SAAA;AtC6mON;;AsC5mOE;EACE,2BAAA;AtC+mOJ;;AsC9mOE;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;EACA,uBAAA;AtCinOJ;;AsChnOI;EACE,qBAAA;AtCmnON;;AsClnOM;EACE,kBAAA;EACA,cAAA;AtCqnOR;;AsCpnOM;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EAEA,cAAA;EACA,SAAA;EACA,kBAAA;AtCsnOR;;AsCrnOQ;EAEU,wBAAA;EACR,UAAA;AtCwnOV;;AsCvnOQ;EAEU,yBAAA;EACR,WAAA;AtC0nOV;;AsCznOI;EACE,qBAAA;AtC4nON;;AsC3nOM;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,SAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;AtC8nOR;;AsC7nOM;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,SAAA;EACA,YAAA;EACA,yBAAA;AtCgoOR;;AsC/nOI;EACE,qBAAA;AtCkoON;;AsCjoOM;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;AtCooOR;;AsCnoOM;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,SAAA;EACA,yBAAA;AtCsoOR;;AsCroOI;EACE,qBAAA;AtCwoON;;AsCtoOM;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EAEQ,wBAAA;AtCyoOhB;;AsCvoOM;EACE,8BAAA;EACA,SAAA;EACA,WAAA;EAEQ,yBAAA;EAEA,2BAAA;AtC0oOhB;;AsCzoOM;EACE,8BAAA;EACA,UAAA;EACA,UAAA;EAEQ,yBAAA;EAEA,wBAAA;AtC4oOhB;;AsC3oOM;EACE,WAAA;EACA,YAAA;EACA,0CAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;AtC8oOR;;AsC7oOM;EACE,UAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;EAEQ,yBAAA;AtCgpOhB;;AsC/oOM;EACE,WAAA;EACA,yBrClNgB;EqCmNhB,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;AtCkpOR;;AsCjpOQ;EACE,WAAA;EACA,UAAA;EACA,SAAA;EAEQ,wBAAA;AtCopOlB;;AsCnpOQ;EACE,WAAA;EACA,UAAA;EACA,SAAA;EAEQ,yBAAA;AtCspOlB;;AsCrpOE;EACE,iBAAA;AtCwpOJ;AsCxoOA;EACE;IAEU,qBAAA;EtC6pOV;EsC5pOA;IAEU,sBAAA;EtC8pOV;EsC7pOA;IAEU,sBAAA;EtC+pOV;EsC9pOA;IAEU,mBAAA;EtCgqOV;AACF;AsCvpOA;EACE;IAEU,mBAAA;EtCmqOV;EsClqOA;IAEU,qBAAA;EtCoqOV;AACF;AsCnqOA;EAEU,8BAAA;AtCqqOV;;AsCpqOE;EAEU,eAAA;AtCuqOZ;;AsCrqOA;EAEU,8BAAA;AtCwqOV;;AsCvqOE;EAEU,eAAA;AtC0qOZ;AsClpOA;EACE;IACE,QAAA;IACA,SAAA;IACA,SAAA;EtCgrOF;EsC/qOA;IACE,QAAA;IACA,SAAA;IACA,SAAA;EtCirOF;EsChrOA;IACE,WAAA;IACA,UAAA;IACA,SAAA;EtCkrOF;EsCjrOA;IACE,WAAA;IACA,UAAA;IACA,SAAA;EtCmrOF;EsClrOA;IACE,WAAA;IACA,UAAA;IACA,SAAA;EtCorOF;AACF;AsCjqOA;EACE;IACE,QAAA;IACA,WAAA;IACA,SAAA;EtCyrOF;EsCxrOA;IACE,QAAA;IACA,WAAA;IACA,SAAA;EtC0rOF;EsCzrOA;IACE,WAAA;IACA,QAAA;IACA,SAAA;EtC2rOF;EsC1rOA;IACE,WAAA;IACA,UAAA;IACA,SAAA;EtC4rOF;AACF;AsC7qOA;EACE;IAEU,yBAAA;EtCisOV;EsChsOA;IAEU,yBAAA;EtCksOV;EsCjsOA;IAEU,0BAAA;EtCmsOV;EsClsOA;IAEU,0BAAA;EtCosOV;AACF;AsCnsOA;EAEU,oCAAA;AtCqsOV;;AsCnsOA;EAEU,qCAAA;AtCssOV;;AsCpsOA;EAEU,0CAAA;AtCusOV;AsC3rOA;EACE;IAEU,0BAAA;IACR,UAAA;EtC0sOF;EsCzsOA;IAEU,wBAAA;IACR,UAAA;EtC2sOF;AACF;AsC1sOA;EAEU,kCAAA;AtC4sOV;AsCrrOA;EACE;IAEU,qBAAA;IACR,gBAAA;IACA,UAAA;EtCitOF;EsChtOA;IAEU,qBAAA;IACR,gBAAA;IACA,UAAA;EtCktOF;EsCjtOA;IAEU,sBAAA;IACR,gBAAA;EtCmtOF;EsCltOA;IAEU,mBAAA;IACR,aAAA;IACA,UAAA;EtCotOF;AACF;AsCntOA;EAEU,8BAAA;AtCqtOV;AsC7sOA;EACE;IACE,qBAAA;EtCwtOF;EsCvtOA;IACE,qBAAA;EtCytOF;AACF;AsCxtOA;EAEU,iDAAA;AtC0tOV;AsCltOA;EACE;IACE,yBAAA;EtC6tOF;EsC5tOA;IACE,yBAAA;EtC8tOF;AACF;AsC7tOA;EAEU,qDAAA;AtC+tOV;AsCrtOA;EACE;IAEU,uBAAA;EtCkuOV;EsCjuOA;IAEU,yBAAA;EtCmuOV;AACF;AuCtvPA;EACI,kBAAA;AvCwvPJ;;AuCrvPA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AvCwvPJ;;AuCrvPA;EACI,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,gCAAA;EACA,kBAAA;EACA,YAAA;AvCwvPJ;;AuCrvPA;EACI,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;AvCwvPJ;;AuCrvPA;EACI,WAAA;EACA,YAAA;AvCwvPJ;;AuCrvPA;EACI,SAAA;AvCwvPJ;;AuCrvPA;EACI,SAAA;AvCwvPJ;;AuCrvPA;EACI,YAAA;EACA,aAAA;EACA,YAAA;AvCwvPJ;;AuCrvPA;EACI,kBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,oEAAA;AvCwvPJ;;AuCrvPA;EACI,iBAAA;EACA,eAAA;EACA,kBAAA;AvCwvPJ;;AuCrvPA;EACI,kBAAA;AvCwvPJ;;AuCrvPA;EACI,SAAA;EACA,QAAA;AvCwvPJ;;AuCrvPA;EACI,MAAA;EACA,QAAA;AvCwvPJ;;AuCrvPA;EACI,iBAAA;EACA,YAAA;EACA,kBAAA;AvCwvPJ;;AuCrvPA;EACI,WAAA;EACA,qBAAA;EACA,wBAAA;AvCwvPJ;;AuCrvPA;EACI,WAAA;AvCwvPJ;;AuCrvPA;EACI,qBAAA;EACA,YAAA;AvCwvPJ;;AuCrvPA;EACI,WAAA;AvCwvPJ;;AuCrvPA;EACI,YAAA;AvCwvPJ;;AuCrvPA;EACI,YAAA;EACA,WAAA;EACA,qBAAA;EACA,sBAAA;AvCwvPJ;;AuCrvPA;EACI,eAAA;AvCwvPJ;;AuCrvPA;EACI,kBAAA;AvCwvPJ;;AuCrvPA;EACI,qBAAA;EACA,sBAAA;EACA,iBAAA;EACA,iBAAA;AvCwvPJ;;AwC73PA;;;;EAAA;AAMA;EACI,2BAAA;EACA,gCAAA;EACA,oCAAA;EACA,kBAAA;AxC+3PJ;;AwC53PA;;;;;;EAMI,uBAAA;AxC+3PJ;;AwC53PA;EACI,yCvCTyB;ADw4P7B;;AwC73PA;;EAEI,mCAAA;AxCg4PJ;;AwC73PA;EACI,kBAAA;EACA,WAAA;AxCg4PJ;;AwC73PA;EACI,6BAAA;AxCg4PJ;;AwC73PA;;EAEI,gBAAA;AxCg4PJ;;AwC73PA;EACI,6BAAA;AxCg4PJ;;AwC73PA;EACI,YAAA;EACA,cAAA;AxCg4PJ;;AwC73PA;EACI,WAAA;AxCg4PJ;;AwC73PA;EACI,SAAA;EACA,UAAA;EACA,SAAA;AxCg4PJ;;AwC73PA;EACI,iBAAA;AxCg4PJ;;AwC73PA;EACI,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AxCg4PJ;;AwC73PA;EACI,eAAA;EACA,4BAAA;EACA,mBAAA;AxCg4PJ;;AwC73PA;EACI,yDAAA;EACA,8BAAA;AxCg4PJ;;AwC73PA;EACI,yDAAA;EACA,8BAAA;AxCg4PJ;;AwC73PA;EACI,yDAAA;EACA,8BAAA;AxCg4PJ;;AwC53PA;EACI,WAAA;AxC+3PJ;;AwC53PA;EACI,gBAAA;AxC+3PJ;;AwC53PA;EACI,iBAAA;AxC+3PJ;;AwC53PA,gCAAA;AACA;EACI,2CAAA;AxC+3PJ;;AwC53PA;EACI,kBAAA;AxC+3PJ;;AwC53PA;EACI,cAAA;AxC+3PJ;;AwC53PA;;EAEI,yBAAA;EACA,eAAA;AxC+3PJ;;AwC53PA;EACI,kBAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;AxC+3PJ;;AwC73PA;EACI,gBvC4EyB;EuC3EzB,mBvCoE2B;AD4zP/B;;AwC93PA;;EAEI,gBAAA;EACA,mBAAA;AxCi4PJ;;AwC93PA;EACI,SAAA;AxCi4PJ;;AwC93PA;EACI,iBAAA;EACA,wBAAA;AxCi4PJ;;AwC93PA;EACI,iBAAA;EACA,iBAAA;AxCi4PJ;;AwC93PA;EACI,kBAAA;EACA,qBAAA;EACA,sBAAA;AxCi4PJ;;AwC93PA;EACI,qBAAA;AxCi4PJ;;AwC93PA;EACI,iBAAA;AxCi4PJ;;AwC93PA;EACI,iBAAA;AxCi4PJ;;AwC93PA;EACI,gBAAA;AxCi4PJ;;AwC93PA;EACI,aAAA;EACA,mBvCS2B;ADw3P/B;;AwC/3PA;EACI,cAAA;EACA,kBAAA;EACA,6BAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,wBAAA;AxCk4PJ;;AwCh4PA;EACI,mBAAA;AxCm4PJ;;AwCh4PA;;;EAGI,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AxCm4PJ;;AwCh4PA;EACI,oBAAA;EACA,eAAA;AxCm4PJ;;AwCh4PA;EACI,aAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;AxCm4PJ;;AwCh4PA;EACI,iBAAA;EACA,qBAAA;EACA,cAAA;EACA,2BAAA;AxCm4PJ;;AwCh4PA,wBAAA;AACA;EACI,sBAAA;AxCm4PJ;;AwCh4PA;EACI,sBAAA;EACA,sBAAA;AxCm4PJ;;AwCh4PA;EACI,qBAAA;EACA,4BAAA;AxCm4PJ;;AwCh4PA;EACI,eAAA;AxCm4PJ;;AwCh4PA;EACI,gBAAA;AxCm4PJ;;AwCh4PA;EACI,2BAAA;EACA,8BAAA;AxCm4PJ;;AwCh4PA;EACI,4BAAA;EACA,+BAAA;AxCm4PJ;;AwCh4PA,wBAAA;AACA;EACI,UAAA;EACA,SAAA;AxCm4PJ;;AwCh4PA;EACI,QAAA;EACA,UAAA;AxCm4PJ;;AwCh4PA,8BAAA;AACA;EACI,WAAA;EACA,aAAA;AxCm4PJ;;AwCh4PA;EACI,MAAA;EACA,OAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;AxCm4PJ;;AwC93PI;EACI,cAAA;AxCi4PR;AwC/3PQ;EACI,cAAA;EACA,WAAA;EACA,WAAA;AxCi4PZ;AwC73PY;EACI,mBvC/Ge;AD8+P/B;AwC73PY;EACI,iBAAA;AxC+3PhB;AwC53PQ;;EAEI,gBAAA;EACA,mBAAA;AxC83PZ;AwCz3PQ;EAGI,YAAA;AxCy3PZ;;AyC3rQA;EACE,WAAA;EACA,0BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;AzC8rQF;;AyC5rQA;;EAIE,uBAAA;AzC+rQF;;AyC7rQA;;EAEE,kBAAA;AzCgsQF;;AyC9rQA;;EAEE,mBAAA;AzCisQF;;AyC9rQA;EACE,mBAAA;EACA,gBAAA;EACA,mBAAA;AzCisQF;;AyC/rQA;EACE,WAAA;EACA,qBAAA;AzCksQF;;AyChsQA;EACE,iBAAA;AzCmsQF;;AyCjsQA;EACE,mBAAA;EACA,mBAAA;EACA,gBAAA;AzCosQF;;AyClsQA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;AzCqsQF;;AyCnsQA;EACE,gBAAA;EACA,mBAAA;AzCssQF;;AyCpsQA;EACE,SAAA;EACA,mBAAA;EACA,iBAAA;AzCusQF;;AyCrsQA;EACE,aAAA;EACA,mBAAA;AzCwsQF;;AyCtsQA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AzCysQF;;AyCtsQA;;;;EAIE,mBAAA;AzCysQF;;AyCvsQA;;EAEE,aAAA;AzC0sQF;;AyCxsQA;;;;;EAKE,eAAA;EACA,kBAAA;AzC2sQF;;AyCzsQA;;;;;EAKE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,cAAA;EACA,mCAAA;EACA,YAAA;AzC4sQF;;AyC1sQA;EACE,YAAA;EACA,gBAAA;EACA,SAAA;AzC6sQF;;AyC3sQA;EACE,gBAAA;EACA,uBAAA;AzC8sQF;;AyC5sQA;EACE,gBAAA;EACA,2BAAA;AzC+sQF;;AyC7sQA;;EAEE,WAAA;AzCgtQF;;AyC7sQA;EACE,2BAAA;AzCgtQF;;AyC7sQA;EACE,gBAAA;EACA,wBAAA;EACA,2BAAA;AzCgtQF;;AyC9sQA;;;EAGE,aAAA;AzCitQF;;AyC/sQA;;EAEE,gBAAA;AzCktQF;;AyC/sQA;EACE,wBAAA;EACA,gBAAA;AzCktQF;;AyC/sQA;EACE;;;;IAIE,kBAAA;EzCktQF;AACF;AyChtQA;EACE,mBAAA;AzCktQF;;AyChtQA;;;EAGE,QAAA;EACA,UAAA;AzCmtQF;;AyChtQA;;EAEE,oBAAA;AzCmtQF;;AyCjtQA;;;EAGE,qBAAA;AzCotQF;;AyCltQA;;EAEE,sBAAA;AzCqtQF;;AyCltQA;EACE,sBAAA;AzCqtQF;;AyCltQA;EACE,SAAA;AzCqtQF;;AyCntQA;EACE,eAAA;AzCstQF;;AyCptQA;EACE,gBAAA;AzCutQF;;AyCjtQI;EACI,YAAA;AzCotQR;AyC1sQY;;;;;EACI,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,WAAA;EACA,0BAAA;EACA,YAAA;AzCgtQhB;AyCtsQgB;;;;;EACI,aAAA;AzC4sQpB;AyCtsQY;EACI,YAAA;EACA,gBAAA;AzCwsQhB;AyCnsQY;EACI,gBAAA;EACA,QAAA;AzCqsQhB;AyChsQY;EACI,gBAAA;EACA,SAAA;AzCksQhB;AyC7rQI;;;;;;EAMI,uBAAA;EACA,UAAA;AzC+rQR;AyC5rQI;EACI,YAAA;AzC8rQR;;AyCxrQQ;;;;;EAKI,mBAAA;AzC2rQZ;;AyCnrQI;EACQ,UAAA;AzCsrQZ;;AyCjrQI;;;EAGI,0BAAA;AzCorQR;AyC9qQQ;;;EACI,wBAAA;AzCkrQZ;AyC9qQI;;EAEI,kBAAA;EACA,6BAAA;EACA,eAAA;AzCgrQR;AyC3qQQ;;EACI,QAAA;EACA,gBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,wBAAA;EACA,uBAAA;EACA,kBAAA;EACA,8CAAA;EACA,iBAAA;EACA,YAAA;EACA,sBAAA;AzC8qQZ;AyCxqQQ;;EACI,YAAA;EACA,cAAA;AzC2qQZ;AyCtqQQ;EACI,aAAA;AzCwqQZ;;AyC/pQQ;;EACI,kBAAA;AzCmqQZ;AyC7pQQ;;EACI,QAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AzCgqQZ;;AyC1pQI;;EAEI,kBAAA;EACA,eAAA;AzC6pQR;AyCxpQQ;;EACI,QAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,wBAAA;EACA,uBAAA;EACA,kBAAA;EACA,8CAAA;EACA,iBAAA;EACA,YAAA;EACA,yBAAA;AzC2pQZ;AyCrpQQ;;EACI,YAAA;EACA,yBAAA;AzCwpQZ;;AyClpQI;EACI,kBAAA;AzCqpQR;AyCjpQQ;EACI,kCAAA;AzCmpQZ;AyC/oQI;EACI,qBAAA;EACA,qBAAA;EACA,SAAA;EACA,UAAA;AzCipQR;AyC9oQI;EACI,gCAAA;EACA,gBAAA;AzCgpQR;AyC5oQQ;EACI,cAAA;AzC8oQZ;AyCzoQQ;EACI,mBAAA;AzC2oQZ;AyCvoQI;EACI,qBAAA;EACA,eAAA;EACA,iBAAA;AzCyoQR;;AyCroQA;EACI,eAAA;EACA,sBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AzCwoQJ;AyCtoQI;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;EACA,yBAAA;EACA,uBAAA;EACA,oBAAA;EACA,0CAAA;AzCwoQR;AyCroQI;EACI,kBAAA;EACA,YAAA;AzCuoQR;AyCpoQI;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;AzCsoQR;AyCloQQ;EACI,yBAAA;AzCooQZ;AyChoQI;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,8BAAA;AzCkoQR;;AyCvnQgB;EACI,mBAAA;AzC0nQpB;;AyCnnQA;EACI;IACI,UAAA;EzCsnQN;EyChnQc;IAEI,aAAA;EzCinQlB;AACF;A0CvoRA;;;;EAAA;AAMA;EACC,cAAA;EACA,gBAAA;A1CwoRD;;A0CroRA;EACC,iBAAA;A1CwoRD;;A0CroRA,WAAA,sCAAA;EACC,cAAA;A1CwoRD;;A0CpoRA;mGAAA;AAGA;;;;;;;EAOC,kBAAA;A1CsoRD;;A0CnoRA;EACC,sBAAA;A1CsoRD;;A0CnoRA;;EAEC,gBAAA;A1CsoRD;;A0CnoRA;EACC,WAAA;A1CsoRD;;A0CnoRA;EACC,mBzCqE4B;ADikR7B;;A0CnoRA,gBAAA,iCAAA;EACC,mBAAA;EACA,YAAA;EACA,yBAAA,EAAA,WAAA;A1CsoRD;;A0CnoRA,cAAA,uCAAA;EACC,8BAAA;EACA,YAAA;EACA,yBAAA,EAAA,WAAA;A1CsoRD;;A0CnoRA,kBAAA,8CAAA;EACC,sCAAA;EACA,mBAAA;A1CsoRD;;A0CloRA;mGAAA;AAGA;EACC,qBAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;EAEA,uCAAA;EACA,2BAAA;EACA,yBAAA;EAIA,iBAAA;A1CmoRD;;A0ChoRA;;;;;;CAAA;AAQA;EACC,kBAAA;EACA,cAAA,EAAA,4DAAA;A1CkoRD;;A0C/nRA;EACC,YAAA;EACA,iBAAA;EACA,eAAA;EACA,QAAA;EACA,QAAA;A1CkoRD;;A0C/nRA;EACC,YAAA;EACA,iBAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;A1CkoRD;;A0C/nRA;EACC,YAAA;EACA,eAAA;EACA,QAAA;A1CkoRD;;A0C/nRA;EACC,YAAA;EACA,eAAA;EACA,QAAA;A1CkoRD;;A0C/nRA;EACC,YAAA;EACA,eAAA;EACA,OAAA;EACA,SAAA;A1CkoRD;;A0C/nRA;EACC,YAAA;EACA,eAAA;EACA,OAAA;EACA,QAAA;A1CkoRD;;A0C/nRA;EACC,YAAA;EACA,eAAA;EACA,OAAA;A1CkoRD;;A0C/nRA;EACC,YAAA;EACA,eAAA;EACA,OAAA;A1CkoRD;;A0C9nRA;mGAAA;AAGA;EACC,iBzCpD4B;EyCqDzB,6BzC3CyB;EyC4CzB,gBzCmDyB;EWpN3B,Y8BmKmB;E9BhKnB,yBAAA;E8BiKE,iBAAA;EAEA,qBzCpJyB;EyCqJzB,czCrJyB;ADoxR7B;A0C5nRI;E9B1KF,U8B4KuB;E9BzKvB,0BAAA;E8B0KM,qBAAA;A1C8nRR;A0C5nRI;EpCtKM,gBoCyKD;EACA,qBAAA;A1C6nRT;;A0CxnRA,yCAAA;AACA;EAA+B,SAAA;EAAW,UAAA;A1C6nR1C;;A0C3nRA,oBAAA,cAAA;EACC,iBAAA;A1C8nRD;;A0C3nRA,mCAAA,cAAA;EACC,2BAAA;EACA,8BAAA;A1C8nRD;;A0C3nRA,oCAAA,cAAA;EACC,4BAAA;EACA,+BAAA;A1C8nRD;;A0C3nRA,qBAAA;AAEA,sBAAA,cAAA;EACC,kBAAA;EACA,YAAA,EAAA,kDAAA;EACA,eAAA;EACA,sBAAA;A1C6nRD;;A0C1nRA;;;CAAA;AAKA;;;EAGC,cAAA;EACA,yBAAA;A1C4nRD;;A0CznRA;;;EAGI,yBzC1MyB;EyC2MzB,qBzC3MyB;EyC4MzB,eAAA;E9BnOF,a8BoOgB;E9BjOhB,yBAAA;E8BkOD,mBAAA;A1C6nRD;;A0C1nRA;EACC,yBzCxH4B;ADqvR7B;;A0C1nRA;;;;;;EAMC,yBzChO4B;EyCiOzB,cAAA;A1C6nRJ;;A0CxnRA;mGAAA;AAGA;EACC,qBAAA;A1C0nRD;;A0CvnRA;;;CAAA;AAKA,2BAAA,yDAAA;EACC,WAAA;EACA,iBAAA;A1CynRD;;A0CtnRA,sCAAA,SAAA;EACC,cAAA;A1CynRD;;A0CrnRA;mGAAA;AAGA;EACC,kBAAA;EpCzQS,4CoC0QT;A1CwnRD;;A0CrnRA,yBAAA,kDAAA;EACC,gBAAA;A1CwnRD;;A0CrnRA;EACC,aAAA;A1CwnRD;;A0CrnRA;EACC,eAAA;A1CwnRD;;A0CrnRA;;EAEC,WAAA;A1CwnRD;;A0CrnRA;;EAEC,YAAA;A1CwnRD;;A0CrnRA,aAAA;AAEA;EACC,iBAAA;EACA,mBAAA;A1CunRD;;A0CpnRA;EACC,gBAAA;EACA,eAAA;A1CunRD;;A0CpnRA,gBAAA;AAEA;EACC,aAAA,EAAA,oDAAA;A1CsnRD;;A0ClnRA;mGAAA;AAGA;EACC,mBAAA;EACA,iBAAA;A1ConRD;;A0CjnRA;EACC,SAAA;EACA,SAAA;EACA,gBAAA,EAAA,yDAAA;EACA,mBAAA;A1ConRD;;A0CjnRA;EACC,WAAA;A1ConRD;;A0CjnRA;;;;EAIC,gEAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;A1ConRD;;A0CjnRA;EACC,SAAA,EAAA,6BAAA;A1ConRD;;A0CjnRA;EACC,YAAA,EAAA,6BAAA;A1ConRD;;A0ChnRA;mGAAA;AAGA;EACC,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,cAAA,EAAA,4BAAA;A1CknRD;;A0C/mRA;EACC,iBAAA;EACG,wBAAA;EACA,mBzCtK2B;EyCuK3B,yBAAA;EACA,czC3VyB;EyC4VzB,gBzCnKyB;EyCoKzB,mBAAA;A1CknRJ;;A0C/mRA;EACC,mBAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;A1CknRD;;A0C/mRA;EACC,oBAAA,EAAA,iCAAA;A1CknRD;;A0C/mRA;EACI,SAAA;A1CknRJ;;A0C/mRA;EACI,gBzC3N2B;AD60R/B;;A0ChnRA;mGAAA;AAGA,cAAA,mFAAA;EACC,+FAAA;EACA,mBAAA;EACA,eAAA;A1CknRD;;A0C/mRA;EACC;4CAAA;EAEA,iCAAA;EACA,kCAAA;EAEA,8BAAA;EACA,mCAAA;A1CinRD;;A0C9mRA;EACC,gCAAA,EAAA,+BAAA;A1CinRD;;A0C7mRA;mGAAA;AAGA;EACC,kBAAA;A1C+mRD;;A0C5mRA;EACC,UAAA;A1C+mRD;;A0C5mRA,mDAAA;AAEA;;EAEC,SAAA,EAAA,sCAAA;A1C8mRD;;A0C3mRA;;EAEC,YAAA,EAAA,sCAAA;A1C8mRD;;A0C3mRA;;EAEC,yBAAA;A1C8mRD;;A0C3mRA;EACC,UAAA;A1C8mRD;;A0C1mRA;EACC,UAAA;A1C6mRD;;A0C1mRA;;;CAAA;AAKA;EACC,kBAAA;EACA,UAAA;EACA,mBAAA,EAAA,uCAAA;A1C4mRD;;A0CzmRA;EACC,UAAA;A1C4mRD;;A0CzmRA;;EAEC,wCAAA;EACA,gBAAA,EAAA,sCAAA;EACA,yBAAA;EAEA,4DAAA;EACA,gBAAA;A1C2mRD;;A0CxmRA;;EAEC,2CAAA;EACA,aAAA;A1C2mRD;;A0CvmRA;mGAAA;AAGA,eAAA,mEAAA;EACC,kBAAA;EACA,kBAAA;A1CymRD;;A0CtmRA,mBAAA,yCAAA;EACC,kBAAA,EAAA,2BAAA;EACA,WAAA,EAAA,gFAAA;EACA,gBAAA,EAAA,6EAAA;A1CymRD;;A0CrmRA;mGAAA;AAGA;EACC,kBAAA,EAAA,kDAAA;EACA,cAAA,EAAA,2BAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yCzCvf4B,EyCufG,6BAAA;EAC/B,mBAAA,EAAA,sCAAA;A1CumRD;A0CrmRI;EACI,yCzC1fqB;ADimS7B;A0CrmRI;EACI,uCzC5fqB;ADmmS7B;A0CrmRI;EACI,yCzC9fqB;ADqmS7B;A0CrmRI;EACI,wCzChgBqB;ADumS7B;;A0CnmRA,gEAAA;AACA;;;EAGC,czCngB4B,EyCmgBP,uBAAA;EACrB,qBAAA,EAAA,uBAAA;A1CsmRD;;A0CnmRA;;EAEC,eAAA,EAAA,qEAAA;A1CsmRD;;A0CnmRA;4BAC4B,yCAAA;EAC3B,mBAAA;A1CsmRD;;A0CnmRA,mBAAA,6CAAA;EACC,UAAA;EACA,gBAAA;EACA,aAAA;EACA,yBAAA,EAAA,WAAA;A1CsmRD;;A0CnmRA;EACC,kBAAA;EACA,UAAA;A1CsmRD;;A0CnmRA;EACC,kBAAA;EACA,UAAA;A1CsmRD;;A0ClmRA;mGAAA;AAGA,mGAAA;AAEA;;EAEC,cAAA;EACA,oBAAA;EACA,iBAAA,EAAA,oCAAA;EACA,yBAAA;EACA,4BAAA;A1CmmRD;;A0ChmRA;;EAEC,eAAA;EACA,qBAAA;EACA,kBAAA,EAAA,oCAAA;EACA,0BAAA;EACA,6BAAA;A1CmmRD;;A0ChmRA,YAAA;AAEA,0BAAA,kDAAA;EACC,SAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;A1CkmRD;;A0C/lRA,kBAAA;AACA;;;;;;EAMC,WAAA,EAAA,2CAAA;EACA,gBAAA;A1CkmRD;;A0C/lRA,kBAAA;AACA;;;;;;EAMC,UAAA,EAAA,2CAAA;EACA,gBAAA;A1CkmRD;;A0C9lRA;;;;CAAA;AAMA;EACC,iBAAA,EAAA,qCAAA;EACA,gBAAA;A1CgmRD;;A0C5lRA,iCAAA,qCAAA;EACC,mBAAA;EACA,gBAAA;A1C+lRD;;A0C5lRA;EACC,iBAAA;A1C+lRD;;A0C5lRA,iCAAA,iCAAA;EACC,UAAA;EACA,WAAA;EACA,UAAA;A1C+lRD;;A0C3lRA;mGAAA;AAGA,8CAAA;AAEA;EACC,eAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;A1C4lRD;;A0CzlRA;EACC,0BAAA;A1C4lRD;;A0CzlRA,cAAA,4DAAA;EACC,aAAA;A1C4lRD;;A0CzlRA,qDAAA;AAEA;EACC,UAAA,EAAA,iDAAA;A1C2lRD;;A0CxlRA;EACC,UAAA;EACA,YAAA;A1C2lRD;;A0CxlRA;EACC,aAAA;A1C2lRD;;A0CxlRA;mGAAA;AAGA;EACC,kBAAA;EACA,kBAAA;A1C0lRD;;A0CvlRA;EACC,WAAA;EACA,gBAAA;A1C0lRD;;A0CvlRA;EACC,YAAA;A1C0lRD;;A0CvlRA;EACC,qBAAA;A1C0lRD;;A0CvlRA,qDAAA;AACA,0BAAA,uDAAA;EACC,WAAA;EACA,mBAAA;A1C0lRD;;A0CvlRA,0DAAA;AACA,qCAAA,uDAAA;EACC,cAAA;A1C0lRD;;A0CvlRA,eAAA;AAEA;EACC,SAAA;A1CylRD;;A0CtlRA,4CAAA;AAEA;EACC,kBAAA;A1CwlRD;;A0CrlRA;;EAEC,UAAA;A1CwlRD;;A0CrlRA;EACC,UAAA;A1CwlRD;;A0CrlRA;;EAEC,UAAA;A1CwlRD;;A0CrlRA;EACC,UAAA;A1CwlRD;;A0CplRA;mGAAA;AAGA,iFAAA;AACA,iGAAA;AACA;;;EAKS,uBAAA;A1CslRT;;A0CnlRA;mBACmB,6DAAA;EAClB,kBAAA;EACA,UAAA;A1CslRD;;A0CnlRA;mGAAA;AAGA,sBAAA;AAEA;;EAEC,+DAAA;EACA,gBAAA,EAAA,gEAAA;EACA,mBAAA,EAAA,iEAAA;A1ColRD;;A0CjlRA;EACC,eAAA,EAAA,gDAAA;A1ColRD;;A0CjlRA,gGAAA;AAEA;EACC,gBAAA;A1CmlRD;;A0ChlRA;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;A1CmlRD;;A0ChlRA,gCAAA;AAEA;;EAEC,YAAA;A1CklRD;;A0C9kRA;EACC,kBAAA;A1CilRD;;A0C9kRA;EACC,yEAAA;EACA,qBAAA;EACA,iBAAA;A1CilRD;;A0C9kRA;EACC,YAAA;A1CilRD;;A0C9kRA;EACC,gBAAA;A1CilRD;;A0C9kRA;EACC,YAAA;EACA,yBAAA,EAAA,WAAA;EACA;;qDAAA;A1CmlRD;;A0C9kRA;mGAAA;AAGA;EACC,kBAAA;EACA,UAAA,EAAA,uDAAA;A1CglRD;;A0C7kRA;EACC,eAAA,EAAA,qDAAA;A1CglRD;;A0C7kRA;EACC,gBAAA,EAAA,gEAAA;EACA,mBAAA,EAAA,6DAAA;A1CglRD;;A0C5kRA;mGAAA;AAGA,eAAA,wCAAA;EACC,sBAAA;EACA,cAAA;EACA,mBAAA;A1C8kRD;;A0C3kRA;EACC,iBAAA;A1C8kRD;;A0C3kRA;EACC,gBAAA;A1C8kRD;;A0C3kRA;EACC,mBAAA,EAAA,uCAAA;A1C8kRD;;A0C1kRA;mGAAA;AAGA;gBACgB,6DAAA;EACf,kBAAA;EACA,UAAA;A1C4kRD;;A0CzkRA;EACC,gBAAA,EAAA,oEAAA;A1C4kRD;;A0CzkRA,sBAAA,oDAAA;EACC,4BAAA;A1C4kRD;;A0CzkRA;EACC,UAAA;A1C4kRD;;A0CzkRA;qBACqB,mEAAA;EACpB,kBAAA;EACA,UAAA;A1C4kRD;;A0CzkRA;;EAEC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;A1C4kRD;;A0CzkRA;EACC,UAAA;A1C4kRD;;A0CzkRA;EACC,UAAA;A1C4kRD;;A0CzkRA;EACC,UAAA;A1C4kRD;;A0CzkRA;EACC,UAAA;A1C4kRD;;A0CxkRA;mGAAA;AAGA;EACC,aAAA;EACA,gBAAA,EAAA,gDAAA;A1C0kRD;;A0CvkRA;EACC,wBAAA;A1C0kRD;;A0CvkRA,6CAAA,mBAAA;EACC,gBAAA,EAAA,yBAAA;A1C0kRD;;A0CtkRA;mGAAA;AAGA,wCAAA,yDAAA;EACC,kBAAA,EAAA,kEAAA;A1CwkRD;;A0CrkRA;EACC,kBAAA;EACA,OAAA;EACA,QAAA;EACA,oCAAA;A1CwkRD;;A0CpkRA;mGAAA;AAGA;sCACsC,uDAAA;EACrC,kBAAA;A1CskRD;;A0CnkRA,4CAAA,mDAAA;EACC,oBAAA;A1CskRD;;A0CnkRA,4CAAA,yCAAA;EACC,oBAAA;A1CskRD;;A0CnkRA;;EAEC,kBAAA;EACA,UAAA,EAAA,0BAAA;A1CskRD;;A0CnkRA;EACC,6CAAA;EACA,OAAA;EACA,QAAA;A1CskRD;;A0ClkRA;mGAAA;AAGA,2BAAA,gDAAA;EACC,sDAAA;EACA,mBAAA;EACA,gBAAA;EAEA,+BAAA;EACA,yBAAA;EACA,0BAAA;A1CmkRD;;A0ChkRA;EACC,sDAAA;EACA,sBAAA;EACA,mBAAA;EAEA,kCAAA;EACA,4BAAA;EACA,6BAAA;A1CkkRD;;A0C9jRA;;;;CAAA;AAMA;EACC,gBAAA,EAAA,+CAAA;A1CgkRD;;A0C7jRA;;EAEC,cAAA;A1CgkRD;;A0C7jRA;EACC,iBAAA;EACA,mBAAA;A1CgkRD;;A0C7jRA,0DAAA;AAEA;EACC,iEAAA;EACA,mBAAA;A1C+jRD;;A0C5jRA;;EAEC,4CAAA;EACA,qBAAA;EACA,mBAAA;A1C+jRD;;A0C5jRA;EACC,aAAA,EAAA,wCAAA;A1C+jRD;;A0C5jRA;EACC,yBAAA,EAAA,4CAAA;A1C+jRD;;A0C5jRA;EACC,cAAA,EAAA,4CAAA;A1C+jRD;;A0C5jRA;EACC,iBAAA,EAAA,kDAAA;EACA,UAAA,EAAA,4BAAA;A1C+jRD;;A0C5jRA,YAAA;AAEA;EACC,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;A1C8jRD;;A0C3jRA;EACC,YAAA;A1C8jRD;;A0C1jRI;EACI,qBAAA;A1C6jRR;A0C3jRI;EACI,iBzCp6BuB;EyCq6BvB,kBzCr6BuB;EyCs6BvB,mBzCt6BuB;ADm+S/B;A0C3jRI;EACI,cAAA;A1C6jRR;A0C3jRI;EACI,eAAA;A1C6jRR;A0C3jRI;;EAEI,mBzCh7BuB;AD6+S/B;A0C3jRI;EACI,mBAAA;A1C6jRR;A0C3jRI;EACI,gBAAA;A1C6jRR;A0C3jRI;EACI,gBAAA;A1C6jRR;;A2C9hTE;EAxDA,wBV7Bc;EU8Bd,yBV9Bc;EU+Bd,iBV9Ba;EU+Bb,cV5BoB;AjCsnTtB;;A2CjiTE;;EArEA,cAAA;EAKA,aAAA;A3C2mTF;;A2CtiTE;EA3FA,qBA4F4B;EAxF5B,2BAwFsC;EArFpC,gBAAA;EAuFA,kBAAA;A3CgjTJ;;A2C7iTE;EAjGA,uBAkG4B;EA9F5B,2BA8FwC;EA3FtC,gBAAA;EA6FA,kBAAA;A3CujTJ;;A2CpjTE;EAvGA,qBAwG4B;EApG5B,yBAoGsC;EA/FpC,iBAAA;EAiGA,gBAAA;A3C8jTJ;;A2C3jTE;EA7GA,qBA8G4B;EA1G5B,2BA0GsC;EAvGpC,gBAAA;EAyGA,kBAAA;A3CqkTJ;;A2ClkTE;EAnHA,qBAoH4B;EAhH5B,uBAgHsC;EAzGpC,kBAAA;EA2GA,kBAAA;A3C4kTJ;;A2CzkTE;EAzHA,uBA0H4B;EAtH5B,uBAsHwC;EA/GtC,kBAAA;EAiHA,kBAAA;A3CmlTJ;;A2ChlTE;EA/HA,qBAgI4B;EA5H5B,2BA4HsC;EAzHpC,gBAAA;EA2HA,kBAAA;A3C0lTJ;;A2CvlTE;EArIA,uBAsI4B;EAlI5B,2BAkIwC;EA/HtC,gBAAA;EAiIA,kBAAA;A3CimTJ;;A2C9lTE;EA3IA,mBA6I4B;EAzI5B,yBAyIoC;EApIlC,iBAAA;EAsIA,gBAAA;A3CumTJ;;A2CpmTE;EAlJA,mBAmJ4B;EA/I5B,2BA+IoC;EA5IlC,gBAAA;EA8IA,gBAAA;A3C8mTJ;;A2C3mTE;EAvHA,0BV7Bc;EU8Bd,iBV5Bc;EU+BZ,qBVhCgB;AjCowTpB;;A2C7mTE;EAlHA,iBV/Bc;EUgCd,qBV9Be;AjCiwTjB;;A2C9mTE;EAjHA,UAAA;EACA,iBVvCc;AjC0wThB;;A2C/mTE;EA5GA,YAAA;EACA,iBV1CgB;AjCywTlB;;A2ChnTE;EA3GA,UAAA;EACA,kBV5Ca;AjC2wTf;;A2CjnTE;EA1GA,UAAA;EACA,kBV9Ce;AjC6wTjB;;A2C3tTE;EACE,eA2GY;A3CmnThB;A2C3tTE;EACE,aAuGY;A3CsnThB;;A2CluTE;EACE,eA2GY;A3C0nThB;A2CluTE;EACE,aAuGY;A3C6nThB;;A2CzuTE;EACE,eA2GY;A3CioThB;A2CzuTE;EACE,aAuGY;A3CooThB;;A2ChvTE;EACE,eA2GY;A3CwoThB;A2ChvTE;EACE,aAuGY;A3C2oThB;;A2CvvTE;EACE,eA2GY;A3C+oThB;A2CvvTE;EACE,aAuGY;A3CkpThB;;A2C9vTE;EACE,eA2GY;A3CspThB;A2C9vTE;EACE,aAuGY;A3CypThB;;A2CrwTE;EACE,eA2GY;A3C6pThB;A2CrwTE;EACE,aAuGY;A3CgqThB;;A2C5wTE;EACE,eA2GY;A3CoqThB;A2C5wTE;EACE,aAuGY;A3CuqThB;;A2CnxTE;EACE,eA2GY;A3C2qThB;A2CnxTE;EACE,aAuGY;A3C8qThB;;A2C1xTE;EACE,eA2GY;A3CkrThB;A2C1xTE;EACE,aAuGY;A3CqrThB;;A2CjyTE;EACE,eA2GY;A3CyrThB;A2CjyTE;EACE,aAuGY;A3C4rThB;;A2CxyTE;EACE,eA2GY;A3CgsThB;A2CxyTE;EACE,aAuGY;A3CmsThB;;A2C/yTE;EACE,eA2GY;A3CusThB;A2C/yTE;EACE,aAuGY;A3C0sThB;;A2CtzTE;EACE,eA2GY;A3C8sThB;A2CtzTE;EACE,aAuGY;A3CitThB;;A2C7zTE;EACE,eA2GY;A3CqtThB;A2C7zTE;EACE,aAuGY;A3CwtThB;;A2C3sTM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;A3Ci7T3C;A2C56TE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;A3C86TJ;A2C36TE;EACE,WAAA;EACA,cAAA;EACA,WAAA;A3C66TJ;A2C16TE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;A3C46TJ;;A2CpuTM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;A3C08T3C;A2Cr8TE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;A3Cu8TJ;A2Cp8TE;EACE,WAAA;EACA,cAAA;EACA,WAAA;A3Cs8TJ;A2Cn8TE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;A3Cq8TJ;;A2C7vTM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;A3Cm+T3C;A2C99TE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;A3Cg+TJ;A2C79TE;EACE,WAAA;EACA,cAAA;EACA,WAAA;A3C+9TJ;A2C59TE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;A3C89TJ;;A2CtxTM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;A3C4/T3C;A2Cv/TE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;A3Cy/TJ;A2Ct/TE;EACE,WAAA;EACA,cAAA;EACA,WAAA;A3Cw/TJ;A2Cr/TE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;A3Cu/TJ;;A2C/yTM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;A3CqhU3C;A2ChhUE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;A3CkhUJ;A2C/gUE;EACE,WAAA;EACA,cAAA;EACA,WAAA;A3CihUJ;A2C9gUE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;A3CghUJ;;A2Cx0TM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;A3C8iU3C;A2CziUE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;A3C2iUJ;A2CxiUE;EACE,WAAA;EACA,cAAA;EACA,WAAA;A3C0iUJ;A2CviUE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;A3CyiUJ;;A2Cj2TM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;A3CukU3C;A2ClkUE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;A3CokUJ;A2CjkUE;EACE,WAAA;EACA,cAAA;EACA,WAAA;A3CmkUJ;A2ChkUE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;A3CkkUJ;;A2C13TM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;A3CgmU3C;A2C3lUE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,qBAAA;A3C6lUJ;A2C1lUE;EACE,WAAA;EACA,cAAA;EACA,WAAA;A3C4lUJ;A2CzlUE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;A3C2lUJ;;A2Cn5TM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;A3CynU3C;A2CpnUE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,6BAAA;A3CsnUJ;A2CnnUE;EACE,WAAA;EACA,cAAA;EACA,WAAA;A3CqnUJ;A2ClnUE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;A3ConUJ;;A2C56TM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;A3CkpU3C;A2C7oUE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;A3C+oUJ;A2C5oUE;EACE,WAAA;EACA,cAAA;EACA,WAAA;A3C8oUJ;A2C3oUE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;A3C6oUJ;;A2Cr8TM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;A3C2qU3C;A2CtqUE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;A3CwqUJ;A2CrqUE;EACE,WAAA;EACA,cAAA;EACA,WAAA;A3CuqUJ;A2CpqUE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;A3CsqUJ;;A2C99TM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;A3CosU3C;A2C/rUE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;A3CisUJ;A2C9rUE;EACE,WAAA;EACA,cAAA;EACA,WAAA;A3CgsUJ;A2C7rUE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;A3C+rUJ;;A2Cv/TM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;A3C6tU3C;A2CxtUE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;A3C0tUJ;A2CvtUE;EACE,WAAA;EACA,cAAA;EACA,WAAA;A3CytUJ;A2CttUE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;A3CwtUJ;;A2ChhUM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;A3CsvU3C;A2CjvUE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;A3CmvUJ;A2ChvUE;EACE,WAAA;EACA,cAAA;EACA,WAAA;A3CkvUJ;A2C/uUE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;A3CivUJ;;A2CziUM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;A3C+wU3C;A2C1wUE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,qBAAA;A3C4wUJ;A2CzwUE;EACE,WAAA;EACA,cAAA;EACA,WAAA;A3C2wUJ;A2CxwUE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;A3C0wUJ;;A2ClkUM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;A3CwyU3C;A2CnyUE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;A3CqyUJ;A2ClyUE;EACE,WAAA;EACA,cAAA;EACA,WAAA;A3CoyUJ;A2CjyUE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;A3CmyUJ;;A2C3lUM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;A3Ci0U3C;A2C5zUE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;A3C8zUJ;A2C3zUE;EACE,WAAA;EACA,cAAA;EACA,WAAA;A3C6zUJ;A2C1zUE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;A3C4zUJ;;A2C5mUA;EACI,0BAAA;A3C+mUJ;;A2C7mUA;EACI,0BAAA;A3CgnUJ;;A2C9mUA;EACI,0BAAA;A3CinUJ;;A2C/mUA;EACI,0BAAA;A3CknUJ;;A2ChnUA;EACI,0BAAA;A3CmnUJ;;A4Cx2UA,8BAAA;AACA;EAEE,kBAAA;EACA,2BAAA;EACA,wBAAA;A5C22UF;;A4C12UE;EACE;IACE,yBAAA;E5C62UJ;AACF;A4C72UE;EACE;IACE,yBAAA;E5C+2UJ;AACF;A4C/2UE;;EAEE,cAAA;EACA,6BAAA;A5Ci3UJ;;A4Ch3UE;EACE,oBAAA;A5Cm3UJ;;A4Cl3UI;EACE,sBAAA;EACA,YAAA;A5Cq3UN;;A4Cp3UM;EACE,sBAAA;A5Cu3UR;;A4Ct3UI;EACE,sBAAA;EACA,YAAA;A5Cy3UN;;A4Cx3UM;EACE,sBAAA;A5C23UR;;A4C13UE;EACE,aAAA;EACA,kBAAA;EACA,mCAAA;EAGA,kBAAA;EACA,UAAA;EAIA,6DAAA;EACA,WAAA;EACA,mDAAA;EACA,WAAA;A5C63UJ;;A4C53UI;EACE,kBAAA;EACA,mCAAA;EACA,sBAAA;EAGA,kBAAA;EAIA,wCAAA;EACA,SAAA;EACA,8CAAA;EACA,WAAA;A5C+3UN;;A4C93UE;EACE,aAAA;EACA,kBAAA;EACA,mCAAA;EAGA,kBAAA;EACA,UAAA;EAIA,6DAAA;EACA,UAAA;EACA,kDAAA;EACA,UAAA;A5Ci4UJ;;A4Ch4UI;EACE,kBAAA;EACA,mCAAA;EACA,sBAAA;EAGA,kBAAA;EAIA,wCAAA;EACA,QAAA;EACA,6CAAA;EACA,UAAA;A5Cm4UN;;A4Cl4UE;EACE,oBAAA;A5Cq4UJ;;A4Cp4UI;EACE,sBAAA;EACA,YAAA;A5Cu4UN;;A4Ct4UM;EACE,sBAAA;A5Cy4UR;;A4Cx4UI;EACE,sBAAA;EACA,YAAA;A5C24UN;;A4C14UM;EACE,sBAAA;A5C64UR;;A4C54UE;;EAEE,YAAA;A5C+4UJ;;A4C94UE;EACE,sBAAA;EACA,YAAA;A5Ci5UJ;;A4Ch5UI;EACE,sBAAA;A5Cm5UN;;A4Cl5UE;EACE,sBAAA;EACA,YAAA;A5Cq5UJ;;A4Cp5UI;EACE,sBAAA;A5Cu5UN;;A6CrgVA;;;;;EAAA;AAOA;;EAEE,wBAAA;A7CugVF;;A6CrgVA;EACE,eAAA;A7CwgVF;;A6CtgVA;EACE,WAAA;EACA,mBAAA;EACA,UAAA;EACA,SAAA;A7CygVF;A6CvgVI;EACI,kBAAA;A7CygVR;;A6CrgVA;EACE,6BAAA;EACA,SAAA;EACA,SAAA;EACA,yBAAA;EACA,uBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;EACA,YAAA;EACA,sCAAA;EACA,uCAAA;A7CwgVF;;A6CtgVA;EACE,MAAA;EACA,OAAA;EACA,yBAAA;EACA,sBAAA;EACA,UAAA;A7CygVF;;A6CvgVA;;EAEE,qBAAA;A7C0gVF;;A6CxgVA;EACE,sBAAA;A7C2gVF;;A6CzgVA;EACE,WAAA;A7C4gVF;;A6CzgVA;EACE,gBAAA;EACA,UAAA;EACA,YAAA;A7C4gVF;;A6C1gVA;EACE,WAAA;A7C6gVF;;A6C3gVA;EACI,WAAA;A7C8gVJ;;A6C5gVA;EACE,aAAA;A7C+gVF;;A6C7gVA;EACE,gBAAA;A7CghVF;;A6C9gVA;;EAEE,WAAA;EACA,qBAAA;EACA,cAAA;A7CihVF;;A6C/gVA;;;EAGE,YAAA;A7CkhVF;;A6ChhVA;;;EAGE,gBAAA;A7CmhVF;;A6CjhVA;;EAEE,UAAA;A7CohVF;;A6ClhVA;;EAEE,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,sBAAA;A7CqhVF;;A6CnhVA;EACE,WAAA;A7CshVF;;A6CphVA;;EAEE,mBAAA;A7CuhVF;;A6CrhVA;;EAEE,wBAAA;A7CwhVF;;A6CthVA;EACE,kBAAA;EACA,oBAAA;EACA,qBAAA;A7CyhVF;;A6CvhVA;EACE,aAAA;A7C0hVF;;A6CxhVA;EACE,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;A7C2hVF;;A6CzhVA;EACE,aAAA;A7C4hVF;;A6C1hVA;EACE,WAAA;A7C6hVF;;A6C3hVA;EACE,eAAA;EAGQ,sBAAA;EACT,4BAAA;A7C8hVD;;A6C5hVA;EACE,gBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,cAAA;EACA,4BAAA;EACA,kBAAA;EACD,wBAAA;EAES,gBAAA;A7C+hVV;;A6C7hVA;EACE,kBAAA;A7CgiVF;;A6C9hVA;EACE,WAAA;A7CiiVF;;A6C/hVA;EACE,mBAAA;A7CkiVF;;A6ChiVA;EACE,eAAA;EACA,yBAAA;EAGQ,iBAAA;A7CmiVV;;A6CjiVA;EACE,kBAAA;EACA,oBAAA;A7CoiVF;;A6CliVA;EACE,aAAA;A7CqiVF;;A6CniVA;EACE,qBAAA;A7CsiVF;;A6CpiVA;EACE,mBAAA;A7CuiVF;;A6CriVA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EAEQ,+CAAA;EACR,oBAAA;EACA,YAAA;EAGQ,sBAAA;A7CwiVV;;A6CtiVA;EACE,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;A7CyiVF;;A6CviVA;EACE,gBAAA;A7C0iVF;;A6CxiVA;EACE,gBAAA;EACA,SAAA;EACA,gBAAA;A7C2iVF;;A6CziVA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;A7C4iVF;;A6C1iVA;EACE,kBAAA;A7C6iVF;;A6C3iVA;EACE,aAAA;A7C8iVF;;A6C5iVA;EACE,WAAA;EACA,kCAAA;EACA,mCAAA;EACA,iDAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,aAAA;A7C+iVF;;A6C7iVA;EACE,WAAA;EACA,kCAAA;EACA,mCAAA;EACA,8BAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;A7CgjVF;;A6C9iVA;EACE,YAAA;EACA,SAAA;EACA,8CAAA;EACA,gBAAA;A7CijVF;;A6C/iVA;EACE,YAAA;EACA,SAAA;EACA,2BAAA;EACA,gBAAA;A7CkjVF;;A6ChjVA;EACE,WAAA;EACA,UAAA;A7CmjVF;;A6CjjVA;EACE,WAAA;EACA,UAAA;A7CojVF;;A6CljVA;;EAEE,cAAA;A7CqjVF;;A6CnjVA;;;EAGE,gBAAA;A7CsjVF;;A6CpjVA;EACE,WAAA;EAGQ,sBAAA;A7CujVV;;A6CrjVA;EACE,UAAA;A7CwjVF;;A6CtjVA;EACE,WAAA;EACA,WAAA;EAGQ,sBAAA;A7CyjVV;;A6CvjVA;EACE,WAAA;A7C0jVF;;A6CxjVA;EACE,kBAAA;A7C2jVF;;A6CzjVA;EACE,gBAAA;EACA,WAAA;EACA,WAAA;A7C4jVF;;A6CzjVA;EACI,eAAA;A7C4jVJ;A6CzjVQ;EACI,cAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;A7C2jVZ;A6CrjVY;EAEI,6BAAA;A7CsjVhB;A6CjjVY;EACI,oCAAA;EACA,yBAAA;EACA,UAAA;EACA,qBAAA;A7CmjVhB;A6C9iVI;EACI,4BAAA;EACA,aAAA;EACA,kBAAA;A7CgjVR;A6C9iVQ;EACI,cAAA;EACA,mBAAA;A7CgjVZ;A6C5iVI;EACI,mBAAA;A7C8iVR;;A6CziVA;EACI,yB5ChWoB;E4CiWpB,qB5CjWoB;AD64VxB;;A8Ch5VA;;;;EAAA;AAkBA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,SAAA;A9Cs4VF;;A8Cl4VA;EACI,gBAAA;A9Cq4VJ;A8Cl4VI;EACI,YAAA;EACA,WAAA;A9Co4VR;A8Cj4VY;EADJ;IAEQ,WAAA;E9Co4Vd;AACF;A8Cl4VY;EALJ;IAMQ,WAAA;E9Cq4Vd;AACF;A8Cn4VY;EATJ;IAUQ,WAAA;E9Cs4Vd;AACF;A8Cj4VY;EACI,4CAAA;EACA,wCAAA;EACA,yCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;A9Cm4VhB;A8Ch4VY;EACI,iCAAA;EACA,wCAAA;EACA,yCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;A9Ck4VhB;A8C93VQ;EACI,gBAAA;EACA,oBAAA;A9Cg4VZ;A8C93VY;EACI,gBAAA;EACA,kBAAA;A9Cg4VhB;A8C73VY;EACI,yCAAA;EACA,wCAAA;EACA,yCAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,SAAA;A9C+3VhB;A8C53VY;EACI,8BAAA;EACA,wCAAA;EACA,yCAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,SAAA;A9C83VhB;A8Cv3VY;EACI,UAAA;EACA,UAAA;A9Cy3VhB;A8Ct3VY;EACI,UAAA;EACA,UAAA;A9Cw3VhB;A8Cp3VQ;EACI,8BAAA;EACA,qBAAA;EACA,qBAAA;EACA,0BAAA;A9Cs3VZ;A8Cl3VI;EACI,SAAA;A9Co3VR;A8Cj3VI;EACI,cAAA;EACA,eAAA;A9Cm3VR;A8Ch3VI;EACI,gBAAA;A9Ck3VR;A8C/2VI;EACI,WAAA;EACA,YAAA;EACA,gB7C+DqB;E6C9DrB,mB7CuDuB;E6CtDvB,WAAA;EACA,kBAAA;A9Ci3VR;A8C92VI;EACI,YAAA;A9Cg3VR;A8C72VI;EAEI,0BAAA;A9C82VR;A8C32VI;EAEI,4BAAA;A9C42VR;A8Cz2VI;EAEI,0BAAA;A9C02VR;A8Cv2VI;EAEI,4BAAA;A9Cw2VR;A8Cr2VI;EAEI,qBAAA;A9Cs2VR;A8Cn2VI;EAEI,uBAAA;A9Co2VR;A8Cj2VI;EAEI,uBAAA;A9Ck2VR;A8C/1VI;EAEI,2BAAA;A9Cg2VR;A8C71VI;EAEI,gCAAA;A9C81VR;A8C31VI;EACI,kBAAA;EACA,kB7CrBwB;E6CsBxB,eAAA;A9C61VR;A8C31VQ;EAEI,uCAAA;A9C41VZ;A8Cz1VQ;EACI,UAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;A9C21VZ;A8Cz1VY;EACI,gBAAA;EACA,aAAA;EACA,WAAA;EACA,kB7CxCgB;E6CyChB,0BAAA;A9C21VhB;A8Cx1VY;;EAEI,c7CtOQ;ADgkWxB;A8Cr1VI;EACI,WAAA;EACA,SAAA;A9Cu1VR;A8Cp1VQ;EAGI,kBAAA;A9Co1VZ;A8C/0VQ;EAGI,YAAA;EACA,iBAAA;EACA,WAAA;A9C+0VZ;A8C70VY;EACI,YAAA;A9C+0VhB;A8C50VY;EAEI,gBAAA;EACA,c7C9Oa;E6C+Ob,mBAAA;A9C60VhB;A8C10VY;EAEI,kB7CpFgB;E6CqFhB,YAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;A9C20VhB;A8Cv0VY;EAEI,yBAAA;A9Cw0VhB;A8Cr0VY;EAEI,qBAAA;A9Cs0VhB;A8Cn0VY;EACI,kBAAA;EACA,gCAAA;EACA,kB7C/Fe;E6CgGf,yBAAA;EACA,c7C1Qa;E6C2Qb,gB7ClFa;E6CmFb,mBAAA;EACA,iB7ClJe;ADu9V/B;A8Cj0VQ;EACI,eAAA;A9Cm0VZ;A8Cj0VY;EAEI,mB7C1Ra;AD4lW7B;A8C7zVY;EACI,kB7C/HgB;E6CiIhB,YAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;A9C8zVhB;A8C3zVY;EACI,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,c7C3Sa;ADwmW7B;A8C1zVY;EACI,YAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;A9C4zVhB;A8CzzVY;EAEI,kBAAA;A9C0zVhB;A8CvzVY;EAII,mB7CpUa;E6CqUb,eAAA;A9CszVhB;A8CnzVY;EAEI,c7CzUa;AD6nW7B;A8CjzVY;EACI,kBAAA;A9CmzVhB;A8CjzVgB;EACI,WAAA;EACA,qBAAA;EACA,qCAAA;EACA,4B7C3WI;E6C4WJ,oCAlW4B;EAmW5B,kBAAA;EACA,WAAA;EACA,UAAA;A9CmzVpB;A8C/yVY;EAEI,yB7CrXQ;E6CsXR,c7CxQa;ADwjW7B;A8C5yVY;EACI,yBAAA;A9C8yVhB;A8C3yVY;EAEI,gBAAA;EACA,c7CzWa;E6C0Wb,mBAAA;A9C4yVhB;A8CzyVY;EAGG,qBAAA;EACC,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;A9CyyVhB;A8CvyVgB;EACI,mB7C3XS;ADoqW7B;A8CtyVgB;EACI,yB7CtZI;E6CuZJ,c7CzSS;ADilW7B;A8CryVgB;EACI,c7CnYS;AD0qW7B;A8CpyVgB;EAEI,gBAAA;EACA,c7CzYS;E6C0YT,mBAAA;A9CqyVpB;A8C5xVQ;;;EACI,6BAAA;A9CgyVZ;A8C3xVgB;;;EACI,c7ChaS;E6CiaT,6BAAA;A9C+xVpB;A8CxxVQ;EACI,YAAA;EACA,iBAAA;A9C0xVZ;;A8CpxVI;EACI,eAAA;A9CuxVR;;A8CnxVA;;;;;;EAMI,YAAA;A9CsxVJ;;A8CnxVA;EACI,UAAA;EAKA,uCAAA;A9CsxVJ;A8CpxVI;EAKI,qCAAA;A9CsxVR;A8CpxVI;EACI,UAAA;EAKA,iCAAA;EACA,iEAAA;A9CsxVR;;A8CjxVA;EACI,oBAAA;A9CoxVJ;;A8CjxVA;EAKI,mCAAA;A9CoxVJ;A8ClxVI;EACI,8BAAA;EACA,mCAAA;EACA,oCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;A9CoxVR;A8ClxVI;EACI,8BAAA;EACA,mCAAA;EACA,oCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;A9CoxVR;;A+C/xWA,8CAAA;AAGA;;;EAAA;AAIA;;EAEA,2BAAA;EACA,6CAAA;EACA,yBAAA;EAEC,kBAAA;EAGA,iBAAA;EAEA,sBAAA;A/CgyWD;;A+C9xWA;EACC,kBAAA;EACA,cAAA;A/CiyWD;;A+C/xWA;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA,EAAA,YAAA;A/CkyWD;;A+ChyWA;EACC,kBAAA;EACA,QAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;A/CmyWD;;A+CjyWA;EACC,kBAAA;EACA,SAAA;EACA,QAAA;A/CoyWD;;A+ClyWA;EACC,kBAAA;EACA,UAAA;A/CqyWD;;A+CnyWA;;EAGC,wDAAA;A/CsyWD;;A+CpyWA;EACC,0BAAA;A/CuyWD;;A+CpyWA;;EAAA;AAGA;;EAGC,+BAAA;A/CuyWD;;A+CpyWA;EAAA;AAEA;EACC,WAAA;A/CuyWD;;A+CryWA;EACI,kBAAA;EACH,yB9C0C4B;E8CzC5B,2CAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACG,kBAAA;EACA,gBAAA;EACH,aAAA;A/CwyWD;;A+CtyWA;EACC,WAAA;A/CyyWD;;A+CvyWA;EACC,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;A/C0yWD;;A+CvyWA;EAAA;AAEA;EACC,0CAAA;EACA,kBAAA;A/C0yWD;;A+CxyWA;EACC,mB9C5E4B;E8C6EzB,kBAAA;EAEH,4BAAA;A/C2yWD;;A+CxyWA;EAAA;AAEA;EACC,iBAAA;A/C2yWD;;A+CzyWA;EACC,iBAAA;A/C4yWD;;A+C1yWA;EAEC,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,4EAAA;EAGA,iCAAA;EACG,8BAAA;EACA,6BAAA;EACA,2BAAA;EACA,yBAAA;A/C0yWJ;;A+CxyWA;EAKI,+BAAA;A/C2yWJ;;A+CxyWA;EAAA;AAGA;EACC,mBAAA;A/C0yWD;;A+CxyWA;;;EAGC,mBAAA;A/C2yWD;;A+CxyWA;;EAAA;AAGA;;EAGC,sBAAA;A/C2yWD;;A+CzyWA;EACC,kBAAA;EACA,WAAA;A/C4yWD;;A+CzyWA;;EAAA;AAGA;EACC,kBAAA;EACA,kBAAA;A/C4yWD;;A+C1yWA;EACC,WAAA;EACA,eAAA;A/C6yWD;;A+C1yWA;;EAAA;AAGA;EACC,kBAAA;EACA,gBAAA;A/C6yWD;;A+C3yWA;EACC,gBAAA;A/C8yWD;;A+C5yWA;EACC,gBAAA;A/C+yWD;;A+C5yWA;;EAAA;AAGA;EACC,eAAA;EACA,YAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;A/C+yWD;;A+C7yWA;EAEC,oCAAA;A/CgzWD;;A+C7yWA;EACC,iBAAA;EACA,UAAA;EACA,WAAA;A/CgzWD;;A+C9yWA;EACC,YAAA;A/CizWD;;A+C/yWA;EACC,YAAA;A/CkzWD;;A+C/yWA;;EAAA;AAGA;EACC,eAAA;EACA,YAAA;EACA,MAAA;EACA,UAAA;A/CkzWD;;A+ChzWA;EAEC,iCAAA;EACA,kBAAA;A/CmzWD;;A+ChzWA;EACC,UAAA;EACA,WAAA;EACA,gBAAA;A/CmzWD;;A+CjzWA;EACC,WAAA;A/CozWD;;A+ClzWA;EACC,WAAA;A/CqzWD;;A+ClzWA;EACC,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;A/CqzWD;;A+CnzWA;EAEI,6BAAA;EACA,SAAA;EACA,YAAA;A/CszWJ;;A+CpzWA;EAEI,6BAAA;EACA,QAAA;EACA,WAAA;A/CuzWJ;;A+ChzWE;EAEU,yB9C1JiB;AD48W7B;;A+C7yWE;EAEU,yB9C1QY;ADyjXxB;;A+C1yWQ;EAEI,yB9CtRY;ADkkXxB;;A+CxyWQ;EAEI,yB9CzRY;ADmkXxB;;A+CtyWQ;EAEI,yB9C9RY;ADskXxB;;A+CpyWQ;EAEI,yB9CtSY;AD4kXxB;;AgDjlXA,sCAAA;AACA;;;EAAA;AAIA;;EAEE,2BAAA;EACA,6CAAA;EACA,yBAAA;EAEA,kBAAA;EAGA,iBAAA;EAEA,sBAAA;AhDolXF;;AgDllXA;EACE,kBAAA;AhDqlXF;;AgDnlXA;;EAEE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;AhDslXF;;AgDplXA;EAAA;AAEA;EACE,gBAAA;EACA,UAAA;AhDulXF;;AgDrlXA;;EAEE,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,QAAA;EACA,yBAAA;EACA,6BAAA;EACA,oCAAA;EACA,qBAAA;EACA,qBAAA;AhDwlXF;;AgDtlXA;EACE,YAAA;EACA,WAAA;AhDylXF;;AgDvlXA;EACE,WAAA;EACA,UAAA;AhD0lXF;;AgDxlXA;EAAA;AAEA;EACE,OAAA;EACA,WAAA;AhD2lXF;;AgDzlXA;;EAAA;AAGA;EACE,QAAA;AhD4lXF;;AgD1lXA;EACE,SAAA;AhD6lXF;;AgD3lXA;EAEE,2BAAA;EACA,kBAAA;AhD8lXF;;AgD5lXA;EACE,YAAA;EACA,WAAA;AhD+lXF;;AgD7lXA;;EAGE,0BAAA;AhDgmXF;;AgD9lXA;EACE,0BAAA;AhDimXF;;AgD/lXA;EAAA;AAEA;EACE,WAAA;AhDkmXF;;AgDhmXA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,QAAA;AhDmmXF;;AgDjmXA;EACE,WAAA;AhDomXF;;AgDlmXA;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;AhDqmXF;;AgDnmXA;EACE,WAAA;EACA,WAAA;AhDsmXF;;AgDpmXA;;EAAA;AAGA;EACE,mBAAA;EACA,kBAAA;AhDumXF;;AgDrmXA;EACE,kBAAA;AhDwmXF;;AgDtmXA;EACE,mBAAA;AhDymXF;;AgDvmXA;EAAA;AAEA;EACE,iBAAA;AhD0mXF;;AgDxmXA;EACE,iBAAA;AhD2mXF;;AgDzmXA;EACE,2CAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AhD4mXF;;AgD1mXA;EAAA;AAEA;EAAA;AAEA;EACE,mBAAA;AhD6mXF;;AgD3mXA;;;EAGE,mBAAA;AhD8mXF;;AgD5mXA;;EAAA;AAGA;;EAGE,sBAAA;AhD+mXF;;AgD7mXA;EACE,kBAAA;EACA,WAAA;AhDgnXF;;AgD9mXA;;EAAA;AAGA;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;AhDinXF;;AgD/mXA;EACE,WAAA;EACA,eAAA;AhDknXF;;AgDhnXA;;EAAA;AAGA;EACE,kBAAA;EACA,gBAAA;AhDmnXF;;AgDjnXA;EACE,gBAAA;AhDonXF;;AgDlnXA;EACE,gBAAA;AhDqnXF;;AgDnnXA;;EAAA;AAGA;EACE,eAAA;EACA,YAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;AhDsnXF;;AgDpnXA;EAEE,+BAAA;AhDunXF;;AgDrnXA;EAEE,8BAAA;AhDwnXF;;AgDtnXA;EACE,iBAAA;EACA,UAAA;EACA,WAAA;AhDynXF;;AgDvnXA;EACE,YAAA;AhD0nXF;;AgDxnXA;EACE,YAAA;AhD2nXF;;AgDznXA;;EAAA;AAGA;EACE,eAAA;EACA,YAAA;EACA,MAAA;EACA,UAAA;AhD4nXF;;AgD1nXA;EAEE,6BAAA;EACA,kBAAA;AhD6nXF;;AgD3nXA;EAEE,4BAAA;AhD8nXF;;AgD5nXA;EACE,UAAA;EACA,WAAA;EACA,gBAAA;AhD+nXF;;AgD7nXA;EACE,WAAA;AhDgoXF;;AgD9nXA;EACE,WAAA;AhDioXF;;AgD/nXA;EACE,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AhDkoXF;;AgDhoXA;EAEE,6BAAA;EACA,SAAA;EACA,YAAA;AhDmoXF;;AgDjoXA;EAEE,6BAAA;EACA,QAAA;EACA,WAAA;AhDooXF;;AgDloXA;EAEE,4BAAA;EACA,UAAA;EACA,YAAA;AhDqoXF;;AgDnoXA;EAEE,8BAAA;EACA,SAAA;EACA,WAAA;AhDsoXF;;AgDpoXA;EACE,+BAAA;AhDuoXF;;AgDpoXE;EACE,mB/CtRoB;AD65XxB;;AgDnoXE;EACE,mB/ChSoB;ADs6XxB;;AgDloXE;EACE,mB/ClSoB;ADu6XxB;;AgDjoXE;EACE,mB/CtSoB;AD06XxB;;AgDhoXE;EACE,mB/C7SoB;ADg7XxB;;AiDr7XA;EACE,cAAA;EACA,aAAA;EACA,SAAA;AjDw7XF;;AiDt7XA;EACE,iBAAA;EACA,oBAAA;EACA,0BAAA;EACA,eAAA;AjDy7XF;;AiDv7XA;EACE,mBAAA;AjD07XF;;AiDx7XA;EACE,SAAA;EACA,UAAA;AjD27XF;;AiDz7XA;EACE,sBAAA;EACA,YAAA;EAGA,aAAA;EAGA,sBAAA;EAGA,oBAAA;AjD47XF;;AiD17XA;;;EAGE,mBAAA;AjD67XF;;AiD37XA;;EAEE,gBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;AjD87XF;;AiD57XA;;;;EAIE,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AjD+7XF;;AiD77XA;EACE,cAAA;AjDg8XF;;AiD97XA;EACE,cAAA;EACA,YAAA;AjDi8XF;;AiD57XA;EACE,gBAAA;EAGA,SAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,6BAAA;EACA,cAAA;EACA,gBAAA;AjD+7XF;AiD77XI;EACE,mBAAA;AjD+7XN;;AiD37XA;;;EAGE,cAAA;EACA,qBAAA;AjD87XF;;AiD57XA;EACE,kBAAA;EAGA,iBAAA;EACA,yBAAA;EACA,UAAA;EACA,iBAAA;AjD+7XF;;AiD77XA;EAGE,aAAA;EAGA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AjDg8XF;;AiD97XA;EAGE,YAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA;EACA,iBAAA;AjDi8XF;;AiD/7XA;EACE,qBAAA;EACA,SAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,6BAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,oBAAA;EACA,kBAAA;EACA,aAAA;AjDk8XF;;AiDh8XA;EACE,aAAA;AjDm8XF;;AiDh8XE;EAEE,kBAAA;EACA,sBAAA;EACA,WAAA;AjDk8XJ;;AiD/7XA;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;AjDk8XF;;AiDh8XA;EACE,qBAAA;EACA,mBAAA;AjDm8XF;;AiDj8XA;EACE,0BAAA;EACA,6BAAA;AjDo8XF;;AiDl8XA;EACE,yBAAA;EACA,4BAAA;AjDq8XF;;AiDn8XA;EACE,kBAAA;EACA,yBAAA;EACA,4BAAA;AjDs8XF;;AiDp8XA;EACE,kBAAA;EACA,0BAAA;EACA,6BAAA;AjDu8XF;;AiDr8XA;EACE,gBAAA;AjDw8XF;;AiDt8XA;EACE,iBAAA;AjDy8XF;;AiDv8XA;EACE,cAAA;EACA,kBAAA;AjD08XF;;AiDx8XA;;EAEE,iBAAA;AjD28XF;;AiDx8XA;EACE,eAAA;EACA,oBAAA;AjD28XF;;AiDz8XA;EACE,yBAAA;AjD48XF;;AiD18XA;EACE,cAAA;AjD68XF;;AiD38XA;EACE,kDAAA;AjD88XF;;AiD58XA;EACE,yBAAA;EACA,4BAAA;AjD+8XF;;AiD78XA;EACE,0BAAA;EACA,6BAAA;AjDg9XF;;AiD98XA;EACE,yBAAA;EACA,0BAAA;AjDi9XF;;AiD/8XA;EACE,4BAAA;EACA,6BAAA;AjDk9XF;;AiDh9XA;EACE,4BAAA;EACA,6BAAA;AjDm9XF;;AiDj9XA;EACE,yBAAA;EACA,0BAAA;AjDo9XF;;AiDl9XA;EAGE,aAAA;EAGA,mBAAA;AjDq9XF;;AiDn9XA;EACE,oBAAA;AjDs9XF;;AiDp9XA;EACE,oCAAA;AjDu9XF;;AiDr9XA;EACE,0CAAA;EACA,UAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;AjDw9XF;;AiDt9XA;EACE,kBAAA;EACA,sBAAA;EACA,kBAAA;EAGA,aAAA;EAGA,sBAAA;EAGA,SAAA;EACA,WAAA;EAGA,iBAAA;EACA,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AjDy9XF;;AiDv9XA;EACE,gBAAA;AjD09XF;;AiDx9XA;EAGE,aAAA;EAGA,mBAAA;AjD29XF;;AiDx9XA;EAGE,aAAA;EACA,kBAAA;EAGA,sBAAA;EAGA,SAAA;EAEA,4BAAA;EAEA,gBAAA;EACA,YAAA;AjDy9XF;;AiDv9XA;EACE,0BAAA;AjD09XF;;AiDx9XA;EACE,SAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AjD29XF;;AiDz9XA;EACE,iBAAA;AjD49XF;;AiD19XA;;;EAGE,cAAA;EACA,qBAAA;AjD69XF;;AiD39XA;EAGE,aAAA;EAGA,mBAAA;EAGA,SAAA;EACA,gBAAA;AjD89XF;;AiD59XA;EAGE,SAAA;AjD+9XF;;AiD79XA;EACE,2BAAA;AjDg+XF;;AiD99XA;EACE,oBAAA;EACA,4BAAA;AjDi+XF;;AiD/9XA;EACE,kBAAA;EACA,UAAA;EACA,yBAAA;EACA,sBAAA;EACA,0CAAA;EACA,aAAA;AjDk+XF;;AiDh+XA;EACE,eAAA;AjDm+XF;;AiDj+XA;EACE,gCAAA;EACA,6BAAA;EACA,iBAAA;AjDo+XF;;AiDl+XA;EAGE,aAAA;EAGA,sBAAA;EAGA,SAAA;EACA,cAAA;AjDq+XF;;AiDn+XA;EACE,WAAA;EACA,sBAAA;EACA,iBAAA;EACA,yBAAA;AjDs+XF;;AiDp+XA;EACE,iBAAA;EACA,mBAAA;AjDu+XF;;AiDr+XA;EACE,kBAAA;EACA,mBAAA;EACA,yBAAA;AjDw+XF;;AiDt+XA;EACE,2BAAA;AjDy+XF;;AiDv+XA;EACE,oBAAA;EACA,4BAAA;AjD0+XF;;AiDx+XA;EACE,0BAAA;AjD2+XF;;AiDz+XA;EACE,gBAAA;EACA,gBAAA;EACA,6BAAA;AjD4+XF;;AiD1+XA;EACE,iBAAA;AjD6+XF;;AiD3+XA;EACE,yBAAA;AjD8+XF;;AiD5+XA;EACE,aAAA;AjD++XF;;AiD7+XA;EACE,aAAA;AjDg/XF;;AiD9+XA;;EAEE,mBAAA;AjDi/XF;;AiD/+XA;EACE,WAAA;AjDk/XF;;AiDh/XA;EAGE,aAAA;EAGA,sBAAA;EACA,gBAAA;AjDm/XF;;AiDj/XA;EAGE,SAAA;AjDo/XF;;AiDl/XA;EACE,6BAAA;EACA,gBAAA;EAGA,aAAA;EAGA,wBAAA;AjDq/XF;;AiDn/XA;;EAIE,UAAA;AjDs/XF;;AiDp/XA;EACE,cAAA;AjDu/XF;;AiDr/XA;EACE,kBAAA;AjDw/XF;;AiDt/XA;EACE,SAAA;EACA,OAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;AjDy/XF;;AiDv/XA;EACE,UAAA;EACA,QAAA;AjD0/XF;;AiDx/XA;EAGE,aAAA;EACA,gBAAA;EACA,gBAAA;EAGA,sBAAA;EAGA,uBAAA;EACA,gBAAA;EACA,kBAAA;AjD2/XF;;AiDz/XA;EAGE,UAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;EAGA,uBAAA;EACA,WAAA;EACA,mBAAA;AjD4/XF;;AiD1/XA;EACE,WAAA;EAGA,SAAA;EACA,qBAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;AjD6/XF;;AiD3/XA;EACE,2BAAA;AjD8/XF;;AiD5/XA;EAGE,SAAA;AjD+/XF;;AiD7/XA;EACE,iBAAA;AjDggYF;;AiD9/XA;EACE,kBAAA;AjDigYF;;AiD//XA;EACE,WAAA;EACA,kBAAA;EACA,oCAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;AjDkgYF;;AiDhgYA;EACE,YAAA;AjDmgYF;;AiDjgYA;EAGE,aAAA;EAGA,sBAAA;EAGA,SAAA;EACA,WAAA;EACA,sBAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AjDogYF;;AiDlgYA;EACE,mBAAA;AjDqgYF;;AiDngYA;EACE,uBAAA;EACA,WAAA;EACA,kBAAA;AjDsgYF;;AiDpgYA;EACE,kBAAA;EACA,UAAA;AjDugYF;;AiDrgYA;EACE,sBAAA;EACA,gBAAA;AjDwgYF;;AiDtgYA;EAGE,aAAA;EAGA,cAAA;EAGA,mBAAA;AjDygYF;;AiDvgYA;EACE,4BAAA;AjD0gYF;;AiDxgYA;EACE,qBAAA;EACA,2BAAA;AjD2gYF;;AiDzgYA;EACE,6BAAA;AjD4gYF;;AiD1gYA;EACE,6BAAA;AjD6gYF;;AiD3gYA;EAGE,SAAA;EACA,YAAA;EAGA,sBAAA;EACA,2BAAA;AjD8gYF;;AiD5gYA;EACE,oBAAA;EACA,4BAAA;AjD+gYF;;AiD7gYA;EAGE,aAAA;EAGA,SAAA;EAGA,uBAAA;EACA,WAAA;EACA,0BAAA;EACA,gBAAA;EACA,kBAAA;AjDghYF;;AiD9gYA;EAGE,UAAA;AjDihYF;;AiD/gYA;EACE,2BAAA;AjDkhYF;;AiDhhYA;EACE,oBAAA;EACA,4BAAA;AjDmhYF;;AiDjhYA;EACE,WAAA;EAGA,iBAAA;EACA,yBAAA;AjDohYF;;AiDlhYA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,oBAAA;AjDqhYF;;AiDnhYA;EACE,WAAA;EACA,kBAAA,EAAA,kDAAA;EACA,cAAA,EAAA,2BAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,yChDtoB2B,EgDsoBI,6BAAA;EAE/B,mBAAA,EAAA,sCAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;AjDqhYF;AiDnhYE;EACE,yChD9oByB;ADmqZ7B;AiDnhYE;EACE,uChDhpByB;ADqqZ7B;AiDnhYE;EACE,yChDlpByB;ADuqZ7B;AiDnhYE;EACE,wChDppByB;ADyqZ7B;AiDlhYE;EACE,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;AjDohYJ;;AiDjhYA;EACE,yBAAA;EACA,uBAAA;EAAA,0BAAA;EACA,2BAAA;EAAA,8BAAA;AjDohYF;;AiDjhYA;EACE,yBhDrkB2B;ADylZ7B;;AiDlhYA;EACE;IACE,cAAA;EjDqhYF;EiDphYE;IACE,cAAA;IACA,kBAAA;EjDshYJ;EiDphYE;IACE,cAAA;IACA,kBAAA;IACA,UAAA;EjDshYJ;AACF;AkD5tZA;EACE,uBAAA;EACA,oBAAA;EAAA,uBAAA;EACA,qBAAA;EAAA,wBAAA;AlD8tZF;;AmDjuZA;EACE,iBAAA;E7CoCE,4BAAA;ANqsZJ;AoDzuZE;EACE,yBnDMoB;ADquZxB;AoDvuZI;EACE,qBnDCkB;ADwuZxB;AoDluZM;EACE,qBnDPgB;EmDQhB,cnDRgB;AD4uZxB;AoD9tZI;EACE,yBnDfkB;AD+uZxB;AoD5tZE;EACE,yBnDpBoB;ADkvZxB;AoD3tZE;EACE,qBnDxBoB;ADqvZxB;AoD5vZE;EACE,yBnDIoB;AD0vZxB;AoD1vZI;EACE,qBnDDkB;AD6vZxB;AoDrvZM;EACE,qBnDTgB;EmDUhB,cnDVgB;ADiwZxB;AoDjvZI;EACE,yBnDjBkB;ADowZxB;AoD/uZE;EACE,yBnDtBoB;ADuwZxB;AoD9uZE;EACE,qBnD1BoB;AD0wZxB;AoD/wZE;EACE,yBnDKoB;AD4wZxB;AoD7wZI;EACE,qBAAA;ApD+wZN;AoDxwZM;EACE,qBnDRgB;EmDShB,cnDTgB;ADmxZxB;AoDpwZI;EACE,yBnDhBkB;ADsxZxB;AoDlwZE;EACE,yBnDrBoB;ADyxZxB;AoDjwZE;EACE,qBnDzBoB;AD4xZxB;AoDlyZE;EACE,yBnDGoB;ADiyZxB;AoDhyZI;EACE,qBnDFkB;ADoyZxB;AoD3xZM;EACE,qBnDVgB;EmDWhB,cnDXgB;ADwyZxB;AoDvxZI;EACE,yBnDlBkB;AD2yZxB;AoDrxZE;EACE,yBnDvBoB;AD8yZxB;AoDpxZE;EACE,qBnD3BoB;ADizZxB;AoDrzZE;EACE,yBnDCoB;ADszZxB;AoDnzZI;EACE,qBnDJkB;ADyzZxB;AoD9yZM;EACE,qBnDZgB;EmDahB,cnDbgB;AD6zZxB;AoD1yZI;EACE,yBnDpBkB;ADg0ZxB;AoDxyZE;EACE,yBnDzBoB;ADm0ZxB;AoDvyZE;EACE,qBnD7BoB;ADs0ZxB;AmDrzZE;EACE,0BAAA;EACA,oBAAA;EACA,6BAAA;AnDuzZJ;AmDtzZI;EACE,kBAAA;AnDwzZN;AmDvzZM;EACE,clDGqB;EkDFrB,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;AnDyzZR;AmDpzZE;EACE,gBAAA;AnDszZJ;AmDnzZE;;;;;;EAME,6BAAA;EACA,gBAAA;AnDqzZJ;AmDlzZE;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;AnDozZJ;AmDjzZE;EACE,kBAAA;AnDmzZJ;AmDjzZI;EACE,aAAA;EACA,mBAAA;EAEA,uBAAA;AnDmzZN;AmD/yZE;;EAEE,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,UAAA;EACA,sBAAA;AnDizZJ;AmD/yZE;EACE,iBAAA;AnDizZJ;AmD9yZE;EACE,YAAA;EACA,aAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,4BAAA;AnDgzZJ;AmD9yZI;EACE,qBAAA;AnDgzZN;AmD5yZE;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,4CAAA;EACA,QAAA;EACA,SAAA;EACA,yBlDrFyB;EkDuFzB,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AnD6yZJ;AmD1yZE;EACE,eAAA;EACA,cAAA;EACA,YAAA;EACA,OAAA;EACA,qBAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;AnD4yZJ;AmDzyZE;EACE,WAAA;AnD2yZJ;AmDxyZE;EACE,iBAAA;EACA,eAAA;AnD0yZJ;AmDvyZE;EACE,eAAA;AnDyyZJ;AmDvyZI;EACE,gBAAA;AnDyyZN;AmDryZE;EACE,aAAA;AnDuyZJ;AmDpyZE;EACE,kBAAA;EACA,oBAAA;AnDsyZJ;AmDpyZI;EACE,eAAA;AnDsyZN;AmDlyZE;EACE,kBAAA;AnDoyZJ;AmDjyZE;EACE,yBAAA;AnDmyZJ;AmDhyZE;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;AnDkyZJ;AmD/xZE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;AnDiyZJ;AmD/xZI;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;AnDiyZN;AmD9xZI;EACE,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,clDrKuB;EkDsKvB,mBAAA;EACA,yBAAA;EACA,oBAAA;EACA,4BAAA;AnDgyZN;AmD7xZI;EACE,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;AnD+xZN;AmD1xZM;EACE,qBAAA;AnD4xZR;AmDxxZI;;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;AnD0xZN;AmDtxZE;EACE,aAAA;AnDwxZJ;AmDrxZE;EACE,mBAAA;EACA,mBAAA;AnDuxZJ;AmDpxZE;EACE,SAAA;AnDsxZJ;AmDnxZE;EACE,yBlDxMyB;AD69Z7B;AmDnxZI;EACE,cAAA;AnDqxZN;AmDlxZI;EACE,oBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AnDoxZN;AmDjxZI;;;;;EAKE,yBAAA;EACA,gBAAA;AnDmxZN;AmDhxZI;EACE,cAAA;EACA,eAAA;EACA,eAAA;AnDkxZN;AmD9wZE;EACE,gBAAA;AnDgxZJ;AmD3wZI;;E7CzMI,iCAAA;AN49ZR;;AqDjiaA;;CAAA;AAIA;EACE,kBAAA;ArDmiaF;AqDliaE;EAKE,4BAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;ArDoiaJ;AqDjiaI;EACE,UAAA;EACA,mBAAA;EACA,aAAA;ArDmiaN;;AqD/haA;EACE,aAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,qCAAA;EACA,mBAAA;EAEA,4CAAA;EACA,oCAAA;EACA,4BAAA;EACA,gBAAA;ArDkiaF;AqDhiaE;EACE,4CAAA;EACA,mCAAA;EACA,oCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;ArDkiaJ;AqDhiaE;EACE,iCAAA;EACA,mCAAA;EACA,oCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;ArDkiaJ;;AqD9haA;EACE,cAAA;EACA,SAAA;ArDiiaF;;AqD/haA;EACE,gBAAA;EACA,gBAAA;ArDkiaF;;AqD/haA;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;ArDkiaF;;AqD/haA;EACE,WAAA;EACA,SAAA;EACA,gCAAA;ArDkiaF;;AqDhiaA;;EAEE,kBAAA;EACA,YAAA;ArDmiaF;;AqDjiaA;EACE,eAAA;ArDoiaF;;AqDliaA;EACE,YAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;ArDqiaF;AqDpiaE;EAGE,oCAAA;EACA,cpDWyB;ADyha7B;;AqD/haI;EACE,kBAAA;EACA,gCAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;ArDkiaN;AqDhiaI;;EAEE,cpD5FuB;AD8na7B;;AqD7haA;;;;;EAKE,mBAAA;EACA,eAAA;ArDgiaF;;AqD9haA;EACE,kBAAA;ArDiiaF;;AqD/haA;EACE,yBAAA;ArDkiaF;;AqDhiaA;;EAEE,gBAAA;EACA,cAAA;EACA,mBAAA;ArDmiaF;;AqDhiaA;EACE,cAAA;ArDmiaF;;AqDjiaA;;EAEE,gBAAA;EACA,cAAA;EACA,mBAAA;ArDoiaF;;AqDliaA;EACE,eAAA;EACA,mBAAA;ArDqiaF;;AqDniaA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ArDsiaF;;AqDpiaA;;EAEE,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;ArDuiaF;;AqDpiaA;;EAEE,cAAA;EACA,2BAAA,EAAA,eAAA;EACA,yBAAA,EAAA,wBAAA,EACA,cAAA,EACA,YAAA,EACA,2BAAA;EACA,iBAAA;ArDuiaF;;AqDpiaA;;EAEE,gBAAA;EACA,cAAA;EACA,mBAAA;ArDuiaF;;AqDriaA;EACE,eAAA;ArDwiaF;;AqDtiaA;EACE,mBAAA;ArDyiaF;;AqDtiaA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;ArDyiaF;;AqDviaA;EACE,sBAAA;ArD0iaF;;AqDviaA;EACE,WAAA;EACA,YAAA;ArD0iaF;;AqDviaA;;EAEE,YAAA;EACA,UAAA;EACA,eAAA;ArD0iaF;;AqDxiaA;;EAEE,gBAAA;ArD2iaF;;AqDxiaA;EACE,qBAAA;ArD2iaF;;AqDviaE;EACE,WAAA;EACA,WAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;ArD0iaJ;AqDxiaE;EACE,QAAA;EACA,6BAAA;ArD0iaJ;;AqDtiaA;EACE,aAAA;ArDyiaF;;AqDtiaA;EACE,WAAA;ArDyiaF;AqDxiaE;EACE,YAAA;EACA,YAAA;EACA,6BAAA;ArD0iaJ;;AqDriaI;EACE,cpD1PkB;EoD2PlB,kBAAA;EACA,yBAAA;ArDwiaN;;AqDniaA;EACE,YAAA;EACA,kBAAA;ArDsiaF;;AqDpiaA;EACE,iBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,cpDhP2B;EoDqP3B,4BAAA;EAEA,2BAAA,EAAA,eAAA;EACA,yBAAA,EAAA,wBAAA,EACA,cAAA,EACA,YAAA,EACA,2BAAA;EACA,iBAAA;ArDsiaF;;AqDpiaA;EACE,gBAAA;EACA,cAAA;ArDuiaF;;AqDriaA;EACE,gBAAA;ArDwiaF;;AqDriaA;EACE,sBAAA;EACA,iBAAA;EACA,WAAA;ArDwiaF;;AqDriaA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;ArDwiaF;;AqDtiaA;;EAEE,oBAAA;ArDyiaF;AqDxiaE;;;;EAEE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;ArD4iaJ;AqD1iaI;;;;EACE,oCAAA;EACA,cpD7MuB;AD4va7B;;AqDxiaI;EACE,eAAA;ArD2iaN;;AsD/2aI;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AtDk3aN;AsDj3aM;EACE,gBAAA;AtDm3aR;;AuD33aA;;;;;;CAAA;AASA;;CAAA;AAKE;EACE,gBAAA;EACA,+BAAA;EACA,8BAAA;EACA,sBAAA;EACA,sBAAA;EACA,yBAAA;EAEA,uCAAA;EAEA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,iCAAA;AvD03aJ;AuDx3aE;EACE,gBAAA;EACA,iBAAA;EAAA,uBAAA;EACA,cAAA;EAAA,oBAAA;EACA,kBAAA;EACA,iBAAA;AvD03aJ;AuDx3aE;EACE,eAAA;EACA,cAAA;EACA,iBAAA;AvD03aJ;AuDt3aM;EACE,6BAAA;AvDw3aR;AuDp3aU;EACE,yCAAA;EACA,WAAA;AvDs3aZ;AuDj3aQ;EACE,yCAAA;EACA,WAAA;AvDm3aV;AuD/2aQ;EACE,cAAA;EACA,eAAA;AvDi3aV;AuD52aE;EACE,yBtDwCyB;EsDvCzB,kCAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,WAAA;AvD82aJ;AuD72aI;EACE,4BAAA;EACA,6BAAA;AvD+2aN;AuD32aQ;EACE,yBAAA;EACA,SAAA;AvD62aV;AuD12aM;EACE,yBAAA;EACA,gBAAA;AvD42aR;AuDx2aM;EACE,oBAAA;EACA,kBAAA;EACA,6BAAA;AvD02aR;AuDz2aQ;EACE,oBAAA;AvD22aV;AuDz2aQ;EACE,gBAAA;AvD22aV;AuDx2aM;EACE,QAAA;EACA,ctD1FqB;ADo8a7B;AuDv2aI;EACE,ctDxFuB;EsDyFvB,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,OAAA;EACA,cAAA;EACA,eAAA;AvDy2aN;AuDv2aI;;EAEE,mBAAA;AvDy2aN;AuDv2aI;EACE,WAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;EACA,iBAAA;AvDy2aN;AuDx2aM;EACE,aAAA;AvD02aR;AuDx2aM;EACE,UAAA;EACA,qBAAA;AvD02aR;AuDv2aQ;EACE,6BAAA;EACA,0CAAA;EACA,mBAAA;EACA,2BAAA;EACA,qBAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,WAAA;AvDy2aV;AuDv2aQ;EACE,yBtDTmB;ADk3a7B;AuDv2aQ;EACE,aAAA;AvDy2aV;AuDr2aQ;EACE,YAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACA,QAAA;EACA,kBAAA;EACA,iBAAA;AvDu2aV;AuDr2aQ;EACE,aAAA;AvDu2aV;AuD/1aQ;EACE,qBtD9Kc;AD+gbxB;AuD71aQ;;EAEE,ctDpLc;ADmhbxB;AuD31aI;EACE,yBAAA;AvD61aN;AuD51aM;EACE,ctDnEqB;EsDoErB,8BAAA;AvD81aR;AuD71aQ;EACE,ctD9Lc;EsD+Ld,6BAAA;AvD+1aV;AuDv1aQ;EACE,qBtD1Mc;ADmibxB;AuDr1aQ;;EAEE,ctDhNc;ADuibxB;AuDn1aI;EACE,yBAAA;AvDq1aN;AuDp1aM;EACE,ctDrFqB;EsDsFrB,8BAAA;AvDs1aR;AuDr1aQ;EACE,ctD1Nc;EsD2Nd,6BAAA;AvDu1aV;AuD/0aQ;EACE,qBtDvOc;ADwjbxB;AuD70aQ;;EAEE,ctD7Oc;AD4jbxB;AuD30aI;EACE,yBAAA;AvD60aN;AuD50aM;EACE,ctDnHqB;EsDoHrB,8BAAA;AvD80aR;AuD70aQ;EACE,ctDvPc;EsDwPd,6BAAA;AvD+0aV;AuDv0aQ;EACE,qBtD7Pc;ADskbxB;AuDr0aQ;;EAEE,ctDnQc;AD0kbxB;AuDn0aI;EACE,yBAAA;AvDq0aN;AuDp0aM;EACE,ctDrIqB;EsDsIrB,8BAAA;AvDs0aR;AuDr0aQ;EACE,ctD7Qc;EsD8Qd,6BAAA;AvDu0aV;AuD/zaQ;EACE,qBtDzRc;AD0lbxB;AuD7zaQ;;EAEE,ctD/Rc;AD8lbxB;AuD3zaI;EACE,yBAAA;AvD6zaN;AuD5zaM;EACE,ctD1JqB;EsD2JrB,8BAAA;AvD8zaR;AuD7zaQ;EACE,ctDzSc;EsD0Sd,6BAAA;AvD+zaV;AuD1zaE;EACE,yBAAA;AvD4zaJ;AuD3zaI;EACE,kBAAA;EACA,ctD3RuB;EsD4RvB,8BAAA;AvD6zaN;AuD5zaM;EACE,ctD7RqB;EsD8RrB,6BAAA;AvD8zaR;AuDxzaM;EACE,aAAA;AvD0zaR;AuDxzaM;EACE,yBAAA;EACA,yBAAA;AvD0zaR;AuDvzaI;EACE,yBAAA;AvDyzaN;;AwDpobA;EACE,kBAAA;EAGA,aAAA;EAIA,sBAAA;EACA,6BAAA;AxDuobF;;AwDpobE;EACE,iBAAA;AxDuobJ;AwDrobE;EACE,gBAAA;AxDuobJ;AwDrobE;EACE,kBAAA;AxDuobJ;;AwDpobA;EACE,sBAAA;AxDuobF;;AwDrobA;EAGE,YAAA;EAGA,aAAA;EAIA,sBAAA;EAGA,oBAAA;EACA,WAAA;EACA,yBAAA;EACA,cAAA;AxDwobF;;AwDtobA;EAGE,cAAA;EAGA,aAAA;EAIA,sBAAA;EACA,yBAAA;EAGA,iBAAA;AxDyobF;;AwDvobA;EACE,+BAAA;EACA,4CAAA;AxD0obF;;AwDxobA;EACE,4CAAA;AxD2obF;;AwDzobA;;EAEE,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;AxD4obF;AwD3obE;;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AxD8obJ;;AwD3obA;EACE,kBAAA;AxD8obF;;AwD5obA;EACE,iBAAA;EACA,SAAA;EAAA,eAAA;AxD+obF;;AwD5obE;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,SAAA;EACA,WAAA;EACA,kCAAA;EACA,gBAAA;AxD+obJ;;AwD3obE;EACE,gBAAA;EACA,SAAA;EACA,kBAAA;EACA,qBAAA;EACA,SAAA;EACA,WAAA;EACA,kCAAA;EACA,gBAAA;EACA,YAAA;AxD8obJ;;AwD1obE;EACE,gBAAA;EACA,QAAA;EACA,kBAAA;EACA,qBAAA;EACA,SAAA;EACA,WAAA;EACA,kCAAA;EACA,gBAAA;EACA,YAAA;AxD6obJ;;AwD1obA;;EAEE,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mEAAA;EACA,qCAAA;AxD6obF;AwD1obI;;;;;;EAGE,iBAAA;EACA,iBAAA;AxD+obN;;AwDvobI;;;;;;EAGE,iBAAA;EACA,iBAAA;AxD6obN;;AwDzobA;;EAEE,eAAA;AxD4obF;;AwD1obA;;EAEE,eAAA;AxD6obF;;AwD3obA;EACE,iBAAA;AxD8obF;;AwD5obA;EACE,gBAAA;AxD+obF;;AwD7obA;EACE,gBAAA;EACA,uBAAA;AxDgpbF;AwD/obE;EACE,aAAA;AxDipbJ;;AwD9obA;EACE,2BAAA;AxDipbF;;AwD/obA;;EAEE,UAAA;EACA,QAAA;EACA,yBAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,oBAAA;AxDkpbF;;AwDhpbA;EACE,oCAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;AxDmpbF;;AwDjpbA;EACE,oCAAA;EACA,0BAAA;EACA,kBAAA;EACA,iBAAA;AxDopbF;;AwDlpbA;EAGE,kBAAA;EAGA,aAAA;EAIA,sBAAA;EACA,cAAA;AxDqpbF;;AwDnpbA;EACE,4CAAA;AxDspbF;;AwDppbA;EACE,gBAAA;AxDupbF;;AwDrpbA;EACE,eAAA;AxDwpbF;;AwDtpbA;EACE,eAAA;AxDypbF;;AwDvpbA;EAGE,cAAA;EAGA,aAAA;EAIA,sBAAA;EAGA,oBAAA;AxD0pbF;;AwDxpbA;EAGE,cAAA;EAGA,oBAAA;AxD2pbF;;AwDzpbA;;EAIE,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,uDAAA;EACA,YAAA;AxD4pbF;;AwD1pbA;;EAEE,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,oBAAA;EACA,qBAAA;AxD6pbF;;AwD3pbA;EACE,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,cAAA;AxD8pbF;;AwD5pbA;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EAEA,+CAAA;EACA,qCAAA;EACA,sCAAA;EACA,wCAAA;EACA,4DAAA;EACA,eAAA;AxD+pbF;;AwD7pbA;EAEE,0CAAA;AxDgqbF;;AwD9pbA;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AxDiqbF;;AwD/pbA;EAGE,cAAA;EAGA,aAAA;EAIA,sBAAA;EACA,0CAAA;AxDkqbF;;AwDhqbA;EACE,2CAAA;AxDmqbF;;AwDjqbA;EACE,eAAA;AxDoqbF;;AwDlqbA;EACE,+BAAA;AxDqqbF;;AwDnqbA;EACE,+BAAA;AxDsqbF;;AwDpqbA;EACE,UAAA;EAGA,aAAA;EAGA,8BAAA;EAGA,oBAAA;EAEA,eAAA;EACA,YAAA;AxDuqbF;;AwDjqbA;;EAEE,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;AxDoqbF;AwDnqbE;;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AxDsqbJ;;AwDnqbA;EACE,wBAAA;EAEA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,yBAAA;EACA,8BAAA;EACA,yBAAA;EACA,eAAA;EACA,aAAA;AxDsqbF;;AwDpqbA;EACE,YAAA;EACA,mBAAA;AxDuqbF;;AwDrqbA;EACE,8BAAA;EACA,WAAA;AxDwqbF;;AwDtqbA;;EAIE,SAAA;EACA,kBAAA;AxDyqbF;;AwDvqbA;EAGE,WAAA;EACA,kBAAA;EACA,gBAAA;EAGA,aAAA;EAIA,mBAAA;EAEA,eAAA;EAGA,mBAAA;EAEA,6BAAA;AxD0qbF;;AwDxqbA;EACE,qBAAA;EACA,gBAAA;EACA,mBAAA;AxD2qbF;;AwDzqbA;EACE,qBAAA;AxD4qbF;;AwD1qbA;EACE,gBAAA;AxD6qbF;;AwD3qbA;EACE,cAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EAEA,gCAAA;EACA,oCAAA;EACA,yBAAA;EACA,UAAA;EACA,oBAAA;EACA,aAAA;EACA,yBAAA;AxD8qbF;;AwD5qbA;EACE,cAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,oCAAA;EACA,yBAAA;EACA,WAAA;EACA,UAAA;EACA,oBAAA;AxD+qbF;;AwD7qbA;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,OAAA;EACA,eAAA;EACA,yBAAA;EAEA,2BAAA;EACA,yDAAA;AxDgrbF;;AwD9qbA;EACE,UAAA;EACA,UAAA;EACA,mBAAA;AxDirbF;;AwD/qbA;EAEE,0BAAA;AxDkrbF;;AwDhrbA;;EAEE,2BAAA;EACA,kBAAA;EACA,yBAAA;EAGA,iBAAA;AxDmrbF;;AwDhrbA;EACE,aAAA;AxDmrbF;;AwDjrbA;EACE,eAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;AxDorbF;;AyDxqcA;EACE,sBAAA;AzD2qcF;;A0D5qcA;EACE,6BAAA;EAAA,yBAAA;A1D+qcF;A0D9qcE;;;EAGE,+CAAA;EACA,uBAAA;EACA,UAAA;EACA,0BAAA;EACA,6BAAA;A1DgrcJ;A0D/qcI;;;EACE,kBAAA;EACA,mBAAA;A1DmrcN;A0DjrcI;;;EACE,aAAA;A1DqrcN;;A2DpscA;EACE,aAAA;EAAA,mBAAA;EACA,gBAAA;EAAA,mBAAA;A3DuscF;A2DtscE;;;EAGE,SAAA;EAAA,eAAA;EACA,mBAAA;A3DwscJ;A2DrscI;EACE,eAAA;A3DuscN;;A2DlscA;EAGM;IACE,aAAA;IAAA,mBAAA;E3DmscN;E2DjscI;IACE,QAAA;E3DmscN;AACF;A2D9rcA;EACE;;;;;;IAME,mBAAA;IACA,kBAAA;E3DgscF;AACF;A4DtucA;EACI,gCAAA;A5DwucJ;;A6DxucE;EvDwFE,mBuDvFuB;EvD6FvB,8EAAA;EACA,0BAAA;ANopcJ;A6DhvcE;EACE,WAAA;A7DkvcJ;A6DhvcE;EACE,iBAAA;A7DkvcJ;A6DhvcE;EACE,WAAA;EACA,QAAA;A7DkvcJ;;A6D5ucI;EACE,kBAAA;A7D+ucN;A6D5ucM;EACE,kBAAA;A7D8ucR;A6DzucI;EACE,iBAAA;EACA,wBAAA;A7D2ucN;;A6DtucA;EACE,aAAA;EACA,oBAAA;EACA,QAAA;EACA,SAAA;A7DyucF;;A6DtucA;EAEI;IACE,WAAA;IACA,YAAA;IACA,oBAAA;IACA,cAAA;IACA,UAAA;E7DwucJ;AACF;A6DnucE;EACE,iBAAA;EACA,yB5DsK0B;AD+jc9B;;A6DhucA;EACE,mBAAA;EACA,qEAAA;EACA,YAAA;A7DmucF;;A8DpycA;EACE,gBAAA;EACA,eAAA;EACA,UAAA;A9DuycF;A8DtycE;EACE,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iCAAA;EACA,QAAA;EACA,SAAA;EACA,uBAAA;A9DwycJ;A8DtycE;EACE,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,gBAAA;A9DwycJ;A8DtycE;EACE,2BAAA;A9DwycJ;A8DrycI;EACE,iBAAA;A9DuycN;A8DrycI;EACE,sBAAA;A9DuycN;;A+Dr0cA;EACE,sBAAA;EACA,gCAAA;EACA,gBAAA;EACA,gBAAA;EzDiCE,4BAAA;AN4ycJ;;A+Dz0cA;EACE,gCAAA;A/D40cF;;A+Dz0cA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,sBAAA;EzDYE,4BAAA;ANq0cJ;A+D90cE;EACE,iBAAA;EACA,mBAAA;A/Dg1cJ;A+D90cI;EACE,UAAA;EACA,kBAAA;A/Dg1cN;A+D50cE;EzDDE,4BAAA;EyDUA,c9D1ByB;E8D2BzB,eAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,iBAAA;EACA,qBAAA;EACA,MAAA;EACA,WAAA;EACA,UAAA;A/D20cJ;A+D91cI;EACE,gBAAA;EACA,kCAAA;EACA,gBAAA;A/Dg2cN;A+D70cE;EtChDG,qBxBLmB;EwBMnB,cxBNmB;ADs4cxB;A+D70cE;EtCpDG,qBxBVmB;EwBWnB,cxBXmB;AD+4cxB;A+D70cE;EtCxDG,qBxBPmB;EwBQnB,cxBRmB;ADg5cxB;A+D70cE;EtC5DG,qBxBNmB;EwBOnB,cxBPmB;ADm5cxB;A+D70cE;EtChEG,qBxBRmB;EwBSnB,cxBTmB;ADy5cxB;A+D30cI;EtClEC,qBxBTmB;EwBUnB,cxB+FwB;EwB9FxB,yBxBXmB;AD25cxB;A+D70cI;EtCrEC,qBxBdmB;EwBenB,cxB+FwB;EwB9FxB,yBxBhBmB;ADq6cxB;A+D/0cI;EtCxEC,qBxBXmB;EwBYnB,cxB+FwB;EwB9FxB,yBxBbmB;ADu6cxB;A+Dj1cI;EtC3EC,qBxBVmB;EwBWnB,cxB+FwB;EwB9FxB,yBxBZmB;AD26cxB;A+Dn1cI;EtC9EC,qBxBZmB;EwBanB,cxB+FwB;EwB9FxB,yBxBdmB;ADk7cxB;A+Dp1cE;EAEE,c9DYyB;ADy0c7B;;A+Dj1cA;EACE,eAAA;EACA,iBAAA;A/Do1cF;;A+Dl1cA;EACE,uBAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;A/Dq1cF","sourcesContent":["/*!\n\n =========================================================\n * Light Bootstrap Dashboard - v2.0.1\n =========================================================\n\n * Product Page: http://www.creative-tim.com/product/light-bootstrap-dashboard\n * Copyright 2020 Creative Tim (http://www.creative-tim.com)\n * License (http://www.creative-tim.com/license)\n\n =========================================================\n\n * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.\n\n */\n\n@import \"lbd/variables\";\n@import \"lbd/mixins\";\n@import \"lbd/modals\";\n\n@import \"lbd/typography\";\n\n// Core CSS\n@import \"lbd/misc\";\n@import \"lbd/sidebar-and-main-panel\";\n@import \"lbd/fixed-plugin\";\n@import \"lbd/modal\";\n\n@import \"lbd/buttons\";\n@import \"lbd/social-buttons\";\n@import \"lbd/inputs\";\n\n@import \"lbd/alerts\";\n@import \"lbd/tables\";\n\n@import \"lbd/checkbox-radio-switch\";\n@import \"lbd/navbars\";\n@import \"lbd/footers\";\n@import \"lbd/tags\";\n@import \"lbd/tabs-navs-pagination\";\n@import \"lbd/progress-bars\";\n@import \"lbd/sliders\";\n\n\n\n// Fancy Stuff\n@import \"lbd/dropdown\";\n@import \"lbd/cards\";\n@import \"lbd/chartist\";\n@import \"lbd/responsive\";\n@import \"lbd/bootstrap-switch\";\n\n// Nucleo Icons\n@import \"lbd/partial-nucleo-icons\";\n\n//plugins css\n@import \"lbd/plugins/animate\";\n@import \"lbd/plugins/sweetalert2\";\n\n@import \"lbd/plugins/jquery.jvectormap\";\n@import \"lbd/plugins/bootstrap-table\";\n@import \"lbd/plugins/datatables.net\";\n@import \"lbd/plugins/fullcalendar\";\n@import \"lbd/plugins/chartist\";\n@import \"lbd/plugins/perfect-scrollbar\";\n@import \"lbd/plugins/bootstrap-select\";\n@import \"lbd/plugins/datetime-picker\";\n@import \"lbd/plugins/nouislider\";\n\n// React Differences\n@import \"lbdpr/react-differences\";\n","// General Colors\n\n\n$color-azure:           #23CCEF;\n$color-purple:          #9368E9;\n$color-red:             #FB404B;\n$color-green:           #275D38;\n$color-orange:          #FFA534;\n$color-blue:            #447DF7;\n$color-black:           #5e5e5e;\n\n\n/*      light colors         */\n\n$light-blue:                 rgba($color-blue, .2);\n$light-azure:                rgba($color-azure, .2);\n$light-green:                rgba($color-green, .2);\n$light-orange:               rgba($color-orange, .2);\n$light-red:                  rgba($color-red, .2);\n\n\n$default-color:              #888888 !default;\n\n$black-color:                #333333 !default;\n$black-hr:                   #444444 !default;\n\n$light-gray:                 #E3E3E3 !default;\n$medium-gray:                #DDDDDD !default;\n$placeholder-gray:           #C3C3C3 !default;\n$medium-dark-gray:           #AAAAAA !default;\n$dark-gray:                  #9A9A9A !default;\n\n// Gradients colors\n\n$default-color-top:\t                #d9d9d9;\n$default-color-bottom:              #909297;\n\n$blue-color-top: \t\t            #4087ea;\n$blue-color-bottom: \t            #533ce1;\n\n$azure-color-top:   \t            #45c0fd;\n$azure-color-bottom:            \t#4091ff;\n\n$green-color-top: \t                #a1eb3a;\n$green-color-bottom: \t            #6dc030;\n\n$orange-color-top: \t                #ffb33b;\n// $orange-color-bottom: \t            #ec1657;\n\n$red-color-top: \t                #ff3b30;\n$red-color-bottom: \t                #bb0502;\n\n$purple-color-top: \t                #df55e1;\n$purple-color-bottom: \t            #943bea;\n\n$pink-color-top: \t\t            #ff2a63;\n$pink-color-bottom: \t            #ff2e2e;\n\n$black-color-top:\t \t            #787878;\n$black-color-bottom: \t            #343434;\n\n\n$social-facebook: \t\t\t        #3b5998;\n$social-states-facebook: \t\t\tdarken(#3b5998, 10%) !default;\n$social-twitter: \t\t\t        #55acee;\n$social-states-twitter: \t\t\tdarken(#55acee, 10%) !default;\n$social-pinterest: \t\t\t        #cc2127;\n$social-states-pinterest: \t\t\tdarken(#cc2127, 10%) !default;\n$social-google: \t\t\t        #dd4b39;\n$social-states-google: \t\t\t    darken(#dd4b39, 10%) !default;\n$social-linkedin: \t\t\t        #0976b4;\n$social-states-linkedin: \t\t\tdarken(#0976b4, 10%) !default;\n$social-dribbble: \t\t\t        #ea4c89;\n$social-states-dribble: \t        darken(#ea4c89, 10%) !default;\n$social-github: \t\t\t        #333333;\n$social-states-github: \t\t        darken(#333333, 10%) !default;\n$social-youtube: \t\t\t        #e52d27;\n$social-states-youtube: \t        darken(#e52d27, 10%) !default;\n$social-stumbleupon: \t\t        #eb4924;\n$social-states-stumbleupon:\t        darken(#eb4924, 10%) !default;\n$social-reddit: \t\t\t        #ff4500;\n$social-states-reddit: \t\t        darken(#ff4500, 10%) !default;\n$social-tumblr: \t\t\t        #35465c;\n$social-states-tumblr: \t\t\t    darken(#35465c, 10%) !default;\n$social-behance: \t\t\t        #1769ff;\n$social-states-behance: \t        darken(#1769ff, 10%) !default;\n\n\n$filter-blue:         darken($color-blue, 10%);\n$filter-azure:        darken($color-azure, 10%);\n$filter-green:        darken($color-green, 10%);\n$filter-orange:       darken($color-orange, 10%);\n$filter-red:          darken($color-red, 10%);\n\n\n$white-navbar:              rgba(#FFFFFF, .96);\n$blue-navbar:               lighten($color-blue, 10%);\n$azure-navbar:              lighten($color-azure, 15%);\n$green-navbar:              lighten($color-green, 10%);\n$orange-navbar:             lighten($color-orange, 10%);\n$red-navbar:                lighten($color-red, 10%);\n\n\n\n\n//== Buttons\n//\n//## For each of Bootstrap's buttons, define text, background and border color.\n\n$none:                       0   !default;\n$border-thin:                1px !default;\n$border-thick:               2px !default;\n\n$white-color:                #FFFFFF !default;\n$white-bg:                   #FFFFFF !default;\n\n$smoke-bg:                   #F5F5F5 !default;\n\n$black-bg:                   rgba(30,30,30,.97) !default;\n\n$transparent-bg:             transparent !default;\n\n\n$default-bg:                 $default-color !default;\n$default-states-color:       darken($default-color, 6%) !default;\n\n$primary-color:              $color-blue !default;\n$primary-bg:                 $color-blue !default;\n$primary-states-color:       darken($color-blue, 5%) !default;\n\n$info-color:                 $color-azure !default;\n$info-bg:                    $color-azure !default;\n$info-states-color:          darken($color-azure, 6%) !default;\n\n$success-color:              $color-green !default;\n$success-bg:                 $color-green !default;\n$success-states-color:       darken($color-green, 5%) !default;\n\n$warning-color:              $color-orange !default;\n$warning-bg:                 $color-orange !default;\n$warning-states-color:       darken($color-orange, 7%) !default;\n\n\n$danger-color:               $color-red !default;\n$danger-bg:                  $color-red !default;\n$danger-states-color:        darken($color-red, 8%) !default;\n\n$link-disabled-color:        #666666 !default;\n\n\n//== Components\n//\n\n$padding-default-vertical:     10px !default;\n$padding-default-horizontal:   15px !default;\n\n\n$padding-base-vertical:         8px !default;\n$padding-base-horizontal:      16px !default;\n\n$padding-round-vertical:        8px !default;\n$padding-round-horizontal:     16px !default;\n\n$padding-simple-vertical:      9px !default;\n$padding-simple-horizontal:    16px !default;\n\n$padding-large-vertical:       14px !default;\n$padding-large-horizontal:     30px !default;\n\n$padding-small-vertical:        5px !default;\n$padding-small-horizontal:     10px !default;\n\n$padding-xs-vertical:           1px !default;\n$padding-xs-horizontal:         5px !default;\n\n$padding-label-vertical:        2px !default;\n$padding-label-horizontal:     12px !default;\n\n$margin-large-vertical:        30px !default;\n$margin-base-vertical:         15px !default;\n\n$margin-base:                  15px !default;\n\n$padding-zero:                   0px !default;\n\n$margin-bottom:                0 0 10px 0 !default;\n$border-radius-small:           3px !default;\n$border-radius-base:            4px !default;\n$border-radius-large:           6px !default;\n$border-radius-extreme:        10px !default;\n\n$border-radius-large-top:      $border-radius-large $border-radius-large 0 0 !default;\n$border-radius-large-bottom:   0 0 $border-radius-large $border-radius-large !default;\n\n$btn-round-radius:             30px !default;\n\n$height-base:                  40px !default;\n\n$font-size-base:               0.875rem !default;\n$font-size-small:              0.75rem !default;\n$font-size-medium:             1rem !default;\n$font-size-large:              1.125rem !default;\n$font-size-large-navbar:       1.25rem !default;\n\n$font-size-h1:                 3.25rem !default;\n$font-size-h2:                 2.25rem !default;\n$font-size-h3:                 1.75rem !default;\n$font-size-h4:                 1.375rem !default;\n$font-size-h5:                 1.125rem !default;\n$font-size-h6:                 0.875rem !default;\n$font-paragraph:               1rem !default;\n$font-size-navbar:             1rem !default;\n$font-size-small:              0.75rem !default;\n\n$font-weight-light:          300 !default;\n$font-weight-normal:         400 !default;\n$font-weight-semi:           500 !default;\n$font-weight-bold:           600 !default;\n\n$line-height-general:          1.5 !default;\n$line-height:                 20px !default;\n$line-height-lg:              54px !default;\n\n$sidebar-width:               calc(100% - 260px) !default;\n\n\n$border-radius-top:        10px 10px 0 0 !default;\n$border-radius-bottom:     0 0 10px 10px !default;\n\n$dropdown-shadow:          1px 2px 3px rgba(0, 0, 0, 0.125);\n\n$general-transition-time:  300ms !default;\n\n$slow-transition-time:           370ms !default;\n$dropdown-coordinates:      29px -50px !default;\n\n$fast-transition-time:           150ms !default;\n$ultra-fast-transition-time:      60ms  !default;\n\n$select-coordinates:         50% -40px !default;\n\n$transition-linear:                                   linear !default;\n$transition-bezier:         cubic-bezier(0.34, 1.61, 0.7, 1) !default;\n$transition-ease:           ease 0s;\n$transition-ease-in:              ease-in !default;\n$transition-ease-out:             ease-out !default;\n\n\n$navbar-padding-a:               10px 15px;\n$navbar-margin-a:                10px  3px;\n\n$padding-social-a:               10px  5px;\n\n$navbar-margin-a-btn:            15px 3px;\n$navbar-margin-a-btn-round:      16px 3px;\n\n$navbar-padding-a-icons:         6px 15px;\n$navbar-margin-a-icons:          6px  3px;\n\n$navbar-padding-brand:           15px 15px;\n$navbar-margin-brand:             7px  0px;\n\n$navbar-margin-brand-icons:      12px auto;\n\n$navbar-margin-btn:              10px  3px;\n\n$height-icon:\t\t\t\t\t 64px !default;\n$width-icon:\t\t\t\t\t 64px !default;\n$padding-icon:\t\t\t\t\t 12px !default;\n$border-radius-icon:\t\t     15px !default;\n\n$size-icon: \t\t\t\t\t 64px;\n$size-icon-sm: \t\t\t\t\t 32px;\n\n$height-icon-sm:\t\t\t\t 32px;\n$width-icon-sm:\t\t\t\t\t 32px;\n$padding-icon-sm:\t\t\t     4px;\n$border-radius-icon-sm:\t\t\t 7px;\n\n$height-icon-message:\t\t\t 40px;\n$width-icon-message:\t\t\t 40px;\n\n$height-icon-message-sm: \t\t 20px;\n$width-icon-message-sm:\t\t\t 20px;\n\n\n\n$topbar-x:             topbar-x !default;\n$topbar-back:          topbar-back !default;\n$bottombar-x:          bottombar-x !default;\n$bottombar-back:       bottombar-back !default;\n\n\n\n//== Media queries breakpoints\n//\n//## Define the breakpoints at which your layout will change, adapting to different screen sizes.\n\n// Extra small screen / phone\n//** Deprecated `$screen-xs` as of v3.0.1\n$screen-xs:                  480px !default;\n//** Deprecated `$screen-xs-min` as of v3.2.0\n$screen-xs-min:              $screen-xs !default;\n//** Deprecated `$screen-phone` as of v3.0.1\n$screen-phone:               $screen-xs-min !default;\n\n// Small screen / tablet\n//** Deprecated `$screen-sm` as of v3.0.1\n$screen-sm:                  768px !default;\n$screen-sm-min:              $screen-sm !default;\n//** Deprecated `$screen-tablet` as of v3.0.1\n$screen-tablet:              $screen-sm-min !default;\n\n// Medium screen / desktop\n//** Deprecated `$screen-md` as of v3.0.1\n$screen-md:                  992px !default;\n$screen-md-min:              $screen-md !default;\n//** Deprecated `$screen-desktop` as of v3.0.1\n$screen-desktop:             $screen-md-min !default;\n\n// Large screen / wide desktop\n//** Deprecated `$screen-lg` as of v3.0.1\n$screen-lg:                  1200px !default;\n$screen-lg-min:              $screen-lg !default;\n//** Deprecated `$screen-lg-desktop` as of v3.0.1\n$screen-lg-desktop:          $screen-lg-min !default;\n\n// So media queries don't overlap when required, provide a maximum\n$screen-xs-max:              ($screen-sm-min - 1) !default;\n$screen-sm-max:              ($screen-md-min - 1) !default;\n$screen-md-max:              ($screen-lg-min - 1) !default;\n\n\n$navbar-padding-a:               10px 15px;\n$navbar-margin-a:                10px  3px;\n\n$padding-social-a:               10px  5px;\n\n$navbar-margin-a-btn:            15px 3px;\n$navbar-margin-a-btn-round:      16px 3px;\n\n$navbar-padding-a-icons:         6px 15px;\n$navbar-margin-a-icons:          6px  3px;\n\n$navbar-padding-brand:           15px 15px;\n$navbar-margin-brand:             5px  0px;\n\n$navbar-margin-brand-icons:      12px auto;\n\n$navbar-margin-btn:              15px  3px;\n\n$height-icon:\t\t\t\t\t 64px !default;\n$width-icon:\t\t\t\t\t 64px !default;\n$padding-icon:\t\t\t\t\t 12px !default;\n$border-radius-icon:\t\t     15px !default;\n\n$size-icon: \t\t\t\t\t 64px;\n$size-icon-sm: \t\t\t\t\t 32px;\n\n\n$height-icon-sm:\t\t\t\t 32px;\n$width-icon-sm:\t\t\t\t\t 32px;\n$padding-icon-sm:\t\t\t     4px;\n$border-radius-icon-sm:\t\t\t 7px;\n\n$height-icon-message:\t\t\t 40px;\n$width-icon-message:\t\t\t 40px;\n\n$height-icon-message-sm: \t\t 20px;\n$width-icon-message-sm:\t\t\t 20px;\n\n$default-color-top:\t#d9d9d9 !default;\n$default-color-bottom: #909297 !default;\n\n$blue-color-top: \t\t            #4087ea;\n$blue-color-bottom: \t            #533ce1;\n\n$azure-color-top:   \t            #45c0fd;\n$azure-color-bottom:            \t#4091ff;\n\n$green-color-top: \t                #a1eb3a;\n$green-color-bottom: \t            #6dc030;\n\n$orange-color-top: \t                #ffb33b;\n$orange-color-bottom: \t            #ff5221;\n\n$red-color-top: \t                #ff3b30;\n$red-color-bottom: \t                #bb0502;\n\n$purple-color-top: \t                #df55e1;\n$purple-color-bottom: \t            #943bea;\n\n$pink-color-top: \t\t            #ff2a63;\n$pink-color-bottom: \t            #ff2e2e;\n\n$black-color-top:\t \t            #787878;\n$black-color-bottom: \t            #343434;\n\n$social-facebook: \t\t\t#3b5998;\n$social-twitter: \t\t\t#55acee;\n$social-pinterest: \t\t\t#cc2127;\n$social-google: \t\t\t#dd4b39;\n$social-linkedin: \t\t\t#0976b4;\n$social-dribbble: \t\t\t#ea4c89;\n$social-github: \t\t\t#333333;\n$social-youtube: \t\t\t#e52d27;\n$social-stumbleupon: \t\t#eb4924;\n$social-reddit: \t\t\t#ff4500;\n$social-tumblr: \t\t\t#35465c;\n$social-behance: \t\t\t#1769ff;\n\n\n$filter-blue:         darken($primary-color, 10%);\n$filter-azure:        darken($info-color, 10%);\n$filter-green:        darken($success-color, 10%);\n$filter-orange:       darken($warning-color, 10%);\n$filter-red:          darken($danger-color, 10%);\n\n\n$new-blue:            #1DC7EA;\n$new-purple:          #9368E9;\n$new-red:             #FB404B;\n$new-green:           #87CB16;\n$new-orange:          #FFA534;\n$new-dark-blue:       #1F77D0;\n$new-black:           #5e5e5e;\n\n\n$topbar-x:             topbar-x !default;\n$topbar-back:          topbar-back !default;\n$bottombar-x:          bottombar-x !default;\n$bottombar-back:       bottombar-back !default;\n\n\n$white-navbar:              rgba(#FFFFFF, .96);\n$blue-navbar:               lighten($new-dark-blue, 10%);\n$azure-navbar:              lighten($new-blue, 15%);\n$green-navbar:              lighten($new-green, 10%);\n$orange-navbar:             lighten($new-orange, 10%);\n$red-navbar:                lighten($new-red, 10%);\n","$prefixes: ('', '-moz-', '-webkit-', '-ms-') !default;\n\n@mixin circle-animation(){\n   @for $i from 0 to length($prefixes) {\n        @include circle-animation-details(nth($prefixes, $i + 1));\n   }  \n}\n\n@mixin circle-animation-details($name){\n    #{$name}animation-name: spin;\n    #{$name}animation-duration: 1250ms;\n    #{$name}animation-iteration-count: infinite;\n    #{$name}animation-timing-function: linear;\n\n}\n@keyframes spin {\n    from { transform:rotate(0deg); }\n    to { transform:rotate(360deg); }\n}\n\n@-webkit-keyframes spin {\n    from { -webkit-transform: rotate(0deg); }\n    to { -webkit-transform: rotate(360deg); }\n}\n\n@-moz-keyframes spin {\n    from { -moz-transform: rotate(0deg); }\n    to { -moz-transform: rotate(360deg); }\n}\n\n@-ms-keyframes spin {\n    from { -ms-transform: rotate(0deg); }\n    to { -ms-transform: rotate(360deg); }\n}",".modal{\n    &.show{\n        .modal-dialog{\n            -webkit-transform: translate(0, 30%);\n            -o-transform: translate(0, 30%);\n            transform: translate(0, 30%);\n        }\n    }\n    &.modal-mini{\n        .modal-dialog{\n            max-width: 255px;\n            margin: 0 auto;\n        }\n    }\n    .modal-content{\n        .modal-header{\n            border-bottom: none;\n            padding-top: 24px;\n            padding-right: 24px;\n            padding-bottom: 0;\n            padding-left: 24px;\n\n            .modal-profile{\n                width: 80px;\n                height: 80px;\n                border-radius: 50%;\n                text-align: center;\n                line-height: 5.7;\n                box-shadow: 0px 1px 20px 0px rgba(0, 0, 0, 0.3);\n\n                i{\n                    font-size: 32px;\n                    padding-top: 24px;\n                }\n            }\n        }\n\n        .modal-body{\n            padding-top: 24px;\n            padding-right: 24px;\n            padding-bottom: 16px;\n            padding-left: 24px;\n            line-height: 1.9;\n        }\n\n        .modal-body + .modal-footer{\n            padding-top: 0;\n        }\n\n        .modal-footer{\n            border-top: none;\n            padding-right: 24px;\n            padding-bottom: 16px;\n            padding-left: 24px;\n            -webkit-justify-content: space-between;\n            justify-content: space-between;\n\n            .btn{\n                margin: 0;\n                padding-left: 16px;\n                padding-right: 16px;\n                width: auto;\n\n                &:hover,\n                &focus{\n                    text-decoration: none;\n                }\n            }\n        }\n    }\n}\n","/*           Font Smoothing      */\nbody,\nh1, .h1,\nh2, .h2,\nh3, .h3,\nh4, .h4,\nh5, .h5,\nh6, .h6,\np,\n.navbar,\n.brand,\n.btn-simple,\n.alert,\na,\n.td-name,\ntd,\nbutton.close{\n    -moz-osx-font-smoothing: grayscale;\n    -webkit-font-smoothing: antialiased;\n    font-family: \"Roboto\",\"Helvetica Neue\",Arial,sans-serif;\n    font-weight: $font-weight-normal;\n}\n\nh1, .h1, h2, .h2, h3, .h3, h4, .h4{\n    font-weight: $font-weight-light;\n    margin: $margin-large-vertical 0 $margin-base-vertical;\n}\n\nh1, .h1 {\n    font-size: $font-size-h1;\n}\nh2, .h2{\n    font-size: $font-size-h2;\n}\nh3, .h3{\n    font-size: $font-size-h3;\n    margin: 20px 0 10px;\n}\nh4, .h4{\n    font-size: $font-size-h4;\n    line-height: 30px;\n}\nh5, .h5 {\n    font-size: $font-size-h5;\n    margin-bottom: 15px;\n}\nh6, .h6{\n    font-size: $font-size-h6;\n    font-weight: $font-weight-bold;\n    text-transform: uppercase;\n}\np{\n    font-size: $font-paragraph;\n    line-height: $line-height-general;\n}\n\nh1 small, h2 small, h3 small, h4 small, h5 small, h6 small, .h1 small, .h2 small, .h3 small, .h4 small, .h5 small, .h6 small, h1 .small, h2 .small, h3 .small, h4 .small, h5 .small, h6 .small, .h1 .small, .h2 .small, .h3 .small, .h4 .small, .h5 .small, .h6 .small {\n    color: $dark-gray;\n    font-weight: $font-weight-light;\n    line-height: $line-height-general;\n}\n\nh1 small, h2 small, h3 small, h1 .small, h2 .small, h3 .small {\n    font-size: 60%;\n}\n\nh1 .subtitle{\n    display: block;\n    margin: 0 0 $margin-large-vertical;\n}\n\n.text-muted{\n    color: #9A9A9A;\n}\n.text-primary, .text-primary:hover{\n    color: #1D62F0 !important;\n}\n.text-info, .text-info:hover{\n    color: $info-color !important;\n}\n.text-success, .text-success:hover{\n    color: $success-color !important;\n}\n.text-warning, .text-warning:hover{\n    color: $warning-color !important;\n}\n.text-danger, .text-danger:hover{\n    color: $danger-color !important;\n}\n\n.typo-line{\n    padding-left: 140px;\n    margin-bottom: 40px;\n    position: relative;\n\n    .category{\n        transform: translateY(-50%);\n        top: 50%;\n        left: 0px;\n        position: absolute;\n        font-size: 14px;\n        font-weight: 400;\n        color: #888888;\n        margin-bottom: 0px;\n    }\n}\n\nblockquote{\n    padding: 10px 20px;\n    margin: 0 0 20px;\n    font-size: 17.5px;\n    border-left: 5px solid #eee;\n}\n","/*     General overwrite     */\nbody,\n.wrapper{\n    min-height: 100vh;\n    position: relative;\n}\na{\n  color: $info-color;\n\n  &:hover, &:focus{\n     color: $info-states-color;\n     text-decoration: none;\n  }\n}\n\na:focus, a:active,\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner,\ninput[type=\"reset\"]::-moz-focus-inner,\ninput[type=\"button\"]::-moz-focus-inner,\ninput[type=\"submit\"]::-moz-focus-inner,\nselect::-moz-focus-inner,\ninput[type=\"file\"] > input[type=\"button\"]::-moz-focus-inner{\n    outline:0;\n}\n.ui-slider-handle:focus,\n.navbar-toggle,\ninput:focus {\n    outline : 0 !important;\n}\n\n/*           Animations              */\n.form-control,\n.input-group-addon,\n.tagsinput,\n.navbar,\n.navbar .alert{\n    @include transition($general-transition-time, $transition-linear);\n}\n\n\n.animation-transition-fast,\n.sidebar .nav .collapse a > span,\n.sidebar .sidebar-wrapper > .nav p,\n.sidebar .user .info > a > span,\n.sidebar .logo a.logo-normal,\n.sidebar .user .info .collapse .nav a > span {\n    @include transition($fast-transition-time, $transition-linear);\n}\n\n.sidebar .nav a,\n.table > tbody > tr .td-actions .btn{\n    @include transition($fast-transition-time, $transition-ease-in);\n}\n\n.btn{\n    @include transition($ultra-fast-transition-time, $transition-ease-in);\n}\n.fa,.fas,.far,.fal,.fad,.fab{\n    width: 18px;\n    text-align: center;\n}\n.margin-top{\n    margin-top: 50px;\n}\n\n.wrapper{\n    position: relative;\n    top: 0;\n    height: 100vh;\n}\n\n.card .map{\n    height: 400px;\n\n    .map-big{\n        height: 350px;\n    }\n}\n\n\n// documentation\n\n.page-header{\n    .page-header-image{\n        background-position: center center;\n        background-size: cover;\n        height: 450px;\n        overflow: hidden;\n        width: 100%;\n        z-index: 1;\n    }\n    .title-container{\n        color: #fff;\n        position: relative;\n        top: 200px;\n        z-index: 3;\n    }\n    .filter:after{\n        background: rgba(0, 0, 0, 0) linear-gradient(to bottom, #9368e9 0%, #943bea 100%) repeat scroll 0 0 / 150% 150%;\n        content: \"\";\n        display: block;\n        height: 450px;\n        left: 0;\n        opacity: 0.77;\n        position: absolute;\n        top: 0;\n        width: 100%;\n        z-index: 2;\n    }\n}\n\n// accordion\n\n.form-control,\n.input-group-addon,\n.tagsinput,\n.navbar .alert,\n.card-collapse.collapse{\n    -webkit-transition: all 300ms linear;\n    -moz-transition: all 300ms linear;\n    -o-transition: all 300ms linear;\n    -ms-transition: all 300ms linear;\n    transition: all 300ms linear;\n}\n\n.card{\n    .card-body.content-full-width{\n        padding: 15px 0px 10px 0px;\n\n        .accordions{\n            .card-title{\n                a{\n                    padding: 0px 0px 5px 15px;\n                }\n            }\n        }\n    }\n}\n","// User select\n// For selecting text on the page\n\n@mixin user-select($select) {\n  -webkit-user-select: $select;\n     -moz-user-select: $select;\n      -ms-user-select: $select; // IE10+\n          user-select: $select;\n}\n\n@mixin box-shadow($shadow...) {\n  -webkit-box-shadow: $shadow; // iOS <4.3 & Android <4.1\n          box-shadow: $shadow;\n}\n\n// Transition w/ opacity\n\n@mixin transition-opacity($time, $type){\n    -webkit-transition: opacity $time $type;\n    -moz-transition: opacity $time $type;\n    -o-transition: opacity $time $type;\n    -ms-transition: opacity $time $type;\n    transition: opacity $time $type;\n}\n\n// Box sizing\n@mixin box-sizing($boxmodel) {\n  -webkit-box-sizing: $boxmodel;\n     -moz-box-sizing: $boxmodel;\n          box-sizing: $boxmodel;\n}\n\n@mixin transition($time, $type){\n    -webkit-transition: all $time $type;\n    -moz-transition: all $time $type;\n    -o-transition: all $time $type;\n    -ms-transition: all $time $type;\n    transition: all $time $type;\n}\n\n@mixin transform-scale($value){\n     -webkit-transform: scale($value);\n        -moz-transform: scale($value);\n        -o-transform: scale($value);\n        -ms-transform: scale($value);\n        transform: scale($value);\n}\n\n@mixin transform-translate-x($value){\n     -webkit-transform:  translate3d($value, 0, 0);\n        -moz-transform: translate3d($value, 0, 0);\n        -o-transform: translate3d($value, 0, 0);\n        -ms-transform: translate3d($value, 0, 0);\n        transform: translate3d($value, 0, 0);\n}\n\n@mixin transform-translate-3d($value){\n    -webkit-transform: translate3d($value, 0, 0);\n    -moz-transform: translate3d($value, 0, 0);\n    -o-transform: translate3d($value, 0, 0);\n    -ms-transform: translate3d($value, 0, 0);\n    transform: translate3d($value, 0, 0);\n}\n\n@mixin transform-translate-y($value){\n     -webkit-transform:  translate3d(0, $value, 0);\n        -moz-transform: translate3d(0, $value, 0);\n        -o-transform: translate3d(0, $value, 0);\n        -ms-transform: translate3d(0, $value, 0);\n        transform: translate3d(0, $value, 0);\n}\n\n@mixin transform-translate-y-dropdown($value){\n     -webkit-transform:  translate3d(0, $value, 0) !important;\n        -moz-transform: translate3d(0, $value, 0) !important;\n        -o-transform: translate3d(0, $value, 0) !important;\n        -ms-transform: translate3d(0, $value, 0) !important;\n        transform: translate3d(0, $value, 0) !important;\n}\n\n@mixin transform-origin($coordinates){\n      -webkit-transform-origin: $coordinates;\n        -moz-transform-origin: $coordinates;\n        -o-transform-origin: $coordinates;\n        -ms-transform-origin: $coordinates;\n        transform-origin: $coordinates;\n}\n\n@mixin icon-gradient ($top-color, $bottom-color){\n    background: $top-color;\n    background: -moz-linear-gradient(top,  $top-color 0%, $bottom-color 100%);\n    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,$top-color), color-stop(100%,$bottom-color));\n    background: -webkit-linear-gradient(top,  $top-color 0%,$bottom-color 100%);\n    background: -o-linear-gradient(top,  $top-color 0%,$bottom-color 100%);\n    background: -ms-linear-gradient(top,  $top-color 0%,$bottom-color 100%);\n    background: linear-gradient(to bottom,  $top-color 0%,$bottom-color 100%);\n    background-size: 150% 150%;\n}\n\n@mixin radial-gradient($extern-color, $center-color){\n    background: $extern-color;\n    background: -moz-radial-gradient(center, ellipse cover, $center-color 0%, $extern-color 100%); /* FF3.6+ */\n    background: -webkit-gradient(radial, center center, 0px, center center, 100%, color-stop(0%,$center-color), color-stop(100%,$extern-color)); /* Chrome,Safari4+ */\n    background: -webkit-radial-gradient(center, ellipse cover, $center-color 0%,$extern-color 100%); /* Chrome10+,Safari5.1+ */\n    background: -o-radial-gradient(center, ellipse cover, $center-color 0%,$extern-color 100%); /* Opera 12+ */\n    background: -ms-radial-gradient(center, ellipse cover, $center-color 0%,$extern-color 100%); /* IE10+ */\n    background: radial-gradient(ellipse at center, $center-color 0%,$extern-color 100%); /* W3C */\n    background-size: 550% 450%;\n}\n\n@mixin vertical-align {\n  position: relative;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n\n@mixin rotate-180(){\n    filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n    -webkit-transform: rotate(180deg);\n    -ms-transform: rotate(180deg);\n    transform: rotate(180deg);\n}\n\n@mixin bar-animation($type){\n     -webkit-animation: $type 500ms linear 0s;\n     -moz-animation: $type 500ms linear 0s;\n     animation: $type 500ms 0s;\n     -webkit-animation-fill-mode: forwards;\n     -moz-animation-fill-mode: forwards;\n     animation-fill-mode: forwards;\n}\n\n@mixin topbar-x-rotation(){\n    @keyframes topbar-x {\n      0% {top: 0px; transform: rotate(0deg); }\n      45% {top: 6px; transform: rotate(145deg); }\n      75% {transform: rotate(130deg); }\n      100% {transform: rotate(135deg); }\n    }\n    @-webkit-keyframes topbar-x {\n      0% {top: 0px; -webkit-transform: rotate(0deg); }\n      45% {top: 6px; -webkit-transform: rotate(145deg); }\n      75% {-webkit-transform: rotate(130deg); }\n      100% { -webkit-transform: rotate(135deg); }\n    }\n    @-moz-keyframes topbar-x {\n      0% {top: 0px; -moz-transform: rotate(0deg); }\n      45% {top: 6px; -moz-transform: rotate(145deg); }\n      75% {-moz-transform: rotate(130deg); }\n      100% { -moz-transform: rotate(135deg); }\n    }\n}\n\n@mixin topbar-back-rotation(){\n    @keyframes topbar-back {\n      0% { top: 6px; transform: rotate(135deg); }\n      45% { transform: rotate(-10deg); }\n      75% { transform: rotate(5deg); }\n      100% { top: 0px; transform: rotate(0); }\n    }\n\n    @-webkit-keyframes topbar-back {\n      0% { top: 6px; -webkit-transform: rotate(135deg); }\n      45% { -webkit-transform: rotate(-10deg); }\n      75% { -webkit-transform: rotate(5deg); }\n      100% { top: 0px; -webkit-transform: rotate(0); }\n    }\n\n    @-moz-keyframes topbar-back {\n      0% { top: 6px; -moz-transform: rotate(135deg); }\n      45% { -moz-transform: rotate(-10deg); }\n      75% { -moz-transform: rotate(5deg); }\n      100% { top: 0px; -moz-transform: rotate(0); }\n    }\n}\n\n@mixin bottombar-x-rotation(){\n    @keyframes bottombar-x {\n      0% {bottom: 0px; transform: rotate(0deg);}\n      45% {bottom: 6px; transform: rotate(-145deg);}\n      75% {transform: rotate(-130deg);}\n      100% {transform: rotate(-135deg);}\n    }\n    @-webkit-keyframes bottombar-x {\n      0% {bottom: 0px; -webkit-transform: rotate(0deg);}\n      45% {bottom: 6px; -webkit-transform: rotate(-145deg);}\n      75% {-webkit-transform: rotate(-130deg);}\n      100% {-webkit-transform: rotate(-135deg);}\n    }\n    @-moz-keyframes bottombar-x {\n      0% {bottom: 0px; -moz-transform: rotate(0deg);}\n      45% {bottom: 6px; -moz-transform: rotate(-145deg);}\n      75% {-moz-transform: rotate(-130deg);}\n      100% {-moz-transform: rotate(-135deg);}\n    }\n}\n\n@mixin bottombar-back-rotation{\n    @keyframes bottombar-back {\n      0% { bottom: 6px;transform: rotate(-135deg);}\n      45% { transform: rotate(10deg);}\n      75% { transform: rotate(-5deg);}\n      100% { bottom: 0px;transform: rotate(0);}\n    }\n    @-webkit-keyframes bottombar-back {\n      0% {bottom: 6px;-webkit-transform: rotate(-135deg);}\n      45% {-webkit-transform: rotate(10deg);}\n      75% {-webkit-transform: rotate(-5deg);}\n      100% {bottom: 0px;-webkit-transform: rotate(0);}\n    }\n    @-moz-keyframes bottombar-back {\n      0% {bottom: 6px;-moz-transform: rotate(-135deg);}\n      45% {-moz-transform: rotate(10deg);}\n      75% {-moz-transform: rotate(-5deg);}\n      100% {bottom: 0px;-moz-transform: rotate(0);}\n    }\n\n}\n",".sidebar,\n.main-panel,\n.sidebar-wrapper,\n.navbar-fixed,\n.navbar-minimize{\n    -webkit-transition-property: top,bottom,width;\n    transition-property: top,bottom, width;\n    -webkit-transition-duration: .2s,.2s, .35s;\n    transition-duration: .2s,.2s, .35s;\n    -webkit-transition-timing-function: linear,linear,ease;\n    transition-timing-function: linear,linear,ease;\n    -webkit-overflow-scrolling: touch;\n}\n.animation-transition-general,\n.sidebar .nav p,\n.sidebar .user .photo,\n.bootstrap-navbar .user .photo,\n.sidebar .user a,\n.bootstrap-navbar .user a,\n.login-page .card{\n    @include transition (300ms, linear);\n}\n\n\n    // THE SIDEBAR\n\n.sidebar{\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 260px;\n    display: block;\n    z-index: 1;\n    color: #fff;\n    font-weight: 200;\n    background-size: cover;\n    background-position: center center;\n\n    .logo-img{\n        width: 30px;\n        display: inline-block;\n        max-height: 30px;\n\n        img{\n            width: 35px;\n            top: 1px;\n            position: absolute;\n            left: 0px;\n        }\n    }\n\n    .logo{\n        padding: 12px 0px 9px;\n        margin: 0;\n        position: relative;\n        z-index: 4;\n        display: block;\n\n        a.logo-mini{\n            float: left;\n            width: 30px;\n            text-align: center;\n            margin-left: 23px;\n            margin-right: 15px;\n            position: relative;\n        }\n\n        a.logo-normal{\n            display: block;\n            opacity: 1;\n            @include transform-translate-x(0px);\n        }\n\n        .simple-text{\n            text-transform: uppercase;\n            padding: $padding-small-vertical $padding-zero;\n            display: inline-block;\n            font-size: $font-size-large;\n            font-weight: $font-weight-normal;\n            line-height: 30px;\n            white-space: nowrap;\n            color: $white-color;\n            overflow: hidden;\n        }\n\n        p{\n            float: left;\n            font-size: 20px;\n            margin: 10px 10px;\n            line-height: 20px;\n        }\n\n        &:before{\n            content: \"\";\n            position: absolute;\n            bottom: 0px;\n            right: 15px;\n            width: calc(100% - 30px);\n            height: 1px;\n        }\n    }\n\n    .sidebar-wrapper{\n        position: relative;\n        max-height: calc(100vh - 75px);\n        min-height: 100%;\n        overflow: auto;\n        width: 260px;\n        z-index: 4;\n        padding-bottom: 100px;\n\n        .nav .nav-item {\n            [data-toggle=\"collapse\"] ~ div{\n                .nav{\n                    .nav-item{\n                        .nav-link{\n                            background: transparent;\n                            padding-left: 55px;\n                            text-transform: capitalize;\n                            padding: 5px 15px 5px 15px;\n                            font-weight: 400;\n                            font-size: 14px;\n                        }\n\n                        &:hover,\n                        &:focus,\n                        &.active{\n                            .nav-link{\n                                background: rgba(255, 255, 255, 0.13);\n                            }\n                        }\n                    }\n                    .sidebar-normal{\n                        left: 15px;\n                    }\n                }\n            }\n        }\n\n        .nav .nav-link{\n            p{\n                margin: 0;\n                line-height: 30px;\n                font-size: 12px;\n                font-weight: 600;\n                text-transform: uppercase;\n                white-space: nowrap;\n                position: relative;\n                color: #FFFFFF;\n                @include transform-translate-x(0px);\n                display: block;\n                height: auto;\n                opacity: 1;\n            }\n        }\n\n        .navbar-form.navbar-search-form{\n            margin-top: 15px;\n            padding-left: 25px;\n\n            input{\n                padding-left: 10px;\n                padding-top: 5px;\n            }\n        }\n    }\n\n    .sidebar-background{\n        position: absolute;\n        z-index: 1;\n        height: 100%;\n        width: 100%;\n        display: block;\n        top: 0;\n        left: 0;\n        background-size: cover;\n        background-position: center center;\n    }\n\n    .user{\n        border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n        padding-bottom: 20px;\n        margin-top: 20px;\n\n        .photo{\n            width: 34px;\n            height: 34px;\n            overflow: hidden;\n            border-radius: 50%;\n            float: left;\n            margin-right: 11px;\n            margin-left: 23px;\n            z-index: 5;\n            border: 2px solid rgba(255, 255, 255, 0.3);\n\n            img{\n                width: 100%;\n            }\n        }\n        .info{\n            .caret{\n                right: 15px;\n                top: -5px;\n            }\n            a{\n                color: $white-color;\n                padding: 8px 14px;\n                display: block;\n                white-space: nowrap;\n                line-height: 18px;\n            }\n            span{\n                position: relative;\n                display: block;\n            }\n            .collapse{\n                .sidebar-normal{\n                    padding-left: 0;\n                }\n            }\n        }\n\n        .profile-dropdown{\n            text-align: left !important;\n            padding-left: 25px !important;\n\n            .sidebar-mini,\n            .sidebar-normal{\n                margin-right: 0;\n                font-size: 14px;\n            }\n            .sidebar-normal{\n                left: 15px;\n            }\n        }\n    }\n\n    .caret{\n        display: inline-block;\n        width: 0;\n        height: 0;\n        vertical-align: middle;\n        border-top: 4px dashed;\n        border-top: 4px solid\\9;\n        border-right: 4px solid transparent;\n        border-left: 4px solid transparent;\n        margin-top: 13px;\n        position: absolute;\n        right: 0;\n        @include transition(150ms, ease-in);\n    }\n\n    a[data-toggle=\"collapse\"][aria-expanded=\"true\"] .caret,\n    .btn[data-toggle=\"collapse\"][aria-expanded=\"true\"] .caret,\n    a.dropdown-toggle[aria-expanded=\"true\"] .caret{\n        filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n        -webkit-transform: rotate(180deg);\n        -ms-transform: rotate(180deg);\n        transform: rotate(180deg);\n    }\n\n    .nav{\n        float: none;\n        display: block;\n\n        .nav-item{\n            .nav-link{\n                color: $white-color;\n                margin: 5px 15px 0px 10px;\n                opacity: .86;\n                border-radius: 4px;\n                text-transform: uppercase;\n                line-height: 30px;\n                font-size: 12px;\n                font-weight: 600;\n                padding: 10px 15px;\n                white-space: nowrap;\n\n                &:hover{\n                    background: rgba(255, 255, 255, 0.13);\n                    opacity: 1;\n                }\n\n                i{\n                    font-size: 28px;\n                    margin-right: 15px;\n                    width: 30px;\n                    text-align: center;\n                    vertical-align: middle;\n                    float: left;\n                }\n            }\n\n            &:not(.collapse .nav-link):hover .nav-link{\n                background: rgba(255,255,255,0.13);\n                opacity: 1;\n            }\n\n            &.active .nav-link{\n                color: $white-color;\n                opacity: 1;\n                background: rgba(255,255,255,0.23);\n\n            }\n\n            &.separator{\n                margin: 15px 0;\n                border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n\n                & + .nav-item {\n                    margin-top: 31px;\n                }\n            }\n\n        }\n\n    }\n\n    &:after,\n    &:before{\n        display: block;\n        content: \"\";\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        top: 0;\n        left: 0;\n        z-index: 2;\n    }\n\n    &:before{\n        opacity: .33;\n        background: #000000;\n    }\n\n\n    &[data-image]:after,\n    &.has-image:after{\n        opacity: .95;\n    }\n}\n\n\n.sidebar,\n.bootstrap-navbar{\n    .logo{\n\n        p{\n            float: left;\n            font-size: 20px;\n            margin: 10px 10px;\n            color: $white-color;\n            line-height: 20px;\n            font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n        }\n\n        .logo-text{\n            text-transform: uppercase;\n            padding: 5px 0px 5px 15px;\n            display: block;\n            font-size: $font-size-large;\n            color: $white-color;\n            font-weight: $font-weight-normal;\n            line-height: 30px;\n            white-space: nowrap;\n            overflow: hidden;\n        }\n\n        .logo-image{\n            float: left;\n            height: 40px;\n            width: 40px;\n            margin: 0 10px;\n        }\n\n        .logo-round{\n            border-radius: 50%;\n            display: block;\n            overflow: hidden;\n\n            img{\n                width: 100%;\n            }\n        }\n\n        &:before{\n            content: \"\";\n            position: absolute;\n            bottom: 0px;\n            right: 15px;\n            width: calc(100% - 30px);\n            height: 1px;\n            background-color: rgba($white-color, 0.3);\n        }\n\n    }\n    .logo-mini{\n        .logo-text{\n            text-transform: uppercase;\n            padding: 7px 0px;\n            display: block;\n            font-size: $font-size-large;\n            color: $white-color;\n            font-weight: $font-weight-normal;\n            line-height: 30px;\n            text-align: center;\n            white-space: nowrap;\n            overflow: hidden;\n        }\n    }\n\n    // colors for the sidebar with an image\n\n    &[data-color=\"black\"]:after{\n        @include icon-gradient($default-states-color, rgba($default-states-color,.7));\n    }\n    &[data-color=\"blue\"]:after{\n        @include icon-gradient($color-blue, rgba($blue-color-bottom,.7));\n    }\n    &[data-color=\"azure\"]:after{\n        @include icon-gradient($color-azure, rgba($azure-color-bottom,.7));\n    }\n    &[data-color=\"green\"]:after{\n        @include icon-gradient($color-green, rgba($green-color-bottom,.7));\n    }\n    &[data-color=\"orange\"]:after{\n        @include icon-gradient($color-orange, rgba($orange-color-bottom,.7));\n    }\n    &[data-color=\"red\"]:after{\n        @include icon-gradient($color-red, rgba($red-color-bottom,.7));\n    }\n    &[data-color=\"purple\"]:after{\n        @include icon-gradient($color-purple, rgba($purple-color-bottom,.7));\n    }\n}\n\n    //  MAIN PANEL\n\n\n.main-panel{\n    background: rgba(203,203,210,.15);\n    position: relative;\n    float: right;\n    width: $sidebar-width;\n\n    .content{\n        padding: 30px 15px;\n        min-height: calc(100vh - 123px);\n    }\n\n    .footer{\n        border-top: 1px solid #e7e7e7;\n    }\n\n    .navbar{\n        margin-bottom: 0;\n    }\n}\n\n\n    // SIDEBAR MINI\n\n.sidebar-mini{\n    .sidebar .sidebar-wrapper{\n        .nav{\n            .nav-item:hover{\n                .collapse{\n                    .nav-item .nav-link{\n                        padding: 5px 15px;\n                    }\n                }\n            }\n        }\n    }\n}\n\n\n.sidebar .sidebar-wrapper .nav [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-mini,\n.sidebar .sidebar-wrapper .user .info [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-mini{\n    text-transform: uppercase;\n    float: left;\n    width: 30px;\n    text-align: center;\n    // margin-right: 15px;\n    letter-spacing: 1px;\n}\n\n.sidebar .sidebar-wrapper > .nav [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-normal,\n.sidebar .sidebar-wrapper .user .info [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-normal,\n.off-canvas-sidebar .sidebar-wrapper > .nav [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-normal,\n.off-canvas-sidebar .sidebar-wrapper .user .info [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-normal{\n    margin: 0;\n    position: relative;\n    transform: translateX(0px);\n    opacity: 1;\n    white-space: nowrap;\n    display: inline-block;\n    line-height: 23px;\n}\n.sidebar .nav .nav-item .nav-link .sidebar-mini{\n    padding-left: 5px !important;\n    opacity: .86 !important;\n\n}\n\n\n@media (min-width: $screen-md) {\n    .sidebar-mini{\n        .visible-on-sidebar-regular{\n            display: none !important;\n        }\n        .visible-on-sidebar-mini{\n            display: inline-block !important;\n        }\n        .sidebar{\n            width: 80px;\n            display: block;\n            font-weight: 200;\n            z-index: 3;\n            position: fixed;\n\n            .logo{\n                a.logo-mini{\n                    opacity: 1;\n                }\n\n                a.logo-normal{\n                    opacity: 0;\n                    @include transform-translate-x(-25px);\n                }\n            }\n\n            .sidebar-wrapper{\n                overflow: inherit;\n                width: 80px;\n                box-shadow: none;\n\n                .nav [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-normal,\n                .user .info [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-normal,\n                .user .info > a > span,\n                > .nav li > a p{\n                    @include transform-translate-x(-25px);\n                    opacity: 0;\n                }\n            }\n\n            .info{\n                .collapse .nav{\n                    li{\n                        >a{\n                            margin: 0;\n                            border-radius: 0;\n                        }\n                    }\n                }\n                .caret{\n                    opacity: 0;\n                }\n\n                [data-toggle=\"collapse\"] ~ div > ul > li:last-child > a{\n                    margin-bottom: 5px;\n                    border-bottom-left-radius: 3px;\n                    border-bottom-right-radius: 3px;\n                }\n\n                [data-toggle=\"collapse\"] ~ div > ul > li:first-child > a{\n                    margin-top: 5px;\n                    border-top-left-radius: 3px;\n                    border-top-right-radius: 3px;\n                }\n            }\n\n            .nav{\n                .nav-item .nav-link{\n                    .sidebar-mini{\n                        padding-left: 30px !important;\n                    }\n                }\n            }\n\n            &:hover{\n                width: 260px;\n\n                .logo{\n                    a.logo-normal{\n                        opacity: 1;\n                        @include transform-translate-x(0px);\n                    }\n                }\n\n                .nav-item [data-toggle=\"collapse\"] ~ div .nav .sidebar-normal{\n                    left: 0;\n                }\n\n                .caret{\n                    opacity: 1;\n                }\n\n                .sidebar-wrapper{\n                    width: 260px;\n\n                    > .nav li > a p,\n                    > .nav [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-normal,\n                    .user .info [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-normal,\n                    .user .info > a > p,\n                    > .nav li > a .caret,\n                    .user .info a span{\n                        @include transform-translate-x(0px);\n                        opacity: 1;\n                    }\n\n                    > .nav{\n                        li.active{\n                            > a:not([data-toggle=\"collapse\"]){\n                                &:before,\n                                &:after{\n                                   opacity: 0;\n                                }\n                            }\n                        }\n                    }\n                }\n\n                .nav{\n                    .nav-item .nav-link{\n                        .sidebar-mini{\n                            margin-right: 5px !important;\n                        }\n                    }\n                }\n\n                .sidebar-normal{\n                    padding-left: 10px;\n                    padding-right: 10px;\n                    margin: 5px 15px 0px;\n                    border-radius: 4px;\n                    color: #FFFFFF;\n                    opacity: .86;\n                }\n            }\n        }\n\n        .main-panel{\n            width: calc(100% - 80px);\n            margin-left: 80px;\n        }\n\n        .wrapper{\n            height: auto;\n        }\n\n        .sidebar,\n        .main-panel{\n            overflow: visible;\n            max-height: none;\n            height: auto;\n        }\n\n        .navbar-fixed{\n            width: calc(100% - 80px) !important;\n        }\n    }\n}\n\n\n\n.visible-on-sidebar-regular{\n    display: inline-block !important;\n}\n.visible-on-sidebar-mini{\n    display: none !important;\n}\n.navbar-minimize{\n    margin-right: 15px;\n}\n\n\n\n\n\n// Pages Design\n\n.wrapper-full-page{\n    min-height: 100vh;\n    height: 100%;\n\n    .navbar{\n        z-index: 1030;\n        .nav-link{\n            i{\n                font-size: 18px;\n                position: relative;\n                right: 10px;\n                text-align: center;\n            }\n        }\n\n        .nav-item.active{\n            .nav-link{\n                background-color: rgba(255, 255, 255, 0.2) !important;\n            }\n        }\n        .nav-link:not(.btn):hover{\n            background-color: rgba(255, 255, 255, 0.2) !important;\n            border-radius: 0.1875rem;\n            @include transition (300ms, linear);\n        }\n        .navbar-nav{\n            .nav-item .nav-link{\n                padding: 3px 15px;\n            }\n        }\n    }\n\n    .footer{\n        position: relative;\n        z-index: 2;\n        background: transparent;\n        .copyright{\n            color: rgba(255, 255, 255, 0.7);\n            a{\n                opacity: 1;\n            }\n        }\n    }\n}\n\n.full-page{\n    .full-page-background{\n        position: absolute;\n        z-index: 1;\n        height: 100%;\n        width: 100%;\n        display: block;\n        top: 0;\n        left: 0;\n        background-size: cover;\n        background-position: center center;\n    }\n\n    &:before,\n    &:after{\n        display: block;\n        content: \"\";\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        top: 0;\n        left: 0;\n        z-index: 2;\n    }\n\n    &:before{\n        opacity: .33;\n        // background: #000000;\n    }\n\n    &.register-page{\n        .content:first-of-type{\n            padding-top: 10vh;\n        }\n    }\n\n    > .content{\n        min-height: calc(100vh - 70px);\n        z-index: 4;\n        position: relative;\n\n        .card-register{\n            .card-title{\n                color: $white-color;\n            }\n            .card-subtitle{\n                margin-top: 10px;\n                margin-bottom: 0;\n                font-size: 21px;\n                color: $white-color;\n            }\n            .footer{\n                background-color: transparent;\n            }\n            .content{\n                padding-top: 5%;\n            }\n\n            .media{\n                color: #FFFFFF;\n                margin-bottom: 15px;\n\n                .icon{\n                    float: left;\n                    margin-right: 5px;\n                    i{\n                        font-size: 36px;\n                    }\n                }\n\n                .media-left,\n                .media-body{\n                    display: table-cell;\n                    vertical-align: top;\n                }\n                .media-body{\n                    overflow: hidden;\n                }\n                h4{\n                    margin: 0 0 5px 15px;\n                    text-align: left;\n                }\n                p{\n                    text-align: justify;\n                    margin-left: 15px;\n                }\n            }\n        }\n    }\n\n    >.content:first-of-type{\n        padding-top: 20vh;\n    }\n\n    &.register-page{\n        .content{\n            padding-top: 10vh;\n        }\n    }\n    &[data-color=\"black\"]:after{\n        @include icon-gradient($default-states-color, $default-states-color);\n    }\n    &[data-color=\"blue\"]:after{\n        @include icon-gradient($new-dark-blue, $blue-color-bottom);\n    }\n    &[data-color=\"azure\"]:after{\n        @include icon-gradient($new-blue, $azure-color-bottom);\n    }\n    &[data-color=\"green\"]:after{\n        @include icon-gradient($new-green, $green-color-bottom);\n    }\n    &[data-color=\"orange\"]:after{\n        @include icon-gradient($new-orange, $orange-color-bottom);\n    }\n    &[data-color=\"red\"]:after{\n        @include icon-gradient($new-red, $red-color-bottom);\n    }\n    &[data-color=\"purple\"]:after{\n        @include icon-gradient($new-purple, $purple-color-bottom);\n    }\n}\n.full-page[data-image]:after,\n.full-page.has-image:after{\n    opacity: .77;\n}\n",".fixed-plugin{\n    .dropdown{\n        .dropdown-menu{\n            border-radius: 10px;\n            li.adjustments-line{\n                border-bottom: 1px solid #ddd;\n            }\n            li{\n                padding: 5px 2px !important;\n            }\n            .button-container{\n                a{\n                    font-size: 14px;\n                }\n            }\n            .adjustments-line{\n                .bootstrap-switch{\n                    position: absolute;\n                    right: 10px !important;\n                }\n                label{\n                    margin-bottom: .6rem !important;\n                }\n            }\n        }\n    }\n}\n\n.fixed-plugin li > a,\n.fixed-plugin .badge{\n    transition: all .34s;\n    -webkit-transition: all .34s;\n    -moz-transition: all .34s;\n}\n\n.fixed-plugin{\n    position: fixed;\n    top: 200px;\n    right: 0;\n    width: 64px;\n    background: rgba(0,0,0,.3);\n    z-index: 1031;\n    border-radius: 8px 0 0 8px;\n    text-align: center;\n}\n.fixed-plugin .fa-cogs{\n    color: #FFFFFF;\n    padding: 10px;\n    border-radius: 0 0 6px 6px;\n    width: auto;\n}\n.fixed-plugin .dropdown-menu{\n    right: 80px;\n    left: auto;\n    width: 290px;\n    border-radius: 0.1875rem;\n    padding: 0 10px;\n}\n.fixed-plugin .dropdown-menu:after, .fixed-plugin .dropdown-menu:before{\n    right: 10px;\n    margin-left: auto;\n    left: auto;\n}\n.fixed-plugin .fa-circle-thin{\n    color: #FFFFFF;\n}\n.fixed-plugin .active .fa-circle-thin{\n    color: #00bbff;\n}\n\n.fixed-plugin .dropdown-menu > .active > a,\n.fixed-plugin .dropdown-menu > .active > a:hover,\n.fixed-plugin .dropdown-menu > .active > a:focus{\n    color: #777777;\n    text-align: center;\n}\n\n.fixed-plugin img{\n    border-radius: 0;\n    width: 100%;\n    height: 100px;\n    margin: 0 auto;\n}\n\n.fixed-plugin .dropdown-menu li > a:hover,\n.fixed-plugin .dropdown-menu li > a:focus{\n    box-shadow: none;\n}\n\n.fixed-plugin .badge{\n    border: 3px solid #FFFFFF;\n    border-radius: 50%;\n    cursor: pointer;\n    display: inline-block;\n    height: 23px;\n    margin-right: 5px;\n    position: relative;\n    width: 23px;\n}\n.fixed-plugin .badge.active,\n.fixed-plugin .badge:hover{\n    border-color: #00bbff;\n}\n\n.fixed-plugin .badge-black{\n    background-color: #777;\n}\n.fixed-plugin .badge-azure{\n    background-color: #2CA8FF;\n}\n.fixed-plugin .badge-green{\n    background-color: #18ce0f;\n}\n.fixed-plugin .badge-orange{\n    background-color: #f96332;\n}\n.fixed-plugin .badge-yellow{\n    background-color: #FFB236;\n}\n.fixed-plugin .badge-red{\n    background-color: #FF3636;\n}\n.fixed-plugin .badge-purple{\n    background-color: #9368E9;\n}\n\n.fixed-plugin h5{\n    font-size: 14px;\n    margin: 10px;\n}\n.fixed-plugin .dropdown-menu li{\n    display: block;\n    padding: 18px 2px;\n    width: 25%;\n    float: left;\n}\n\n.fixed-plugin li.adjustments-line,\n.fixed-plugin li.header-title,\n.fixed-plugin li.button-container{\n    width: 100%;\n    height: 50px;\n    min-height: inherit;\n}\n\n.fixed-plugin li.button-container{\n    height: auto;\n}\n.fixed-plugin li.button-container div{\n    margin-bottom: 5px;\n}\n\n.fixed-plugin #sharrreTitle{\n    text-align: center;\n    padding: 10px 0;\n    height: 50px;\n}\n\n.fixed-plugin li.header-title{\n    height: 30px;\n    line-height: 25px;\n    font-size: 12px;\n    font-weight: 600;\n    text-transform: uppercase;\n}\n\n.fixed-plugin .adjustments-line p{\n    float: left;\n    display: inline-block;\n    margin-bottom: 0;\n    font-size: 1em;\n    color: #3C4858;\n    padding-top: 7px;\n}\n\n.fixed-plugin .adjustments-line a .badge-colors{\n    position: relative;\n    top: -2px;\n}\n\n.fixed-plugin .adjustments-line .togglebutton{\n    float: right;\n}\n\n.fixed-plugin .adjustments-line .togglebutton .toggle{\n    margin-right: 0;\n}\n\n.fixed-plugin .dropdown-menu > li.adjustments-line > a{\n      padding-right: 0;\n      padding-left: 0;\n      /*border-bottom: 1px solid #ddd;*/\n      border-radius: 0;\n      margin: 0;\n}\n.fixed-plugin .dropdown-menu > li > a.img-holder{\n      font-size: 16px;\n      text-align: center;\n      border-radius: 10px;\n      background-color: #FFF;\n      border: 3px solid #FFF;\n      padding-left: 0;\n      padding-right: 0;\n      opacity: 1;\n      cursor: pointer;\n      display: block;\n      max-height: 100px;\n      overflow: hidden;\n      padding: 0;\n}\n\n.fixed-plugin .dropdown-menu > li > a.switch-trigger:hover,\n.fixed-plugin .dropdown-menu > li > a.switch-trigger:focus{\n    background-color: transparent;\n}\n.fixed-plugin .dropdown-menu > li:hover > a.img-holder,\n.fixed-plugin .dropdown-menu > li:focus > a.img-holder{\n    border-color: rgba(0, 187, 255, 0.53);;\n}\n.fixed-plugin .dropdown-menu > .active > a.img-holder,\n.fixed-plugin .dropdown-menu > .active > a.img-holder{\n    border-color: #00bbff;\n    background-color: #FFFFFF;\n}\n\n.fixed-plugin .dropdown-menu > li > a img{\n    margin-top: auto;\n}\n\n.fixed-plugin .btn-social{\n    width: 50%;\n    display: block;\n    width: 48%;\n    float: left;\n    font-weight: 600;\n}\n.fixed-plugin .btn-social i{\n    margin-right: 5px;\n}\n.fixed-plugin .btn-social:first-child{\n    margin-right: 2%;\n}\n\n.fixed-plugin .adjustments-line a:hover,\n.fixed-plugin .adjustments-line a:focus,\n.fixed-plugin .adjustments-line a{\n    color: transparent;\n}\n\n.fixed-plugin .dropdown .dropdown-menu{\n    @include transform-translate-y-dropdown(-5%);\n    top: -40px !important;\n    opacity: 0;\n    left: -303px !important;\n    transform-origin: 0 0;\n}\n.fixed-plugin .dropdown.show .dropdown-menu{\n    opacity: 1;\n    @include transform-translate-y-dropdown(0%);\n    transform-origin: 0 0;\n    left: -303px !important;\n}\n\n.fixed-plugin .dropdown-menu:before,\n.fixed-plugin .dropdown-menu:after{\n    content: \"\";\n    display: inline-block;\n    position: absolute;\n    top: 65px;\n    width: 16px;\n    transform: translateY(-50%);\n    -webkit-transform: translateY(-50%);\n    -moz-transform: translateY(-50%);\n\n}\n.fixed-plugin .dropdown-menu:before{\n    border-bottom: 16px solid rgba(0, 0, 0, 0);\n    border-left: 16px solid rgba(0,0,0,0.2);\n    border-top: 16px solid rgba(0,0,0,0);\n    right: -16px;\n}\n\n.fixed-plugin .dropdown-menu:after{\n    border-bottom: 16px solid rgba(0, 0, 0, 0);\n    border-left: 16px solid #fff;\n    border-top: 16px solid rgba(0,0,0,0);\n    right: -15px;\n}\n\n.wrapper-full-page ~ .fixed-plugin .dropdown.open .dropdown-menu{\n    -webkit-transform: translateY(-17%);\n    -moz-transform: translateY(-17%);\n    -o-transform: translateY(-17%);\n    -ms-transform: translateY(-17%);\n    transform: translateY(-17%);\n}\n\n.wrapper-full-page ~ .fixed-plugin .dropdown .dropdown-menu{\n    -webkit-transform: translateY(-19%);\n    -moz-transform: translateY(-19%);\n    -o-transform: translateY(-19%);\n    -ms-transform: translateY(-19%);\n    transform: translateY(-19%);\n}\n",".modal-header {\n    border: 0 none;\n}\n.modal-content {\n    border: 0 none;\n    border-radius: 10px;\n    box-shadow: 0 0 15px rgba(0, 0, 0, 0.15), 0 0 1px 1px rgba(0, 0, 0, 0.1);\n}\n.modal-dialog {\n    padding-top: 60px;\n}\n.modal-footer {\n    border-top: 0 none;\n    padding: 10px 10px;        \n}\n.modal-footer .modal-footer .btn-default.btn-simple{\n    font-weight: 400;\n}\n\n.modal.fade .modal-dialog {\n    transform: none;\n    -webkit-transform: none;\n    -moz-transform: none;\n}\n.modal.in .modal-dialog {\n    transform: none;\n    -webkit-transform: none;\n    -moz-transform: none;\n}\n.modal-small{\n    .modal-dialog{\n        max-width: 350px;\n    }\n}\n.modal-small{\n    .divider{\n        margin: 0 auto;\n        display: block;\n        width: 14px;\n        position: relative;\n        margin-top: 40px;\n        margin-bottom: 30px;\n        font-size: $font-paragraph;\n    }\n    .divider:after{\n        position: absolute;\n        content: \"\";\n        right: -140px;\n        top: 12px;\n        height: 1px;\n        width: 115px;\n        background-color: $light-gray;\n    }\n    .divider:before{\n        position: absolute;\n        content: \"\";\n        left: -140px;\n        top: 12px;\n        height: 1px;\n        width: 115px;\n        background-color: $light-gray;\n    }\n    .modal-footer{\n        text-align: center;\n    }\n}\n.social-area{\n    text-align: center;\n    \n    .btn-social{\n        margin: 0 10px;\n    }\n}\n.modal-backdrop.in {\n    opacity: 0.25;\n}\n\n\n\n",".btn {\n  border-width: $border-thick;\n  background-color: $transparent-bg;\n  font-weight: $font-weight-normal;\n  padding: $padding-base-vertical $padding-base-horizontal;\n  @include btn-styles($default-color, $default-states-color);\n  margin-bottom: 5px;\n  font-size: $font-size-base;\n  line-height: 1.42857143;\n\n  &:hover,\n  &:focus {\n    outline: 0 !important;\n    box-shadow: none;\n  }\n  &:active,\n  &.active,\n  .open > &.dropdown-toggle {\n    @include box-shadow(none);\n    outline: 0 !important;\n  }\n\n  &.btn-icon {\n    padding: $padding-base-vertical;\n  }\n}\n\n// Apply the mixin to the buttons\n// .btn-default { @include btn-styles($default-color, $default-states-color); }\n.btn-primary {\n  @include btn-styles($primary-color, $primary-states-color);\n}\n.btn-success {\n  @include btn-styles($success-color, $success-states-color);\n}\n.btn-info {\n  @include btn-styles($info-color, $info-states-color);\n}\n.btn-warning {\n  @include btn-styles($warning-color, $warning-states-color);\n}\n.btn-danger {\n  @include btn-styles($danger-color, $danger-states-color);\n}\n.btn-neutral {\n  @include btn-styles($white-color, $white-color);\n\n  &:active,\n  &.active,\n  .open > &.dropdown-toggle {\n    background-color: $white-color;\n    color: $default-color;\n  }\n\n  &.btn-fill,\n  &.btn-fill:hover,\n  &.btn-fill:focus {\n    color: $default-color;\n  }\n\n  &.btn-simple:active,\n  &.btn-simple.active {\n    background-color: transparent;\n  }\n}\n\n.btn {\n  &:disabled,\n  &[disabled],\n  &.disabled {\n    @include opacity(0.5);\n  }\n}\n.btn-round {\n  border-width: $border-thin;\n  border-radius: $btn-round-radius !important;\n  padding: $padding-round-vertical $padding-round-horizontal;\n\n  &.btn-icon {\n    padding: $padding-round-vertical;\n  }\n}\n\n.btn-lg {\n  @include btn-size(\n    $padding-large-vertical,\n    $padding-large-horizontal,\n    $font-size-large,\n    $border-radius-large\n  );\n  font-weight: $font-weight-normal;\n}\n.btn-sm {\n  @include btn-size(\n    $padding-small-vertical,\n    $padding-small-horizontal,\n    $font-size-small,\n    $border-radius-small\n  );\n}\n\n.btn-wd {\n  min-width: 140px;\n}\n\n.btn-group.select {\n  width: 100%;\n}\n.btn-group.select .btn {\n  text-align: left;\n}\n.btn-group.select .caret {\n  position: absolute;\n  top: 50%;\n  margin-top: -1px;\n  right: 8px;\n}\n.btn-social {\n  opacity: 0.85;\n}\n\nbutton[type=\"button\"] {\n  appearance: none;\n  // background: transparent;\n  border: 0;\n}\n","// Mixin for generating new styles\n@mixin btn-styles($btn-color, $btn-states-color) {\n  border: 1px solid $btn-color;\n  color: $white-color;\n  background-color: $btn-color;\n  cursor: pointer;\n\n  &:hover,\n  &:focus,\n  &:active,\n  &.active,\n  .open > &.dropdown-toggle {\n    background-color: $btn-states-color;\n    color: $white-color;\n    border-color: $btn-states-color;\n  }\n\n  &.disabled,\n  &:disabled,\n  &[disabled],\n  fieldset[disabled] & {\n    &,\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n      background-color: $transparent-bg;\n      border-color: $btn-color;\n    }\n  }\n\n\n  &.btn-outline {\n    color: $btn-color;\n    background-color: $transparent-bg;\n    border: 1px solid $btn-color;\n    @include opacity(1);\n\n    &:hover,\n    &:focus,\n    &:active,\n    &.active,\n    .open > &.dropdown-toggle{\n        background-color: $btn-states-color;\n        color: $white-color;\n        border: 1px solid $btn-states-color;\n    }\n\n    .caret{\n        border-top-color: $white-color;\n    }\n  }\n\n  &.btn-link{\n      border-color: $transparent-bg !important;\n      background-color: $transparent-bg !important;\n      color: $default-color;\n\n      &:hover,\n      &:focus,\n      &:active{\n          text-decoration: none;\n          border-color: $transparent-bg;\n          color: $default-states-color;\n      }\n\n  }\n\n  .caret{\n      border-top-color: $btn-color;\n  }\n}\n\n\n@mixin btn-size($padding-vertical, $padding-horizontal, $font-size, $border){\n   font-size: $font-size;\n   border-radius: $border;\n   padding: $padding-vertical $padding-horizontal;\n\n   &.btn-round{\n       padding: $padding-vertical + 1 $padding-horizontal;\n   }\n\n   &.btn-simple{\n       padding: $padding-vertical + 2 $padding-horizontal;\n   }\n\n}\n","// Opacity\n\n@mixin opacity($opacity) {\n  opacity: $opacity;\n  // IE8 filter\n  $opacity-ie: ($opacity * 100);\n  filter: #{alpha(opacity=$opacity-ie)};\n}\n\n@mixin black-filter($opacity){\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    position: absolute;\n    background-color: rgba(17,17,17,$opacity);\n    display: block;\n    content: \"\";\n    z-index: 1; \n}",".btn-social {\n\tpadding: 8px 9px;\n\n\t.fa,.fas,.far,.fal,.fad,.fab {\n\t\tfont-size: 18px;\n\t\twidth: 20px;\n\t\tvertical-align: middle;\n\t\tdisplay: inline-block;\n\t}\n\n\t&.btn-round {\n\t\tpadding: 8px;\n\t}\n\n\t&.btn-link {\n\t\tpadding: 8px 5px;\n\t\tfont-size: 16px;\n\n\t\t.fa,.fas,.far,.fal,.fad,.fab{\n\t\t\tfont-size: 20px;\n\t\t\tposition: relative;\n\t\t\ttop: -2px;\n\t\t\twidth: 24px;\n\t\t}\n\t}\n\n\n}\n\n.btn-facebook {\n\t@include social-buttons-color($social-facebook, $social-states-facebook);\n}\n\n.btn-twitter {\n\t@include social-buttons-color($social-twitter, $social-states-twitter);\n}\n\n.btn-pinterest {\n\t@include social-buttons-color($social-pinterest, $social-states-pinterest);\n}\n\n.btn-google {\n\t@include social-buttons-color($social-google, $social-states-google);\n}\n\n.btn-linkedin {\n\t@include social-buttons-color($social-linkedin, $social-states-linkedin);\n}\n\n.btn-dribbble {\n\t@include social-buttons-color($social-dribbble, $social-states-dribble);\n}\n\n.btn-github {\n\t@include social-buttons-color($social-github, $social-states-github);\n}\n\n.btn-youtube {\n\t@include social-buttons-color($social-youtube, $social-states-youtube);\n}\n\n.btn-stumbleupon {\n\t@include social-buttons-color($social-stumbleupon, $social-states-stumbleupon);\n}\n\n.btn-reddit {\n\t@include social-buttons-color($social-reddit, $social-states-reddit);\n}\n\n.btn-tumblr {\n\t@include social-buttons-color($social-tumblr, $social-states-tumblr);\n}\n\n.btn-behance{\n\t@include social-buttons-color($social-behance, $social-states-behance);\n}\n","@mixin social-buttons-color ($btn-color, $btn-states-color){\n  border-color: $btn-color;\n  background-color: $btn-color;\n  color: $white-color;\n\n  &:hover,\n  &:focus,\n  &:active,\n  &.active,\n  .open > &.dropdown-toggle {\n    background-color: $btn-states-color;\n    color: $white-color;\n    border-color: $btn-color;\n  }\n\n  &:disabled,\n  &[disabled],\n  &.disabled {\n    background-color: $transparent-bg;\n    border-color: $btn-color;\n  }\n\n  &.btn-outline{\n    color: $btn-color;\n    background-color: $transparent-bg;\n    border: 1px solid $btn-color;\n\n    &:hover,\n    &:focus,\n    &:active,\n    &.active,\n    .open > &.dropdown-toggle{\n        background-color: $btn-states-color;\n        color: $white-color;\n        border: 1px solid $btn-states-color;\n\n    }\n  }\n  &.btn-link {\n    color: $btn-color;\n    background-color: $transparent-bg;\n    border: 1px solid $btn-color;\n\n    &:hover,\n    &:focus,\n    &:active,\n    &.active,\n    .open > &.dropdown-toggle{\n        background-color: $transparent-bg;\n        color: $btn-states-color;\n        border: 1px solid $btn-states-color;\n\n    }\n  }\n\n\n}\n",".form-control::-moz-placeholder{\n   @include placeholder($medium-gray,1);\n}\n.form-control:-moz-placeholder{\n   @include placeholder($medium-gray,1);\n}\n.form-control::-webkit-input-placeholder{\n   @include placeholder($medium-gray,1);\n}\n.form-control:-ms-input-placeholder{\n   @include placeholder($medium-gray,1);\n}\n\n.form-control {\n    background-color: $white-bg;\n    border: 1px solid $light-gray;\n    border-radius: $border-radius-base;\n    font-size: .875rem;\n    color: #565656;\n    @include input-size($padding-base-vertical, $padding-base-horizontal - 4, $height-base);\n    @include box-shadow(none);\n\n    &:focus{\n           background-color: $white-bg;\n           border: 1px solid $medium-dark-gray;\n           @include box-shadow(none);\n           outline: 0 !important;\n           color: #333333;\n    }\n\n    .has-success &,\n    .has-error &,\n    .has-success &:focus,\n    .has-error &:focus{\n        border-color: $light-gray;\n        @include box-shadow(none);\n    }\n\n    .has-success &:focus{\n        border-color: $success-color;\n        color: $success-color;\n    }\n    .has-error &{\n        color: $danger-color;\n    }\n    .has-error &:focus{\n        border-color: $danger-color;\n    }\n\n    & + .form-control-feedback{\n        border-radius: $border-radius-large;\n        font-size: $font-size-base;\n        margin-top: -7px;\n        position: absolute;\n        right: 10px;\n        top: 50%;\n        vertical-align: middle;\n    }\n\n    .open &{\n        border-radius: $border-radius-base $border-radius-base 0 0;\n        border-bottom-color: transparent;\n    }\n}\n\n.input-lg{\n    height: 55px;\n    padding: $padding-large-vertical $padding-large-horizontal;\n}\n\n.has-error{\n    .form-control-feedback{\n        color: $danger-color;\n    }\n}\n.has-success{\n    .form-control-feedback{\n        color: $success-color\n    }\n}\n\n\n.input-group-addon {\n    background-color: $white-color;\n    border: 1px solid $light-gray;\n    border-radius: $border-radius-base;\n\n    .has-success &,\n    .has-error &{\n        background-color: $white-color;\n        border: 1px solid $light-gray;\n    }\n    .has-error .form-control:focus + &{\n        border-color: $danger-color;\n        color: $danger-color;\n    }\n    .has-success .form-control:focus + &{\n        border-color: $success-color;\n        color: $success-color;\n    }\n    .form-control:focus + &,\n    .form-control:focus ~ &{\n        background-color: $white-color;\n        border-color: $dark-gray;\n    }\n}\n\n.input-group .form-control:first-child,\n.input-group-addon:first-child,\n.input-group-btn:first-child > .dropdown-toggle,\n.input-group-btn:last-child > .btn:not(:last-child):not(.dropdown-toggle) {\n    border-right: 0 none;\n}\n.input-group .form-control:last-child,\n.input-group-addon:last-child,\n.input-group-btn:last-child > .dropdown-toggle,\n.input-group-btn:first-child > .btn:not(:first-child) {\n    border-left: 0 none;\n}\n.form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control {\n    background-color: $smoke-bg;\n    color: $default-color;\n    cursor: not-allowed;\n}\n\n.input-group-btn .btn{\n    border-width: $border-thin;\n    padding: $padding-round-vertical $padding-base-horizontal;\n}\n.input-group-btn .btn-default:not(.btn-fill){\n    border-color: $medium-gray;\n}\n\n.input-group-btn:last-child > .btn{\n    margin-left: 0;\n}\n\n.input-group-focus .input-group-addon{\n    border-color: $dark-gray;\n}\n\n.star{\n    color: #FB404B;\n    padding-left: 3px;\n}\n\n.card .card-body {\n    .control-label{\n        text-align: right;\n        padding-top: 18px;\n    }\n    .form-control-static,\n    .col-sm-10 .form-check:first-of-type,\n    .col-sm-4 .form-check:first-of-type{\n        padding-top: 8px;\n    }\n}\n\n.form-group.has-error{\n    .error{\n        color: $danger-color;\n        text-transform: none;\n        margin-bottom: 0;\n    }\n}\n\n.form-group.has-success{\n    .error{\n        display: none !important;\n    }\n}\n","@mixin input-size($padding-vertical, $padding-horizontal, $height){\n    padding: $padding-vertical $padding-horizontal;\n    height: $height;\n}\n\n@mixin placeholder($color, $opacity){\n   color: $color;\n   @include opacity(1);\n}\n\n@mixin light-form(){\n    border-radius: 0;\n    border:0;\n    padding: 0;\n    background-color: transparent;\n\n}",".alert{\n    border: 0;\n    border-radius: 0;\n    color: #FFFFFF;\n    padding: 10px 15px;\n    font-size: 14px;\n\n    .container &{\n        border-radius: 4px;\n\n    }\n    .navbar &{\n        border-radius: 0;\n        left: 0;\n        position: absolute;\n        right: 0;\n        top: 85px;\n        width: 100%;\n        z-index: 3;\n    }\n    .navbar:not(.navbar-transparent) &{\n        top: 70px;\n    }\n\n    span[data-notify=\"icon\"]{\n        font-size: 30px;\n        display: block;\n        left: 15px;\n        position: absolute;\n        top: 50%;\n        margin-top: -15px;\n    }\n\n    i.nc-simple-remove{\n        font-size: 12px !important;\n        font: bold normal normal 14px/1 'nucleo-icons';\n    }\n\n    button.close{\n        position: absolute;\n        right: 10px;\n        top: 50%;\n        margin-top: -13px;\n        z-index: 1033;\n        background-color: #FFFFFF;\n        display: block;\n        border-radius: 50%;\n        opacity: .4;\n        line-height: 9px;\n        width: 25px;\n        height: 25px;\n        outline: 0 !important;\n        text-align: center;\n        padding: 3px;\n        font-weight: 300;\n\n        &:hover{\n            opacity: .55;\n        }\n    }\n\n    .close ~ span{\n        display: block;\n        max-width: 89%;\n    }\n\n    &[data-notify=\"container\"]{\n        padding: 10px 10px 10px 20px;\n        border-radius: $border-radius-base;\n    }\n\n    &.alert-with-icon{\n        padding-left: 65px;\n    }\n}\n.alert-primary{\n    background-color: $blue-navbar;\n}\n.alert-info{\n     background-color: $azure-navbar;\n}\n.alert-success {\n    background-color: $green-navbar;\n}\n.alert-warning {\n     background-color: $orange-navbar;\n}\n.alert-danger {\n     background-color: $red-navbar;\n}\n",".table{\n\n   .radio,\n   .checkbox{\n        position: relative;\n        height: 20px;\n        display: block;\n        width: 20px;\n        padding: 0px 0px;\n        margin: 0px 5px;\n   }\n   > thead > tr > th,\n   > tbody > tr > th,\n   > tfoot > tr > th,\n   > thead > tr > td,\n   > tbody > tr > td,\n   > tfoot > tr > td{\n       padding: 12px 8px;\n       vertical-align: middle;\n       border-color: $light-gray;\n   }\n\n    > thead > tr > th{\n        border-bottom-width: 1px;\n        font-size: $font-size-small;\n        text-transform: uppercase;\n        color: $dark-gray;\n        font-weight: $font-weight-normal;\n        padding-bottom: 5px;\n    }\n\n    table > tr > td.td-actions{\n        display: inline-flex !important;\n    }\n\n   .td-actions .btn{\n        @include opacity(0.36);\n\n        &.btn-xs{\n            padding-left: 3px;\n            padding-right: 3px;\n        }\n    }\n    .td-actions{\n        min-width: 90px;\n    }\n\n    > tbody > tr{\n        position: relative;\n        font-size: 14px !important;\n\n\n        &:hover{\n            .td-actions .btn{\n                @include opacity(1);\n            }\n        }\n    }\n    thead th{\n        border-bottom: none !important;\n        border-top: none !important;\n    }\n\n    .btn-info.btn-link{\n        color: $info-color;\n    }\n    .btn-danger.btn-link{\n        color: $danger-color;\n    }\n    .btn-success.btn-link{\n        color: $success-color;\n    }\n    .btn-warning.btn-link{\n        color: $warning-color;\n    }\n\n    .form-check{\n        .form-check-sign,\n        .form-check-sign:before,\n        .form-check-sign:after{\n            margin-top: -14px;\n        }\n    }\n}\n\n.card{\n    .table{\n        tbody td:first-child,\n        thead th:first-child{\n            padding-left: 15px;\n        }\n\n        tbody td:last-child,\n        thead th:last-child{\n            padding-right: 15px;\n            display: block;\n        }\n    }\n}\n\n.table-bigboy{\n    > thead > tr > th{\n        font-size: $font-size-h6;\n        text-transform: uppercase;\n        color: $dark-gray;\n        font-weight: $font-weight-normal;\n    }\n    > tbody > tr > td{\n        font-size: $font-size-base;\n\n        b{\n            display: block;\n            margin-bottom: 5px;\n        }\n    }\n    .td-name,\n    {\n       font-weight: $font-weight-light;\n       font-size: $font-size-h5;\n   }\n    .td-name{\n        min-width: 240px;\n    }\n    .td-number{\n        text-align: right;\n        min-width: 110px;\n\n        small{\n            margin-right: 3px;\n        }\n    }\n\n    .td-actions{\n        width: 60px;\n        min-width: auto;\n\n        .btn{\n            float: right;\n        }\n    }\n    .img-container{\n        width: 180px;\n        height: 120px;\n        overflow: hidden;\n        display: block;\n\n        border-radius: $border-radius-large;\n\n        img{\n            width: 100%;\n        }\n    }\n\n\n}\n\n.table-with-links{\n    .card-body{\n        padding-bottom: 0 !important;\n\n        .table{\n            .btn{\n                margin-bottom: 0 !important;\n            }\n            tr td{\n                padding: 7px 3px !important;\n            }\n        }\n    }\n}\n\n\n.table-with-switches,\n.regular-table-with-color{\n    .card-body{\n        padding-bottom: 0 !important;\n\n        .table tbody td:last-child{\n            padding-right: 10px !important;\n        }\n    }\n}\n\n.table-big-boy{\n    .card-body{\n        padding-bottom: 0 !important;\n\n        .table tbody td:last-child{\n            padding-right: 10px !important;\n        }\n    }\n}\n\n.bootstrap-table{\n    .table thead th:first-child{\n        padding-left: 0!important;\n    }\n    .dropdown-menu{\n        li{\n            a{\n                display: block;\n                padding: 8px 16px;\n                clear: both;\n                font-weight: 400;\n                line-height: 1.42857143;\n                white-space: nowrap;\n                color: #333;\n\n                &:hover{\n                    background-color: #F5F5F5;\n                }\n            }\n            &.active{\n                a{\n                    background-color: rgba(68, 125, 247, 0.2);\n                }\n            }\n\n        }\n\n    }\n}\n.data-tables{\n    table{\n        tbody{\n            .btn{\n                padding: 3px !important;\n                font-size: 16px !important;\n            }\n        }\n    }\n    .pagination{\n        float: right;\n    }\n    tfoot{\n        font-size: 14px;\n    }\n}\n\n.card-tasks{\n    .table tbody{\n        td:last-child{\n            padding-right: 0;\n            display: inline-flex;\n            .btn{\n                padding: 3px;\n            }\n        }\n        td:first-child{\n            padding-left: 0;\n        }\n    }\n    .table-full-width{\n        padding-bottom: 0 !important;\n    }\n    .card-footer{\n        padding-top: 0;\n    }\n    .table{\n        margin-bottom: 0 !important;\n    }\n}\n\n.table-full-width{\n    margin-left: -15px;\n    margin-right: -15px;\n    padding: 15px !important;\n}\n\n\n\n\n@include table-row-variant('success', $light-green);\n@include table-row-variant('info', $light-azure);\n@include table-row-variant('warning', $light-orange);\n@include table-row-variant('danger', $light-red);\n","@mixin table-row-variant($state, $background) {\n  .table > thead > tr,\n  .table > tbody > tr,\n  .table > tfoot > tr {\n    > td.#{$state},\n    > th.#{$state},\n    &.#{$state} > td,\n    &.#{$state} > th {\n      background-color: $background;\n    }\n  }\n\n  .table-hover > tbody > tr {\n    > td.#{$state}:hover,\n    > th.#{$state}:hover,\n    &.#{$state}:hover > td,\n    &:hover > .#{$state},\n    &.#{$state}:hover > th {\n      background-color: lighten($background, 3%);\n    }\n  }\n}",".from-check,\n.form-check-radio {\n    margin-bottom: 12px;\n    position: relative;\n}\n\n.form-check{\n    .form-check-label{\n        display: inline-block;\n        position: relative;\n        cursor: pointer;\n        padding-left: 35px;\n        line-height: 26px;\n        margin-bottom: 0;\n        text-transform: capitalize;\n    }\n\n    .form-check-sign::before,\n    .form-check-sign::after{\n        font-family: \"Font Awesome 5 Free\";\n        content: \"\\f0c8\";\n        color: $default-color;\n        display: inline-block;\n        position: absolute;\n        width: 19px;\n        height: 19px;\n        margin-left: -23px;\n        font-size: 18px;\n        cursor: pointer;\n        @include transition-opacity(.3s, linear);\n    }\n    .form-check-sign::after{\n        font-family: \"Font Awesome 5 Free\";\n        content: \"\\f14a\";\n        text-align: center;\n        opacity: 0;\n        color: $info-color;\n        border: 0;\n        background-color: inherit;\n        margin-left: -23px;\n        font-weight: bold;\n    }\n    .form-check-sign::before{\n        margin-left: -22px;\n    }\n    &.disabled{\n        .form-check-label{\n            color: $dark-gray;\n            opacity: .5;\n            cursor: not-allowed;\n        }\n    }\n\n}\n\n#RegisterValidation .card{\n    .form-check{\n        .form-check-sign:before{\n            margin-left: -27px;\n        }\n    }\n}\n\n.form-check .form-check-input:disabled + .form-check-sign:before,\n.form-check .form-check-input:disabled + .form-check-sign:after,\n.radio input[type=\"radio\"]:disabled + label,\n.form-check .form-check-input:disabled:checked + .form-check-sign::after{\n    color: #ddd;\n    pointer-events: none\n}\n\n.form-check.disabled .form-check-label{\n    cursor: not-allowed;\n}\n\n.form-check input[type=\"checkbox\"],\n.form-check-radio input[type=\"radio\"]{\n    opacity: 0;\n    position: absolute;\n    visibility: hidden;\n}\n.form-check input[type=\"checkbox\"]:checked + .form-check-sign::after{\n    opacity: 1;\n}\n\n.form-check input[type=\"checkbox\"]:checked + .form-check-sign::before{\n    opacity: 0;\n}\n\n.form-control input[type=\"checkbox\"]:disabled + .form-check-sign::before,\n.checkbox input[type=\"checkbox\"]:disabled + .form-check-sign::after{\n    cursor: not-allowed;\n}\n\n.form-check .form-check-label input[type=\"checkbox\"]:disabled + .form-check-sign,\n.form-check-radio input[type=\"radio\"]:disabled + .form-check-sign{\n    pointer-events: none !important;\n}\n\n.form-check.checkbox-inline{\n    display: inline-block;\n}\n\n\n.form-check-radio{\n    .form-check-label{\n        padding-left: 2.2rem;\n    }\n    &.disabled{\n        .form-check-label{\n            color: $dark-gray;\n            opacity: .5;\n            cursor: not-allowed;\n        }\n    }\n}\n\n.form-check-radio .form-check-sign::before{\n    font-family: 'FontAwesome';\n    content: \"\\f10c\";\n    font-size: 18px;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    display: inline-block;\n    position: absolute;\n    opacity: .50;\n    left: 34px;\n}\n\n.form-check-radio input[type=\"radio\"] + .form-check-sign:after,\n.form-check-radio input[type=\"radio\"] {\n    opacity: 0;\n    @include transition-opacity(.3s, linear);\n    content:\" \";\n    display: block;\n    margin-left: 5px;\n    font-size: 18px;\n}\n\n.form-check-radio input[type=\"radio\"]:checked + .form-check-sign::after {\n    font-family: 'FontAwesome';\n    content: \"\\f192\";\n    position: absolute;\n    left: 5.3px;\n    opacity: 1;\n}\n\n.form-check-radio input[type=\"radio\"]:checked + .form-check-sign::after{\n    opacity: 1;\n    @include transition-opacity(.3s, linear);\n}\n\n.form-check input[type=\"radio\"]:checked + .form-check-sign::before{\n    opacity: 0;\n    @include transition-opacity(.3s, linear);\n}\n\n.form-check-radio input[type=\"radio\"]:disabled + .form-check-sign::before,\n.form-check-radio input[type=\"radio\"]:disabled + .form-check-sign::after {\n    color: $dark-gray;\n}\n\n.card{\n    &.stacked-form,\n    &.horizontal-form{\n        .form-check{\n            .form-check-label{\n                padding-left: 22px !important;\n            }\n        }\n    }\n}\n",".nav {\n    .nav-item{\n        .nav-link:hover,\n        .nav-link:focus{\n            background-color: transparent;\n        }\n    }\n\n}\n.navbar{\n    border: $none;\n    font-size: $font-size-navbar;\n    border-radius: 0;\n    min-height: 50px;\n    max-height: 61px;\n    background-color: $white-navbar;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n\n    .navbar-brand {\n        font-weight: 400;\n        margin: 5px 0px;\n        font-size: 18px;\n        color: $default-color;\n\n        &:hover{\n            color: #5e5e5e;\n        }\n    }\n\n    .navbar-wrapper{\n        display: inline-flex;\n        align-items: center;\n    }\n\n    .navbar-toggler{\n        width: 37px;\n        height: 27px;\n        vertical-align: middle;\n        outline: 0;\n        cursor: pointer;\n\n        &.navbar-toggler-left{\n            position: relative;\n            left: 0;\n            padding-left: 0;\n        }\n\n        &.navbar-toggler-right{\n            padding-right: 0;\n        }\n\n        & .navbar-toggler-bar{\n            width: 3px;\n            height: 3px;\n            border-radius: 50%;\n            margin: 0 auto;\n        }\n        .burger-lines{\n            display: block;\n            position: relative;\n            background-color: #888;\n            width: 24px;\n            height: 2px;\n            border-radius: 1px;\n            margin: 4px auto;\n        }\n    }\n\n    .btn-round.btn-icon{\n        padding: 8px 9px;\n    }\n\n\n    .navbar-nav{\n        .nav-item{\n            .nav-link{\n                color: $default-color;\n                padding: $navbar-padding-a;\n                margin: $navbar-margin-a;\n                position: relative;\n                display: inline-flex;\n                line-height: 40px;\n\n                &.btn{\n                    margin: $navbar-margin-a-btn;\n                    padding: $padding-base-vertical $padding-base-horizontal;\n                }\n\n                &.btn-round{\n                    margin: $navbar-margin-a-btn-round;\n                }\n\n                [class^=\"fa\"],\n                [class^=\"fas\"],\n                [class^=\"far\"],\n                [class^=\"fal\"],\n                [class^=\"fad\"],\n                [class^=\"fab\"]{\n                    font-size: $font-size-large + 1;\n                    position: relative;\n                    line-height: 40px;\n                    top: 1px;\n                }\n\n                &:hover{\n                    color: $info-color;\n                }\n\n                .stats{\n                    margin-left: 10px;\n                }\n            }\n\n            .dropdown-menu{\n                border-radius: $border-radius-extreme;\n                margin-top: -5px;\n\n                .dropdown-item{\n                    &:first-child{\n                        border-top-left-radius: 10px;\n                        border-top-right-radius: 10px;\n                    }\n                    &:last-child{\n                        border-bottom-left-radius: 10px;\n                        border-bottom-right-radius: 10px;\n                    }\n                }\n\n                .divider{\n                    height: 1px;\n                    margin: 5px 0;\n                    overflow: hidden;\n                    background-color: #e5e5e5;\n                }\n            }\n        }\n\n        .notification{\n            position: absolute;\n            background-color: #FB404B;\n            text-align: center;\n            border-radius: 10px;\n            min-width: 18px;\n            padding: 0 5px;\n            height: 18px;\n            font-size: 12px;\n            color: $white-color;\n            font-weight: bold;\n            line-height: 18px;\n            top: 10px;\n            left: 7px;\n        }\n\n        .dropdown-toggle:after{\n            display: inline-block;\n            width: 0;\n            height: 0;\n            margin-left: 5px;\n            margin-top: 18px;\n            vertical-align: middle;\n            border-top: 4px dashed;\n            border-top: 4px solid\\9;\n            border-right: 4px solid transparent;\n            border-left: 4px solid transparent;\n        }\n    }\n    .btn{\n       margin: $navbar-margin-btn;\n       font-size: $font-size-base;\n    }\n    .btn-simple{\n        font-size: $font-size-medium;\n    }\n\n    &.fixed{\n        width: calc(100% - #{$sidebar-width});\n        right: 0;\n        left: auto;\n        border-radius: 0;\n    }\n\n}\n\n.navbar-transparent, [class*=\"navbar-ct\"]{\n    .navbar-brand{\n        color: $white-color;\n        margin-left: 10px;\n        @include opacity(.9);\n\n        &:focus,\n        &:hover{\n            background-color: transparent;\n            @include opacity(1);\n            color: $white-color;\n        }\n    }\n\n    .navbar-nav{\n        .nav-item{\n            .nav-link:not(.btn){\n                color: $white-color;\n                border-color: $white-color;\n                @include opacity(0.8);\n            }\n        }\n\n        .active,\n        .nav-item{\n            .nav-link:not(.btn),\n            .nav-link:hover:not(.btn),\n            .nav-link:focus:not(.btn),{\n                background-color: transparent;\n                border-radius: 3px;\n                color: $white-color;\n                @include opacity(.8);\n\n                &:focus,\n                &:hover{\n                    @include opacity(1);\n                }\n            }\n        }\n\n        .nav .nav-item .nav-link.btn:hover{\n            background-color: transparent;\n        }\n\n        .show{\n            .nav-link,\n            .nav-link:hover,\n            .nav-link:focus{\n                background-color: transparent;\n                color: $white-color;\n                @include opacity(1);\n            }\n        }\n    }\n\n    .btn-default{\n        color: $white-color;\n        border-color: $white-color;\n    }\n    .btn-default.btn-fill{\n        color: $dark-gray;\n        background-color: $white-color;\n        @include opacity(.9);\n    }\n    .btn-default.btn-fill:hover,\n    .btn-default.btn-fill:focus,\n    .btn-default.btn-fill:active,\n    .btn-default.btn-fill.active,\n    .show .dropdown-toggle.btn-fill.btn-default{\n        border-color: $white-color;\n        @include opacity(1);\n    }\n\n}\n.navbar-transparent{\n    .dropdown-menu .divider{\n        background-color: rgba($white-color,.2);\n    }\n}\n\n\n.navbar-default {\n    background-color: $white-navbar;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n\n    .navbar-nav{\n        .nav-item{\n            .nav-link:not(.btn){\n                color: $dark-gray;\n            }\n        }\n\n        .active .nav-link,\n        .active .nav-link:not(.btn):hover,\n        .active .nav-link:not(.btn):focus,\n        .nav-item .nav-link:not(.btn):hover,\n        .nav-item .nav-link:not(.btn):focus{\n            background-color: transparent;\n            border-radius: 3px;\n            color: $info-color;\n            @include opacity(1);\n        }\n\n        .show{\n            .nav-link,\n            .nav-link:hover,\n            .nav-link:focus{\n                background-color: transparent;\n                color: $info-color;\n            }\n        }\n\n\n        .navbar-toggle:hover,.navbar-toggle:focus {\n            background-color: transparent;\n        }\n\n    }\n\n    &:not(.navbar-transparent) .btn-default:hover{\n        color: $info-color;\n        border-color: $info-color;\n    }\n    &:not(.navbar-transparent) .btn-neutral,\n    &:not(.navbar-transparent) .btn-neutral:hover,\n    &:not(.navbar-transparent) .btn-neutral:active{\n            color: $dark-gray;\n        }\n}\n\n/*      Navbar with icons            */\n\n.navbar-icons{\n    &.navbar .navbar-brand{\n        margin-top: 12px;\n        margin-bottom: 12px;\n    }\n    .navbar-nav{\n        .nav-item{\n            .nav-link{\n                text-align: center;\n                padding: $navbar-padding-a-icons;\n                margin: $navbar-margin-a-icons;\n            }\n        }\n\n        [class^=\"pe\"] {\n            font-size: 30px;\n            position: relative;\n        }\n        p {\n            margin: 3px 0 0;\n        }\n    }\n}\n\n.navbar-form{\n   @include box-shadow(none);\n   .form-control{\n        @include light-form();\n        height: 22px;\n        font-size: $font-size-navbar;\n        line-height: $line-height-general;\n        color: $light-gray;\n    }\n    .navbar-transparent & .form-control,\n    [class*=\"navbar-ct\"] & .form-control{\n        color: $white-color;\n        border: $none;\n        border-bottom: 1px solid rgba($white-color,.6);\n    }\n\n}\n\n.navbar-ct-blue{\n    @include navbar-color($blue-navbar);\n}\n.navbar-ct-azure{\n    @include navbar-color($azure-navbar);\n}\n.navbar-ct-green{\n    @include navbar-color($green-navbar);\n}\n.navbar-ct-orange{\n    @include navbar-color($orange-navbar);\n}\n.navbar-ct-red{\n    @include navbar-color($red-navbar);\n}\n\n.navbar-transparent{\n    padding-top: 15px;\n    background-color: transparent;\n    border-bottom: 1px solid transparent;\n    z-index: 999;\n    .navbar-toggler{\n        .burger-lines{\n            background: $white-color;\n        }\n    }\n}\n\n.navbar-toggle{\n    margin-top: 19px;\n    margin-bottom: 19px;\n    border: $none;\n\n    .icon-bar {\n        background-color: $white-color;\n    }\n     .navbar-collapse,\n     .navbar-form {\n        border-color: transparent;\n    }\n\n    &.navbar-default .navbar-toggle:hover,\n    &.navbar-default .navbar-toggle:focus {\n        background-color: transparent;\n    }\n}\n\n.main-panel{\n    .navbar-fixed{\n        position: fixed;\n        right: 0;\n        width: calc(100% - 260px);\n        z-index: 1030;\n    }\n    .navbar-fixed + .content{\n        padding-top: 90px;\n    }\n}\n\n.nav-mobile-menu.nav .navbar-search-form{\n    .nc-icon{\n        font-size: 28px;\n        width: 30px;\n        text-align: center;\n        vertical-align: middle;\n        float: left;\n        color: $white-color;\n    }\n\n    .form-control{\n        &::-webkit-input-placeholder { /* Chrome/Opera/Safari */\n            color: $white-color;\n        }\n        &::-moz-placeholder { /* Firefox 19+ */\n            color: $white-color;\n        }\n        &:-ms-input-placeholder { /* IE 10+ */\n            color: $white-color;\n        }\n        &:-moz-placeholder { /* Firefox 18- */\n            color: $white-color;\n        }\n    }\n}\n\n.nav .navbar-search-form{\n    .nc-icon{\n        color: #888888;\n    }\n}\n","@mixin navbar-color($color){\n    background-color: $color;\n}\n\n@mixin center-item(){\n    left: 0;\n    right: 0;\n    margin-right: auto;\n    margin-left: auto;\n    position: absolute;\n}",".footer{\n    background-color: $white-color;\n    width: 100%;\n\n    .footer-menu{\n        height: 41px;\n    }\n\n    nav > ul{\n        list-style: none;\n        margin: 0;\n        padding: 0;\n        font-weight: normal;\n\n        a:not(.btn){\n            color: $dark-gray;\n            display: block;\n            margin-bottom: 3px;\n            &:hover,\n            &:focus{\n                color: $default-states-color;\n            }\n        }\n    }\n    .social-area{\n        padding: 15px 0;\n        h5{\n            padding-bottom: 15px;\n        }\n    }\n    .social-area > a:not(.btn){\n       color: $dark-gray;\n       display: inline-block;\n       vertical-align: top;\n       padding: $padding-social-a;\n       font-size: $font-size-large-navbar;\n       font-weight: normal;\n       line-height: $line-height;\n       text-align: center;\n       &:hover,\n       &:focus{\n           color: $default-states-color;\n       }\n    }\n    .copyright{\n        color: $default-states-color;\n        padding: 10px 15px;\n        margin: 10px 3px;\n        line-height: 20px;\n        font-size: $font-size-base;\n    }\n    hr{\n        border-color: $medium-gray;\n    }\n    .title{\n        color: $default-states-color;\n    }\n}\n\n.footer-default{\n    background-color: $smoke-bg;\n}\n\n.footer:not(.footer-big){\n    nav > ul{\n       font-size: $font-size-base;\n       li{\n            margin-left: 20px;\n            float: left;\n        }\n        a{\n            padding: 10px 0px;\n            margin: 10px 10px 10px 0px;\n        }\n    }\n}\n\n.full-page + .footer li a,\n.full-page + .footer .copyright a{\n    color: #fff !important;\n}\n","\n.bootstrap-tagsinput {\n    // height: $height-base;\n    overflow-y: auto;\n    text-align: left;\n    .badge {\n        // @extend .animation-transition-ultra-fast;\n        cursor: pointer;\n        overflow: hidden;\n        position: relative;\n        margin: 5px 3px 5px 0;\n        padding: 4px 18px !important;\n        @include label-style();\n        background-color: transparent;\n        border: 1px solid $default-color;\n        font-size: 12px !important;\n\n        &.badge-blue,\n        &.badge-blue .tagsinput-remove-link{\n             @include label-color($primary-color);\n        }\n        &.badge-azure,\n        &.badge-azure .tagsinput-remove-link{\n             @include label-color($info-color);\n        }\n        &.badge-green .tag,\n        &.badge-green .tagsinput-remove-link{\n             @include label-color($success-color);\n        }\n        &.badge-orange .tag,\n        &.badge-orange .tagsinput-remove-link{\n             @include label-color($warning-color);\n        }\n        &.badgebadge-red .tag,\n        &.badgebadge-red .tagsinput-remove-link{\n             @include label-color($danger-color);\n        }\n\n        .badge-remove-link{\n            @include transition(60ms, ease-in);\n        }\n\n    }\n    .badge:hover{\n        padding-left: 10px;\n        padding-right: 18px;\n        opacity: 1 !important;\n        visibility: visible !important;\n        .badge-remove-link{\n            opacity: 1 !important;\n            color: black;\n            padding-right: 6px;\n        }\n\n    }\n\n    .tagsinput-add {\n        color: $black-color;\n        cursor: pointer;\n        display: inline-block;\n        font-size: 14px;\n        padding: 5px 6px;\n        vertical-align: top;\n        @include opacity(0.8);\n\n        &:hover,\n        &:focus{\n            @include opacity(1);\n        }\n    }\n    .tagsinput-add:before {\n        content: \"\\f067\";\n        font-family: \"FontAwesome\";\n    }\n\n    .badge-remove-link {\n        // @extend .animation-transition-ultra-fast;\n        cursor: pointer;\n        font-size: 12px;\n        padding: 3px 0;\n        position: absolute;\n        right: -3px;\n        opacity: 0;\n        text-align: right;\n        text-decoration: none;\n        top: 0;\n        width: 100%;\n        z-index: 2;\n    }\n    .tag:hover .tagsinput-remove-link {\n        opacity: 1;\n        padding-right: 6px;\n    }\n    .badge-remove-link:before {\n        content: \"\\f00d\";\n        font-family: \"FontAwesome\";\n        color: $info-color;\n    }\n    .tagsinput-add-container {\n        display: inline-block;\n        vertical-align: middle;\n    }\n    input{\n        background: transparent;\n        border: none;\n        color: $black-color;\n        margin: 0;\n        outline: medium none !important;\n        padding: 0 0 0 5px;\n        vertical-align: top;\n        width: 40px;\n        height: 30px;\n    }\n\n\n    &.badge-fill{\n        & .badge-blue{\n            @include label-color-fill($primary-color);\n        }\n        & .badge-azure{\n            @include label-color-fill($info-color);\n        }\n        &.badge-green{\n            @include label-color-fill($success-color);\n        }\n        &.badge-orange{\n            @include label-color-fill($warning-color);\n        }\n        &.badge-red{\n            @include label-color-fill($danger-color);\n        }\n    }\n    &.badge-fill .tagsinput-remove-link{\n        color: $white-color;\n    }\n}\n","@mixin label-style(){\n     padding: $padding-label-vertical $padding-label-horizontal;\n     border: 1px solid $default-color;\n     border-radius: $border-radius-small;\n     color: $default-color;\n     font-weight: $font-weight-semi;\n     font-size: $font-size-small;\n     text-transform: uppercase;\n     display: inline-block;\n     vertical-align: middle;\n}\n\n@mixin label-color($color){\n     border-color: $color;\n     color: $color;\n}\n@mixin label-color-fill($color){\n     border-color: $color;\n     color: $white-color;\n     background-color: $color;\n}","/*            Navigation menu                */\n.nav-pills {\n\n    > li + li {\n        margin-left: 0;\n    }\n    > li > a {\n        border: 1px solid $info-color;\n        border-radius: 0;\n        color: $info-color;\n        margin-left: -1px;\n\n        &:hover,\n        &:focus{\n            background-color: #F5F5F5;\n        }\n    }\n    > li.active > a,\n    > li.active > a:hover,\n    > li.active > a:focus {\n        background-color: $info-color;\n        color: #FFFFFF;\n    }\n    > li:first-child > a{\n        border-radius: 4px 0 0 4px;\n        margin: 0;\n    }\n    > li:last-child > a{\n        border-radius: 0 4px 4px 0;\n    }\n\n}\n\n.pagination{\n    .page-item{\n        .page-link{\n            border-radius: 50%;\n            margin: 0 2px;\n            color: #797979;\n            padding: 6px 12px;\n\n            &:hover{\n                background-color: #eee;\n                border-color: #ddd;\n            }\n        }\n\n        &.active{\n            .page-link{\n                background-color: #23CCEF;\n                border: 0;\n                color: #FFFFFF !important;\n                padding: 7px 13px;\n            }\n        }\n    }\n\n\n    .page-item{\n        &:first-child,\n        &:last-child{\n            .page-link{\n                border-radius: 50%;\n            }\n        }\n    }\n}\n\n.pagination > li.disabled{\n    opacity: .4;\n}\n\n.pagination.pagination-no-border > li > a,\n.pagination.pagination-no-border > li > span{\n    border: 0;\n}\n.pagination > li > a,\n.pagination > li > span,\n.pagination > li:first-child > a,\n.pagination > li:first-child > span,\n.pagination > li:last-child > a,\n.pagination > li:last-child > span{\n    border-radius: 50%;\n    margin: 0 2px;\n    color: $default-states-color;\n}\n.pagination > li.active > a,\n.pagination > li.active > span,\n.pagination > li.active > a:hover,\n.pagination > li.active > span:hover,\n.pagination > li.active > a:focus,\n.pagination > li.active > span:focus {\n    background-color: $info-color;\n    border: 0;\n    color: #FFFFFF;\n    padding: 7px 13px;\n}\n\n.nav-pills-blue{\n    > li.active {\n        > a,\n        > a:hover,\n        > a:focus{\n           background-color: $color-blue;\n        }\n    }\n}\n\n.pagination-blue{\n    > li.active{\n        a,\n        a:hover,\n        a:focus,\n        span,\n        span:hover,\n        span:focus{\n            background-color: $color-blue !important;\n        }\n    }\n}\n\n.nav-pills-azure{\n    > li.active {\n        > a,\n        > a:hover,\n        > a:focus{\n           background-color: $color-azure;\n        }\n    }\n}\n\n.pagination-azure{\n    li.active{\n        a,\n        a:hover,\n        a:focus,\n        span,\n        span:hover,\n        span:focus{\n            background-color: $color-azure !important;\n        }\n    }\n}\n\n.nav-pills-green{\n    > li.active {\n        > a,\n        > a:hover,\n        > a:focus{\n           background-color: $color-green;\n        }\n    }\n}\n\n.pagination-green{\n    > li.active{\n        a,\n        a:hover,\n        a:focus,\n        span,\n        span:hover,\n        span:focus{\n            background-color: $color-green !important;\n        }\n    }\n}\n\n.nav-pills-orange{\n    > li.active {\n        > a,\n        > a:hover,\n        > a:focus{\n           background-color: $color-orange;\n        }\n    }\n}\n\n.pagination-orange{\n    > li.active{\n        a,\n        a:hover,\n        a:focus,\n        span,\n        span:hover,\n        span:focus{\n            background-color: $color-orange !important;\n        }\n    }\n}\n\n.nav-pills-red{\n    > li.active {\n        > a,\n        > a:hover,\n        > a:focus{\n           background-color: $color-red;\n        }\n    }\n}\n\n.pagination-red{\n    > li.active{\n        a,\n        a:hover,\n        a:focus,\n        span,\n        span:hover,\n        span:focus{\n            background-color: $color-red !important;\n        }\n    }\n}\n\n// Bootstrap Table pagination\n\n.bootstrap-table{\n    .pagination{\n        .page-number{\n            a{\n                padding: 7px 12px;\n            }\n        }\n    }\n}\n\n.nav-pills-blue > li > a {\n    @include pill-style($color-blue);\n}\n.nav-pills-azure > li > a {\n    @include pill-style($color-azure);\n}\n.nav-pills-green > li > a {\n    @include pill-style($color-green);\n}\n.nav-pills-orange > li > a {\n    @include pill-style($color-orange);\n}\n.nav-pills-red > li > a {\n    @include pill-style($color-red);\n}\n\n.nav-text,\n.nav-icons{\n    padding:  $padding-default-vertical 0 0;\n\n    .nav-item .nav-link{\n        display: block;\n        padding: 0px $padding-base-horizontal;\n        color: $dark-gray;\n        text-align: center;\n        @include opacity(0.8);\n\n        &:hover,\n        &:focus{\n            background-color: $transparent-bg;\n            @include opacity(1);\n        }\n    }\n    .nav-item:first-child .nav-link{\n        padding-left: 0;\n    }\n    .nav-item .nav-link.active,\n    .nav-item.active .nav-link{\n       color: $info-color;\n    }\n    // .nav-item.active .nav-link.active{\n    //     color: $info-color;\n    // }\n}\n\n.nav-icons > li{\n    display: inline-block;\n     > a{\n        padding: 0 10px;\n        margin-bottom: 10px;\n    }\n    > a i{\n        font-size: $font-size-h4;\n        margin-bottom: 10px;\n        width: $font-size-h4;\n    }\n}\n\n.nav-icons.nav-stacked > li{\n    display: block;\n    > a {\n        margin-bottom: 20px;\n    }\n}\n\n.nav-blue > li.active a{\n    color: $primary-color;\n}\n.nav-azure > li.active a{\n    color: $info-color;\n}\n.nav-green > li.active a{\n    color: $success-color;\n}\n.nav-orange > li.active a{\n    color: $warning-color;\n}\n.nav-red > li.active a{\n    color: $danger-color;\n}\n\n.nav-text{\n    margin: $margin-bottom;\n\n    > li > a{\n        font-size: $font-size-h6;\n        text-transform: uppercase;\n        padding: 3px 0;\n        text-align: left;\n        font-weight: $font-weight-semi;\n\n    }\n    > li:first-child > a{\n        padding-top: 0;\n    }\n    h4{\n        margin-top: 0;\n    }\n}\n\n.nav-text:not(.nav-stacked){\n    > li{\n        display: inline-block;\n    }\n    > li > a{\n        margin-right: 15px;\n    }\n}\n\n.tab-pane{\n    padding: 15px 0;\n}\n\n.nav-container{\n    display: block;\n    width: 100%;\n    text-align: center;\n}\n.content-full-width{\n    .nav-tabs{\n        li:first-child{\n            padding-left: $padding-default-horizontal;\n        }\n    }\n    .tab-pane{\n        padding: $padding-default-horizontal;\n    }\n}\n\n\n// ACCORDION\n\n.accordions{\n    .card{\n        border: 0;\n        box-shadow: none;\n        margin-bottom: 15px;\n\n        .card-header{\n            padding: 0;\n            border-bottom: 1px solid #DDDDDD !important;\n\n            .card-title{\n                margin-top: 0;\n                margin-bottom: 0;\n                font-size: 18px;\n                color: inherit;\n\n                a{\n                    color: #333;\n                    padding: 0px 0 5px;\n                    display: block;\n                    width: 100%;\n                    font-size: 16px;\n\n                    &:hover{\n                        color: #797979;\n                    }\n                }\n            }\n\n            .caret{\n                display: inline-block;\n                width: 0;\n                height: 0;\n                margin-left: 2px;\n                vertical-align: middle;\n                border-top: 4px dashed;\n                border-top: 4px solid\\9;\n                border-right: 4px solid transparent;\n                border-left: 4px solid transparent;\n                float: right;\n                margin-top: 12px;\n                margin-right: 15px;\n                @include transition(150ms, ease-in);\n\n            }\n            a[data-toggle=\"collapse\"][aria-expanded=\"true\"] .caret,\n            a[data-toggle=\"collapse-hover\"][aria-expanded=\"true\"] .caret{\n                filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n                -webkit-transform: rotate(180deg);\n                -ms-transform: rotate(180deg);\n                transform: rotate(180deg);\n            }\n        }\n\n        .card-header + .card-collapse{\n            .card-body{\n                box-shadow: inset 0 7px 10px -7px rgba(0, 0, 0, 0.14);\n            }\n        }\n\n        .card-collapse.collapse-hover{\n            -webkit-transition: all 300ms linear;\n            -moz-transition: all 300ms linear;\n            -o-transition: all 300ms linear;\n            -ms-transition: all 300ms linear;\n            transition: all 300ms linear !important;\n        }\n    }\n\n\n}\n\n.card-body-full-width{\n    padding: 15px 0 !important;\n\n    .accordions{\n        .card-header{\n            .card-title{\n                a{\n                    padding: 10px 15px;\n                }\n            }\n        }\n    }\n}\n\n\n\n// PANELS\n\n.content-full-width{\n    .nav-tabs{\n        .nav-item:first-child{\n            padding-left: 15px;\n        }\n    }\n}\n\n.nav-container .nav-icons{\n    .nc-icon{\n        font-weight: 700;\n    }\n}\n\n\n// nav-pills - Wizard\n\n.card-wizard{\n    .nav-tabs{\n        margin-left: -15px;\n        margin-right: -15px;\n        margin-top: 10px;\n        margin-bottom: 10px;\n\n        .nav-item{\n            width: 33.33%;\n            .nav-link{\n                text-align: center;\n                border: none;\n                background-color: #9A9A9A;\n                color: $white-color;\n                text-transform: uppercase;\n                border-radius: unset;\n\n                &.active{\n                    background-color: $info-color;\n                }\n            }\n        }\n    }\n}\n","@mixin pill-style($color){\n    border: 1px solid $color;\n    color: $color;\n}",".progress {\n    background-color: #E5E5E5;\n    border-radius: 3px;\n    box-shadow: none;\n    height: 4px;\n    margin-bottom: 20px;\n}\n.progress-thin{\n    height: 2px;\n}\n\n.progress-bar,\n.progress-bar-primary{\n   background-color: $primary-color;\n}\n.progress-bar-info{\n    background-color: $info-color;\n}\n.progress-bar-success{\n   background-color: $success-color;\n}\n.progress-bar-warning{\n   background-color: $warning-color;\n}\n.progress-bar-danger{\n   background-color: $danger-color;\n}\n","\n/*!\n * jQuery UI Slider 1.10.4\n * http://jqueryui.com\n *\n * Copyright 2014 jQuery Foundation and other contributors\n * Released under the MIT license.\n * http://jquery.org/license\n *\n * http://api.jqueryui.com/slider/#theming\n */\n \n.ui-slider {\n\tposition: relative;\n\ttext-align: left;\n}\n.ui-slider .ui-slider-handle {\n\tposition: absolute;\n\tz-index: 2;\n\twidth: 1.2em;\n\theight: 1.2em;\n\tcursor: default;\n}\n.ui-slider .ui-slider-range {\n\tposition: absolute;\n\tz-index: 1;\n\tfont-size: .7em;\n\tdisplay: block;\n\tborder: 0;\n\tbackground-position: 0 0;\n}\n\n/* For IE8 - See #6727 */\n.ui-slider.ui-state-disabled .ui-slider-handle,\n.ui-slider.ui-state-disabled .ui-slider-range {\n\tfilter: inherit;\n}\n\n.ui-slider-horizontal {\n\theight: 4px;\n}\n.ui-slider-horizontal .ui-slider-handle {\n    margin-left: -10px;\n    top: -7px;\n}\n.ui-slider-horizontal .ui-slider-range {\n\ttop: 0;\n\theight: 100%;\n}\n.ui-slider-horizontal .ui-slider-range-min {\n\tleft: 0;\n}\n.ui-slider-horizontal .ui-slider-range-max {\n\tright: 0;\n}\n\n.ui-slider-vertical {\n\twidth: .8em;\n\theight: 100px;\n}\n.ui-slider-vertical .ui-slider-handle {\n\tleft: -.3em;\n\tmargin-left: 0;\n\tmargin-bottom: -.6em;\n}\n.ui-slider-vertical .ui-slider-range {\n\tleft: 0;\n\twidth: 100%;\n}\n.ui-slider-vertical .ui-slider-range-min {\n\tbottom: 0;\n}\n.ui-slider-vertical .ui-slider-range-max {\n\ttop: 0;\n}\n\n/* Component containers\n----------------------------------*/\n.ui-widget {\n\tfont-size: 1.1em/*{fsDefault}*/;\n}\n.ui-widget .ui-widget {\n\tfont-size: 1em;\n}\n.ui-widget input,\n.ui-widget select,\n.ui-widget textarea,\n.ui-widget button {\n\tfont-size: 1em;\n}\n.ui-widget-content {\n\tbackground-color: #E5E5E5;\n}\n.ui-widget-content a {\n\tcolor: #222222/*{fcContent}*/;\n}\n.ui-widget-header {\n\tbackground: #999999;\n\tcolor: #222222;\n\tfont-weight: bold;\n}\n.ui-widget-header a {\n\tcolor: #222222;\n}\n\n.slider-primary .ui-widget-header{\n   background-color: $primary-color;\n}\n.slider-info .ui-widget-header{\n    background-color: $info-color;\n}\n.slider-success .ui-widget-header{\n   background-color: $success-color;\n}\n.slider-warning .ui-widget-header{\n   background-color: $warning-color;\n}\n.slider-danger .ui-widget-header{\n   background-color: $danger-color;\n}\n\n/* Interaction states\n----------------------------------*/\n.ui-state-default,\n.ui-widget-content .ui-state-default,\n.ui-widget-header .ui-state-default {\n\tbackground: rgb(255,255,255); /* Old browsers */\n    background: -moz-linear-gradient(top,  rgba(255,255,255,1) 0%, rgba(241,241,242,1) 100%); /* FF3.6+ */\n    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,rgba(255,255,255,1)), color-stop(100%,rgba(241,241,242,1))); /* Chrome,Safari4+ */\n    background: -webkit-linear-gradient(top,  rgba(255,255,255,1) 0%,rgba(241,241,242,1) 100%); /* Chrome10+,Safari5.1+ */\n    background: -o-linear-gradient(top,  rgba(255,255,255,1) 0%,rgba(241,241,242,1) 100%); /* Opera 11.10+ */\n    background: -ms-linear-gradient(top,  rgba(255,255,255,1) 0%,rgba(241,241,242,1) 100%); /* IE10+ */\n    background: linear-gradient(to bottom,  rgba(255,255,255,1) 0%,rgba(241,241,242,1) 100%); /* W3C */\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#f1f1f2',GradientType=0 ); /* IE6-9 */\n    \n    border-radius: 50%;\n    box-shadow: 0 1px 1px #FFFFFF inset, 0 1px 2px rgba(0, 0, 0, 0.4);\n\theight:15px;\n\twidth:15px;\n\tcursor:pointer;\n}\n.ui-state-default a,\n.ui-state-default a:link,\n.ui-state-default a:visited {\n\tcolor: #555555/*{fcDefault}*/;\n\ttext-decoration: none;\n}\n\n.ui-state-hover a,\n.ui-state-hover a:hover,\n.ui-state-hover a:link,\n.ui-state-hover a:visited,\n.ui-state-focus a,\n.ui-state-focus a:hover,\n.ui-state-focus a:link,\n.ui-state-focus a:visited {\n\tcolor: #212121/*{fcHover}*/;\n\ttext-decoration: none;\n}\n.ui-state-active a,\n.ui-state-active a:link,\n.ui-state-active a:visited {\n\tcolor: #212121/*{fcActive}*/;\n\ttext-decoration: none;\n}\n\n/* Interaction Cues\n----------------------------------*/\n.ui-state-highlight,\n.ui-widget-content .ui-state-highlight,\n.ui-widget-header .ui-state-highlight {\n\tborder: 1px solid #fcefa1;\n\tbackground: #fbf9ee;\n\tcolor: #363636;\n}\n.ui-state-highlight a,\n.ui-widget-content .ui-state-highlight a,\n.ui-widget-header .ui-state-highlight a {\n\tcolor: #363636;\n}\n.ui-state-error,\n.ui-widget-content .ui-state-error,\n.ui-widget-header .ui-state-error {\n\tborder: 1px solid $danger-color/*{borderColorError}*/;\n\tbackground-color: $danger-color;\n\tcolor: $danger-color/*{fcError}*/;\n}\n.ui-state-error a,\n.ui-widget-content .ui-state-error a,\n.ui-widget-header .ui-state-error a {\n\tcolor: $danger-color/*{fcError}*/;\n}\n.ui-state-error-text,\n.ui-widget-content .ui-state-error-text,\n.ui-widget-header .ui-state-error-text {\n\tcolor: $danger-color/*{fcError}*/;\n}\n.ui-priority-primary,\n.ui-widget-content .ui-priority-primary,\n.ui-widget-header .ui-priority-primary {\n\tfont-weight: bold;\n}\n.ui-priority-secondary,\n.ui-widget-content .ui-priority-secondary,\n.ui-widget-header .ui-priority-secondary {\n\topacity: .7;\n\tfilter:Alpha(Opacity=70);\n\tfont-weight: normal;\n}\n.ui-state-disabled,\n.ui-widget-content .ui-state-disabled,\n.ui-widget-header .ui-state-disabled {\n\topacity: .35;\n\tfilter:Alpha(Opacity=35);\n\tbackground-image: none;\n}\n.ui-state-disabled .ui-icon {\n\tfilter:Alpha(Opacity=35); /* For IE8 - See #6059 */\n}",".dropdown-menu{\n    visibility: hidden;\n    margin: 0;\n    padding: 0;\n    border-radius: $border-radius-extreme;\n    display: block;\n    z-index: 9000;\n    position: absolute;\n\n    @include opacity(0);\n    @include box-shadow($dropdown-shadow);\n\n    .show &{\n        @include opacity(1);\n        visibility: visible;\n    }\n    .select &{\n       border-radius: $border-radius-bottom;\n       @include box-shadow(none);\n       @include transform-origin($select-coordinates);\n       @include transform-scale(1);\n       @include transition($fast-transition-time, $transition-linear);\n       margin-top: -20px;\n    }\n    .select.show &{\n        margin-top: -1px;\n    }\n\n    .dropdown-item {\n       padding: $padding-base-vertical $padding-base-horizontal;\n       color: #333333;\n\n       img{\n           margin-top: -3px;\n       }\n    }\n    .dropdown-item:focus{\n        outline: 0 !important;\n    }\n\n    .btn-group.select &{\n        min-width: 100%;\n    }\n\n    > li:first-child > a{\n       border-top-left-radius: $border-radius-extreme;\n       border-top-right-radius: $border-radius-extreme;\n    }\n\n    > li:last-child > a{\n        border-bottom-left-radius: $border-radius-extreme;\n        border-bottom-right-radius: $border-radius-extreme;\n    }\n\n    .select & > li:first-child > a{\n        border-radius: 0;\n        border-bottom: 0 none;\n    }\n\n    .dropdown-item:hover,\n    .dropdown-item:focus {\n        background-color: $smoke-bg;\n        color: #333333;\n        opacity: 1;\n        text-decoration: none;\n    }\n\n    &.dropdown-blue > li > a:hover,\n    &.dropdown-blue > li > a:focus{\n        background-color: $light-blue;\n    }\n    &.dropdown-azure > li > a:hover,\n    &.dropdown-azure > li > a:focus{\n        background-color: $light-azure;\n    }\n    &.ct-green > li > a:hover,\n    &.ct-green > li > a:focus{\n        background-color: $light-green;\n    }\n    &.dropdown-orange > li > a:hover,\n    &.dropdown-orange > li > a:focus{\n        background-color: $light-orange;\n    }\n    &.dropdown-red > li > a:hover,\n    &.dropdown-red > li > a:focus{\n        background-color: $light-red;\n    }\n\n    .dropdown-item{\n        i[class*=\"nc-icon\"]{\n            font-size: 18px;\n            text-align: center;\n            line-height: 25px;\n            float: left;\n            padding-right: 10px;\n        }\n    }\n\n    &.dropdown-menu-right{\n        &:before,\n        &:after{\n            right: 12px !important;\n            left: auto !important;\n        }\n    }\n\n}\n\n.dropdown-with-icons{\n    > li > a{\n        padding-left: 0px;\n        line-height: 28px;\n    }\n    i{\n        text-align: center;\n        line-height: 28px;\n        float: left;\n\n        &[class^=\"pe-\"]{\n             font-size: 24px;\n             width: 46px;\n        }\n        &[class^=\"fa\"],\n        &[class^=\"fas\"],\n        &[class^=\"far\"],\n        &[class^=\"fal\"],\n        &[class^=\"fad\"],\n        &[class^=\"fab\"]{\n            font-size: 14px;\n            width: 38px;\n        }\n    }\n}\n\n//fix bug for the select items in btn-group\n.btn-group.select{\n    overflow: hidden;\n}\n.btn-group.select.show{\n    overflow: visible;\n}\n",".card{\n    border-radius: $border-radius-base;\n    background-color: $white-color;\n    // margin-bottom: 30px;\n\n    .card-image{\n        width: 100%;\n        overflow: hidden;\n        height: 260px;\n        border-radius: $border-radius-base $border-radius-base 0 0;\n        position: relative;\n        -webkit-transform-style: preserve-3d;\n        -moz-transform-style: preserve-3d;\n        transform-style: preserve-3d;\n\n        img {\n            width: 100%;\n        }\n    }\n    .filter{\n        position: absolute;\n        z-index: 2;\n        background-color: rgba(0,0,0,.68);\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        text-align: center;\n\n        @include opacity(0);\n\n        .btn{\n            @include vertical-align();\n        }\n    }\n    &:hover .filter{\n        @include opacity(1);\n    }\n    .btn-hover{\n        @include opacity(0);\n    }\n    &:hover .btn-hover{\n        @include opacity(1);\n    }\n    .card-body{\n        padding: 15px 15px 10px 15px;\n    }\n    .card-header{\n        padding: 15px 15px 0;\n        background-color: $white-color;\n        border-bottom: none !important;\n\n    }\n    .card-category,\n    label{\n        font-size: $font-size-base;\n        font-weight: $font-weight-normal;\n        color: $dark-gray;\n        margin-bottom: 0px;\n\n        i{\n            font-size: $font-paragraph;\n        }\n    }\n\n    label{\n        font-size: $font-size-small;\n        margin-bottom: 5px;\n        text-transform: uppercase;\n    }\n\n    .card-title{\n        margin: $none;\n        color: $black-color;\n        font-weight: $font-weight-light;\n    }\n    .avatar{\n        height: 100%;\n        overflow: hidden;\n        border-radius: 50%;\n        margin-right: 5px;\n    }\n    .description{\n        font-size: $font-size-base;\n        color: #333;\n    }\n    .card-footer{\n        padding: 15px 15px 10px 15px;\n        background-color: $transparent-bg;\n        line-height: 30px;\n        border-top: none !important;\n        font-size: 14px;\n\n        .legend{\n            padding: 5px 0;\n        }\n\n        hr{\n            margin-top: 5px;\n            margin-bottom: 5px;\n        }\n    }\n    .stats{\n        color: #a9a9a9;\n    }\n\n    .author{\n        font-size: $font-size-small;\n        font-weight: $font-weight-bold;\n        text-transform: uppercase;\n        border-radius: 50%;\n        // width: 100px;\n        // height: 100px;\n        border: 4px solid rgba(255, 255, 255, 0.3);\n        overflow: hidden;\n        margin: 0 auto;\n        -webkit-transition: all 300ms linear;\n        -moz-transition: all 300ms linear;\n        -o-transition: all 300ms linear;\n        -ms-transition: all 300ms linear;\n        transition: all 300ms linear;\n    }\n    .author i{\n        font-size: $font-size-base;\n    }\n    h6{\n        font-size: $font-size-small;\n        margin: 0;\n    }\n    &.card-separator:after{\n        height: 100%;\n        right: -15px;\n        top: 0;\n        width: 1px;\n        background-color: $medium-gray;\n        card-body: \"\";\n        position: absolute;\n    }\n\n    .ct-chart{\n        margin: 30px 0 30px;\n        // height: 245px;\n    }\n\n    .ct-label{\n        font-size: 1rem !important;\n    }\n\n    .alert{\n        border-radius: $border-radius-base;\n        position: relative;\n\n        &.alert-with-icon{\n            padding-left: 65px;\n        }\n    }\n\n    &.card-lock{\n        .card-body .card-title{\n            margin-bottom: 20px;\n            color: $white-color;\n        }\n        .card-header{\n            .author{\n                width: 100px;\n                height: 100px;\n\n            }\n        }\n    }\n}\n\n\n\n.card-stats{\n    .card-body{\n        padding: 15px 15px 0px;\n\n        .numbers{\n            text-align: right;\n\n            p{\n                margin-bottom: 0;\n            }\n        }\n    }\n    .card-footer{\n        padding: 0px 15px 10px 15px;\n    }\n    .icon-big {\n        font-size: 3em;\n        min-height: 64px;\n\n        i{\n            line-height: 59px;\n        }\n    }\n\n\n}\n\n.card-user{\n    .card-image{\n        height: 110px;\n    }\n    .card-image-plain{\n        height: 0;\n        margin-top: 110px;\n    }\n    .author{\n        text-align: center;\n        text-transform: none;\n        margin-top: -70px;\n    }\n    .avatar{\n        width: 124px;\n        height: 124px;\n        border: 5px solid #EEEEEE;\n        position: relative;\n        margin-bottom: 15px;\n\n        &.border-gray{\n            border-color: #EEEEEE;\n        }\n    }\n    .title{\n        line-height: 24px;\n    }\n    .card-body{\n        min-height: 240px;\n    }\n    .card-header.no-padding{\n        padding: 0;\n    }\n\n    .card-footer{\n        .button-container .btn{\n            font-size: 16px;\n        }\n    }\n}\n\n.card-user,\n.card-price{\n    .card-footer{\n        padding: 5px 15px 10px;\n    }\n    hr{\n        margin: 5px 15px;\n    }\n}\n.card-plain{\n    background-color: transparent;\n    box-shadow: none;\n    border-radius: 0;\n\n    .card-image{\n        border-radius: 4px;\n    }\n}\n\n.card.card-plain{\n    border: none !important;\n\n    .card-header{\n        background-color: transparent !important;\n    }\n}\n\n.card{\n    &.card-login{\n        box-shadow: 0 25px 30px -13px rgba(40, 40, 40, 0.4);\n        border-radius: 10px;\n        padding-top: 10px;\n        padding-bottom: 30px;\n        @include transform-translate-y(0px);\n        @include transition(300ms, linear);\n\n        .form-check{\n            margin-left: -12px;\n        }\n        &.card-hidden{\n            opacity: 0;\n            @include transform-translate-y(-60px);\n        }\n    }\n\n    &.card-register{\n        .header-text{\n            hr{\n                border-top: 1px solid rgba(255,255,255,.3);\n            }\n        }\n    }\n}\n","@mixin ct-responsive-svg-container($width: 100%, $ratio: $ct-container-ratio) {\n  display: block;\n  position: relative;\n  width: $width;\n\n  &:before {\n    display: block;\n    float: left;\n    content: \"\";\n    width: 0;\n    height: 0;\n    padding-bottom: $ratio * 100%;\n  }\n\n  &:after {\n    content: \"\";\n    display: table;\n    clear: both;\n  }\n\n  > svg {\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n  }\n}\n\n@mixin ct-align-justify($ct-text-align: $ct-text-align, $ct-text-justify: $ct-text-justify) {\n  -webkit-box-align: $ct-text-align;\n  -webkit-align-items: $ct-text-align;\n  -ms-flex-align: $ct-text-align;\n  align-items: $ct-text-align;\n  -webkit-box-pack: $ct-text-justify;\n  -webkit-justify-content: $ct-text-justify;\n  -ms-flex-pack: $ct-text-justify;\n  justify-content: $ct-text-justify;\n  // Fallback to text-align for non-flex browsers\n  @if($ct-text-justify == 'flex-start') {\n    text-align: left;\n  } @else if ($ct-text-justify == 'flex-end') {\n    text-align: right;\n  } @else {\n    text-align: center;\n  }\n}\n\n@mixin ct-flex() {\n  // Fallback to block\n  display: block;\n  display: -webkit-box;\n  display: -moz-box;\n  display: -ms-flexbox;\n  display: -webkit-flex;\n  display: flex;\n}\n\n@mixin ct-chart-label($ct-text-color: $ct-text-color, $ct-text-size: $ct-text-size, $ct-text-line-height: $ct-text-line-height) {\n  fill: $ct-text-color;\n  color: $ct-text-color;\n  font-size: $ct-text-size;\n  line-height: $ct-text-line-height;\n}\n\n@mixin ct-chart-grid($ct-grid-color: $ct-grid-color, $ct-grid-width: $ct-grid-width, $ct-grid-dasharray: $ct-grid-dasharray) {\n  stroke: $ct-grid-color;\n  stroke-width: $ct-grid-width;\n\n  @if ($ct-grid-dasharray) {\n    stroke-dasharray: $ct-grid-dasharray;\n  }\n}\n\n@mixin ct-chart-point($ct-point-size: $ct-point-size, $ct-point-shape: $ct-point-shape) {\n  stroke-width: $ct-point-size;\n  stroke-linecap: $ct-point-shape;\n}\n\n@mixin ct-chart-line($ct-line-width: $ct-line-width, $ct-line-dasharray: $ct-line-dasharray) {\n  fill: none;\n  stroke-width: $ct-line-width;\n\n  @if ($ct-line-dasharray) {\n    stroke-dasharray: $ct-line-dasharray;\n  }\n}\n\n@mixin ct-chart-area($ct-area-opacity: $ct-area-opacity) {\n  stroke: none;\n  fill-opacity: $ct-area-opacity;\n}\n\n@mixin ct-chart-bar($ct-bar-width: $ct-bar-width) {\n  fill: none;\n  stroke-width: $ct-bar-width;\n}\n\n@mixin ct-chart-donut($ct-donut-width: $ct-donut-width) {\n  fill: none;\n  stroke-width: $ct-donut-width;\n}\n\n@mixin ct-chart-series-color($color) {\n  .#{$ct-class-point}, .#{$ct-class-line}, .#{$ct-class-bar}, .#{$ct-class-slice-donut} {\n    stroke: $color;\n  }\n\n  .#{$ct-class-slice-pie}, .#{$ct-class-area} {\n    fill: $color;\n  }\n}\n\n@mixin ct-chart($ct-container-ratio: $ct-container-ratio, $ct-text-color: $ct-text-color, $ct-text-size: $ct-text-size, $ct-grid-color: $ct-grid-color, $ct-grid-width: $ct-grid-width, $ct-grid-dasharray: $ct-grid-dasharray, $ct-point-size: $ct-point-size, $ct-point-shape: $ct-point-shape, $ct-line-width: $ct-line-width, $ct-bar-width: $ct-bar-width, $ct-donut-width: $ct-donut-width, $ct-series-names: $ct-series-names, $ct-series-colors: $ct-series-colors) {\n\n  .#{$ct-class-label} {\n    @include ct-chart-label($ct-text-color, $ct-text-size);\n  }\n\n  .#{$ct-class-chart-line} .#{$ct-class-label},\n  .#{$ct-class-chart-bar} .#{$ct-class-label} {\n    @include ct-flex();\n  }\n\n  .#{$ct-class-label}.#{$ct-class-horizontal}.#{$ct-class-start} {\n    @include ct-align-justify(flex-end, flex-start);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: start;\n  }\n\n  .#{$ct-class-label}.#{$ct-class-horizontal}.#{$ct-class-end} {\n    @include ct-align-justify(flex-start, flex-start);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: start;\n  }\n\n  .#{$ct-class-label}.#{$ct-class-vertical}.#{$ct-class-start} {\n    @include ct-align-justify(flex-end, flex-end);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: end;\n  }\n\n  .#{$ct-class-label}.#{$ct-class-vertical}.#{$ct-class-end} {\n    @include ct-align-justify(flex-end, flex-start);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: start;\n  }\n\n  .#{$ct-class-chart-bar} .#{$ct-class-label}.#{$ct-class-horizontal}.#{$ct-class-start} {\n    @include ct-align-justify(flex-end, center);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: start;\n  }\n\n  .#{$ct-class-chart-bar} .#{$ct-class-label}.#{$ct-class-horizontal}.#{$ct-class-end} {\n    @include ct-align-justify(flex-start, center);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: start;\n  }\n\n  .#{$ct-class-chart-bar}.#{$ct-class-horizontal-bars} .#{$ct-class-label}.#{$ct-class-horizontal}.#{$ct-class-start} {\n    @include ct-align-justify(flex-end, flex-start);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: start;\n  }\n\n  .#{$ct-class-chart-bar}.#{$ct-class-horizontal-bars} .#{$ct-class-label}.#{$ct-class-horizontal}.#{$ct-class-end} {\n    @include ct-align-justify(flex-start, flex-start);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: start;\n  }\n\n  .#{$ct-class-chart-bar}.#{$ct-class-horizontal-bars} .#{$ct-class-label}.#{$ct-class-vertical}.#{$ct-class-start} {\n    //@include ct-chart-label($ct-text-color, $ct-text-size, center, $ct-vertical-text-justify);\n    @include ct-align-justify(center, flex-end);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: end;\n  }\n\n  .#{$ct-class-chart-bar}.#{$ct-class-horizontal-bars} .#{$ct-class-label}.#{$ct-class-vertical}.#{$ct-class-end} {\n    @include ct-align-justify(center, flex-start);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: end;\n  }\n\n  .#{$ct-class-grid} {\n    @include ct-chart-grid($ct-grid-color, $ct-grid-width, $ct-grid-dasharray);\n  }\n\n  .#{$ct-class-point} {\n    @include ct-chart-point($ct-point-size, $ct-point-shape);\n  }\n\n  .#{$ct-class-line} {\n    @include ct-chart-line($ct-line-width);\n  }\n\n  .#{$ct-class-area} {\n    @include ct-chart-area();\n  }\n\n  .#{$ct-class-bar} {\n    @include ct-chart-bar($ct-bar-width);\n  }\n\n  .#{$ct-class-slice-donut} {\n    @include ct-chart-donut($ct-donut-width);\n  }\n\n  @if $ct-include-colored-series {\n    @for $i from 0 to length($ct-series-names) {\n      .#{$ct-class-series}-#{nth($ct-series-names, $i + 1)} {\n        $color: nth($ct-series-colors, $i + 1);\n\n        @include ct-chart-series-color($color);\n      }\n    }\n  }\n}\n\n@if $ct-include-classes {\n  @include ct-chart();\n\n  @if $ct-include-alternative-responsive-containers {\n    @for $i from 0 to length($ct-scales-names) {\n      .#{nth($ct-scales-names, $i + 1)} {\n        @include ct-responsive-svg-container($ratio: nth($ct-scales, $i + 1));\n      }\n    }\n  }\n}","// Scales for responsive SVG containers\n$ct-scales: ((1), (15/16), (8/9), (5/6), (4/5), (3/4), (2/3), (5/8), (1/1.618), (3/5), (9/16), (8/15), (1/2), (2/5), (3/8), (1/3), (1/4)) !default;\n$ct-scales-names: (ct-square, ct-minor-second, ct-major-second, ct-minor-third, ct-major-third, ct-perfect-fourth, ct-perfect-fifth, ct-minor-sixth, ct-golden-section, ct-major-sixth, ct-minor-seventh, ct-major-seventh, ct-octave, ct-major-tenth, ct-major-eleventh, ct-major-twelfth, ct-double-octave) !default;\n\n// Class names to be used when generating CSS\n$ct-class-chart: ct-chart !default;\n$ct-class-chart-line: ct-chart-line !default;\n$ct-class-chart-bar: ct-chart-bar !default;\n$ct-class-horizontal-bars: ct-horizontal-bars !default;\n$ct-class-chart-pie: ct-chart-pie !default;\n$ct-class-chart-donut: ct-chart-donut !default;\n$ct-class-label: ct-label !default;\n$ct-class-series: ct-series !default;\n$ct-class-line: ct-line !default;\n$ct-class-point: ct-point !default;\n$ct-class-area: ct-area !default;\n$ct-class-bar: ct-bar !default;\n$ct-class-slice-pie: ct-slice-pie !default;\n$ct-class-slice-donut: ct-slice-donut !default;\n$ct-class-grid: ct-grid !default;\n$ct-class-vertical: ct-vertical !default;\n$ct-class-horizontal: ct-horizontal !default;\n$ct-class-start: ct-start !default;\n$ct-class-end: ct-end !default;\n\n// Container ratio\n$ct-container-ratio: (1/1.618) !default;\n\n// Text styles for labels\n$ct-text-color: rgba(0, 0, 0, 0.4) !default;\n$ct-text-size: 1.3rem !default;\n$ct-text-align: flex-start !default;\n$ct-text-justify: flex-start !default;\n$ct-text-line-height: 1;\n\n// Grid styles\n$ct-grid-color: rgba(0, 0, 0, 0.2) !default;\n$ct-grid-dasharray: 2px !default;\n$ct-grid-width: 1px !default;\n\n// Line chart properties\n$ct-line-width: 3px !default;\n$ct-line-dasharray: false !default;\n$ct-point-size: 8px !default;\n// Line chart point, can be either round or square\n$ct-point-shape: round !default;\n// Area fill transparency between 0 and 1\n$ct-area-opacity: 0.8 !default;\n\n// Bar chart bar width\n$ct-bar-width: 10px !default;\n\n// Donut width (If donut width is to big it can cause issues where the shape gets distorted)\n$ct-donut-width: 60px !default;\n\n// If set to true it will include the default classes and generate CSS output. If you're planning to use the mixins you\n// should set this property to false\n$ct-include-classes: true !default;\n\n// If this is set to true the CSS will contain colored series. You can extend or change the color with the\n// properties below\n$ct-include-colored-series: $ct-include-classes !default;\n\n// If set to true this will include all responsive container variations using the scales defined at the top of the script\n$ct-include-alternative-responsive-containers: $ct-include-classes !default;\n\n// Series names and colors. This can be extended or customized as desired. Just add more series and colors.\n$ct-series-names: (a, b, c, d, e, f, g, h, i, j, k, l, m, n, o) !default;\n$ct-series-colors: (\n  $new-blue,\n  $new-red,\n  $new-orange,\n  $new-purple,\n  $new-green,\n  $new-dark-blue,\n  $new-black,\n  $social-google,\n  $social-tumblr,\n  $social-youtube,\n  $social-twitter,\n  $social-pinterest,\n  $social-behance,\n  #6188e2,\n  #a748ca\n) !default;\n","@media (min-width: 992px){\n\n    .navbar-fixed{\n        width: calc(100% + 260px);\n    }\n\n    .navbar-form {\n        padding-left: 15px;\n        padding-right: 5px;\n\n        .input-group{\n            .form-control{\n                margin-left: 10px;\n            }\n        }\n    }\n\n    .nav.nav-mobile-menu{\n        display: none;\n    }\n\n    .navbar{\n        .navbar-nav{\n            .nc-icon{\n                font-weight: 700;\n                margin-top: 10px;\n            }\n            .input-group{\n                .nc-icon{\n                    margin-top: 0;\n                }\n            }\n            .dropdown-menu .dropdown-item{\n                .nc-icon{\n                    margin-top: 0;\n                }\n            }\n        }\n    }\n    .close-layer{\n        display: none;\n    }\n\n    .navbar-nav .nav-item .dropdown-menu, .dropdown .dropdown-menu{\n        @include transform-scale(0);\n        @include transition($slow-transition-time, $transition-bezier);\n    }\n    .navbar-nav .nav-item.show .dropdown-menu, .dropdown.show .dropdown-menu{\n        @include transform-scale(1);\n        @include transform-origin($dropdown-coordinates);\n\n    }\n\n    .sidebar-mini .sidebar .sidebar-wrapper > .nav [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-normal, .sidebar-mini .sidebar .sidebar-wrapper .user .info [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-normal, .sidebar-mini .sidebar .sidebar-wrapper .user .info > a > span,\n    .sidebar-mini .sidebar .sidebar-wrapper > .nav li > a span,\n    .sidebar-mini .sidebar .sidebar-wrapper > .nav li > a .caret{\n        @include transform-translate-3d(-25px);\n        opacity: 0;\n    }\n\n    .sidebar-mini{\n        .sidebar{\n            .logo{\n                a.logo-mini{\n                    opacity: 1;\n                }\n                a.logo-normal{\n                    opacity: 0;\n                }\n            }\n        }\n    }\n\n    .footer{\n        height: 60px;\n        .footer-menu{\n            float: left;\n        }\n        .copyright{\n            float: right;\n        }\n    }\n    .navbar-nav .nav-item .dropdown-menu:before{\n        border-bottom: 11px solid rgba(0, 0, 0, 0.2);\n        border-left: 11px solid rgba(0, 0, 0, 0);\n        border-right: 11px solid rgba(0, 0, 0, 0);\n        content: \"\";\n        display: inline-block;\n        position: absolute;\n        left: 12px;\n        top: -11px;\n    }\n    .navbar-nav .nav-item .dropdown-menu:after {\n        border-bottom: 11px solid #FFFFFF;\n        border-left: 11px solid rgba(0, 0, 0, 0);\n        border-right: 11px solid rgba(0, 0, 0, 0);\n        content: \"\";\n        display: inline-block;\n        position: absolute;\n        left: 12px;\n        top: -10px;\n    }\n\n    .navbar-nav.navbar-right .nav-item .dropdown-menu:before{\n        left: auto;\n        right: 12px;\n    }\n\n    .navbar-nav.navbar-right .nav-item .dropdown-menu:after{\n        left: auto;\n        right: 12px;\n    }\n\n    .footer:not(.footer-big){\n        nav > ul{\n           li:first-child{\n             margin-left: 0;\n           }\n        }\n    }\n\n    .card{\n        form{\n            [class*=\"col-\"]{\n                padding: 6px;\n            }\n            [class*=\"col-\"]:first-child{\n                padding-left: 15px;\n            }\n            [class*=\"col-\"]:last-child{\n                padding-right: 15px;\n            }\n        }\n    }\n}\n\n/*          Changes for small display      */\n\n@media (max-width: 991px){\n\n    .sidebar{\n        right: 0 !important;\n        left: auto;\n        @include transform-translate-3d(260px);\n        @include transition (0.5s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n    }\n\n    .nav-open{\n        .main-panel{\n            position: absolute;\n            left: 0;\n            @include transform-translate-3d(-260px);\n            @include transition (0.5s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n        }\n\n        .sidebar{\n            @include transform-translate-3d(0px);\n            @include transition (0.5s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n        }\n    }\n\n    .main-panel{\n        // @include transform-translate-3d(0px);\n        @include transition (0.5s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n    }\n\n    .menu-on-left{\n        .sidebar{\n            left: 0 !important;\n            right: auto;\n            @include transform-translate-3d(-260px);\n            @include transition (0.5s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n        }\n        .main-panel{\n            @include transform-translate-3d(0px);\n            @include transition (0.5s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n        }\n    }\n\n        .nav-open{\n            .menu-on-left{\n                .main-panel{\n                    position: absolute;\n                    left: 0;\n                    @include transform-translate-3d(260px);\n                    @include transition (0.5s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n                }\n\n                .sidebar{\n                    @include transform-translate-3d(0px);\n                    @include transition (0.5s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n                }\n            }\n        }\n\n\n\n    .nav-item.active-pro{\n        position: relative !important;\n    }\n\n    .nav-mobile-menu{\n        border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n        margin-bottom: 15px;\n        padding-bottom: 15px;\n        padding-top: 5px;\n\n        .dropdown{\n            .dropdown-menu{\n                position: static !important;\n                float: none;\n                width: auto;\n                color: $white-color;\n                margin-top: 0;\n                background-color: transparent;\n                border: 0;\n                -webkit-box-shadow: none;\n                box-shadow: none;\n                transform: translate3d(0px, 0px, 0px) !important;\n                @include transition (0.5s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n\n                .dropdown-item{\n                    margin: 5px 15px 0px 20px;\n                    border-radius: 4px;\n                    color: $white-color;\n                    opacity: .86;\n                    padding: 8px 50px;\n                    &:hover{\n                        background-color: rgba(255, 255, 255, 0.23)\n                    }\n                    .nc-icon{\n                        margin-left: -40px;\n                    }\n                }\n            }\n\n        }\n        .nav-item{\n            .nav-link{\n                span{\n                    display: inline-block !important;\n                }\n                .no-icon{\n                    padding-left: 50px;\n                }\n            }\n        }\n    }\n    .main-panel{\n        width: 100%;\n    }\n\n    .navbar-brand{\n        padding: 15px 0px;\n    }\n    .navbar-transparent{\n        padding-top: 15px;\n        // background-color: rgba(0, 0, 0, 0.45);\n    }\n    body {\n         position: relative;\n    }\n    .wrapper{\n       left: 0;\n       background-color: white;\n    }\n    .navbar .container{\n        left: 15px;\n        width: 100%;\n        position: relative;\n        top: -10px;\n    }\n\n    .navbar-nav{\n        .nav-item{\n            float: none;\n            position: relative;\n            display: block;\n        }\n    }\n\n    body > .navbar-collapse {\n        position: fixed;\n        display: block;\n        top: 0;\n        height: 100%;\n        right: 0;\n        left: auto;\n        z-index: 1032;\n        visibility: visible;\n        background-color: #999;\n        overflow-y: visible;\n        border-top: none;\n        text-align: left;\n        padding: 0;\n\n        @include transform-translate-x(260px);\n        @include transition (0.33s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n        > ul {\n            position: relative;\n            z-index: 4;\n            overflow-y:scroll;\n            height: calc(100vh - 61px);\n            width: 100%;\n        }\n\n        &::before{\n            top: 0;\n            left: 0;\n            height: 100%;\n            width: 100%;\n            position: absolute;\n            background-color: #282828;\n            display: block;\n            content: \"\";\n            z-index: 1;\n        }\n\n        .logo{\n            position: relative;\n            z-index: 4;\n        }\n\n        .nav li > a{\n            padding: 10px 15px;\n        }\n    }\n    .nav-show .navbar-collapse{\n        @include transform-translate-x(0px);\n    }\n    .nav-show .navbar .container{\n        left: -250px;\n    }\n    .nav-show .wrapper{\n        left: 0;\n        @include transform-translate-x(-260px);\n    }\n    .navbar-toggle .icon-bar {\n          display: block;\n          position: relative;\n          background: #fff;\n          width: 24px;\n          height: 2px;\n          border-radius: 1px;\n          margin: 0 auto;\n    }\n\n    .navbar-header .navbar-toggle {\n        margin: 10px 15px 10px 0;\n        width: 40px;\n        height: 40px;\n    }\n    .bar1,\n    .bar2,\n    .bar3 {\n      outline: 1px solid transparent;\n    }\n    .bar1 {\n      top: 0px;\n      @include bar-animation($topbar-back);\n    }\n    .bar2 {\n      opacity: 1;\n    }\n    .bar3 {\n      bottom: 0px;\n      @include bar-animation($bottombar-back);\n    }\n    .toggled .bar1 {\n      top: 6px;\n      @include bar-animation($topbar-x);\n    }\n    .toggled .bar2 {\n      opacity: 0;\n    }\n    .toggled .bar3 {\n      bottom: 6px;\n      @include bar-animation($bottombar-x);\n    }\n\n    @include topbar-x-rotation();\n    @include topbar-back-rotation();\n    @include bottombar-x-rotation();\n    @include bottombar-back-rotation();\n\n    @-webkit-keyframes fadeIn {\n      0% {opacity: 0;}\n      100% {opacity: 1;}\n    }\n    @-moz-keyframes fadeIn {\n      0% {opacity: 0;}\n      100% {opacity: 1;}\n    }\n    @keyframes fadeIn {\n      0% {opacity: 0;}\n      100% {opacity: 1;}\n    }\n\n    .dropdown-menu .divider{\n        background-color: rgba(229, 229, 229, 0.15);\n    }\n\n    .navbar-nav {\n        margin: 1px 0;\n\n        .show .dropdown-menu .nav-item{\n            .nav-link{\n                padding: 10px 15px 10px 60px;\n            }\n        }\n    }\n\n    [class*=\"navbar-\"] .navbar-nav {\n        & > li > a,\n        > li > a:hover,\n        > li > a:focus,\n        .active > a,\n        .active > a:hover,\n        .active > a:focus,\n        .show .dropdown-menu > li > a,\n        .show .dropdown-menu > li > a:hover,\n        .show .dropdown-menu > li > a:focus,\n        .show .dropdown-menu > li > a:active {\n            color: white;\n        }\n\n        & > li > a,\n        > li > a:hover,\n        > li > a:focus{\n            opacity: .7;\n            background-color: transparent;\n            outline: none;\n        }\n\n        .show .dropdown-menu > li > a:hover,\n        .show .dropdown-menu > li > a:focus{\n            background-color: rgba(255,255,255, .1);\n        }\n\n\n\n        &.navbar-nav .show .dropdown-menu > li > a:active {\n            opacity: 1;\n        }\n\n        & .dropdown > a{\n            &:hover .caret {\n                border-bottom-color: #fff;\n                border-top-color: #fff;\n            }\n            &:active .caret {\n                border-bottom-color: white;\n                border-top-color: white;\n            }\n        }\n\n    }\n\n    .dropdown-menu {\n        display: none;\n    }\n    .navbar-fixed-top {\n        -webkit-backface-visibility: hidden;\n    }\n    #bodyClick {\n        height: 100%;\n        width: 100%;\n        position: fixed;\n        opacity: 0;\n        top: 0;\n        left: auto;\n        right: 250px;\n        content: \"\";\n        z-index: 9999;\n        overflow-x: hidden;\n    }\n\n    .social-line .btn{\n        margin: $margin-bottom;\n    }\n    .subscribe-line .form-control{\n        margin: $margin-bottom;\n    }\n    .social-line.pull-right{\n        float: none;\n    }\n    .social-area.pull-right{\n        float: none !important;\n    }\n    .form-control + .form-control-feedback{\n        margin-top: -8px;\n    }\n    .navbar-toggle:hover,.navbar-toggle:focus {\n        background-color: transparent !important;\n    }\n    .btn.dropdown-toggle{\n        margin-bottom: 0;\n    }\n    .media-post .author{\n        width: 20%;\n        float: none !important;\n        display: block;\n        margin: 0 auto 10px;\n    }\n    .media-post .media-body{\n        width: 100%;\n    }\n\n    .navbar-collapse.collapse.in {\n        display: block;\n    }\n    .navbar-header .collapse, .navbar-toggle {\n        display:block !important;\n    }\n    .navbar-header {\n        float:none;\n    }\n    .navbar-nav .show .dropdown-menu {\n        position: static;\n        float: none;\n        width: auto;\n        margin-top: 0;\n        background-color: transparent;\n        border: 0;\n        -webkit-box-shadow: none;\n        box-shadow: none;\n    }\n    .navbar-collapse{\n        .navbar-nav p{\n            line-height: 40px !important;\n            margin: 0;\n        }\n\n        [class^=\"pe-7s-\"]{\n            float: left;\n            font-size: 20px;\n            margin-right: 10px;\n        }\n    }\n}\n\n//overwrite table responsive for 768px screens\n\n@media (min-width: 992px){\n    .table-full-width{\n        margin-left: -15px;\n        margin-right: -15px;\n    }\n    .table-responsive{\n        overflow: visible;\n    }\n\n}\n\n@media (max-width: 991px){\n    .table-responsive {\n        width: 100%;\n        margin-bottom: 15px;\n        overflow-x: scroll;\n        overflow-y: hidden;\n        -ms-overflow-style: -ms-autohiding-scrollbar;\n        -webkit-overflow-scrolling: touch;\n    }\n\n    .close-layer{\n        height: 100%;\n        width: 100%;\n        position: absolute;\n        opacity: 0;\n        top: 0;\n        left: auto;\n\n        content: \"\";\n        z-index: 9999;\n        overflow-x: hidden;\n        background-color: rgba(0,0,0,.35);\n\n        @include transition($slow-transition-time, $transition-ease-in);\n\n        &.visible{\n            opacity: 1;\n        }\n    }\n}\n\n@media (max-width: 768px){\n    .main-panel{\n        .navbar.navbar-fixed{\n            width: 100% !important;\n        }\n\n        .typo-line{\n            padding-left: 80px;\n        }\n        .slider-success.noUi-target{\n            margin-bottom: 15px;\n        }\n    }\n\n    .card{\n        .card-body{\n            .control-label{\n                text-align: left;\n            }\n        }\n    }\n}\n",".bootstrap-switch {\n  display: inline-block;\n  direction: ltr;\n  cursor: pointer;\n  border-radius: 30px;\n  border: 0;\n  position: relative;\n  text-align: left;\n  overflow: hidden;\n  margin-bottom: 5px;\n  line-height: 8px;\n  width: 61px !important;\n  height: 26px;\n  outline: none;\n  z-index: 0;\n  margin-right: 1px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  vertical-align: middle;\n  -webkit-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\n  transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\n}\n\n.bootstrap-switch .bootstrap-switch-container {\n  display: inline-flex;\n  top: 0;\n  height: 26px;\n  border-radius: 4px;\n  -webkit-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0);\n  width: 100px !important;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on,\n.bootstrap-switch .bootstrap-switch-handle-off,\n.bootstrap-switch .bootstrap-switch-label {\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    box-sizing: border-box;\n    cursor: pointer;\n    display: inline-block !important;\n    height: 100%;\n    color: #fff;\n    padding: 6px 10px;\n    font-size: 11px;\n    text-indent: -5px;\n    line-height: 15px;\n    -webkit-transition: 0.25s ease-out;\n    transition: 0.25s ease-out;\n\n    i{\n        font-size: 12px;\n        line-height: 14px;\n  }\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on,\n.bootstrap-switch .bootstrap-switch-handle-off {\n  text-align: center;\n  z-index: 1;\n  float: left;\n  width: 50% !important;\n  background-color: $info-color;\n}\n\n\n.bootstrap-switch .bootstrap-switch-label {\n  text-align: center;\n  z-index: 100;\n  color: #333333;\n  background: #ffffff;\n  width: 22px !important;\n  height: 22px;\n  margin: 2px -11px;\n  border-radius: 12px;\n  position: relative;\n  float: left;\n  padding: 0;\n  background-color: #FFFFFF;\n  box-shadow: 0 1px 1px #FFFFFF inset, 0 1px 1px rgba(0, 0, 0, 0.25);\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on {\n  border-bottom-left-radius: 3px;\n  border-top-left-radius: 3px;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-off {\n  text-indent: 6px;\n}\n\n.bootstrap-switch input[type='radio'],\n.bootstrap-switch input[type='checkbox'] {\n  position: absolute !important;\n  top: 0;\n  left: 0;\n  opacity: 0;\n  filter: alpha(opacity=0);\n  z-index: -1;\n}\n\n\n.bootstrap-switch.bootstrap-switch-animate .bootstrap-switch-container {\n  -webkit-transition: margin-left 0.5s;\n  transition: margin-left 0.5s;\n}\n\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-container {\n  margin-left: -2px !important;\n}\n\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-container {\n  margin-left: -37px !important;\n}\n\n.bootstrap-switch.bootstrap-switch-on:hover .bootstrap-switch-label {\n  width: 26px !important;\n  margin: 2px -15px;\n}\n\n.bootstrap-switch.bootstrap-switch-off:hover .bootstrap-switch-label {\n  width: 26px !important;\n  margin: 2px -15px -13px -11px;\n}\n\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-danger  {\n  background-color: $color-red;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-warning  {\n  background-color: $color-orange;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-success  {\n  background-color: $color-green;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-primary  {\n  background-color: $color-blue;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-info  {\n  background-color: $color-azure;\n}\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-default  {\n  background-color: $color-black;\n}\n\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-danger,\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-primary,\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-info,\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-warning,\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-success {\n  background-color: #cfcfca;\n}\n","/*--------------------------------\n\nnucleo-icons Web Font - built using nucleoapp.com\nLicense - nucleoapp.com/license/\n\n-------------------------------- */\n@font-face {\n  font-family: 'nucleo-icons';\n  src: url('~assets/fonts/nucleo-icons.eot');\n  src: url('~assets/fonts/nucleo-icons.eot') format('embedded-opentype'), url('~assets/fonts/nucleo-icons.woff2') format('woff2'), url('~assets/fonts/nucleo-icons.woff') format('woff'), url('~assets/fonts/nucleo-icons.ttf') format('truetype'), url('~assets/fonts/nucleo-icons.svg') format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n/*------------------------\n\tbase class definition\n-------------------------*/\n.nc-icon {\n  display: inline-block;\n  font: normal normal normal 14px/1 'nucleo-icons';\n  font-size: inherit;\n  speak: none;\n  text-transform: none;\n  /* Better Font Rendering */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n\n  &.icon-bold{\n    font-weight: 700;\n  }\n}\n/*------------------------\n  change icon size\n-------------------------*/\n.nc-icon.lg {\n  font-size: 1.33333333em;\n  vertical-align: -16%;\n}\n.nc-icon.x2 {\n  font-size: 2em;\n}\n.nc-icon.x3 {\n  font-size: 3em;\n}\n/*----------------------------------\n  add a square/circle background\n-----------------------------------*/\n.nc-icon.square,\n.nc-icon.circle {\n  padding: 0.33333333em;\n  vertical-align: -16%;\n  background-color: #eee;\n}\n.nc-icon.circle {\n  border-radius: 50%;\n}\n/*------------------------\n  list icons\n-------------------------*/\n.nc-icon-ul {\n  padding-left: 0;\n  margin-left: 2.14285714em;\n  list-style-type: none;\n}\n.nc-icon-ul > li {\n  position: relative;\n}\n.nc-icon-ul > li > .nc-icon {\n  position: absolute;\n  left: -1.57142857em;\n  top: 0.14285714em;\n  text-align: center;\n}\n.nc-icon-ul > li > .nc-icon.lg {\n  top: 0;\n  left: -1.35714286em;\n}\n.nc-icon-ul > li > .nc-icon.circle,\n.nc-icon-ul > li > .nc-icon.square {\n  top: -0.19047619em;\n  left: -1.9047619em;\n}\n\n.all-icons{\n    .font-icon-list{\n        .font-icon-detail i{\n            font-size: 32px;\n        }\n    }\n}\n/*------------------------\n  spinning icons\n-------------------------*/\n.nc-icon.spin {\n  -webkit-animation: nc-icon-spin 2s infinite linear;\n  -moz-animation: nc-icon-spin 2s infinite linear;\n  animation: nc-icon-spin 2s infinite linear;\n}\n@-webkit-keyframes nc-icon-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n@-moz-keyframes nc-icon-spin {\n  0% {\n    -moz-transform: rotate(0deg);\n  }\n  100% {\n    -moz-transform: rotate(360deg);\n  }\n}\n@keyframes nc-icon-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n/*------------------------\n  rotated/flipped icons\n-------------------------*/\n.nc-icon.rotate-90 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);\n  -webkit-transform: rotate(90deg);\n  -moz-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n  -o-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n.nc-icon.rotate-180 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n  -webkit-transform: rotate(180deg);\n  -moz-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  -o-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n.nc-icon.rotate-270 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);\n  -webkit-transform: rotate(270deg);\n  -moz-transform: rotate(270deg);\n  -ms-transform: rotate(270deg);\n  -o-transform: rotate(270deg);\n  transform: rotate(270deg);\n}\n.nc-icon.flip-y {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=0);\n  -webkit-transform: scale(-1, 1);\n  -moz-transform: scale(-1, 1);\n  -ms-transform: scale(-1, 1);\n  -o-transform: scale(-1, 1);\n  transform: scale(-1, 1);\n}\n.nc-icon.flip-x {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n  -webkit-transform: scale(1, -1);\n  -moz-transform: scale(1, -1);\n  -ms-transform: scale(1, -1);\n  -o-transform: scale(1, -1);\n  transform: scale(1, -1);\n}\n/*------------------------\n\tfont icons\n-------------------------*/\n\n.nc-air-baloon::before {\n    content: \"\\ea01\";\n}\n\n.nc-album-2::before {\n    content: \"\\ea02\";\n}\n\n.nc-alien-33::before {\n    content: \"\\ea03\";\n}\n\n.nc-align-center::before {\n    content: \"\\ea04\";\n}\n\n.nc-align-left-2::before {\n    content: \"\\ea05\";\n}\n\n.nc-ambulance::before {\n    content: \"\\ea06\";\n}\n\n.nc-android::before {\n    content: \"\\ea07\";\n}\n\n.nc-app::before {\n    content: \"\\ea08\";\n}\n\n.nc-apple::before {\n    content: \"\\ea09\";\n}\n\n.nc-atom::before {\n    content: \"\\ea0a\";\n}\n\n.nc-attach-87::before {\n    content: \"\\ea0b\";\n}\n\n.nc-audio-92::before {\n    content: \"\\ea0c\";\n}\n\n.nc-backpack::before {\n    content: \"\\ea0d\";\n}\n\n.nc-badge::before {\n    content: \"\\ea0e\";\n}\n\n.nc-bag::before {\n    content: \"\\ea0f\";\n}\n\n.nc-bank::before {\n    content: \"\\ea10\";\n}\n\n.nc-battery-81::before {\n    content: \"\\ea11\";\n}\n\n.nc-bell-55::before {\n    content: \"\\ea12\";\n}\n\n.nc-bold::before {\n    content: \"\\ea13\";\n}\n\n.nc-bulb-63::before {\n    content: \"\\ea14\";\n}\n\n.nc-bullet-list-67::before {\n    content: \"\\ea15\";\n}\n\n.nc-bus-front-12::before {\n    content: \"\\ea16\";\n}\n\n.nc-button-pause::before {\n    content: \"\\ea17\";\n}\n\n.nc-button-play::before {\n    content: \"\\ea18\";\n}\n\n.nc-button-power::before {\n    content: \"\\ea19\";\n}\n\n.nc-camera-20::before {\n    content: \"\\ea1a\";\n}\n\n.nc-caps-small::before {\n    content: \"\\ea1b\";\n}\n\n.nc-cart-simple::before {\n    content: \"\\ea1c\";\n}\n\n.nc-cctv::before {\n    content: \"\\ea1d\";\n}\n\n.nc-chart-bar-32::before {\n    content: \"\\ea1e\";\n}\n\n.nc-chart-pie-35::before {\n    content: \"\\ea1f\";\n}\n\n.nc-chart-pie-36::before {\n    content: \"\\ea20\";\n}\n\n.nc-chart::before {\n    content: \"\\ea21\";\n}\n\n.nc-chat-round::before {\n    content: \"\\ea22\";\n}\n\n.nc-check-2::before {\n    content: \"\\ea23\";\n}\n\n.nc-circle-09::before {\n    content: \"\\ea24\";\n}\n\n.nc-circle::before {\n    content: \"\\ea25\";\n}\n\n.nc-cloud-download-93::before {\n    content: \"\\ea26\";\n}\n\n.nc-cloud-upload-94::before {\n    content: \"\\ea27\";\n}\n\n.nc-compass-05::before {\n    content: \"\\ea28\";\n}\n\n.nc-controller-modern::before {\n    content: \"\\ea29\";\n}\n\n.nc-credit-card::before {\n    content: \"\\ea2a\";\n}\n\n.nc-delivery-fast::before {\n    content: \"\\ea2b\";\n}\n\n.nc-email-83::before {\n    content: \"\\ea2c\";\n}\n\n.nc-email-85::before {\n    content: \"\\ea2d\";\n}\n\n.nc-explore-2::before {\n    content: \"\\ea2e\";\n}\n\n.nc-fav-remove::before {\n    content: \"\\ea2f\";\n}\n\n.nc-favourite-28::before {\n    content: \"\\ea30\";\n}\n\n.nc-globe-2::before {\n    content: \"\\ea31\";\n}\n\n.nc-grid-45::before {\n    content: \"\\ea32\";\n}\n\n.nc-headphones-2::before {\n    content: \"\\ea33\";\n}\n\n.nc-html5::before {\n    content: \"\\ea34\";\n}\n\n.nc-istanbul::before {\n    content: \"\\ea35\";\n}\n\n.nc-key-25::before {\n    content: \"\\ea36\";\n}\n\n.nc-layers-3::before {\n    content: \"\\ea37\";\n}\n\n.nc-light-3::before {\n    content: \"\\ea38\";\n}\n\n.nc-lock-circle-open::before {\n    content: \"\\ea39\";\n}\n\n.nc-map-big::before {\n    content: \"\\ea3a\";\n}\n\n.nc-mobile::before {\n    content: \"\\ea3c\";\n}\n\n.nc-money-coins::before {\n    content: \"\\ea3b\";\n}\n\n.nc-note-03::before {\n    content: \"\\ea3d\";\n}\n\n.nc-notes::before {\n    content: \"\\ea3e\";\n}\n\n.nc-notification-70::before {\n    content: \"\\ea3f\";\n}\n\n.nc-palette::before {\n    content: \"\\ea40\";\n}\n\n.nc-paper-2::before {\n    content: \"\\ea41\";\n}\n\n.nc-pin-3::before {\n    content: \"\\ea42\";\n}\n\n.nc-planet::before {\n    content: \"\\ea43\";\n}\n\n.nc-preferences-circle-rotate::before {\n    content: \"\\ea44\";\n}\n\n.nc-puzzle-10::before {\n    content: \"\\ea45\";\n}\n\n.nc-quote::before {\n    content: \"\\ea46\";\n}\n\n.nc-refresh-02::before {\n    content: \"\\ea47\";\n}\n\n.nc-ruler-pencil::before {\n    content: \"\\ea48\";\n}\n\n.nc-satisfied::before {\n    content: \"\\ea49\";\n}\n\n.nc-scissors::before {\n    content: \"\\ea4a\";\n}\n\n.nc-send::before {\n    content: \"\\ea4b\";\n}\n\n.nc-settings-90::before {\n    content: \"\\ea4c\";\n}\n\n.nc-settings-gear-64::before {\n    content: \"\\ea4d\";\n}\n\n.nc-settings-tool-66::before {\n    content: \"\\ea4e\";\n}\n\n.nc-simple-add::before {\n    content: \"\\ea4f\";\n}\n\n.nc-simple-delete::before {\n    content: \"\\ea50\";\n}\n\n.nc-simple-remove::before {\n    content: \"\\ea51\";\n}\n\n.nc-single-02::before {\n    content: \"\\ea52\";\n}\n\n.nc-single-copy-04::before {\n    content: \"\\ea53\";\n}\n\n.nc-spaceship::before {\n    content: \"\\ea54\";\n}\n\n.nc-square-pin::before {\n    content: \"\\ea55\";\n}\n\n.nc-stre-down::before {\n    content: \"\\ea56\";\n}\n\n.nc-stre-left::before {\n    content: \"\\ea57\";\n}\n\n.nc-stre-right::before {\n    content: \"\\ea58\";\n}\n\n.nc-stre-up::before {\n    content: \"\\ea59\";\n}\n\n.nc-sun-fog-29::before {\n    content: \"\\ea5a\";\n}\n\n.nc-support-17::before {\n    content: \"\\ea5b\";\n}\n\n.nc-tablet-2::before {\n    content: \"\\ea5c\";\n}\n\n.nc-tag-content::before {\n    content: \"\\ea5d\";\n}\n\n.nc-tap-01::before {\n    content: \"\\ea5e\";\n}\n\n.nc-time-alarm::before {\n    content: \"\\ea5f\";\n}\n\n.nc-tv-2::before {\n    content: \"\\ea60\";\n}\n\n.nc-umbrella-13::before {\n    content: \"\\ea61\";\n}\n\n.nc-vector::before {\n    content: \"\\ea62\";\n}\n\n.nc-watch-time::before {\n    content: \"\\ea63\";\n}\n\n.nc-zoom-split::before {\n    content: \"\\ea64\";\n}\n\n\n/* all icon font classes list here */\n","\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n// This file was modified by Creative Tim to keep only the animation that we need for Bootstrap Notify\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n@charset \"UTF-8\";\n\n/*!\nAnimate.css - http://daneden.me/animate\nLicensed under the MIT license - http://opensource.org/licenses/MIT\n\nCopyright (c) 2015 Daniel Eden\n*/\n\n.animated {\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n.animated.infinite {\n  -webkit-animation-iteration-count: infinite;\n  animation-iteration-count: infinite;\n}\n\n.animated.hinge {\n  -webkit-animation-duration: 2s;\n  animation-duration: 2s;\n}\n\n.animated.bounceIn,\n.animated.bounceOut {\n  -webkit-animation-duration: .75s;\n  animation-duration: .75s;\n}\n\n.animated.flipOutX,\n.animated.flipOutY {\n  -webkit-animation-duration: .75s;\n  animation-duration: .75s;\n}\n\n@-webkit-keyframes shake {\n  from, to {\n    -webkit-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n  }\n\n  10%, 30%, 50%, 70%, 90% {\n    -webkit-transform: translate3d(-10px, 0, 0);\n    transform: translate3d(-10px, 0, 0);\n  }\n\n  20%, 40%, 60%, 80% {\n    -webkit-transform: translate3d(10px, 0, 0);\n    transform: translate3d(10px, 0, 0);\n  }\n}\n\n@keyframes shake {\n  from, to {\n    -webkit-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n  }\n\n  10%, 30%, 50%, 70%, 90% {\n    -webkit-transform: translate3d(-10px, 0, 0);\n    transform: translate3d(-10px, 0, 0);\n  }\n\n  20%, 40%, 60%, 80% {\n    -webkit-transform: translate3d(10px, 0, 0);\n    transform: translate3d(10px, 0, 0);\n  }\n}\n\n.shake {\n  -webkit-animation-name: shake;\n  animation-name: shake;\n}\n\n\n\n@-webkit-keyframes fadeInDown {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n@keyframes fadeInDown {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n.fadeInDown {\n  -webkit-animation-name: fadeInDown;\n  animation-name: fadeInDown;\n}\n\n\n@-webkit-keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n  }\n}\n\n@keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n  }\n}\n\n.fadeOut {\n  -webkit-animation-name: fadeOut;\n  animation-name: fadeOut;\n}\n\n@-webkit-keyframes fadeOutDown {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 100%, 0);\n    transform: translate3d(0, 100%, 0);\n  }\n}\n\n@keyframes fadeOutDown {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 100%, 0);\n    transform: translate3d(0, 100%, 0);\n  }\n}\n\n.fadeOutDown {\n  -webkit-animation-name: fadeOutDown;\n  animation-name: fadeOutDown;\n}\n\n@-webkit-keyframes fadeOutUp {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n}\n\n@keyframes fadeOutUp {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n}\n\n.fadeOutUp {\n  -webkit-animation-name: fadeOutUp;\n  animation-name: fadeOutUp;\n}\n\n","// SweetAlert\n// github.com/limonte/sweetalert2\n\n.sweet-overlay {\n  background-color: rgba(0, 0, 0, 0.4);\n  position: fixed;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  display: none;\n  z-index: 1000; }\n\n.sweet-alert {\n  background-color: #fff;\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  border-radius: 5px;\n  box-sizing: border-box;\n  text-align: center;\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  margin-top: -200px;\n  max-height: 90%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  display: none;\n  z-index: 2000;\n\n  &:focus{\n      outline: 0;\n  }\n\n  button{\n      margin: 0 5px;\n  }\n\n  .form-control{\n      max-width: 300px;\n      margin: 0 auto;\n  }\n}\n  .sweet-alert h2 {\n    color: #575757;\n    text-align: center;\n    text-transform: none;\n    position: relative;\n    padding: 0;\n    display: block;\n}\n  .sweet-alert p {\n    text-align: center;\n    position: relative;\n    float: none;\n    margin: 0;\n    padding: 0;\n}\n  .sweet-alert hr {\n    height: 5px;\n    color: transparent;\n    border: 0;\n}\n  .sweet-alert button.styled {\n    color: #fff;\n    border: 0;\n    box-shadow: none;\n    font-size: 17px;\n    font-weight: 500;\n    border-radius: 5px;\n    padding: 10px 32px;\n    margin: 0 5px;\n    cursor: pointer; }\n    .sweet-alert button.styled:focus {\n      outline: none; }\n    .sweet-alert button.styled.sweet-cancel[disabled] {\n      opacity: .4; }\n    .sweet-alert button.styled.sweet-confirm[disabled] {\n      border: 4px solid transparent;\n      border-color: transparent;\n      width: 40px;\n      height: 40px;\n      padding: 0;\n      margin: 0 30px;\n      vertical-align: middle;\n      background-color: transparent !important;\n      color: transparent;\n      cursor: default;\n      border-radius: 100%;\n      -webkit-animation: rotate-loading 1.5s linear 0s infinite normal;\n              animation: rotate-loading 1.5s linear 0s infinite normal; }\n    .sweet-alert button.styled::-moz-focus-inner {\n      border: 0; }\n  .sweet-alert[data-has-cancel-button=false] button {\n    box-shadow: none !important; }\n  .sweet-alert .icon {\n    width: 80px;\n    height: 80px;\n    border: 4px solid #808080;\n    border-radius: 50%;\n    margin: 20px auto;\n    padding: 0;\n    position: relative;\n    box-sizing: content-box; }\n    .sweet-alert .icon.error {\n      border-color: #f27474; }\n      .sweet-alert .icon.error .x-mark {\n        position: relative;\n        display: block; }\n      .sweet-alert .icon.error .line {\n        position: absolute;\n        height: 5px;\n        width: 47px;\n        // background-color: $color-red;\n        display: block;\n        top: 37px;\n        border-radius: 2px; }\n        .sweet-alert .icon.error .line.left {\n          -webkit-transform: rotate(45deg);\n                  transform: rotate(45deg);\n          left: 17px; }\n        .sweet-alert .icon.error .line.right {\n          -webkit-transform: rotate(-45deg);\n                  transform: rotate(-45deg);\n          right: 16px; }\n    .sweet-alert .icon.warning {\n      border-color: #f8bb86; }\n      .sweet-alert .icon.warning .body {\n        position: absolute;\n        width: 5px;\n        height: 47px;\n        left: 50%;\n        top: 10px;\n        border-radius: 2px;\n        margin-left: -2px;\n        background-color: #f8bb86; }\n      .sweet-alert .icon.warning .dot {\n        position: absolute;\n        width: 7px;\n        height: 7px;\n        border-radius: 50%;\n        margin-left: -3px;\n        left: 50%;\n        bottom: 10px;\n        background-color: #f8bb86; }\n    .sweet-alert .icon.info {\n      border-color: #c9dae1; }\n      .sweet-alert .icon.info::before {\n        content: '';\n        position: absolute;\n        width: 5px;\n        height: 29px;\n        left: 50%;\n        bottom: 17px;\n        border-radius: 2px;\n        margin-left: -2px;\n        background-color: #c9dae1; }\n      .sweet-alert .icon.info::after {\n        content: '';\n        position: absolute;\n        width: 7px;\n        height: 7px;\n        border-radius: 50%;\n        margin-left: -3px;\n        top: 19px;\n        background-color: #c9dae1; }\n    .sweet-alert .icon.success {\n      border-color: #a5dc86;\n    }\n      .sweet-alert .icon.success::before, .sweet-alert .icon.success::after {\n        content: '';\n        border-radius: 50%;\n        position: absolute;\n        width: 60px;\n        height: 120px;\n        background: #fff;\n        -webkit-transform: rotate(45deg);\n                transform: rotate(45deg);\n    }\n      .sweet-alert .icon.success::before {\n        border-radius: 120px 0 0 120px;\n        top: -7px;\n        left: -33px;\n        -webkit-transform: rotate(-45deg);\n                transform: rotate(-45deg);\n        -webkit-transform-origin: 60px 60px;\n                transform-origin: 60px 60px; }\n      .sweet-alert .icon.success::after {\n        border-radius: 0 120px 120px 0;\n        top: -11px;\n        left: 30px;\n        -webkit-transform: rotate(-45deg);\n                transform: rotate(-45deg);\n        -webkit-transform-origin: 0 60px;\n                transform-origin: 0 60px; }\n      .sweet-alert .icon.success .placeholder {\n        width: 80px;\n        height: 80px;\n        border: 4px solid rgba(165, 220, 134, 0.2);\n        border-radius: 50%;\n        box-sizing: content-box;\n        position: absolute;\n        left: -4px;\n        top: -4px;\n        z-index: 2; }\n      .sweet-alert .icon.success .fix {\n        width: 5px;\n        height: 90px;\n        background-color: #fff;\n        position: absolute;\n        left: 28px;\n        top: 8px;\n        z-index: 1;\n        -webkit-transform: rotate(-45deg);\n                transform: rotate(-45deg); }\n      .sweet-alert .icon.success .line {\n        height: 5px;\n        background-color: $color-green;\n        display: block;\n        border-radius: 2px;\n        position: absolute;\n        z-index: 2; }\n        .sweet-alert .icon.success .line.tip {\n          width: 25px;\n          left: 14px;\n          top: 46px;\n          -webkit-transform: rotate(45deg);\n                  transform: rotate(45deg); }\n        .sweet-alert .icon.success .line.long {\n          width: 47px;\n          right: 8px;\n          top: 38px;\n          -webkit-transform: rotate(-45deg);\n                  transform: rotate(-45deg); }\n  .sweet-alert .sweet-image {\n    margin: 20px auto; }\n\n@-webkit-keyframes showSweetAlert {\n  0% {\n    -webkit-transform: scale(0.7);\n            transform: scale(0.7); }\n  45% {\n    -webkit-transform: scale(1.05);\n            transform: scale(1.05); }\n  80% {\n    -webkit-transform: scale(0.95);\n            transform: scale(0.95); }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1); } }\n\n@keyframes showSweetAlert {\n  0% {\n    -webkit-transform: scale(0.7);\n            transform: scale(0.7); }\n  45% {\n    -webkit-transform: scale(1.05);\n            transform: scale(1.05); }\n  80% {\n    -webkit-transform: scale(0.95);\n            transform: scale(0.95); }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1); } }\n\n@-webkit-keyframes hideSweetAlert {\n  0% {\n    -webkit-transform: scale(1);\n            transform: scale(1); }\n  100% {\n    -webkit-transform: scale(0.5);\n            transform: scale(0.5); } }\n\n@keyframes hideSweetAlert {\n  0% {\n    -webkit-transform: scale(1);\n            transform: scale(1); }\n  100% {\n    -webkit-transform: scale(0.5);\n            transform: scale(0.5); } }\n\n.show-sweet-alert {\n  -webkit-animation: showSweetAlert 0.3s;\n          animation: showSweetAlert 0.3s; }\n  .show-sweet-alert.no-animation {\n    -webkit-animation: none;\n            animation: none; }\n\n.hide-sweet-alert {\n  -webkit-animation: hideSweetAlert 0.2s;\n          animation: hideSweetAlert 0.2s; }\n  .hide-sweet-alert.no-animation {\n    -webkit-animation: none;\n            animation: none; }\n\n@-webkit-keyframes animate-success-tip {\n  0% {\n    width: 0;\n    left: 1px;\n    top: 19px; }\n  54% {\n    width: 0;\n    left: 1px;\n    top: 19px; }\n  70% {\n    width: 50px;\n    left: -8px;\n    top: 37px; }\n  84% {\n    width: 17px;\n    left: 21px;\n    top: 48px; }\n  100% {\n    width: 25px;\n    left: 14px;\n    top: 45px; } }\n\n@keyframes animate-success-tip {\n  0% {\n    width: 0;\n    left: 1px;\n    top: 19px; }\n  54% {\n    width: 0;\n    left: 1px;\n    top: 19px; }\n  70% {\n    width: 50px;\n    left: -8px;\n    top: 37px; }\n  84% {\n    width: 17px;\n    left: 21px;\n    top: 48px; }\n  100% {\n    width: 25px;\n    left: 14px;\n    top: 45px; } }\n\n@-webkit-keyframes animate-success-long {\n  0% {\n    width: 0;\n    right: 46px;\n    top: 54px; }\n  65% {\n    width: 0;\n    right: 46px;\n    top: 54px; }\n  84% {\n    width: 55px;\n    right: 0;\n    top: 35px; }\n  100% {\n    width: 47px;\n    right: 8px;\n    top: 38px; } }\n\n@keyframes animate-success-long {\n  0% {\n    width: 0;\n    right: 46px;\n    top: 54px; }\n  65% {\n    width: 0;\n    right: 46px;\n    top: 54px; }\n  84% {\n    width: 55px;\n    right: 0;\n    top: 35px; }\n  100% {\n    width: 47px;\n    right: 8px;\n    top: 38px; } }\n\n@-webkit-keyframes rotatePlaceholder {\n  0% {\n    -webkit-transform: rotate(-45deg);\n            transform: rotate(-45deg); }\n  5% {\n    -webkit-transform: rotate(-45deg);\n            transform: rotate(-45deg); }\n  12% {\n    -webkit-transform: rotate(-405deg);\n            transform: rotate(-405deg); }\n  100% {\n    -webkit-transform: rotate(-405deg);\n            transform: rotate(-405deg); } }\n\n@keyframes rotatePlaceholder {\n  0% {\n    -webkit-transform: rotate(-45deg);\n            transform: rotate(-45deg); }\n  5% {\n    -webkit-transform: rotate(-45deg);\n            transform: rotate(-45deg); }\n  12% {\n    -webkit-transform: rotate(-405deg);\n            transform: rotate(-405deg); }\n  100% {\n    -webkit-transform: rotate(-405deg);\n            transform: rotate(-405deg); } }\n\n.animate-success-tip {\n  -webkit-animation: animate-success-tip 0.75s;\n          animation: animate-success-tip 0.75s; }\n\n.animate-success-long {\n  -webkit-animation: animate-success-long 0.75s;\n          animation: animate-success-long 0.75s; }\n\n.icon.success.animate::after {\n  -webkit-animation: rotatePlaceholder 4.25s ease-in;\n          animation: rotatePlaceholder 4.25s ease-in; }\n\n@-webkit-keyframes animate-error-icon {\n  0% {\n    -webkit-transform: rotateX(100deg);\n            transform: rotateX(100deg);\n    opacity: 0; }\n  100% {\n    -webkit-transform: rotateX(0deg);\n            transform: rotateX(0deg);\n    opacity: 1; } }\n\n@keyframes animate-error-icon {\n  0% {\n    -webkit-transform: rotateX(100deg);\n            transform: rotateX(100deg);\n    opacity: 0; }\n  100% {\n    -webkit-transform: rotateX(0deg);\n            transform: rotateX(0deg);\n    opacity: 1; } }\n\n.animate-error-icon {\n  -webkit-animation: animate-error-icon 0.5s;\n          animation: animate-error-icon 0.5s; }\n\n@-webkit-keyframes animate-x-mark {\n  0% {\n    -webkit-transform: scale(0.4);\n            transform: scale(0.4);\n    margin-top: 26px;\n    opacity: 0; }\n  50% {\n    -webkit-transform: scale(0.4);\n            transform: scale(0.4);\n    margin-top: 26px;\n    opacity: 0; }\n  80% {\n    -webkit-transform: scale(1.15);\n            transform: scale(1.15);\n    margin-top: -6px; }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    margin-top: 0;\n    opacity: 1; } }\n\n@keyframes animate-x-mark {\n  0% {\n    -webkit-transform: scale(0.4);\n            transform: scale(0.4);\n    margin-top: 26px;\n    opacity: 0; }\n  50% {\n    -webkit-transform: scale(0.4);\n            transform: scale(0.4);\n    margin-top: 26px;\n    opacity: 0; }\n  80% {\n    -webkit-transform: scale(1.15);\n            transform: scale(1.15);\n    margin-top: -6px; }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    margin-top: 0;\n    opacity: 1; } }\n\n.animate-x-mark {\n  -webkit-animation: animate-x-mark 0.5s;\n          animation: animate-x-mark 0.5s; }\n\n@-webkit-keyframes pulse-warning {\n  0% {\n    border-color: #f8d486; }\n  100% {\n    border-color: #f8bb86; } }\n\n@keyframes pulse-warning {\n  0% {\n    border-color: #f8d486; }\n  100% {\n    border-color: #f8bb86; } }\n\n.pulse-warning {\n  -webkit-animation: pulse-warning 0.75s infinite alternate;\n          animation: pulse-warning 0.75s infinite alternate; }\n\n@-webkit-keyframes pulse-warning-ins {\n  0% {\n    background-color: #f8d486; }\n  100% {\n    background-color: #f8bb86; } }\n\n@keyframes pulse-warning-ins {\n  0% {\n    background-color: #f8d486; }\n  100% {\n    background-color: #f8bb86; } }\n\n.pulse-warning-ins {\n  -webkit-animation: pulse-warning-ins 0.75s infinite alternate;\n          animation: pulse-warning-ins 0.75s infinite alternate; }\n\n@-webkit-keyframes rotate-loading {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); } }\n\n@keyframes rotate-loading {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); } }\n","svg {\n    touch-action: none;\n}\n\n.jvectormap-container {\n    width: 100%;\n    height: 100%;\n    position: relative;\n    overflow: hidden;\n    touch-action: none;\n}\n\n.jvectormap-tip {\n    position: absolute;\n    display: none;\n    border: solid 1px #CDCDCD;\n    border-radius: 3px;\n    background: #292929;\n    color: white;\n    font-family: sans-serif, Verdana;\n    font-size: smaller;\n    padding: 3px;\n}\n\n.jvectormap-zoomin, .jvectormap-zoomout, .jvectormap-goback {\n    position: absolute;\n    left: 10px;\n    border-radius: 3px;\n    background: #292929;\n    padding: 3px;\n    color: white;\n    cursor: pointer;\n    line-height: 10px;\n    text-align: center;\n    box-sizing: content-box;\n}\n\n.jvectormap-zoomin, .jvectormap-zoomout {\n    width: 10px;\n    height: 10px;\n}\n\n.jvectormap-zoomin {\n    top: 10px;\n}\n\n.jvectormap-zoomout {\n    top: 30px;\n}\n\n.jvectormap-goback {\n    bottom: 10px;\n    z-index: 1000;\n    padding: 6px;\n}\n\n.jvectormap-spinner {\n    position: absolute;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    background: center no-repeat url(data:image/gif;base64,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);\n}\n\n.jvectormap-legend-title {\n    font-weight: bold;\n    font-size: 14px;\n    text-align: center;\n}\n\n.jvectormap-legend-cnt {\n    position: absolute;\n}\n\n.jvectormap-legend-cnt-h {\n    bottom: 0;\n    right: 0;\n}\n\n.jvectormap-legend-cnt-v {\n    top: 0;\n    right: 0;\n}\n\n.jvectormap-legend {\n    background: black;\n    color: white;\n    border-radius: 3px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend {\n    float: left;\n    margin: 0 10px 10px 0;\n    padding: 3px 3px 1px 3px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend .jvectormap-legend-tick {\n    float: left;\n}\n\n.jvectormap-legend-cnt-v .jvectormap-legend {\n    margin: 10px 10px 0 0;\n    padding: 3px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend-tick {\n    width: 40px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend-tick-sample {\n    height: 15px;\n}\n\n.jvectormap-legend-cnt-v .jvectormap-legend-tick-sample {\n    height: 20px;\n    width: 20px;\n    display: inline-block;\n    vertical-align: middle;\n}\n\n.jvectormap-legend-tick-text {\n    font-size: 12px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend-tick-text {\n    text-align: center;\n}\n\n.jvectormap-legend-cnt-v .jvectormap-legend-tick-text {\n    display: inline-block;\n    vertical-align: middle;\n    line-height: 20px;\n    padding-left: 3px;\n}","/**\n * @author zhixin wen <wenzhixin2010@gmail.com>\n * version: 1.8.1\n * https://github.com/wenzhixin/bootstrap-table/\n */\n\n.bootstrap-table .table {\n    margin-bottom: 0 !important;\n    border-bottom: 1px solid #dddddd;\n    border-collapse: collapse !important;\n    border-radius: 1px;\n}\n\n.bootstrap-table .table,\n.bootstrap-table .table > tbody > tr > th,\n.bootstrap-table .table > tfoot > tr > th,\n.bootstrap-table .table > thead > tr > td,\n.bootstrap-table .table > tbody > tr > td,\n.bootstrap-table .table > tfoot > tr > td {\n    padding: 8px !important;\n}\n\n.bootstrap-table .table > tbody > .selected{\n    background-color: $light-blue;\n}\n.bootstrap-table .table.table-no-bordered > thead > tr > th,\n.bootstrap-table .table.table-no-bordered > tbody > tr > td {\n    border-right: 2px solid transparent;\n}\n\n.fixed-table-container {\n    position: relative;\n    clear: both;\n}\n\n.fixed-table-container.table-no-bordered {\n    border: 1px solid transparent;\n}\n\n.fixed-table-footer,\n.fixed-table-header {\n    overflow: hidden;\n}\n\n.fixed-table-footer {\n    border-top: 1px solid #dddddd;\n}\n\n.fixed-table-body {\n    height: 100%;\n    overflow: auto;\n}\n\n.fixed-table-container table {\n    width: 100%;\n}\n\n.fixed-table-container thead th {\n    height: 0;\n    padding: 0;\n    margin: 0;\n}\n\n.fixed-table-container thead th:first-child {\n    border-left: none;\n}\n\n.fixed-table-container thead th .th-inner {\n    padding: 0 8px;\n    line-height: 24px;\n    vertical-align: top;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.fixed-table-container thead th .sortable {\n    cursor: pointer;\n    background-repeat: no-repeat;\n    padding-right: 30px;\n}\n\n.fixed-table-container thead th .both {\n    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAQAAADYWf5HAAAAkElEQVQoz7X QMQ5AQBCF4dWQSJxC5wwax1Cq1e7BAdxD5SL+Tq/QCM1oNiJidwox0355mXnG/DrEtIQ6azioNZQxI0ykPhTQIwhCR+BmBYtlK7kLJYwWCcJA9M4qdrZrd8pPjZWPtOqdRQy320YSV17OatFC4euts6z39GYMKRPCTKY9UnPQ6P+GtMRfGtPnBCiqhAeJPmkqAAAAAElFTkSuQmCC');\n    background-position: right 2px;\n}\n\n.fixed-table-container thead th .asc {\n    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIGNIUk0AAG2YAABzjgAA+swAAIT6AAB5gQAA/RMAADBtAAASKQ0eJk4AAACASURBVHja7NKhDcJQFIbRV1MSEqaoYwYMYyARR6HZowzAHqguUolHYEgxD9MmTYPpA1JEb/KZK476Q4wxfKvwc6x/WKJE3v+nYkc8cfgIwxpXRNQokjBkOLdQ1wlZCrbFbYDdsRmFYYVqAHVdsBiD7dHg8aYGu2l2NmMz9s/YawDpU8qkYQTHqgAAAABJRU5ErkJggg==');\n    background-position: right 5px;\n}\n\n.fixed-table-container thead th .desc {\n    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIGNIUk0AAG2YAABzjgAA+swAAIT6AAB5gQAA/RMAADBtAAASKQ0eJk4AAACFSURBVHja7NKhDcJQFIbRWwMJCVPgmKGGMZCIo9DsAQOwRxWLIPEIDCnmYR4JaSp4DYKQis/8NznqRkopvlWM2Ij9BYY1Wtx7arEpwaZokHo6Yf4xFhGBGrcOdMUqIqIUq3DoYEdUxVgGFzhn6ILl61aMZXCLB3bv+1Bsgj1mg7CfeNrnAMXSyqQtsCNeAAAAAElFTkSuQmCC');\n    background-position: right 0px;\n}\n\n\n.fixed-table-container th.detail {\n    width: 30px;\n}\n\n.fixed-table-container tbody tr:first-child td {\n    border-top: none;\n}\n\n.fixed-table-container tbody td:first-child {\n    border-left: none;\n}\n\n/* the same color with .active */\n.fixed-table-container tbody .selected td {\n    background-color: rgba(245, 245, 245, 0.34);\n}\n\n.fixed-table-container .bs-checkbox {\n    text-align: center;\n}\n\n.fixed-table-container .bs-checkbox .th-inner {\n    padding: 8px 0;\n}\n\n.fixed-table-container input[type=\"radio\"],\n.fixed-table-container input[type=\"checkbox\"] {\n    margin: 0 auto !important;\n    cursor: pointer;\n}\n\n.fixed-table-container .no-records-found {\n    text-align: center;\n    background-color: #FFFFFF !important;\n    height: 340px;\n    border-radius: 10px;\n    width: 100%;\n    vertical-align: middle;\n}\n.fixed-table-container .no-records-found td{\n    font-weight: $font-weight-light;\n    font-size: $font-size-h4;\n}\n.fixed-table-pagination div.pagination,\n.fixed-table-pagination .pagination-detail {\n    margin-top: 10px;\n    margin-bottom: 10px;\n}\n\n.fixed-table-pagination div.pagination .pagination {\n    margin: 0;\n}\n\n.fixed-table-pagination .pagination a {\n    padding: 6px 12px;\n    line-height: 1.428571429;\n}\n\n.fixed-table-pagination .pagination-info {\n    line-height: 34px;\n    margin-right: 5px;\n}\n\n.fixed-table-pagination .btn-group {\n    position: relative;\n    display: inline-block;\n    vertical-align: middle;\n}\n\n.fixed-table-pagination .page-list {\n    display: inline-block;\n}\n\n.fixed-table-toolbar{\n    padding: 5px 15px;\n}\n\n.fixed-table-toolbar .columns-left {\n    margin-right: 5px;\n}\n\n.fixed-table-toolbar .columns-right {\n    margin-left: 5px;\n}\n\n.fixed-table-toolbar .columns .btn{\n    margin: 0 2px;\n    border-radius: $btn-round-radius;\n}\n.fixed-table-toolbar .columns label {\n    display: block;\n    padding: 10px 20px;\n    border-bottom: 1px solid #eee;\n    clear: both;\n    margin-bottom: 0;\n    font-weight: normal;\n    line-height: 1.428571429;\n}\n.fixed-table-toolbar .columns li:last-child label{\n    border-bottom: none;\n}\n\n.fixed-table-toolbar .bars,\n.fixed-table-toolbar .search,\n.fixed-table-toolbar .columns {\n    position: relative;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    line-height: 34px;\n}\n\n.fixed-table-pagination li.disabled a {\n    pointer-events: none;\n    cursor: default;\n}\n\n.fixed-table-loading {\n    display: none;\n    position: absolute;\n    top: 42px;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 99;\n    background-color: #fff;\n    text-align: center;\n}\n\n.fixed-table-body .card-view .title {\n    font-weight: bold;\n    display: inline-block;\n    min-width: 30%;\n    text-align: left !important;\n}\n\n/* support bootstrap 2 */\n.fixed-table-body thead th .th-inner {\n    box-sizing: border-box;\n}\n\n.table th, .table td {\n    vertical-align: middle;\n    box-sizing: border-box;\n}\n\n.fixed-table-toolbar .btn-group > .btn-group {\n    display: inline-block;\n    margin-left: -1px !important;\n}\n\n.fixed-table-toolbar .dropdown-menu label{\n    cursor: pointer;\n}\n\n.fixed-table-toolbar .btn-group > .btn-group > .btn {\n    border-radius: 0;\n}\n\n.fixed-table-toolbar .btn-group > .btn-group:first-child > .btn {\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px;\n}\n\n.fixed-table-toolbar .btn-group > .btn-group:last-child > .btn {\n    border-top-right-radius: 4px;\n    border-bottom-right-radius: 4px;\n}\n\n/* support bootstrap 3 */\n.bootstrap-table .table thead > tr > th {\n    padding: 0;\n    margin: 0;\n}\n\n.pull-right .dropdown-menu {\n    right: 0;\n    left: auto;\n}\n\n/* calculate scrollbar width */\np.fixed-table-scroll-inner {\n    width: 100%;\n    height: 200px;\n}\n\ndiv.fixed-table-scroll-outer {\n    top: 0;\n    left: 0;\n    visibility: hidden;\n    width: 200px;\n    height: 150px;\n    overflow: hidden;\n}\n\n\n.bootstrap-table{\n    .fixed-table-pagination{\n        margin: 0 10px;\n\n        &:after{\n            display: table;\n            content: \"\";\n            clear: both;\n        }\n\n        .page-list{\n            .btn{\n                border-radius: $btn-round-radius;\n            }\n            .btn-group{\n                margin-right: 5px;\n            }\n        }\n        div.pagination,\n        .pagination-detail{\n            margin-top: 15px;\n            margin-bottom: 15px;\n        }\n    }\n\n    .table{\n        &.table-striped > thead > tr > td,\n        &.table-striped > tbody > tr >td,\n        &.table-striped > tfoot > tr >td{\n            border: none;\n        }\n\n    }\n\n}\n","table.dataTable {\n  clear: both;\n  margin-top: 6px !important;\n  margin-bottom: 6px !important;\n  max-width: none !important;\n  border-collapse: separate !important;\n}\ntable.dataTable td,\ntable.dataTable th {\n  -webkit-box-sizing: content-box;\n  -moz-box-sizing: content-box;\n  box-sizing: content-box;\n}\ntable.dataTable td.dataTables_empty,\ntable.dataTable th.dataTables_empty {\n  text-align: center;\n}\ntable.dataTable.nowrap th,\ntable.dataTable.nowrap td {\n  white-space: nowrap;\n}\n\ndiv.dataTables_wrapper div.dataTables_length label {\n  font-weight: normal;\n  text-align: left;\n  white-space: nowrap;\n}\ndiv.dataTables_wrapper div.dataTables_length select {\n  width: 75px;\n  display: inline-block;\n}\ndiv.dataTables_wrapper div.dataTables_filter {\n  text-align: right;\n}\ndiv.dataTables_wrapper div.dataTables_filter label {\n  font-weight: normal;\n  white-space: nowrap;\n  text-align: left;\n}\ndiv.dataTables_wrapper div.dataTables_filter input {\n  margin-left: 0.5em;\n  display: inline-block;\n  width: auto;\n}\ndiv.dataTables_wrapper div.dataTables_info {\n  padding-top: 8px;\n  white-space: nowrap;\n}\ndiv.dataTables_wrapper div.dataTables_paginate {\n  margin: 0;\n  white-space: nowrap;\n  text-align: right;\n}\ndiv.dataTables_wrapper div.dataTables_paginate ul.pagination {\n  margin: 2px 0;\n  white-space: nowrap;\n}\ndiv.dataTables_wrapper div.dataTables_processing {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 200px;\n  margin-left: -100px;\n  margin-top: -26px;\n  text-align: center;\n  padding: 1em 0;\n}\n\ntable.dataTable thead > tr > th.sorting_asc, table.dataTable thead > tr > th.sorting_desc, table.dataTable thead > tr > th.sorting,\ntable.dataTable thead > tr > td.sorting_asc,\ntable.dataTable thead > tr > td.sorting_desc,\ntable.dataTable thead > tr > td.sorting {\n  padding-right: 30px;\n}\ntable.dataTable thead > tr > th:active,\ntable.dataTable thead > tr > td:active {\n  outline: none;\n}\ntable.dataTable thead .sorting,\ntable.dataTable thead .sorting_asc,\ntable.dataTable thead .sorting_desc,\ntable.dataTable thead .sorting_asc_disabled,\ntable.dataTable thead .sorting_desc_disabled {\n  cursor: pointer;\n  position: relative;\n}\ntable.dataTable thead .sorting:after,\ntable.dataTable thead .sorting_asc:after,\ntable.dataTable thead .sorting_desc:after,\ntable.dataTable thead .sorting_asc_disabled:after,\ntable.dataTable thead .sorting_desc_disabled:after {\n  position: absolute;\n  bottom: 8px;\n  right: 8px;\n  display: block;\n  font-family: 'Glyphicons Halflings';\n  opacity: 0.5;\n}\ntable.dataTable thead .sorting:after {\n  opacity: 0.2;\n  content: \"\\e150\";\n  /* sort */\n}\ntable.dataTable thead .sorting_asc:after {\n  content: \"\\e155\";\n  /* sort-by-attributes */\n}\ntable.dataTable thead .sorting_desc:after {\n  content: \"\\e156\";\n  /* sort-by-attributes-alt */\n}\ntable.dataTable thead .sorting_asc_disabled:after,\ntable.dataTable thead .sorting_desc_disabled:after {\n  color: #eee;\n}\n\ndiv.dataTables_scrollHead table.dataTable {\n  margin-bottom: 0 !important;\n}\n\ndiv.dataTables_scrollBody table {\n  border-top: none;\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n}\ndiv.dataTables_scrollBody table thead .sorting:after,\ndiv.dataTables_scrollBody table thead .sorting_asc:after,\ndiv.dataTables_scrollBody table thead .sorting_desc:after {\n  display: none;\n}\ndiv.dataTables_scrollBody table tbody tr:first-child th,\ndiv.dataTables_scrollBody table tbody tr:first-child td {\n  border-top: none;\n}\n\ndiv.dataTables_scrollFoot table {\n  margin-top: 0 !important;\n  border-top: none;\n}\n\n@media screen and (max-width: 767px) {\n  div.dataTables_wrapper div.dataTables_length,\n  div.dataTables_wrapper div.dataTables_filter,\n  div.dataTables_wrapper div.dataTables_info,\n  div.dataTables_wrapper div.dataTables_paginate {\n    text-align: center;\n  }\n}\ntable.dataTable.table-condensed > thead > tr > th {\n  padding-right: 20px;\n}\ntable.dataTable.table-condensed .sorting:after,\ntable.dataTable.table-condensed .sorting_asc:after,\ntable.dataTable.table-condensed .sorting_desc:after {\n  top: 6px;\n  right: 6px;\n}\n\ntable.table-bordered.dataTable th,\ntable.table-bordered.dataTable td {\n  border-left-width: 0;\n}\ntable.table-bordered.dataTable th:last-child, table.table-bordered.dataTable th:last-child,\ntable.table-bordered.dataTable td:last-child,\ntable.table-bordered.dataTable td:last-child {\n  border-right-width: 0;\n}\ntable.table-bordered.dataTable tbody th,\ntable.table-bordered.dataTable tbody td {\n  border-bottom-width: 0;\n}\n\ndiv.dataTables_scrollHead table.table-bordered {\n  border-bottom-width: 0;\n}\n\ndiv.table-responsive > div.dataTables_wrapper > div.row {\n  margin: 0;\n}\ndiv.table-responsive > div.dataTables_wrapper > div.row > div[class^=\"col-\"]:first-child {\n  padding-left: 0;\n}\ndiv.table-responsive > div.dataTables_wrapper > div.row > div[class^=\"col-\"]:last-child {\n  padding-right: 0;\n}\n\n\ntable.dataTable{\n\n    .btn-simple.btn-icon{\n        padding: 3px;\n    }\n\n    thead{\n        .sorting,\n        .sorting_asc,\n        .sorting_desc,\n        .sorting_asc_disabled,\n        .sorting_desc_disabled{\n\n            &:after{\n                position: relative;\n                display: inline-block;\n                bottom: 0px;\n                right: -7px;\n                font-family: 'FontAwesome';\n                opacity: 0.8;\n            }\n\n        }\n\n        .disabled-sorting.sorting,\n        .disabled-sorting.sorting_asc,\n        .disabled-sorting.sorting_desc,\n        .disabled-sorting.sorting_asc_disabled,\n        .disabled-sorting.sorting_desc_disabled{\n                &:after{\n                    display: none;\n                }\n\n        }\n\n        .sorting{\n            &:after{\n                opacity: 0.4;\n                content: \"\\f0dc\";\n            }\n        }\n\n        .sorting_asc{\n            &:after{\n                content: \"\\f0de\";\n                top: 3px;\n            }\n        }\n\n        .sorting_desc{\n            &:after{\n                content: \"\\f0dd\";\n                top: -3px;\n            }\n        }\n    }\n\n    > thead > tr > th,\n    > tbody > tr > th,\n    > tfoot > tr > th,\n    > thead > tr > td,\n    > tbody > tr > td,\n    > tfoot > tr > td{\n        padding: 8px !important;\n        outline: 0;\n    }\n\n    > thead > tr > th{\n        border: none;\n    }\n}\n\n.fresh-datatables{\n    .pagination {\n        > li > a,\n        > li:first-child > a,\n        > li:first-child > span,\n        > li:last-child > a,\n        > li:last-child > span{\n            border-radius: 25px;\n        }\n    }\n}\n\n\n\n.dataTables_paginate{\n    a{\n            outline: 0;\n    }\n}\n\ntable.dataTable.dtr-inline.collapsed {\n    > tbody > tr > td.child,\n    > tbody > tr > th.child,\n    > tbody > tr > td.dataTables_empty{\n        cursor: default !important;\n    }\n\n    > tbody > tr > td.child,\n    > tbody > tr > th.child,\n    > tbody > tr > td.dataTables_empty{\n        &:before{\n            display: none !important;\n        }\n    }\n\n    > tbody > tr > td:first-child,\n    > tbody > tr > th:first-child{\n        position: relative;\n        padding-left: 30px !important;\n        cursor: pointer;\n    }\n\n    > tbody > tr > td:first-child,\n    > tbody > tr > th:first-child{\n        &:before{\n            top: 50%;\n            margin-top: -9px;\n            left: 4px;\n            height: 18px;\n            width: 18px;\n            display: block;\n            position: absolute;\n            color: #518607;\n            border: 0px solid white;\n            border-radius: 14px;\n            box-shadow: 0 0 3px #444;\n            box-sizing: content-box;\n            text-align: center;\n            font-family: 'Courier New', Courier, monospace;\n            line-height: 18px;\n            content: '+';\n            background-color: #FFF;\n        }\n    }\n\n    > tbody > tr.parent > td:first-child,\n    > tbody > tr.parent > th:first-child{\n        &:before{\n            content: '-';\n            color: #ED362C;\n        }\n    }\n\n    > tbody > tr.child td{\n        &:before{\n            display: none;\n        }\n    }\n}\n\n\ntable.dataTable.dtr-inline.collapsed.compact{\n    > tbody > tr > td,\n    > tbody > tr > th{\n        &:first-child{\n            padding-left: 27px;\n        }\n    }\n\n    > tbody > tr > td,\n    > tbody > tr > th{\n        &:first-child:before{\n            top: 5px;\n            left: 4px;\n            height: 14px;\n            width: 14px;\n            border-radius: 14px;\n            line-height: 14px;\n            text-indent: 3px;\n        }\n    }\n}\n\ntable.dataTable.dtr-column{\n    > tbody > tr > td.control,\n    > tbody > tr > th.control{\n        position: relative;\n        cursor: pointer;\n    }\n\n    > tbody > tr > td.control,\n    > tbody > tr > th.control{\n        &:before{\n            top: 50%;\n            left: 50%;\n            height: 16px;\n            width: 16px;\n            margin-top: -10px;\n            margin-left: -10px;\n            display: block;\n            position: absolute;\n            color: white;\n            border: 2px solid white;\n            border-radius: 14px;\n            box-shadow: 0 0 3px #444;\n            box-sizing: content-box;\n            text-align: center;\n            font-family: 'Courier New', Courier, monospace;\n            line-height: 14px;\n            content: '+';\n            background-color: #31b131;\n        }\n    }\n\n    > tbody > tr.parent td.control,\n    > tbody > tr.parent th.control{\n        &:before{\n            content: '-';\n            background-color: #d33333;\n        }\n    }\n}\n\ntable.dataTable{\n    > tbody > tr.child {\n        padding: 0.5em 1em;\n    }\n\n    > tbody > tr.child{\n        &:hover{\n            background: transparent !important;\n        }\n    }\n\n    > tbody > tr.child ul {\n        display: inline-block;\n        list-style-type: none;\n        margin: 0;\n        padding: 0;\n    }\n\n    > tbody > tr.child ul li {\n        border-bottom: 1px solid #efefef;\n        padding: 0.5em 0;\n    }\n\n    > tbody > tr.child ul li{\n        &:first-child{\n            padding-top: 0;\n        }\n    }\n\n    > tbody > tr.child ul li{\n        &:last-child{\n            border-bottom: none;\n        }\n    }\n\n    > tbody > tr.child span.dtr-title {\n        display: inline-block;\n        min-width: 75px;\n        font-weight: bold;\n    }\n}\n\ndiv.dtr-modal {\n    position: fixed;\n    box-sizing: border-box;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    z-index: 100;\n    padding: 10em 1em;\n\n    div.dtr-modal-display {\n        position: absolute;\n        top: 0;\n        left: 0;\n        bottom: 0;\n        right: 0;\n        width: 50%;\n        height: 50%;\n        overflow: auto;\n        margin: auto;\n        z-index: 102;\n        overflow: auto;\n        background-color: #f5f5f7;\n        border: 1px solid black;\n        border-radius: 0.5em;\n        box-shadow: 0 12px 30px rgba(0, 0, 0, 0.6);\n    }\n\n    div.dtr-modal-content {\n        position: relative;\n        padding: 1em;\n    }\n\n    div.dtr-modal-close {\n        position: absolute;\n        top: 6px;\n        right: 6px;\n        width: 22px;\n        height: 22px;\n        border: 1px solid #eaeaea;\n        background-color: #f9f9f9;\n        text-align: center;\n        border-radius: 3px;\n        cursor: pointer;\n        z-index: 12;\n    }\n\n    div.dtr-modal-close{\n        &:hover{\n            background-color: #eaeaea;\n        }\n    }\n\n    div.dtr-modal-background {\n        position: fixed;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        z-index: 101;\n        background: rgba(0, 0, 0, 0.6);\n    }\n}\n\n.data-tables{\n    .pagination{\n        .paginate_button.page-item{\n            &.first,\n            &.previous,\n            &.next,\n            &.last{\n                .page-link{\n                    border-radius: 25px;\n                }\n            }\n        }\n    }\n}\n\n@media screen and (max-width: 767px) {\n    div.dtr-modal div.dtr-modal-display {\n        width: 95%;\n    }\n\n    .data-tables{\n        .pagination{\n            .paginate_button.page-item{\n                &.first,\n                &.last{\n                    display: none;\n                }\n            }\n        }\n    }\n}\n","/*!\n * FullCalendar v3.6.2 Stylesheet\n * Docs & License: https://fullcalendar.io/\n * (c) 2017 Adam Shaw\n */\n\n.fc {\n\tdirection: ltr;\n\ttext-align: left;\n}\n\n.fc-rtl {\n\ttext-align: right;\n}\n\nbody .fc { /* extra precedence to overcome jqui */\n\tfont-size: 1em;\n}\n\n\n/* Colors\n--------------------------------------------------------------------------------------------------*/\n\n.fc-unthemed th,\n.fc-unthemed td,\n.fc-unthemed thead,\n.fc-unthemed tbody,\n.fc-unthemed .fc-divider,\n.fc-unthemed .fc-row,\n.fc-unthemed .fc-popover {\n\tborder-color: #ddd;\n}\n\n.fc-unthemed .fc-popover {\n\tbackground-color: #fff;\n}\n\n.fc-unthemed .fc-divider,\n.fc-unthemed .fc-popover .fc-header {\n\tbackground: #eee;\n}\n\n.fc-unthemed .fc-popover .fc-header .fc-close {\n\tcolor: #666;\n}\n\n.fc-unthemed .fc-today {\n\tbackground: $smoke-bg;\n}\n\n.fc-highlight { /* when user is selecting cells */\n\tbackground: #bce8f1;\n\topacity: .3;\n\tfilter: alpha(opacity=30); /* for IE */\n}\n\n.fc-bgevent { /* default look for background events */\n\tbackground: rgb(143, 223, 130);\n\topacity: .3;\n\tfilter: alpha(opacity=30); /* for IE */\n}\n\n.fc-nonbusiness { /* default look for non-business-hours areas */\n\t/* will inherit .fc-bgevent's styles */\n\tbackground: #d7d7d7;\n}\n\n\n/* Icons (inline elements with styled text that mock arrow icons)\n--------------------------------------------------------------------------------------------------*/\n\n.fc-icon {\n\tdisplay: inline-block;\n\twidth: 1em;\n\theight: 1em;\n\tline-height: 1em;\n\tfont-size: 1em;\n\ttext-align: center;\n\toverflow: hidden;\n\tfont-family: \"Courier New\", Courier, monospace;\n\n\t/* don't allow browser text-selection */\n\t-webkit-touch-callout: none;\n\t-webkit-user-select: none;\n\t-khtml-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none;\n\t}\n\n/*\nAcceptable font-family overrides for individual icons:\n\t\"Arial\", sans-serif\n\t\"Times New Roman\", serif\n\nNOTE: use percentage font sizes or else old IE chokes\n*/\n\n.fc-icon:after {\n\tposition: relative;\n\tmargin: 0 -1em; /* ensures character will be centered, regardless of width */\n}\n\n.fc-icon-left-single-arrow:after {\n\tcontent: \"\\02039\";\n\tfont-weight: bold;\n\tfont-size: 200%;\n\ttop: -7%;\n\tleft: 3%;\n}\n\n.fc-icon-right-single-arrow:after {\n\tcontent: \"\\0203A\";\n\tfont-weight: bold;\n\tfont-size: 200%;\n\ttop: -7%;\n\tleft: -3%;\n}\n\n.fc-icon-left-double-arrow:after {\n\tcontent: \"\\000AB\";\n\tfont-size: 160%;\n\ttop: -7%;\n}\n\n.fc-icon-right-double-arrow:after {\n\tcontent: \"\\000BB\";\n\tfont-size: 160%;\n\ttop: -7%;\n}\n\n.fc-icon-left-triangle:after {\n\tcontent: \"\\25C4\";\n\tfont-size: 125%;\n\ttop: 3%;\n\tleft: -2%;\n}\n\n.fc-icon-right-triangle:after {\n\tcontent: \"\\25BA\";\n\tfont-size: 125%;\n\ttop: 3%;\n\tleft: 2%;\n}\n\n.fc-icon-down-triangle:after {\n\tcontent: \"\\25BC\";\n\tfont-size: 125%;\n\ttop: 2%;\n}\n\n.fc-icon-x:after {\n\tcontent: \"\\000D7\";\n\tfont-size: 200%;\n\ttop: 6%;\n}\n\n\n/* Buttons (styled <button> tags, normalized to work cross-browser)\n--------------------------------------------------------------------------------------------------*/\n\n.fc button {\n\tborder-width: $border-thin;\n    background-color: $transparent-bg;\n    font-weight: $font-weight-normal;\n\n    @include opacity(.8);\n    padding: $padding-base-vertical $padding-base-horizontal;\n\n    border-color: $default-color;\n    color: $default-color;\n\n\n    &:hover,\n    &:focus{\n        @include opacity(1);\n        outline: 0 !important;\n    }\n    &:active,\n    &.active,\n    .open > &.dropdown-toggle {\n         @include box-shadow(none);\n         outline: 0 !important;\n    }\n\n}\n\n/* Firefox has an annoying inner border */\n.fc button::-moz-focus-inner { margin: 0; padding: 0; }\n\n.fc-state-default { /* non-theme */\n\tborder: 1px solid;\n}\n\n.fc-state-default.fc-corner-left { /* non-theme */\n\tborder-top-left-radius: 4px;\n\tborder-bottom-left-radius: 4px;\n}\n\n.fc-state-default.fc-corner-right { /* non-theme */\n\tborder-top-right-radius: 4px;\n\tborder-bottom-right-radius: 4px;\n}\n\n/* icons in buttons */\n\n.fc button .fc-icon { /* non-theme */\n\tposition: relative;\n\ttop: -0.05em; /* seems to be a good adjustment across browsers */\n\tmargin: 0 .2em;\n\tvertical-align: middle;\n}\n\n/*\n  button states\n  borrowed from twitter bootstrap (http://twitter.github.com/bootstrap/)\n*/\n\n.fc-state-hover,\n.fc-state-active,\n.fc-state-disabled {\n\tcolor: #333333;\n\tbackground-color: #e6e6e6;\n}\n\n.fc button[disabled],\n.fc button[disabled]:focus,\n.fc button[disabled]:hover{\n    background-color: $light-gray;\n    border-color: $light-gray;\n    cursor: default;\n\t@include opacity(.65);\n\tmargin-left: .75em;\n}\n\n.fc-state-hover {\n\tbackground-color: $smoke-bg;\n}\n\n.fc .fc-state-active,\n.fc .fc-state-active:focus,\n.fc .fc-state-active:hover,\n.fc .fc-state-active:active:focus,\n.fc .fc-state-active:active:hover,\n.fc .fc-state-active:active {\n\tbackground-color: $default-color;\n    color: #FFFFFF;\n}\n\n\n\n/* Buttons Groups\n--------------------------------------------------------------------------------------------------*/\n\n.fc-button-group {\n\tdisplay: inline-block;\n}\n\n/*\nevery button that is not first in a button group should scootch over one pixel and cover the\nprevious button's border...\n*/\n\n.fc .fc-button-group > * { /* extra precedence b/c buttons have margin set to zero */\n\tfloat: left;\n\tmargin: 0 0 0 5px;\n}\n\n.fc .fc-button-group > :first-child { /* same */\n\tmargin-left: 0;\n}\n\n\n/* Popover\n--------------------------------------------------------------------------------------------------*/\n\n.fc-popover {\n\tposition: absolute;\n\t@include box-shadow($dropdown-shadow);\n}\n\n.fc-popover .fc-header { /* TODO: be more consistent with fc-head/fc-body */\n\tpadding: 2px 4px;\n}\n\n.fc-popover .fc-header .fc-title {\n\tmargin: 0 2px;\n}\n\n.fc-popover .fc-header .fc-close {\n\tcursor: pointer;\n}\n\n.fc-ltr .fc-popover .fc-header .fc-title,\n.fc-rtl .fc-popover .fc-header .fc-close {\n\tfloat: left;\n}\n\n.fc-rtl .fc-popover .fc-header .fc-title,\n.fc-ltr .fc-popover .fc-header .fc-close {\n\tfloat: right;\n}\n\n/* unthemed */\n\n.fc-unthemed .fc-popover {\n\tborder-width: 1px;\n\tborder-style: solid;\n}\n\n.fc-unthemed .fc-popover .fc-header .fc-close {\n\tfont-size: .9em;\n\tmargin-top: 2px;\n}\n\n/* jqui themed */\n\n.fc-popover > .ui-widget-header + .ui-widget-content {\n\tborder-top: 0; /* where they meet, let the header have the border */\n}\n\n\n/* Misc Reusable Components\n--------------------------------------------------------------------------------------------------*/\n\n.fc-divider {\n\tborder-style: solid;\n\tborder-width: 1px;\n}\n\nhr.fc-divider {\n\theight: 0;\n\tmargin: 0;\n\tpadding: 0 0 2px; /* height is unreliable across browsers, so use padding */\n\tborder-width: 1px 0;\n}\n\n.fc-clear {\n\tclear: both;\n}\n\n.fc-bg,\n.fc-bgevent-skeleton,\n.fc-highlight-skeleton,\n.fc-helper-skeleton {\n\t/* these element should always cling to top-left/right corners */\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n}\n\n.fc-bg {\n\tbottom: 0; /* strech bg to bottom edge */\n}\n\n.fc-bg table {\n\theight: 100%; /* strech bg to bottom edge */\n}\n\n\n/* Tables\n--------------------------------------------------------------------------------------------------*/\n\n.fc table {\n\twidth: 100%;\n\ttable-layout: fixed;\n\tborder-collapse: collapse;\n\tborder-spacing: 0;\n\tfont-size: 1em; /* normalize cross-browser */\n}\n\n.fc th {\n\ttext-align: right;\n    border-bottom-width: 1px;\n    font-size: $font-size-h6;\n    text-transform: uppercase;\n    color: $dark-gray;\n    font-weight: $font-weight-normal;\n    padding-bottom: 3px;\n}\n\n.fc td {\n\tborder-style: solid;\n\tborder-width: 1px;\n\tpadding: 0;\n\tvertical-align: top;\n}\n\n.fc td.fc-today {\n\tborder-style: double; /* overcome neighboring borders */\n}\n\n.fc .fc-widget-header{\n    border: 0;\n}\n\n.fc .fc-head .fc-widget-header{\n    margin-top: $margin-base-vertical;\n}\n/* Fake Table Rows\n--------------------------------------------------------------------------------------------------*/\n\n.fc .fc-row { /* extra precedence to overcome themes w/ .ui-widget-content forcing a 1px border */\n\t/* no visible border by default. but make available if need be (scrollbar width compensation) */\n\tborder-style: solid;\n\tborder-width: 0;\n}\n\n.fc-row table {\n\t/* don't put left/right border on anything within a fake row.\n\t   the outer tbody will worry about this */\n\tborder-left: 0 hidden transparent;\n\tborder-right: 0 hidden transparent;\n\n\t/* no bottom borders on rows */\n\tborder-bottom: 0 hidden transparent;\n}\n\n.fc-row:first-child table {\n\tborder-top: 0 hidden transparent; /* no top border on first row */\n}\n\n\n/* Day Row (used within the header and the DayGrid)\n--------------------------------------------------------------------------------------------------*/\n\n.fc-row {\n\tposition: relative;\n}\n\n.fc-row .fc-bg {\n\tz-index: 1;\n}\n\n/* highlighting cells & background event skeleton */\n\n.fc-row .fc-bgevent-skeleton,\n.fc-row .fc-highlight-skeleton {\n\tbottom: 0; /* stretch skeleton to bottom of row */\n}\n\n.fc-row .fc-bgevent-skeleton table,\n.fc-row .fc-highlight-skeleton table {\n\theight: 100%; /* stretch skeleton to bottom of row */\n}\n\n.fc-row .fc-highlight-skeleton td,\n.fc-row .fc-bgevent-skeleton td {\n\tborder-color: transparent;\n}\n\n.fc-row .fc-bgevent-skeleton {\n\tz-index: 2;\n\n}\n\n.fc-row .fc-highlight-skeleton {\n\tz-index: 3;\n}\n\n/*\nrow content (which contains day/week numbers and events) as well as \"helper\" (which contains\ntemporary rendered events).\n*/\n\n.fc-row .fc-content-skeleton {\n\tposition: relative;\n\tz-index: 4;\n\tpadding-bottom: 2px; /* matches the space above the events */\n}\n\n.fc-row .fc-helper-skeleton {\n\tz-index: 5;\n}\n\n.fc-row .fc-content-skeleton td,\n.fc-row .fc-helper-skeleton td {\n\t/* see-through to the background below */\n\tbackground: none; /* in case <td>s are globally styled */\n\tborder-color: transparent;\n\n\t/* don't put a border between events and/or the day number */\n\tborder-bottom: 0;\n}\n\n.fc-row .fc-content-skeleton tbody td, /* cells with events inside (so NOT the day number cell) */\n.fc-row .fc-helper-skeleton tbody td {\n\t/* don't put a border between event cells */\n\tborder-top: 0;\n}\n\n\n/* Scrolling Container\n--------------------------------------------------------------------------------------------------*/\n\n.fc-scroller { /* this class goes on elements for guaranteed vertical scrollbars */\n\toverflow-y: scroll;\n\toverflow-x: hidden;\n}\n\n.fc-scroller > * { /* we expect an immediate inner element */\n\tposition: relative; /* re-scope all positions */\n\twidth: 100%; /* hack to force re-sizing this inner element when scrollbars appear/disappear */\n\toverflow: hidden; /* don't let negative margins or absolute positioning create further scroll */\n}\n\n\n/* Global Event Styles\n--------------------------------------------------------------------------------------------------*/\n\n.fc-event {\n\tposition: relative; /* for resize handle and other inner positioning */\n\tdisplay: block; /* make the <a> tag block */\n\tfont-size: .85em;\n\tline-height: 1.3;\n\tborder-radius: 2px;\n\tbackground-color: $light-blue; /* default BACKGROUND color */\n\tfont-weight: normal; /* undo jqui's ui-widget-header bold */\n\n    &.event-azure{\n        background-color: $light-azure;\n    }\n    &.event-green{\n        background-color: $light-green;\n    }\n    &.event-orange{\n        background-color: $light-orange;\n    }\n    &.event-red{\n        background-color: $light-red;\n    }\n}\n\n/* overpower some of bootstrap's and jqui's styles on <a> tags */\n.fc-event,\n.fc-event:hover,\n.ui-widget .fc-event {\n\tcolor: $black-color; /* default TEXT color */\n\ttext-decoration: none; /* if <a> has an href */\n}\n\n.fc-event[href],\n.fc-event.fc-draggable {\n\tcursor: pointer; /* give events with links and draggable events a hand mouse pointer */\n}\n\n.fc-not-allowed, /* causes a \"warning\" cursor. applied on body */\n.fc-not-allowed .fc-event { /* to override an event's custom cursor */\n\tcursor: not-allowed;\n}\n\n.fc-event .fc-bg { /* the generic .fc-bg already does position */\n\tz-index: 1;\n\tbackground: #fff;\n\topacity: .25;\n\tfilter: alpha(opacity=25); /* for IE */\n}\n\n.fc-event .fc-content {\n\tposition: relative;\n\tz-index: 2;\n}\n\n.fc-event .fc-resizer {\n\tposition: absolute;\n\tz-index: 3;\n}\n\n\n/* Horizontal Events\n--------------------------------------------------------------------------------------------------*/\n\n/* events that are continuing to/from another week. kill rounded corners and butt up against edge */\n\n.fc-ltr .fc-h-event.fc-not-start,\n.fc-rtl .fc-h-event.fc-not-end {\n\tmargin-left: 0;\n\tborder-left-width: 0;\n\tpadding-left: 1px; /* replace the border with padding */\n\tborder-top-left-radius: 0;\n\tborder-bottom-left-radius: 0;\n}\n\n.fc-ltr .fc-h-event.fc-not-end,\n.fc-rtl .fc-h-event.fc-not-start {\n\tmargin-right: 0;\n\tborder-right-width: 0;\n\tpadding-right: 1px; /* replace the border with padding */\n\tborder-top-right-radius: 0;\n\tborder-bottom-right-radius: 0;\n}\n\n/* resizer */\n\n.fc-h-event .fc-resizer { /* positioned it to overcome the event's borders */\n\ttop: -1px;\n\tbottom: -1px;\n\tleft: -1px;\n\tright: -1px;\n\twidth: 5px;\n}\n\n/* left resizer  */\n.fc-ltr .fc-h-event .fc-start-resizer,\n.fc-ltr .fc-h-event .fc-start-resizer:before,\n.fc-ltr .fc-h-event .fc-start-resizer:after,\n.fc-rtl .fc-h-event .fc-end-resizer,\n.fc-rtl .fc-h-event .fc-end-resizer:before,\n.fc-rtl .fc-h-event .fc-end-resizer:after {\n\tright: auto; /* ignore the right and only use the left */\n\tcursor: w-resize;\n}\n\n/* right resizer */\n.fc-ltr .fc-h-event .fc-end-resizer,\n.fc-ltr .fc-h-event .fc-end-resizer:before,\n.fc-ltr .fc-h-event .fc-end-resizer:after,\n.fc-rtl .fc-h-event .fc-start-resizer,\n.fc-rtl .fc-h-event .fc-start-resizer:before,\n.fc-rtl .fc-h-event .fc-start-resizer:after {\n\tleft: auto; /* ignore the left and only use the right */\n\tcursor: e-resize;\n}\n\n\n/* DayGrid events\n----------------------------------------------------------------------------------------------------\nWe use the full \"fc-day-grid-event\" class instead of using descendants because the event won't\nbe a descendant of the grid when it is being dragged.\n*/\n\n.fc-day-grid-event {\n\tmargin: 2px 5px 0; /* spacing between events and edges */\n\tpadding: 1px 2px;\n}\n\n\n.fc-day-grid-event .fc-content { /* force events to be one-line tall */\n\twhite-space: nowrap;\n\toverflow: hidden;\n}\n\n.fc-day-grid-event .fc-time {\n\tfont-weight: bold;\n}\n\n.fc-day-grid-event .fc-resizer { /* enlarge the default hit area */\n\tleft: -3px;\n\tright: -3px;\n\twidth: 7px;\n}\n\n\n/* Event Limiting\n--------------------------------------------------------------------------------------------------*/\n\n/* \"more\" link that represents hidden events */\n\na.fc-more {\n\tmargin: 1px 3px;\n\tfont-size: .85em;\n\tcursor: pointer;\n\ttext-decoration: none;\n}\n\na.fc-more:hover {\n\ttext-decoration: underline;\n}\n\n.fc-limited { /* rows and cells that are hidden because of a \"more\" link */\n\tdisplay: none;\n}\n\n/* popover that appears when \"more\" link is clicked */\n\n.fc-day-grid .fc-row {\n\tz-index: 1; /* make the \"more\" popover one higher than this */\n}\n\n.fc-more-popover {\n\tz-index: 2;\n\twidth: 220px;\n}\n\n.fc-more-popover .fc-event-container {\n\tpadding: 10px;\n}\n\n/* Toolbar\n--------------------------------------------------------------------------------------------------*/\n\n.fc-toolbar {\n\ttext-align: center;\n\tmargin-bottom: 1em;\n}\n\n.fc-toolbar .fc-left {\n\tfloat: left;\n\tmin-width: 260px;\n}\n\n.fc-toolbar .fc-right {\n\tfloat: right;\n}\n\n.fc-toolbar .fc-center {\n\tdisplay: inline-block;\n}\n\n/* the things within each left/right/center section */\n.fc .fc-toolbar > * > * { /* extra precedence to override button border margins */\n\tfloat: left;\n\tmargin-left: .75em;\n}\n\n/* the first thing within each left/center/right section */\n.fc .fc-toolbar > * > :first-child { /* extra precedence to override button border margins */\n\tmargin-left: 0;\n}\n\n/* title text */\n\n.fc-toolbar h2 {\n\tmargin: 0;\n}\n\n/* button layering (for border precedence) */\n\n.fc-toolbar button {\n\tposition: relative;\n}\n\n.fc-toolbar .fc-state-hover,\n.fc-toolbar .ui-state-hover {\n\tz-index: 2;\n}\n\n.fc-toolbar .fc-state-down {\n\tz-index: 3;\n}\n\n.fc-toolbar .fc-state-active,\n.fc-toolbar .ui-state-active {\n\tz-index: 4;\n}\n\n.fc-toolbar button:focus {\n\tz-index: 5;\n}\n\n\n/* View Structure\n--------------------------------------------------------------------------------------------------*/\n\n/* undo twitter bootstrap's box-sizing rules. normalizes positioning techniques */\n/* don't do this for the toolbar because we'll want bootstrap to style those buttons as some pt */\n.fc-view-container *,\n.fc-view-container *:before,\n.fc-view-container *:after {\n\t-webkit-box-sizing: content-box;\n\t   -moz-box-sizing: content-box;\n\t        box-sizing: content-box;\n}\n\n.fc-view, /* scope positioning and z-index's for everything within the view */\n.fc-view > table { /* so dragged elements can be above the view's main element */\n\tposition: relative;\n\tz-index: 1;\n}\n\n/* BasicView\n--------------------------------------------------------------------------------------------------*/\n\n/* day row structure */\n\n.fc-basicWeek-view .fc-content-skeleton,\n.fc-basicDay-view .fc-content-skeleton {\n\t/* we are sure there are no day numbers in these views, so... */\n\tpadding-top: 1px; /* add a pixel to make sure there are 2px padding above events */\n\tpadding-bottom: 1em; /* ensure a space at bottom of cell for user selecting/clicking */\n}\n\n.fc-basic-view .fc-body .fc-row {\n\tmin-height: 4em; /* ensure that all rows are at least this tall */\n}\n\n/* a \"rigid\" row will take up a constant amount of height because content-skeleton is absolute */\n\n.fc-row.fc-rigid {\n\toverflow: hidden;\n}\n\n.fc-row.fc-rigid .fc-content-skeleton {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n}\n\n/* week and day number styling */\n\n.fc-basic-view .fc-week-number,\n.fc-basic-view .fc-day-number {\n\tpadding: 8px;\n}\n\n\n.fc-basic-view .fc-week-number {\n\ttext-align: center;\n}\n\n.fc-basic-view .fc-week-number span {\n\t/* work around the way we do column resizing and ensure a minimum width */\n\tdisplay: inline-block;\n\tmin-width: 1.25em;\n}\n\n.fc-ltr .fc-basic-view .fc-day-number {\n\tfloat: right;\n}\n\n.fc-rtl .fc-basic-view .fc-day-number {\n\ttext-align: left;\n}\n\n.fc-other-month .fc-day-number{\n\topacity: 0.3;\n\tfilter: alpha(opacity=30); /* for IE */\n\t/* opacity with small font can sometimes look too faded\n\t   might want to set the 'color' property instead\n\t   making day-numbers bold also fixes the problem */\n}\n\n/* AgendaView all-day area\n--------------------------------------------------------------------------------------------------*/\n\n.fc-agenda-view .fc-day-grid {\n\tposition: relative;\n\tz-index: 2; /* so the \"more..\" popover will be over the time grid */\n}\n\n.fc-agenda-view .fc-day-grid .fc-row {\n\tmin-height: 3em; /* all-day section will never get shorter than this */\n}\n\n.fc-agenda-view .fc-day-grid .fc-row .fc-content-skeleton {\n\tpadding-top: 1px; /* add a pixel to make sure there are 2px padding above events */\n\tpadding-bottom: 1em; /* give space underneath events for clicking/selecting days */\n}\n\n\n/* TimeGrid axis running down the side (for both the all-day area and the slot area)\n--------------------------------------------------------------------------------------------------*/\n\n.fc .fc-axis { /* .fc to overcome default cell styles */\n\tvertical-align: middle;\n\tpadding: 0 4px;\n\twhite-space: nowrap;\n}\n\n.fc-ltr .fc-axis {\n\ttext-align: right;\n}\n\n.fc-rtl .fc-axis {\n\ttext-align: left;\n}\n\n.ui-widget td.fc-axis {\n\tfont-weight: normal; /* overcome jqui theme making it bold */\n}\n\n\n/* TimeGrid Structure\n--------------------------------------------------------------------------------------------------*/\n\n.fc-time-grid-container, /* so scroll container's z-index is below all-day */\n.fc-time-grid { /* so slats/bg/content/etc positions get scoped within here */\n\tposition: relative;\n\tz-index: 1;\n}\n\n.fc-time-grid {\n\tmin-height: 100%; /* so if height setting is 'auto', .fc-bg stretches to fill height */\n}\n\n.fc-time-grid table { /* don't put outer borders on slats/bg/content/etc */\n\tborder: 0 hidden transparent;\n}\n\n.fc-time-grid > .fc-bg {\n\tz-index: 1;\n}\n\n.fc-time-grid .fc-slats,\n.fc-time-grid > hr { /* the <hr> AgendaView injects when grid is shorter than scroller */\n\tposition: relative;\n\tz-index: 2;\n}\n\n.fc-time-grid .fc-bgevent-skeleton,\n.fc-time-grid .fc-content-skeleton {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n}\n\n.fc-time-grid .fc-bgevent-skeleton {\n\tz-index: 3;\n}\n\n.fc-time-grid .fc-highlight-skeleton {\n\tz-index: 4;\n}\n\n.fc-time-grid .fc-content-skeleton {\n\tz-index: 5;\n}\n\n.fc-time-grid .fc-helper-skeleton {\n\tz-index: 6;\n}\n\n\n/* TimeGrid Slats (lines that run horizontally)\n--------------------------------------------------------------------------------------------------*/\n\n.fc-time-grid .fc-slats td {\n\theight: 1.5em;\n\tborder-bottom: 0; /* each cell is responsible for its top border */\n}\n\n.fc-time-grid .fc-slats .fc-minor td {\n\tborder-top-style: dotted;\n}\n\n.fc-time-grid .fc-slats .ui-widget-content { /* for jqui theme */\n\tbackground: none; /* see through to fc-bg */\n}\n\n\n/* TimeGrid Highlighting Slots\n--------------------------------------------------------------------------------------------------*/\n\n.fc-time-grid .fc-highlight-container { /* a div within a cell within the fc-highlight-skeleton */\n\tposition: relative; /* scopes the left/right of the fc-highlight to be in the column */\n}\n\n.fc-time-grid .fc-highlight {\n\tposition: absolute;\n\tleft: 0;\n\tright: 0;\n\t/* top and bottom will be in by JS */\n}\n\n\n/* TimeGrid Event Containment\n--------------------------------------------------------------------------------------------------*/\n\n.fc-time-grid .fc-event-container, /* a div within a cell within the fc-content-skeleton */\n.fc-time-grid .fc-bgevent-container { /* a div within a cell within the fc-bgevent-skeleton */\n\tposition: relative;\n}\n\n.fc-ltr .fc-time-grid .fc-event-container { /* space on the sides of events for LTR (default) */\n\tmargin: 0 2.5% 0 2px;\n}\n\n.fc-rtl .fc-time-grid .fc-event-container { /* space on the sides of events for RTL */\n\tmargin: 0 2px 0 2.5%;\n}\n\n.fc-time-grid .fc-event,\n.fc-time-grid .fc-bgevent {\n\tposition: absolute;\n\tz-index: 1; /* scope inner z-index's */\n}\n\n.fc-time-grid .fc-bgevent {\n\t/* background events always span full width */\n\tleft: 0;\n\tright: 0;\n}\n\n\n/* Generic Vertical Event\n--------------------------------------------------------------------------------------------------*/\n\n.fc-v-event.fc-not-start { /* events that are continuing from another day */\n\t/* replace space made by the top border with padding */\n\tborder-top-width: 0;\n\tpadding-top: 1px;\n\n\t/* remove top rounded corners */\n\tborder-top-left-radius: 0;\n\tborder-top-right-radius: 0;\n}\n\n.fc-v-event.fc-not-end {\n\t/* replace space made by the top border with padding */\n\tborder-bottom-width: 0;\n\tpadding-bottom: 1px;\n\n\t/* remove bottom rounded corners */\n\tborder-bottom-left-radius: 0;\n\tborder-bottom-right-radius: 0;\n}\n\n\n/* TimeGrid Event Styling\n----------------------------------------------------------------------------------------------------\nWe use the full \"fc-time-grid-event\" class instead of using descendants because the event won't\nbe a descendant of the grid when it is being dragged.\n*/\n\n.fc-time-grid-event {\n\toverflow: hidden; /* don't let the bg flow over rounded corners */\n}\n\n.fc-time-grid-event .fc-time,\n.fc-time-grid-event .fc-title {\n\tpadding: 0 1px;\n}\n\n.fc-time-grid-event .fc-time {\n\tfont-size: .85em;\n\twhite-space: nowrap;\n}\n\n/* short mode, where time and title are on the same line */\n\n.fc-time-grid-event.fc-short .fc-content {\n\t/* don't wrap to second line (now that contents will be inline) */\n\twhite-space: nowrap;\n}\n\n.fc-time-grid-event.fc-short .fc-time,\n.fc-time-grid-event.fc-short .fc-title {\n\t/* put the time and title on the same line */\n\tdisplay: inline-block;\n\tvertical-align: top;\n}\n\n.fc-time-grid-event.fc-short .fc-time span {\n\tdisplay: none; /* don't display the full time text... */\n}\n\n.fc-time-grid-event.fc-short .fc-time:before {\n\tcontent: attr(data-start); /* ...instead, display only the start time */\n}\n\n.fc-time-grid-event.fc-short .fc-time:after {\n\tcontent: \"\\000A0-\\000A0\"; /* seperate with a dash, wrapped in nbsp's */\n}\n\n.fc-time-grid-event.fc-short .fc-title {\n\tfont-size: .85em; /* make the title text the same size as the time */\n\tpadding: 0; /* undo padding from above */\n}\n\n/* resizer */\n\n.fc-time-grid-event .fc-resizer {\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\theight: 8px;\n\toverflow: hidden;\n\tline-height: 8px;\n\tfont-size: 11px;\n\tfont-family: monospace;\n\ttext-align: center;\n\tcursor: s-resize;\n}\n\n.fc-time-grid-event .fc-resizer:after {\n\tcontent: \"=\";\n}\n\n.card-calendar{\n    .content{\n        padding: 0 !important;\n    }\n    .fc-toolbar{\n        padding-top: $padding-default-horizontal;\n        padding-left: $padding-default-horizontal;\n        padding-right: $padding-default-horizontal;\n    }\n    .fc td:first-child{\n        border-left: 0;\n    }\n    .fc td:last-child{\n        border-right: 0;\n    }\n    .fc-basic-view td:last-child.fc-week-number span,\n    .fc-basic-view td:last-child.fc-day-number{\n        padding-right: $padding-default-horizontal;\n    }\n    .fc .fc-day-header:last-child{\n        padding-right: 15px;\n    }\n    .fc .fc-row:last-child td{\n        border-bottom: 0;\n    }\n    .fc .fc-body .fc-widget-content{\n        border-bottom: 0;\n    }\n}\n","@mixin ct-responsive-svg-container($width: 100%, $ratio: $ct-container-ratio) {\n  display: block;\n  position: relative;\n  width: $width;\n\n  &:before {\n    display: block;\n    float: left;\n    content: \"\";\n    width: 0;\n    height: 0;\n    padding-bottom: $ratio * 100%;\n  }\n\n  &:after {\n    content: \"\";\n    display: table;\n    clear: both;\n  }\n\n  > svg {\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n  }\n}\n\n@mixin ct-align-justify($ct-text-align: $ct-text-align, $ct-text-justify: $ct-text-justify) {\n  -webkit-box-align: $ct-text-align;\n  -webkit-align-items: $ct-text-align;\n  -ms-flex-align: $ct-text-align;\n  align-items: $ct-text-align;\n  -webkit-box-pack: $ct-text-justify;\n  -webkit-justify-content: $ct-text-justify;\n  -ms-flex-pack: $ct-text-justify;\n  justify-content: $ct-text-justify;\n  // Fallback to text-align for non-flex browsers\n  @if($ct-text-justify == 'flex-start') {\n    text-align: left;\n  } @else if ($ct-text-justify == 'flex-end') {\n    text-align: right;\n  } @else {\n    text-align: center;\n  }\n}\n\n@mixin ct-flex() {\n  // Fallback to block\n  display: block;\n  display: -webkit-box;\n  display: -moz-box;\n  display: -ms-flexbox;\n  display: -webkit-flex;\n  display: flex;\n}\n\n@mixin ct-chart-label($ct-text-color: $ct-text-color, $ct-text-size: $ct-text-size, $ct-text-line-height: $ct-text-line-height) {\n  fill: $ct-text-color;\n  color: $ct-text-color;\n  font-size: $ct-text-size;\n  line-height: $ct-text-line-height;\n}\n\n@mixin ct-chart-grid($ct-grid-color: $ct-grid-color, $ct-grid-width: $ct-grid-width, $ct-grid-dasharray: $ct-grid-dasharray) {\n  stroke: $ct-grid-color;\n  stroke-width: $ct-grid-width;\n\n  @if ($ct-grid-dasharray) {\n    stroke-dasharray: $ct-grid-dasharray;\n  }\n}\n\n@mixin ct-chart-point($ct-point-size: $ct-point-size, $ct-point-shape: $ct-point-shape) {\n  stroke-width: $ct-point-size;\n  stroke-linecap: $ct-point-shape;\n}\n\n@mixin ct-chart-line($ct-line-width: $ct-line-width, $ct-line-dasharray: $ct-line-dasharray) {\n  fill: none;\n  stroke-width: $ct-line-width;\n\n  @if ($ct-line-dasharray) {\n    stroke-dasharray: $ct-line-dasharray;\n  }\n}\n\n@mixin ct-chart-area($ct-area-opacity: $ct-area-opacity) {\n  stroke: none;\n  fill-opacity: $ct-area-opacity;\n}\n\n@mixin ct-chart-bar($ct-bar-width: $ct-bar-width) {\n  fill: none;\n  stroke-width: $ct-bar-width;\n}\n\n@mixin ct-chart-donut($ct-donut-width: $ct-donut-width) {\n  fill: none;\n  stroke-width: $ct-donut-width;\n}\n\n@mixin ct-chart-series-color($color) {\n  .#{$ct-class-point}, .#{$ct-class-line}, .#{$ct-class-bar}, .#{$ct-class-slice-donut} {\n    stroke: $color;\n  }\n\n  .#{$ct-class-slice-pie}, .#{$ct-class-area} {\n    fill: $color;\n  }\n}\n\n@mixin ct-chart($ct-container-ratio: $ct-container-ratio, $ct-text-color: $ct-text-color, $ct-text-size: $ct-text-size, $ct-grid-color: $ct-grid-color, $ct-grid-width: $ct-grid-width, $ct-grid-dasharray: $ct-grid-dasharray, $ct-point-size: $ct-point-size, $ct-point-shape: $ct-point-shape, $ct-line-width: $ct-line-width, $ct-bar-width: $ct-bar-width, $ct-donut-width: $ct-donut-width, $ct-series-names: $ct-series-names, $ct-series-colors: $ct-series-colors) {\n\n  .#{$ct-class-label} {\n    @include ct-chart-label($ct-text-color, $ct-text-size);\n  }\n\n  .#{$ct-class-chart-line} .#{$ct-class-label},\n  .#{$ct-class-chart-bar} .#{$ct-class-label} {\n    @include ct-flex();\n  }\n\n  .#{$ct-class-label}.#{$ct-class-horizontal}.#{$ct-class-start} {\n    @include ct-align-justify(flex-end, flex-start);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: start;\n  }\n\n  .#{$ct-class-label}.#{$ct-class-horizontal}.#{$ct-class-end} {\n    @include ct-align-justify(flex-start, flex-start);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: start;\n  }\n\n  .#{$ct-class-label}.#{$ct-class-vertical}.#{$ct-class-start} {\n    @include ct-align-justify(flex-end, flex-end);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: end;\n  }\n\n  .#{$ct-class-label}.#{$ct-class-vertical}.#{$ct-class-end} {\n    @include ct-align-justify(flex-end, flex-start);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: start;\n  }\n\n  .#{$ct-class-chart-bar} .#{$ct-class-label}.#{$ct-class-horizontal}.#{$ct-class-start} {\n    @include ct-align-justify(flex-end, center);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: start;\n  }\n\n  .#{$ct-class-chart-bar} .#{$ct-class-label}.#{$ct-class-horizontal}.#{$ct-class-end} {\n    @include ct-align-justify(flex-start, center);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: start;\n  }\n\n  .#{$ct-class-chart-bar}.#{$ct-class-horizontal-bars} .#{$ct-class-label}.#{$ct-class-horizontal}.#{$ct-class-start} {\n    @include ct-align-justify(flex-end, flex-start);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: start;\n  }\n\n  .#{$ct-class-chart-bar}.#{$ct-class-horizontal-bars} .#{$ct-class-label}.#{$ct-class-horizontal}.#{$ct-class-end} {\n    @include ct-align-justify(flex-start, flex-start);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: start;\n  }\n\n  .#{$ct-class-chart-bar}.#{$ct-class-horizontal-bars} .#{$ct-class-label}.#{$ct-class-vertical}.#{$ct-class-start} {\n    //@include ct-chart-label($ct-text-color, $ct-text-size, center, $ct-vertical-text-justify);\n    @include ct-align-justify(center, flex-end);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: end;\n  }\n\n  .#{$ct-class-chart-bar}.#{$ct-class-horizontal-bars} .#{$ct-class-label}.#{$ct-class-vertical}.#{$ct-class-end} {\n    @include ct-align-justify(center, flex-start);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: end;\n  }\n\n  .#{$ct-class-grid} {\n    @include ct-chart-grid($ct-grid-color, $ct-grid-width, $ct-grid-dasharray);\n  }\n\n  .#{$ct-class-point} {\n    @include ct-chart-point($ct-point-size, $ct-point-shape);\n  }\n\n  .#{$ct-class-line} {\n    @include ct-chart-line($ct-line-width);\n  }\n\n  .#{$ct-class-area} {\n    @include ct-chart-area();\n  }\n\n  .#{$ct-class-bar} {\n    @include ct-chart-bar($ct-bar-width);\n  }\n\n  .#{$ct-class-slice-donut} {\n    @include ct-chart-donut($ct-donut-width);\n  }\n\n  @if $ct-include-colored-series {\n    @for $i from 0 to length($ct-series-names) {\n      .#{$ct-class-series}-#{nth($ct-series-names, $i + 1)} {\n        $color: nth($ct-series-colors, $i + 1);\n\n        @include ct-chart-series-color($color);\n      }\n    }\n  }\n}\n\n@if $ct-include-classes {\n  @include ct-chart();\n\n  @if $ct-include-alternative-responsive-containers {\n    @for $i from 0 to length($ct-scales-names) {\n      .#{nth($ct-scales-names, $i + 1)} {\n        @include ct-responsive-svg-container($ratio: nth($ct-scales, $i + 1));\n      }\n    }\n  }\n}\n\n\n.ct-blue{\n    stroke: $color-blue !important;\n}\n.ct-azure{\n    stroke: $color-azure !important;\n}\n.ct-green{\n    stroke: $color-green !important;\n}\n.ct-orange{\n    stroke: $color-orange !important;\n}\n.ct-red{\n    stroke: $color-red !important;\n}\n","/* perfect-scrollbar v0.6.10 */\n.ps-container {\n  -ms-touch-action: none;\n  touch-action: none;\n  overflow: hidden !important;\n  -ms-overflow-style: none; }\n  @supports (-ms-overflow-style: none) {\n    .ps-container {\n      overflow: auto !important; } }\n  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n    .ps-container {\n      overflow: auto !important; } }\n  .ps-container.ps-active-x > .ps-scrollbar-x-rail,\n  .ps-container.ps-active-y > .ps-scrollbar-y-rail {\n    display: block;\n    background-color: transparent; }\n  .ps-container.ps-in-scrolling {\n    pointer-events: none; }\n    .ps-container.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail {\n      background-color: #eee;\n      opacity: 0.9; }\n      .ps-container.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail > .ps-scrollbar-x {\n        background-color: #999; }\n    .ps-container.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail {\n      background-color: #eee;\n      opacity: 0.9; }\n      .ps-container.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail > .ps-scrollbar-y {\n        background-color: #999; }\n  .ps-container > .ps-scrollbar-x-rail {\n    display: none;\n    position: absolute;\n    /* please don't change 'position' */\n    -webkit-border-radius: 4px;\n    -moz-border-radius: 4px;\n    border-radius: 4px;\n    opacity: 0;\n    -webkit-transition: background-color .2s linear, opacity .2s linear;\n    -moz-transition: background-color .2s linear, opacity .2s linear;\n    -o-transition: background-color .2s linear, opacity .2s linear;\n    transition: background-color .2s linear, opacity .2s linear;\n    bottom: 3px;\n    /* there must be 'bottom' for ps-scrollbar-x-rail */\n    height: 8px; }\n    .ps-container > .ps-scrollbar-x-rail > .ps-scrollbar-x {\n      position: absolute;\n      /* please don't change 'position' */\n      background-color: #aaa;\n      -webkit-border-radius: 4px;\n      -moz-border-radius: 4px;\n      border-radius: 4px;\n      -webkit-transition: background-color .2s linear;\n      -moz-transition: background-color .2s linear;\n      -o-transition: background-color .2s linear;\n      transition: background-color .2s linear;\n      bottom: 0;\n      /* there must be 'bottom' for ps-scrollbar-x */\n      height: 8px; }\n  .ps-container > .ps-scrollbar-y-rail {\n    display: none;\n    position: absolute;\n    /* please don't change 'position' */\n    -webkit-border-radius: 4px;\n    -moz-border-radius: 4px;\n    border-radius: 4px;\n    opacity: 0;\n    -webkit-transition: background-color .2s linear, opacity .2s linear;\n    -moz-transition: background-color .2s linear, opacity .2s linear;\n    -o-transition: background-color .2s linear, opacity .2s linear;\n    transition: background-color .2s linear, opacity .2s linear;\n    right: 3px;\n    /* there must be 'right' for ps-scrollbar-y-rail */\n    width: 8px; }\n    .ps-container > .ps-scrollbar-y-rail > .ps-scrollbar-y {\n      position: absolute;\n      /* please don't change 'position' */\n      background-color: #aaa;\n      -webkit-border-radius: 4px;\n      -moz-border-radius: 4px;\n      border-radius: 4px;\n      -webkit-transition: background-color .2s linear;\n      -moz-transition: background-color .2s linear;\n      -o-transition: background-color .2s linear;\n      transition: background-color .2s linear;\n      right: 0;\n      /* there must be 'right' for ps-scrollbar-y */\n      width: 8px; }\n  .ps-container:hover.ps-in-scrolling {\n    pointer-events: none; }\n    .ps-container:hover.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail {\n      background-color: #eee;\n      opacity: 0.9; }\n      .ps-container:hover.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail > .ps-scrollbar-x {\n        background-color: #999; }\n    .ps-container:hover.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail {\n      background-color: #eee;\n      opacity: 0.9; }\n      .ps-container:hover.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail > .ps-scrollbar-y {\n        background-color: #999; }\n  .ps-container:hover > .ps-scrollbar-x-rail,\n  .ps-container:hover > .ps-scrollbar-y-rail {\n    opacity: 0.6; }\n  .ps-container:hover > .ps-scrollbar-x-rail:hover {\n    background-color: #eee;\n    opacity: 0.9; }\n    .ps-container:hover > .ps-scrollbar-x-rail:hover > .ps-scrollbar-x {\n      background-color: #999; }\n  .ps-container:hover > .ps-scrollbar-y-rail:hover {\n    background-color: #eee;\n    opacity: 0.9; }\n    .ps-container:hover > .ps-scrollbar-y-rail:hover > .ps-scrollbar-y {\n      background-color: #999; }\n","/*!\n * Bootstrap-select v1.12.2 (http://silviomoreto.github.io/bootstrap-select)\n *\n * Copyright 2013-2017 bootstrap-select\n * Licensed under MIT (https://github.com/silviomoreto/bootstrap-select/blob/master/LICENSE)\n */\n\nselect.bs-select-hidden,\nselect.selectpicker {\n  display: none !important;\n}\n.bootstrap-select {\n  min-width: 100%;\n}\n.bootstrap-select > .dropdown-toggle {\n  width: 100%;\n  padding-right: 25px;\n  z-index: 1;\n  margin: 0;\n\n    &:after{\n        margin-left: -10px;\n    }\n}\n\n.bootstrap-select > select {\n  position: absolute !important;\n  bottom: 0;\n  left: 50%;\n  display: block !important;\n  width: 0.5px !important;\n  height: 100% !important;\n  padding: 0 !important;\n  opacity: 0 !important;\n  border: none;\n  border-top-left-radius: 3px !important;\n  border-top-right-radius: 3px !important;\n}\n.bootstrap-select > select.mobile-device {\n  top: 0;\n  left: 0;\n  display: block !important;\n  width: 100% !important;\n  z-index: 2;\n}\n.has-error .bootstrap-select .dropdown-toggle,\n.error .bootstrap-select .dropdown-toggle {\n  border-color: #b94a48;\n}\n.bootstrap-select.fit-width {\n  width: auto !important;\n}\n.bootstrap-select:not([class*=\"col-\"]):not([class*=\"form-control\"]):not(.input-group-btn) {\n  width: 100%;\n}\n\n.bootstrap-select.form-control {\n  margin-bottom: 0;\n  padding: 0;\n  border: none;\n}\n.bootstrap-select.form-control:not([class*=\"col-\"]) {\n  width: 100%;\n}\n.bootstrap-select.btn-block{\n    width: 100%;\n}\n.bootstrap-select.form-control.input-group-btn {\n  z-index: auto;\n}\n.bootstrap-select.form-control.input-group-btn:not(:first-child):not(:last-child) > .btn {\n  border-radius: 0;\n}\n.bootstrap-select.btn-group:not(.input-group-btn),\n.bootstrap-select.btn-group[class*=\"col-\"] {\n  float: none;\n  display: inline-block;\n  margin-left: 0;\n}\n.bootstrap-select.btn-group.dropdown-menu-right,\n.bootstrap-select.btn-group[class*=\"col-\"].dropdown-menu-right,\n.row .bootstrap-select.btn-group[class*=\"col-\"].dropdown-menu-right {\n  float: right;\n}\n.form-inline .bootstrap-select.btn-group,\n.form-horizontal .bootstrap-select.btn-group,\n.form-group .bootstrap-select.btn-group {\n  margin-bottom: 0;\n}\n.form-group-lg .bootstrap-select.btn-group.form-control,\n.form-group-sm .bootstrap-select.btn-group.form-control {\n  padding: 0;\n}\n.form-group-lg .bootstrap-select.btn-group.form-control .dropdown-toggle,\n.form-group-sm .bootstrap-select.btn-group.form-control .dropdown-toggle {\n  height: 100%;\n  font-size: inherit;\n  line-height: inherit;\n  border-radius: inherit;\n}\n.form-inline .bootstrap-select.btn-group .form-control {\n  width: 100%;\n}\n.bootstrap-select.btn-group.disabled,\n.bootstrap-select.btn-group > .disabled {\n  cursor: not-allowed;\n}\n.bootstrap-select.btn-group.disabled:focus,\n.bootstrap-select.btn-group > .disabled:focus {\n  outline: none !important;\n}\n.bootstrap-select.btn-group.bs-container {\n  position: absolute;\n  height: 0 !important;\n  padding: 0 !important;\n}\n.bootstrap-select.btn-group.bs-container .dropdown-menu {\n  z-index: 1060;\n}\n.bootstrap-select.btn-group .dropdown-toggle .filter-option {\n  display: inline-block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 100%;\n  text-align: left;\n}\n.bootstrap-select.btn-group .dropdown-toggle .caret {\n  display: none;\n}\n.bootstrap-select.btn-group[class*=\"col-\"] .dropdown-toggle {\n  width: 100%;\n}\n.bootstrap-select.btn-group .dropdown-menu {\n  min-width: 100%;\n  -webkit-box-sizing: border-box;\n     -moz-box-sizing: border-box;\n          box-sizing: border-box;\n max-height: 400px !important;\n}\n.bootstrap-select.btn-group .dropdown-menu.inner {\n  position: static;\n  float: none;\n  border: 0;\n  padding: 0;\n  margin: 0;\n  display: block;\n  max-height: 400px !important;\n  overflow-y: scroll;\n -ms-overflow-style: auto;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.bootstrap-select.btn-group .dropdown-menu li {\n  position: relative;\n}\n.bootstrap-select.btn-group .dropdown-menu li.active small {\n  color: #fff;\n}\n.bootstrap-select.btn-group .dropdown-menu li.disabled a {\n  cursor: not-allowed;\n}\n.bootstrap-select.btn-group .dropdown-menu li a {\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.bootstrap-select.btn-group .dropdown-menu li a.opt {\n  position: relative;\n  padding-left: 2.25em;\n}\n.bootstrap-select.btn-group .dropdown-menu li a span.check-mark {\n  display: none;\n}\n.bootstrap-select.btn-group .dropdown-menu li a span.text {\n  display: inline-block;\n}\n.bootstrap-select.btn-group .dropdown-menu li small {\n  padding-left: 0.5em;\n}\n.bootstrap-select.btn-group .dropdown-menu .notify {\n  position: absolute;\n  bottom: 5px;\n  width: 96%;\n  margin: 0 2%;\n  min-height: 26px;\n  padding: 3px 5px;\n  background: #f5f5f5;\n  border: 1px solid #e3e3e3;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);\n          box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);\n  pointer-events: none;\n  opacity: 0.9;\n  -webkit-box-sizing: border-box;\n     -moz-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.bootstrap-select.btn-group .no-results {\n  padding: 3px;\n  background: #f5f5f5;\n  margin: 0 5px;\n  white-space: nowrap;\n}\n.bootstrap-select.btn-group.fit-width .dropdown-toggle .filter-option {\n  position: static;\n}\n.bootstrap-select.btn-group.fit-width .dropdown-toggle .caret {\n  position: static;\n  top: auto;\n  margin-top: -1px;\n}\n.bootstrap-select.btn-group.show-tick .dropdown-menu li.selected a span.check-mark {\n  position: absolute;\n  display: inline-block;\n  right: 20px;\n  margin-top: 3px;\n  color: black;\n}\n.bootstrap-select.btn-group.show-tick .dropdown-menu li a span.text {\n  margin-right: 34px;\n}\n.bootstrap-select.show-menu-arrow.open > .dropdown-toggle {\n  z-index: 1061;\n}\n.bootstrap-select.show-menu-arrow .dropdown-toggle:before {\n  content: '';\n  border-left: 7px solid transparent;\n  border-right: 7px solid transparent;\n  border-bottom: 7px solid rgba(204, 204, 204, 0.2);\n  position: absolute;\n  bottom: -4px;\n  left: 9px;\n  display: none;\n}\n.bootstrap-select.show-menu-arrow .dropdown-toggle:after {\n  content: '';\n  border-left: 6px solid transparent;\n  border-right: 6px solid transparent;\n  border-bottom: 6px solid white;\n  position: absolute;\n  bottom: -4px;\n  left: 10px;\n  display: none;\n}\n.bootstrap-select.show-menu-arrow.dropup .dropdown-toggle:before {\n  bottom: auto;\n  top: -3px;\n  border-top: 7px solid rgba(204, 204, 204, 0.2);\n  border-bottom: 0;\n}\n.bootstrap-select.show-menu-arrow.dropup .dropdown-toggle:after {\n  bottom: auto;\n  top: -3px;\n  border-top: 6px solid white;\n  border-bottom: 0;\n}\n.bootstrap-select.show-menu-arrow.pull-right .dropdown-toggle:before {\n  right: 12px;\n  left: auto;\n}\n.bootstrap-select.show-menu-arrow.pull-right .dropdown-toggle:after {\n  right: 13px;\n  left: auto;\n}\n.bootstrap-select.show-menu-arrow.open > .dropdown-toggle:before,\n.bootstrap-select.show-menu-arrow.open > .dropdown-toggle:after {\n  display: block;\n}\n.bs-searchbox,\n.bs-actionsbox,\n.bs-donebutton {\n  padding: 4px 8px;\n}\n.bs-actionsbox {\n  width: 100%;\n  -webkit-box-sizing: border-box;\n     -moz-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.bs-actionsbox .btn-group button {\n  width: 50%;\n}\n.bs-donebutton {\n  float: left;\n  width: 100%;\n  -webkit-box-sizing: border-box;\n     -moz-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.bs-donebutton .btn-group button {\n  width: 100%;\n}\n.bs-searchbox + .bs-actionsbox {\n  padding: 0 8px 4px;\n}\n.bs-searchbox .form-control {\n  margin-bottom: 0;\n  width: 100%;\n  float: none;\n}\n\n.bootstrap-select{\n    margin-top: 5px;\n\n    .dropdown-menu.inner{\n        li a{\n            display: block;\n            padding: 8px 16px;\n            clear: both;\n            font-weight: 400;\n            line-height: 1.42857143;\n            color: #333;\n            white-space: nowrap;\n            outline: none;\n            font-size: 14px;\n        }\n\n        li.disabled a{\n            // color: $default-color-opacity;\n\n            &:hover,\n            &:focus{\n                background-color: transparent;\n            }\n        }\n\n        li{\n            a:hover{\n                background-color: #F5F5F5 !important;\n                color: #333333 !important;\n                opacity: 1;\n                text-decoration: none;\n            }\n        }\n    }\n\n    .dropdown-menu.open{\n        overflow: visible !important;\n        display: none;\n        visibility: hidden;\n\n        &.show{\n            display: block;\n            visibility: visible;\n        }\n    }\n\n    .dropdown-menu.open[x-placement=\"top-start\"]{\n        top: 0px !important;\n    }\n}\n\n\n.show .btn-info.dropdown-toggle{\n    background-color: $info-color;\n    border-color: $info-color;\n}\n","/*!\n * Datetimepicker for Bootstrap 3\n * ! version : 4.7.14\n * https://github.com/Eonasdan/bootstrap-datetimepicker/\n */\n$bs-datetimepicker-timepicker-font-size: 1.2em !default;\n$bs-datetimepicker-active-bg: $info-color !default;\n$bs-datetimepicker-active-color: $white-color !default;\n$bs-datetimepicker-border-radius: $border-radius-base;\n$bs-datetimepicker-btn-hover-bg: $light-gray !default;\n$bs-datetimepicker-disabled-color: $medium-gray !default;\n$bs-datetimepicker-alternate-color: $medium-gray !default;\n$bs-datetimepicker-secondary-border-color: #ccc !default;\n$bs-datetimepicker-secondary-border-color-rgba: rgba(0, 0, 0, 0.2) !default;\n$bs-datetimepicker-primary-border-color: white !default;\n$bs-datetimepicker-text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25) !default;\n\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0,0,0,0);\n  border: 0;\n}\n\n\n.bootstrap-datetimepicker-widget {\n    list-style: none;\n\n\n    &.dropdown-menu {\n        padding: 4px;\n        width: 19em;\n\n        &.timepicker-sbs {\n            @media (min-width: $screen-sm-min) {\n                width: 38em;\n            }\n\n            @media (min-width: $screen-md-min) {\n                width: 38em;\n            }\n\n            @media (min-width: $screen-lg-min) {\n                width: 38em;\n            }\n        }\n\n        &.bottom {\n\n            &:before {\n                border-bottom: 11px solid rgba(0, 0, 0, 0.2);\n                border-left: 11px solid rgba(0, 0, 0, 0);\n                border-right: 11px solid rgba(0, 0, 0, 0);\n                content: \"\";\n                display: inline-block;\n                position: absolute;\n                left: 12px;\n                top: -11px;\n            }\n\n            &:after {\n                border-bottom: 11px solid #FFFFFF;\n                border-left: 11px solid rgba(0, 0, 0, 0);\n                border-right: 11px solid rgba(0, 0, 0, 0);\n                content: \"\";\n                display: inline-block;\n                position: absolute;\n                left: 12px;\n                top: -10px;\n            }\n        }\n\n        &.top {\n            margin-top: auto;\n            margin-bottom: -20px;\n\n            &.open{\n                margin-top: auto;\n                margin-bottom: 5px;\n            }\n\n            &:before {\n                border-top: 11px solid rgba(0, 0, 0, 0.2);\n                border-left: 11px solid rgba(0, 0, 0, 0);\n                border-right: 11px solid rgba(0, 0, 0, 0);\n                border-bottom: none;\n                content: \"\";\n                display: inline-block;\n                position: absolute;\n                left: 12px;\n                bottom: -11px;\n                top: auto;\n            }\n\n            &:after {\n                border-top: 11px solid #FFFFFF;\n                border-left: 11px solid rgba(0, 0, 0, 0);\n                border-right: 11px solid rgba(0, 0, 0, 0);\n                border-bottom: none;\n                content: \"\";\n                display: inline-block;\n                position: absolute;\n                left: 12px;\n                bottom: -10px;\n                top: auto;\n            }\n        }\n\n\n\n        &.pull-right {\n            &:before {\n                left: auto;\n                right: 6px;\n            }\n\n            &:after {\n                left: auto;\n                right: 7px;\n            }\n        }\n\n        &.open{\n            visibility: visible !important;\n            opacity: 1 !important;\n            top: 120px !important;\n            font-size: 14px !important;\n        }\n    }\n\n    .list-unstyled {\n        margin: 0;\n    }\n\n    a[data-action] {\n        padding: 6px 0;\n        border-width: 0;\n    }\n\n    a[data-action]:active {\n        box-shadow: none;\n    }\n\n    .timepicker-hour, .timepicker-minute, .timepicker-second {\n        width: 56px;\n        height: 56px;\n        font-weight: $font-weight-light;\n        font-size: $font-size-h4;\n        margin: 3px;\n        border-radius: 50%;\n    }\n\n    button[data-action] {\n        padding: 6px;\n    }\n\n    .btn[data-action=\"incrementHours\"]::after {\n        @extend .sr-only;\n        content: \"Increment Hours\";\n    }\n\n    .btn[data-action=\"incrementMinutes\"]::after {\n        @extend .sr-only;\n        content: \"Increment Minutes\";\n    }\n\n    .btn[data-action=\"decrementHours\"]::after {\n        @extend .sr-only;\n        content: \"Decrement Hours\";\n    }\n\n    .btn[data-action=\"decrementMinutes\"]::after {\n        @extend .sr-only;\n        content: \"Decrement Minutes\";\n    }\n\n    .btn[data-action=\"showHours\"]::after {\n        @extend .sr-only;\n        content: \"Show Hours\";\n    }\n\n    .btn[data-action=\"showMinutes\"]::after {\n        @extend .sr-only;\n        content: \"Show Minutes\";\n    }\n\n    .btn[data-action=\"togglePeriod\"]::after {\n        @extend .sr-only;\n        content: \"Toggle AM/PM\";\n    }\n\n    .btn[data-action=\"clear\"]::after {\n        @extend .sr-only;\n        content: \"Clear the picker\";\n    }\n\n    .btn[data-action=\"today\"]::after {\n        @extend .sr-only;\n        content: \"Set the date to today\";\n    }\n\n    .picker-switch {\n        text-align: center;\n        border-radius: $bs-datetimepicker-border-radius;\n        font-size: 14px;\n\n        &::after {\n            @extend .sr-only;\n            content: \"Toggle Date and Time Screens\";\n        }\n\n        td {\n            padding: 0;\n            margin: 0;\n            height: auto;\n            width: auto;\n            line-height: inherit;\n\n            span {\n                line-height: 2.5;\n                height: 2.5em;\n                width: 100%;\n                border-radius: $bs-datetimepicker-border-radius;\n                margin: 2px 0px !important;\n            }\n\n            a,\n            a:hover{\n                color: $info-color;\n            }\n        }\n    }\n\n    table {\n        width: 100%;\n        margin: 0;\n\n\n        & td > div,\n        & th > div {\n            // @extend .animation-transition-fast;\n            text-align: center;\n\n        }\n\n\n        & th {\n            // @extend .animation-transition-fast;\n\n            height: 20px;\n            line-height: 20px;\n            width: 20px;\n\n            &.picker-switch {\n                width: 145px;\n            }\n\n            &.disabled,\n            &.disabled:hover {\n                background: none;\n                color: $bs-datetimepicker-disabled-color;\n                cursor: not-allowed;\n            }\n\n            &.prev span,\n            &.next span{\n                border-radius: $bs-datetimepicker-border-radius;\n                height: 27px;\n                width: 27px;\n                line-height: 28px;\n                font-size: 12px;\n                border-radius: 50%;\n                text-align: center;\n\n            }\n\n            &.prev::after {\n                @extend .sr-only;\n                content: \"Previous Month\";\n            }\n\n            &.next::after {\n                @extend .sr-only;\n                content: \"Next Month\";\n            }\n\n            &.dow{\n                text-align: center;\n                border-bottom: 1px solid $light-gray;\n                font-size: $font-size-small;\n                text-transform: uppercase;\n                color: $dark-gray;\n                font-weight: $font-weight-normal;\n                padding-bottom: 5px;\n                padding-top: $padding-default-vertical;\n            }\n        }\n\n        & thead tr:first-child th{\n            cursor: pointer;\n\n            &:hover span,\n            &.picker-switch:hover{\n                background: $bs-datetimepicker-btn-hover-bg;\n            }\n        }\n\n        & td{\n            > div {\n                border-radius: $bs-datetimepicker-border-radius;\n\n                height: 54px;\n                line-height: 54px;\n                width: 54px;\n                text-align: center;\n            }\n\n            &.cw > div {\n                font-size: .8em;\n                height: 20px;\n                line-height: 20px;\n                color: $bs-datetimepicker-alternate-color;\n            }\n\n            &.day > div {\n                height: 30px;\n                line-height: 30px;\n                width: 30px;\n                text-align: center;\n                padding: 0px;\n                border-radius: 50%;\n                margin: 0 auto;\n                z-index: -1;\n                position: relative;\n            }\n\n            &.minute > div,\n            &.hour > div{\n                border-radius: 50%;\n            }\n\n            &.day:hover > div,\n            &.hour:hover > div,\n            &.minute:hover > div,\n            &.second:hover > div {\n                background: $bs-datetimepicker-btn-hover-bg;\n                cursor: pointer;\n            }\n\n            &.old > div,\n            &.new > div{\n                color: $bs-datetimepicker-alternate-color;\n            }\n\n            &.today > div{\n                position: relative;\n\n                &:before {\n                    content: '';\n                    display: inline-block;\n                    border: 0 0 7px 7px solid transparent;\n                    border-bottom-color: $bs-datetimepicker-active-bg;\n                    border-top-color: $bs-datetimepicker-secondary-border-color-rgba;\n                    position: absolute;\n                    bottom: 4px;\n                    right: 4px;\n                }\n            }\n\n            &.active > div,\n            &.active:hover > div {\n                background-color: $info-bg;\n                color: $bs-datetimepicker-active-color;\n\n            }\n\n            &.active.today:before > div{\n                border-bottom-color: #fff;\n            }\n\n            &.disabled > div,\n            &.disabled:hover > div {\n                background: none;\n                color: $bs-datetimepicker-disabled-color;\n                cursor: not-allowed;\n            }\n\n            span {\n                // @extend .animation-transition-fast;\n\n               display: inline-block;\n                width: 56px;\n                height: 56px;\n                line-height: 56px;\n                margin: 3px 3px;\n                cursor: pointer;\n                border-radius: 50%;\n                text-align: center;\n\n                &:hover {\n                    background: $bs-datetimepicker-btn-hover-bg;\n                }\n\n                &.active {\n                    background-color: $bs-datetimepicker-active-bg;\n                    color: $bs-datetimepicker-active-color;\n                }\n\n                &.old {\n                    color: $bs-datetimepicker-alternate-color;\n                }\n\n                &.disabled,\n                &.disabled:hover {\n                    background: none;\n                    color: $bs-datetimepicker-disabled-color;\n                    cursor: not-allowed;\n                }\n            }\n        }\n    }\n\n    .timepicker-picker,\n    .timepicker-hours,\n    .timepicker-minutes{\n        span{\n            border-radius: 50% !important;\n        }\n\n        .table-condensed{\n            td{\n                a{\n                    color: $default-color;\n                    background-color: transparent;\n                }\n            }\n        }\n    }\n\n    &.usetwentyfour {\n        td.hour {\n            height: 27px;\n            line-height: 27px;\n        }\n    }\n}\n\n.input-group.date {\n    & .input-group-addon {\n        cursor: pointer;\n    }\n}\n\n.table-condensed>tbody>tr>td,\n.table-condensed>tbody>tr>th,\n.table-condensed>tfoot>tr>td,\n.table-condensed>tfoot>tr>th,\n.table-condensed>thead>tr>td,\n.table-condensed>thead>tr>th{\n    padding: 1px;\n}\n\n.bootstrap-datetimepicker-widget{\n    opacity: 0;\n    -webkit-transform: translate3d(0px, -10px, 0px);\n    -moz-transform: translate3d(0, -10px, 0);\n    -o-transform: translate3d(0, -10px, 0);\n    -ms-transform: translate3d(0, -10px, 0);\n    transform: translate3d(0px, -10px, 0px);\n\n    &.top{\n        -webkit-transform: translate3d(0px, 0px, 0px);\n        -moz-transform: translate3d(0, 0px, 0);\n        -o-transform: translate3d(0, 0px, 0);\n        -ms-transform: translate3d(0, 0px, 0);\n        transform: translate3d(0px, 0px, 0px);\n    }\n    &.open{\n        opacity: 1;\n        -webkit-transform: translate3d(0, 5px, 0);\n        -moz-transform: translate3d(0, 5px, 0);\n        -o-transform: translate3d(0, 5px, 0);\n        -ms-transform: translate3d(0, 5px, 0);\n        transform: translate3d(0, 5px, 0);\n        transition: transform 0.5s cubic-bezier(0.215, 0.61, 0.355, 1) 0s;\n    }\n}\n\n\n.bootstrap-datetimepicker-widget.dropdown-menu.top{\n    top: auto !important;\n}\n\n.bootstrap-datetimepicker-widget.open.top{\n    -webkit-transform: translate3d(0, -10px, 0);\n    -moz-transform: translate3d(0, -10px, 0);\n    -o-transform: translate3d(0, -10px, 0);\n    -ms-transform: translate3d(0, -10px, 0);\n    transform: translate3d(0, -10px, 0);\n\n    &:before{\n        border-top: 11px solid #DCD9D1;\n        border-left: 11px solid transparent;\n        border-right: 11px solid transparent;\n        content: \"\";\n        display: inline-block;\n        position: absolute;\n        left: 12px;\n        bottom: -12px;\n    }\n    &:after{\n        border-top: 11px solid $white-color;\n        border-left: 11px solid transparent;\n        border-right: 11px solid transparent;\n        content: \"\";\n        display: inline-block;\n        position: absolute;\n        left: 12px;\n        bottom: -11px;\n    }\n}\n","/*! nouislider - 9.1.0 - 2016-12-10 16:00:32 */\n\n\n/* Functional styling;\n * These styles are required for noUiSlider to function.\n * You don't need to change these rules to apply your design.\n */\n.noUi-target,\n.noUi-target * {\n-webkit-touch-callout: none;\n-webkit-tap-highlight-color: rgba(0,0,0,0);\n-webkit-user-select: none;\n-ms-touch-action: none;\n\ttouch-action: none;\n-ms-user-select: none;\n-moz-user-select: none;\n\tuser-select: none;\n-moz-box-sizing: border-box;\n\tbox-sizing: border-box;\n}\n.noUi-target {\n\tposition: relative;\n\tdirection: ltr;\n}\n.noUi-base {\n\twidth: 100%;\n\theight: 100%;\n\tposition: relative;\n\tz-index: 1; /* Fix 401 */\n}\n.noUi-connect {\n\tposition: absolute;\n\tright: 0;\n\ttop: 0;\n\tleft: 0;\n\tbottom: 0;\n}\n.noUi-origin {\n\tposition: absolute;\n\theight: 0;\n\twidth: 0;\n}\n.noUi-handle {\n\tposition: relative;\n\tz-index: 1;\n}\n.noUi-state-tap .noUi-connect,\n.noUi-state-tap .noUi-origin {\n-webkit-transition: top 0.3s, right 0.3s, bottom 0.3s, left 0.3s;\n\ttransition: top 0.3s, right 0.3s, bottom 0.3s, left 0.3s;\n}\n.noUi-state-drag * {\n\tcursor: inherit !important;\n}\n\n/* Painting and performance;\n * Browsers can paint handles in their own layer.\n */\n.noUi-base,\n.noUi-handle {\n\t-webkit-transform: translate3d(0,0,0);\n\ttransform: translate3d(0,0,0);\n}\n\n/* Slider size and handle placement;\n */\n.noUi-horizontal {\n\theight: 4px;\n}\n.noUi-horizontal .noUi-handle {\n    border-radius: 50%;\n\tbackground-color: $white-color;\n\tbox-shadow: 0 1px 13px 0 rgba(0, 0, 0, 0.2);\n\theight:15px;\n\twidth:15px;\n\tcursor:pointer;\n    margin-left: -10px;\n    margin-top: -6px;\n\toutline: none;\n}\n.noUi-vertical {\n\twidth: 18px;\n}\n.noUi-vertical .noUi-handle {\n\twidth: 28px;\n\theight: 34px;\n\tleft: -6px;\n\ttop: -17px;\n}\n\n/* Styling;\n */\n.noUi-target {\n\tbackground-color: rgba(182, 182, 182, .3);\n\tborder-radius: 3px;\n}\n.noUi-connect {\n\tbackground: $default-color;\n    border-radius: 3px;\n-webkit-transition: background 450ms;\n\ttransition: background 450ms;\n}\n\n/* Handles and cursors;\n */\n.noUi-draggable {\n\tcursor: ew-resize;\n}\n.noUi-vertical .noUi-draggable {\n\tcursor: ns-resize;\n}\n.noUi-handle {\n\t// border: 1px solid #D9D9D9;\n\tborder-radius: 3px;\n\tbackground: #FFF;\n\tcursor: default;\n\tbox-shadow: inset 0 0 1px #FFF,\n\t\t\t\tinset 0 1px 7px #EBEBEB,\n\t\t\t\t0 3px 6px -3px #BBB;\n\t-webkit-transition: $general-transition-time $transition-ease;\n    -moz-transition: $general-transition-time $transition-ease;\n    -ms-transition: $general-transition-time $transition-ease;\n    -o-transform: $general-transition-time $transition-ease;\n    transition: $general-transition-time $transition-ease;\n}\n.noUi-active {\n\t-webkit-transform: scale3d(1.5,1.5,1);\n    -moz-transform: scale3d(1.5,1.5,1);\n    -ms-transform: scale3d(1.5,1.5,1);\n    -o-transform: scale3d(1.5,1.5,1);\n    transform: scale3d(1.5,1.5,1);\n}\n\n/* Disabled state;\n */\n\n[disabled] .noUi-connect {\n\tbackground: #B8B8B8;\n}\n[disabled].noUi-target,\n[disabled].noUi-handle,\n[disabled] .noUi-handle {\n\tcursor: not-allowed;\n}\n\n/* Base;\n *\n */\n.noUi-pips,\n.noUi-pips * {\n-moz-box-sizing: border-box;\n\tbox-sizing: border-box;\n}\n.noUi-pips {\n\tposition: absolute;\n\tcolor: #999;\n}\n\n/* Values;\n *\n */\n.noUi-value {\n\tposition: absolute;\n\ttext-align: center;\n}\n.noUi-value-sub {\n\tcolor: #ccc;\n\tfont-size: 10px;\n}\n\n/* Markings;\n *\n */\n.noUi-marker {\n\tposition: absolute;\n\tbackground: #CCC;\n}\n.noUi-marker-sub {\n\tbackground: #AAA;\n}\n.noUi-marker-large {\n\tbackground: #AAA;\n}\n\n/* Horizontal layout;\n *\n */\n.noUi-pips-horizontal {\n\tpadding: 10px 0;\n\theight: 80px;\n\ttop: 100%;\n\tleft: 0;\n\twidth: 100%;\n}\n.noUi-value-horizontal {\n\t-webkit-transform: translate3d(-50%,50%,0);\n\ttransform: translate3d(-50%,50%,0);\n}\n\n.noUi-marker-horizontal.noUi-marker {\n\tmargin-left: -1px;\n\twidth: 2px;\n\theight: 5px;\n}\n.noUi-marker-horizontal.noUi-marker-sub {\n\theight: 10px;\n}\n.noUi-marker-horizontal.noUi-marker-large {\n\theight: 15px;\n}\n\n/* Vertical layout;\n *\n */\n.noUi-pips-vertical {\n\tpadding: 0 10px;\n\theight: 100%;\n\ttop: 0;\n\tleft: 100%;\n}\n.noUi-value-vertical {\n\t-webkit-transform: translate3d(0,50%,0);\n\ttransform: translate3d(0,50%,0);\n\tpadding-left: 25px;\n}\n\n.noUi-marker-vertical.noUi-marker {\n\twidth: 5px;\n\theight: 2px;\n\tmargin-top: -1px;\n}\n.noUi-marker-vertical.noUi-marker-sub {\n\twidth: 10px;\n}\n.noUi-marker-vertical.noUi-marker-large {\n\twidth: 15px;\n}\n\n.noUi-tooltip {\n\tdisplay: block;\n\tposition: absolute;\n\tborder: 1px solid #D9D9D9;\n\tborder-radius: 3px;\n\tbackground: #fff;\n\tcolor: #000;\n\tpadding: 5px;\n\ttext-align: center;\n}\n.noUi-horizontal .noUi-tooltip {\n-webkit-transform: translate(-50%, 0);\n    transform: translate(-50%, 0);\n    left: 50%;\n    bottom: 120%;\n}\n.noUi-vertical .noUi-tooltip {\n-webkit-transform: translate(0, -50%);\n    transform: translate(0, -50%);\n    top: 50%;\n    right: 120%;\n}\n\n\n\n\n\t.slider-neutral{\n\t\t& .noUi-connect,\n        &.noUi-connect{\n            background-color: $white-color;\n        }\n\t}\n\n\t.slider-primary{\n\t\t& .noUi-connect,\n        &.noUi-connect{\n            background-color: $primary-color;\n        }\n\t}\n\n    .slider-info{\n        & .noUi-connect,\n        &.noUi-connect{\n            background-color: $info-color;\n        }\n    }\n    .slider-success{\n        & .noUi-connect,\n        &.noUi-connect{\n            background-color: $success-color;\n        }\n    }\n    .slider-warning{\n        & .noUi-connect,\n        &.noUi-connect{\n            background-color: $warning-color;\n        }\n    }\n    .slider-danger{\n        & .noUi-connect,\n        &.noUi-connect{\n            background-color: $danger-color;\n        }\n    }\n","/*! nouislider - 14.6.3 - 11/19/2020 */\n/* Functional styling;\n * These styles are required for noUiSlider to function.\n * You don't need to change these rules to apply your design.\n */\n.noUi-target,\n.noUi-target * {\n  -webkit-touch-callout: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  -webkit-user-select: none;\n  -ms-touch-action: none;\n  touch-action: none;\n  -ms-user-select: none;\n  -moz-user-select: none;\n  user-select: none;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n.noUi-target {\n  position: relative;\n}\n.noUi-base,\n.noUi-connects {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  z-index: 1;\n}\n/* Wrapper for all connect elements.\n */\n.noUi-connects {\n  overflow: hidden;\n  z-index: 0;\n}\n.noUi-connect,\n.noUi-origin {\n  will-change: transform;\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  right: 0;\n  -ms-transform-origin: 0 0;\n  -webkit-transform-origin: 0 0;\n  -webkit-transform-style: preserve-3d;\n  transform-origin: 0 0;\n  transform-style: flat;\n}\n.noUi-connect {\n  height: 100%;\n  width: 100%;\n}\n.noUi-origin {\n  height: 10%;\n  width: 10%;\n}\n/* Offset direction\n */\n.noUi-txt-dir-rtl.noUi-horizontal .noUi-origin {\n  left: 0;\n  right: auto;\n}\n/* Give origins 0 height/width so they don't interfere with clicking the\n * connect elements.\n */\n.noUi-vertical .noUi-origin {\n  width: 0;\n}\n.noUi-horizontal .noUi-origin {\n  height: 0;\n}\n.noUi-handle {\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  position: absolute;\n}\n.noUi-touch-area {\n  height: 100%;\n  width: 100%;\n}\n.noUi-state-tap .noUi-connect,\n.noUi-state-tap .noUi-origin {\n  -webkit-transition: transform 0.3s;\n  transition: transform 0.3s;\n}\n.noUi-state-drag * {\n  cursor: inherit !important;\n}\n/* Slider size and handle placement;\n */\n.noUi-horizontal {\n  height: 4px;\n}\n.noUi-horizontal .noUi-handle {\n  width: 15px;\n  height: 15px;\n  right: -10px;\n  top: 0px;\n}\n.noUi-vertical {\n  width: 18px;\n}\n.noUi-vertical .noUi-handle {\n  width: 15px;\n  height: 15px;\n  right: -6px;\n  top: -17px;\n}\n.noUi-txt-dir-rtl.noUi-horizontal .noUi-handle {\n  left: -17px;\n  right: auto;\n}\n/* Styling;\n * Giving the connect element a border radius causes issues with using transform: scale\n */\n.noUi-target {\n  background: #FAFAFA;\n  border-radius: 4px;\n}\n.noUi-connects {\n  border-radius: 3px;\n}\n.noUi-connect {\n  background: #3FB8AF;\n}\n/* Handles and cursors;\n */\n.noUi-draggable {\n  cursor: ew-resize;\n}\n.noUi-vertical .noUi-draggable {\n  cursor: ns-resize;\n}\n.noUi-handle {\n  box-shadow: 0 1px 13px 0 rgba(0, 0, 0, 0.2);\n  border-radius: 50%;\n  background: #FFF;\n  cursor: default;\n  transition: $general-transition-time $transition-ease;\n}\n/* Handle stripes;\n */\n/* Disabled state;\n */\n[disabled] .noUi-connect {\n  background: #B8B8B8;\n}\n[disabled].noUi-target,\n[disabled].noUi-handle,\n[disabled] .noUi-handle {\n  cursor: not-allowed;\n}\n/* Base;\n *\n */\n.noUi-pips,\n.noUi-pips * {\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n.noUi-pips {\n  position: absolute;\n  color: #999;\n}\n/* Values;\n *\n */\n.noUi-value {\n  position: absolute;\n  white-space: nowrap;\n  text-align: center;\n}\n.noUi-value-sub {\n  color: #ccc;\n  font-size: 10px;\n}\n/* Markings;\n *\n */\n.noUi-marker {\n  position: absolute;\n  background: #CCC;\n}\n.noUi-marker-sub {\n  background: #AAA;\n}\n.noUi-marker-large {\n  background: #AAA;\n}\n/* Horizontal layout;\n *\n */\n.noUi-pips-horizontal {\n  padding: 10px 0;\n  height: 80px;\n  top: 100%;\n  left: 0;\n  width: 100%;\n}\n.noUi-value-horizontal {\n  -webkit-transform: translate(-50%, 50%);\n  transform: translate(-50%, 50%);\n}\n.noUi-rtl .noUi-value-horizontal {\n  -webkit-transform: translate(50%, 50%);\n  transform: translate(50%, 50%);\n}\n.noUi-marker-horizontal.noUi-marker {\n  margin-left: -1px;\n  width: 2px;\n  height: 5px;\n}\n.noUi-marker-horizontal.noUi-marker-sub {\n  height: 10px;\n}\n.noUi-marker-horizontal.noUi-marker-large {\n  height: 15px;\n}\n/* Vertical layout;\n *\n */\n.noUi-pips-vertical {\n  padding: 0 10px;\n  height: 100%;\n  top: 0;\n  left: 100%;\n}\n.noUi-value-vertical {\n  -webkit-transform: translate(0, -50%);\n  transform: translate(0, -50%);\n  padding-left: 25px;\n}\n.noUi-rtl .noUi-value-vertical {\n  -webkit-transform: translate(0, 50%);\n  transform: translate(0, 50%);\n}\n.noUi-marker-vertical.noUi-marker {\n  width: 5px;\n  height: 2px;\n  margin-top: -1px;\n}\n.noUi-marker-vertical.noUi-marker-sub {\n  width: 10px;\n}\n.noUi-marker-vertical.noUi-marker-large {\n  width: 15px;\n}\n.noUi-tooltip {\n  display: block;\n  position: absolute;\n  border: 1px solid #D9D9D9;\n  border-radius: 3px;\n  background: #fff;\n  color: #000;\n  padding: 5px;\n  text-align: center;\n  white-space: nowrap;\n}\n.noUi-horizontal .noUi-tooltip {\n  -webkit-transform: translate(-50%, 0);\n  transform: translate(-50%, 0);\n  left: 50%;\n  bottom: 120%;\n}\n.noUi-vertical .noUi-tooltip {\n  -webkit-transform: translate(0, -50%);\n  transform: translate(0, -50%);\n  top: 50%;\n  right: 120%;\n}\n.noUi-horizontal .noUi-origin > .noUi-tooltip {\n  -webkit-transform: translate(50%, 0);\n  transform: translate(50%, 0);\n  left: auto;\n  bottom: 10px;\n}\n.noUi-vertical .noUi-origin > .noUi-tooltip {\n  -webkit-transform: translate(0, -18px);\n  transform: translate(0, -18px);\n  top: auto;\n  right: 28px;\n}\n.noUi-active {\n  transform: scale3d(1.5,1.5,1);\n}\n.slider-primary {\n  .noUi-connect{\n    background: $color-blue;\n  }\n}\n.slider-info {\n  .noUi-connect{\n    background: $color-azure;\n  }\n}\n.slider-success {\n  .noUi-connect {\n    background: $color-green;\n  }\n}\n.slider-warning {\n  .noUi-connect {\n    background: $color-orange;\n  }\n}\n.slider-danger {\n  .noUi-connect {\n    background: $color-red;\n  }\n}\n",".rbc-btn {\n  color: inherit;\n  font: inherit;\n  margin: 0;\n}\nbutton.rbc-btn {\n  overflow: visible;\n  text-transform: none;\n  -webkit-appearance: button;\n  cursor: pointer;\n}\nbutton[disabled].rbc-btn {\n  cursor: not-allowed;\n}\nbutton.rbc-input::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\n.rbc-calendar {\n  box-sizing: border-box;\n  height: 100%;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-align-items: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n}\n.rbc-calendar *,\n.rbc-calendar *:before,\n.rbc-calendar *:after {\n  box-sizing: inherit;\n}\n.rbc-abs-full,\n.rbc-row-bg {\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n.rbc-ellipsis,\n.rbc-event-label,\n.rbc-row-segment .rbc-event-content,\n.rbc-show-more {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.rbc-rtl {\n  direction: rtl;\n}\n.rbc-off-range {\n  color: #333333;\n  opacity: 0.3;\n}\n// .rbc-off-range-bg {\n//   background: #e5e5e5;\n// }\n.rbc-header {\n  overflow: hidden;\n  -webkit-flex: 1 0 0%;\n  -ms-flex: 1 0 0%;\n  flex: 1 0 0%;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding: 0 3px;\n  text-align: right;\n  vertical-align: middle;\n  font-size: .875em;\n  min-height: 0;\n  border-bottom: 1px solid #DDD;\n  color: #999999;\n  font-weight: 400;\n  &:last-child{\n    span{\n      padding-right: 15px;\n    }\n  }\n}\n.rbc-header > a,\n.rbc-header > a:active,\n.rbc-header > a:visited {\n  color: inherit;\n  text-decoration: none;\n}\n.rbc-row-content {\n  position: relative;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-user-select: none;\n  z-index: 4;\n  min-height: 153px;\n}\n.rbc-toolbar {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  margin-bottom: 10px;\n  font-size: 16px;\n  padding-top: 20px;\n  padding-left: 20px;\n  padding-right: 20px;\n}\n.rbc-toolbar .rbc-toolbar-label {\n  -webkit-flex-grow: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  padding: 0 10px;\n  text-align: center;\n  font-family: inherit;\n  line-height: 1.5em;\n  color: inherit;\n  font-weight: 300;\n  margin: 0;\n  font-size: 2.25em;\n}\n.rbc-toolbar button {\n  display: inline-block;\n  margin: 0;\n  text-align: center;\n  vertical-align: middle;\n  background: none;\n  background-image: none;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  line-height: normal;\n  white-space: nowrap;\n  border-width: 1px;\n  background-color: transparent;\n  font-weight: 400;\n  padding: 8px 16px;\n  border-color: #888;\n  color: #888;\n  font-family: inherit;\n  font-size: inherit;\n  font: inherit;\n}\n.rbc-toolbar button:focus {\n  outline: none;\n}\n.rbc-toolbar button.rbc-active {\n  &,\n  &:hover {\n    border-color: #888;\n    background-color: #888;\n    color: #fff;\n  }\n}\n.rbc-toolbar button:hover {\n  color: #373a3c;\n  background-color: #e6e6e6;\n  border-color: #adadad;\n}\n.rbc-btn-group {\n  display: inline-block;\n  white-space: nowrap;\n}\n.rbc-btn-group > button:first-child:not(:last-child) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.rbc-btn-group > button:last-child:not(:first-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.rbc-rtl .rbc-btn-group > button:first-child:not(:last-child) {\n  border-radius: 4px;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.rbc-rtl .rbc-btn-group > button:last-child:not(:first-child) {\n  border-radius: 4px;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.rbc-btn-group > button:not(:first-child):not(:last-child) {\n  border-radius: 0;\n}\n.rbc-btn-group button + button {\n  margin-left: -1px;\n}\n.rbc-rtl .rbc-btn-group button + button {\n  margin-left: 0;\n  margin-right: -1px;\n}\n.rbc-btn-group + .rbc-btn-group,\n.rbc-btn-group + button {\n  margin-left: 10px;\n}\n\n.rbc-slot-selecting .rbc-event {\n  cursor: inherit;\n  pointer-events: none;\n}\n.rbc-event.rbc-selected {\n  background-color: #265985;\n}\n.rbc-event-label {\n  font-size: 80%;\n}\n.rbc-event-overlaps {\n  box-shadow: -1px 1px 5px 0px rgba(51, 51, 51, 0.5);\n}\n.rbc-event-continues-prior {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.rbc-event-continues-after {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.rbc-event-continues-earlier {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.rbc-event-continues-later {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.rbc-event-continues-day-after {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.rbc-event-continues-day-prior {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.rbc-row {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n}\n.rbc-row-segment {\n  padding: 2px 6px 1px;\n}\n.rbc-selected-cell {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n.rbc-show-more {\n  background-color: rgba(255, 255, 255, 0.3);\n  z-index: 4;\n  font-weight: bold;\n  font-size: 85%;\n  height: auto;\n  line-height: normal;\n  white-space: nowrap;\n}\n.rbc-month-view {\n  position: relative;\n  border: 1px solid #DDD;\n  border-bottom: 0px;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex: 1 0 0;\n  -ms-flex: 1 0 0px;\n  flex: 1 0 0;\n  width: 100%;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-user-select: none;\n  height: 100%;\n  border-left: none;\n  border-right: none;\n}\n.rbc-month-view {\n  border-top: none;\n}\n.rbc-month-header {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n}\n\n.rbc-month-row {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex: 1 0 0;\n  -ms-flex: 1 0 0px;\n  flex: 1 0 0;\n  // -webkit-flex-basis: 0px;\n  -ms-flex-preferred-size: 0px;\n  // flex-basis: 0px;\n  overflow: hidden;\n  height: 100%;\n}\n.rbc-month-row + .rbc-month-row {\n  border-top: 1px solid #DDD;\n}\n.rbc-date-cell {\n  flex: 1 1;\n  min-width: 0;\n  padding-left: 5px;\n  text-align: left;\n}\n.rbc-date-cell.rbc-now {\n  font-weight: bold;\n}\n.rbc-date-cell > a,\n.rbc-date-cell > a:active,\n.rbc-date-cell > a:visited {\n  color: inherit;\n  text-decoration: none;\n}\n.rbc-row-bg {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex: 1 0 0;\n  -ms-flex: 1 0 0px;\n  flex: 1 0 0;\n  overflow: hidden;\n}\n.rbc-day-bg {\n  -webkit-flex: 1 0 0%;\n  -ms-flex: 1 0 0%;\n  flex: 1 0 0%;\n}\n.rbc-day-bg + .rbc-day-bg {\n  border-left: 1px solid #DDD;\n}\n.rbc-rtl .rbc-day-bg + .rbc-day-bg {\n  border-left-width: 0;\n  border-right: 1px solid #DDD;\n}\n.rbc-overlay {\n  position: absolute;\n  z-index: 5;\n  border: 1px solid #e5e5e5;\n  background-color: #fff;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);\n  padding: 10px;\n}\n.rbc-overlay > * + * {\n  margin-top: 1px;\n}\n.rbc-overlay-header {\n  border-bottom: 1px solid #e5e5e5;\n  margin: -10px -10px 5px -10px;\n  padding: 2px 10px;\n}\n.rbc-agenda-view {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex: 1 0 0;\n  -ms-flex: 1 0 0px;\n  flex: 1 0 0;\n  overflow: auto;\n}\n.rbc-agenda-view table.rbc-agenda-table {\n  width: 100%;\n  border: 1px solid #DDD;\n  border-spacing: 0;\n  border-collapse: collapse;\n}\n.rbc-agenda-view table.rbc-agenda-table tbody > tr > td {\n  padding: 5px 10px;\n  vertical-align: top;\n}\n.rbc-agenda-view table.rbc-agenda-table .rbc-agenda-time-cell {\n  padding-left: 15px;\n  padding-right: 15px;\n  text-transform: lowercase;\n}\n.rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {\n  border-left: 1px solid #DDD;\n}\n.rbc-rtl .rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {\n  border-left-width: 0;\n  border-right: 1px solid #DDD;\n}\n.rbc-agenda-view table.rbc-agenda-table tbody > tr + tr {\n  border-top: 1px solid #DDD;\n}\n.rbc-agenda-view table.rbc-agenda-table thead > tr > th {\n  padding: 3px 5px;\n  text-align: left;\n  border-bottom: 1px solid #DDD;\n}\n.rbc-rtl .rbc-agenda-view table.rbc-agenda-table thead > tr > th {\n  text-align: right;\n}\n.rbc-agenda-time-cell {\n  text-transform: lowercase;\n}\n.rbc-agenda-time-cell .rbc-continues-after:after {\n  content: ' »';\n}\n.rbc-agenda-time-cell .rbc-continues-prior:before {\n  content: '« ';\n}\n.rbc-agenda-date-cell,\n.rbc-agenda-time-cell {\n  white-space: nowrap;\n}\n.rbc-agenda-event-cell {\n  width: 100%;\n}\n.rbc-time-column {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  min-height: 100%;\n}\n.rbc-time-column .rbc-timeslot-group {\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n.rbc-timeslot-group {\n  border-bottom: 1px solid #DDD;\n  min-height: 40px;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-flow: column nowrap;\n  -ms-flex-flow: column nowrap;\n  flex-flow: column nowrap;\n}\n.rbc-time-gutter,\n.rbc-header-gutter {\n  -webkit-flex: none;\n  -ms-flex: none;\n  flex: none;\n}\n.rbc-label {\n  padding: 0 5px;\n}\n.rbc-day-slot {\n  position: relative;\n}\n.rbc-day-slot .rbc-events-container {\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  right: 10px;\n  top: 0;\n}\n.rbc-day-slot .rbc-events-container.rbc-is-rtl {\n  left: 10px;\n  right: 0;\n}\n.rbc-day-slot .rbc-event {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  max-height: 100%;\n  min-height: 20px;\n  -webkit-flex-flow: column wrap;\n  -ms-flex-flow: column wrap;\n  flex-flow: column wrap;\n  -webkit-align-items: flex-start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  overflow: hidden;\n  position: absolute;\n}\n.rbc-day-slot .rbc-event-label {\n  -webkit-flex: none;\n  -ms-flex: none;\n  flex: none;\n  padding-right: 5px;\n  width: auto;\n  font-weight: bold;\n  -webkit-box-sizing: content-box;\n  -moz-box-sizing: content-box;\n  box-sizing: content-box;\n  color: #fff;\n  white-space: nowrap;\n}\n.rbc-day-slot .rbc-event-content {\n  width: 100%;\n  -webkit-flex: 1 1 0;\n  -ms-flex: 1 1 0px;\n  flex: 1 1 0;\n  word-wrap: break-word;\n  line-height: 1;\n  height: 100%;\n  min-height: 1em;\n}\n.rbc-day-slot .rbc-time-slot + .rbc-time-slot{\n  border-top: 1px dotted #ddd;\n}\n.rbc-time-slot {\n  -webkit-flex: 1 0 0;\n  -ms-flex: 1 0 0px;\n  flex: 1 0 0;\n}\n.rbc-time-slot.rbc-now {\n  font-weight: bold;\n}\n.rbc-day-header {\n  text-align: center;\n}\n.rbc-slot-selection {\n  z-index: 10;\n  position: absolute;\n  background-color: rgba(0, 0, 0, 0.5);\n  color: white;\n  font-size: 75%;\n  width: 100%;\n  padding: 3px;\n}\n.rbc-slot-selecting {\n  cursor: move;\n}\n.rbc-time-view {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  width: 100%;\n  border: 1px solid #DDD;\n  min-height: 0;\n  border-left: none;\n  border-right: none;\n  border-top: none;\n}\n.rbc-time-view .rbc-time-gutter {\n  white-space: nowrap;\n}\n.rbc-time-view .rbc-allday-cell {\n  box-sizing: content-box;\n  width: 100%;\n  position: relative;\n}\n.rbc-time-view .rbc-allday-events {\n  position: relative;\n  z-index: 4;\n}\n.rbc-time-view .rbc-row {\n  box-sizing: border-box;\n  min-height: 20px;\n}\n.rbc-time-header {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n}\n.rbc-time-header.rbc-overflowing {\n  border-right: 1px solid #DDD;\n}\n.rbc-rtl .rbc-time-header.rbc-overflowing {\n  border-right-width: 0;\n  border-left: 1px solid #DDD;\n}\n.rbc-time-header > .rbc-row:first-child {\n  border-bottom: 1px solid #DDD;\n}\n.rbc-time-header > .rbc-row.rbc-row-resource {\n  border-bottom: 1px solid #DDD;\n}\n.rbc-time-header-content {\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  min-width: 0;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  border-left: 1px solid #DDD;\n}\n.rbc-rtl .rbc-time-header-content {\n  border-left-width: 0;\n  border-right: 1px solid #DDD;\n}\n.rbc-time-content {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex: 1 0 0%;\n  -ms-flex: 1 0 0%;\n  flex: 1 0 0%;\n  -webkit-align-items: flex-start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  width: 100%;\n  border-top: 2px solid #DDD;\n  overflow-y: auto;\n  position: relative;\n}\n.rbc-time-content > .rbc-time-gutter {\n  -webkit-flex: none;\n  -ms-flex: none;\n  flex: none;\n}\n.rbc-time-content > * + * > * {\n  border-left: 1px solid #DDD;\n}\n.rbc-rtl .rbc-time-content > * + * > * {\n  border-left-width: 0;\n  border-right: 1px solid #DDD;\n}\n.rbc-time-content > .rbc-day-slot {\n  width: 100%;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-user-select: none;\n}\n.rbc-current-time-indicator {\n  position: absolute;\n  z-index: 3;\n  height: 1px;\n  background-color: #74ad31;\n  pointer-events: none;\n}\n.rbc-event {\n  width: 100%;\n  position: relative; /* for resize handle and other inner positioning */\n  display: block; /* make the <a> tag block */\n  font-size: .85em;\n  border-radius: 2px;\n  padding: 0;\n  background-color: $light-blue; /* default BACKGROUND color */\n  // @include shadow-big-color($brand-success);\n  font-weight: normal; /* undo jqui's ui-widget-header bold */\n  text-align: left;\n  border: none;\n  padding-bottom: 1px;\n  line-height: 1.2;\n\n  &.rbc-event-azure{\n    background-color: $light-azure;\n  }\n  &.rbc-event-green{\n    background-color: $light-green;\n  }\n  &.rbc-event-orange{\n    background-color: $light-orange;\n  }\n  &.rbc-event-red{\n    background-color: $light-red;\n  }\n\n  .rbc-event-content{\n    position: relative;\n    z-index: 2;\n    white-space: nowrap;\n    overflow: hidden;\n    color: inherit;\n    padding: 0 5px;\n  }\n}\n.rbc-day-slot .rbc-event {\n  display: block !important;\n  height: unset !important;\n  max-height: unset !important;\n}\n\n.rbc-today{\n  background-color: $smoke-bg;\n}\n@media screen and (max-width: 1373px){\n  .rbc-toolbar {\n    display: block;\n    .rbc-btn-group{\n      display: block;\n      text-align: center;\n    }\n    .rbc-toolbar-label{\n      display: block;\n      flex-grow: unset;\n      padding: 0;\n    }\n  }\n}\n",".sweet-alert {\n  margin: auto!important;\n  top: unset!important;\n  left: unset!important;\n}\n",".card-wizard{\n  min-height: 410px;\n  // box-shadow: $box-shadow;\n  @include transition($general-transition-time, $transition-linear);\n  &[data-color=\"primary\"]{\n    @include set-wizard-color($primary-color);\n  }\n  &[data-color=\"green\"]{\n    @include set-wizard-color($success-color);\n  }\n  &[data-color=\"orange\"]{\n    @include set-wizard-color($warning-color);\n  }\n  &[data-color=\"red\"]{\n    @include set-wizard-color($danger-color);\n  }\n  &[data-color=\"blue\"]{\n    @include set-wizard-color($info-color);\n  }\n\n  .card-header {\n    padding: 15px 0 !important;\n    padding-bottom: 40px;\n    background-color: transparent;\n    .card-title{\n      margin-bottom: 0px;\n      & + .description{\n        color: $dark-gray;\n        font-size: 0.875rem;\n        font-weight: 400;\n        margin: 0px;\n        margin-bottom: 40px;\n      }\n    }\n  }\n\n  .nav-pills .nav-item .nav-link{\n    padding: .75rem;\n  }\n\n  .nav-pills .nav-item .nav-link,\n  .nav-pills .nav-item .nav-link.active,\n  .nav-pills .nav-item .nav-link:hover,\n  .nav-pills .nav-item .nav-link:focus,\n  .nav-pills .nav-item .nav-link.active:focus,\n  .nav-pills .nav-item .nav-link.active:hover{\n    background-color: transparent;\n    box-shadow: none;\n  }\n\n  .picture-container{\n    position: relative;\n    cursor: pointer;\n    text-align: center;\n  }\n\n  .wizard-navigation{\n    position: relative;\n\n    .nav-link{\n      display: flex;\n      align-items: center;\n      -ms-flex-pack: center;\n      justify-content: center;\n    }\n  }\n\n  .wizard-navigation .nav-link i,\n  .moving-tab i{\n    display: inline-block;\n    font-size: 19px;\n    line-height: 18px;\n    margin-right: 6px;\n    padding: 0;\n    vertical-align: bottom;\n  }\n  .moving-tab i{\n    margin-right: 9px;\n  }\n\n  .picture{\n    width: 106px;\n    height: 106px;\n    background-color: #999999;\n    border: 1px solid $light-gray;\n    color: #FFFFFF;\n    border-radius: 50%;\n    margin: 5px auto;\n    overflow: hidden;\n    transition: all 0.2s;\n    -webkit-transition: all 0.2s;\n\n    &:hover{\n      border-color: #2ca8ff;\n    }\n  }\n\n  .moving-tab{\n    position: absolute;\n    text-align: center;\n    padding: .75rem;\n    font-size: 1rem;\n    text-transform: uppercase;\n    -webkit-font-smoothing: subpixel-antialiased;\n    top: 0px;\n    left: 0px;\n    background-color: $default-color;\n    // box-shadow: $box-shadow;\n    color: $white-color !important;\n    cursor: pointer;\n    font-weight: 400;\n    line-height: 18px;\n  }\n\n  .picture input[type=\"file\"] {\n    cursor: pointer;\n    display: block;\n    height: 100%;\n    left: 0;\n    opacity: 0 !important;\n    position: absolute;\n    top: 0;\n    width: 100%;\n  }\n\n  .picture-src{\n    width: 100%;\n  }\n\n  .tab-content{\n    min-height: 355px;\n    padding: 20px 0;\n  }\n\n  .wizard-footer{\n    padding: 0 15px;\n\n    .checkbox{\n      margin-top: 16px;\n    }\n  }\n\n  .disabled{\n    display: none;\n  }\n\n  .wizard-header{\n    text-align: center;\n    padding: 25px 0 35px;\n\n    h5{\n      margin: 5px 0 0;\n    }\n  }\n\n  .nav-pills > li{\n    text-align: center;\n  }\n\n  .btn{\n    text-transform: uppercase;\n  }\n\n  .info-text{\n    text-align: center;\n    font-weight: 300;\n    margin: 10px 0 30px;\n  }\n\n  .choice{\n    text-align: center;\n    cursor: pointer;\n    margin-top: 20px;\n\n    &[disabled]{\n      pointer-events: none;\n      cursor: not-allowed;\n      opacity: .5;\n    }\n\n    .icon{\n      text-align: center;\n      vertical-align: middle;\n      height: 116px;\n      width: 116px;\n      border-radius: 50%;\n      color: $default-color;\n      margin: 0 auto 20px;\n      border: 1px solid $light-gray;\n      transition: all 0.2s;\n      -webkit-transition: all 0.2s;\n    }\n\n    i{\n      font-size: 30px;\n      line-height: 116px;\n      position: absolute;\n      left: 0;\n      right: 0;\n    }\n\n    &:hover,\n    &.active{\n      .icon{\n        border-color: #2ca8ff;\n      }\n    }\n\n    input[type=\"radio\"],\n    input[type=\"checkbox\"]{\n      position: absolute;\n      left: -10000px;\n      z-index: -1;\n    }\n  }\n\n  .btn-finish{\n    display: none;\n  }\n\n  .card-title + .description{\n    font-size: $font-size-base + 3;\n    margin-bottom: 32px;\n  }\n\n  .wizard-title{\n    margin: 0;\n  }\n\n  .nav-pills{\n    background-color: $dark-gray;\n\n    > li + li {\n      margin-left: 0;\n    }\n\n    > li > a {\n      border: 0 !important;\n      border-radius: 0 ;\n      line-height: 18px;\n      text-transform: uppercase;\n      font-size: 1rem;\n      font-weight: 400;\n      min-width: 100px;\n      text-align: center;\n      color: $white-color !important;\n    }\n\n    > li.active > a,\n    > li.active > a:hover,\n    > li.active > a:focus,\n    > li > a:hover,\n    > li > a:focus{\n      background-color: inherit;\n      box-shadow: none;\n    }\n\n    > li i{\n      display: block;\n      font-size: 30px;\n      padding: 15px 0;\n    }\n  }\n\n  .form-group.select-wizard {\n    margin-top: 15px;\n  }\n\n  .dropdown.show,\n  .dropup.show {\n    .dropdown-menu {\n      @include transform-translate-y(0px);\n    }\n  }\n}\n","@mixin set-wizard-color($color) {\n  .moving-tab{\n    background-color: $color;\n  }\n\n  .picture{\n    &:hover{\n      border-color: $color;\n    }\n  }\n\n  .choice{\n    &:hover,\n    &.active{\n      .icon{\n        border-color: $color;\n        color: $color;\n      }\n    }\n  }\n\n  .checkbox input[type=checkbox]:checked + .checkbox-material{\n    .check{\n      background-color: $color;\n    }\n  }\n\n  .radio input[type=radio]:checked ~ .check {\n    background-color: $color;\n  }\n\n  .radio input[type=radio]:checked ~ .circle {\n    border-color: $color;\n  }\n}\n","/*!\n* https://github.com/YouCanBookMe/react-datetime\n*/\n\n.rdt {\n  position: relative;\n  .rdtPicker {\n    -webkit-transition: all 150ms linear;\n    -moz-transition: all 150ms linear;\n    -o-transition: all 150ms linear;\n    -ms-transition: all 150ms linear;\n    transition: all 150ms linear;\n    margin-top: -20px;\n    visibility: hidden;\n    display: block;\n    opacity: 0;\n  }\n  &.rdtOpen {\n    .rdtPicker {\n      opacity: 1;\n      visibility: visible;\n      margin-top: 0;\n    }\n  }\n}\n.rdtPicker {\n  display: none;\n  position: absolute;\n  width: 260px;\n  padding: 4px;\n  margin-top: 1px;\n  z-index: 99999 !important;\n  background: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 10px;\n  -webkit-box-shadow: 1px 2px 3px rgba(0, 0, 0, 0.125);\n  box-shadow: 1px 2px 3px rgba(0, 0, 0, 0.125);\n  -webkit-background-clip: padding-box;\n  background-clip: padding-box;\n  min-width: 160px;\n\n  &:before {\n    border-bottom: 11px solid rgba(0, 0, 0, 0.2);\n    border-left: 11px solid transparent;\n    border-right: 11px solid transparent;\n    content: \"\";\n    display: inline-block;\n    position: absolute;\n    left: 12px;\n    top: -11px;\n  }\n  &:after {\n    border-bottom: 11px solid #ffffff;\n    border-left: 11px solid transparent;\n    border-right: 11px solid transparent;\n    content: \"\";\n    display: inline-block;\n    position: absolute;\n    left: 12px;\n    top: -10px;\n  }\n}\n\n.rdtOpen .rdtPicker {\n  display: block;\n  top: 49px;\n}\n.rdtStatic .rdtPicker {\n  box-shadow: none;\n  position: static;\n}\n\n.rdtPicker .rdtTimeToggle {\n  text-align: center;\n  padding: 5px;\n  border-radius: 4px;\n}\n\n.rdtPicker table {\n  width: 100%;\n  margin: 0;\n  border-color: $white-color !important;\n}\n.rdtPicker td,\n.rdtPicker th {\n  text-align: center;\n  padding: 1px;\n}\n.rdtPicker td {\n  cursor: pointer;\n}\n.rdtDay {\n  height: 30px;\n  line-height: 33px;\n  width: 30px;\n  text-align: center;\n  padding: 0px;\n  border-radius: 50%;\n  &.rdtToday.rdtActive,\n  &.rdtActive,\n  &.rdtActive:hover {\n    background-color: $color-azure !important;\n    color: $white-color;\n  }\n}\n.rdtDays {\n  tr {\n    .dow {\n      text-align: center;\n      border-bottom: 1px solid #e3e3e3;\n      font-size: 12px;\n      text-transform: uppercase;\n      color: #9a9a9a;\n      font-weight: 400;\n      padding-bottom: 5px;\n      padding-top: 10px;\n    }\n    .rdtOld,\n    .rdtNew {\n      color: $medium-gray;\n    }\n  }\n}\n\n.rdtPicker td.rdtDay:hover,\n.rdtPicker td.rdtHour:hover,\n.rdtPicker td.rdtMinute:hover,\n.rdtPicker td.rdtSecond:hover,\n.rdtPicker .rdtTimeToggle:hover {\n  background: #eeeeee;\n  cursor: pointer;\n}\n.rdtPicker td.rdtToday {\n  position: relative;\n}\n.rdtPicker td.rdtActive.rdtToday:before {\n  border-bottom-color: #fff;\n}\n.rdtPicker td.rdtDisabled,\n.rdtPicker td.rdtDisabled:hover {\n  background: none;\n  color: #999999;\n  cursor: not-allowed;\n}\n\n.rdtPicker td span.rdtOld {\n  color: #999999;\n}\n.rdtPicker td span.rdtDisabled,\n.rdtPicker td span.rdtDisabled:hover {\n  background: none;\n  color: #999999;\n  cursor: not-allowed;\n}\n.rdtPicker .dow {\n  width: 14.2857%;\n  border-bottom: none;\n}\n.rdtPicker th.rdtSwitch {\n  width: 50px;\n  padding: 5px;\n  border-radius: 4px;\n}\n.rdtPicker th.rdtNext,\n.rdtPicker th.rdtPrev {\n  font-size: 21px;\n  vertical-align: top;\n  border-radius: 50%;\n  line-height: 33px;\n}\n\n.rdtPrev span,\n.rdtNext span {\n  display: block;\n  -webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Chrome/Safari/Opera */\n  -khtml-user-select: none; /* Konqueror */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none;\n}\n\n.rdtPicker th.rdtDisabled,\n.rdtPicker th.rdtDisabled:hover {\n  background: none;\n  color: #999999;\n  cursor: not-allowed;\n}\n.rdtPicker thead tr:first-child th {\n  cursor: pointer;\n}\n.rdtPicker thead tr:first-child th:hover {\n  background: #eeeeee;\n}\n\n.rdtPicker button {\n  border: none;\n  background: none;\n  cursor: pointer;\n}\n.rdtPicker button:hover {\n  background-color: #eee;\n}\n\n.rdtPicker thead button {\n  width: 100%;\n  height: 100%;\n}\n\ntd.rdtMonth,\ntd.rdtYear {\n  height: 50px;\n  width: 25%;\n  cursor: pointer;\n}\ntd.rdtMonth:hover,\ntd.rdtYear:hover {\n  background: #eee;\n}\n\n.rdtCounters {\n  display: inline-block;\n}\n\n.rdtCounters {\n  > div {\n    float: left;\n    width: 40px;\n    font-weight: 300;\n    margin: 3px;\n    border-radius: 50%;\n  }\n  .rdtCounterSeparator {\n    width: 0;\n    border: 1px solid transparent;\n  }\n}\n\n.rdtCounter {\n  height: 100px;\n}\n\n.rdtCounter {\n  width: 40px;\n  .rdtCount {\n    padding: 7px;\n    height: 40px;\n    border: 1px solid transparent;\n  }\n}\n.rdtCounters {\n  .rdtCounter:last-child {\n    .rdtCount {\n      color: $color-azure;\n      border-radius: 50%;\n      border: 1px solid $color-azure;\n    }\n  }\n}\n\n.rdtCounterSeparator {\n  padding: 7px;\n  line-height: 100px;\n}\n.rdtCounter .rdtBtn {\n  line-height: 40px;\n  cursor: pointer;\n  display: block;\n  border-radius: 50%;\n  color: $medium-dark-gray;\n  -webkit-transition: all 60ms ease-in;\n  -moz-transition: all 60ms ease-in;\n  -o-transition: all 60ms ease-in;\n  -ms-transition: all 60ms ease-in;\n  transition: all 60ms ease-in;\n\n  -webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Chrome/Safari/Opera */\n  -khtml-user-select: none; /* Konqueror */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none;\n}\n.rdtCounter .rdtBtn:hover {\n  background: #eee;\n  color: #797979;\n}\n.rdtCounter .rdtCount {\n  font-size: 1.2em;\n}\n\n.rdtMilli {\n  vertical-align: middle;\n  padding-left: 8px;\n  width: 48px;\n}\n\n.rdtMilli input {\n  width: 100%;\n  font-size: 1.2em;\n  margin-top: 37px;\n}\n.rdtMonths,\n.rdtYears {\n  padding-bottom: 10px;\n  .rdtMonth,\n  .rdtYear {\n    display: inline-block;\n    width: 56px;\n    height: 56px;\n    line-height: 56px;\n    margin: 3px 3px;\n    cursor: pointer;\n    border-radius: 50%;\n    text-align: center;\n\n    &.rdtActive {\n      background-color: $color-azure !important;\n      color: $white-color;\n    }\n  }\n}\n\n.rdtTime {\n  .rdtCounters {\n    .rdtCounterSeparator + .rdtCounter + .rdtCounter .rdtCount {\n      font-size: 1rem;\n    }\n  }\n}\n",".rna-container{\n  .alert {\n    button.close{\n      color: #000;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      span {\n        margin-top: -4px;\n      }\n    }\n  }\n}\n","/**\n* React Select v1.0.0-rc.10\n* ============\n* Created by Jed Watson and Joss Mackison for KeystoneJS, https://www.keystonejs.com/\n* https://twitter.com/jedwatson https://twitter.com/jossmackison https://twitter.com/keystonejs\n* MIT License: https://github.com/JedWatson/react-select\n*/\n\n\n/*\nThis file was modified entirely by Creative Tim for React-Select v2.0.0\n*/\n\n.react-select {\n  .react-select__menu{\n    border-radius: 0;\n    border-bottom-right-radius: 4px;\n    border-bottom-left-radius: 4px;\n    background-color: #fff;\n    border: 1px solid #ccc;\n    border-top-color: #e6e6e6;\n    -webkit-box-shadow: 0 1px 0 rgba(0,0,0,.06);\n    box-shadow: 0 1px 0 rgba(0,0,0,.06);\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n    margin-top: -1px;\n    position: absolute;\n    left: 0;\n    top: 100%;\n    width: 100%;\n    z-index: 5;\n    -webkit-overflow-scrolling: touch;\n  }\n  .react-select__menu-list {\n    overflow-y: auto;\n    padding-bottom: unset;\n    padding-top: unset;\n    position: relative;\n    max-height: 200px;\n  }\n  .react-select__option {\n    cursor: pointer;\n    display: block;\n    padding: 8px 10px;\n  }\n  .react-select__menu{\n    .react-select__option{\n      &,&:active{\n        background-color: transparent;\n      }\n      &.react-select__option--is-selected{\n        &,&:not(:first-child),&.react-select__option--is-focused:not(:first-child){\n          &,&:active{\n            background-color: rgba(0,126,255,.04);\n            color: #333;\n          }\n        }\n      }\n      &:not(:first-child).react-select__option--is-focused:not(:first-child) {\n        &,&:active{\n          background-color: rgba(0,126,255,.08);\n          color: #333;\n        }\n      }\n      &.react-select__option--is-disabled {\n        &,&:active{\n          color: #cccccc;\n          cursor: default;\n        }\n      }\n    }\n  }\n  .react-select__control{\n    background-color: $white-color;\n    border-color: #d9d9d9 #ccc #b3b3b3;\n    border-radius: 4px;\n    border: 1px solid #ccc;\n    min-height: 36px;\n    height: 36px;\n    box-sizing: border-box;\n    border-collapse: separate;\n    display: table;\n    width: 100%;\n    &.react-select__control--menu-is-open{\n      border-bottom-left-radius: 0;\n      border-bottom-right-radius: 0;\n    }\n    &.react-select__control--is-focused{\n      .react-select__dropdown-indicator{\n        &:after{\n          transform: rotate(180deg);\n          top: -4px;\n        }\n      }\n      &,&:hover{\n        border: 1px solid $primary-color;\n        box-shadow: none;\n      }\n    }\n    .react-select__value-container--has-value{\n      .react-select__multi-value{\n        display: inline-flex;\n        border-radius: 4px;\n        background-color: transparent;\n        & + div:not(.react-select__multi-value){\n          display: inline-flex;\n        }\n        .react-select__multi-value__label{\n          font-size: 0.9em;\n        }\n      }\n      .react-select__single-value{\n        top: 48%;\n        color: $black-color;\n      }\n    }\n    .react-select__placeholder{\n      color: $medium-dark-gray;\n      line-height: 34px;\n      padding-left: 10px;\n      padding-right: 10px;\n      font-size: 14px;\n      left: 0;\n      margin-left: 0;\n      margin-right: 0;\n    }\n    .react-select__value-container,\n    .react-select__indicators{\n      display: table-cell;\n    }\n    .react-select__indicators {\n      width: 60px;\n      padding-right: 10px;\n      align-items: flex-end;\n      vertical-align: middle;\n      text-align: right;\n      .react-select__indicator-separator{\n        display: none;\n      }\n      .react-select__indicator {\n        padding: 0;\n        display: inline-block;\n      }\n      .react-select__dropdown-indicator{\n        &:after{\n          transition: all 150ms ease 0s;\n          border-color: #999 transparent transparent;\n          border-style: solid;\n          border-width: 5px 5px 2.5px;\n          display: inline-block;\n          height: 0;\n          width: 0;\n          position: relative;\n          content: \"\";\n        }\n        &:hover:after{\n          border-top-color: $link-disabled-color;\n        }\n        & > * {\n          display: none;\n        }\n      }\n      .react-select__clear-indicator{\n        &:before{\n          content: \"\\D7\";\n          display: inline-block;\n          font-size: 18px;\n          line-height: 1;\n          top: 2px;\n          position: relative;\n          margin-right: 3px;\n        }\n        & > * {\n          display: none;\n        }\n      }\n    }\n  }\n  &.primary{\n    .react-select__control{\n      &.react-select__control--is-focused{\n        &,&:hover{\n          border-color: $primary-color;\n        }\n      }\n      .react-select__value-container--has-value{\n        .react-select__single-value,\n        .react-select__multi-value__label{\n          color: $primary-color;\n        }\n      }\n    }\n    .react-select__multi-value{\n      border: 1px solid $primary-color;\n      .react-select__multi-value__remove{\n        color: $primary-states-color;\n        border-left: 1px solid $primary-states-color;\n        &:hover{\n          color: $primary-color;\n          background-color: transparent;\n        }\n      }\n    }\n  }\n  &.success{\n    .react-select__control{\n      &.react-select__control--is-focused{\n        &,&:hover{\n          border-color: $success-color;\n        }\n      }\n      .react-select__value-container--has-value{\n        .react-select__single-value,\n        .react-select__multi-value__label{\n          color: $success-color;\n        }\n      }\n    }\n    .react-select__multi-value{\n      border: 1px solid $success-color;\n      .react-select__multi-value__remove{\n        color: $success-states-color;\n        border-left: 1px solid $success-states-color;\n        &:hover{\n          color: $success-color;\n          background-color: transparent;\n        }\n      }\n    }\n  }\n  &.info{\n    .react-select__control{\n      &.react-select__control--is-focused{\n        &,&:hover{\n          border-color: $info-color;\n        }\n      }\n      .react-select__value-container--has-value{\n        .react-select__single-value,\n        .react-select__multi-value__label{\n          color: $info-color;\n        }\n      }\n    }\n    .react-select__multi-value{\n      border: 1px solid $info-color;\n      .react-select__multi-value__remove{\n        color: $info-states-color;\n        border-left: 1px solid $info-states-color;\n        &:hover{\n          color: $info-color;\n          background-color: transparent;\n        }\n      }\n    }\n  }\n  &.warning{\n    .react-select__control{\n      &.react-select__control--is-focused{\n        &,&:hover{\n          border-color: $warning-color;\n        }\n      }\n      .react-select__value-container--has-value{\n        .react-select__single-value,\n        .react-select__multi-value__label{\n          color: $warning-color;\n        }\n      }\n    }\n    .react-select__multi-value{\n      border: 1px solid $warning-color;\n      .react-select__multi-value__remove{\n        color: $warning-states-color;\n        border-left: 1px solid $warning-states-color;\n        &:hover{\n          color: $warning-color;\n          background-color: transparent;\n        }\n      }\n    }\n  }\n  &.danger{\n    .react-select__control{\n      &.react-select__control--is-focused{\n        &,&:hover{\n          border-color: $danger-color;\n        }\n      }\n      .react-select__value-container--has-value{\n        .react-select__single-value,\n        .react-select__multi-value__label{\n          color: $danger-color;\n        }\n      }\n    }\n    .react-select__multi-value{\n      border: 1px solid $danger-color;\n      .react-select__multi-value__remove{\n        color: $danger-states-color;\n        border-left: 1px solid $danger-states-color;\n        &:hover{\n          color: $danger-color;\n          background-color: transparent;\n        }\n      }\n    }\n  }\n  .react-select__multi-value{\n    border: 1px solid $dark-gray;\n    .react-select__multi-value__remove{\n      position: relative;\n      color: $medium-dark-gray;\n      border-left: 1px solid $medium-dark-gray;\n      &:hover{\n        color: $dark-gray;\n        background-color: transparent;\n      }\n    }\n  }\n  &.react-select--is-disabled{\n    .react-select__multi-value--is-disabled{\n      .react-select__multi-value__remove {\n        display: none;\n      }\n      &.react-select__multi-value{\n        background-color: #fcfcfc;\n        border: 1px solid #e3e3e3;\n      }\n    }\n    .react-select__control--is-disabled{\n      background-color: #f9f9f9;\n    }\n  }\n}\n",".ReactTable {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  background-color: transparent;\n}\n.ReactTable {\n  .actions-right {\n    text-align: right;\n  }\n  .actions-left {\n    text-align: left;\n  }\n  .actions-center {\n    text-align: center;\n  }\n}\n.ReactTable * {\n  box-sizing: border-box;\n}\n.ReactTable .rt-table {\n  -webkit-box-flex: 1;\n  -ms-flex: auto 1;\n  flex: auto 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n  width: 100%;\n  border-collapse: collapse;\n  overflow: auto;\n}\n.ReactTable .rt-thead {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 auto;\n  flex: 1 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.ReactTable .rt-thead.-headerGroups {\n  background: rgba(0, 0, 0, 0.03);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n}\n.ReactTable .rt-thead.-filters {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n}\n.ReactTable .rt-thead.-filters input,\n.ReactTable .rt-thead.-filters select {\n  border: 1px solid #e3e3e3;\n  border-radius: 4px;\n  color: #565656;\n  font-weight: 400;\n  height: 36px;\n  background-color: inherit;\n  padding-left: 0.8em;\n  &:focus {\n    outline: none;\n    border: 1px solid #aaa;\n    color: #333;\n  }\n}\n.ReactTable .rt-thead .rt-tr {\n  text-align: center;\n}\n.ReactTable .rt-thead .rt-th:last-child {\n  text-align: right;\n  margin: unset;\n}\n.ReactTable .rt-thead .rt-th.-cursor-pointer > div:first-of-type {\n  &:after {\n    opacity: 0.4;\n    content: \"\\F0DC\";\n    position: relative;\n    display: inline-block;\n    bottom: 0;\n    right: -7px;\n    font-family: \"Font Awesome 5 Free\";\n    font-weight: 900;\n  }\n}\n.ReactTable .rt-thead .rt-th.-cursor-pointer.-sort-desc > div:first-of-type {\n  &:after {\n    content: \"\\F0DD\";\n    top: -3px;\n    position: relative;\n    display: inline-block;\n    bottom: 0;\n    right: -7px;\n    font-family: \"Font Awesome 5 Free\";\n    font-weight: 900;\n    opacity: 0.8;\n  }\n}\n.ReactTable .rt-thead .rt-th.-cursor-pointer.-sort-asc > div:first-of-type {\n  &:after {\n    content: \"\\F0DE\";\n    top: 3px;\n    position: relative;\n    display: inline-block;\n    bottom: 0;\n    right: -7px;\n    font-family: \"Font Awesome 5 Free\";\n    font-weight: 900;\n    opacity: 0.8;\n  }\n}\n.ReactTable .rt-thead .rt-th,\n.ReactTable .rt-thead .rt-td {\n  font-size: 1.063rem;\n  text-align: left;\n  font-weight: 300;\n  line-height: 2.5em !important;\n  padding: 5px 5px;\n  line-height: normal;\n  position: relative;\n  transition: box-shadow 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  box-shadow: inset 0 0 0 0 transparent;\n\n  .form-check {\n    .form-check-sign,\n    .form-check-sign:before,\n    .form-check-sign:after {\n      margin-top: -14px;\n      position: inherit;\n    }\n  }\n}\n\n.ReactTable .rt-tr .rt-th,\n.ReactTable .rt-tr .rt-td {\n  .form-check {\n    .form-check-sign,\n    .form-check-sign:before,\n    .form-check-sign:after {\n      margin-top: -14px;\n      position: inherit;\n    }\n  }\n}\n.ReactTable .rt-thead .rt-th.-cursor-pointer,\n.ReactTable .rt-thead .rt-td.-cursor-pointer {\n  cursor: pointer;\n}\n.ReactTable .rt-thead .rt-th:last-child,\n.ReactTable .rt-thead .rt-td:last-child {\n  border-right: 0;\n}\n.ReactTable .rt-thead .rt-resizable-header {\n  overflow: visible;\n}\n.ReactTable .rt-thead .rt-resizable-header:last-child {\n  overflow: hidden;\n}\n.ReactTable .rt-thead .rt-resizable-header-content {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  &:focus {\n    outline: none;\n  }\n}\n.ReactTable .rt-thead .rt-header-pivot {\n  border-right-color: #f7f7f7;\n}\n.ReactTable .rt-thead .rt-header-pivot:after,\n.ReactTable .rt-thead .rt-header-pivot:before {\n  left: 100%;\n  top: 50%;\n  border: solid transparent;\n  content: \" \";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none;\n}\n.ReactTable .rt-thead .rt-header-pivot:after {\n  border-color: rgba(255, 255, 255, 0);\n  border-left-color: #fff;\n  border-width: 8px;\n  margin-top: -8px;\n}\n.ReactTable .rt-thead .rt-header-pivot:before {\n  border-color: rgba(102, 102, 102, 0);\n  border-left-color: #f7f7f7;\n  border-width: 10px;\n  margin-top: -10px;\n}\n.ReactTable .rt-tbody {\n  -webkit-box-flex: 99999;\n  -ms-flex: 99999 1 auto;\n  flex: 99999 1 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  overflow: auto;\n}\n.ReactTable .rt-tbody .rt-tr-group {\n  border-bottom: solid 1px rgba(0, 0, 0, 0.05);\n}\n.ReactTable .rt-tbody .rt-tr-group:last-child {\n  border-bottom: 0;\n}\n.ReactTable .rt-tbody .rt-td:last-child {\n  border-right: 0;\n}\n.ReactTable .rt-tbody .rt-expandable {\n  cursor: pointer;\n}\n.ReactTable .rt-tr-group {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 auto;\n  flex: 1 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n}\n.ReactTable .rt-tr {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 auto;\n  flex: 1 0 auto;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}\n.ReactTable .rt-th,\n.ReactTable .rt-td {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 0px;\n  flex: 1 0 0;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  padding: 7px 5px;\n  overflow: hidden;\n  transition: 0.3s ease;\n  transition-property: width, min-width, padding, opacity;\n  margin: auto;\n}\n.ReactTable .rt-th.-hidden,\n.ReactTable .rt-td.-hidden {\n  width: 0 !important;\n  min-width: 0 !important;\n  padding: 0 !important;\n  border: 0 !important;\n  opacity: 0 !important;\n}\n.ReactTable .rt-expander {\n  display: inline-block;\n  position: relative;\n  margin: 0;\n  color: transparent;\n  margin: 0 10px;\n}\n.ReactTable .rt-expander:after {\n  content: \"\";\n  position: absolute;\n  width: 0;\n  height: 0;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%) rotate(-90deg);\n  transform: translate(-50%, -50%) rotate(-90deg);\n  border-left: 5.04px solid transparent;\n  border-right: 5.04px solid transparent;\n  border-top: 7px solid rgba(0, 0, 0, 0.8);\n  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  cursor: pointer;\n}\n.ReactTable .rt-expander.-open:after {\n  -webkit-transform: translate(-50%, -50%) rotate(0);\n  transform: translate(-50%, -50%) rotate(0);\n}\n.ReactTable .rt-resizer {\n  display: inline-block;\n  position: absolute;\n  width: 36px;\n  top: 0;\n  bottom: 0;\n  right: -18px;\n  cursor: col-resize;\n  z-index: 10;\n}\n.ReactTable .rt-tfoot {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 auto;\n  flex: 1 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);\n}\n.ReactTable .rt-tfoot .rt-td {\n  border-right: 1px solid rgba(0, 0, 0, 0.05);\n}\n.ReactTable .rt-tfoot .rt-td:last-child {\n  border-right: 0;\n}\n.ReactTable.-striped .rt-tr.-odd {\n  background: rgba(0, 0, 0, 0.03);\n}\n.ReactTable.-highlight .rt-tbody .rt-tr:not(.-padRow):hover {\n  background: rgba(0, 0, 0, 0.05);\n}\n.ReactTable .-pagination {\n  z-index: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  padding: 3px;\n}\n// .ReactTable .rt-thead.-filters select, .ReactTable .-pagination .select-wrap select{\n//\n//\n// }\n.ReactTable .-pagination input,\n.ReactTable .-pagination select {\n  border: 1px solid #e3e3e3;\n  border-radius: 4px;\n  color: #565656;\n  font-weight: 400;\n  height: 36px;\n  background-color: inherit;\n  text-align: center;\n  &:focus {\n    outline: none;\n    border: 1px solid #aaa;\n    color: #333;\n  }\n}\n.ReactTable .-pagination .-btn {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  display: block;\n  width: 100%;\n  height: 100%;\n  border: 0;\n  border-radius: 3px;\n  padding: 6px;\n  font-size: 1em;\n  color: rgba(0, 0, 0, 0.6);\n  background: rgba(0, 0, 0, 0.1);\n  transition: all 0.1s ease;\n  cursor: pointer;\n  outline: none;\n}\n.ReactTable .-pagination .-btn[disabled] {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.ReactTable .-pagination .-btn:not([disabled]):hover {\n  background: rgba(0, 0, 0, 0.3);\n  color: #fff;\n}\n.ReactTable .-pagination .-previous,\n.ReactTable .-pagination .-next {\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  text-align: center;\n}\n.ReactTable .-pagination .-center {\n  -webkit-box-flex: 1.5;\n  -ms-flex: 1.5;\n  flex: 1.5;\n  text-align: center;\n  margin-bottom: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-pack: distribute;\n  justify-content: space-around;\n}\n.ReactTable .-pagination .-pageInfo {\n  display: inline-block;\n  margin: 3px 10px;\n  white-space: nowrap;\n}\n.ReactTable .-pagination .-pageJump {\n  display: inline-block;\n}\n.ReactTable .-pagination .-pageSizeOptions {\n  margin: 3px 10px;\n}\n.ReactTable .rt-noData {\n  display: block;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  background: rgba(255, 255, 255, 0.8);\n  transition: all 0.3s ease;\n  z-index: 1;\n  pointer-events: none;\n  padding: 20px;\n  color: rgba(0, 0, 0, 0.5);\n}\n.ReactTable .-loading {\n  display: block;\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background: rgba(255, 255, 255, 0.8);\n  transition: all 0.3s ease;\n  z-index: -1;\n  opacity: 0;\n  pointer-events: none;\n}\n.ReactTable .-loading > div {\n  position: absolute;\n  display: block;\n  text-align: center;\n  width: 100%;\n  top: 50%;\n  left: 0;\n  font-size: 15px;\n  color: rgba(0, 0, 0, 0.6);\n  -webkit-transform: translateY(-52%);\n  transform: translateY(-52%);\n  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n.ReactTable .-loading.-active {\n  opacity: 1;\n  z-index: 2;\n  pointer-events: all;\n}\n.ReactTable .-loading.-active > div {\n  -webkit-transform: translateY(50%);\n  transform: translateY(50%);\n}\n.ReactTable .rt-resizing .rt-th,\n.ReactTable .rt-resizing .rt-td {\n  transition: none !important;\n  cursor: col-resize;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.ReactTable .rt-thead .rt-th:focus {\n  outline: none;\n}\n.ReactTable .rt-thead .rt-th {\n  font-size: 12px;\n  text-transform: uppercase;\n  color: #9a9a9a;\n  font-weight: 400;\n}\n",".alert{\n  border-radius: .25rem;\n}\n",".fixed-plugin{\n  background-color: unset;\n  .dropdown-toggle,\n  .dropdown-toggle:focus,\n  .dropdown-toggle:active {\n    background-color: rgba(0, 0, 0, 0.3) !important;\n    border: none !important;\n    padding: 0;\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n    .fa-cogs {\n      padding-left: 15px;\n      padding-right: 15px;\n    }\n    &::after{\n      display: none;\n    }\n  }\n}\n",".navbar {\n  min-height: unset;\n  max-height: unset;\n  .btn,\n  .navbar-brand,\n  .navbar-nav .nav-item .nav-link  {\n    margin: unset;\n    align-items: center;\n  }\n  .navbar-nav {\n    .dropdown-toggle:after {\n      margin-top: 0px;\n    }\n  }\n}\n\n@media (min-width: 992px) {\n  .navbar {\n    .navbar-nav {\n      .nc-icon {\n        margin-top: unset;\n      }\n      .notification {\n        top: 0px;\n      }\n    }\n  }\n}\n\n@media (max-width: 991.98px){\n  .navbar-expand-lg>.container,\n  .navbar-expand-lg>.container-fluid,\n  .navbar-expand-lg>.container-lg,\n  .navbar-expand-lg>.container-md,\n  .navbar-expand-lg>.container-sm,\n  .navbar-expand-lg>.container-xl {\n    padding-right: 15px;\n    padding-left: 15px;\n  }\n}\n",".card-header-tabs {\n    border-bottom: 1px solid #dee2e6;  \n}\n",".sidebar {\n  &[data-color=\"black\"]:after{\n    @include icon-gradient(#282828, rgba(#111,.7));\n  }\n  .logo a.logo-mini,.logo-img {\n    width: 40px;\n  }\n  .logo a.logo-mini {\n    margin-right: 5px;\n  }\n  .logo-img img{\n    width: 40px;\n    top: 6px;\n  }\n}\n\n.sidebar-mini {\n  .sidebar {\n    .nav .nav-item .nav-link {\n      padding: 10px 12px;\n    }\n    &:hover {\n      .nav .nav-item .nav-link {\n        padding: 10px 15px;\n      }\n    }\n  }\n  .main-panel {\n    .navbar.fixed-top {\n      margin-left: auto;\n      width: calc(100% - 80px);\n    }\n  }\n}\n\n.close-layer {\n  display: none;\n  pointer-events: none;\n  width: 0;\n  height: 0;\n}\n\n@media (max-width: 991px){\n  .nav-open {\n    .close-layer {\n      width: 100%;\n      height: 100%;\n      pointer-events: auto;\n      display: block;\n      opacity: 1;\n    }\n  }\n}\n\n.main-panel {\n  .navbar.fixed-top {\n    margin-left: auto;\n    width: $sidebar-width;\n  }\n}\n\n\n.full-page[data-color=\"black\"]:after {\n  background: #282828;\n  background: linear-gradient(180deg,#282828 0,rgba(17,17,17,.4));\n  opacity: .9;\n}\n",".custom-switch {\n  min-height: 26px;\n  min-width: 62px;\n  padding: 0;\n  .custom-control-label::after {\n    width: 22px!important;\n    height: 22px!important;\n    border-radius: 22px;\n    transition: all .15s ease-in-out;\n    top: 2px;\n    left: 2px;\n    background-color: white;\n  }\n  .custom-control-label::before {\n    width: 62px!important;\n    height: 26px!important;\n    border-radius: 26px;\n    left: 0;\n    top: 0;\n    border: #ddd;\n    background: #ddd;\n  }\n  .custom-control-input:checked~.custom-control-label::after {\n    transform: translateX(36px);\n  }\n  &:hover{\n    .custom-control-input:checked~.custom-control-label::after{\n      margin-left: -6px;\n    }\n    .custom-control-label::after{\n      width: 28px !important;\n    }\n  }\n}\n",".react-tagsinput {\n  background-color: #fff;\n  border-bottom: 2px solid #efefef;\n  overflow: hidden;\n  padding-top: 5px;\n  @include transition(60ms, ease-in);\n}\n\n.react-tagsinput--focused {\n  border-bottom: 2px solid #2196f3;\n}\n\n.react-tagsinput-tag {\n  cursor: pointer;\n  overflow: hidden;\n  position: relative;\n  margin: 5px 3px 5px 0;\n  padding: 2px 12px;\n  border: 1px solid #888888;\n  border-radius: 3px;\n  color: #888888;\n  font-weight: 500;\n  font-size: 12px;\n  text-transform: uppercase;\n  display: inline-block;\n  vertical-align: middle;\n  @include transition(60ms, ease-in);\n\n  &:hover {\n    padding-left: 8px;\n    padding-right: 16px;\n\n    a {\n      opacity: 1;\n      padding-right: 4px;\n    }\n  }\n\n  a {\n    &::before {\n      content: \"\\f00d\";\n      font-family: \"Font Awesome 5 Free\";\n      font-weight: 900;\n    }\n\n    // @extend .animation-transition-ultra-fast;\n    @include transition(60ms, ease-in);\n    color: $default-color;\n    cursor: pointer;\n    font-size: 12px;\n    padding: 2px 0;\n    position: absolute;\n    right: 0;\n    opacity: 0;\n    text-align: right;\n    text-decoration: none;\n    top: 0;\n    width: 100%;\n    z-index: 2;\n  }\n\n  &.tag-blue,\n  &.tag-blue a {\n    @include label-color($primary-color);\n  }\n  &.tag-azure,\n  &.tag-azure a {\n    @include label-color($info-color);\n  }\n  &.tag-green,\n  &.tag-green a {\n    @include label-color($success-color);\n  }\n  &.tag-orange,\n  &.tag-orange a {\n    @include label-color($warning-color);\n  }\n  &.tag-red,\n  &.tag-red a {\n    @include label-color($danger-color);\n  }\n\n  &.tag-fill {\n    &.tag-blue {\n      @include label-color-fill($primary-color);\n    }\n    &.tag-azure {\n      @include label-color-fill($info-color);\n    }\n    &.tag-green {\n      @include label-color-fill($success-color);\n    }\n    &.tag-orange {\n      @include label-color-fill($warning-color);\n    }\n    &.tag-red {\n      @include label-color-fill($danger-color);\n    }\n  }\n  &.tag-fill,\n  &.tag-fill a {\n    color: $white-color;\n  }\n}\n\n.react-tagsinput-remove {\n  cursor: pointer;\n  font-weight: bold;\n}\n.react-tagsinput-input {\n  background: transparent;\n  border: 0;\n  color: #777;\n  font-family: sans-serif;\n  font-size: 13px;\n  font-weight: 400;\n  margin-bottom: 6px;\n  margin-top: 1px;\n  outline: none;\n  padding: 5px;\n  width: 80px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
